import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JWT: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AbortMultipartUploadInput = {
  key: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
};

export type AcceptGroupInviteResponse = {
  __typename?: 'AcceptGroupInviteResponse';
  joinedInstantly: Scalars['Boolean']['output'];
};

export type AcceptSessionInput = {
  sessionId: Scalars['ID']['input'];
};

export type AchievementBadge = {
  __typename?: 'AchievementBadge';
  artworkUrl?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  family: AchievementFamily;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tier: Scalars['Int']['output'];
};

export enum AchievementFamily {
  Community = 'COMMUNITY',
  ContentCreator = 'CONTENT_CREATOR',
  InfluenceTier = 'INFLUENCE_TIER',
  Networking = 'NETWORKING'
}

export type AchievementProgressView = {
  __typename?: 'AchievementProgressView';
  badge: AchievementBadge;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  progress: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
  target: Scalars['Int']['output'];
  unlocked: Scalars['Boolean']['output'];
  unlockedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ActionButton = {
  __typename?: 'ActionButton';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isShow: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type ActivateInfluenceConfigInput = {
  caps: Scalars['JSON']['input'];
  eligibility: Scalars['JSON']['input'];
  featureFlags: Scalars['JSON']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  scoringRules: Scalars['JSON']['input'];
};

export type ActiveUsersStats = {
  __typename?: 'ActiveUsersStats';
  formattedPercent: Scalars['String']['output'];
  totalActiveLast30Days: Scalars['Int']['output'];
  trend: Scalars['String']['output'];
};

export type ActivityMedia = {
  __typename?: 'ActivityMedia';
  createdAt: Scalars['DateTime']['output'];
  fileUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  optimizedUrl?: Maybe<Scalars['String']['output']>;
  postId: Scalars['String']['output'];
};

export type ActorInfo = {
  __typename?: 'ActorInfo';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type AdAdvertiserCandidate = {
  __typename?: 'AdAdvertiserCandidate';
  eligible: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  hasActiveSubscription: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  ineligibleReason?: Maybe<Scalars['String']['output']>;
  isIndustryPartner: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  profileImageOptimizedUrl?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type AdDurationPack = {
  __typename?: 'AdDurationPack';
  appleProductId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  googleProductId?: Maybe<Scalars['String']['output']>;
  hours: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  priceCents: Scalars['Int']['output'];
  status: PlanStatus;
  stripePriceId?: Maybe<Scalars['String']['output']>;
  stripeProductId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Ad creative format (SINGLE_IMAGE, VIDEO, CAROUSEL) */
export enum AdFormat {
  Carousel = 'CAROUSEL',
  SingleImage = 'SINGLE_IMAGE',
  Video = 'VIDEO'
}

/** Where an ad was shown (FEED, RSS); frequency caps are counted per placement */
export enum AdPlacement {
  Feed = 'FEED',
  Rss = 'RSS'
}

export type AddActionButtonInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  isShow: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type AddContactInput = {
  platform: ContactPlatform;
  showOnProfile?: Scalars['Boolean']['input'];
  url: Scalars['String']['input'];
};

export type AddCuratedReelByUrlInput = {
  channelTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type AddEducationInput = {
  degree: Scalars['String']['input'];
  endDay?: InputMaybe<Scalars['Int']['input']>;
  endMonth?: InputMaybe<Scalars['Int']['input']>;
  endYear?: InputMaybe<Scalars['Int']['input']>;
  fieldOfStudy: Scalars['String']['input'];
  institution: Scalars['String']['input'];
  startDay?: InputMaybe<Scalars['Int']['input']>;
  startMonth?: InputMaybe<Scalars['Int']['input']>;
  startYear: Scalars['Int']['input'];
};

export type AddExperienceInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AddLicenseInput = {
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate: Scalars['DateTime']['input'];
  licenseID: Scalars['String']['input'];
  licenseURL: Scalars['String']['input'];
  organization: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type AddSigningFieldInput = {
  documentId: Scalars['ID']['input'];
  height?: InputMaybe<Scalars['Float']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  page: Scalars['Int']['input'];
  recipientId: Scalars['ID']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type: SigningFieldType;
  width?: InputMaybe<Scalars['Float']['input']>;
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type AddSigningRecipientInput = {
  documentId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  role?: InputMaybe<SigningRecipientRole>;
};

export type AddSkillInput = {
  skillName: Scalars['String']['input'];
  skillTitle: Scalars['String']['input'];
};

export type AddSkillsInput = {
  skills: Array<AddSkillInput>;
};

export type AdjustInfluenceInput = {
  points: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type AdminAchievementDefinition = {
  __typename?: 'AdminAchievementDefinition';
  active: Scalars['Boolean']['output'];
  artworkUrl?: Maybe<Scalars['String']['output']>;
  criteria: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  expiresAfterDays?: Maybe<Scalars['Int']['output']>;
  family: AchievementFamily;
  holders: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tier: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminAuditLogInput = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  targetUserId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminBroadcast = {
  __typename?: 'AdminBroadcast';
  audience: BroadcastAudience;
  channels: Array<BroadcastChannel>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByAdminId: Scalars['ID']['output'];
  emailBody?: Maybe<Scalars['String']['output']>;
  emailSent: Scalars['Int']['output'];
  emailSubject?: Maybe<Scalars['String']['output']>;
  failed: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inAppSent: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Users passed through delivery so far (progress = processed / totalEstimate). */
  processed: Scalars['Int']['output'];
  pushSent: Scalars['Int']['output'];
  /** Null = the notification is not clickable. */
  redirectTarget?: Maybe<BroadcastRedirectTarget>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: BroadcastStatus;
  totalEstimate: Scalars['Int']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminBroadcastFailure = {
  __typename?: 'AdminBroadcastFailure';
  channel: BroadcastChannel;
  createdAt: Scalars['DateTime']['output'];
  error: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type AdminBroadcastFailurePage = {
  __typename?: 'AdminBroadcastFailurePage';
  items: Array<AdminBroadcastFailure>;
  nextCursor?: Maybe<Scalars['ID']['output']>;
};

export type AdminBroadcastPage = {
  __typename?: 'AdminBroadcastPage';
  items: Array<AdminBroadcast>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminCampaignInvoice = {
  __typename?: 'AdminCampaignInvoice';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  invoicePdf?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  providerInvoiceId?: Maybe<Scalars['String']['output']>;
  receiptUrl?: Maybe<Scalars['String']['output']>;
  referenceId: Scalars['ID']['output'];
  status: InvoiceStatus;
  subtotal: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminCommissionStats = {
  __typename?: 'AdminCommissionStats';
  thisMonthEarned: Scalars['Float']['output'];
  thisMonthSessions: Scalars['Int']['output'];
  thisMonthVolume: Scalars['Float']['output'];
  totalEarned: Scalars['Float']['output'];
  totalMentorPayouts: Scalars['Float']['output'];
  totalPlatformFees: Scalars['Float']['output'];
  totalSessions: Scalars['Int']['output'];
  totalVolume: Scalars['Float']['output'];
};

export type AdminCreateCampaignInput = {
  adFormat?: AdFormat;
  /** User the ad runs as */
  advertiserUserId: Scalars['ID']['input'];
  ctaText?: InputMaybe<Scalars['String']['input']>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  durationDays?: InputMaybe<Scalars['Int']['input']>;
  durationHours?: InputMaybe<Scalars['Float']['input']>;
  headline: Scalars['String']['input'];
  mediaUrls: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  objective: CampaignObjective;
  targetCompanyTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  targetEducationLevels?: InputMaybe<Array<Scalars['String']['input']>>;
  targetExperienceLevels?: InputMaybe<Array<Scalars['String']['input']>>;
  targetLocations?: InputMaybe<Array<Scalars['String']['input']>>;
  targetRoles?: InputMaybe<Array<Role>>;
  targetSpecializations?: InputMaybe<Array<Expertise>>;
};

export type AdminCuratedReelModel = {
  __typename?: 'AdminCuratedReelModel';
  channelHandle?: Maybe<Scalars['String']['output']>;
  channelTitle?: Maybe<Scalars['String']['output']>;
  commentsCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  curatedSourceId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  embedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isHidden: Scalars['Boolean']['output'];
  likesCount: Scalars['Int']['output'];
  provider?: Maybe<VideoProvider>;
  providerVideoId?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminCuratedReelsPaginatedResponse = {
  __typename?: 'AdminCuratedReelsPaginatedResponse';
  data: Array<AdminCuratedReelModel>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AdminDigitalCard = {
  __typename?: 'AdminDigitalCard';
  amountPaidCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoices?: Maybe<Array<AdminDigitalCardInvoice>>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  purchasedAt: Scalars['DateTime']['output'];
  qrScanCount: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<AdminDigitalCardUser>;
  userId: Scalars['ID']['output'];
  viewCount: Scalars['Int']['output'];
};

export type AdminDigitalCardInvoice = {
  __typename?: 'AdminDigitalCardInvoice';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  invoicePdf?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  payerEmail?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  providerInvoiceId?: Maybe<Scalars['String']['output']>;
  receiptUrl?: Maybe<Scalars['String']['output']>;
  referenceId: Scalars['ID']['output'];
  status: InvoiceStatus;
  subtotal: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
};

export type AdminDigitalCardStats = {
  __typename?: 'AdminDigitalCardStats';
  disabledCards: Scalars['Int']['output'];
  enabledCards: Scalars['Int']['output'];
  thisMonthPurchases: Scalars['Int']['output'];
  thisMonthRevenueCents: Scalars['Int']['output'];
  totalCards: Scalars['Int']['output'];
  totalQrScans: Scalars['Int']['output'];
  totalRevenueCents: Scalars['Int']['output'];
  totalViews: Scalars['Int']['output'];
};

export type AdminDigitalCardUser = {
  __typename?: 'AdminDigitalCardUser';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type AdminGroupGrowthMetrics = {
  __typename?: 'AdminGroupGrowthMetrics';
  membersPercent: Scalars['Float']['output'];
  postsPercent: Scalars['Float']['output'];
};

export type AdminGroupGrowthResult = {
  __typename?: 'AdminGroupGrowthResult';
  categories: Array<Scalars['String']['output']>;
  growth: AdminGroupGrowthMetrics;
  series: Array<AdminGroupSeriesData>;
  timeframe: Scalars['String']['output'];
  totals: AdminGroupTotals;
};

export type AdminGroupSeriesData = {
  __typename?: 'AdminGroupSeriesData';
  data: Array<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export type AdminGroupTotals = {
  __typename?: 'AdminGroupTotals';
  totalMembers: Scalars['Float']['output'];
  totalPosts: Scalars['Float']['output'];
};

export type AdminInfluenceAuditLog = {
  __typename?: 'AdminInfluenceAuditLog';
  action: Scalars['String']['output'];
  adminId: Scalars['ID']['output'];
  adminName?: Maybe<Scalars['String']['output']>;
  after?: Maybe<Scalars['JSON']['output']>;
  before?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  targetUserId?: Maybe<Scalars['ID']['output']>;
};

export type AdminInfluenceAuditLogPage = {
  __typename?: 'AdminInfluenceAuditLogPage';
  items: Array<AdminInfluenceAuditLog>;
  total: Scalars['Int']['output'];
};

export type AdminInfluenceConfig = {
  __typename?: 'AdminInfluenceConfig';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  caps: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdById?: Maybe<Scalars['ID']['output']>;
  eligibility: Scalars['JSON']['output'];
  featureFlags: Scalars['JSON']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  isActive: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  scoringRules: Scalars['JSON']['output'];
  version: Scalars['Int']['output'];
};

export type AdminInfluenceConfigPage = {
  __typename?: 'AdminInfluenceConfigPage';
  items: Array<AdminInfluenceConfig>;
  total: Scalars['Int']['output'];
};

export type AdminInfluenceEvent = {
  __typename?: 'AdminInfluenceEvent';
  actor?: Maybe<AdminInfluenceMember>;
  actorId?: Maybe<Scalars['ID']['output']>;
  counter?: Maybe<Scalars['String']['output']>;
  counterDelta: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  decision: InfluenceDecision;
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  occurredAt: Scalars['DateTime']['output'];
  periodKey: Scalars['String']['output'];
  points: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  relatedPostId?: Maybe<Scalars['ID']['output']>;
  reversalOf?: Maybe<Scalars['ID']['output']>;
  reversed: Scalars['Boolean']['output'];
  scoringConfigVersion: Scalars['Int']['output'];
  sourceId: Scalars['String']['output'];
  sourceType: Scalars['String']['output'];
  user?: Maybe<AdminInfluenceMember>;
  userId: Scalars['ID']['output'];
};

export type AdminInfluenceEventPage = {
  __typename?: 'AdminInfluenceEventPage';
  items: Array<AdminInfluenceEvent>;
  total: Scalars['Int']['output'];
};

export type AdminInfluenceMember = {
  __typename?: 'AdminInfluenceMember';
  exists: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AdminInfluenceOverview = {
  __typename?: 'AdminInfluenceOverview';
  configVersion: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  flaggedLast7Days: Scalars['Int']['output'];
  outboxFailed: Scalars['Int']['output'];
  outboxPending: Scalars['Int']['output'];
  processorLastError?: Maybe<Scalars['String']['output']>;
  processorLastSuccessAt?: Maybe<Scalars['DateTime']['output']>;
  profiles: Scalars['Int']['output'];
};

export type AdminInfluenceUser = {
  __typename?: 'AdminInfluenceUser';
  achievements: Array<AdminInfluenceUserAchievement>;
  connectionsCount: Scalars['Int']['output'];
  contributionCount: Scalars['Int']['output'];
  coursesCompletedCount: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  flaggedEvents: Scalars['Int']['output'];
  hideFromLeaderboards: Scalars['Boolean']['output'];
  isAiAgent: Scalars['Boolean']['output'];
  lifetimeInfluencePoints: Scalars['Int']['output'];
  meaningfulCommentsCount: Scalars['Int']['output'];
  mentorshipSessionsCount: Scalars['Int']['output'];
  monthlyInfluence: Scalars['Int']['output'];
  monthlyRank?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  postsCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  statusHidden: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
};

export type AdminInfluenceUserAchievement = {
  __typename?: 'AdminInfluenceUserAchievement';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  unlockedAt: Scalars['DateTime']['output'];
};

export type AdminInfluenceUserSearchResult = {
  __typename?: 'AdminInfluenceUserSearchResult';
  email?: Maybe<Scalars['String']['output']>;
  lifetimeInfluencePoints: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type AdminKnowledgeArticleListInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<KnowledgeArticleStatus>>;
};

export type AdminLeaderboardEntry = {
  __typename?: 'AdminLeaderboardEntry';
  badgesCount: Scalars['Int']['output'];
  contributionCount: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  exists: Scalars['Boolean']['output'];
  flaggedEvents: Scalars['Int']['output'];
  hiddenFromPublic: Scalars['Boolean']['output'];
  isAiAgent: Scalars['Boolean']['output'];
  lifetimeInfluencePoints: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  role?: Maybe<Scalars['String']['output']>;
  score: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type AdminLeaderboardInput = {
  category: LeaderboardCategory;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  periodKey?: InputMaybe<Scalars['String']['input']>;
};

export type AdminLeaderboardPage = {
  __typename?: 'AdminLeaderboardPage';
  category: LeaderboardCategory;
  entries: Array<AdminLeaderboardEntry>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  periodKey: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  visibleToMembers: Scalars['Boolean']['output'];
};

export type AdminLedgerInput = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};

export type AdminLog = {
  __typename?: 'AdminLog';
  action: Scalars['String']['output'];
  actor?: Maybe<ActorInfo>;
  createdAt: Scalars['DateTime']['output'];
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminLogListResult = {
  __typename?: 'AdminLogListResult';
  items: Array<AdminLog>;
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AdminOutboxInput = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  status?: InputMaybe<InfluenceOutboxStatus>;
};

export type AdminOutboxItem = {
  __typename?: 'AdminOutboxItem';
  attempts: Scalars['Int']['output'];
  availableAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  eventId: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  payload: Scalars['JSON']['output'];
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  status: InfluenceOutboxStatus;
};

export type AdminOutboxPage = {
  __typename?: 'AdminOutboxPage';
  items: Array<AdminOutboxItem>;
  total: Scalars['Int']['output'];
};

export type AdminPageInput = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};

export type AdminPendingTrialSummary = {
  __typename?: 'AdminPendingTrialSummary';
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardLast4?: Maybe<Scalars['String']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  couponDiscountPercent?: Maybe<Scalars['Int']['output']>;
  firstChargeDate: Scalars['DateTime']['output'];
  planName: Scalars['String']['output'];
  priceMonthly: Scalars['Float']['output'];
  trialDays: Scalars['Int']['output'];
  trialEnabled: Scalars['Boolean']['output'];
};

export type AdminPlatformEarningsStats = {
  __typename?: 'AdminPlatformEarningsStats';
  thisMonthCommissionEarned: Scalars['Float']['output'];
  thisMonthPlatformRevenue: Scalars['Float']['output'];
  thisMonthRefunded: Scalars['Float']['output'];
  thisMonthSessionVolume: Scalars['Float']['output'];
  thisMonthSessions: Scalars['Int']['output'];
  thisMonthStripeFees: Scalars['Float']['output'];
  thisMonthSubscriptionRevenue: Scalars['Float']['output'];
  thisMonthSubscriptions: Scalars['Int']['output'];
  totalCommissionEarned: Scalars['Float']['output'];
  totalPlatformRevenue: Scalars['Float']['output'];
  totalRefunded: Scalars['Float']['output'];
  totalSessionVolume: Scalars['Float']['output'];
  totalSessions: Scalars['Int']['output'];
  totalStripeFees: Scalars['Float']['output'];
  totalSubscriptionRevenue: Scalars['Float']['output'];
  totalSubscriptions: Scalars['Int']['output'];
};

export type AdminPostActionInput = {
  actionType: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export type AdminPostBoost = {
  __typename?: 'AdminPostBoost';
  amountCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  durationHours: Scalars['Int']['output'];
  durationSeconds: Scalars['Int']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  hourlyRateCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  invoiceId?: Maybe<Scalars['ID']['output']>;
  invoices?: Maybe<Array<AdminPostBoostInvoice>>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  post?: Maybe<AdminPostBoostPost>;
  postId: Scalars['ID']['output'];
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status: PostBoostStatus;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<AdminPostBoostUser>;
  userId: Scalars['ID']['output'];
};

export type AdminPostBoostChartData = {
  __typename?: 'AdminPostBoostChartData';
  boosts: Array<Scalars['Int']['output']>;
  boostsByDate: Array<AdminPostBoostCountByDate>;
  categories: Array<Scalars['String']['output']>;
  revenueByDate: Array<AdminPostBoostRevenueByDate>;
  revenueCents: Array<Scalars['Int']['output']>;
};

export type AdminPostBoostCountByDate = {
  __typename?: 'AdminPostBoostCountByDate';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type AdminPostBoostDurationPerformance = {
  __typename?: 'AdminPostBoostDurationPerformance';
  durationHours: Scalars['Int']['output'];
  purchases: Scalars['Int']['output'];
  revenueCents: Scalars['Int']['output'];
};

export type AdminPostBoostEarnings = {
  __typename?: 'AdminPostBoostEarnings';
  from?: Maybe<Scalars['DateTime']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
  totalPurchases: Scalars['Int']['output'];
  totalRevenueCents: Scalars['Int']['output'];
};

export type AdminPostBoostInvoice = {
  __typename?: 'AdminPostBoostInvoice';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  payerEmail?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  receiptUrl?: Maybe<Scalars['String']['output']>;
  referenceId: Scalars['ID']['output'];
  status: InvoiceStatus;
  subtotal: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
};

export type AdminPostBoostPost = {
  __typename?: 'AdminPostBoostPost';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mediaUrls?: Maybe<Array<Scalars['String']['output']>>;
};

export type AdminPostBoostRevenueByDate = {
  __typename?: 'AdminPostBoostRevenueByDate';
  date: Scalars['String']['output'];
  revenue: Scalars['Int']['output'];
};

export type AdminPostBoostStats = {
  __typename?: 'AdminPostBoostStats';
  activeBoosts: Scalars['Int']['output'];
  averageBoostPriceCents: Scalars['Float']['output'];
  cancelledBoosts: Scalars['Int']['output'];
  expiredBoosts: Scalars['Int']['output'];
  failedBoosts: Scalars['Int']['output'];
  monthlyRevenueCents: Scalars['Int']['output'];
  pendingBoosts: Scalars['Int']['output'];
  todayRevenueCents: Scalars['Int']['output'];
  totalBoosts: Scalars['Int']['output'];
  totalRevenueCents: Scalars['Int']['output'];
  uniqueUsersBoosted: Scalars['Int']['output'];
  weeklyRevenueCents: Scalars['Int']['output'];
};

export type AdminPostBoostStatusStat = {
  __typename?: 'AdminPostBoostStatusStat';
  count: Scalars['Int']['output'];
  status: PostBoostStatus;
};

export type AdminPostBoostUser = {
  __typename?: 'AdminPostBoostUser';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type AdminProfileBoost = {
  __typename?: 'AdminProfileBoost';
  clicks: Scalars['Int']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  consumedActiveSeconds: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  ctr: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  hourlyRateCents: Scalars['Int']['output'];
  hours: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  impressions: Scalars['Int']['output'];
  invoices?: Maybe<Array<AdminProfileBoostInvoice>>;
  mentor?: Maybe<AdminProfileBoostMentor>;
  mentorId: Scalars['ID']['output'];
  packId?: Maybe<Scalars['ID']['output']>;
  packLabel?: Maybe<Scalars['String']['output']>;
  profileVisits: Scalars['Int']['output'];
  purchasedDurationSeconds: Scalars['Int']['output'];
  remainingDurationSeconds: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: ProfileBoostStatus;
  totalPaidCents: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type AdminProfileBoostChartData = {
  __typename?: 'AdminProfileBoostChartData';
  categories: Array<Scalars['String']['output']>;
  clicks: Array<Scalars['Int']['output']>;
  impressions: Array<Scalars['Int']['output']>;
  profileVisits: Array<Scalars['Int']['output']>;
  revenueCents: Array<Scalars['Int']['output']>;
};

export type AdminProfileBoostEarnings = {
  __typename?: 'AdminProfileBoostEarnings';
  byProvider: Array<AdminProfileBoostProviderEarnings>;
  extensionRevenueCents: Scalars['Int']['output'];
  from?: Maybe<Scalars['DateTime']['output']>;
  initialPurchaseRevenueCents: Scalars['Int']['output'];
  refundedCents: Scalars['Int']['output'];
  to?: Maybe<Scalars['DateTime']['output']>;
  totalPurchases: Scalars['Int']['output'];
  totalRevenueCents: Scalars['Int']['output'];
};

export type AdminProfileBoostInvoice = {
  __typename?: 'AdminProfileBoostInvoice';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  invoicePdf?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  payerEmail?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  providerInvoiceId?: Maybe<Scalars['String']['output']>;
  receiptUrl?: Maybe<Scalars['String']['output']>;
  referenceId: Scalars['ID']['output'];
  status: InvoiceStatus;
  subtotal: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
};

export type AdminProfileBoostMentor = {
  __typename?: 'AdminProfileBoostMentor';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type AdminProfileBoostProviderEarnings = {
  __typename?: 'AdminProfileBoostProviderEarnings';
  provider: Scalars['String']['output'];
  purchaseCount: Scalars['Int']['output'];
  revenueCents: Scalars['Int']['output'];
};

export type AdminProfileBoostPurchase = {
  __typename?: 'AdminProfileBoostPurchase';
  amountCents: Scalars['Int']['output'];
  boostId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  durationSeconds: Scalars['Int']['output'];
  hourlyRateCents: Scalars['Int']['output'];
  hoursPurchased: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  invoiceId?: Maybe<Scalars['ID']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  mentorEmail?: Maybe<Scalars['String']['output']>;
  mentorName?: Maybe<Scalars['String']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  status: InvoiceStatus;
  type: ProfileBoostPurchaseType;
  userId: Scalars['ID']['output'];
};

export type AdminProfileBoostStats = {
  __typename?: 'AdminProfileBoostStats';
  activeBoosts: Scalars['Int']['output'];
  completedBoosts: Scalars['Int']['output'];
  ctr: Scalars['String']['output'];
  expiredBoosts: Scalars['Int']['output'];
  pausedBoosts: Scalars['Int']['output'];
  thisMonthPurchases: Scalars['Int']['output'];
  thisMonthRevenueCents: Scalars['Int']['output'];
  totalBoosts: Scalars['Int']['output'];
  totalClicks: Scalars['Int']['output'];
  totalImpressions: Scalars['Int']['output'];
  totalProfileVisits: Scalars['Int']['output'];
  totalPurchases: Scalars['Int']['output'];
  totalRevenueCents: Scalars['Int']['output'];
  uniqueMentorsBoosted: Scalars['Int']['output'];
};

export type AdminReconcileInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
};

export type AdminReconciliationMismatch = {
  __typename?: 'AdminReconciliationMismatch';
  actual: Scalars['Int']['output'];
  expected: Scalars['Int']['output'];
  field: Scalars['String']['output'];
};

export type AdminReconciliationReport = {
  __typename?: 'AdminReconciliationReport';
  checked: Scalars['Int']['output'];
  mismatches: Array<AdminUserReconciliation>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type AdminRoleChangeFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  requestedRole?: InputMaybe<Role>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RoleChangeRequestStatus>;
};

export type AdminSendSupportMessageInput = {
  attachmentMediaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** True → internal note (never shown to the user, no email). */
  isInternal?: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  ticketId: Scalars['ID']['input'];
};

export type AdminSponsoredRequestFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SponsoredRequestStatus>;
};

export type AdminSponsorshipEvent = {
  __typename?: 'AdminSponsorshipEvent';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminSponsorshipPlan = {
  __typename?: 'AdminSponsorshipPlan';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  features: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  paidPurchaseCount: Scalars['Int']['output'];
  priceCents: Scalars['Int']['output'];
  purchaseCount: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminSponsorshipPurchaseDetail = {
  __typename?: 'AdminSponsorshipPurchaseDetail';
  amountCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invoice?: Maybe<BillingInvoice>;
  isPublic: Scalars['Boolean']['output'];
  paymentIntentId: Scalars['String']['output'];
  paymentStatus: InvoiceStatus;
  plan?: Maybe<AdminSponsorshipPlan>;
  planName: Scalars['String']['output'];
  planPriceCentsAtPurchase: Scalars['Int']['output'];
  purchaseReference: Scalars['String']['output'];
  purchaseStatus: SponsorshipPurchaseStatus;
  purchasedAt?: Maybe<Scalars['DateTime']['output']>;
  sponsor: SponsoredRequestModel;
  transactions: Array<BillingTransaction>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminSponsorshipPurchaseFilterInput = {
  approvalStatus?: InputMaybe<SponsoredRequestStatus>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  paymentStatus?: InputMaybe<InvoiceStatus>;
  planId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AdminSponsorshipPurchaseRow = {
  __typename?: 'AdminSponsorshipPurchaseRow';
  amountCents: Scalars['Int']['output'];
  approvalStatus: SponsoredRequestStatus;
  company?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPublic: Scalars['Boolean']['output'];
  paymentStatus: InvoiceStatus;
  phone?: Maybe<Scalars['String']['output']>;
  planName: Scalars['String']['output'];
  purchaseReference: Scalars['String']['output'];
  purchaseStatus: SponsorshipPurchaseStatus;
  purchasedAt?: Maybe<Scalars['DateTime']['output']>;
  sponsorName: Scalars['String']['output'];
};

export type AdminStripeStatus = {
  __typename?: 'AdminStripeStatus';
  accountEmail?: Maybe<Scalars['String']['output']>;
  accountId: Scalars['String']['output'];
  accountName?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  connected: Scalars['Boolean']['output'];
  country?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  ownerPhone?: Maybe<Scalars['String']['output']>;
};

export type AdminSubscriptionInvoice = {
  __typename?: 'AdminSubscriptionInvoice';
  amountDue: Scalars['Int']['output'];
  amountPaid: Scalars['Int']['output'];
  billingReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  finalAmountPaid?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  invoicePdf?: Maybe<Scalars['String']['output']>;
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  newPlanPrice?: Maybe<Scalars['Int']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentMethodBrand?: Maybe<Scalars['String']['output']>;
  paymentMethodLast4?: Maybe<Scalars['String']['output']>;
  periodDays?: Maybe<Scalars['Int']['output']>;
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  periodLabel?: Maybe<Scalars['String']['output']>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  previousPlanAmount?: Maybe<Scalars['Int']['output']>;
  previousPlanUnusedCredit?: Maybe<Scalars['Int']['output']>;
  providerInvoiceId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  stripeInvoiceId: Scalars['String']['output'];
  user?: Maybe<SubscriptionUserProfile>;
};

export type AdminSubscriptionStats = {
  __typename?: 'AdminSubscriptionStats';
  activeSubscribers: Scalars['Int']['output'];
  mrrCents: Scalars['Int']['output'];
  pastDueSubscribers: Scalars['Int']['output'];
  thisMonthRevenueCents: Scalars['Int']['output'];
  totalRevenueCents: Scalars['Int']['output'];
  trialingSubscribers: Scalars['Int']['output'];
};

export type AdminSummary = {
  __typename?: 'AdminSummary';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export type AdminSupportAgent = {
  __typename?: 'AdminSupportAgent';
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
};

export type AdminSupportCategory = {
  __typename?: 'AdminSupportCategory';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  /** Tickets currently filed under this category. */
  ticketCount: Scalars['Int']['output'];
};

export type AdminSupportMessage = {
  __typename?: 'AdminSupportMessage';
  attachments: Array<Media>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Internal note — visible to support staff only. */
  isInternal: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  sender?: Maybe<AdminSupportAgent>;
  senderId?: Maybe<Scalars['ID']['output']>;
  senderType: SupportSenderType;
  ticketId: Scalars['ID']['output'];
};

export type AdminSupportTicket = {
  __typename?: 'AdminSupportTicket';
  aiConversationId?: Maybe<Scalars['ID']['output']>;
  aiPrioritySuggestion?: Maybe<SupportTicketPriority>;
  aiSummary?: Maybe<Scalars['String']['output']>;
  assignedAt?: Maybe<Scalars['DateTime']['output']>;
  assignedTo?: Maybe<AdminSupportAgent>;
  assignedToId?: Maybe<Scalars['ID']['output']>;
  category?: Maybe<AdminSupportCategory>;
  categoryId?: Maybe<Scalars['ID']['output']>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  feedbackAt?: Maybe<Scalars['DateTime']['output']>;
  feedbackComment?: Maybe<Scalars['String']['output']>;
  feedbackResolved?: Maybe<Scalars['Boolean']['output']>;
  firstAgentReplyAt?: Maybe<Scalars['DateTime']['output']>;
  /** Set only when user is null (a guest ticket). */
  guestEmail?: Maybe<Scalars['String']['output']>;
  /** Set only when user is null (a guest ticket). */
  guestName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastAgentReplyAt?: Maybe<Scalars['DateTime']['output']>;
  lastUserReplyAt?: Maybe<Scalars['DateTime']['output']>;
  messageCount: Scalars['Int']['output'];
  /** Full thread incl. internal notes. Populated by adminSupportTicket(id) only. */
  messages?: Maybe<Array<AdminSupportMessage>>;
  priority: SupportTicketPriority;
  relatedId?: Maybe<Scalars['String']['output']>;
  relatedType?: Maybe<SupportRelatedType>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  source: SupportTicketSource;
  status: SupportTicketStatus;
  subject: Scalars['String']['output'];
  ticketNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Null for a guest ticket (source GUEST_FORM / GUEST_AI) — see guestName/guestEmail. */
  user?: Maybe<AdminSupportTicketUser>;
};

export type AdminSupportTicketConnection = {
  __typename?: 'AdminSupportTicketConnection';
  data: Array<AdminSupportTicket>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AdminSupportTicketUser = {
  __typename?: 'AdminSupportTicketUser';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type AdminSupportTicketsFilterInput = {
  /** Agent user id, or "me", or "unassigned". */
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ISO date — created on/after. */
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  /** ISO date — created on/before. */
  dateTo?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  priority?: InputMaybe<Array<SupportTicketPriority>>;
  /** Ticket number, subject, user name or user email. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Sort field: updatedAt | createdAt | priority | status. Default updatedAt. */
  sortBy?: InputMaybe<Scalars['String']['input']>;
  /** asc | desc. Default desc. */
  sortDir?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Array<SupportTicketSource>>;
  status?: InputMaybe<Array<SupportTicketStatus>>;
};

/** On-demand user context for the ticket detail page (spec §31). */
export type AdminSupportUserContext = {
  __typename?: 'AdminSupportUserContext';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  isEmailVerified: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  memberSince: Scalars['DateTime']['output'];
  openTicketCount: Scalars['Int']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  recentBookings: Array<SupportUserContextBooking>;
  recentPayments: Array<SupportUserContextPayment>;
  role: Role;
  status: Scalars['String']['output'];
  subscription?: Maybe<SupportUserContextSubscription>;
  totalTicketCount: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
};

export type AdminUserReconciliation = {
  __typename?: 'AdminUserReconciliation';
  leaderboardMismatches: Array<AdminReconciliationMismatch>;
  profileMismatches: Array<AdminReconciliationMismatch>;
  userId: Scalars['ID']['output'];
};

export type AdvertisingHourlyRate = {
  __typename?: 'AdvertisingHourlyRate';
  hourlyRateCents: Scalars['Int']['output'];
};

export type Advisor = {
  __typename?: 'Advisor';
  bio?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum AdvisorMoveDirection {
  Down = 'DOWN',
  Up = 'UP'
}

export type AdvisorSlot = {
  __typename?: 'AdvisorSlot';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AdvisorsPaginatedResponse = {
  __typename?: 'AdvisorsPaginatedResponse';
  data: Array<Advisor>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  /** Unfiltered advisor count (for display order) */
  totalAdvisors: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AiAgent = {
  __typename?: 'AiAgent';
  activeHoursEnd?: Maybe<Scalars['Int']['output']>;
  activeHoursStart?: Maybe<Scalars['Int']['output']>;
  allowedTopics: Array<Scalars['String']['output']>;
  blockedTopics: Array<Scalars['String']['output']>;
  commentLookbackDays: Scalars['Int']['output'];
  consecutiveFailures: Scalars['Int']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByAdmin?: Maybe<User>;
  createdByAdminId: Scalars['String']['output'];
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastActionAt?: Maybe<Scalars['DateTime']['output']>;
  loginPassword?: Maybe<Scalars['String']['output']>;
  maxCommentsPerDay: Scalars['Int']['output'];
  maxMinutesBetweenActions: Scalars['Int']['output'];
  maxPostsPerDay: Scalars['Int']['output'];
  maxReactionsPerDay: Scalars['Int']['output'];
  maxRepliesPerDay: Scalars['Int']['output'];
  minMinutesBetweenActions: Scalars['Int']['output'];
  nextActionAt?: Maybe<Scalars['DateTime']['output']>;
  personaPrompt: Scalars['String']['output'];
  poolOrder: Scalars['Int']['output'];
  postLookbackDays: Scalars['Int']['output'];
  reactionLookbackDays: Scalars['Int']['output'];
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  status: AiAgentStatus;
  timezone: Scalars['String']['output'];
  todayUsage?: Maybe<AiAgentDailyUsageSummary>;
  tone?: Maybe<Scalars['String']['output']>;
  topics: Array<Scalars['String']['output']>;
  totalComments: Scalars['Int']['output'];
  totalFailures: Scalars['Int']['output'];
  totalPosts: Scalars['Int']['output'];
  totalReactions: Scalars['Int']['output'];
  totalReplies: Scalars['Int']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The DentMent user account this agent acts through. */
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
  voiceProfile: AiAgentVoiceProfile;
};

export type AiAgentActionModel = {
  __typename?: 'AiAgentActionModel';
  agent?: Maybe<AiAgent>;
  agentId: Scalars['ID']['output'];
  attempts: Scalars['Int']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  generatedContent?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  llmCompletionTokens?: Maybe<Scalars['Int']['output']>;
  llmPromptTokens?: Maybe<Scalars['Int']['output']>;
  parentAgentActionId?: Maybe<Scalars['ID']['output']>;
  /** CREATE_POST only — layout the post was written in. */
  postFormat?: Maybe<Scalars['String']['output']>;
  /** CREATE_POST only — what kind of post it was (tip, question, opinion, …). */
  postIntent?: Maybe<Scalars['String']['output']>;
  reactionType?: Maybe<ReactionType>;
  /** Why the graph chose this action, or the SKIP/FAILED reason. */
  reason?: Maybe<Scalars['String']['output']>;
  resultCommentId?: Maybe<Scalars['ID']['output']>;
  resultPostId?: Maybe<Scalars['ID']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: AiAgentActionStatus;
  targetCommentId?: Maybe<Scalars['ID']['output']>;
  targetPostId?: Maybe<Scalars['ID']['output']>;
  type: AiAgentActionType;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Lifecycle status of one AiAgentAction (PLANNED, PENDING_APPROVAL, EXECUTING, SUCCEEDED, FAILED, REJECTED, SKIPPED) */
export enum AiAgentActionStatus {
  Executing = 'EXECUTING',
  Failed = 'FAILED',
  PendingApproval = 'PENDING_APPROVAL',
  Planned = 'PLANNED',
  Rejected = 'REJECTED',
  Skipped = 'SKIPPED',
  Succeeded = 'SUCCEEDED'
}

/** Kind of autonomous action an AI agent took or proposed (CREATE_POST, COMMENT, REPLY, REACT_POST, REACT_COMMENT) */
export enum AiAgentActionType {
  Comment = 'COMMENT',
  CreatePost = 'CREATE_POST',
  ReactComment = 'REACT_COMMENT',
  ReactPost = 'REACT_POST',
  Reply = 'REPLY'
}

/** Whether AI Agent Pool content-bearing actions execute automatically or require admin approval */
export enum AiAgentApprovalMode {
  Auto = 'AUTO',
  RequireApproval = 'REQUIRE_APPROVAL'
}

export type AiAgentDailyUsageSummary = {
  __typename?: 'AiAgentDailyUsageSummary';
  comments: Scalars['Int']['output'];
  failures: Scalars['Int']['output'];
  posts: Scalars['Int']['output'];
  reactions: Scalars['Int']['output'];
  replies: Scalars['Int']['output'];
};

export type AiAgentPoolConfigModel = {
  __typename?: 'AiAgentPoolConfigModel';
  /** How many enrolled agents may be ACTIVE at once (Section 21). */
  activeCount: Scalars['Int']['output'];
  activeHoursEnd?: Maybe<Scalars['Int']['output']>;
  activeHoursStart?: Maybe<Scalars['Int']['output']>;
  allowedTopics: Array<Scalars['String']['output']>;
  approvalMode: AiAgentApprovalMode;
  blockedTopics: Array<Scalars['String']['output']>;
  commentLookbackDays: Scalars['Int']['output'];
  consecutiveFailureDisableThreshold: Scalars['Int']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Global kill switch. See Section 61 — checked before target selection/LLM/quota. */
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  maxActionsPerTick: Scalars['Int']['output'];
  /** Max agent actions (all agents combined) on one person's content per cooldown window. */
  maxActionsPerUserInCooldown: Scalars['Int']['output'];
  maxCommentsPerDay: Scalars['Int']['output'];
  maxMentionRepliesPerHour: Scalars['Int']['output'];
  maxMinutesBetweenActions: Scalars['Int']['output'];
  maxPostsPerDay: Scalars['Int']['output'];
  maxReactionsPerDay: Scalars['Int']['output'];
  maxRepliesPerDay: Scalars['Int']['output'];
  maxRepliesPerThread: Scalars['Int']['output'];
  maxRepliesPerUserPerHour: Scalars['Int']['output'];
  minMinutesBetweenActions: Scalars['Int']['output'];
  model: Scalars['String']['output'];
  /** Max minutes of the random gap between two original posts (whole pool). */
  postGapMaxMinutes: Scalars['Int']['output'];
  /** Min minutes of the random gap between two original posts (whole pool). */
  postGapMinMinutes: Scalars['Int']['output'];
  postLookbackDays: Scalars['Int']['output'];
  reactionLookbackDays: Scalars['Int']['output'];
  sameAuthorCooldownHours: Scalars['Int']['output'];
  timezone: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Rolling window (minutes) of the pool-wide per-user cooldown. 0 = off. */
  userCooldownMinutes: Scalars['Int']['output'];
};

export type AiAgentPoolOverview = {
  __typename?: 'AiAgentPoolOverview';
  activeAgents: Scalars['Int']['output'];
  commentsToday: Scalars['Int']['output'];
  config: AiAgentPoolConfigModel;
  disabledAgents: Scalars['Int']['output'];
  failuresToday: Scalars['Int']['output'];
  idleAgents: Scalars['Int']['output'];
  pendingApprovals: Scalars['Int']['output'];
  postsToday: Scalars['Int']['output'];
  reactionsToday: Scalars['Int']['output'];
  repliesToday: Scalars['Int']['output'];
  totalEnrolled: Scalars['Int']['output'];
};

export type AiAgentPoolRunResult = {
  __typename?: 'AiAgentPoolRunResult';
  /** Agents skipped because a concurrent tick already held their lease. */
  busy: Scalars['Int']['output'];
  /** Agents whose tick threw an unhandled error. */
  failed: Scalars['Int']['output'];
  /** Agents whose tick ran to completion (the tick may still have decided to skip acting). */
  ran: Scalars['Int']['output'];
  /** ACTIVE agents picked up by this run. */
  totalAgents: Scalars['Int']['output'];
};

/** Lifecycle status of an enrolled AI agent (IDLE, ACTIVE, DISABLED, REMOVED) */
export enum AiAgentStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Idle = 'IDLE',
  Removed = 'REMOVED'
}

export type AiAgentVoiceProfile = {
  __typename?: 'AiAgentVoiceProfile';
  emoji: Scalars['String']['output'];
  formats: Array<Scalars['String']['output']>;
  intents: Array<Scalars['String']['output']>;
  length: Scalars['String']['output'];
  quirks: Array<Scalars['String']['output']>;
};

export type AiConversationModel = {
  __typename?: 'AiConversationModel';
  createdAt: Scalars['DateTime']['output'];
  escalatedAt?: Maybe<Scalars['DateTime']['output']>;
  helpful?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  mode: Scalars['String']['output'];
  outcome: AiConversationOutcome;
  status: AiConversationStatus;
  /** Set once this conversation has been escalated into a ticket. */
  supportTicketId?: Maybe<Scalars['ID']['output']>;
};

/** Resolution outcome of an AI conversation (UNRESOLVED, AI_RESOLVED, ESCALATED) */
export enum AiConversationOutcome {
  AiResolved = 'AI_RESOLVED',
  Escalated = 'ESCALATED',
  Unresolved = 'UNRESOLVED'
}

/** AI assistant conversation status (ACTIVE, ESCALATED, CLOSED) */
export enum AiConversationStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Escalated = 'ESCALATED'
}

export type AllCoursesPaginatedResponse = {
  __typename?: 'AllCoursesPaginatedResponse';
  data: Array<CourseWithTotalLectures>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum AllowedPostMediaTypes {
  Document = 'DOCUMENT',
  PostImage = 'POST_IMAGE',
  PostVideo = 'POST_VIDEO'
}

export type ApiRequestLog = {
  __typename?: 'ApiRequestLog';
  bodyOmitted: Scalars['Boolean']['output'];
  bodyTruncated: Scalars['Boolean']['output'];
  clientPlatform?: Maybe<Scalars['String']['output']>;
  clientVersion?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  durationMs: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorStack?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  operationName?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  requestBody?: Maybe<Scalars['JSON']['output']>;
  requestHeaders?: Maybe<Scalars['JSON']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  responseBody?: Maybe<Scalars['JSON']['output']>;
  responseHeaders?: Maybe<Scalars['JSON']['output']>;
  source: ApiRequestSource;
  statusCode?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
  userRole?: Maybe<Scalars['String']['output']>;
};

export type ApiRequestLogListResult = {
  __typename?: 'ApiRequestLogListResult';
  items: Array<ApiRequestLog>;
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ApiRequestLogsFilterInput = {
  clientPlatform?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  operationName?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<ApiRequestSource>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ApiRequestSource {
  Graphql = 'GRAPHQL',
  Rest = 'REST'
}

export type ApiRequestStats = {
  __typename?: 'ApiRequestStats';
  avgDurationMs: Scalars['Float']['output'];
  errorCount: Scalars['Int']['output'];
  errorRatePercent: Scalars['Float']['output'];
  requestsOverTime: Array<ApiRequestTimeBucket>;
  totalRequests: Scalars['Int']['output'];
};

export type ApiRequestTimeBucket = {
  __typename?: 'ApiRequestTimeBucket';
  bucketStart: Scalars['DateTime']['output'];
  count: Scalars['Int']['output'];
  errorCount: Scalars['Int']['output'];
};

export type AppConfig = {
  __typename?: 'AppConfig';
  enabledFeatures: Array<Scalars['String']['output']>;
  /** Version-gated GraphQL fields enabled for this client. Ungated schema fields are globally available. */
  enabledGraphqlFields: Array<Scalars['String']['output']>;
  forceUpdate: Scalars['Boolean']['output'];
  forceUpdateMessage?: Maybe<Scalars['String']['output']>;
  latestVersion: Scalars['String']['output'];
  maintenanceMessage?: Maybe<Scalars['String']['output']>;
  maintenanceMode: Scalars['Boolean']['output'];
  minimumSupportedVersion: Scalars['String']['output'];
  updateUrl?: Maybe<Scalars['String']['output']>;
};

export type ApproveAndScheduleNewsletterInput = {
  /** UTC instant to send the newsletter at */
  scheduledAt: Scalars['DateTime']['input'];
};

export type Article = {
  __typename?: 'Article';
  author: User;
  companyAuthor?: Maybe<Company>;
  content: Scalars['String']['output'];
  coverImageOptimizedUrl?: Maybe<Scalars['String']['output']>;
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isSaved?: Maybe<Scalars['Boolean']['output']>;
  /** My Library item holding this content for the current user, or null when not saved. */
  libraryItemId?: Maybe<Scalars['ID']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  post?: Maybe<Post>;
  postId: Scalars['String']['output'];
  readingTimeMinutes: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  status: ArticleStatus;
  subtitle?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  translatedContent?: Maybe<Scalars['String']['output']>;
  translatedExcerpt?: Maybe<Scalars['String']['output']>;
  translatedSubtitle?: Maybe<Scalars['String']['output']>;
  translatedTitle?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  viewCount: Scalars['Int']['output'];
};

export type ArticleFiltersInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  status?: InputMaybe<ArticleStatus>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

/** Status of an article */
export enum ArticleStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type AssignSupportTicketInput = {
  /** Admin user id to assign to. */
  assigneeId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
};

export type AttachSigningDocumentPdfInput = {
  documentId: Scalars['ID']['input'];
  pageCount?: InputMaybe<Scalars['Int']['input']>;
  pdfMediaId: Scalars['ID']['input'];
};

export type AttendeeInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorSummary = {
  __typename?: 'AuthorSummary';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type Availability = {
  __typename?: 'Availability';
  dateOverrides: Array<DateAvailabilityOverride>;
  id: Scalars['ID']['output'];
  schedulingId: Scalars['String']['output'];
  weeklyAvailability: SchedulingWeeklyAvailability;
};

export type BanMemberInput = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type BasicAccount = {
  __typename?: 'BasicAccount';
  Sociallink?: Maybe<Scalars['String']['output']>;
  businessType?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyLogo?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  expertise?: Maybe<Expertise>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<Gender>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  position?: Maybe<Scalars['String']['output']>;
  reasonForJoining?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Suffix>;
  title?: Maybe<Scalars['String']['output']>;
  valueToCommunity?: Maybe<Scalars['String']['output']>;
};

export type BillingInvoice = {
  __typename?: 'BillingInvoice';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  discount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  invoicePdf?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  provider: Scalars['String']['output'];
  receiptUrl?: Maybe<Scalars['String']['output']>;
  referenceId: Scalars['String']['output'];
  status: InvoiceStatus;
  subtotal: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  type: InvoiceType;
};

export type BillingPeriodStats = {
  __typename?: 'BillingPeriodStats';
  campaignCount: Scalars['Int']['output'];
  campaignRevenue: Scalars['Float']['output'];
  commissionEarned: Scalars['Float']['output'];
  digitalCardCount: Scalars['Int']['output'];
  digitalCardRevenue: Scalars['Float']['output'];
  period: Scalars['String']['output'];
  periodLabel: Scalars['String']['output'];
  platformRevenue: Scalars['Float']['output'];
  postBoostCount: Scalars['Int']['output'];
  postBoostRevenue: Scalars['Float']['output'];
  profileBoostCount: Scalars['Int']['output'];
  profileBoostRevenue: Scalars['Float']['output'];
  refundedAmount: Scalars['Float']['output'];
  sessionCount: Scalars['Int']['output'];
  subscriptionCount: Scalars['Int']['output'];
  subscriptionRevenue: Scalars['Float']['output'];
};

export type BillingPortalResult = {
  __typename?: 'BillingPortalResult';
  url: Scalars['String']['output'];
};

export type BillingTransaction = {
  __typename?: 'BillingTransaction';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  direction: TransactionDirection;
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: LedgerTransactionType;
};

export type BillingWallet = {
  __typename?: 'BillingWallet';
  availableBalance: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pendingBalance: Scalars['Float']['output'];
  recentTransactions?: Maybe<Array<BillingTransaction>>;
  walletKey?: Maybe<Scalars['String']['output']>;
};

export type BookSessionInput = {
  /** Date in YYYY-MM-DD format */
  date: Scalars['String']['input'];
  /** An optional description or additional details */
  description: Scalars['String']['input'];
  /** ID of the mentor with whom the user is booking a session */
  mentorId: Scalars['String']['input'];
  /** Stripe PaymentIntent ID — required for paid sessions; must be in succeeded state */
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  /** Start time in 24-hour format (e.g., "11:30") */
  startTime: Scalars['String']['input'];
  /** Subject or title of the session */
  subject: Scalars['String']['input'];
  /** Timezone identifier (could be an enum or a string scalar) */
  timezone: Scalars['String']['input'];
};

export type BookSessionResult = {
  __typename?: 'BookSessionResult';
  bookingId: Scalars['String']['output'];
  isFree: Scalars['Boolean']['output'];
};

export type Booking = {
  __typename?: 'Booking';
  attendee: BookingAttendee;
  createdAt: Scalars['DateTime']['output'];
  endsAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  schedulingId: Scalars['String']['output'];
  startsAt: Scalars['DateTime']['output'];
  status: BookingStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type BookingAttendee = {
  __typename?: 'BookingAttendee';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

/** Status of a scheduling booking */
export enum BookingStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING'
}

export type BroadcastAudience = {
  __typename?: 'BroadcastAudience';
  noSubscription?: Maybe<Scalars['Boolean']['output']>;
  roles?: Maybe<Array<Role>>;
  signedUpFrom?: Maybe<Scalars['DateTime']['output']>;
  signedUpTo?: Maybe<Scalars['DateTime']['output']>;
  subscriptionPlanIds?: Maybe<Array<Scalars['ID']['output']>>;
  subscriptionStatuses?: Maybe<Array<SubscriptionStatus>>;
  userIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type BroadcastAudienceInput = {
  noSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<Role>>;
  signedUpFrom?: InputMaybe<Scalars['DateTime']['input']>;
  signedUpTo?: InputMaybe<Scalars['DateTime']['input']>;
  subscriptionPlanIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  subscriptionStatuses?: InputMaybe<Array<SubscriptionStatus>>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BroadcastAudiencePreview = {
  __typename?: 'BroadcastAudiencePreview';
  count: Scalars['Int']['output'];
  sample: Array<BroadcastAudienceSampleUser>;
};

export type BroadcastAudienceSampleUser = {
  __typename?: 'BroadcastAudienceSampleUser';
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  role: Role;
};

/** Delivery channel of an admin broadcast (IN_APP, EMAIL) */
export enum BroadcastChannel {
  Email = 'EMAIL',
  InApp = 'IN_APP'
}

export type BroadcastFailuresInput = {
  broadcastId: Scalars['ID']['input'];
  cursor?: InputMaybe<Scalars['ID']['input']>;
  limit?: Scalars['Int']['input'];
};

export type BroadcastListInput = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  status?: InputMaybe<BroadcastStatus>;
};

/** App module an admin broadcast notification opens when tapped. Clients treat unknown values as no redirect. */
export enum BroadcastRedirectTarget {
  AiChat = 'AI_CHAT',
  CeCourses = 'CE_COURSES',
  Communities = 'COMMUNITIES',
  Companies = 'COMPANIES',
  Courses = 'COURSES',
  Events = 'EVENTS',
  Groups = 'GROUPS',
  Home = 'HOME',
  Influence = 'INFLUENCE',
  Jobs = 'JOBS',
  Library = 'LIBRARY',
  LiveStreams = 'LIVE_STREAMS',
  Mentors = 'MENTORS',
  Messages = 'MESSAGES',
  MyNetwork = 'MY_NETWORK',
  Podcasts = 'PODCASTS',
  Reels = 'REELS',
  Services = 'SERVICES',
  Sessions = 'SESSIONS',
  SubscriptionPlans = 'SUBSCRIPTION_PLANS',
  Support = 'SUPPORT'
}

export type BroadcastRetryOutcome = {
  __typename?: 'BroadcastRetryOutcome';
  attempted: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
  succeeded: Scalars['Int']['output'];
};

/** Lifecycle of an admin broadcast (DRAFT, SENDING, PAUSED, COMPLETED, CANCELLED, FAILED) */
export enum BroadcastStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Paused = 'PAUSED',
  Scheduled = 'SCHEDULED',
  Sending = 'SENDING'
}

export type BroadcastUserOption = {
  __typename?: 'BroadcastUserOption';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  role: Role;
};

/** CTA button types */
export enum CtaType {
  ApplyNow = 'APPLY_NOW',
  ContactUs = 'CONTACT_US',
  Custom = 'CUSTOM',
  LearnMore = 'LEARN_MORE',
  VisitWebsite = 'VISIT_WEBSITE'
}

export type CallResponse = {
  __typename?: 'CallResponse';
  message: Scalars['String']['output'];
  room?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type CallSendInput = {
  callType: Scalars['String']['input'];
  receiverId: Scalars['String']['input'];
};

export type Campaign = {
  __typename?: 'Campaign';
  adFormat: AdFormat;
  amountPaid: Scalars['Int']['output'];
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  clicks: Scalars['Int']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  consumedActiveSeconds: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdByAdmin?: Maybe<CampaignCreatorAdmin>;
  createdByAdminId?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  ctr: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  impressions: Scalars['Int']['output'];
  invoices?: Maybe<Array<AdminCampaignInvoice>>;
  mediaUrls: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  objective: CampaignObjective;
  optimizedMediaUrls?: Maybe<Array<Scalars['String']['output']>>;
  purchasedDurationSeconds: Scalars['Int']['output'];
  refundedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  remainingDurationSeconds: Scalars['Int']['output'];
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  source: CampaignSource;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: CampaignStatus;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  suspendedAt?: Maybe<Scalars['DateTime']['output']>;
  suspensionReason?: Maybe<Scalars['String']['output']>;
  targetCompanyTypes: Array<Scalars['String']['output']>;
  targetEducationLevels: Array<Scalars['String']['output']>;
  targetExperienceLevels: Array<Scalars['String']['output']>;
  targetLocations: Array<Scalars['String']['output']>;
  targetRoles: Array<Role>;
  targetSpecializations: Array<Expertise>;
  totalPaidCents: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<CampaignOwner>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CampaignChartData = {
  __typename?: 'CampaignChartData';
  categories: Array<Scalars['String']['output']>;
  clicks: Array<Scalars['Int']['output']>;
  impressions: Array<Scalars['Int']['output']>;
};

export type CampaignCostPreview = {
  __typename?: 'CampaignCostPreview';
  amountCents: Scalars['Int']['output'];
  durationSeconds: Scalars['Int']['output'];
  hourlyRateCents: Scalars['Int']['output'];
};

export type CampaignCreatorAdmin = {
  __typename?: 'CampaignCreatorAdmin';
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

/** The objective of an ad campaign */
export enum CampaignObjective {
  BrandAwareness = 'BRAND_AWARENESS',
  CourseEnrollment = 'COURSE_ENROLLMENT',
  Engagement = 'ENGAGEMENT',
  EventAttendance = 'EVENT_ATTENDANCE',
  LeadGeneration = 'LEAD_GENERATION',
  WebsiteTraffic = 'WEBSITE_TRAFFIC'
}

export type CampaignOwner = {
  __typename?: 'CampaignOwner';
  city?: Maybe<Scalars['String']['output']>;
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Role;
  state?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CampaignPaymentInit = {
  __typename?: 'CampaignPaymentInit';
  amountCents: Scalars['Int']['output'];
  clientSecret: Scalars['String']['output'];
  durationSeconds: Scalars['Int']['output'];
  hourlyRateCents: Scalars['Int']['output'];
  paymentIntentId: Scalars['String']['output'];
  publishableKey: Scalars['String']['output'];
  purchaseId: Scalars['ID']['output'];
};

export type CampaignPurchaseRecord = {
  __typename?: 'CampaignPurchaseRecord';
  amountCents: Scalars['Int']['output'];
  campaignId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  durationSeconds: Scalars['Int']['output'];
  hourlyRateCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Who launched an ad campaign (USER = self-serve paid, ADMIN = run by admin on behalf of a partner) */
export enum CampaignSource {
  Admin = 'ADMIN',
  User = 'USER'
}

export type CampaignStats = {
  __typename?: 'CampaignStats';
  activeCampaigns: Scalars['Int']['output'];
  completedCampaigns: Scalars['Int']['output'];
  ctr: Scalars['String']['output'];
  draftCampaigns: Scalars['Int']['output'];
  pausedCampaigns: Scalars['Int']['output'];
  pendingApprovalCampaigns: Scalars['Int']['output'];
  thisMonthRevenueCents: Scalars['Int']['output'];
  totalCampaigns: Scalars['Int']['output'];
  totalClicks: Scalars['Int']['output'];
  totalImpressions: Scalars['Int']['output'];
  totalRevenueCents: Scalars['Int']['output'];
};

/** The status of an ad campaign */
export enum CampaignStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Paused = 'PAUSED',
  PendingApproval = 'PENDING_APPROVAL',
  PendingPayment = 'PENDING_PAYMENT',
  RefundProcessed = 'REFUND_PROCESSED',
  Rejected = 'REJECTED',
  Suspended = 'SUSPENDED'
}

export type CaseMediaModel = {
  __typename?: 'CaseMediaModel';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  optimizedImageUrl?: Maybe<Scalars['String']['output']>;
  order: Scalars['Float']['output'];
  step: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
  translatedText?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type CasePostModel = {
  __typename?: 'CasePostModel';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  media: Array<CaseMediaModel>;
  postId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CeCourse = {
  __typename?: 'CeCourse';
  category?: Maybe<Scalars['String']['output']>;
  ceCredits?: Maybe<Scalars['Float']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deliveryMode?: Maybe<CeCourseDeliveryMode>;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** e.g. "Live Webinar", "MP4 Video". */
  format?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  instructors: Array<Scalars['String']['output']>;
  isFree?: Maybe<Scalars['Boolean']['output']>;
  /** My Library item holding this content for the current user, or null when not saved. */
  libraryItemId?: Maybe<Scalars['ID']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  /** Source site name, e.g. "Dentaltown". */
  provider: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Start time for live webinars / events. */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Course page on the source site — open in a new tab. */
  url: Scalars['String']['output'];
};

/** How an external CE course is taken (ON_DEMAND, LIVE_WEBINAR, IN_PERSON) */
export enum CeCourseDeliveryMode {
  InPerson = 'IN_PERSON',
  LiveWebinar = 'LIVE_WEBINAR',
  OnDemand = 'ON_DEMAND'
}

export type CeCourseFacet = {
  __typename?: 'CeCourseFacet';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CeCourseFilters = {
  __typename?: 'CeCourseFilters';
  categories: Array<CeCourseFacet>;
  /** Counts per delivery mode; `name` is a CeCourseDeliveryMode value. */
  deliveryModes: Array<CeCourseFacet>;
  freeCount: Scalars['Int']['output'];
  paidCount: Scalars['Int']['output'];
  providers: Array<CeCourseFacet>;
};

export type CeCoursePage = {
  __typename?: 'CeCoursePage';
  items: Array<CeCourse>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  /** Total courses matching the filters. */
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

/** Price filter for ceCourses (FREE, PAID) */
export enum CeCoursePriceFilter {
  Free = 'FREE',
  Paid = 'PAID'
}

export type CeCoursesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  /** Any of these delivery modes. */
  deliveryModes?: InputMaybe<Array<CeCourseDeliveryMode>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Courses worth at least this many CE credits. */
  minCredits?: InputMaybe<Scalars['Float']['input']>;
  /** 1-based page number. */
  page?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<CeCoursePriceFilter>;
  /** Provider names from `ceCourseFilters`. */
  providers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches title, description, category or provider. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeGroupStatusInput = {
  groupId: Scalars['String']['input'];
  status: GroupStatus;
};

export type ChangeSupportTicketPriorityInput = {
  priority: SupportTicketPriority;
  ticketId: Scalars['ID']['input'];
};

export type ChangeSupportTicketStatusInput = {
  status: SupportTicketStatus;
  ticketId: Scalars['ID']['input'];
};

/** Whether the subject of a realtime event was created, updated or deleted. */
export enum ChangeType {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Updated = 'UPDATED'
}

export type ChartData = {
  __typename?: 'ChartData';
  categories: Array<Scalars['String']['output']>;
  range: Scalars['String']['output'];
  series: Array<ChartSeries>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ChartSeries = {
  __typename?: 'ChartSeries';
  data: Array<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type CheckCouponAvailabilityInput = {
  serviceId: Scalars['ID']['input'];
};

export type CheckSignupAvailabilityInput = {
  dentalLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  universityEmail?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutSessionResult = {
  __typename?: 'CheckoutSessionResult';
  checkoutUrl: Scalars['String']['output'];
};

export type Comment = {
  __typename?: 'Comment';
  content: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  mediaUrls: Array<Scalars['String']['output']>;
  optimizedMediaUrls?: Maybe<Array<Scalars['String']['output']>>;
  originalLanguage?: Maybe<Scalars['String']['output']>;
  reactions: ReactionSummary;
  repliesCount?: Maybe<Scalars['Int']['output']>;
  translatedContent?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: CommentAuthor;
  userId: Scalars['String']['output'];
};

export type CommentAuthor = {
  __typename?: 'CommentAuthor';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Badge the user chose to show beside their name (opt-in, null when none). Batched per request. */
  influenceBadge?: Maybe<AchievementBadge>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Role;
  title?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommissionTransaction = {
  __typename?: 'CommissionTransaction';
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoicePdf?: Maybe<Scalars['String']['output']>;
  mentorName?: Maybe<Scalars['String']['output']>;
  paidAmount?: Maybe<Scalars['Float']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  platformFeeAmount?: Maybe<Scalars['Float']['output']>;
  receiptUrl?: Maybe<Scalars['String']['output']>;
  sessionFeeAmount?: Maybe<Scalars['Float']['output']>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  studentName?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type Community = {
  __typename?: 'Community';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  logoOptimizedUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Company = {
  __typename?: 'Company';
  autoInvite: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  coverOptimizedUrl?: Maybe<Scalars['String']['output']>;
  coverUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  ctaLabel?: Maybe<Scalars['String']['output']>;
  ctaType?: Maybe<CtaType>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  followersCount?: Maybe<Scalars['Int']['output']>;
  hashtags?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  logoOptimizedUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  mission?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orgType?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  ownerId: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  showcases?: Maybe<Array<Company>>;
  size?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  specialties?: Maybe<Array<Scalars['String']['output']>>;
  status?: Maybe<CompanyStatus>;
  story?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  type: CompanyType;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
  websiteLinks?: Maybe<Scalars['JSON']['output']>;
};

export type CompanyAuthor = {
  __typename?: 'CompanyAuthor';
  followersCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  isFollowing?: Maybe<Scalars['Boolean']['output']>;
  logoOptimizedUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  tagline?: Maybe<Scalars['String']['output']>;
};

export type CompanyFollowersPaginated = {
  __typename?: 'CompanyFollowersPaginated';
  hasMore: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
  users: Array<User>;
};

export type CompanyInboxMessage = {
  __typename?: 'CompanyInboxMessage';
  allMessages: Array<CompanyInboxMessageReply>;
  content: Scalars['String']['output'];
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  hasReplies: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastMessageAt: Scalars['DateTime']['output'];
  replies: Array<CompanyInboxMessageReply>;
  repliesCount: Scalars['Int']['output'];
  senderAvatar?: Maybe<Scalars['String']['output']>;
  senderId: Scalars['String']['output'];
  senderName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  totalMessages: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
};

export type CompanyInboxMessageReply = {
  __typename?: 'CompanyInboxMessageReply';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isAuthor: Scalars['Boolean']['output'];
  senderId: Scalars['String']['output'];
};

export type CompanyInboxResponse = {
  __typename?: 'CompanyInboxResponse';
  limit: Scalars['Int']['output'];
  messages: Array<CompanyInboxMessage>;
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
};

export type CompanyInfo = {
  __typename?: 'CompanyInfo';
  id: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ownerId: Scalars['ID']['output'];
};

export enum CompanyMessageStatus {
  Archived = 'ARCHIVED',
  Deleted = 'DELETED',
  Read = 'READ',
  Replied = 'REPLIED',
  Unread = 'UNREAD'
}

export type CompanyPagesPaginated = {
  __typename?: 'CompanyPagesPaginated';
  items: Array<Company>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CompanyPreview = {
  __typename?: 'CompanyPreview';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  followersCount?: Maybe<Scalars['Int']['output']>;
  hashtags?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  isFollowing: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CompanyType>;
};

/** The status of a company */
export enum CompanyStatus {
  Active = 'ACTIVE',
  Suspended = 'SUSPENDED'
}

/** Company page type (COMPANY, SHOWCASE, EDUCATIONAL_INSTITUTION) */
export enum CompanyType {
  Company = 'COMPANY',
  EducationalInstitution = 'EDUCATIONAL_INSTITUTION',
  Showcase = 'SHOWCASE'
}

export type CompleteMultipartUploadInput = {
  fileSize: Scalars['BigInt']['input'];
  fileType: FileType;
  key: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  module?: InputMaybe<MediaModule>;
  parts: Array<MultipartCompletedPartInput>;
  uploadId: Scalars['String']['input'];
};

export type ConfirmUploadInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ConnectionActionInput = {
  requesterId: Scalars['String']['input'];
};

export type ConnectionListItemType = {
  __typename?: 'ConnectionListItemType';
  createdAt: Scalars['DateTime']['output'];
  direction: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export enum ConnectionRequestDirection {
  Received = 'RECEIVED',
  Sent = 'SENT'
}

/** The status of a connection between two users */
export enum ConnectionStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ConnectionStatusModel = {
  __typename?: 'ConnectionStatusModel';
  direction?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type ConnectionStatusType = {
  __typename?: 'ConnectionStatusType';
  direction: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  id: Scalars['ID']['output'];
  platform: ContactPlatform;
  showOnProfile: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export enum ContactPlatform {
  Discord = 'DISCORD',
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  Other = 'OTHER',
  Snapchat = 'SNAPCHAT',
  Telegram = 'TELEGRAM',
  Threads = 'THREADS',
  Tiktok = 'TIKTOK',
  X = 'X'
}

export type ContentToken = {
  __typename?: 'ContentToken';
  handle?: Maybe<Scalars['String']['output']>;
  type: ContentTokenType;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** The type of content token */
export enum ContentTokenType {
  Hashtag = 'HASHTAG',
  Link = 'LINK',
  Mention = 'MENTION',
  Text = 'TEXT'
}

export type ContentViewResponse = {
  __typename?: 'ContentViewResponse';
  contentId: Scalars['ID']['output'];
  contentType: ContentViewType;
  duration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  viewedAt: Scalars['DateTime']['output'];
};

/** The type of content viewed (LECTURE, QUIZ) */
export enum ContentViewType {
  Document = 'DOCUMENT',
  Lecture = 'LECTURE',
  Quiz = 'QUIZ'
}

export type Conversation = {
  __typename?: 'Conversation';
  company?: Maybe<CompanyInfo>;
  companyId?: Maybe<Scalars['ID']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastMessage?: Maybe<Scalars['String']['output']>;
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  messages?: Maybe<Array<Message>>;
  type: ConversationType;
  unreadCount: Scalars['Float']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<ConversationMember>;
};

export type ConversationLivekitTokenResponse = {
  __typename?: 'ConversationLivekitTokenResponse';
  room: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type ConversationMember = {
  __typename?: 'ConversationMember';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ConversationType {
  UserToCompany = 'USER_TO_COMPANY',
  UserToUser = 'USER_TO_USER'
}

export type CountryUsersStats = {
  __typename?: 'CountryUsersStats';
  country?: Maybe<Scalars['String']['output']>;
  percentage: Scalars['Float']['output'];
  totalUsers: Scalars['Int']['output'];
};

export type Coupon = {
  __typename?: 'Coupon';
  couponCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  discountPrice: Scalars['Float']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  redeemedCoupons: Scalars['Float']['output'];
  serviceId?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totalCoupons: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CouponAvailabilityResponse = {
  __typename?: 'CouponAvailabilityResponse';
  couponCode?: Maybe<Scalars['String']['output']>;
  discountPrice?: Maybe<Scalars['Float']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  isRedeemedByMe?: Maybe<Scalars['Boolean']['output']>;
  isReportedByMe?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  redeemedCoupons?: Maybe<Scalars['Float']['output']>;
  status: CouponStatus;
  title?: Maybe<Scalars['String']['output']>;
  totalCoupons?: Maybe<Scalars['Float']['output']>;
};

export type CouponDetailWithUsers = {
  __typename?: 'CouponDetailWithUsers';
  couponCode: Scalars['String']['output'];
  discountPrice: Scalars['Float']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  redeemedCoupons: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  status: CouponStatus;
  title: Scalars['String']['output'];
  totalCoupons: Scalars['Int']['output'];
  users: Array<CouponUser>;
};

export type CouponRedemptionUser = {
  __typename?: 'CouponRedemptionUser';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type CouponRedemptionsResponse = {
  __typename?: 'CouponRedemptionsResponse';
  couponCode: Scalars['String']['output'];
  discountPrice: Scalars['Float']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  redeemedCoupons: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
  status: CouponStatus;
  title: Scalars['String']['output'];
  totalCoupons: Scalars['Float']['output'];
  users: Array<CouponRedemptionUser>;
};

export type CouponStats = {
  __typename?: 'CouponStats';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

/** The status of the coupon (UPCOMING, ACTIVE, EXPIRED) */
export enum CouponStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Expired = 'EXPIRED',
  Upcoming = 'UPCOMING'
}

export type CouponUser = {
  __typename?: 'CouponUser';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Role;
  title?: Maybe<Scalars['String']['output']>;
};

export type Course = {
  __typename?: 'Course';
  category: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  difficultyLevel: DifficultyLevel;
  durationMinutes: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  instructor?: Maybe<User>;
  instructorId?: Maybe<Scalars['ID']['output']>;
  introVideoUrl?: Maybe<Scalars['String']['output']>;
  isPublished: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  /** My Library item holding this content for the current user, or null when not saved. */
  libraryItemId?: Maybe<Scalars['ID']['output']>;
  modules?: Maybe<Array<CourseModule>>;
  subcategory?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CourseCategory = {
  __typename?: 'CourseCategory';
  children?: Maybe<Array<CourseCategory>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CourseContentStatsResponse = {
  __typename?: 'CourseContentStatsResponse';
  lectures: Array<LectureStats>;
  quizzes: Array<QuizStats>;
};

export type CourseDetail = {
  __typename?: 'CourseDetail';
  /** Average rating for the course */
  averageRating?: Maybe<Scalars['Float']['output']>;
  category: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  difficultyLevel: DifficultyLevel;
  durationMinutes: Scalars['Float']['output'];
  enrollmentStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructor?: Maybe<InstructorDetail>;
  introVideoUrl?: Maybe<Scalars['String']['output']>;
  isEnrolledByMe: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  modules?: Maybe<Array<ModuleDetail>>;
  subcategory?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalEnrolledStudents: Scalars['Float']['output'];
  /** Total number of ratings for the course */
  totalRatings: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CourseDetailWithProgress = {
  __typename?: 'CourseDetailWithProgress';
  category: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['String']['output']>;
  completedLectures: Scalars['Int']['output'];
  completedQuizzes: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  difficultyLevel: Scalars['String']['output'];
  durationMinutes: Scalars['Int']['output'];
  enrollmentId?: Maybe<Scalars['String']['output']>;
  enrollmentStatus: Scalars['String']['output'];
  id: Scalars['String']['output'];
  instructor: InstructorInfo;
  introVideoUrl: Scalars['String']['output'];
  isCourseRatedByMe: Scalars['Boolean']['output'];
  isEnrolled: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  modules: Array<ModuleWithProgress>;
  overallProgress: Scalars['Int']['output'];
  subcategory: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totalDocuments: Scalars['Int']['output'];
  totalLectures: Scalars['Int']['output'];
  totalQuizzes: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type CourseDocument = {
  __typename?: 'CourseDocument';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documentUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  moduleId: Scalars['ID']['output'];
  orderIndex?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CourseModule = {
  __typename?: 'CourseModule';
  courseId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  documents?: Maybe<Array<CourseDocument>>;
  id: Scalars['ID']['output'];
  lectures?: Maybe<Array<Lecture>>;
  name: Scalars['String']['output'];
  orderIndex: Scalars['Float']['output'];
  quizzes?: Maybe<Array<Quiz>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CoursePaginatedResponse = {
  __typename?: 'CoursePaginatedResponse';
  data: Array<Course>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CourseWithTotalLectures = {
  __typename?: 'CourseWithTotalLectures';
  averageRating: Scalars['Float']['output'];
  category: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  difficultyLevel: DifficultyLevel;
  durationMinutes: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  instructor?: Maybe<User>;
  instructorId?: Maybe<Scalars['ID']['output']>;
  introVideoUrl?: Maybe<Scalars['String']['output']>;
  isPublished: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  /** My Library item holding this content for the current user, or null when not saved. */
  libraryItemId?: Maybe<Scalars['ID']['output']>;
  modules?: Maybe<Array<CourseModule>>;
  subcategory?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalLectures: Scalars['Int']['output'];
  totalRatings: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CreateAdminInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  permissionId: Scalars['String']['input'];
};

export type CreateAdminPermissionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateAdvisorInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  imageUrl: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateAiAgentInput = {
  activeHoursEnd?: InputMaybe<Scalars['Int']['input']>;
  activeHoursStart?: InputMaybe<Scalars['Int']['input']>;
  allowedTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  blockedTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  commentLookbackDays?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  maxCommentsPerDay?: InputMaybe<Scalars['Int']['input']>;
  maxMinutesBetweenActions?: InputMaybe<Scalars['Int']['input']>;
  maxPostsPerDay?: InputMaybe<Scalars['Int']['input']>;
  maxReactionsPerDay?: InputMaybe<Scalars['Int']['input']>;
  maxRepliesPerDay?: InputMaybe<Scalars['Int']['input']>;
  minMinutesBetweenActions?: InputMaybe<Scalars['Int']['input']>;
  personaPrompt: Scalars['String']['input'];
  postLookbackDays?: InputMaybe<Scalars['Int']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  reactionLookbackDays?: InputMaybe<Scalars['Int']['input']>;
  role: Role;
  timezone?: InputMaybe<Scalars['String']['input']>;
  tone?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateArticleInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  coverImageUrl?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: ArticleStatus;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tags?: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateBookingInput = {
  attendee: AttendeeInput;
  endsAt: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  schedulingId: Scalars['ID']['input'];
  startsAt: Scalars['String']['input'];
};

export type CreateBroadcastInput = {
  audience: BroadcastAudienceInput;
  channels: Array<BroadcastChannel>;
  /** Plain-text email body (no HTML). */
  emailBody?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  /** In-app notification text. Required when the In-app channel is on. */
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** App module the in-app notification opens when tapped. Omit/null = the notification is not clickable. */
  redirectTarget?: InputMaybe<BroadcastRedirectTarget>;
};

export type CreateCampaignInput = {
  adFormat?: AdFormat;
  ctaText?: InputMaybe<Scalars['String']['input']>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  durationDays?: InputMaybe<Scalars['Int']['input']>;
  durationHours?: InputMaybe<Scalars['Float']['input']>;
  headline: Scalars['String']['input'];
  mediaUrls: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  objective: CampaignObjective;
  targetCompanyTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  targetEducationLevels?: InputMaybe<Array<Scalars['String']['input']>>;
  targetExperienceLevels?: InputMaybe<Array<Scalars['String']['input']>>;
  targetLocations?: InputMaybe<Array<Scalars['String']['input']>>;
  targetRoles?: InputMaybe<Array<Role>>;
  targetSpecializations?: InputMaybe<Array<Expertise>>;
};

export type CreateCasePostData = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Float']['input'];
  step: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type CreateCasePostInput = {
  casemedia: Array<CreateCasePostData>;
  communityId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  mediaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  mentions?: InputMaybe<Array<MentionInput>>;
  privacy?: InputMaybe<PostPrivacy>;
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommentInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  mediaURL?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['ID']['input'];
};

export type CreateCommunityInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreateCompanyInput = {
  coverUrl?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  ctaType?: InputMaybe<CtaType>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  industry?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orgType?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  specialties?: InputMaybe<Array<Scalars['String']['input']>>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CompanyType>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCouponInput = {
  couponCode: Scalars['String']['input'];
  discountPrice: Scalars['Float']['input'];
  endDate: Scalars['String']['input'];
  serviceId?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  totalCoupons: Scalars['Float']['input'];
};

export type CreateCourseCategoryInput = {
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCourseDocumentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  documentUrl: Scalars['String']['input'];
  orderIndex?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
};

export type CreateCourseInput = {
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  difficultyLevel: DifficultyLevel;
  durationMinutes: Scalars['Float']['input'];
  introVideoUrl?: InputMaybe<Scalars['String']['input']>;
  isPublished?: Scalars['Boolean']['input'];
  language: Scalars['String']['input'];
  modules?: InputMaybe<Array<CreateCourseModuleInput>>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateCourseModuleInput = {
  documents?: InputMaybe<Array<CreateCourseDocumentInput>>;
  lectures?: InputMaybe<Array<CreateLectureInput>>;
  name: Scalars['String']['input'];
  orderIndex: Scalars['Float']['input'];
  quizzes?: InputMaybe<Array<CreateQuizInput>>;
};

export type CreateEventInput = {
  category: Scalars['String']['input'];
  courseId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['DateTime']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  maxAttendees?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type CreateFaqInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type CreateGroupInput = {
  categories: Array<Scalars['String']['input']>;
  coverImage: Scalars['String']['input'];
  description: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  privacy: Scalars['String']['input'];
  profileImage: Scalars['String']['input'];
  reviewPosts?: InputMaybe<Scalars['Boolean']['input']>;
  rules?: InputMaybe<Scalars['String']['input']>;
  tags: Array<Scalars['String']['input']>;
};

export type CreateLectureInput = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  handoutDocumentsUrl?: InputMaybe<Array<Scalars['String']['input']>>;
  orderIndex: Scalars['Float']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLegalInstructionInput = {
  pdfUrl?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateLibraryCollectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateLibraryFolderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateLibraryTagInput = {
  name: Scalars['String']['input'];
};

export type CreateLiveStreamInput = {
  description?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNewsletterDraftInput = {
  content: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type CreateNewsletterInput = {
  /** Email address of the subscriber */
  email: Scalars['String']['input'];
};

export type CreateOccasionPostInput = {
  communityId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  description: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['String']['input'];
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  mediaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  mentions?: InputMaybe<Array<MentionInput>>;
  privacy?: InputMaybe<PostPrivacy>;
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreatePodcastCommentInput = {
  content: Scalars['String']['input'];
  episodeId: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePodcastSourceInput = {
  /** If false (default), synced episodes land hidden for the owner to publish one by one. */
  autoPublish?: InputMaybe<Scalars['Boolean']['input']>;
  url: Scalars['String']['input'];
};

export type CreatePollPostInput = {
  communityId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  duration: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  mediaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  mentions?: InputMaybe<Array<MentionInput>>;
  options: Array<Scalars['String']['input']>;
  privacy?: InputMaybe<PostPrivacy>;
  question: Scalars['String']['input'];
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePostInput = {
  communityId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  mediaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  mentions?: InputMaybe<Array<MentionInput>>;
  privacy?: InputMaybe<PostPrivacy>;
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
};

export type CreateQuizInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isPublished?: Scalars['Boolean']['input'];
  orderIndex: Scalars['Float']['input'];
  passingScore?: Scalars['Float']['input'];
  questions: Array<CreateQuizQuestionInput>;
  title: Scalars['String']['input'];
};

export type CreateQuizOptionInput = {
  isCorrect: Scalars['Boolean']['input'];
  optionText: Scalars['String']['input'];
  orderIndex: Scalars['Float']['input'];
};

export type CreateQuizQuestionInput = {
  options: Array<CreateQuizOptionInput>;
  orderIndex: Scalars['Float']['input'];
  points?: Scalars['Float']['input'];
  questionText: Scalars['String']['input'];
  questionType: Scalars['String']['input'];
};

export type CreateReelCommentInput = {
  content: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  reelId: Scalars['ID']['input'];
};

export type CreateReferralCampaignInput = {
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  type: ReferralType;
};

export type CreateRepostInput = {
  mentions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  originalPostId: Scalars['String']['input'];
  repostComment?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReviewInput = {
  comment: Scalars['String']['input'];
  mentorId: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
};

export type CreateRoleChangeRequestInput = {
  reason: Scalars['String']['input'];
  requestedRole: Role;
};

export type CreateRssSourceInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateSchedulingInput = {
  bufferAfter?: InputMaybe<Scalars['Int']['input']>;
  bufferBefore?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Int']['input'];
  locationType: SchedulingLocationType;
  slug?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateServiceInput = {
  address: Scalars['String']['input'];
  category: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  description: Scalars['String']['input'];
  fee: Scalars['Float']['input'];
  images: Array<Scalars['String']['input']>;
  langitude: Scalars['Float']['input'];
  latitude: Scalars['Float']['input'];
  priceType: PriceType;
  serviceStatus: ServiceStatus;
  title: Scalars['String']['input'];
  type?: InputMaybe<ServiceType>;
};

export type CreateServiceReportInput = {
  reason: Scalars['String']['input'];
  serviceId: Scalars['ID']['input'];
};

export type CreateSigningDocumentInput = {
  fileName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pageCount?: InputMaybe<Scalars['Int']['input']>;
  pdfMediaId?: InputMaybe<Scalars['ID']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSigningTemplateInput = {
  fileName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pageCount?: InputMaybe<Scalars['Int']['input']>;
  pdfMediaId: Scalars['ID']['input'];
};

export type CreateSourceCompanyInput = {
  cons: Array<SourcePointInput>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pros: Array<SourcePointInput>;
};

export type CreateSourceReviewInput = {
  reviewer: Scalars['String']['input'];
  sourceCompanyId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type CreateSponsoredRequestInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSponsorshipCheckoutInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['String']['input'];
};

export type CreateSponsorshipEventInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateSponsorshipPlanInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** Price in cents. Must be > 0. */
  priceCents: Scalars['Int']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateStoryInput = {
  contents: Array<StoryContentItemInput>;
};

export type CreateSubscriberInput = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSubscriptionCouponInput = {
  discountPercent: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  type: SubscriptionCouponType;
};

export type CreateSubscriptionPlanInput = {
  accessAIChatbot?: Scalars['Boolean']['input'];
  actionButtonOnProfile?: Scalars['Boolean']['input'];
  appleProductId?: InputMaybe<Scalars['String']['input']>;
  companyPages?: InputMaybe<Scalars['Int']['input']>;
  connectionSendingLimits?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  googleProductId?: InputMaybe<Scalars['String']['input']>;
  groupCreation?: InputMaybe<Scalars['Int']['input']>;
  liveStreaming?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  priceMonthly: Scalars['Float']['input'];
  serviceListings?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSupportTicketInput = {
  /** Media ids from uploadDocument (module: SUPPORT). */
  attachmentMediaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** SupportCategory id. Optional but recommended. */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  relatedId?: InputMaybe<Scalars['String']['input']>;
  relatedType?: InputMaybe<SupportRelatedType>;
  subject: Scalars['String']['input'];
};

export type CreateVideoSourceInput = {
  autoPublish?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  includeShorts?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  provider: VideoProvider;
  syncMode?: InputMaybe<VideoSourceSyncMode>;
  url: Scalars['String']['input'];
};

export type CronJobStatus = {
  __typename?: 'CronJobStatus';
  failureCount: Scalars['Int']['output'];
  jobName: Scalars['String']['output'];
  lastDurationMs?: Maybe<Scalars['Int']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  lastFailureAt?: Maybe<Scalars['DateTime']['output']>;
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  lastStatus?: Maybe<Scalars['String']['output']>;
  lastSuccessAt?: Maybe<Scalars['DateTime']['output']>;
  runCount: Scalars['Int']['output'];
  schedule: Scalars['String']['output'];
};

export enum Currency {
  Aud = 'AUD',
  Cad = 'CAD',
  Chf = 'CHF',
  Cny = 'CNY',
  Eur = 'EUR',
  Gbp = 'GBP',
  Inr = 'INR',
  Jpy = 'JPY',
  Nzd = 'NZD',
  Usd = 'USD'
}

export type DateAvailabilityOverride = {
  __typename?: 'DateAvailabilityOverride';
  date: Scalars['String']['output'];
  ranges: Array<SchedulingTimeRange>;
  type: DateAvailabilityOverrideType;
};

export enum DateAvailabilityOverrideType {
  Custom = 'CUSTOM',
  Unavailable = 'UNAVAILABLE'
}

export enum Day {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DeleteCommentInput = {
  commentId: Scalars['String']['input'];
};

export type DeleteConnectionInput = {
  userId: Scalars['String']['input'];
};

export type DeleteContactInput = {
  contactId: Scalars['String']['input'];
};

export type DeleteContentInput = {
  contentId: Scalars['ID']['input'];
};

export type DeleteEducationInput = {
  educationId: Scalars['String']['input'];
};

export type DeleteExperienceInput = {
  experienceId: Scalars['String']['input'];
};

export type DeleteLicenseInput = {
  licenseId: Scalars['String']['input'];
};

export type DeletePodcastEpisodeInput = {
  episodeId: Scalars['String']['input'];
};

export type DeleteReelInput = {
  reelId: Scalars['ID']['input'];
};

export type DeleteSkillInput = {
  skillId: Scalars['String']['input'];
};

export type DigitalCardPaymentInit = {
  __typename?: 'DigitalCardPaymentInit';
  amountCents: Scalars['Int']['output'];
  clientSecret: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
  publishableKey: Scalars['String']['output'];
};

export type DigitalCardVisibilitySettings = {
  __typename?: 'DigitalCardVisibilitySettings';
  about: Scalars['Boolean']['output'];
  education: Scalars['Boolean']['output'];
  email: Scalars['Boolean']['output'];
  experience: Scalars['Boolean']['output'];
  expertise: Scalars['Boolean']['output'];
  phone: Scalars['Boolean']['output'];
  socialLinks: Scalars['Boolean']['output'];
  website: Scalars['Boolean']['output'];
};

export type DisconnectGoogleCalendarResult = {
  __typename?: 'DisconnectGoogleCalendarResult';
  success: Scalars['Boolean']['output'];
};

export type DiscoverGroupsResponse = {
  __typename?: 'DiscoverGroupsResponse';
  groups: Array<Group>;
  hasNext: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type DocumentDetail = {
  __typename?: 'DocumentDetail';
  description?: Maybe<Scalars['String']['output']>;
  documentUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  orderIndex?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
};

export type DocumentProgress = {
  __typename?: 'DocumentProgress';
  description?: Maybe<Scalars['String']['output']>;
  documentUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isAccessible: Scalars['Boolean']['output'];
  isRemaining: Scalars['Boolean']['output'];
  orderIndex: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type EditAboutInput = {
  about: Scalars['String']['input'];
};

export type EditBasicAccountInput = {
  businessType?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expertise?: InputMaybe<Expertise>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Suffix>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EditContactInput = {
  contactId: Scalars['String']['input'];
  platform: ContactPlatform;
  showOnProfile?: Scalars['Boolean']['input'];
  url: Scalars['String']['input'];
};

export type EditEducationInput = {
  degree?: InputMaybe<Scalars['String']['input']>;
  educationId: Scalars['ID']['input'];
  endDay?: InputMaybe<Scalars['Int']['input']>;
  endMonth?: InputMaybe<Scalars['Int']['input']>;
  endYear?: InputMaybe<Scalars['Int']['input']>;
  fieldOfStudy?: InputMaybe<Scalars['String']['input']>;
  institution?: InputMaybe<Scalars['String']['input']>;
  startDay?: InputMaybe<Scalars['Int']['input']>;
  startMonth?: InputMaybe<Scalars['Int']['input']>;
  startYear?: InputMaybe<Scalars['Int']['input']>;
};

export type EditExperienceInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  experienceId: Scalars['String']['input'];
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EditLicenseInput = {
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate: Scalars['DateTime']['input'];
  licenseID: Scalars['String']['input'];
  licenseId: Scalars['String']['input'];
  licenseURL: Scalars['String']['input'];
  organization: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type EditMentorAvailabilityInput = {
  price: Scalars['Float']['input'];
  /** Timezone identifier (could be an enum or a string scalar) */
  timezone: Scalars['String']['input'];
  weeklyAvailability: Array<WeeklyAvailabilityInput>;
};

export type EditMentorDayAvailabilityInput = {
  currency?: Currency;
  day: Array<Day>;
  isRecurring?: Scalars['Boolean']['input'];
  price: Scalars['Float']['input'];
  timeSlots: Array<MentorTimeRangeInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type Education = {
  __typename?: 'Education';
  degree: Scalars['String']['output'];
  endDay?: Maybe<Scalars['Int']['output']>;
  endMonth?: Maybe<Scalars['Int']['output']>;
  endYear?: Maybe<Scalars['Int']['output']>;
  fieldOfStudy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  institution: Scalars['String']['output'];
  startDay?: Maybe<Scalars['Int']['output']>;
  startMonth?: Maybe<Scalars['Int']['output']>;
  startYear?: Maybe<Scalars['Int']['output']>;
};

export type EnrollCourseInput = {
  /** The ID of the course to enroll in */
  courseId: Scalars['ID']['input'];
};

export type EnrolledCourse = {
  __typename?: 'EnrolledCourse';
  /** Average rating for the course */
  averageRating?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  difficultyLevel?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  instructor?: Maybe<InstructorInfo>;
  progressPercentage: Scalars['Int']['output'];
  subcategory?: Maybe<Scalars['String']['output']>;
  thumbnailUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** Total number of ratings for the course */
  totalRatings: Scalars['Int']['output'];
};

export type EnrolledCoursePaginatedResponse = {
  __typename?: 'EnrolledCoursePaginatedResponse';
  data: Array<EnrolledCourse>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type EnrolledStudentStats = {
  __typename?: 'EnrolledStudentStats';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  courseProgress: Scalars['Int']['output'];
  dateJoined: Scalars['DateTime']['output'];
  firstName: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lessonsCompleted: Scalars['Int']['output'];
  quizzesCompleted: Scalars['Int']['output'];
  studentId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  totalLessons: Scalars['Int']['output'];
  totalQuizzes: Scalars['Int']['output'];
};

export type EnrolledStudentStatsPaginatedResponse = {
  __typename?: 'EnrolledStudentStatsPaginatedResponse';
  data: Array<EnrolledStudentStats>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type EnrollmentResponse = {
  __typename?: 'EnrollmentResponse';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  courseId: Scalars['ID']['output'];
  enrolledAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lecturesCompleted: Scalars['Float']['output'];
  message?: Maybe<Scalars['String']['output']>;
  progressPercentage: Scalars['Float']['output'];
  quizzesCompleted: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  studentId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Event = {
  __typename?: 'Event';
  category: Scalars['String']['output'];
  course?: Maybe<EventCourse>;
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isjoinedbyMe: Scalars['Boolean']['output'];
  /** My Library item holding this content for the current user, or null when not saved. */
  libraryItemId?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  maxAttendees?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  optimizedImageUrl?: Maybe<Scalars['String']['output']>;
  organizedby: OrganizedBy;
  participantsCount: Scalars['Int']['output'];
  startTime: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EventCourse = {
  __typename?: 'EventCourse';
  id?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type EventsConnection = {
  __typename?: 'EventsConnection';
  data: Array<Event>;
  hasNextPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Experience = {
  __typename?: 'Experience';
  company?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  position: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export enum Expertise {
  DentalAnesthesiology = 'DENTAL_ANESTHESIOLOGY',
  DentalHygiene = 'DENTAL_HYGIENE',
  DentalProphylaxis = 'DENTAL_PROPHYLAXIS',
  Endodontics = 'ENDODONTICS',
  GeneralDentist = 'GENERAL_DENTIST',
  GumDiseasePrevention = 'GUM_DISEASE_PREVENTION',
  OralHealthAndHygiene = 'ORAL_HEALTH_AND_HYGIENE',
  OralHealthAssessment = 'ORAL_HEALTH_ASSESSMENT',
  OralMaxillofacialPathology = 'ORAL_MAXILLOFACIAL_PATHOLOGY',
  OralMaxillofacialRadiology = 'ORAL_MAXILLOFACIAL_RADIOLOGY',
  OralMaxillofacialSurgery = 'ORAL_MAXILLOFACIAL_SURGERY',
  OralMedicine = 'ORAL_MEDICINE',
  OrofacialPain = 'OROFACIAL_PAIN',
  OrthodonticsDentofacialOrthopedics = 'ORTHODONTICS_DENTOFACIAL_ORTHOPEDICS',
  PatientEducation = 'PATIENT_EDUCATION',
  PediatricDentistry = 'PEDIATRIC_DENTISTRY',
  PeriodontalCare = 'PERIODONTAL_CARE',
  Periodontics = 'PERIODONTICS',
  PreventiveDentistry = 'PREVENTIVE_DENTISTRY',
  Prosthodontics = 'PROSTHODONTICS'
}

export type ExpoPushTokenResponse = {
  __typename?: 'ExpoPushTokenResponse';
  token: Scalars['String']['output'];
  user: User;
};

export type ExternalEvent = {
  __typename?: 'ExternalEvent';
  allDay: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  costText?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endsAt: Scalars['DateTime']['output'];
  field: ExternalEventField;
  /** Long name, e.g. "Conference on Neural Information Processing Systems". */
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isOnline: Scalars['Boolean']['output'];
  kind: ExternalEventKind;
  organizerName?: Maybe<Scalars['String']['output']>;
  /** Data licence of the source, e.g. "MIT", "CC0". */
  sourceLicense?: Maybe<Scalars['String']['output']>;
  /** Where the listing comes from, e.g. "California Dental Association", "confs.tech". */
  sourceName: Scalars['String']['output'];
  sourceUrl: Scalars['String']['output'];
  startsAt: Scalars['DateTime']['output'];
  state?: Maybe<Scalars['String']['output']>;
  /** Next upcoming paper submission deadline (research conferences). */
  submissionDeadline?: Maybe<Scalars['DateTime']['output']>;
  /** IANA zone of the event (dental events), for showing local time. */
  timezone?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  topics: Array<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Event page on the source / organizer site — open in a new tab. */
  url: Scalars['String']['output'];
  venueName?: Maybe<Scalars['String']['output']>;
};

export type ExternalEventFacet = {
  __typename?: 'ExternalEventFacet';
  count: Scalars['Int']['output'];
  /** Filter value to send back (enum value, country, state, or "YYYY-MM"). */
  value: Scalars['String']['output'];
};

/** Subject area of an external event (DENTISTRY, TECH, CS_RESEARCH, AI_ML, ACADEMIC) */
export enum ExternalEventField {
  Academic = 'ACADEMIC',
  AiMl = 'AI_ML',
  CsResearch = 'CS_RESEARCH',
  Dentistry = 'DENTISTRY',
  Tech = 'TECH'
}

export type ExternalEventFilters = {
  __typename?: 'ExternalEventFilters';
  countries: Array<ExternalEventFacet>;
  fields: Array<ExternalEventFacet>;
  /** Kinds of dental events. */
  kinds: Array<ExternalEventFacet>;
  /** Months with upcoming events, "YYYY-MM", soonest first. */
  months: Array<ExternalEventFacet>;
  /** US states of dental events. */
  states: Array<ExternalEventFacet>;
  /** Listed events with the soonest upcoming paper deadlines. */
  upcomingDeadlines: Array<ExternalEvent>;
};

/** Kind of external event (CE_COURSE, CONFERENCE, WEBINAR, OTHER) */
export enum ExternalEventKind {
  CeCourse = 'CE_COURSE',
  Conference = 'CONFERENCE',
  Other = 'OTHER',
  Webinar = 'WEBINAR'
}

export type ExternalEventPage = {
  __typename?: 'ExternalEventPage';
  items: Array<ExternalEvent>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  /** Total events matching the filters. */
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

/** Sort order for externalEvents (SOONEST, NEWEST) */
export enum ExternalEventSort {
  Newest = 'NEWEST',
  Soonest = 'SOONEST'
}

export type ExternalEventsInput = {
  /** Country names from `externalEventFilters`. */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Any of these fields; empty = all fields. */
  fields?: InputMaybe<Array<ExternalEventField>>;
  /** Any of these kinds (dental events only carry a real kind). */
  kinds?: InputMaybe<Array<ExternalEventKind>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Events starting in this month, "YYYY-MM". */
  month?: InputMaybe<Scalars['String']['input']>;
  onlineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** 1-based page number. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Matches title, full name, city, country or organizer. */
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ExternalEventSort>;
  /** US states (e.g. "CA") from `externalEventFilters`. */
  states?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Faq = {
  __typename?: 'Faq';
  answer: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mentorId: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FaqResponse = {
  __typename?: 'FaqResponse';
  faqs: Array<Faq>;
  total: Scalars['Float']['output'];
};

export type FeedInput = {
  communityId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
};

export type FeedItem = {
  __typename?: 'FeedItem';
  advertisement?: Maybe<Campaign>;
  cursor: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  post?: Maybe<Post>;
  postBoost?: Maybe<PostBoost>;
  profileBoost?: Maybe<ProfileBoostFeedCard>;
  reels?: Maybe<Array<ReelModel>>;
  type: FeedItemType;
};

/** Discriminator for a single row in the mixed feed. */
export enum FeedItemType {
  Advertisement = 'ADVERTISEMENT',
  Post = 'POST',
  ProfileBoost = 'PROFILE_BOOST',
  ReelsTray = 'REELS_TRAY'
}

export type FeedPageInfo = {
  __typename?: 'FeedPageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type FeedResponse = {
  __typename?: 'FeedResponse';
  items: Array<FeedItem>;
  pageInfo: FeedPageInfo;
  /** @deprecated Use items where type=POST. Will be removed after clients migrate. */
  posts: Array<Post>;
  /** @deprecated Use items where type=ADVERTISEMENT. Will be removed after clients migrate. */
  sponsoredAd?: Maybe<Campaign>;
};

export enum FileType {
  BannerImage = 'BANNER_IMAGE',
  CommentImage = 'COMMENT_IMAGE',
  Document = 'DOCUMENT',
  GroupCover = 'GROUP_COVER',
  GroupPostMedia = 'GROUP_POST_MEDIA',
  Other = 'OTHER',
  PodcastAudio = 'PODCAST_AUDIO',
  PodcastVideo = 'PODCAST_VIDEO',
  PostImage = 'POST_IMAGE',
  PostVideo = 'POST_VIDEO',
  ProfileImage = 'PROFILE_IMAGE'
}

export type FilterCategoryEntity = {
  __typename?: 'FilterCategoryEntity';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FilterInstructorEntity = {
  __typename?: 'FilterInstructorEntity';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FilterLevelEntity = {
  __typename?: 'FilterLevelEntity';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FilterReviewEntity = {
  __typename?: 'FilterReviewEntity';
  count: Scalars['Int']['output'];
  rating: Scalars['Int']['output'];
};

export type FiltersResponseEntity = {
  __typename?: 'FiltersResponseEntity';
  categories: Array<FilterCategoryEntity>;
  instructors: Array<FilterInstructorEntity>;
  levels: Array<FilterLevelEntity>;
  reviews: Array<FilterReviewEntity>;
};

export type ForgetPasswordInput = {
  email: Scalars['String']['input'];
};

/** gender */
export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

export type GenerateNewsletterInput = {
  /** Overrides the default automation AI instructions for this one-off generation */
  instructions?: InputMaybe<Scalars['String']['input']>;
};

export type GetAdvisorsInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Search by name or bio */
  query?: InputMaybe<Scalars['String']['input']>;
};

export type GetAiAgentActionsInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<AiAgentActionStatus>;
  statuses?: InputMaybe<Array<AiAgentActionStatus>>;
  todayOnly?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<AiAgentActionType>;
};

export type GetAiAgentsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllCoursesInput = {
  /** Filter by multiple categories */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by instructor names */
  instructors?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by difficulty levels */
  levels?: InputMaybe<Array<DifficultyLevel>>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  /** Filter by review ratings (average) */
  reviews?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type GetCommentRepliesInput = {
  commentId: Scalars['ID']['input'];
};

export type GetCompanyInboxInput = {
  companyId: Scalars['String']['input'];
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type GetConnectionRequestsInput = {
  direction: ConnectionRequestDirection;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};

export type GetConnectionStatusInput = {
  userId: Scalars['String']['input'];
};

export type GetConversationMessagesInput = {
  conversationId: Scalars['String']['input'];
  includeReplies?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};

export type GetCuratedReelsInput = {
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<VideoProvider>;
  query?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetLinkPreviewInput = {
  url: Scalars['String']['input'];
};

export type GetLoanCalculatorLeadsInput = {
  /** ISO date — submitted on/after */
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  /** ISO date — submitted on/before */
  dateTo?: InputMaybe<Scalars['String']['input']>;
  /** true = need exceeds the government loan cap; false = within the cap (leads without funding inputs are excluded) */
  exceedsGovernmentCap?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  /** Filter by marketing consent */
  marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  page?: Scalars['Int']['input'];
  /** Search by email */
  query?: InputMaybe<Scalars['String']['input']>;
};

export type GetMentorAvailabilityInput = {
  mentorId: Scalars['String']['input'];
};

export type GetMentorDayAvailableSlotsInput = {
  /** Date in YYYY-MM-DD format */
  date: Scalars['String']['input'];
  /** ID of the mentor with whom the user is booking a session */
  mentorId: Scalars['String']['input'];
  /** Legacy US timezone enum (deprecated — prefer timezoneIana) */
  timezone?: InputMaybe<Timezone>;
  /** IANA timezone identifier of the requesting user (e.g. "Asia/Karachi") */
  timezoneIana?: InputMaybe<Scalars['String']['input']>;
};

export type GetMentorViewerAvailabilityCalendarInput = {
  /** ID of the mentor whose recurring availability should be projected */
  mentorId: Scalars['String']['input'];
  /** Legacy US timezone enum (deprecated — prefer timezoneIana) */
  timezone?: InputMaybe<Timezone>;
  /** IANA timezone of the viewer (e.g. "Asia/Karachi") */
  timezoneIana?: InputMaybe<Scalars['String']['input']>;
};

export type GetNewUsersInput = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetNewslettersInput = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  /** Search by subject */
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<NewsletterStatus>;
};

export type GetPodcastCommentRepliesInput = {
  commentId: Scalars['String']['input'];
  /** ISO datetime cursor (createdAt of last item) */
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GetPodcastCommentsInput = {
  /** ISO datetime cursor (createdAt of last item) */
  cursor?: InputMaybe<Scalars['String']['input']>;
  episodeId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GetPodcastCreatorsInput = {
  /** Opaque cursor from a previous page */
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Only creators with this user role */
  role?: InputMaybe<Role>;
  /** Match creators by name or organization (every word must match) */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetPodcastEpisodesByUserInput = {
  /** ISO datetime cursor (createdAt of last item) */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Owner-only filter: true = only pending-review synced episodes, false = only published. Ignored for non-owners. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Filter to audio-only or video-only episodes */
  mediaType?: InputMaybe<PodcastMediaType>;
  userId: Scalars['String']['input'];
};

export type GetPodcastEpisodesInput = {
  /** Filter by exact category */
  category?: InputMaybe<Scalars['String']['input']>;
  /** ISO datetime cursor (createdAt of last item), or offset for non-date sorts */
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Filter to audio-only or video-only episodes */
  mediaType?: InputMaybe<PodcastMediaType>;
  /** Search by title, description, or author name */
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PodcastEpisodeSortBy>;
};

export type GetPostInput = {
  postId: Scalars['ID']['input'];
};

export type GetPostReactionsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  postId: Scalars['ID']['input'];
  reactionType?: InputMaybe<ReactionType>;
};

export type GetPracticeValuationLeadsInput = {
  /** ISO date — submitted on/after */
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  /** ISO date — submitted on/before */
  dateTo?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  /** Filter by marketing consent */
  marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  page?: Scalars['Int']['input'];
  /** Search by name or email */
  query?: InputMaybe<Scalars['String']['input']>;
  timing?: InputMaybe<PracticeValuationTiming>;
};

export type GetProfileInput = {
  profileId: Scalars['String']['input'];
};

export type GetProfileViewersInput = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  profileUserId: Scalars['String']['input'];
};

export type GetReelCommentRepliesInput = {
  commentId: Scalars['ID']['input'];
  /** ISO datetime cursor for pagination */
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GetReelCommentsInput = {
  /** ISO datetime cursor for pagination (createdAt of last item) */
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  reelId: Scalars['ID']['input'];
};

export type GetReelsByUserIdInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};

export type GetSavedRssFeedsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type GetStoryReactorsInput = {
  contentId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type GetSubscribersInput = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  /** Search by email or name */
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<NewsletterSubscriberStatus>;
};

export type GetSuggestedCoursesInput = {
  courseId?: InputMaybe<Scalars['ID']['input']>;
  instructorId: Scalars['ID']['input'];
};

export type GetTopLevelCommentsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  postId: Scalars['ID']['input'];
};

export type GetUploadUrlInput = {
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};

export type GetUserAllComments = {
  __typename?: 'GetUserAllComments';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  mediaUrls?: Maybe<Array<Scalars['String']['output']>>;
  postId: Scalars['String']['output'];
  translatedContent?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: UserInfo;
  userId: Scalars['String']['output'];
};

export type GetUserCommunityPostsInput = {
  communityId: Scalars['String']['input'];
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};

export type GetUserPostsInput = {
  limit?: Scalars['Float']['input'];
  page?: Scalars['Float']['input'];
  userId: Scalars['ID']['input'];
};

export type GetUsersInput = {
  filter?: InputMaybe<UserFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type GetVideoSourcesInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<VideoProvider>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type GoogleCalendarAuthUrl = {
  __typename?: 'GoogleCalendarAuthUrl';
  url: Scalars['String']['output'];
};

export enum GoogleCalendarConnectionState {
  Connected = 'CONNECTED',
  Expired = 'EXPIRED',
  NotConnected = 'NOT_CONNECTED'
}

export type GoogleCalendarConnectionStatus = {
  __typename?: 'GoogleCalendarConnectionStatus';
  calendarId?: Maybe<Scalars['String']['output']>;
  connected: Scalars['Boolean']['output'];
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  googleEmail?: Maybe<Scalars['String']['output']>;
  status: GoogleCalendarConnectionState;
};

export type GoogleCalendarEvent = {
  __typename?: 'GoogleCalendarEvent';
  allDay: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  htmlLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  start: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Group = {
  __typename?: 'Group';
  categories: Array<Scalars['String']['output']>;
  coverImage?: Maybe<Scalars['String']['output']>;
  coverImageOptimizedUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  membersCount: Scalars['Float']['output'];
  memberships?: Maybe<Array<Maybe<GroupMembership>>>;
  name: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  postsCount: Scalars['Float']['output'];
  privacy: Scalars['String']['output'];
  profileImage?: Maybe<Scalars['String']['output']>;
  profileImageOptimizedUrl?: Maybe<Scalars['String']['output']>;
  reviewPosts: Scalars['Boolean']['output'];
  rules?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GroupFeedInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  limit?: Scalars['Int']['input'];
};

export type GroupImagesResult = {
  __typename?: 'GroupImagesResult';
  coverImageOptimizedUrl?: Maybe<Scalars['String']['output']>;
  coverImageUrl: Scalars['String']['output'];
  profileImageOptimizedUrl?: Maybe<Scalars['String']['output']>;
  profileImageUrl: Scalars['String']['output'];
};

export type GroupInvite = {
  __typename?: 'GroupInvite';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  groupId: Scalars['ID']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitee?: Maybe<GroupInviteUserPreview>;
  inviteeEmail: Scalars['String']['output'];
  inviter?: Maybe<GroupInviteUserPreview>;
  inviterId: Scalars['ID']['output'];
  status: InviteStatus;
};

export type GroupInviteUserPreview = {
  __typename?: 'GroupInviteUserPreview';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  title?: Maybe<Scalars['String']['output']>;
};

export type GroupListResult = {
  __typename?: 'GroupListResult';
  items: Array<GroupSummary>;
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type GroupMembership = {
  __typename?: 'GroupMembership';
  groupId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isBanned: Scalars['Boolean']['output'];
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
  role: Scalars['String']['output'];
  status: MembershipStatus;
  user: User;
  userId: Scalars['String']['output'];
};

export type GroupPreview = {
  __typename?: 'GroupPreview';
  categories: Array<Scalars['String']['output']>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isJoined: Scalars['Boolean']['output'];
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  membersCount: Scalars['Int']['output'];
  membershipStatus?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owner: UserPreview;
  postsCount: Scalars['Int']['output'];
  privacy: Scalars['String']['output'];
  profileImage?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
};

/** Privacy enum for groups */
export enum GroupPrivacy {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type GroupRoleIds = {
  __typename?: 'GroupRoleIds';
  admins: Array<Scalars['ID']['output']>;
  moderators: Array<Scalars['ID']['output']>;
  ownerId: Scalars['ID']['output'];
};

/** The status of the group */
export enum GroupStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE'
}

export type GroupSummary = {
  __typename?: 'GroupSummary';
  admin?: Maybe<AdminSummary>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  privacy?: Maybe<GroupPrivacy>;
  profileImage?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Headline = {
  __typename?: 'Headline';
  bannerImageOptimizedUrl?: Maybe<Scalars['String']['output']>;
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  boostEndsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  consultationsCount?: Maybe<Scalars['Float']['output']>;
  experienceYearsCount?: Maybe<Scalars['Float']['output']>;
  expertise?: Maybe<Expertise>;
  headline?: Maybe<Scalars['String']['output']>;
  isBoosted?: Maybe<Scalars['Boolean']['output']>;
  isHiring?: Maybe<Scalars['Boolean']['output']>;
  isMentorVerified?: Maybe<Scalars['Boolean']['output']>;
  mentorshipPrice?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  openToWork?: Maybe<Scalars['Boolean']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  profileImageOptimizedUrl?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  profileVisitsCount?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  role: Role;
  state?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type IndustryPartnerMobileSignupInput = {
  Sociallink?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyLogo?: InputMaybe<Scalars['String']['input']>;
  confirmPassword: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  dentalSchool?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  graduationDate?: InputMaybe<Scalars['DateTime']['input']>;
  homeZip?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  officeFax?: InputMaybe<Scalars['String']['input']>;
  officePhone?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  paymentProvider: SignupPaymentProvider;
  phone: Scalars['String']['input'];
  position?: InputMaybe<Scalars['String']['input']>;
  reasonForJoining?: InputMaybe<Scalars['String']['input']>;
  selectedPlanId: Scalars['String']['input'];
  specialty?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  valueToCommunity?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type IndustryPartnerMobileSignupResult = {
  __typename?: 'IndustryPartnerMobileSignupResult';
  paymentProvider: SignupPaymentProvider;
  paymentStatus: SignupPaymentStatus;
  pendingSignupId: Scalars['String']['output'];
  selectedPlanId: Scalars['String']['output'];
};

export enum InfluenceDecision {
  Discounted = 'DISCOUNTED',
  Flagged = 'FLAGGED',
  Valid = 'VALID'
}

export enum InfluenceOutboxStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type InfluenceProfileView = {
  __typename?: 'InfluenceProfileView';
  connectionsCount: Scalars['Int']['output'];
  contributionCount: Scalars['Int']['output'];
  coursesCompletedCount: Scalars['Int']['output'];
  hideFromLeaderboards?: Maybe<Scalars['Boolean']['output']>;
  lifetimeInfluence: Scalars['Int']['output'];
  meaningfulCommentsCount: Scalars['Int']['output'];
  mentorshipSessionsCount: Scalars['Int']['output'];
  monthlyInfluence: Scalars['Int']['output'];
  monthlyRank?: Maybe<Scalars['Int']['output']>;
  nameBadge?: Maybe<AchievementBadge>;
  nextAchievement?: Maybe<AchievementProgressView>;
  nextTier?: Maybe<InfluenceTierView>;
  periodKey: Scalars['String']['output'];
  postsCount: Scalars['Int']['output'];
  selectedBadges: Array<AchievementBadge>;
  tier?: Maybe<InfluenceTierView>;
  userId: Scalars['ID']['output'];
};

export type InfluenceStatus = {
  __typename?: 'InfluenceStatus';
  enabled: Scalars['Boolean']['output'];
  leaderboardsEnabled: Scalars['Boolean']['output'];
};

export type InfluenceTierView = {
  __typename?: 'InfluenceTierView';
  badge: AchievementBadge;
  threshold: Scalars['Int']['output'];
};

export type InitializePostBoostPaymentInput = {
  durationHours: Scalars['Int']['input'];
  postId: Scalars['ID']['input'];
};

export type InitializeProfileBoostExtensionInput = {
  boostId: Scalars['String']['input'];
  durationHours: Scalars['Int']['input'];
};

export type InitializeProfileBoostPaymentInput = {
  durationHours: Scalars['Int']['input'];
  headline?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type InitializeSessionPaymentInput = {
  date: Scalars['String']['input'];
  description: Scalars['String']['input'];
  mentorId: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export type InitiateMultipartUploadInput = {
  fileSize: Scalars['BigInt']['input'];
  fileType: FileType;
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};

export type InstructorDetail = {
  __typename?: 'InstructorDetail';
  about?: Maybe<Scalars['String']['output']>;
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Badge the user chose to show beside their name (opt-in, null when none). Batched per request. */
  influenceBadge?: Maybe<AchievementBadge>;
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Role;
  title?: Maybe<Scalars['String']['output']>;
};

export type InstructorInfo = {
  __typename?: 'InstructorInfo';
  about?: Maybe<Scalars['String']['output']>;
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Badge the user chose to show beside their name (opt-in, null when none). Batched per request. */
  influenceBadge?: Maybe<AchievementBadge>;
  lastName: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type InviteLiveStreamResponse = {
  __typename?: 'InviteLiveStreamResponse';
  invitedCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  skippedCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export enum InviteStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type InviteToGroupInput = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  groupId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InviteToGroupResponse = {
  __typename?: 'InviteToGroupResponse';
  invitedCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  skippedCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type InviteToLiveStreamInput = {
  roomId: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
};

export enum InvoiceStatus {
  Failed = 'FAILED',
  Paid = 'PAID',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
}

export enum InvoiceType {
  Campaign = 'CAMPAIGN',
  DigitalProfessionalCard = 'DIGITAL_PROFESSIONAL_CARD',
  PostBoost = 'POST_BOOST',
  ProfileBoost = 'PROFILE_BOOST',
  Session = 'SESSION',
  Sponsorship = 'SPONSORSHIP',
  Subscription = 'SUBSCRIPTION'
}

/** DDS Recruit employment type filter */
export enum JobEmploymentType {
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME',
  PerDiem = 'PER_DIEM'
}

export type JobFilterOption = {
  __typename?: 'JobFilterOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type JobFilterOptions = {
  __typename?: 'JobFilterOptions';
  employmentTypes: Array<JobFilterOption>;
  roleTypes: Array<JobFilterOption>;
  sort: Array<JobFilterOption>;
  specialties: Array<JobFilterOption>;
  yearsOfExperience: Array<JobFilterOption>;
};

export type JobListing = {
  __typename?: 'JobListing';
  additionalLocations?: Maybe<Array<Scalars['String']['output']>>;
  annualCompMax?: Maybe<Scalars['Int']['output']>;
  annualCompMin?: Maybe<Scalars['Int']['output']>;
  /** DDS Recruit apply URL. Must be opened verbatim for referral attribution. */
  applyUrl: Scalars['String']['output'];
  benefits?: Maybe<Array<Scalars['String']['output']>>;
  challenge?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dailyProductionGoal?: Maybe<Scalars['Int']['output']>;
  employmentType?: Maybe<JobEmploymentType>;
  experienceLevel?: Maybe<Scalars['String']['output']>;
  guaranteeType?: Maybe<Scalars['String']['output']>;
  guaranteedDailyRate?: Maybe<Scalars['Int']['output']>;
  headcount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  labFeeResponsibility?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  majorEquipment?: Maybe<Array<Scalars['String']['output']>>;
  microscopeUse?: Maybe<Scalars['String']['output']>;
  neighborhoodDescription?: Maybe<Scalars['String']['output']>;
  nonNegotiableAvailability?: Maybe<Scalars['String']['output']>;
  officeDescription?: Maybe<Scalars['String']['output']>;
  openToMentoring?: Maybe<Scalars['Boolean']['output']>;
  productionPercentage?: Maybe<Scalars['Float']['output']>;
  requiredDaysHours?: Maybe<Scalars['String']['output']>;
  requiredLicenses?: Maybe<Array<Scalars['String']['output']>>;
  requiredProcedures?: Maybe<Array<Scalars['String']['output']>>;
  roleNeeded: Scalars['String']['output'];
  roleType?: Maybe<JobRoleType>;
  specialistCaseVolume?: Maybe<Scalars['String']['output']>;
  specialty?: Maybe<JobSpecialty>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  techLevel?: Maybe<Scalars['Int']['output']>;
  tieredCommission?: Maybe<Scalars['Boolean']['output']>;
  upsideBasis?: Maybe<Scalars['String']['output']>;
  whyAttractive?: Maybe<Scalars['String']['output']>;
  workerClassification?: Maybe<Scalars['String']['output']>;
  yearsOfExperience?: Maybe<JobYearsOfExperience>;
};

/** DDS Recruit role type filter */
export enum JobRoleType {
  General = 'GENERAL',
  Specialist = 'SPECIALIST'
}

/** DDS Recruit listing sort order */
export enum JobSort {
  Newest = 'NEWEST',
  Oldest = 'OLDEST'
}

/** DDS Recruit dental specialty filter */
export enum JobSpecialty {
  DentalAnesthesiology = 'DENTAL_ANESTHESIOLOGY',
  DentalPublicHealth = 'DENTAL_PUBLIC_HEALTH',
  Endodontics = 'ENDODONTICS',
  OralMaxillofacialPathology = 'ORAL_MAXILLOFACIAL_PATHOLOGY',
  OralMaxillofacialRadiology = 'ORAL_MAXILLOFACIAL_RADIOLOGY',
  OralMaxillofacialSurgery = 'ORAL_MAXILLOFACIAL_SURGERY',
  OralMedicine = 'ORAL_MEDICINE',
  OrofacialPain = 'OROFACIAL_PAIN',
  Orthodontics = 'ORTHODONTICS',
  PediatricDentistry = 'PEDIATRIC_DENTISTRY',
  Periodontics = 'PERIODONTICS',
  Prosthodontics = 'PROSTHODONTICS'
}

/** DDS Recruit years-of-experience filter */
export enum JobYearsOfExperience {
  FivePlus = 'FIVE_PLUS',
  ThreeToFive = 'THREE_TO_FIVE',
  ZeroToTwo = 'ZERO_TO_TWO'
}

export type JobsFilterInput = {
  employmentType?: InputMaybe<JobEmploymentType>;
  /** Partial match against role title or company name */
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Partial match against location */
  location?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Partial match against role title */
  role?: InputMaybe<Scalars['String']['input']>;
  roleType?: InputMaybe<JobRoleType>;
  sort?: InputMaybe<JobSort>;
  specialty?: InputMaybe<JobSpecialty>;
  yearsOfExperience?: InputMaybe<JobYearsOfExperience>;
};

export type JobsPaginatedResponse = {
  __typename?: 'JobsPaginatedResponse';
  hasMore: Scalars['Boolean']['output'];
  items: Array<JobListing>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type KnowledgeArticle = {
  __typename?: 'KnowledgeArticle';
  category?: Maybe<SupportCategory>;
  categoryId?: Maybe<Scalars['ID']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdByAdminId?: Maybe<Scalars['ID']['output']>;
  excerpt?: Maybe<Scalars['String']['output']>;
  helpfulCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  notHelpfulCount: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  status: KnowledgeArticleStatus;
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedByAdminId?: Maybe<Scalars['ID']['output']>;
  viewCount: Scalars['Int']['output'];
};

export type KnowledgeArticleConnection = {
  __typename?: 'KnowledgeArticleConnection';
  data: Array<KnowledgeArticle>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type KnowledgeArticleSearchInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Knowledge base article status (DRAFT, PUBLISHED, ARCHIVED) */
export enum KnowledgeArticleStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum LeaderboardCategory {
  Influence = 'INFLUENCE',
  MostPosts = 'MOST_POSTS'
}

export type LeaderboardEntryView = {
  __typename?: 'LeaderboardEntryView';
  isCurrentUser: Scalars['Boolean']['output'];
  rank: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  user?: Maybe<LeaderboardUserView>;
  userId: Scalars['ID']['output'];
};

export type LeaderboardInput = {
  category: LeaderboardCategory;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  periodKey?: InputMaybe<Scalars['String']['input']>;
};

export type LeaderboardPage = {
  __typename?: 'LeaderboardPage';
  category: LeaderboardCategory;
  entries: Array<LeaderboardEntryView>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  me: LeaderboardPosition;
  page: Scalars['Int']['output'];
  periodKey: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type LeaderboardPosition = {
  __typename?: 'LeaderboardPosition';
  rank?: Maybe<Scalars['Int']['output']>;
  score: Scalars['Int']['output'];
};

export type LeaderboardUserView = {
  __typename?: 'LeaderboardUserView';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type LeaveCourseInput = {
  /** The ID of the course to leave */
  courseId: Scalars['ID']['input'];
};

export type Lecture = {
  __typename?: 'Lecture';
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Float']['output']>;
  handoutDocumentsUrl?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  moduleId: Scalars['ID']['output'];
  orderIndex: Scalars['Float']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type LectureDetail = {
  __typename?: 'LectureDetail';
  duration?: Maybe<Scalars['Float']['output']>;
  handoutDocumentsUrl?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  orderIndex: Scalars['Float']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type LectureProgress = {
  __typename?: 'LectureProgress';
  duration?: Maybe<Scalars['Int']['output']>;
  handoutDocumentsUrl?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  isRemaining: Scalars['Boolean']['output'];
  orderIndex: Scalars['Int']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type LectureStats = {
  __typename?: 'LectureStats';
  id: Scalars['String']['output'];
  percentageViewed: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  totalStudentsViewed: Scalars['Int']['output'];
};

export enum LedgerTransactionType {
  CampaignPayment = 'CAMPAIGN_PAYMENT',
  CampaignRefund = 'CAMPAIGN_REFUND',
  Commission = 'COMMISSION',
  DigitalProfessionalCardPayment = 'DIGITAL_PROFESSIONAL_CARD_PAYMENT',
  PostBoostPayment = 'POST_BOOST_PAYMENT',
  ProfileBoostPayment = 'PROFILE_BOOST_PAYMENT',
  Refund = 'REFUND',
  SessionPayment = 'SESSION_PAYMENT',
  SponsorshipPayment = 'SPONSORSHIP_PAYMENT',
  SponsorshipRefund = 'SPONSORSHIP_REFUND',
  StripeFee = 'STRIPE_FEE',
  SubscriptionPayment = 'SUBSCRIPTION_PAYMENT',
  Transfer = 'TRANSFER'
}

export type LegalInstruction = {
  __typename?: 'LegalInstruction';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pdfUrl?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Effective access to a library folder or collection */
export enum LibraryAccessRole {
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

/** Whether the original content can currently be shown */
export enum LibraryAvailability {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE'
}

export type LibraryCardDetails = {
  __typename?: 'LibraryCardDetails';
  averageRating?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  ceCredits?: Maybe<Scalars['Float']['output']>;
  commentsCount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deliveryMode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  difficultyLevel?: Maybe<Scalars['String']['output']>;
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  /** Post text (trimmed). */
  excerpt?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  instructors?: Maybe<Array<Scalars['String']['output']>>;
  isCurated?: Maybe<Scalars['Boolean']['output']>;
  isFree?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  likesCount?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  /** Post images, in order (max 4). */
  mediaUrls?: Maybe<Array<Scalars['String']['output']>>;
  participantsCount?: Maybe<Scalars['Int']['output']>;
  playsCount?: Maybe<Scalars['Int']['output']>;
  postId?: Maybe<Scalars['ID']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceType?: Maybe<Scalars['String']['output']>;
  readingTimeMinutes?: Maybe<Scalars['Int']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  totalLectures?: Maybe<Scalars['Int']['output']>;
  totalRatings?: Maybe<Scalars['Int']['output']>;
};

export type LibraryCollectionModel = {
  __typename?: 'LibraryCollectionModel';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isShared: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  myRole: LibraryAccessRole;
  /** For shares made with me: the share id, used to leave it. */
  myShareId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  ownerId: Scalars['ID']['output'];
  ownerName?: Maybe<Scalars['String']['output']>;
  /** Recycle bin: the last moment this can still be restored. */
  restorableUntil?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LibraryContentCard = {
  __typename?: 'LibraryContentCard';
  authorId?: Maybe<Scalars['ID']['output']>;
  authorImageUrl?: Maybe<Scalars['String']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  contentId: Scalars['ID']['output'];
  contentType: LibraryContentType;
  /** Type-specific fields for rendering that type's own card. */
  details?: Maybe<LibraryCardDetails>;
  /** Third-party page to open (CE courses). */
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** Source / provider name, e.g. a CE course site or RSS source. */
  provider?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Article slug, used to open /article/:slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** Post variant such as CASE, POLL or MEDIA. */
  subKind?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Kind of DentMent content saved to My Library (POST, ARTICLE, CE_COURSE, PODCAST_EPISODE, REEL, RSS_FEED) */
export enum LibraryContentType {
  Article = 'ARTICLE',
  CeCourse = 'CE_COURSE',
  Course = 'COURSE',
  Event = 'EVENT',
  PodcastEpisode = 'PODCAST_EPISODE',
  Post = 'POST',
  Reel = 'REEL',
  RssFeed = 'RSS_FEED',
  Service = 'SERVICE'
}

export type LibraryEntriesInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  resourceId: Scalars['ID']['input'];
  resourceType: LibraryResourceType;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<LibrarySort>;
  typeFilter?: InputMaybe<LibraryTypeFilter>;
};

export type LibraryEntryInput = {
  contentId: Scalars['ID']['input'];
  contentType: LibraryContentType;
  resourceId: Scalars['ID']['input'];
  resourceType: LibraryResourceType;
};

export type LibraryEntryModel = {
  __typename?: 'LibraryEntryModel';
  addedAt: Scalars['DateTime']['output'];
  addedById: Scalars['ID']['output'];
  addedByName?: Maybe<Scalars['String']['output']>;
  availability: LibraryAvailability;
  content?: Maybe<LibraryContentCard>;
  contentId: Scalars['ID']['output'];
  contentType: LibraryContentType;
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  /** My own saved item for this content, if I saved it. */
  mySavedItemId?: Maybe<Scalars['ID']['output']>;
};

export type LibraryEntryPage = {
  __typename?: 'LibraryEntryPage';
  entries: Array<LibraryEntryModel>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  /** Entries per type chip in this folder or collection, ignoring the type filter and search. */
  typeCounts?: Maybe<Array<LibraryTypeCount>>;
};

export type LibraryFolderModel = {
  __typename?: 'LibraryFolderModel';
  /** Top-level to parent, only on the single-folder query. */
  breadcrumb?: Maybe<Array<LibraryFolderRef>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  depth: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** True when this folder (or an ancestor) is shared with anyone. */
  isShared: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  myRole: LibraryAccessRole;
  /** For shares made with me: the share id, used to leave it. */
  myShareId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  ownerId: Scalars['ID']['output'];
  ownerName?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  /** Recycle bin: the last moment this can still be restored. */
  restorableUntil?: Maybe<Scalars['DateTime']['output']>;
  subfolderCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LibraryFolderRef = {
  __typename?: 'LibraryFolderRef';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type LibraryItemModel = {
  __typename?: 'LibraryItemModel';
  availability: LibraryAvailability;
  /** My own collections this item is in. */
  collections: Array<LibraryFolderRef>;
  /** Null when the original is unavailable to you. */
  content?: Maybe<LibraryContentCard>;
  contentId: Scalars['ID']['output'];
  contentType: LibraryContentType;
  /** My own folders this item is filed in. */
  folders: Array<LibraryFolderRef>;
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  note?: Maybe<LibraryNoteModel>;
  savedAt: Scalars['DateTime']['output'];
  tags: Array<LibraryTagModel>;
};

export type LibraryItemPage = {
  __typename?: 'LibraryItemPage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<LibraryItemModel>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  /** Items per type chip in this scope, ignoring the type filter and search. */
  typeCounts?: Maybe<Array<LibraryTypeCount>>;
};

export type LibraryItemTagInput = {
  itemId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};

export type LibraryItemsInput = {
  favoritesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<LibrarySort>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
  typeFilter?: InputMaybe<LibraryTypeFilter>;
  /** Only items that are not in any of my folders. */
  unfiledOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LibraryLocationModel = {
  __typename?: 'LibraryLocationModel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  resourceType: LibraryResourceType;
  /** Owner name when the folder / collection was shared with me; null when it is mine. */
  sharedByName?: Maybe<Scalars['String']['output']>;
};

export type LibraryNoteModel = {
  __typename?: 'LibraryNoteModel';
  body: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A shareable library resource (FOLDER, COLLECTION) */
export enum LibraryResourceType {
  Collection = 'COLLECTION',
  Folder = 'FOLDER'
}

export type LibrarySearchInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
  sort?: InputMaybe<LibrarySort>;
  typeFilter?: InputMaybe<LibraryTypeFilter>;
};

export type LibrarySearchPage = {
  __typename?: 'LibrarySearchPage';
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  results: Array<LibrarySearchResultModel>;
  total: Scalars['Int']['output'];
  /** Matches per type chip, ignoring the type filter. */
  typeCounts: Array<LibraryTypeCount>;
};

export type LibrarySearchResultModel = {
  __typename?: 'LibrarySearchResultModel';
  /** Who added it, when it is not in my own saved items. */
  addedByName?: Maybe<Scalars['String']['output']>;
  availability: LibraryAvailability;
  content?: Maybe<LibraryContentCard>;
  contentId: Scalars['ID']['output'];
  contentType: LibraryContentType;
  /** When I saved it, or (if I have not saved it) when it was last added to a folder or collection. */
  date: Scalars['DateTime']['output'];
  /** Stable key for this content (`TYPE:contentId`). */
  key: Scalars['ID']['output'];
  /** Folders and collections (mine and shared with me) it is in. */
  locations: Array<LibraryLocationModel>;
  /** My own saved item for this content, if I saved it. */
  savedItem?: Maybe<LibraryItemModel>;
};

export type LibraryShareCandidate = {
  __typename?: 'LibraryShareCandidate';
  headline?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type LibraryShareMember = {
  __typename?: 'LibraryShareMember';
  createdAt: Scalars['DateTime']['output'];
  headline?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  resourceId: Scalars['ID']['output'];
  resourceType: LibraryResourceType;
  role: LibraryShareRole;
  shareId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

/** Access granted when sharing a library resource (VIEWER = read, EDITOR = write) */
export enum LibraryShareRole {
  Editor = 'EDITOR',
  Viewer = 'VIEWER'
}

export type LibrarySharedWithMe = {
  __typename?: 'LibrarySharedWithMe';
  collections: Array<LibraryCollectionModel>;
  folders: Array<LibraryFolderModel>;
};

/** Sort order for My Library lists */
export enum LibrarySort {
  SavedAsc = 'SAVED_ASC',
  SavedDesc = 'SAVED_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UpdatedDesc = 'UPDATED_DESC'
}

export type LibraryStats = {
  __typename?: 'LibraryStats';
  articles: Scalars['Int']['output'];
  cases: Scalars['Int']['output'];
  ceCourses: Scalars['Int']['output'];
  collections: Scalars['Int']['output'];
  favorites: Scalars['Int']['output'];
  folders: Scalars['Int']['output'];
  media: Scalars['Int']['output'];
  posts: Scalars['Int']['output'];
  sharedWithMe: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unfiled: Scalars['Int']['output'];
};

export type LibraryTagModel = {
  __typename?: 'LibraryTagModel';
  id: Scalars['ID']['output'];
  itemCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type LibraryTrash = {
  __typename?: 'LibraryTrash';
  collections: Array<LibraryCollectionModel>;
  folders: Array<LibraryFolderModel>;
};

export type LibraryTypeCount = {
  __typename?: 'LibraryTypeCount';
  count: Scalars['Int']['output'];
  filter: LibraryTypeFilter;
};

/** Content-type filter for My Library lists */
export enum LibraryTypeFilter {
  All = 'ALL',
  Articles = 'ARTICLES',
  Cases = 'CASES',
  CeCourses = 'CE_COURSES',
  Courses = 'COURSES',
  Events = 'EVENTS',
  Media = 'MEDIA',
  Podcasts = 'PODCASTS',
  Posts = 'POSTS',
  Reels = 'REELS',
  Services = 'SERVICES'
}

export type License = {
  __typename?: 'License';
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  issueDate: Scalars['DateTime']['output'];
  licenseID: Scalars['String']['output'];
  licenseURL: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type LikeCommentInput = {
  commentId: Scalars['ID']['input'];
  reactionType?: InputMaybe<Scalars['String']['input']>;
};

export type LikePostInput = {
  postId: Scalars['ID']['input'];
  reactionType?: InputMaybe<ReactionType>;
};

export type LinkPreview = {
  __typename?: 'LinkPreview';
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type LiveStream = {
  __typename?: 'LiveStream';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  hostDisconnectedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isHostOnline?: Maybe<Scalars['Boolean']['output']>;
  lastHostHeartbeat?: Maybe<Scalars['DateTime']['output']>;
  livekitToken?: Maybe<Scalars['String']['output']>;
  roomId: Scalars['String']['output'];
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status: LiveStreamStatus;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export enum LiveStreamChangeType {
  Ended = 'ENDED',
  Started = 'STARTED',
  Updated = 'UPDATED'
}

export type LiveStreamChanged = {
  __typename?: 'LiveStreamChanged';
  changeType: ChangeType;
  roomId: Scalars['String']['output'];
  stream?: Maybe<LiveStream>;
  type: LiveStreamChangeType;
};

/** The status of a livestream */
export enum LiveStreamStatus {
  Ended = 'ENDED',
  HostAway = 'HOST_AWAY',
  Live = 'LIVE'
}

export type LivekitTokenResponse = {
  __typename?: 'LivekitTokenResponse';
  room: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type LoanCalculatorFundingInput = {
  __typename?: 'LoanCalculatorFundingInput';
  /** Government loans available; null = assumed the cap */
  governmentFunding?: Maybe<Scalars['Float']['output']>;
  /** Scholarships, grants, savings */
  otherFunding: Scalars['Float']['output'];
  /** Total cost of the rest of the program */
  totalFundingRequired: Scalars['Float']['output'];
};

export type LoanCalculatorFundingResult = {
  __typename?: 'LoanCalculatorFundingResult';
  exceedsGovernmentCap: Scalars['Boolean']['output'];
  governmentCap: Scalars['Float']['output'];
  governmentFunded: Scalars['Float']['output'];
  otherFunding: Scalars['Float']['output'];
  remainingFunding: Scalars['Float']['output'];
  totalFundingRequired: Scalars['Float']['output'];
};

export type LoanCalculatorLead = {
  __typename?: 'LoanCalculatorLead';
  consentVersion?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  /** Need exceeds the government loan cap */
  exceedsGovernmentCap?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  inputs: LoanCalculatorLeadInputs;
  marketingConsent: Scalars['Boolean']['output'];
  referrer?: Maybe<Scalars['String']['output']>;
  /** Funding still needed after government loans and scholarships */
  remainingFunding?: Maybe<Scalars['Float']['output']>;
  results: LoanCalculatorLeadResults;
  source?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
};

export type LoanCalculatorLeadInputs = {
  __typename?: 'LoanCalculatorLeadInputs';
  funding?: Maybe<LoanCalculatorFundingInput>;
  loans: Array<LoanCalculatorLoanInput>;
  /** Years left in school; 0 = already graduated */
  programYears: Scalars['Int']['output'];
};

export type LoanCalculatorLeadPaginatedResponse = {
  __typename?: 'LoanCalculatorLeadPaginatedResponse';
  data: Array<LoanCalculatorLead>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type LoanCalculatorLeadResults = {
  __typename?: 'LoanCalculatorLeadResults';
  /** Only when funding inputs were given */
  funding?: Maybe<LoanCalculatorFundingResult>;
  /** Highest combined interest-only payment while in school */
  inSchoolMonthlyPayment: Scalars['Float']['output'];
  loans: Array<LoanCalculatorLoanResult>;
  /** Highest combined monthly payment after graduation */
  monthlyPayment: Scalars['Float']['output'];
  paymentSchedule: Array<LoanCalculatorPaymentPeriod>;
  /** Months after graduation until the last loan is paid off */
  payoffMonths: Scalars['Int']['output'];
  totalBorrowed: Scalars['Float']['output'];
  totalInterest: Scalars['Float']['output'];
  totalRepayment: Scalars['Float']['output'];
};

export type LoanCalculatorLoanInput = {
  __typename?: 'LoanCalculatorLoanInput';
  /** Still to borrow */
  amount: Scalars['Float']['output'];
  /** Already borrowed on this loan */
  currentBalance: Scalars['Float']['output'];
  graceMonths: Scalars['Int']['output'];
  inSchoolInterest: LoanInSchoolInterest;
  /** Percent, e.g. 8.07 */
  interestRate: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  termYears: Scalars['Int']['output'];
};

export type LoanCalculatorLoanResult = {
  __typename?: 'LoanCalculatorLoanResult';
  amount: Scalars['Float']['output'];
  balanceAtRepayment: Scalars['Float']['output'];
  currentBalance: Scalars['Float']['output'];
  graceMonths: Scalars['Int']['output'];
  inSchoolInterest: LoanInSchoolInterest;
  inSchoolInterestAmount: Scalars['Float']['output'];
  inSchoolMonthlyPayment: Scalars['Float']['output'];
  interestRate: Scalars['Float']['output'];
  monthlyPayment: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  principal: Scalars['Float']['output'];
  termYears: Scalars['Int']['output'];
  totalInterest: Scalars['Float']['output'];
  totalRepayment: Scalars['Float']['output'];
};

export type LoanCalculatorPaymentPeriod = {
  __typename?: 'LoanCalculatorPaymentPeriod';
  endMonth: Scalars['Int']['output'];
  monthlyPayment: Scalars['Float']['output'];
  /** Months after graduation (1-based) */
  startMonth: Scalars['Int']['output'];
};

/** Student loan calculator: what happens to interest during school + grace (CAPITALIZED, PAID, NONE) */
export enum LoanInSchoolInterest {
  Capitalized = 'CAPITALIZED',
  None = 'NONE',
  Paid = 'PAID'
}

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  accessToken: Scalars['JWT']['output'];
  redirectToPlans: Scalars['Boolean']['output'];
  refreshToken: Scalars['JWT']['output'];
  subscription?: Maybe<UserSubscription>;
};

export type MarkContentViewedInput = {
  contentId: Scalars['ID']['input'];
  contentType: Scalars['String']['input'];
  courseId: Scalars['ID']['input'];
};

export type MarkNotificationReadInput = {
  notificationId: Scalars['String']['input'];
};

export type MarkStoryViewedInput = {
  contentId: Scalars['ID']['input'];
};

export type Media = {
  __typename?: 'Media';
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  module?: Maybe<MediaModule>;
  optimizedUrl?: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
  type: FileType;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** Optional product-area tag for uploaded media (SERVICE, COURSE, …) */
export enum MediaModule {
  Ad = 'AD',
  Article = 'ARTICLE',
  Case = 'CASE',
  Comment = 'COMMENT',
  Community = 'COMMUNITY',
  Company = 'COMPANY',
  Course = 'COURSE',
  Document = 'DOCUMENT',
  Esign = 'ESIGN',
  Event = 'EVENT',
  Group = 'GROUP',
  Occasion = 'OCCASION',
  Other = 'OTHER',
  Podcast = 'PODCAST',
  Post = 'POST',
  Profile = 'PROFILE',
  Service = 'SERVICE',
  Story = 'STORY',
  Support = 'SUPPORT'
}

export type MemberPermissions = {
  __typename?: 'MemberPermissions';
  canAssignRoles: Scalars['Boolean']['output'];
  canDelete: Scalars['Boolean']['output'];
  canEditSettings: Scalars['Boolean']['output'];
  canInvite: Scalars['Boolean']['output'];
  canManageMembers: Scalars['Boolean']['output'];
  canModerate: Scalars['Boolean']['output'];
  canPost: Scalars['Boolean']['output'];
  canRemoveMembers: Scalars['Boolean']['output'];
  isMember: Scalars['Boolean']['output'];
  membershipStatus?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

/** The status of a membership */
export enum MembershipStatus {
  Approved = 'APPROVED',
  Banned = 'BANNED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type MentionInput = {
  userId: Scalars['String']['input'];
};

export type MentorAvailability = {
  __typename?: 'MentorAvailability';
  timezone: Scalars['String']['output'];
  weekly: Array<WeeklyAvailability>;
};

export type MentorAvailabilityData = {
  __typename?: 'MentorAvailabilityData';
  createdAt: Scalars['DateTime']['output'];
  currency: Currency;
  day: Array<Day>;
  id: Scalars['String']['output'];
  isRecurring: Scalars['Boolean']['output'];
  price: Scalars['Float']['output'];
  timeSlots: Array<MentorTimeRange>;
  timezone: Scalars['String']['output'];
};

export type MentorAvailabilityWithDayOff = {
  __typename?: 'MentorAvailabilityWithDayOff';
  availabilities: Array<MentorAvailabilityData>;
  dayOffDates: Array<Scalars['String']['output']>;
};

export type MentorDayOffInput = {
  dates: Array<Scalars['String']['input']>;
  mentorId: Scalars['String']['input'];
};

export type MentorEarningsStats = {
  __typename?: 'MentorEarningsStats';
  avgEarningPerSession: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  monthlyBreakdown: Array<MentorMonthlyEarning>;
  thisMonthEarned: Scalars['Float']['output'];
  thisMonthGrossVolume: Scalars['Float']['output'];
  thisMonthPlatformFees: Scalars['Float']['output'];
  thisMonthRefunded: Scalars['Float']['output'];
  thisMonthSessions: Scalars['Int']['output'];
  totalEarned: Scalars['Float']['output'];
  totalGrossVolume: Scalars['Float']['output'];
  totalNetEarned: Scalars['Float']['output'];
  totalPlatformFees: Scalars['Float']['output'];
  totalRefunded: Scalars['Float']['output'];
  totalSessions: Scalars['Int']['output'];
};

export type MentorItem = {
  __typename?: 'MentorItem';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isMentorVerified: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type MentorMonthlyEarning = {
  __typename?: 'MentorMonthlyEarning';
  earned: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  month: Scalars['String']['output'];
  net: Scalars['Float']['output'];
  refunded: Scalars['Float']['output'];
  sessions: Scalars['Int']['output'];
};

export type MentorPaymentRecord = {
  __typename?: 'MentorPaymentRecord';
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceId?: Maybe<Scalars['ID']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  paidAmount?: Maybe<Scalars['Float']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  platformFeeAmount?: Maybe<Scalars['Float']['output']>;
  receiptUrl?: Maybe<Scalars['String']['output']>;
  sessionDate?: Maybe<Scalars['String']['output']>;
  sessionFeeAmount?: Maybe<Scalars['Float']['output']>;
  sessionStatus?: Maybe<Scalars['String']['output']>;
  sessionTime?: Maybe<Scalars['String']['output']>;
  studentName?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type MentorPrice = {
  __typename?: 'MentorPrice';
  currency: Currency;
  duration: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
};

export type MentorSearchResult = {
  __typename?: 'MentorSearchResult';
  about?: Maybe<Scalars['String']['output']>;
  boostEndsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Badge the user chose to show beside their name (opt-in, null when none). Batched per request. */
  influenceBadge?: Maybe<AchievementBadge>;
  isBoosted?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  totalConnections: Scalars['Int']['output'];
  totalConsultations: Scalars['Int']['output'];
};

export type MentorSettings = {
  __typename?: 'MentorSettings';
  availability?: Maybe<MentorAvailability>;
  pricing?: Maybe<MentorPrice>;
};

export type MentorTimeRange = {
  __typename?: 'MentorTimeRange';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type MentorTimeRangeInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type MentorViewerAvailabilityCalendar = {
  __typename?: 'MentorViewerAvailabilityCalendar';
  /** Weekdays that have at least one bookable slot in the viewer timezone (includes next-day spill from mentor TZ) */
  availableDays: Array<Day>;
  /** Mentor day-off dates projected into viewer-local YYYY-MM-DD dates that would have lost slots */
  dayOffDates: Array<Scalars['String']['output']>;
};

export type Message = {
  __typename?: 'Message';
  content: Scalars['String']['output'];
  conversationId: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isAuthor: Scalars['Boolean']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  readBy?: Maybe<Scalars['String']['output']>;
  receiverId?: Maybe<Scalars['String']['output']>;
  replies?: Maybe<Array<Message>>;
  senderId: Scalars['String']['output'];
  status?: Maybe<CompanyMessageStatus>;
  subject?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ModuleDetail = {
  __typename?: 'ModuleDetail';
  documents?: Maybe<Array<DocumentDetail>>;
  id: Scalars['ID']['output'];
  lectures?: Maybe<Array<LectureDetail>>;
  name: Scalars['String']['output'];
  orderIndex: Scalars['Float']['output'];
  quizzes?: Maybe<Array<QuizDetailWithQuestions>>;
};

export type ModuleWithProgress = {
  __typename?: 'ModuleWithProgress';
  completedLectures: Scalars['Int']['output'];
  completedQuizzes: Scalars['Int']['output'];
  documents: Array<DocumentProgress>;
  id: Scalars['String']['output'];
  lectures: Array<LectureProgress>;
  moduleProgress: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  orderIndex: Scalars['Int']['output'];
  quizzes: Array<QuizProgress>;
  totalLectures: Scalars['Int']['output'];
  totalQuizzes: Scalars['Int']['output'];
};

export type MoveAdvisorInput = {
  direction: AdvisorMoveDirection;
  id: Scalars['ID']['input'];
};

export type MoveLibraryFolderInput = {
  /** Required when the move changes who can see the folder. */
  confirmVisibilityChange?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  /** null moves the folder to the top level. */
  newParentId?: InputMaybe<Scalars['ID']['input']>;
};

export type MoveLibraryItemInput = {
  contentId: Scalars['ID']['input'];
  contentType: LibraryContentType;
  /** Folder to take the item out of (optional). */
  fromFolderId?: InputMaybe<Scalars['ID']['input']>;
  /** Folder to put the item into (null = just remove it from fromFolderId). */
  toFolderId?: InputMaybe<Scalars['ID']['input']>;
};

export type MultipartCompleteUploadResult = {
  __typename?: 'MultipartCompleteUploadResult';
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  mimeType: Scalars['String']['output'];
  size: Scalars['BigInt']['output'];
  type: FileType;
};

export type MultipartCompletedPartInput = {
  eTag: Scalars['String']['input'];
  partNumber: Scalars['Int']['input'];
};

export type MultipartUploadPartInput = {
  chunk: Scalars['Upload']['input'];
  key: Scalars['String']['input'];
  partNumber: Scalars['Int']['input'];
  uploadId: Scalars['String']['input'];
};

export type MultipartUploadSession = {
  __typename?: 'MultipartUploadSession';
  fileUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  partSize: Scalars['Float']['output'];
  totalParts: Scalars['Float']['output'];
  uploadId: Scalars['String']['output'];
};

export type MultipartUploadedPart = {
  __typename?: 'MultipartUploadedPart';
  eTag: Scalars['String']['output'];
  partNumber: Scalars['Float']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  Adminlogin: Token;
  /** Abort multipart upload and remove uploaded parts */
  abortMultipartUpload: Scalars['Boolean']['output'];
  acceptBooking: Scalars['Boolean']['output'];
  acceptConnection: Scalars['Boolean']['output'];
  acceptGroupInvite: AcceptGroupInviteResponse;
  activateDigitalCard: MyDigitalCard;
  addActionButton: Scalars['Boolean']['output'];
  addContact: Scalars['Boolean']['output'];
  /** Validate an external URL, fetch official metadata, and store it as a curated reel. */
  addCuratedReelByUrl: AdminCuratedReelModel;
  addEducation: Scalars['Boolean']['output'];
  addExperience: Scalars['Boolean']['output'];
  addLibraryEntry: LibraryEntryModel;
  addLibraryItemTag: LibraryItemModel;
  addLicense: Scalars['Boolean']['output'];
  addSigningField: SigningFieldEntity;
  addSigningRecipient: SigningRecipientEntity;
  addSkillsToUser: Scalars['Boolean']['output'];
  addUniversityCommunity: Community;
  adminActivateInfluenceConfig: AdminInfluenceConfig;
  adminAdjustInfluence: AdminInfluenceEvent;
  adminApproveCampaign: Campaign;
  adminApproveSessionRefund: Scalars['Boolean']['output'];
  adminAssignSupportTicket: AdminSupportTicket;
  adminCancelBroadcast: AdminBroadcast;
  adminChangeSupportTicketPriority: AdminSupportTicket;
  adminChangeSupportTicketStatus: AdminSupportTicket;
  adminCreateBroadcast: AdminBroadcast;
  /** Launch an ad on behalf of a user (no payment, live immediately) */
  adminCreateCampaignForPartner: Campaign;
  adminCreateSubscriptionPlan: SubscriptionPlan;
  adminDeleteBroadcast: Scalars['Boolean']['output'];
  adminDeleteKnowledgeArticle: Scalars['Boolean']['output'];
  adminDeleteLoanCalculatorLead: Scalars['Boolean']['output'];
  adminDeletePracticeValuationLead: Scalars['Boolean']['output'];
  adminDeleteSubscriptionPlan: Scalars['Boolean']['output'];
  adminPauseBroadcast: AdminBroadcast;
  adminPauseCampaign: Campaign;
  adminPostAction: Scalars['Boolean']['output'];
  adminRecalculateInfluenceUser: AdminUserReconciliation;
  adminRejectCampaign: Campaign;
  adminRejectSessionRefund: Scalars['Boolean']['output'];
  adminResumeBroadcast: AdminBroadcast;
  adminResumeCampaign: Campaign;
  adminRetryBroadcastFailedEmails: BroadcastRetryOutcome;
  adminRetryInfluenceOutbox: Scalars['Int']['output'];
  adminReverseInfluenceEvent: AdminInfluenceEvent;
  adminSendBroadcast: AdminBroadcast;
  adminSendBroadcastTest: Scalars['Boolean']['output'];
  adminSendSupportMessage: AdminSupportMessage;
  adminSetAchievementActive: AdminAchievementDefinition;
  adminSetInfluenceEnabled: AdminInfluenceConfig;
  adminSuspendCampaign: Campaign;
  adminTakeSupportTicket: AdminSupportTicket;
  adminUnsuspendCampaign: Campaign;
  adminUpdateAdDurationPack: AdDurationPack;
  adminUpdateBroadcast: AdminBroadcast;
  adminUpdateProfileBoostPack: ProfileBoostPack;
  adminUpdateSubscriptionPlan: SubscriptionPlan;
  adminUpsertAchievementDefinition: AdminAchievementDefinition;
  adminUpsertKnowledgeArticle: KnowledgeArticle;
  adminUpsertSupportCategory: AdminSupportCategory;
  applySubscriptionCoupon?: Maybe<UserSubscription>;
  /** Approves a PENDING_APPROVAL action and executes it — still subject to the Section 27 checkpoint-3 re-verification. */
  approveAiAgentAction: AiAgentActionModel;
  approveAndScheduleNewsletter: Newsletter;
  approveMembership: Scalars['Boolean']['output'];
  approveNewUser: Scalars['Boolean']['output'];
  approvePost: Scalars['Boolean']['output'];
  approveRoleChangeRequest: RoleChangeRequestModel;
  approveSponsoredRequest: SponsoredRequestModel;
  archiveArticle: Article;
  attachSigningDocumentPdf: SigningDocumentEntity;
  banMember: Scalars['Boolean']['output'];
  blockCompanyFollower: Scalars['Boolean']['output'];
  bookSession: BookSessionResult;
  callCancle: CallResponse;
  callMissed: CallResponse;
  callSend: CallResponse;
  cancelCampaign: Campaign;
  cancelConfirmedSession: Scalars['Boolean']['output'];
  cancelConnectionRequest: Scalars['Boolean']['output'];
  cancelMySubscription: Scalars['Boolean']['output'];
  cancelNewsletter: Newsletter;
  cancelPendingPlanChange?: Maybe<UserSubscription>;
  cancelPendingPostBoost: PostBoost;
  cancelRoleChangeRequest: RoleChangeRequestModel;
  cancelSigningDocument: SigningDocumentEntity;
  changeGroupStatus: Scalars['Boolean']['output'];
  changeMyServiceStatus: Service;
  changeServiceStatus: Scalars['Boolean']['output'];
  changeSubscriptionPlan?: Maybe<UserSubscription>;
  changeUserStatus: Scalars['Boolean']['output'];
  closeSupportTicket: SupportTicket;
  commentOnPost: Comment;
  /** Complete multipart upload after all parts are uploaded to S3 */
  completeMultipartUpload: MultipartCompleteUploadResult;
  completeSession: Scalars['Boolean']['output'];
  confirmCampaignExtension: Campaign;
  confirmCampaignPayment: Campaign;
  confirmDigitalCardPayment: MyDigitalCard;
  confirmPostBoostPayment: PostBoost;
  confirmProfileBoostExtension: ProfileBoost;
  confirmProfileBoostPayment: ProfileBoost;
  confirmReelUpload: ReelModel;
  /** Client-side confirmation after Stripe Elements. Idempotent — the webhook is the source of truth. */
  confirmSponsorshipPayment: SponsorshipPurchaseStatusModel;
  continueSignupWithoutTrial: CheckoutSessionResult;
  createAdminUser: UserGql;
  /** Create a new advisor */
  createAdvisor: Advisor;
  /** Creates a new user account and enrolls it as an AI agent. */
  createAiAgent: AiAgent;
  createArticle: Article;
  createBillingPortalSession: BillingPortalResult;
  createBooking: Booking;
  createCampaign: Campaign;
  createCasePost: Scalars['Boolean']['output'];
  /** Create a new category or subcategory */
  createCategory: CourseCategory;
  createCompany: Company;
  createCoupon: Coupon;
  /** Create a new course with modules, lectures, quizzes, and documents */
  createCourse: Course;
  createEvent: Event;
  /** Create a new FAQ (mentor only) */
  createFaq: Faq;
  createGroup: Group;
  createLegalInstruction: LegalInstruction;
  createLibraryCollection: LibraryCollectionModel;
  createLibraryFolder: LibraryFolderModel;
  createLibraryTag: LibraryTagModel;
  /** Create a new livestream and get LiveKit token */
  createLiveStream: LiveStream;
  createNewsletter: Scalars['Boolean']['output'];
  createNewsletterDraft: Newsletter;
  createNewsletterSubscriber: NewsletterSubscriber;
  createOccasionPost: Scalars['Boolean']['output'];
  createPodcastComment: PodcastCommentModel;
  createPodcastSource: PodcastSourceModel;
  createPollPost: Scalars['Boolean']['output'];
  createPost: Scalars['Boolean']['output'];
  createReelComment: ReelCommentModel;
  /** Admin: create a COMPANY referral campaign */
  createReferralCampaign: ReferralCampaign;
  createRepost: Scalars['Boolean']['output'];
  createReview: Review;
  createRole: PermissionGql;
  createRoleChangeRequest: RoleChangeRequestModel;
  /** Create a new RSS source */
  createRssSource: RssSource;
  createScheduling: Scheduling;
  createSearchIndex: Scalars['Boolean']['output'];
  createService: Service;
  createSessionPaymentIntent: PaymentIntentResult;
  createSigningDocument: SigningDocumentEntity;
  createSigningTemplate: SigningTemplateEntity;
  createSourceCompany: SourceCompany;
  createSourceReview: SourceReview;
  /** Submit a sponsored advisor request (public) */
  createSponsoredRequest: SponsoredRequestModel;
  /** Create the SponsoredRequest + SponsorshipPurchase and a Stripe PaymentIntent. Price comes from the database. */
  createSponsorshipCheckout: SponsorshipCheckoutResult;
  createSponsorshipEvent: AdminSponsorshipEvent;
  createSponsorshipPlan: AdminSponsorshipPlan;
  createStory: Story;
  createSubscriptionCheckout: CheckoutSessionResult;
  createSubscriptionCoupon: SubscriptionCouponGql;
  createSupportTicket: SupportTicket;
  /** Escalate an AI conversation to the Support Team. Requires the conversation to belong to the caller; idempotent (returns the existing ticket if already escalated). */
  createSupportTicketFromAI: SupportTicket;
  createUpgradeCheckout: CheckoutSessionResult;
  createVideoSource: VideoSourceModel;
  declineGroupInvite: Scalars['Boolean']['output'];
  deleteAdminUser: Scalars['Boolean']['output'];
  /** Delete an advisor */
  deleteAdvisor: Scalars['Boolean']['output'];
  deleteArticle: Scalars['Boolean']['output'];
  /** Delete user banner image */
  deleteBannerImage: Scalars['Boolean']['output'];
  deleteBooking: Booking;
  deleteCampaign: Scalars['Boolean']['output'];
  /** Delete a category or subcategory by ID */
  deleteCategory: Scalars['Boolean']['output'];
  deleteComment: Scalars['Boolean']['output'];
  deleteCompany: Scalars['Boolean']['output'];
  deleteCompanyCover: Company;
  deleteCompanyLogo: Company;
  deleteConnection: Scalars['Boolean']['output'];
  deleteContact: Scalars['Boolean']['output'];
  deleteCuratedReel: Scalars['Boolean']['output'];
  deleteEducation: Scalars['Boolean']['output'];
  deleteEvent: Scalars['String']['output'];
  deleteExperience: Scalars['Boolean']['output'];
  /** Delete an FAQ (mentor only, own FAQs) */
  deleteFaq: Scalars['Boolean']['output'];
  deleteGroup: Scalars['Boolean']['output'];
  deleteLegalInstruction: LegalInstruction;
  deleteLibraryCollection: Scalars['Boolean']['output'];
  deleteLibraryFolder: Scalars['Boolean']['output'];
  deleteLibraryNote: LibraryItemModel;
  deleteLibraryTag: Scalars['Boolean']['output'];
  deleteLicense: Scalars['Boolean']['output'];
  deleteMessage: Scalars['Boolean']['output'];
  deleteMyAccount: Scalars['Boolean']['output'];
  deleteNewsletterDraft: Scalars['Boolean']['output'];
  deleteNewsletterSubscriber: Scalars['Boolean']['output'];
  deletePodcastComment: Scalars['Boolean']['output'];
  deletePodcastEpisode: Scalars['Boolean']['output'];
  deletePodcastSource: Scalars['Boolean']['output'];
  deletePost: Scalars['Boolean']['output'];
  /** Delete user profile image */
  deleteProfileImage: Scalars['Boolean']['output'];
  deleteReel: Scalars['Boolean']['output'];
  deleteRole: Scalars['Boolean']['output'];
  /** Delete a live stream room */
  deleteRoom: StreamActionResponse;
  /** Delete an RSS source */
  deleteRssSource: Scalars['Boolean']['output'];
  deleteScheduling: Scheduling;
  deleteSigningDocument: Scalars['Boolean']['output'];
  deleteSigningTemplate: Scalars['Boolean']['output'];
  deleteSkillFromUser: Scalars['Boolean']['output'];
  deleteSourceCompany: SourceCompany;
  deleteSourceReview: SourceReview;
  deleteSponsorshipEvent: Scalars['Boolean']['output'];
  deleteStory: Scalars['Boolean']['output'];
  deleteUniversityCommunity: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  deleteVideoSource: Scalars['Boolean']['output'];
  /** Section 50 — stops autonomous actions only; the User and their content are untouched. */
  disableAiAgent: AiAgent;
  disconnectGoogleCalendar: DisconnectGoogleCalendarResult;
  disconnectMentorStripe: Scalars['Boolean']['output'];
  disconnectPayoutAccount: Scalars['Boolean']['output'];
  editAbout: Scalars['Boolean']['output'];
  editBasicAccount: Scalars['Boolean']['output'];
  editContact: Scalars['Boolean']['output'];
  editEducation: Scalars['Boolean']['output'];
  editExperience: Scalars['Boolean']['output'];
  editLicense: Scalars['Boolean']['output'];
  editMentorAvailability: Scalars['Boolean']['output'];
  enableAiAgent: AiAgent;
  /** End a live stream and kick all participants */
  endLiveStream: StreamActionResponse;
  /** Enroll the current user in a course */
  enrollCourse: EnrollmentResponse;
  followCompany: Scalars['Boolean']['output'];
  forgetPassword: Scalars['Boolean']['output'];
  /** Generate a certificate PDF for a user and course, returns base64 string. */
  generateCertificate: Scalars['String']['output'];
  generateMentorReceiptPdf: ReceiptPdfResult;
  /** Create or return the authenticated user personal referral code */
  generateMyReferralCode: ReferralCampaign;
  generateNewsletterWithAI: Newsletter;
  generateReceiptPdf: ReceiptPdfResult;
  getLivekitTokenForConversation: ConversationLivekitTokenResponse;
  getLivekitTokenForEvent: LivekitTokenResponse;
  getReelUploadUrl: PresignedUploadUrl;
  /** Host heartbeat to keep stream alive */
  hostHeartbeat: StreamActionResponse;
  initializeCampaignExtension: CampaignPaymentInit;
  initializeCampaignPayment: CampaignPaymentInit;
  initializeDigitalCardPayment: DigitalCardPaymentInit;
  initializePostBoostPayment: PostBoostPaymentInit;
  initializeProfileBoostExtension: ProfileBoostPaymentInit;
  initializeProfileBoostPayment: ProfileBoostPaymentInit;
  initializeSessionPayment: PaymentIntentResult;
  /** Start multipart upload and return upload session metadata */
  initiateMultipartUpload: MultipartUploadSession;
  inviteToGroup: InviteToGroupResponse;
  /** Invite users to a live stream (sends notification with Join) */
  inviteToLiveStream: InviteLiveStreamResponse;
  joinEvent: Scalars['String']['output'];
  joinGroup: Scalars['Boolean']['output'];
  /** Join a livestream and get LiveKit token */
  joinLiveStream: LiveStream;
  kickParticipant: Scalars['Boolean']['output'];
  /** Kick a participant from a livestream */
  kickParticipantInStream: StreamActionResponse;
  /** Leave a course (unenroll the current user) */
  leaveCourse: EnrollmentResponse;
  leaveEvent: Scalars['String']['output'];
  leaveGroup: Scalars['Boolean']['output'];
  leaveLibraryShare: Scalars['Boolean']['output'];
  likePodcastComment: PodcastCommentModel;
  likePodcastEpisode: PodcastEpisodeModel;
  likeReel: ReelModel;
  likeReelComment: ReelCommentModel;
  login: LoginResponse;
  logout: Scalars['Boolean']['output'];
  logoutAdmin: Scalars['Boolean']['output'];
  markAllNotificationsAsRead: Scalars['Boolean']['output'];
  markCompanyMessageAsRead: Scalars['Boolean']['output'];
  /** Mark a lecture, quiz, or document as viewed by the current user */
  markContentViewed: ContentViewResponse;
  markConversationAsRead: Scalars['Boolean']['output'];
  /** Mark host as temporarily away */
  markHostAway: StreamActionResponse;
  markMessageAsRead: Scalars['Boolean']['output'];
  markNotificationAsRead: Scalars['Boolean']['output'];
  markPostNotInterested: Scalars['Boolean']['output'];
  markStoryViewed: Scalars['Boolean']['output'];
  mentorStripeDashboardLink: Scalars['String']['output'];
  mentorStripeOnboardingLink: Scalars['String']['output'];
  /** Swap an advisor one position up or down by display order */
  moveAdvisor: Advisor;
  moveLibraryFolder: LibraryFolderModel;
  moveLibraryItem: Scalars['Boolean']['output'];
  myOpenInvoicePaymentUrl: BillingPortalResult;
  pauseCampaign: Campaign;
  pausePostBoost: PostBoost;
  pauseProfileBoost: ProfileBoost;
  payMyOpenInvoice: Scalars['Boolean']['output'];
  payoutDashboardLink: Scalars['String']['output'];
  payoutOnboardingLink: Scalars['String']['output'];
  postNow: Scalars['Boolean']['output'];
  publishArticle: Article;
  purchaseCampaignWithStore: Campaign;
  purchaseProfileBoost: PurchaseProfileBoostResult;
  /** Rate a course as an enrolled student (one time only) */
  rateCourse: Scalars['Boolean']['output'];
  rateKnowledgeArticle: KnowledgeArticle;
  reVerifyMentorStripe: PayoutAccount;
  reVerifyPayoutAccount: PayoutAccount;
  receiveCall: CallResponse;
  reconnectMentorStripe: PayoutAccount;
  reconnectPayoutAccount: PayoutAccount;
  /** Record a click on an ad */
  recordAdClick: Scalars['Boolean']['output'];
  /** Record an impression on an ad */
  recordAdImpression: Scalars['Boolean']['output'];
  recordPodcastPlay: Scalars['Boolean']['output'];
  recordPostBoostClick: Scalars['Boolean']['output'];
  recordPostBoostImpression: Scalars['Boolean']['output'];
  recordProfileBoostClick: Scalars['Boolean']['output'];
  recordProfileBoostImpression: Scalars['Boolean']['output'];
  recordProfileBoostProfileVisit: Scalars['Boolean']['output'];
  recordProfileView: Scalars['Boolean']['output'];
  redeemCoupon: RedeemCouponResponse;
  refreshToken: Token;
  refundSponsorshipPurchase: AdminSponsorshipPurchaseDetail;
  /** Rolls a fresh random writing voice for the agent's posts. */
  regenerateAiAgentVoice: AiAgent;
  rejectAiAgentAction: AiAgentActionModel;
  rejectBooking: Scalars['Boolean']['output'];
  rejectCall: CallResponse;
  rejectConnection: Scalars['Boolean']['output'];
  rejectMembership: Scalars['Boolean']['output'];
  rejectNewUser: Scalars['Boolean']['output'];
  rejectPost: Scalars['Boolean']['output'];
  rejectRoleChangeRequest: RoleChangeRequestModel;
  rejectSponsoredRequest: SponsoredRequestModel;
  /** Section 51 — soft, terminal removal. History and the User are preserved. */
  removeAiAgent: AiAgent;
  removeCompanyFollower: Scalars['Boolean']['output'];
  removeCoupon: Coupon;
  /** Delete a course */
  removeCourse: Course;
  removeLibraryEntry: Scalars['Boolean']['output'];
  removeLibraryItemTag: LibraryItemModel;
  removeMemberFromGroup: Scalars['Boolean']['output'];
  removePodcast: Podcast;
  removeService: Service;
  removeSigningField: Scalars['Boolean']['output'];
  removeSigningRecipient: Scalars['Boolean']['output'];
  /** Reorder advisors by id list */
  reorderAdvisors: Scalars['Boolean']['output'];
  reorderLibraryCollectionItems: Scalars['Boolean']['output'];
  reorderSigningRecipients: Scalars['Boolean']['output'];
  replyOnComment: Comment;
  replyUniversityGroupMessage: UniversityGroupMessage;
  /** Player reports that a synced episode failed to embed; the server checks YouTube oEmbed and soft-deletes it if the video is gone */
  reportPodcastPlaybackError: Scalars['Boolean']['output'];
  reportPost: Scalars['Boolean']['output'];
  /** Player reports that a curated reel failed to embed; the server checks YouTube oEmbed and soft-deletes it if the video is gone */
  reportReelPlaybackError: Scalars['Boolean']['output'];
  reportService: Scalars['Boolean']['output'];
  requestSessionRefund: Scalars['Boolean']['output'];
  resendSigningInvitation: Scalars['Boolean']['output'];
  resendVerificationEmail: Scalars['Boolean']['output'];
  resetPassword: Scalars['Boolean']['output'];
  resetUserPassword: Scalars['Boolean']['output'];
  restoreLibraryCollection: LibraryCollectionModel;
  restoreLibraryFolder: LibraryFolderModel;
  resumeCampaign: Campaign;
  /** Resume an active livestream as host */
  resumeLiveStream: LiveStream;
  resumeMySubscription?: Maybe<UserSubscription>;
  resumePostBoost: PostBoost;
  resumeProfileBoost: ProfileBoost;
  retryTrialSignupWithNewCard: CheckoutSessionResult;
  revokeGroupInvite: Scalars['Boolean']['output'];
  revokeLibraryShare: Scalars['Boolean']['output'];
  revokeSubscriptionCoupon: SubscriptionCouponGql;
  rewriteNewsletterWithAI: Newsletter;
  roleChangeRequest: Scalars['Boolean']['output'];
  roleChangeToggle: Scalars['Boolean']['output'];
  /** Section 59 "Run Now" — bypasses only the pacing timer. Lease, quota, and the mandatory Section 27 re-verification still apply; errors if the pool is off, the agent is not ACTIVE, or another tick currently holds its lease. */
  runAiAgentNow: Scalars['Boolean']['output'];
  /** "Run pool now" — immediately runs every ACTIVE agent, bypassing only their pacing timers. Kill switch, leases, quotas, and safety re-verification still apply; errors if the pool is off. */
  runAiAgentPoolNow: AiAgentPoolRunResult;
  saveArticle: SavedArticle;
  saveLibraryItem: LibraryItemModel;
  savePost: Scalars['Boolean']['output'];
  savePushToken: ExpoPushTokenResponse;
  saveRssFeed: Scalars['Boolean']['output'];
  sendConnectionRequest: Scalars['Boolean']['output'];
  sendMessage: Scalars['Boolean']['output'];
  sendNewsletterTest: Scalars['Boolean']['output'];
  sendSigningDocument: SendSigningDocumentResult;
  sendSupportMessage: SupportMessage;
  sendUniversityGroupMessage: UniversityGroupMessage;
  setActionsForRole: PermissionGql;
  /** Section 61 — the kill switch. */
  setAiAgentPoolEnabled: AiAgentPoolConfigModel;
  setApiRequestLoggingEnabled: Scalars['Boolean']['output'];
  setCuratedReelHidden: AdminCuratedReelModel;
  setDateAvailabilityOverride: Availability;
  setLeaderboardVisibility: Scalars['Boolean']['output'];
  setNewsletterSubscriberStatus: NewsletterSubscriber;
  setPodcastEpisodeHidden: PodcastEpisodeModel;
  setSponsorshipPlanActive: AdminSponsorshipPlan;
  shareLibraryResource: LibraryShareMember;
  signUp: SignUpResponse;
  signUpIndustryPartnerMobile: IndustryPartnerMobileSignupResult;
  /** Record the 👍 / 👎 "Was this helpful?" answer on an AI conversation. */
  submitAiConversationFeedback: Scalars['Boolean']['output'];
  /** Submit quiz answers and calculate score */
  submitQuiz: QuizAttemptResponse;
  submitSupportTicketFeedback: SupportTicket;
  syncPodcastSourceNow: PodcastSourceSyncResult;
  syncStoreSubscription: SyncStoreSubscriptionResult;
  /** Run the curated-reel ingestion job for a single video source now. */
  syncVideoSource: VideoSyncResult;
  /** Run the curated-reel ingestion job for all active AUTO sources now. */
  syncVideoSources: VideoSyncResult;
  takeServiceReportAction: ServiceReportActionResponse;
  /** Toggle advisor active status */
  toggleAdvisorStatus: Advisor;
  toggleCommentReaction?: Maybe<Scalars['String']['output']>;
  toggleCompanyStatus: Company;
  toggleLibraryFavorite: LibraryItemModel;
  toggleMentorDayOff: Scalars['Boolean']['output'];
  toggleMentorVerification: Scalars['Boolean']['output'];
  togglePinPost: Scalars['Boolean']['output'];
  togglePostReaction?: Maybe<Scalars['String']['output']>;
  toggleStoryReaction: StoryReactionResponse;
  toggleVideoSourceStatus: VideoSourceModel;
  unbanMember: Scalars['Boolean']['output'];
  unblockCompanyFollower: Scalars['Boolean']['output'];
  unfollowCompany: Scalars['Boolean']['output'];
  unlikePodcastComment: PodcastCommentModel;
  unlikePodcastEpisode: PodcastEpisodeModel;
  unlikeReel: ReelModel;
  unlikeReelComment: ReelCommentModel;
  unsaveArticle: Scalars['Boolean']['output'];
  unsaveLibraryItem: Scalars['Boolean']['output'];
  unsavePost: Scalars['Boolean']['output'];
  unsaveRssFeed: Scalars['Boolean']['output'];
  unsubscribeSubscriberByToken: Scalars['Boolean']['output'];
  updateActionButton: Scalars['Boolean']['output'];
  updateAdminUser: UserGql;
  updateAdvertisingHourlyRate: PlatformSettings;
  /** Update an advisor */
  updateAdvisor: Advisor;
  updateAiAgent: AiAgent;
  updateAiAgentPoolConfig: AiAgentPoolConfigModel;
  updateArticle: Article;
  updateAvailability: Availability;
  updateBookingStatus: Booking;
  updateCampaign: Campaign;
  updateCasePostMedia: Scalars['Boolean']['output'];
  /** Update a category or subcategory */
  updateCategory: CourseCategory;
  updateComment: Comment;
  updateCompany: Company;
  updateCompanyCover: Company;
  updateCompanyLogo: Company;
  updateCoupon: Coupon;
  /** Update an existing course (course-level fields only) */
  updateCourse: Course;
  updateCuratedReel: AdminCuratedReelModel;
  updateDigitalCardPrice: PlatformSettings;
  updateDigitalCardVisibility: MyDigitalCard;
  updateEvent: Event;
  /** Update an existing FAQ (mentor only, own FAQs) */
  updateFaq: Faq;
  updateGroup: Group;
  updateIsHiring: Scalars['Boolean']['output'];
  updateLegalInstruction: LegalInstruction;
  updateLibraryCollection: LibraryCollectionModel;
  updateLibraryFolder: LibraryFolderModel;
  updateLibraryShareRole: Scalars['Boolean']['output'];
  updateLibraryTag: LibraryTagModel;
  updateMemberRole: Scalars['Boolean']['output'];
  updateNewsletterAutomation: NewsletterAutomation;
  updateNewsletterDraft: Newsletter;
  updateNewsletterSubscriber: NewsletterSubscriber;
  updateOpenToWork: Scalars['Boolean']['output'];
  updatePlatformSettings: PlatformSettings;
  updatePodcastSource: PodcastSourceModel;
  updatePost: Scalars['Boolean']['output'];
  updatePostBoostHourlyRate: PlatformSettings;
  updateProfileBoostHourlyRate: PlatformSettings;
  updateReel: ReelModel;
  /** Admin: update a referral campaign */
  updateReferralCampaign: ReferralCampaign;
  updateRole: PermissionGql;
  updateRssFilters: Scalars['Boolean']['output'];
  /** Update an RSS source */
  updateRssSource: RssSource;
  updateSchedule: Scalars['Boolean']['output'];
  updateScheduling: Scheduling;
  updateSelectedBadges: Array<AchievementBadge>;
  updateService: Service;
  updateSigningDocument: SigningDocumentEntity;
  updateSigningField: SigningFieldEntity;
  updateSigningRecipient: SigningRecipientEntity;
  updateSigningTemplate: SigningTemplateEntity;
  updateSourceCompany: SourceCompany;
  updateSponsorshipEvent: AdminSponsorshipEvent;
  updateSponsorshipPlan: AdminSponsorshipPlan;
  updateUniversityCommunity: Community;
  updateVideoSource: VideoSourceModel;
  /** Upload media for ad campaigns */
  uploadAdMedia: Media;
  /** Upload banner image for user profile */
  uploadBannerImage: Media;
  uploadCommentMedia: Scalars['String']['output'];
  uploadCommunityLogo: Scalars['String']['output'];
  /** Upload a document (pdf, docx, etc.) */
  uploadDocument: Media;
  /** Upload cover and profile images for group */
  uploadGroupImages: GroupImagesResult;
  uploadMedia: Media;
  /** Upload one multipart chunk via backend and return its ETag */
  uploadMultipartPart: MultipartUploadedPart;
  uploadPodcastEpisode: PodcastEpisodeModel;
  uploadPostMedia: Media;
  uploadProfileImage: Media;
  uploadSignImage: Media;
  upsertLibraryNote: LibraryItemModel;
  upsertMentorDayAvailability: Scalars['Boolean']['output'];
  upsertUserHeadline: Scalars['Boolean']['output'];
  verifyCheckoutSession?: Maybe<UserSubscription>;
  verifyEmail: Scalars['Boolean']['output'];
  verifyMobileSubscription: VerifyMobileSubscriptionResult;
  verifyUpgradeCheckoutSession?: Maybe<UserSubscription>;
  voteInPoll: Poll;
  withdrawBooking: Scalars['Boolean']['output'];
  withdrawJoinRequest: Scalars['Boolean']['output'];
  withdrawRoleChangeRequest: Scalars['Boolean']['output'];
};


export type MutationAdminloginArgs = {
  input: LoginInput;
};


export type MutationAbortMultipartUploadArgs = {
  input: AbortMultipartUploadInput;
};


export type MutationAcceptBookingArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationAcceptConnectionArgs = {
  input: ConnectionActionInput;
};


export type MutationAcceptGroupInviteArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationAddActionButtonArgs = {
  input: AddActionButtonInput;
};


export type MutationAddContactArgs = {
  input: AddContactInput;
};


export type MutationAddCuratedReelByUrlArgs = {
  input: AddCuratedReelByUrlInput;
};


export type MutationAddEducationArgs = {
  input: AddEducationInput;
};


export type MutationAddExperienceArgs = {
  input: AddExperienceInput;
};


export type MutationAddLibraryEntryArgs = {
  input: LibraryEntryInput;
};


export type MutationAddLibraryItemTagArgs = {
  input: LibraryItemTagInput;
};


export type MutationAddLicenseArgs = {
  input: AddLicenseInput;
};


export type MutationAddSigningFieldArgs = {
  input: AddSigningFieldInput;
};


export type MutationAddSigningRecipientArgs = {
  input: AddSigningRecipientInput;
};


export type MutationAddSkillsToUserArgs = {
  input: AddSkillsInput;
};


export type MutationAddUniversityCommunityArgs = {
  input: CreateCommunityInput;
};


export type MutationAdminActivateInfluenceConfigArgs = {
  input: ActivateInfluenceConfigInput;
};


export type MutationAdminAdjustInfluenceArgs = {
  input: AdjustInfluenceInput;
};


export type MutationAdminApproveCampaignArgs = {
  campaignId: Scalars['ID']['input'];
};


export type MutationAdminApproveSessionRefundArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationAdminAssignSupportTicketArgs = {
  input: AssignSupportTicketInput;
};


export type MutationAdminCancelBroadcastArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminChangeSupportTicketPriorityArgs = {
  input: ChangeSupportTicketPriorityInput;
};


export type MutationAdminChangeSupportTicketStatusArgs = {
  input: ChangeSupportTicketStatusInput;
};


export type MutationAdminCreateBroadcastArgs = {
  input: CreateBroadcastInput;
};


export type MutationAdminCreateCampaignForPartnerArgs = {
  input: AdminCreateCampaignInput;
};


export type MutationAdminCreateSubscriptionPlanArgs = {
  input: CreateSubscriptionPlanInput;
};


export type MutationAdminDeleteBroadcastArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeleteKnowledgeArticleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeleteLoanCalculatorLeadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeletePracticeValuationLeadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeleteSubscriptionPlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminPauseBroadcastArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminPauseCampaignArgs = {
  campaignId: Scalars['ID']['input'];
};


export type MutationAdminPostActionArgs = {
  input: AdminPostActionInput;
};


export type MutationAdminRecalculateInfluenceUserArgs = {
  apply: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAdminRejectCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationAdminRejectSessionRefundArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationAdminResumeBroadcastArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminResumeCampaignArgs = {
  campaignId: Scalars['ID']['input'];
};


export type MutationAdminRetryBroadcastFailedEmailsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminRetryInfluenceOutboxArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAdminReverseInfluenceEventArgs = {
  input: ReverseInfluenceEventInput;
};


export type MutationAdminSendBroadcastArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminSendBroadcastTestArgs = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAdminSendSupportMessageArgs = {
  input: AdminSendSupportMessageInput;
};


export type MutationAdminSetAchievementActiveArgs = {
  active: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
};


export type MutationAdminSetInfluenceEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationAdminSuspendCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationAdminTakeSupportTicketArgs = {
  ticketId: Scalars['ID']['input'];
};


export type MutationAdminUnsuspendCampaignArgs = {
  campaignId: Scalars['ID']['input'];
};


export type MutationAdminUpdateAdDurationPackArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAdDurationPackInput;
};


export type MutationAdminUpdateBroadcastArgs = {
  input: UpdateBroadcastInput;
};


export type MutationAdminUpdateProfileBoostPackArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProfileBoostPackInput;
};


export type MutationAdminUpdateSubscriptionPlanArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSubscriptionPlanInput;
};


export type MutationAdminUpsertAchievementDefinitionArgs = {
  input: UpsertAchievementDefinitionInput;
};


export type MutationAdminUpsertKnowledgeArticleArgs = {
  input: UpsertKnowledgeArticleInput;
};


export type MutationAdminUpsertSupportCategoryArgs = {
  input: UpsertSupportCategoryInput;
};


export type MutationApplySubscriptionCouponArgs = {
  couponCode: Scalars['String']['input'];
};


export type MutationApproveAiAgentActionArgs = {
  actionId: Scalars['ID']['input'];
};


export type MutationApproveAndScheduleNewsletterArgs = {
  id: Scalars['ID']['input'];
  input: ApproveAndScheduleNewsletterInput;
};


export type MutationApproveMembershipArgs = {
  membershipId: Scalars['String']['input'];
};


export type MutationApproveNewUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationApprovePostArgs = {
  postId: Scalars['String']['input'];
};


export type MutationApproveRoleChangeRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationApproveSponsoredRequestArgs = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationArchiveArticleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAttachSigningDocumentPdfArgs = {
  input: AttachSigningDocumentPdfInput;
};


export type MutationBanMemberArgs = {
  input: BanMemberInput;
};


export type MutationBlockCompanyFollowerArgs = {
  companyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationBookSessionArgs = {
  input: BookSessionInput;
};


export type MutationCallCancleArgs = {
  input: CallSendInput;
};


export type MutationCallMissedArgs = {
  input: CallSendInput;
};


export type MutationCallSendArgs = {
  input: CallSendInput;
};


export type MutationCancelCampaignArgs = {
  campaignId: Scalars['ID']['input'];
};


export type MutationCancelConfirmedSessionArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationCancelConnectionRequestArgs = {
  input: DeleteConnectionInput;
};


export type MutationCancelNewsletterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelPendingPostBoostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelRoleChangeRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationCancelSigningDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangeGroupStatusArgs = {
  input: ChangeGroupStatusInput;
};


export type MutationChangeMyServiceStatusArgs = {
  id: Scalars['ID']['input'];
  status: ServiceStatus;
};


export type MutationChangeServiceStatusArgs = {
  serviceId: Scalars['String']['input'];
  status: ServiceStatus;
};


export type MutationChangeSubscriptionPlanArgs = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['ID']['input'];
};


export type MutationChangeUserStatusArgs = {
  status: UserStatus;
  userId: Scalars['String']['input'];
};


export type MutationCloseSupportTicketArgs = {
  ticketId: Scalars['ID']['input'];
};


export type MutationCommentOnPostArgs = {
  input: CreateCommentInput;
};


export type MutationCompleteMultipartUploadArgs = {
  input: CompleteMultipartUploadInput;
};


export type MutationCompleteSessionArgs = {
  input: AcceptSessionInput;
};


export type MutationConfirmCampaignExtensionArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type MutationConfirmCampaignPaymentArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type MutationConfirmDigitalCardPaymentArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type MutationConfirmPostBoostPaymentArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type MutationConfirmProfileBoostExtensionArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type MutationConfirmProfileBoostPaymentArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type MutationConfirmReelUploadArgs = {
  input: ConfirmUploadInput;
};


export type MutationConfirmSponsorshipPaymentArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type MutationContinueSignupWithoutTrialArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationCreateAdminUserArgs = {
  input: CreateAdminInput;
};


export type MutationCreateAdvisorArgs = {
  input: CreateAdvisorInput;
};


export type MutationCreateAiAgentArgs = {
  input: CreateAiAgentInput;
};


export type MutationCreateArticleArgs = {
  input: CreateArticleInput;
};


export type MutationCreateBookingArgs = {
  createBookingInput: CreateBookingInput;
};


export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type MutationCreateCasePostArgs = {
  input: CreateCasePostInput;
};


export type MutationCreateCategoryArgs = {
  input: CreateCourseCategoryInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateCouponArgs = {
  createCouponInput: CreateCouponInput;
};


export type MutationCreateCourseArgs = {
  createCourseInput: CreateCourseInput;
};


export type MutationCreateEventArgs = {
  createEventInput: CreateEventInput;
};


export type MutationCreateFaqArgs = {
  input: CreateFaqInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateLegalInstructionArgs = {
  input: CreateLegalInstructionInput;
};


export type MutationCreateLibraryCollectionArgs = {
  input: CreateLibraryCollectionInput;
};


export type MutationCreateLibraryFolderArgs = {
  input: CreateLibraryFolderInput;
};


export type MutationCreateLibraryTagArgs = {
  input: CreateLibraryTagInput;
};


export type MutationCreateLiveStreamArgs = {
  createLiveStreamInput: CreateLiveStreamInput;
};


export type MutationCreateNewsletterArgs = {
  input: CreateNewsletterInput;
};


export type MutationCreateNewsletterDraftArgs = {
  input: CreateNewsletterDraftInput;
};


export type MutationCreateNewsletterSubscriberArgs = {
  input: CreateSubscriberInput;
};


export type MutationCreateOccasionPostArgs = {
  input: CreateOccasionPostInput;
};


export type MutationCreatePodcastCommentArgs = {
  input: CreatePodcastCommentInput;
};


export type MutationCreatePodcastSourceArgs = {
  input: CreatePodcastSourceInput;
};


export type MutationCreatePollPostArgs = {
  input: CreatePollPostInput;
};


export type MutationCreatePostArgs = {
  input: CreatePostInput;
};


export type MutationCreateReelCommentArgs = {
  input: CreateReelCommentInput;
};


export type MutationCreateReferralCampaignArgs = {
  input: CreateReferralCampaignInput;
};


export type MutationCreateRepostArgs = {
  input: CreateRepostInput;
};


export type MutationCreateReviewArgs = {
  input: CreateReviewInput;
};


export type MutationCreateRoleArgs = {
  input: CreateAdminPermissionInput;
};


export type MutationCreateRoleChangeRequestArgs = {
  input: CreateRoleChangeRequestInput;
};


export type MutationCreateRssSourceArgs = {
  input: CreateRssSourceInput;
};


export type MutationCreateSchedulingArgs = {
  createSchedulingInput: CreateSchedulingInput;
};


export type MutationCreateServiceArgs = {
  createServiceInput: CreateServiceInput;
};


export type MutationCreateSessionPaymentIntentArgs = {
  bookingId: Scalars['String']['input'];
};


export type MutationCreateSigningDocumentArgs = {
  input: CreateSigningDocumentInput;
};


export type MutationCreateSigningTemplateArgs = {
  input: CreateSigningTemplateInput;
};


export type MutationCreateSourceCompanyArgs = {
  input: CreateSourceCompanyInput;
};


export type MutationCreateSourceReviewArgs = {
  input: CreateSourceReviewInput;
};


export type MutationCreateSponsoredRequestArgs = {
  input: CreateSponsoredRequestInput;
};


export type MutationCreateSponsorshipCheckoutArgs = {
  input: CreateSponsorshipCheckoutInput;
};


export type MutationCreateSponsorshipEventArgs = {
  input: CreateSponsorshipEventInput;
};


export type MutationCreateSponsorshipPlanArgs = {
  input: CreateSponsorshipPlanInput;
};


export type MutationCreateStoryArgs = {
  input: CreateStoryInput;
};


export type MutationCreateSubscriptionCheckoutArgs = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['ID']['input'];
};


export type MutationCreateSubscriptionCouponArgs = {
  input: CreateSubscriptionCouponInput;
};


export type MutationCreateSupportTicketArgs = {
  input: CreateSupportTicketInput;
};


export type MutationCreateSupportTicketFromAiArgs = {
  conversationId: Scalars['ID']['input'];
};


export type MutationCreateUpgradeCheckoutArgs = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['ID']['input'];
};


export type MutationCreateVideoSourceArgs = {
  input: CreateVideoSourceInput;
};


export type MutationDeclineGroupInviteArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationDeleteAdminUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationDeleteAdvisorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteArticleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBookingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCampaignArgs = {
  campaignId: Scalars['ID']['input'];
};


export type MutationDeleteCategoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


export type MutationDeleteCompanyArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationDeleteCompanyCoverArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationDeleteCompanyLogoArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationDeleteConnectionArgs = {
  input: DeleteConnectionInput;
};


export type MutationDeleteContactArgs = {
  input: DeleteContactInput;
};


export type MutationDeleteCuratedReelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEducationArgs = {
  input: DeleteEducationInput;
};


export type MutationDeleteEventArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteExperienceArgs = {
  input: DeleteExperienceInput;
};


export type MutationDeleteFaqArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationDeleteLegalInstructionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLibraryCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLibraryFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLibraryNoteArgs = {
  itemId: Scalars['ID']['input'];
};


export type MutationDeleteLibraryTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLicenseArgs = {
  input: DeleteLicenseInput;
};


export type MutationDeleteMessageArgs = {
  messageId: Scalars['String']['input'];
};


export type MutationDeleteNewsletterDraftArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNewsletterSubscriberArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePodcastCommentArgs = {
  commentId: Scalars['String']['input'];
};


export type MutationDeletePodcastEpisodeArgs = {
  input: DeletePodcastEpisodeInput;
};


export type MutationDeletePodcastSourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePostArgs = {
  postId: Scalars['String']['input'];
};


export type MutationDeleteReelArgs = {
  input: DeleteReelInput;
};


export type MutationDeleteRoleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteRoomArgs = {
  roomId: Scalars['String']['input'];
};


export type MutationDeleteRssSourceArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSchedulingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSigningDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSigningTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSkillFromUserArgs = {
  input: DeleteSkillInput;
};


export type MutationDeleteSourceCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSourceReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSponsorshipEventArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteStoryArgs = {
  input: DeleteContentInput;
};


export type MutationDeleteUniversityCommunityArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationDeleteVideoSourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableAiAgentArgs = {
  agentId: Scalars['ID']['input'];
};


export type MutationEditAboutArgs = {
  input: EditAboutInput;
};


export type MutationEditBasicAccountArgs = {
  input: EditBasicAccountInput;
};


export type MutationEditContactArgs = {
  input: EditContactInput;
};


export type MutationEditEducationArgs = {
  input: EditEducationInput;
};


export type MutationEditExperienceArgs = {
  input: EditExperienceInput;
};


export type MutationEditLicenseArgs = {
  input: EditLicenseInput;
};


export type MutationEditMentorAvailabilityArgs = {
  input: EditMentorAvailabilityInput;
};


export type MutationEnableAiAgentArgs = {
  agentId: Scalars['ID']['input'];
};


export type MutationEndLiveStreamArgs = {
  roomId: Scalars['String']['input'];
};


export type MutationEnrollCourseArgs = {
  enrollCourseInput: EnrollCourseInput;
};


export type MutationFollowCompanyArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationForgetPasswordArgs = {
  input: ForgetPasswordInput;
};


export type MutationGenerateCertificateArgs = {
  courseId: Scalars['String']['input'];
};


export type MutationGenerateMentorReceiptPdfArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationGenerateNewsletterWithAiArgs = {
  input?: InputMaybe<GenerateNewsletterInput>;
};


export type MutationGenerateReceiptPdfArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationGetLivekitTokenForConversationArgs = {
  recieverId: Scalars['String']['input'];
};


export type MutationGetLivekitTokenForEventArgs = {
  eventId: Scalars['String']['input'];
};


export type MutationGetReelUploadUrlArgs = {
  input: GetUploadUrlInput;
};


export type MutationHostHeartbeatArgs = {
  roomId: Scalars['String']['input'];
};


export type MutationInitializeCampaignExtensionArgs = {
  campaignId: Scalars['ID']['input'];
  durationDays?: InputMaybe<Scalars['Int']['input']>;
  durationHours?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationInitializeCampaignPaymentArgs = {
  campaignId: Scalars['ID']['input'];
  durationDays?: InputMaybe<Scalars['Int']['input']>;
  durationHours?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationInitializePostBoostPaymentArgs = {
  input: InitializePostBoostPaymentInput;
};


export type MutationInitializeProfileBoostExtensionArgs = {
  input: InitializeProfileBoostExtensionInput;
};


export type MutationInitializeProfileBoostPaymentArgs = {
  input?: InputMaybe<InitializeProfileBoostPaymentInput>;
  packId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationInitializeSessionPaymentArgs = {
  input: InitializeSessionPaymentInput;
};


export type MutationInitiateMultipartUploadArgs = {
  input: InitiateMultipartUploadInput;
};


export type MutationInviteToGroupArgs = {
  input: InviteToGroupInput;
};


export type MutationInviteToLiveStreamArgs = {
  input: InviteToLiveStreamInput;
};


export type MutationJoinEventArgs = {
  eventId: Scalars['String']['input'];
};


export type MutationJoinGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationJoinLiveStreamArgs = {
  roomId: Scalars['String']['input'];
};


export type MutationKickParticipantArgs = {
  eventId: Scalars['String']['input'];
  participantId: Scalars['String']['input'];
};


export type MutationKickParticipantInStreamArgs = {
  participantIdentity: Scalars['String']['input'];
  roomId: Scalars['String']['input'];
};


export type MutationLeaveCourseArgs = {
  leaveCourseInput: LeaveCourseInput;
};


export type MutationLeaveEventArgs = {
  eventId: Scalars['String']['input'];
};


export type MutationLeaveGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationLeaveLibraryShareArgs = {
  shareId: Scalars['ID']['input'];
};


export type MutationLikePodcastCommentArgs = {
  commentId: Scalars['String']['input'];
};


export type MutationLikePodcastEpisodeArgs = {
  episodeId: Scalars['String']['input'];
};


export type MutationLikeReelArgs = {
  reelId: Scalars['String']['input'];
};


export type MutationLikeReelCommentArgs = {
  commentId: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationMarkCompanyMessageAsReadArgs = {
  companyId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
};


export type MutationMarkContentViewedArgs = {
  input: MarkContentViewedInput;
};


export type MutationMarkConversationAsReadArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationMarkHostAwayArgs = {
  roomId: Scalars['String']['input'];
};


export type MutationMarkMessageAsReadArgs = {
  messageId: Scalars['String']['input'];
};


export type MutationMarkNotificationAsReadArgs = {
  input: MarkNotificationReadInput;
};


export type MutationMarkPostNotInterestedArgs = {
  postId: Scalars['String']['input'];
};


export type MutationMarkStoryViewedArgs = {
  input: MarkStoryViewedInput;
};


export type MutationMoveAdvisorArgs = {
  input: MoveAdvisorInput;
};


export type MutationMoveLibraryFolderArgs = {
  input: MoveLibraryFolderInput;
};


export type MutationMoveLibraryItemArgs = {
  input: MoveLibraryItemInput;
};


export type MutationPauseCampaignArgs = {
  campaignId: Scalars['ID']['input'];
};


export type MutationPausePostBoostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPauseProfileBoostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPostNowArgs = {
  postId: Scalars['String']['input'];
};


export type MutationPublishArticleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPurchaseCampaignWithStoreArgs = {
  input: PurchaseCampaignWithStoreInput;
};


export type MutationPurchaseProfileBoostArgs = {
  input: PurchaseProfileBoostInput;
};


export type MutationRateCourseArgs = {
  courseId: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
};


export type MutationRateKnowledgeArticleArgs = {
  input: RateKnowledgeArticleInput;
};


export type MutationReceiveCallArgs = {
  input: CallSendInput;
};


export type MutationRecordAdClickArgs = {
  campaignId: Scalars['ID']['input'];
};


export type MutationRecordAdImpressionArgs = {
  campaignId: Scalars['ID']['input'];
  placement?: InputMaybe<AdPlacement>;
};


export type MutationRecordPodcastPlayArgs = {
  input: RecordPodcastPlayInput;
};


export type MutationRecordPostBoostClickArgs = {
  boostId: Scalars['ID']['input'];
};


export type MutationRecordPostBoostImpressionArgs = {
  boostId: Scalars['ID']['input'];
};


export type MutationRecordProfileBoostClickArgs = {
  boostId: Scalars['ID']['input'];
};


export type MutationRecordProfileBoostImpressionArgs = {
  boostId: Scalars['ID']['input'];
};


export type MutationRecordProfileBoostProfileVisitArgs = {
  boostId: Scalars['ID']['input'];
};


export type MutationRecordProfileViewArgs = {
  input: RecordProfileViewInput;
};


export type MutationRedeemCouponArgs = {
  redeemCouponInput: RedeemCouponInput;
};


export type MutationRefreshTokenArgs = {
  input: RefreshTokenInput;
};


export type MutationRefundSponsorshipPurchaseArgs = {
  id: Scalars['String']['input'];
};


export type MutationRegenerateAiAgentVoiceArgs = {
  agentId: Scalars['ID']['input'];
};


export type MutationRejectAiAgentActionArgs = {
  actionId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectBookingArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationRejectCallArgs = {
  input: CallSendInput;
};


export type MutationRejectConnectionArgs = {
  input: ConnectionActionInput;
};


export type MutationRejectMembershipArgs = {
  membershipId: Scalars['String']['input'];
};


export type MutationRejectNewUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationRejectPostArgs = {
  postId: Scalars['String']['input'];
};


export type MutationRejectRoleChangeRequestArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRejectSponsoredRequestArgs = {
  adminNote: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationRemoveAiAgentArgs = {
  agentId: Scalars['ID']['input'];
};


export type MutationRemoveCompanyFollowerArgs = {
  companyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveCouponArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveCourseArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveLibraryEntryArgs = {
  input: LibraryEntryInput;
};


export type MutationRemoveLibraryItemTagArgs = {
  input: LibraryItemTagInput;
};


export type MutationRemoveMemberFromGroupArgs = {
  input: RemoveMemberInput;
};


export type MutationRemovePodcastArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveServiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveSigningFieldArgs = {
  documentId: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
};


export type MutationRemoveSigningRecipientArgs = {
  documentId: Scalars['ID']['input'];
  recipientId: Scalars['ID']['input'];
};


export type MutationReorderAdvisorsArgs = {
  input: ReorderAdvisorsInput;
};


export type MutationReorderLibraryCollectionItemsArgs = {
  input: ReorderLibraryCollectionInput;
};


export type MutationReorderSigningRecipientsArgs = {
  input: ReorderSigningRecipientsInput;
};


export type MutationReplyOnCommentArgs = {
  input: ReplyCommentInput;
};


export type MutationReplyUniversityGroupMessageArgs = {
  content: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
  senderId: Scalars['String']['input'];
};


export type MutationReportPodcastPlaybackErrorArgs = {
  input: ReportPodcastPlaybackErrorInput;
};


export type MutationReportPostArgs = {
  input: ReportPostInput;
};


export type MutationReportReelPlaybackErrorArgs = {
  input: ReportReelPlaybackErrorInput;
};


export type MutationReportServiceArgs = {
  createServiceReportInput: CreateServiceReportInput;
};


export type MutationRequestSessionRefundArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
};


export type MutationResendSigningInvitationArgs = {
  documentId: Scalars['ID']['input'];
  recipientId: Scalars['ID']['input'];
};


export type MutationResendVerificationEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResetUserPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationRestoreLibraryCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreLibraryFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResumeCampaignArgs = {
  campaignId: Scalars['ID']['input'];
};


export type MutationResumeLiveStreamArgs = {
  roomId: Scalars['String']['input'];
};


export type MutationResumePostBoostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResumeProfileBoostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetryTrialSignupWithNewCardArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationRevokeGroupInviteArgs = {
  inviteId: Scalars['String']['input'];
};


export type MutationRevokeLibraryShareArgs = {
  shareId: Scalars['ID']['input'];
};


export type MutationRevokeSubscriptionCouponArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRewriteNewsletterWithAiArgs = {
  id: Scalars['ID']['input'];
  input: RewriteNewsletterInput;
};


export type MutationRunAiAgentNowArgs = {
  agentId: Scalars['ID']['input'];
};


export type MutationSaveArticleArgs = {
  input: SaveArticleInput;
};


export type MutationSaveLibraryItemArgs = {
  input: SaveLibraryItemInput;
};


export type MutationSavePostArgs = {
  postId: Scalars['String']['input'];
};


export type MutationSavePushTokenArgs = {
  input: SavePushTokenInput;
};


export type MutationSaveRssFeedArgs = {
  input: SaveRssPostsInput;
};


export type MutationSendConnectionRequestArgs = {
  input: SendConnectionRequestInput;
};


export type MutationSendMessageArgs = {
  input: SendMessageInput;
};


export type MutationSendNewsletterTestArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<SendNewsletterTestInput>;
};


export type MutationSendSigningDocumentArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<SendSigningDocumentInput>;
};


export type MutationSendSupportMessageArgs = {
  input: SendSupportMessageInput;
};


export type MutationSendUniversityGroupMessageArgs = {
  content: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  senderId: Scalars['String']['input'];
};


export type MutationSetActionsForRoleArgs = {
  input: UpdatePermissionActionsInput;
};


export type MutationSetAiAgentPoolEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetApiRequestLoggingEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetCuratedReelHiddenArgs = {
  hidden: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSetDateAvailabilityOverrideArgs = {
  input: SetDateAvailabilityOverrideInput;
};


export type MutationSetLeaderboardVisibilityArgs = {
  hidden: Scalars['Boolean']['input'];
};


export type MutationSetNewsletterSubscriberStatusArgs = {
  id: Scalars['ID']['input'];
  status: NewsletterSubscriberStatus;
};


export type MutationSetPodcastEpisodeHiddenArgs = {
  input: SetPodcastEpisodeHiddenInput;
};


export type MutationSetSponsorshipPlanActiveArgs = {
  id: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};


export type MutationShareLibraryResourceArgs = {
  input: ShareLibraryResourceInput;
};


export type MutationSignUpArgs = {
  input: SignUpInput;
};


export type MutationSignUpIndustryPartnerMobileArgs = {
  input: IndustryPartnerMobileSignupInput;
};


export type MutationSubmitAiConversationFeedbackArgs = {
  conversationId: Scalars['ID']['input'];
  helpful: Scalars['Boolean']['input'];
};


export type MutationSubmitQuizArgs = {
  input: SubmitQuizInput;
};


export type MutationSubmitSupportTicketFeedbackArgs = {
  input: SubmitTicketFeedbackInput;
};


export type MutationSyncPodcastSourceNowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSyncStoreSubscriptionArgs = {
  input: SyncStoreSubscriptionInput;
};


export type MutationSyncVideoSourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTakeServiceReportActionArgs = {
  input: TakeServiceReportActionInput;
};


export type MutationToggleAdvisorStatusArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleCommentReactionArgs = {
  input: LikeCommentInput;
};


export type MutationToggleCompanyStatusArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationToggleLibraryFavoriteArgs = {
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  itemId: Scalars['ID']['input'];
};


export type MutationToggleMentorDayOffArgs = {
  input: MentorDayOffInput;
};


export type MutationToggleMentorVerificationArgs = {
  input: VerifyMentorInput;
};


export type MutationTogglePinPostArgs = {
  postId: Scalars['String']['input'];
};


export type MutationTogglePostReactionArgs = {
  input: LikePostInput;
};


export type MutationToggleStoryReactionArgs = {
  input: ToggleStoryLikeInput;
};


export type MutationToggleVideoSourceStatusArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnbanMemberArgs = {
  input: UnbanMemberInput;
};


export type MutationUnblockCompanyFollowerArgs = {
  companyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUnfollowCompanyArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationUnlikePodcastCommentArgs = {
  commentId: Scalars['String']['input'];
};


export type MutationUnlikePodcastEpisodeArgs = {
  episodeId: Scalars['String']['input'];
};


export type MutationUnlikeReelArgs = {
  reelId: Scalars['String']['input'];
};


export type MutationUnlikeReelCommentArgs = {
  commentId: Scalars['String']['input'];
};


export type MutationUnsaveArticleArgs = {
  input: UnsaveArticleInput;
};


export type MutationUnsaveLibraryItemArgs = {
  itemId: Scalars['ID']['input'];
};


export type MutationUnsavePostArgs = {
  postId: Scalars['String']['input'];
};


export type MutationUnsaveRssFeedArgs = {
  input: UnSaveRssPostsInput;
};


export type MutationUnsubscribeSubscriberByTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationUpdateActionButtonArgs = {
  input: UpdateActionButtonInput;
};


export type MutationUpdateAdminUserArgs = {
  input: UpdateAdminUserInput;
};


export type MutationUpdateAdvertisingHourlyRateArgs = {
  rateCents: Scalars['Int']['input'];
};


export type MutationUpdateAdvisorArgs = {
  input: UpdateAdvisorInput;
};


export type MutationUpdateAiAgentArgs = {
  input: UpdateAiAgentInput;
};


export type MutationUpdateAiAgentPoolConfigArgs = {
  input: UpdateAiAgentPoolConfigInput;
};


export type MutationUpdateArticleArgs = {
  input: UpdateArticleInput;
};


export type MutationUpdateAvailabilityArgs = {
  updateAvailabilityInput: UpdateAvailabilityInput;
};


export type MutationUpdateBookingStatusArgs = {
  updateBookingStatusInput: UpdateBookingStatusInput;
};


export type MutationUpdateCampaignArgs = {
  input: UpdateCampaignInput;
};


export type MutationUpdateCasePostMediaArgs = {
  input: UpdateCasePostInput;
};


export type MutationUpdateCategoryArgs = {
  id: Scalars['String']['input'];
  input: UpdateCourseCategoryInput;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateCompanyArgs = {
  id: Scalars['String']['input'];
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanyCoverArgs = {
  companyId: Scalars['String']['input'];
  coverUrl: Scalars['String']['input'];
};


export type MutationUpdateCompanyLogoArgs = {
  companyId: Scalars['String']['input'];
  logoUrl: Scalars['String']['input'];
};


export type MutationUpdateCouponArgs = {
  updateCouponInput: UpdateCouponInput;
};


export type MutationUpdateCourseArgs = {
  updateCourseInput: UpdateCourseInput;
};


export type MutationUpdateCuratedReelArgs = {
  input: UpdateCuratedReelInput;
};


export type MutationUpdateDigitalCardPriceArgs = {
  priceCents: Scalars['Int']['input'];
};


export type MutationUpdateDigitalCardVisibilityArgs = {
  input: UpdateDigitalCardVisibilityInput;
};


export type MutationUpdateEventArgs = {
  updateEventInput: UpdateEventInput;
};


export type MutationUpdateFaqArgs = {
  input: UpdateFaqInput;
};


export type MutationUpdateGroupArgs = {
  groupId: Scalars['String']['input'];
  input: UpdateGroupInput;
};


export type MutationUpdateIsHiringArgs = {
  isHiring: Scalars['Boolean']['input'];
};


export type MutationUpdateLegalInstructionArgs = {
  input: UpdateLegalInstructionInput;
};


export type MutationUpdateLibraryCollectionArgs = {
  input: UpdateLibraryCollectionInput;
};


export type MutationUpdateLibraryFolderArgs = {
  input: UpdateLibraryFolderInput;
};


export type MutationUpdateLibraryShareRoleArgs = {
  input: UpdateLibraryShareRoleInput;
};


export type MutationUpdateLibraryTagArgs = {
  input: UpdateLibraryTagInput;
};


export type MutationUpdateMemberRoleArgs = {
  input: UpdateMemberRoleInput;
};


export type MutationUpdateNewsletterAutomationArgs = {
  input: UpdateNewsletterAutomationInput;
};


export type MutationUpdateNewsletterDraftArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNewsletterDraftInput;
};


export type MutationUpdateNewsletterSubscriberArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSubscriberInput;
};


export type MutationUpdateOpenToWorkArgs = {
  openToWork: Scalars['Boolean']['input'];
};


export type MutationUpdatePlatformSettingsArgs = {
  input: UpdatePlatformSettingsInput;
};


export type MutationUpdatePodcastSourceArgs = {
  input: UpdatePodcastSourceInput;
};


export type MutationUpdatePostArgs = {
  input: UpdatePostInputForBoth;
};


export type MutationUpdatePostBoostHourlyRateArgs = {
  rateCents: Scalars['Int']['input'];
};


export type MutationUpdateProfileBoostHourlyRateArgs = {
  rateCents: Scalars['Int']['input'];
};


export type MutationUpdateReelArgs = {
  input: UpdateReelInput;
};


export type MutationUpdateReferralCampaignArgs = {
  input: UpdateReferralCampaignInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateAdminPermissionInput;
};


export type MutationUpdateRssFiltersArgs = {
  filters: Array<Scalars['String']['input']>;
};


export type MutationUpdateRssSourceArgs = {
  id: Scalars['String']['input'];
  input: UpdateRssSourceInput;
};


export type MutationUpdateScheduleArgs = {
  input: UpdateScheduleInput;
};


export type MutationUpdateSchedulingArgs = {
  updateSchedulingInput: UpdateSchedulingInput;
};


export type MutationUpdateSelectedBadgesArgs = {
  input: UpdateSelectedBadgesInput;
};


export type MutationUpdateServiceArgs = {
  updateServiceInput: UpdateServiceInput;
};


export type MutationUpdateSigningDocumentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSigningDocumentInput;
};


export type MutationUpdateSigningFieldArgs = {
  input: UpdateSigningFieldInput;
};


export type MutationUpdateSigningRecipientArgs = {
  input: UpdateSigningRecipientInput;
};


export type MutationUpdateSigningTemplateArgs = {
  input: UpdateSigningTemplateInput;
};


export type MutationUpdateSourceCompanyArgs = {
  input: UpdateSourceCompanyInput;
};


export type MutationUpdateSponsorshipEventArgs = {
  input: UpdateSponsorshipEventInput;
};


export type MutationUpdateSponsorshipPlanArgs = {
  input: UpdateSponsorshipPlanInput;
};


export type MutationUpdateUniversityCommunityArgs = {
  id: Scalars['String']['input'];
  input: CreateCommunityInput;
};


export type MutationUpdateVideoSourceArgs = {
  input: UpdateVideoSourceInput;
};


export type MutationUploadAdMediaArgs = {
  input: UploadPostMediaInput;
};


export type MutationUploadBannerImageArgs = {
  input: UploadBannerImageInput;
};


export type MutationUploadCommentMediaArgs = {
  input: UploadCommentMediaInput;
};


export type MutationUploadCommunityLogoArgs = {
  input: UploadCommentMediaInput;
};


export type MutationUploadDocumentArgs = {
  input: UploadPostMediaInput;
};


export type MutationUploadGroupImagesArgs = {
  input: UploadGroupImagesInput;
};


export type MutationUploadMediaArgs = {
  input: UploadPostMediaInput;
};


export type MutationUploadMultipartPartArgs = {
  input: MultipartUploadPartInput;
};


export type MutationUploadPodcastEpisodeArgs = {
  input: UploadPodcastEpisodeInput;
};


export type MutationUploadPostMediaArgs = {
  input: UploadPostMediaInput;
};


export type MutationUploadProfileImageArgs = {
  input: UploadProfileImageInput;
};


export type MutationUploadSignImageArgs = {
  input: UploadProfileImageInput;
};


export type MutationUpsertLibraryNoteArgs = {
  input: UpsertLibraryNoteInput;
};


export type MutationUpsertMentorDayAvailabilityArgs = {
  input: EditMentorDayAvailabilityInput;
};


export type MutationUpsertUserHeadlineArgs = {
  input: UserHeadlineInput;
};


export type MutationVerifyCheckoutSessionArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationVerifyEmailArgs = {
  input: VerifyEmailInput;
};


export type MutationVerifyMobileSubscriptionArgs = {
  input: VerifyMobileSubscriptionInput;
};


export type MutationVerifyUpgradeCheckoutSessionArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationVoteInPollArgs = {
  optionId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};


export type MutationWithdrawBookingArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationWithdrawJoinRequestArgs = {
  groupId: Scalars['String']['input'];
};

export type MyDigitalCard = {
  __typename?: 'MyDigitalCard';
  amountPaidCents: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  publicUrl: Scalars['String']['output'];
  purchasedAt: Scalars['DateTime']['output'];
  slug: Scalars['String']['output'];
  visibility: DigitalCardVisibilitySettings;
};

export type Newsletter = {
  __typename?: 'Newsletter';
  aiInstructions?: Maybe<Scalars['String']['output']>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedById?: Maybe<Scalars['ID']['output']>;
  automationId?: Maybe<Scalars['ID']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['ID']['output']>;
  failedCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isAiGenerated: Scalars['Boolean']['output'];
  recipientCount: Scalars['Int']['output'];
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentCount: Scalars['Int']['output'];
  status: NewsletterStatus;
  subject: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type NewsletterAutomation = {
  __typename?: 'NewsletterAutomation';
  aiInstructions: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
  frequency: NewsletterAutomationFrequency;
  generationLeadTimeMinutes: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  intervalDays?: Maybe<Scalars['Int']['output']>;
  nextGenerationAtUtc?: Maybe<Scalars['DateTime']['output']>;
  nextSendAtUtc?: Maybe<Scalars['DateTime']['output']>;
  timeOfDay: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  weekday?: Maybe<Scalars['Int']['output']>;
};

/** Recurring newsletter automation schedule (INTERVAL, WEEKLY, MONTHLY) */
export enum NewsletterAutomationFrequency {
  Interval = 'INTERVAL',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

/** Per-recipient delivery outcome (PENDING, SENT, FAILED) */
export enum NewsletterDeliveryStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sent = 'SENT'
}

export type NewsletterPaginatedResponse = {
  __typename?: 'NewsletterPaginatedResponse';
  data: Array<Newsletter>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type NewsletterRecipient = {
  __typename?: 'NewsletterRecipient';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  newsletterId: Scalars['ID']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: NewsletterDeliveryStatus;
  subscriberId?: Maybe<Scalars['ID']['output']>;
};

export type NewsletterRecipientPaginatedResponse = {
  __typename?: 'NewsletterRecipientPaginatedResponse';
  data: Array<NewsletterRecipient>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

/** Lifecycle status of a newsletter edition */
export enum NewsletterStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  MissedApproval = 'MISSED_APPROVAL',
  PendingApproval = 'PENDING_APPROVAL',
  Scheduled = 'SCHEDULED',
  Sending = 'SENDING',
  Sent = 'SENT'
}

export type NewsletterSubscriber = {
  __typename?: 'NewsletterSubscriber';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status: NewsletterSubscriberStatus;
  subscribedAt: Scalars['DateTime']['output'];
  unsubscribedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type NewsletterSubscriberPaginatedResponse = {
  __typename?: 'NewsletterSubscriberPaginatedResponse';
  data: Array<NewsletterSubscriber>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

/** Subscription state of a newsletter subscriber (SUBSCRIBED, UNSUBSCRIBED) */
export enum NewsletterSubscriberStatus {
  Subscribed = 'SUBSCRIBED',
  Unsubscribed = 'UNSUBSCRIBED'
}

export type NewsletterVersion = {
  __typename?: 'NewsletterVersion';
  aiMetadata?: Maybe<Scalars['JSON']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  newsletterId: Scalars['ID']['output'];
  source: NewsletterVersionSource;
  subject: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

/** How a newsletter version was created (AI, MANUAL) */
export enum NewsletterVersionSource {
  Ai = 'AI',
  Manual = 'MANUAL'
}

export type Notification = {
  __typename?: 'Notification';
  actor?: Maybe<User>;
  actorId?: Maybe<Scalars['ID']['output']>;
  /** Deep-link target for AD_CAMPAIGN_* notifications. Additive. */
  campaignId?: Maybe<Scalars['ID']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyLogoUrl?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  group?: Maybe<Group>;
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  postId?: Maybe<Scalars['ID']['output']>;
  recipient: User;
  recipientId: Scalars['ID']['output'];
  /** Module an ADMIN_NOTIFICATION opens when tapped. Null = not clickable; clients treat unknown values as null. Additive. */
  redirectTarget?: Maybe<BroadcastRedirectTarget>;
  session?: Maybe<Session>;
  sessionId?: Maybe<Scalars['ID']['output']>;
  /** Action status for invite notifications (PENDING / ACCEPTED / REJECTED). Additive for mobile. */
  status?: Maybe<InviteStatus>;
  /** Deep-link target for SUPPORT_TICKET_* notifications. Additive. */
  supportTicketId?: Maybe<Scalars['ID']['output']>;
  type: NotificationType;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Types of notifications */
export enum NotificationType {
  AchievementUnlocked = 'ACHIEVEMENT_UNLOCKED',
  AdminNotification = 'ADMIN_NOTIFICATION',
  AdCampaignApproved = 'AD_CAMPAIGN_APPROVED',
  AdCampaignRejected = 'AD_CAMPAIGN_REJECTED',
  AudioCallRequested = 'AUDIO_CALL_REQUESTED',
  CallAccepted = 'CALL_ACCEPTED',
  CallCancelled = 'CALL_CANCELLED',
  CallMissed = 'CALL_MISSED',
  CallRejected = 'CALL_REJECTED',
  CommentLiked = 'COMMENT_LIKED',
  CommentReplied = 'COMMENT_REPLIED',
  CompanyMessageReply = 'COMPANY_MESSAGE_REPLY',
  CompanyNewMessage = 'COMPANY_NEW_MESSAGE',
  CompanyPost = 'COMPANY_POST',
  CompanyPostCommented = 'COMPANY_POST_COMMENTED',
  CompanyPostLiked = 'COMPANY_POST_LIKED',
  ConnectionAccepted = 'CONNECTION_ACCEPTED',
  ConnectionRequested = 'CONNECTION_REQUESTED',
  CourseEvent = 'COURSE_EVENT',
  Followed = 'FOLLOWED',
  FollowInvite = 'FOLLOW_INVITE',
  GroupInvite = 'GROUP_INVITE',
  GroupInviteDeclined = 'GROUP_INVITE_DECLINED',
  GroupJoinRequest = 'GROUP_JOIN_REQUEST',
  GroupMembershipApproved = 'GROUP_MEMBERSHIP_APPROVED',
  GroupMemberBanned = 'GROUP_MEMBER_BANNED',
  GroupMemberUnbanned = 'GROUP_MEMBER_UNBANNED',
  GroupPostApproved = 'GROUP_POST_APPROVED',
  GroupPostCreated = 'GROUP_POST_CREATED',
  GroupPostRejected = 'GROUP_POST_REJECTED',
  GroupRoleChanged = 'GROUP_ROLE_CHANGED',
  LibraryShared = 'LIBRARY_SHARED',
  LiveStream = 'LIVE_STREAM',
  LiveStreamInvite = 'LIVE_STREAM_INVITE',
  Message = 'MESSAGE',
  NewsletterReadyForReview = 'NEWSLETTER_READY_FOR_REVIEW',
  OccasionPost = 'OCCASION_POST',
  PodcastCommented = 'PODCAST_COMMENTED',
  PodcastLiked = 'PODCAST_LIKED',
  PollEnded = 'POLL_ENDED',
  PostCelebrated = 'POST_CELEBRATED',
  PostCommented = 'POST_COMMENTED',
  PostFunny = 'POST_FUNNY',
  PostInsightful = 'POST_INSIGHTFUL',
  PostLiked = 'POST_LIKED',
  PostLoved = 'POST_LOVED',
  PostSupported = 'POST_SUPPORTED',
  ReelCommented = 'REEL_COMMENTED',
  ReelLiked = 'REEL_LIKED',
  ReviewAnswered = 'REVIEW_ANSWERED',
  RoleChangeApproved = 'ROLE_CHANGE_APPROVED',
  RoleChangeRejected = 'ROLE_CHANGE_REJECTED',
  RoleChangeRequested = 'ROLE_CHANGE_REQUESTED',
  SessionAccepted = 'SESSION_ACCEPTED',
  SessionCancelled = 'SESSION_CANCELLED',
  SessionRequested = 'SESSION_REQUESTED',
  SessionReviewed = 'SESSION_REVIEWED',
  StoryReacted = 'STORY_REACTED',
  SupportTicketAssigned = 'SUPPORT_TICKET_ASSIGNED',
  SupportTicketCreated = 'SUPPORT_TICKET_CREATED',
  SupportTicketInternalNote = 'SUPPORT_TICKET_INTERNAL_NOTE',
  SupportTicketMessage = 'SUPPORT_TICKET_MESSAGE',
  SupportTicketPriorityChanged = 'SUPPORT_TICKET_PRIORITY_CHANGED',
  SupportTicketReopened = 'SUPPORT_TICKET_REOPENED',
  SupportTicketResolved = 'SUPPORT_TICKET_RESOLVED',
  SupportTicketStatusChanged = 'SUPPORT_TICKET_STATUS_CHANGED',
  SupportTicketWaitingForUser = 'SUPPORT_TICKET_WAITING_FOR_USER',
  UserFollowed = 'USER_FOLLOWED',
  UserMentioned = 'USER_MENTIONED',
  VideoCallRequested = 'VIDEO_CALL_REQUESTED',
  Warning = 'WARNING'
}

export type Occasion = {
  __typename?: 'Occasion';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  optimizedImageUrl?: Maybe<Scalars['String']['output']>;
  postId: Scalars['ID']['output'];
  privacy: PostPrivacy;
  title: Scalars['String']['output'];
  translatedDescription?: Maybe<Scalars['String']['output']>;
  translatedTitle?: Maybe<Scalars['String']['output']>;
};

export type OriginalPostSummary = {
  __typename?: 'OriginalPostSummary';
  author?: Maybe<AuthorSummary>;
  contentTokens?: Maybe<Array<Maybe<ContentToken>>>;
  id: Scalars['String']['output'];
  isRepost: Scalars['Boolean']['output'];
  media?: Maybe<Array<Maybe<ActivityMedia>>>;
  postType?: Maybe<Scalars['String']['output']>;
};

export type Overview = {
  __typename?: 'Overview';
  about?: Maybe<Scalars['String']['output']>;
  basicAccount?: Maybe<BasicAccount>;
  contacts?: Maybe<Array<Contact>>;
  educations?: Maybe<Array<Education>>;
  experiences?: Maybe<Array<Experience>>;
  licenses?: Maybe<Array<License>>;
  recentPosts?: Maybe<Array<Post>>;
  skills?: Maybe<Array<SkillModel>>;
};

export type PaginatedAdAdvertiserCandidates = {
  __typename?: 'PaginatedAdAdvertiserCandidates';
  data: Array<AdAdvertiserCandidate>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminDigitalCardInvoices = {
  __typename?: 'PaginatedAdminDigitalCardInvoices';
  data: Array<AdminDigitalCardInvoice>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminDigitalCards = {
  __typename?: 'PaginatedAdminDigitalCards';
  data: Array<AdminDigitalCard>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminInvoices = {
  __typename?: 'PaginatedAdminInvoices';
  data: Array<AdminSubscriptionInvoice>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminPostBoostInvoices = {
  __typename?: 'PaginatedAdminPostBoostInvoices';
  data: Array<AdminPostBoostInvoice>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminPostBoosts = {
  __typename?: 'PaginatedAdminPostBoosts';
  data: Array<AdminPostBoost>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminProfileBoostInvoices = {
  __typename?: 'PaginatedAdminProfileBoostInvoices';
  data: Array<AdminProfileBoostInvoice>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminProfileBoostPurchases = {
  __typename?: 'PaginatedAdminProfileBoostPurchases';
  data: Array<AdminProfileBoostPurchase>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminProfileBoosts = {
  __typename?: 'PaginatedAdminProfileBoosts';
  data: Array<AdminProfileBoost>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAiAgentActions = {
  __typename?: 'PaginatedAiAgentActions';
  items: Array<AiAgentActionModel>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedAiAgents = {
  __typename?: 'PaginatedAiAgents';
  items: Array<AiAgent>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedCampaigns = {
  __typename?: 'PaginatedCampaigns';
  data: Array<Campaign>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedCommissionTransactions = {
  __typename?: 'PaginatedCommissionTransactions';
  data: Array<CommissionTransaction>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedConnectionsType = {
  __typename?: 'PaginatedConnectionsType';
  connections: Array<ConnectionListItemType>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  totalConnections: Scalars['Float']['output'];
};

export type PaginatedMentorPayments = {
  __typename?: 'PaginatedMentorPayments';
  data: Array<MentorPaymentRecord>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedMentors = {
  __typename?: 'PaginatedMentors';
  items: Array<MentorItem>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedPlatformTransactions = {
  __typename?: 'PaginatedPlatformTransactions';
  data: Array<PlatformTransactionRecord>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedPodcastsResponse = {
  __typename?: 'PaginatedPodcastsResponse';
  data: Array<Podcast>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedProfileViewers = {
  __typename?: 'PaginatedProfileViewers';
  items: Array<ProfileViewer>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedRoleChangeRequests = {
  __typename?: 'PaginatedRoleChangeRequests';
  data: Array<RoleChangeRequestModel>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedSessionAuditRecords = {
  __typename?: 'PaginatedSessionAuditRecords';
  data: Array<SessionAuditRecord>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedSessionRefundRequests = {
  __typename?: 'PaginatedSessionRefundRequests';
  data: Array<SessionRefundRequest>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedSponsoredRequests = {
  __typename?: 'PaginatedSponsoredRequests';
  data: Array<SponsoredRequestModel>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedSponsorshipPurchases = {
  __typename?: 'PaginatedSponsorshipPurchases';
  data: Array<AdminSponsorshipPurchaseRow>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedSubscriptionCoupons = {
  __typename?: 'PaginatedSubscriptionCoupons';
  data: Array<SubscriptionCouponGql>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedUserSubscriptions = {
  __typename?: 'PaginatedUserSubscriptions';
  data: Array<UserSubscription>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedUsers = {
  __typename?: 'PaginatedUsers';
  items: Array<User>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationInput = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};

export type PaymentIntentResult = {
  __typename?: 'PaymentIntentResult';
  amount: Scalars['Int']['output'];
  clientSecret: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
  platformFeeAmount: Scalars['Int']['output'];
  publishableKey: Scalars['String']['output'];
  sessionFeeAmount: Scalars['Int']['output'];
};

export enum PaymentProvider {
  Paypal = 'PAYPAL',
  Stripe = 'STRIPE'
}

export type PayoutAccount = {
  __typename?: 'PayoutAccount';
  accountCountry?: Maybe<Scalars['String']['output']>;
  accountEmail?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  businessType?: Maybe<Scalars['String']['output']>;
  businessUrl?: Maybe<Scalars['String']['output']>;
  cardPaymentsStatus?: Maybe<Scalars['String']['output']>;
  chargesEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultCurrency?: Maybe<Scalars['String']['output']>;
  detailsSubmitted: Scalars['Boolean']['output'];
  disconnectedAt?: Maybe<Scalars['DateTime']['output']>;
  externalAccountBankName?: Maybe<Scalars['String']['output']>;
  externalAccountLast4?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPaymentsActive: Scalars['Boolean']['output'];
  isProviderAccountClosed: Scalars['Boolean']['output'];
  mcc?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  payoutsEnabled: Scalars['Boolean']['output'];
  provider: PaymentProvider;
  providerAccountCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  providerAccountId: Scalars['String']['output'];
  requirementsCurrentlyDue: Array<Scalars['String']['output']>;
  requirementsDisabledReason?: Maybe<Scalars['String']['output']>;
  requirementsEventuallyDue: Array<Scalars['String']['output']>;
  requirementsPastDue: Array<Scalars['String']['output']>;
  status: PayoutAccountStatus;
  supportEmail?: Maybe<Scalars['String']['output']>;
  supportPhone?: Maybe<Scalars['String']['output']>;
  transfersStatus?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum PayoutAccountStatus {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
  NotConnected = 'NOT_CONNECTED',
  Onboarding = 'ONBOARDING',
  Restricted = 'RESTRICTED'
}

export type PermissionGql = {
  __typename?: 'PermissionGQL';
  actions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** The status of the subscription plan */
export enum PlanStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type PlatformSettings = {
  __typename?: 'PlatformSettings';
  advertisingHourlyRateCents: Scalars['Int']['output'];
  commissionRate: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  digitalCardPriceCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  paymentGraceDays: Scalars['Int']['output'];
  postBoostHourlyRateCents: Scalars['Int']['output'];
  profileBoostHourlyRateCents: Scalars['Int']['output'];
  trialDays: Scalars['Int']['output'];
  trialEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PlatformTransactionRecord = {
  __typename?: 'PlatformTransactionRecord';
  chargeId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  direction: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  ledgerDescription?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  payeeAmount?: Maybe<Scalars['Float']['output']>;
  payeeName?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  platformFeeAmount?: Maybe<Scalars['Float']['output']>;
  providerInvoiceId?: Maybe<Scalars['String']['output']>;
  refundId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
  transactionType: Scalars['String']['output'];
  type: InvoiceType;
  walletOwner?: Maybe<Scalars['String']['output']>;
};

export type Podcast = {
  __typename?: 'Podcast';
  channelId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  publishedAt: Scalars['DateTime']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
  videoId: Scalars['String']['output'];
};

export type PodcastActivity = {
  __typename?: 'PodcastActivity';
  actorCommentLiked?: Maybe<Scalars['Boolean']['output']>;
  actorId: Scalars['ID']['output'];
  actorLiked?: Maybe<Scalars['Boolean']['output']>;
  changeType: ChangeType;
  comment?: Maybe<PodcastCommentModel>;
  commentId?: Maybe<Scalars['ID']['output']>;
  commentLikesCount?: Maybe<Scalars['Int']['output']>;
  commentsCount?: Maybe<Scalars['Int']['output']>;
  episodeId: Scalars['ID']['output'];
  likesCount?: Maybe<Scalars['Int']['output']>;
  parentCommentId?: Maybe<Scalars['ID']['output']>;
  repliesCount?: Maybe<Scalars['Int']['output']>;
  type: PodcastActivityType;
};

export enum PodcastActivityType {
  CommentAdded = 'COMMENT_ADDED',
  CommentDeleted = 'COMMENT_DELETED',
  CommentLikesChanged = 'COMMENT_LIKES_CHANGED',
  EpisodeLikesChanged = 'EPISODE_LIKES_CHANGED',
  ReplyAdded = 'REPLY_ADDED',
  ReplyDeleted = 'REPLY_DELETED'
}

export type PodcastAuthor = {
  __typename?: 'PodcastAuthor';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Badge the user chose to show beside their name (opt-in, null when none). Batched per request. */
  influenceBadge?: Maybe<AchievementBadge>;
  name: Scalars['String']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
};

export type PodcastCommentModel = {
  __typename?: 'PodcastCommentModel';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  episodeId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isLikedByMe: Scalars['Boolean']['output'];
  likesCount: Scalars['Int']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  replies?: Maybe<Array<PodcastCommentModel>>;
  repliesCount: Scalars['Int']['output'];
  translatedContent?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: PodcastAuthor;
};

export type PodcastCommentsPaginated = {
  __typename?: 'PodcastCommentsPaginated';
  hasMore: Scalars['Boolean']['output'];
  items: Array<PodcastCommentModel>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type PodcastCreator = {
  __typename?: 'PodcastCreator';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  episodesCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  /** Badge the user chose to show beside their name (opt-in, null when none). Batched per request. */
  influenceBadge?: Maybe<AchievementBadge>;
  latestEpisodeAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
};

export type PodcastCreatorsPaginated = {
  __typename?: 'PodcastCreatorsPaginated';
  hasMore: Scalars['Boolean']['output'];
  items: Array<PodcastCreator>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type PodcastEpisodeModel = {
  __typename?: 'PodcastEpisodeModel';
  author?: Maybe<PodcastAuthor>;
  blurHash?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  commentsCount: Scalars['Int']['output'];
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  /** Official embed URL for synced episodes — play via iframe instead of mediaUrl */
  embedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** True while a synced episode is pending the owner's review/publish */
  isHidden: Scalars['Boolean']['output'];
  isLikedByMe: Scalars['Boolean']['output'];
  /** My Library item holding this content for the current user, or null when not saved. */
  libraryItemId?: Maybe<Scalars['ID']['output']>;
  likesCount: Scalars['Int']['output'];
  mediaType: PodcastMediaType;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  playsCount: Scalars['Int']['output'];
  /** Set when synced from an external channel */
  provider?: Maybe<VideoProvider>;
  /** Id of the PodcastSource this episode was synced from, if any */
  sourceId?: Maybe<Scalars['String']['output']>;
  status: PodcastStatus;
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export enum PodcastEpisodeSortBy {
  MostLiked = 'MOST_LIKED',
  Newest = 'NEWEST',
  Oldest = 'OLDEST'
}

export type PodcastEpisodesPaginated = {
  __typename?: 'PodcastEpisodesPaginated';
  hasMore: Scalars['Boolean']['output'];
  items: Array<PodcastEpisodeModel>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export enum PodcastMediaType {
  Audio = 'AUDIO',
  Video = 'VIDEO'
}

export type PodcastPaginatedResponse = {
  __typename?: 'PodcastPaginatedResponse';
  data: Array<Podcast>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PodcastSourceModel = {
  __typename?: 'PodcastSourceModel';
  autoPublish: Scalars['Boolean']['output'];
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  handle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  lastSyncError?: Maybe<Scalars['String']['output']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider: VideoProvider;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type PodcastSourceSyncResult = {
  __typename?: 'PodcastSourceSyncResult';
  created: Scalars['Int']['output'];
  errors: Array<Scalars['String']['output']>;
  sourcesProcessed: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export enum PodcastStatus {
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Ready = 'READY',
  Removed = 'REMOVED'
}

export type Poll = {
  __typename?: 'Poll';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  options: Array<PollOption>;
  question: Scalars['String']['output'];
  translatedOptions?: Maybe<Array<Scalars['String']['output']>>;
  translatedQuestion?: Maybe<Scalars['String']['output']>;
};

export type PollOption = {
  __typename?: 'PollOption';
  id: Scalars['String']['output'];
  isChosen: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  votes: Scalars['Float']['output'];
};

export type Post = {
  __typename?: 'Post';
  activeBoostId?: Maybe<Scalars['String']['output']>;
  article?: Maybe<Article>;
  author: PostAuthor;
  authorId?: Maybe<Scalars['String']['output']>;
  case?: Maybe<CasePostModel>;
  commentReactions?: Maybe<ReactionSummary>;
  commentsCount: Scalars['Float']['output'];
  company?: Maybe<CompanyAuthor>;
  companyAuthor?: Maybe<CompanyAuthor>;
  companyId?: Maybe<Scalars['String']['output']>;
  contentTokens: Array<ContentToken>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Event>;
  group?: Maybe<PostGroup>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isBoosted?: Maybe<Scalars['Boolean']['output']>;
  isPinned: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  isRepost: Scalars['Boolean']['output'];
  isRepostedByMe?: Maybe<Scalars['Boolean']['output']>;
  isSavedByMe: Scalars['Boolean']['output'];
  isScheduled?: Maybe<Scalars['Boolean']['output']>;
  /** My Library item holding this content for the current user, or null when not saved. */
  libraryItemId?: Maybe<Scalars['ID']['output']>;
  mediaUrls: Array<Scalars['String']['output']>;
  occasion?: Maybe<Occasion>;
  optimizedMediaUrls?: Maybe<Array<Scalars['String']['output']>>;
  originalLanguage?: Maybe<Scalars['String']['output']>;
  originalPost?: Maybe<Post>;
  originalPostId?: Maybe<Scalars['String']['output']>;
  poll?: Maybe<Poll>;
  postType: PostType;
  reactions: ReactionSummary;
  repostComment?: Maybe<Scalars['String']['output']>;
  scheduledAt?: Maybe<Scalars['String']['output']>;
  translatedContentTokens?: Maybe<Array<ContentToken>>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PostActivity = {
  __typename?: 'PostActivity';
  actorId: Scalars['ID']['output'];
  actorReaction?: Maybe<Scalars['String']['output']>;
  changeType: ChangeType;
  comment?: Maybe<Comment>;
  commentId?: Maybe<Scalars['ID']['output']>;
  commentsCount?: Maybe<Scalars['Int']['output']>;
  deletedCommentIds?: Maybe<Array<Scalars['ID']['output']>>;
  parentCommentId?: Maybe<Scalars['ID']['output']>;
  postId: Scalars['ID']['output'];
  reactionCounts?: Maybe<Array<ReactionCount>>;
  repliesCount?: Maybe<Scalars['Int']['output']>;
  totalReactions?: Maybe<Scalars['Int']['output']>;
  type: PostActivityType;
};

export enum PostActivityType {
  CommentAdded = 'COMMENT_ADDED',
  CommentDeleted = 'COMMENT_DELETED',
  CommentReactionsChanged = 'COMMENT_REACTIONS_CHANGED',
  CommentUpdated = 'COMMENT_UPDATED',
  PostReactionsChanged = 'POST_REACTIONS_CHANGED',
  ReplyAdded = 'REPLY_ADDED',
  ReplyDeleted = 'REPLY_DELETED',
  ReplyUpdated = 'REPLY_UPDATED'
}

export type PostAuthor = {
  __typename?: 'PostAuthor';
  actionButtons?: Maybe<Array<ActionButton>>;
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  connection?: Maybe<ConnectionStatusModel>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  firstName: Scalars['String']['output'];
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Badge the user chose to show beside their name (opt-in, null when none). Batched per request. */
  influenceBadge?: Maybe<AchievementBadge>;
  isHiring?: Maybe<Scalars['Boolean']['output']>;
  isMentorVerified?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  openToWork?: Maybe<Scalars['Boolean']['output']>;
  profileImageOptimizedUrl?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Role;
  title?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PostBoost = {
  __typename?: 'PostBoost';
  amountCents: Scalars['Int']['output'];
  clicks?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  ctr?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  durationHours: Scalars['Int']['output'];
  durationSeconds: Scalars['Int']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  hourlyRateCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  impressions?: Maybe<Scalars['Int']['output']>;
  invoiceId?: Maybe<Scalars['ID']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  postId: Scalars['ID']['output'];
  remainingDurationSeconds: Scalars['Int']['output'];
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status: PostBoostStatus;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type PostBoostChanged = {
  __typename?: 'PostBoostChanged';
  boost?: Maybe<PostBoost>;
  boostId: Scalars['ID']['output'];
  changeType: ChangeType;
};

export type PostBoostCostPreview = {
  __typename?: 'PostBoostCostPreview';
  amountCents: Scalars['Int']['output'];
  durationHours: Scalars['Int']['output'];
  durationSeconds: Scalars['Int']['output'];
  hourlyRateCents: Scalars['Int']['output'];
};

export type PostBoostDailyStats = {
  __typename?: 'PostBoostDailyStats';
  categories: Array<Scalars['String']['output']>;
  clicks: Array<Scalars['Int']['output']>;
  impressions: Array<Scalars['Int']['output']>;
};

export type PostBoostHourlyRate = {
  __typename?: 'PostBoostHourlyRate';
  hourlyRateCents: Scalars['Int']['output'];
};

export type PostBoostPaymentInit = {
  __typename?: 'PostBoostPaymentInit';
  amountCents: Scalars['Int']['output'];
  clientSecret: Scalars['String']['output'];
  durationSeconds: Scalars['Int']['output'];
  hours: Scalars['Int']['output'];
  packLabel: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
  postBoostId: Scalars['ID']['output'];
  postId: Scalars['ID']['output'];
  publishableKey: Scalars['String']['output'];
};

export enum PostBoostStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Paused = 'PAUSED',
  Pending = 'PENDING'
}

export type PostDetail = {
  __typename?: 'PostDetail';
  author: AuthorSummary;
  contentTokens?: Maybe<Array<Maybe<ContentToken>>>;
  id: Scalars['String']['output'];
  isRepost: Scalars['Boolean']['output'];
  media?: Maybe<Array<Maybe<ActivityMedia>>>;
  originalPost?: Maybe<OriginalPostSummary>;
  postType?: Maybe<Scalars['String']['output']>;
};

export type PostGroup = {
  __typename?: 'PostGroup';
  coverImage?: Maybe<Scalars['String']['output']>;
  coverImageOptimizedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  privacy: Scalars['String']['output'];
  profileImage?: Maybe<Scalars['String']['output']>;
  profileImageOptimizedUrl?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type PostGrowth = {
  __typename?: 'PostGrowth';
  categories: Array<Scalars['String']['output']>;
  series: Array<SeriesData>;
  timeframe: Scalars['String']['output'];
};

export enum PostPrivacy {
  Connections = 'CONNECTIONS',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type PostReactionsPaginated = {
  __typename?: 'PostReactionsPaginated';
  hasMore: Scalars['Boolean']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  reactors: Array<PostReactor>;
  total: Scalars['Int']['output'];
};

export type PostReactor = {
  __typename?: 'PostReactor';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isCurrentUser: Scalars['Boolean']['output'];
  reactionType: ReactionType;
  user: UserBasicInfo;
};

export enum PostTimeFilter {
  Latest = 'LATEST',
  PastMonth = 'PAST_MONTH',
  PastWeek = 'PAST_WEEK',
  PeopleYouFollow = 'PEOPLE_YOU_FOLLOW'
}

/** The type of post (TEXT, ARTICLE, MEDIA, POLL, EVENT) */
export enum PostType {
  Article = 'ARTICLE',
  Case = 'CASE',
  Event = 'EVENT',
  Media = 'MEDIA',
  Occasion = 'OCCASION',
  Poll = 'POLL',
  Text = 'TEXT'
}

export type PostTypeCount = {
  __typename?: 'PostTypeCount';
  count: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type PostTypeStats = {
  __typename?: 'PostTypeStats';
  data: Array<PostTypeCount>;
  total: Scalars['Int']['output'];
};

export type PracticeValuationLead = {
  __typename?: 'PracticeValuationLead';
  collections: Scalars['Float']['output'];
  consentVersion?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  doctorBuyerHigh: Scalars['Float']['output'];
  doctorBuyerLow: Scalars['Float']['output'];
  dsoBuyerHigh: Scalars['Float']['output'];
  dsoBuyerLow: Scalars['Float']['output'];
  email: Scalars['String']['output'];
  /** The server-computed estimate and its math */
  estimate: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  /** The answers the visitor gave (collections, overhead, hygiene, choices) */
  inputs: Scalars['JSON']['output'];
  marketingConsent: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  practiceType: Scalars['String']['output'];
  referrer?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  timing?: Maybe<PracticeValuationTiming>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
};

export type PracticeValuationLeadPaginatedResponse = {
  __typename?: 'PracticeValuationLeadPaginatedResponse';
  data: Array<PracticeValuationLead>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

/** When a practice owner is thinking of selling (NEXT_12_MONTHS, ONE_TO_THREE_YEARS, JUST_CURIOUS) */
export enum PracticeValuationTiming {
  JustCurious = 'JUST_CURIOUS',
  Next_12Months = 'NEXT_12_MONTHS',
  OneToThreeYears = 'ONE_TO_THREE_YEARS'
}

export type PresignedUploadUrl = {
  __typename?: 'PresignedUploadUrl';
  key: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

/** The type of pricing for a service (FIXED, HOURLY, NEGOTIABLE) */
export enum PriceType {
  Fixed = 'FIXED',
  Negotiable = 'NEGOTIABLE'
}

export type Profile = {
  __typename?: 'Profile';
  editable: Scalars['Boolean']['output'];
  headline: Headline;
  /** Influence summary for this profile (points, tier, rank, showcased badges; next achievement when own profile). */
  influence?: Maybe<InfluenceProfileView>;
  overview: Overview;
  status: UserStatus;
};

export type ProfileBoost = {
  __typename?: 'ProfileBoost';
  activeSegmentStartedAt?: Maybe<Scalars['DateTime']['output']>;
  clicks?: Maybe<Scalars['Int']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  consumedActiveSeconds: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  ctr?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  hourlyRateCents: Scalars['Int']['output'];
  hours: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  impressions?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use ProfileBoostPurchase.invoiceId. Will be removed after clients migrate. */
  invoiceId?: Maybe<Scalars['ID']['output']>;
  mentorId: Scalars['ID']['output'];
  packId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use totalPaidCents. Will be removed after clients migrate. */
  priceCents: Scalars['Int']['output'];
  profileVisits?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use ProfileBoostPurchase.provider. Will be removed after clients migrate. */
  provider?: Maybe<Scalars['String']['output']>;
  purchasedDurationSeconds: Scalars['Int']['output'];
  remainingDurationSeconds: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use startedAt. Will be removed after clients migrate. */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status: ProfileBoostStatus;
  totalPaidCents: Scalars['Int']['output'];
  /** @deprecated Use ProfileBoostPurchase.paymentIntentId. Will be removed after clients migrate. */
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type ProfileBoostChanged = {
  __typename?: 'ProfileBoostChanged';
  boost?: Maybe<ProfileBoost>;
  boostId: Scalars['ID']['output'];
  changeType: ChangeType;
};

export type ProfileBoostCostPreview = {
  __typename?: 'ProfileBoostCostPreview';
  amountCents: Scalars['Int']['output'];
  durationHours: Scalars['Int']['output'];
  durationSeconds: Scalars['Int']['output'];
  hourlyRateCents: Scalars['Int']['output'];
};

export type ProfileBoostDailyStats = {
  __typename?: 'ProfileBoostDailyStats';
  categories: Array<Scalars['String']['output']>;
  clicks: Array<Scalars['Int']['output']>;
  impressions: Array<Scalars['Int']['output']>;
  profileVisits: Array<Scalars['Int']['output']>;
};

export type ProfileBoostFeedCard = {
  __typename?: 'ProfileBoostFeedCard';
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mentor: ProfileBoostFeedMentor;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type ProfileBoostFeedMentor = {
  __typename?: 'ProfileBoostFeedMentor';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isMentorVerified?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Role;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProfileBoostHourlyRate = {
  __typename?: 'ProfileBoostHourlyRate';
  hourlyRateCents: Scalars['Int']['output'];
};

export type ProfileBoostPack = {
  __typename?: 'ProfileBoostPack';
  appleProductId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  googleProductId?: Maybe<Scalars['String']['output']>;
  hours: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  priceCents: Scalars['Int']['output'];
  status: PlanStatus;
  stripePriceId?: Maybe<Scalars['String']['output']>;
  stripeProductId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProfileBoostPaymentInit = {
  __typename?: 'ProfileBoostPaymentInit';
  amountCents: Scalars['Int']['output'];
  boostId?: Maybe<Scalars['ID']['output']>;
  clientSecret: Scalars['String']['output'];
  durationSeconds: Scalars['Int']['output'];
  hours: Scalars['Int']['output'];
  packId?: Maybe<Scalars['ID']['output']>;
  packLabel: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
  publishableKey: Scalars['String']['output'];
};

export enum ProfileBoostPurchaseType {
  Extension = 'EXTENSION',
  Initial = 'INITIAL'
}

export enum ProfileBoostStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Paused = 'PAUSED'
}

export type ProfileViewer = {
  __typename?: 'ProfileViewer';
  viewedDate: Scalars['DateTime']['output'];
  viewer: ProfileViewerUser;
};

export type ProfileViewerUser = {
  __typename?: 'ProfileViewerUser';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PublicAdvisor = {
  __typename?: 'PublicAdvisor';
  bio?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PublicDigitalCard = {
  __typename?: 'PublicDigitalCard';
  about?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  canBookSession: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<PublicDigitalCardContact>>;
  country?: Maybe<Scalars['String']['output']>;
  dentmentProfileUrl: Scalars['String']['output'];
  educations?: Maybe<Array<PublicDigitalCardEducation>>;
  email?: Maybe<Scalars['String']['output']>;
  experiences?: Maybe<Array<PublicDigitalCardExperience>>;
  expertise?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  headline?: Maybe<Scalars['String']['output']>;
  isMentorVerified: Scalars['Boolean']['output'];
  mentorId?: Maybe<Scalars['ID']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  professionalRole?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<Array<Scalars['String']['output']>>;
  slug: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type PublicDigitalCardContact = {
  __typename?: 'PublicDigitalCardContact';
  platform: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PublicDigitalCardEducation = {
  __typename?: 'PublicDigitalCardEducation';
  degree: Scalars['String']['output'];
  endYear?: Maybe<Scalars['Int']['output']>;
  fieldOfStudy: Scalars['String']['output'];
  institution: Scalars['String']['output'];
  startYear?: Maybe<Scalars['Int']['output']>;
};

export type PublicDigitalCardExperience = {
  __typename?: 'PublicDigitalCardExperience';
  company?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  isCurrent: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  position: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type PublicServiceItem = {
  __typename?: 'PublicServiceItem';
  category: Scalars['String']['output'];
  createAT: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  location: Scalars['String']['output'];
  postedBy: PublicServicePostedBy;
  title: Scalars['String']['output'];
};

export type PublicServicePaginatedResponse = {
  __typename?: 'PublicServicePaginatedResponse';
  data: Array<PublicServiceItem>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PublicServicePostedBy = {
  __typename?: 'PublicServicePostedBy';
  avatar?: Maybe<Scalars['String']['output']>;
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type PublicSponsoredAdvisor = {
  __typename?: 'PublicSponsoredAdvisor';
  bio?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  planName?: Maybe<Scalars['String']['output']>;
};

export type PurchaseCampaignWithStoreInput = {
  campaignId: Scalars['String']['input'];
  packId: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  purchaseToken?: InputMaybe<Scalars['String']['input']>;
  purchaseType?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseProfileBoostInput = {
  packId: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  purchaseToken?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseProfileBoostResult = {
  __typename?: 'PurchaseProfileBoostResult';
  alreadyProcessed?: Maybe<Scalars['Boolean']['output']>;
  boost?: Maybe<ProfileBoost>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  PaginatedPodcasts: PaginatedPodcastsResponse;
  accessibleCommunities: Array<Community>;
  achievementDetails: AchievementProgressView;
  activeAdDurationPacks: Array<AdDurationPack>;
  /** Public list of active advisors for the landing page */
  activeAdvisors: Array<PublicAdvisor>;
  activePlans: Array<SubscriptionPlan>;
  activeProfileBoostPacks: Array<ProfileBoostPack>;
  activeUsersStats: ActiveUsersStats;
  adminAchievementDefinitions: Array<AdminAchievementDefinition>;
  /** Users an admin can run an ad as — industry partners first, with eligibility flags (partners need an active subscription) */
  adminAdAdvertiserCandidates: PaginatedAdAdvertiserCandidates;
  adminAdDurationPacks: Array<AdDurationPack>;
  adminAllCampaigns: PaginatedCampaigns;
  adminAllDigitalCards: PaginatedAdminDigitalCards;
  adminAllInvoices: PaginatedAdminInvoices;
  adminAllPlans: Array<SubscriptionPlan>;
  adminAllProfileBoosts: PaginatedAdminProfileBoosts;
  adminAllSubscriptions: PaginatedUserSubscriptions;
  adminBillingPeriodStats: BillingPeriodStats;
  adminBoostedPosts: PaginatedAdminPostBoosts;
  adminBroadcast: AdminBroadcast;
  adminBroadcastFailures: AdminBroadcastFailurePage;
  adminBroadcastUsersByIds: Array<BroadcastUserOption>;
  adminBroadcasts: AdminBroadcastPage;
  adminCampaignById: Campaign;
  adminCampaignChartData: CampaignChartData;
  adminCampaignPayments: Array<CampaignPurchaseRecord>;
  adminCampaignStats: CampaignStats;
  adminCommissionStats: AdminCommissionStats;
  adminCommissionTransactions: PaginatedCommissionTransactions;
  adminCuratedReel: AdminCuratedReelModel;
  /** Paginated curated reels (admin). Filter by provider / visibility / source. */
  adminCuratedReels: AdminCuratedReelsPaginatedResponse;
  adminDigitalCardById: AdminDigitalCard;
  adminDigitalCardInvoices: PaginatedAdminDigitalCardInvoices;
  adminDigitalCardStats: AdminDigitalCardStats;
  adminFlaggedInfluenceEvents: AdminInfluenceEventPage;
  /** Get a single RSS source by ID (admin) */
  adminGetRssSource: RssSource;
  /** Get all RSS sources (admin) */
  adminGetRssSources: Array<RssSource>;
  adminInfluenceAuditLogs: AdminInfluenceAuditLogPage;
  adminInfluenceConfig: AdminInfluenceConfig;
  adminInfluenceConfigHistory: AdminInfluenceConfigPage;
  adminInfluenceLeaderboard: AdminLeaderboardPage;
  adminInfluenceLedger: AdminInfluenceEventPage;
  adminInfluenceOutbox: AdminOutboxPage;
  adminInfluenceOverview: AdminInfluenceOverview;
  adminInfluenceUser: AdminInfluenceUser;
  adminKnowledgeArticle: KnowledgeArticle;
  adminKnowledgeArticles: KnowledgeArticleConnection;
  adminLoanCalculatorLead: LoanCalculatorLead;
  adminLoanCalculatorLeads: LoanCalculatorLeadPaginatedResponse;
  adminLogEntityTypes: Array<Scalars['String']['output']>;
  adminLogs: AdminLogListResult;
  adminPendingTrialSummary?: Maybe<AdminPendingTrialSummary>;
  adminPlatformEarningsStats: AdminPlatformEarningsStats;
  adminPlatformTransactions: PaginatedPlatformTransactions;
  adminPostBoostById: AdminPostBoost;
  adminPostBoostChartData: AdminPostBoostChartData;
  adminPostBoostDurationPerformance: Array<AdminPostBoostDurationPerformance>;
  adminPostBoostEarnings: AdminPostBoostEarnings;
  adminPostBoostInvoices: PaginatedAdminPostBoostInvoices;
  adminPostBoostStats: AdminPostBoostStats;
  adminPostBoostStatusStats: Array<AdminPostBoostStatusStat>;
  adminPracticeValuationLead: PracticeValuationLead;
  adminPracticeValuationLeads: PracticeValuationLeadPaginatedResponse;
  adminPreviewBroadcastAudience: BroadcastAudiencePreview;
  adminProfileBoostById: AdminProfileBoost;
  adminProfileBoostChartData: AdminProfileBoostChartData;
  adminProfileBoostEarnings: AdminProfileBoostEarnings;
  adminProfileBoostInvoices: PaginatedAdminProfileBoostInvoices;
  adminProfileBoostPacks: Array<ProfileBoostPack>;
  adminProfileBoostPayments: Array<AdminProfileBoostPurchase>;
  adminProfileBoostPurchases: PaginatedAdminProfileBoostPurchases;
  adminProfileBoostStats: AdminProfileBoostStats;
  adminReconcileInfluence: AdminReconciliationReport;
  /** Get a role change request by id (admin) */
  adminRoleChangeRequest: RoleChangeRequestModel;
  adminSearchBroadcastUsers: Array<BroadcastUserOption>;
  adminSearchInfluenceUsers: Array<AdminInfluenceUserSearchResult>;
  adminSessionAuditLog: PaginatedSessionAuditRecords;
  adminSessionRefundRequests: PaginatedSessionRefundRequests;
  adminSigningDocument: SigningDocumentEntity;
  adminSigningDocuments: SigningDocumentsListResult;
  /** The current/featured event, if one has been created (admin) */
  adminSponsorshipEvent?: Maybe<AdminSponsorshipEvent>;
  adminSponsorshipPlan: AdminSponsorshipPlan;
  adminSponsorshipPlans: Array<AdminSponsorshipPlan>;
  adminSponsorshipPurchase: AdminSponsorshipPurchaseDetail;
  adminSponsorshipPurchases: PaginatedSponsorshipPurchases;
  adminStripeAccountStatus: AdminStripeStatus;
  adminSubscriptionStats: AdminSubscriptionStats;
  adminSupportAgents: Array<AdminSupportAgent>;
  adminSupportCategories: Array<AdminSupportCategory>;
  adminSupportDashboard: SupportDashboard;
  adminSupportTicket: AdminSupportTicket;
  adminSupportTickets: AdminSupportTicketConnection;
  adminSupportUserContext: AdminSupportUserContext;
  adminTopPerformingAds: Array<Campaign>;
  adminTopPerformingProfileBoosts: Array<AdminProfileBoost>;
  adminVideoSource: VideoSourceModel;
  /** Paginated curated-reel sources (admin). */
  adminVideoSources: VideoSourcesPaginatedResponse;
  advertisingHourlyRate: AdvertisingHourlyRate;
  advertisingHourlyRateCents: Scalars['Int']['output'];
  /** Get advisor by id (admin) */
  advisor: Advisor;
  /** All advisor display-order slots for the create/edit form */
  advisorSlots: Array<AdvisorSlot>;
  /** Paginated advisors (admin). Filter by query (name/bio) and isActive. */
  advisors: AdvisorsPaginatedResponse;
  aiAgent: AiAgent;
  /** Section 47/48 — the audit trail for one agent, or all agents. */
  aiAgentActions: PaginatedAiAgentActions;
  /** Section 60 — actions awaiting admin approval (REQUIRE_APPROVAL mode). */
  aiAgentPendingApprovals: PaginatedAiAgentActions;
  aiAgentPoolConfig: AiAgentPoolConfigModel;
  /** Dashboard summary — Section 47. */
  aiAgentPoolOverview: AiAgentPoolOverview;
  aiAgents: PaginatedAiAgents;
  /** Get all categories with their subcategories */
  allCategories: Array<CourseCategory>;
  /** Get all categories with their children */
  allCategoriesWithChildren: Array<CourseCategory>;
  /** Get all courses (course details only, no nested modules) with pagination in descending order */
  allCourses: AllCoursesPaginatedResponse;
  allGroups: GroupListResult;
  allNewUsers: PaginatedUsers;
  allServices: ServicePaginatedResponse;
  allServicesForAdmin: ServicePaginatedResponse;
  allSessions: Array<Session>;
  allowedRoleChangeTargets: Array<Role>;
  allusers: PaginatedUsers;
  apiRequestLog?: Maybe<ApiRequestLog>;
  apiRequestLoggingEnabled: Scalars['Boolean']['output'];
  apiRequestLogs: ApiRequestLogListResult;
  apiRequestStats: ApiRequestStats;
  /** Client bootstrap config: version compatibility, maintenance, and enabled feature flags. */
  appConfig: AppConfig;
  article: Article;
  articleBySlug: Article;
  articles: Array<Article>;
  availability: Availability;
  booking: Booking;
  bookings: Array<Booking>;
  campaignById: Campaign;
  campaignDailyStats: CampaignChartData;
  campaignPurchases: Array<CampaignPurchaseRecord>;
  /** Get all categories and subcategories (optionally by parentId) */
  categories: Array<CourseCategory>;
  /** Get a single category or subcategory by ID */
  category: CourseCategory;
  /** Provider/category facets for ceCourses. Public. */
  ceCourseFilters: CeCourseFilters;
  /** External CE courses (Dentaltown, Dentalcare, …), page-paginated. Public. */
  ceCourses: CeCoursePage;
  checkCouponAvailability: CouponAvailabilityResponse;
  checkSignupAvailability: SignupAvailability;
  company?: Maybe<Company>;
  companyBlockedFollowers: CompanyFollowersPaginated;
  companyFollowers: CompanyFollowersPaginated;
  companyPosts: Array<Post>;
  /** Get all courses completed by the current user with pagination */
  completedCourses: AllCoursesPaginatedResponse;
  coupon: Coupon;
  couponByServiceId: Coupon;
  couponDetailWithUsers: CouponDetailWithUsers;
  couponRedemptionsByCouponId: CouponRedemptionsResponse;
  couponStats: Array<CouponStats>;
  coupons: Array<Coupon>;
  /** Get a single course with all nested content (modules, lectures, quizzes, documents) */
  course: Course;
  /** Get lecture and quiz stats for a course (views and pass percentages) */
  courseContentStats: CourseContentStatsResponse;
  /** Get detailed course information for users including all modules, lectures, quizzes, documents, and instructor details */
  courseDetail: CourseDetail;
  /** Get detailed course view with all modules, lectures, quizzes, documents and user progress */
  courseDetailWithProgress: CourseDetailWithProgress;
  /** Get total students in a course (active, completed, and total) by course ID */
  courseStudentStats: StatsResponse;
  cronJobStatuses: Array<CronJobStatus>;
  digitalCardPriceCents: Scalars['Int']['output'];
  discoverGroups: Array<Group>;
  downloadSignedSigningDocument: SigningDownloadUrl;
  /** Get courses enrolled by the current user with progress tracking */
  enrolledCourses: EnrolledCoursePaginatedResponse;
  /** Get enrolled students by course with pagination and progress/completion stats */
  enrolledStudentsByCourseAndMonth: EnrolledStudentStatsPaginatedResponse;
  /** Field/kind/country/state/month facets and upcoming paper deadlines for externalEvents. Public. */
  externalEventFilters: ExternalEventFilters;
  /** Upcoming events from dental associations and open conference datasets, page-paginated. Public. */
  externalEvents: ExternalEventPage;
  /** Mentors with an active Profile Boost (for featured placements) */
  featuredMentors: Array<MentorSearchResult>;
  feed: FeedResponse;
  /** Get filters for quizzes: categories, 2 instructors, reviews, and levels with course counts */
  filters: FiltersResponseEntity;
  /** Get all livestreams */
  findAllLiveStreams: Array<LiveStream>;
  findExistingConversation?: Maybe<Conversation>;
  getAcceptedConnections: Array<ConnectionListItemType>;
  getActionButtonByCompanyId?: Maybe<ActionButton>;
  getActionButtonsByUserId: Array<ActionButton>;
  getAdminNotification: Array<Notification>;
  getAllAdminUsers: Array<UserGql>;
  getAllCommentsByUserPosts: Array<GetUserAllComments>;
  getAllEvents: EventsConnection;
  getAllImagesByUser: Array<ActivityMedia>;
  getAllLegalInstructions: Array<LegalInstruction>;
  getAllMentors: PaginatedMentors;
  getAllReviewsOfMentor: Array<Review>;
  getAllRoles: Array<PermissionGql>;
  /** Get all RSS feeds with pagination */
  getAllRssFeeds: RssPaginatedResponse;
  getAllSourceCompanies: SourceCompaniesPaginatedResponse;
  getAllVideosByUser: Array<ActivityMedia>;
  getCaseByPostId?: Maybe<CasePostModel>;
  getCommentReplies: Array<Comment>;
  getCompanyFollowersCount: Scalars['Int']['output'];
  getCompanyInbox: CompanyInboxResponse;
  getCompanyPages: CompanyPagesPaginated;
  getConnectedUsersStories: Array<Story>;
  getConnectionByUserId: ConnectionListItemType;
  getConnectionRequests: PaginatedConnectionsType;
  getConnectionStatus: ConnectionStatusType;
  getConnections: PaginatedConnectionsType;
  getConversationMessages: Conversation;
  getEventById: Event;
  getEventByPostId?: Maybe<Event>;
  getEventsByCourseId: EventsConnection;
  /** Get a specific FAQ by ID */
  getFaq: Faq;
  getFollowedCompanies: Array<Company>;
  getFollowedCompanyIds: Array<Scalars['String']['output']>;
  getGroupRoleIds: GroupRoleIds;
  getIsHiring: Scalars['Boolean']['output'];
  getJoinedEvents: EventsConnection;
  getJoinedPeopleByEventId: Array<User>;
  /** Get latest RSS feeds */
  getLatestRssFeeds: Array<RssFeed>;
  getLegalInstruction?: Maybe<LegalInstruction>;
  getLinkPreview?: Maybe<LinkPreview>;
  /** Get livestream details by roomId */
  getLiveStream: LiveStream;
  getMemberPermissions: MemberPermissions;
  getMentorAvailableSlots: Array<TimeRange>;
  /** Get all FAQs for a specific mentor */
  getMentorFaqs: FaqResponse;
  getMentorViewerAvailabilityCalendar: MentorViewerAvailabilityCalendar;
  getMyEvents: EventsConnection;
  /** Get authenticated mentor's own FAQs */
  getMyFaqs: FaqResponse;
  getMyReels: Array<ReelModel>;
  getOccasionByPostId: Occasion;
  getOpenToWork: Scalars['Boolean']['output'];
  getPollByPostId?: Maybe<Poll>;
  getPost: Post;
  getPostById: PostDetail;
  getProfile: Profile;
  getProfileViewers: PaginatedProfileViewers;
  getProfileViewsLast7Days: Scalars['Int']['output'];
  getRecommendedGroups: Array<GroupPreview>;
  getReelCommentReplies: ReelCommentsPaginated;
  getReelComments: ReelCommentsPaginated;
  getReelsByUserId: ReelsPaginated;
  getReelsFeed: Array<ReelModel>;
  /** Get RSS feed by ID */
  getRssFeedById: RssFeed;
  /** Get RSS feeds by source with pagination */
  getRssFeedsBySource: RssPaginatedResponse;
  getRssFilters: Array<Scalars['String']['output']>;
  getRssSourceByName?: Maybe<RssSource>;
  getSavedPosts: SavedPostsPaginated;
  getSavedRssFeeds: Array<RssFeed>;
  getScheduledPosts: Array<Post>;
  getSourceCompany?: Maybe<SourceCompany>;
  getSources: Array<RssSource>;
  getStoryReactors: Array<StoryReactionUser>;
  getStoryViewCount: Scalars['Float']['output'];
  getStoryViewers: Array<StoryViewer>;
  getSuggestedCompanies: Array<Company>;
  getSuggestedProfiles: Array<User>;
  getTopLevelComments: Array<Comment>;
  getTotalSavedArticles: Scalars['Int']['output'];
  getTotalSavedRssFeeds: Scalars['Int']['output'];
  getTrendingGroups: Array<GroupPreview>;
  getUserBasicInfo?: Maybe<UserBasicInfo>;
  getUserCommunityPosts: Array<Post>;
  getUserConversations: Array<Conversation>;
  getUserDetailForAdmin?: Maybe<User>;
  getUserHeadline?: Maybe<Scalars['String']['output']>;
  getUserNotification: Array<Notification>;
  getUserPosts: Array<Post>;
  getUserStories: Array<Story>;
  googleCalendarAuthUrl: GoogleCalendarAuthUrl;
  googleCalendarConnection: GoogleCalendarConnectionStatus;
  googleCalendarEvents: Array<GoogleCalendarEvent>;
  /** @deprecated Use groupFeed for cursor-paginated mixed wall. Returns first page only. */
  groupApprovedPosts: Array<Post>;
  groupBannedMembers: Array<GroupMembership>;
  groupById?: Maybe<Group>;
  groupFeed: FeedResponse;
  groupGrowth: AdminGroupGrowthResult;
  groupMembers: Array<GroupMembership>;
  groupPendingInvites: Array<GroupInvite>;
  groupPendingJoinRequests: Array<GroupMembership>;
  groupPendingPosts: Array<Post>;
  groupPosts: Array<Post>;
  growNetwork: Array<User>;
  influenceProfile: InfluenceProfileView;
  influenceStatus: InfluenceStatus;
  invoice?: Maybe<BillingInvoice>;
  isAvailableForReview: Scalars['Boolean']['output'];
  isFollowingCompany: Scalars['Boolean']['output'];
  isMentorVerified: Scalars['Boolean']['output'];
  /** Single DDS Recruit listing. Apply using applyUrl on DDS Recruit. */
  job: JobListing;
  /** Controlled vocabularies for Jobs filters */
  jobFilterOptions: JobFilterOptions;
  /** Paginated DDS Recruit job listings for the Jobs page */
  jobs: JobsPaginatedResponse;
  /** One published article by slug. */
  knowledgeArticle: KnowledgeArticle;
  /** Published help-centre articles, with optional keyword/category filtering. */
  knowledgeArticles: KnowledgeArticleConnection;
  leaderboard: LeaderboardPage;
  libraryEntries: LibraryEntryPage;
  libraryShareMembers: Array<LibraryShareMember>;
  me: User;
  mentorAvailabilities: MentorAvailabilityWithDayOff;
  myAchievementProgress: Array<AchievementProgressView>;
  myActiveProfileBoost?: Maybe<ProfileBoost>;
  /** Fetch one of the authenticated user’s AI conversations (escalation state, etc.). */
  myAiConversation: AiConversationModel;
  myArticles: Array<Article>;
  myBannerImage?: Maybe<Scalars['String']['output']>;
  myCampaignChartData: CampaignChartData;
  myCampaignStats: CampaignStats;
  myCampaigns: PaginatedCampaigns;
  myCompanies: Array<Company>;
  myCompaniesByOwner: Array<Company>;
  myConnectionCount?: Maybe<Scalars['Int']['output']>;
  /** Get my courses (as instructor) with pagination */
  myCourses: CoursePaginatedResponse;
  myDigitalCard?: Maybe<MyDigitalCard>;
  myGroups: Array<Group>;
  myGroupsWithPendingRequests: Array<Group>;
  myInfluenceProfile: InfluenceProfileView;
  myInvoices: Array<SubscriptionInvoice>;
  myLibraryCollection: LibraryCollectionModel;
  myLibraryCollections: Array<LibraryCollectionModel>;
  myLibraryFolder: LibraryFolderModel;
  myLibraryFolders: Array<LibraryFolderModel>;
  myLibraryItem: LibraryItemModel;
  myLibraryItems: LibraryItemPage;
  myLibraryStats: LibraryStats;
  myLibraryTags: Array<LibraryTagModel>;
  /** Recycle bin: folders and collections deleted in the last 30 days. */
  myLibraryTrash: LibraryTrash;
  myMentorEarningsStats: MentorEarningsStats;
  myMentorPayments: PaginatedMentorPayments;
  myOwnedGroupsCount: Scalars['Int']['output'];
  myPayoutAccount?: Maybe<PayoutAccount>;
  myPendingGroupInvite?: Maybe<GroupInvite>;
  myPendingGroupInvites: Array<GroupInvite>;
  myPermissions: PermissionGql;
  myPostBoosts: Array<PostBoost>;
  myProfileBoosts: Array<ProfileBoost>;
  myProfileViewsLast7Days?: Maybe<Scalars['Int']['output']>;
  /** Get the authenticated user personal referral campaign */
  myReferralCampaign?: Maybe<ReferralCampaign>;
  myRoleChangeRequests: Array<RoleChangeRequestModel>;
  myServices: ServicePaginatedResponse;
  myStripeProfile?: Maybe<PayoutAccount>;
  mySubscription?: Maybe<UserSubscription>;
  /** The authenticated user's support tickets, newest activity first. */
  mySupportTickets: SupportTicketConnection;
  myTopPerformingAds: Array<Campaign>;
  myTrashedLibraryFolders: Array<LibraryFolderModel>;
  myWallet?: Maybe<BillingWallet>;
  newsletter: Newsletter;
  newsletterAutomation?: Maybe<NewsletterAutomation>;
  newsletterRecipients: NewsletterRecipientPaginatedResponse;
  newsletterSubscriber: NewsletterSubscriber;
  newsletterSubscribers: NewsletterSubscriberPaginatedResponse;
  newsletterVersions: Array<NewsletterVersion>;
  newsletters: NewsletterPaginatedResponse;
  paginatedDiscoverGroups: DiscoverGroupsResponse;
  /** List role change requests for admin review (filterable) */
  pendingRoleChangeRequests: PaginatedRoleChangeRequests;
  platformCommissionRate: Scalars['Float']['output'];
  platformEarningsChart: ChartData;
  platformSettings: PlatformSettings;
  platformStripePublishableKey?: Maybe<Scalars['String']['output']>;
  podcast: Podcast;
  /** @deprecated Superseded by podcastComments, which now embeds each comment's replies directly. */
  podcastCommentReplies: PodcastCommentsPaginated;
  podcastComments: PodcastCommentsPaginated;
  podcastCreators: PodcastCreatorsPaginated;
  podcastEpisode: PodcastEpisodeModel;
  podcastEpisodes: PodcastEpisodesPaginated;
  podcastEpisodesByUser: PodcastEpisodesPaginated;
  podcastSources: Array<PodcastSourceModel>;
  podcasts: PodcastPaginatedResponse;
  postBoost: PostBoost;
  postBoostDailyStats: PostBoostDailyStats;
  postBoostHourlyRate: PostBoostHourlyRate;
  postBoostHourlyRateCents: Scalars['Int']['output'];
  postGrowth: PostGrowth;
  /** Who reacted to a post — cursor paginated, viewer first. */
  postReactions: PostReactionsPaginated;
  postTypeStats: PostTypeStats;
  previewCampaignCost: CampaignCostPreview;
  previewPostBoostCost: PostBoostCostPreview;
  previewProfileBoostCost: ProfileBoostCostPreview;
  previewUpgradeCheckout: UpgradeCheckoutPreview;
  profileBoostById: ProfileBoost;
  profileBoostDailyStats: ProfileBoostDailyStats;
  profileBoostHourlyRate: ProfileBoostHourlyRate;
  profileBoostHourlyRateCents: Scalars['Int']['output'];
  publicDigitalCard?: Maybe<PublicDigitalCard>;
  publicServices: PublicServicePaginatedResponse;
  /** Get the attempt status and data for a quiz by quizId and enrollmentId */
  quizAttemptStatus: QuizAttemptStatusResponse;
  recipientSigningLink: Scalars['String']['output'];
  /** Look up a referral campaign by code */
  referralByCode?: Maybe<ReferralCampaign>;
  /** Admin: list referral campaigns */
  referralCampaigns: ReferralCampaignsResponse;
  /** Admin: list referral signups */
  referralSignups: ReferralSignupsResponse;
  relatedPages: Array<Company>;
  reportedPosts: ReportedPostResult;
  reportsByPost: Array<ReportDetail>;
  roleChangeRequest: RoleChangeRequestModel;
  roleChangeRequestStatus: Scalars['String']['output'];
  savedArticles: Array<Article>;
  scheduling: Scheduling;
  schedulings: Array<Scheduling>;
  search: SearchResults;
  searchApprovedConnectionsByLetter: Array<Search>;
  searchCompanies: Array<CompanyPreview>;
  searchGroups: Array<GroupPreview>;
  searchGroupsByName: Array<GroupPreview>;
  searchLibraryShareUsers: Array<LibraryShareCandidate>;
  searchMentors: Array<MentorSearchResult>;
  /** Search all of My Library: saved items (filed or not), my folders and collections, and ones shared with me. */
  searchMyLibrary: LibrarySearchPage;
  searchPreview: SearchPreview;
  searchUserOrPost: SearchUserOrPostOutput;
  searchUsers: Array<Search>;
  searchUsersByName: Array<User>;
  service: Service;
  serviceReports: ServiceReportPaginatedResponse;
  serviceStats: ServiceStatsResponse;
  services: Array<Service>;
  sharedWithMeLibrary: LibrarySharedWithMe;
  signingDocumentActivity: Array<SigningActivityEntity>;
  signingTemplates: Array<SigningTemplateEntity>;
  similarServices: Array<Service>;
  /** Public list of approved sponsored advisors */
  sponsoredAdvisors: Array<PublicSponsoredAdvisor>;
  /** Get a sponsored advisor request by id (admin) */
  sponsoredRequest: SponsoredRequestModel;
  /** List sponsored advisor requests for admin review */
  sponsoredRequests: PaginatedSponsoredRequests;
  /** The current/featured event, if any — shown on the home page and /sponsorship */
  sponsorshipEvent?: Maybe<SponsorshipEventModel>;
  sponsorshipOverview: SponsorshipOverview;
  /** Active sponsorship plans for the public /sponsorship page */
  sponsorshipPlans: Array<SponsorshipPlanModel>;
  /** Payment + approval status for a sponsorship purchase reference */
  sponsorshipPurchaseStatus: SponsorshipPurchaseStatusModel;
  subscriptionCoupon: SubscriptionCouponGql;
  subscriptionCoupons: PaginatedSubscriptionCoupons;
  /** Get suggested courses by instructor ID (max 3 courses) */
  suggestedCourses: SuggestedCoursesResponse;
  suggestedPodcasts: Array<PodcastEpisodeModel>;
  /** Active support categories for the Create Ticket form. */
  supportCategories: Array<SupportCategory>;
  /** One of the authenticated user’s tickets, with its full visible conversation. */
  supportTicket: SupportTicket;
  /** Get active ads targeted at the current user */
  targetedAds: Array<Campaign>;
  totalUsers: TotalUsersStats;
  trialConfig: TrialConfigResult;
  universityCommunities: UniversityCommunityResult;
  universityGroup?: Maybe<UniversityGroup>;
  universityGroupMessages: Array<UniversityGroupMessage>;
  userAchievements: Array<UserAchievementView>;
  userConfirmedOrCompletedSessionCount: Scalars['Int']['output'];
  userConnectionCount: Scalars['Int']['output'];
  userGrowthChart: ChartData;
  usersByCountry: Array<CountryUsersStats>;
  validateSubscriptionCoupon: SubscriptionCouponValidationResult;
};


export type QueryPaginatedPodcastsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAchievementDetailsArgs = {
  key: Scalars['String']['input'];
};


export type QueryAdminAdAdvertiserCandidatesArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminAllCampaignsArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  source?: InputMaybe<CampaignSource>;
  status?: InputMaybe<CampaignStatus>;
};


export type QueryAdminAllDigitalCardsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminAllInvoicesArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminAllProfileBoostsArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProfileBoostStatus>;
};


export type QueryAdminAllSubscriptionsArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminBillingPeriodStatsArgs = {
  period?: Scalars['String']['input'];
};


export type QueryAdminBoostedPostsArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PostBoostStatus>;
};


export type QueryAdminBroadcastArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminBroadcastFailuresArgs = {
  input: BroadcastFailuresInput;
};


export type QueryAdminBroadcastUsersByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryAdminBroadcastsArgs = {
  input: BroadcastListInput;
};


export type QueryAdminCampaignByIdArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryAdminCampaignChartDataArgs = {
  range?: Scalars['String']['input'];
  source?: InputMaybe<CampaignSource>;
};


export type QueryAdminCampaignPaymentsArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryAdminCampaignStatsArgs = {
  source?: InputMaybe<CampaignSource>;
};


export type QueryAdminCommissionTransactionsArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  paymentStatus?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminCuratedReelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminCuratedReelsArgs = {
  input?: InputMaybe<GetCuratedReelsInput>;
};


export type QueryAdminDigitalCardByIdArgs = {
  cardId: Scalars['ID']['input'];
};


export type QueryAdminDigitalCardInvoicesArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  status?: InputMaybe<InvoiceStatus>;
};


export type QueryAdminFlaggedInfluenceEventsArgs = {
  input: AdminPageInput;
};


export type QueryAdminGetRssSourceArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdminInfluenceAuditLogsArgs = {
  input: AdminAuditLogInput;
};


export type QueryAdminInfluenceConfigHistoryArgs = {
  input: AdminPageInput;
};


export type QueryAdminInfluenceLeaderboardArgs = {
  input: AdminLeaderboardInput;
};


export type QueryAdminInfluenceLedgerArgs = {
  input: AdminLedgerInput;
};


export type QueryAdminInfluenceOutboxArgs = {
  input: AdminOutboxInput;
};


export type QueryAdminInfluenceUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAdminKnowledgeArticleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminKnowledgeArticlesArgs = {
  input?: InputMaybe<AdminKnowledgeArticleListInput>;
};


export type QueryAdminLoanCalculatorLeadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminLoanCalculatorLeadsArgs = {
  input?: InputMaybe<GetLoanCalculatorLeadsInput>;
};


export type QueryAdminLogsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminPendingTrialSummaryArgs = {
  userId: Scalars['String']['input'];
};


export type QueryAdminPlatformTransactionsArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminPostBoostByIdArgs = {
  boostId: Scalars['ID']['input'];
};


export type QueryAdminPostBoostChartDataArgs = {
  range?: Scalars['String']['input'];
};


export type QueryAdminPostBoostEarningsArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryAdminPostBoostInvoicesArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  status?: InputMaybe<InvoiceStatus>;
};


export type QueryAdminPracticeValuationLeadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminPracticeValuationLeadsArgs = {
  input?: InputMaybe<GetPracticeValuationLeadsInput>;
};


export type QueryAdminPreviewBroadcastAudienceArgs = {
  audience: BroadcastAudienceInput;
};


export type QueryAdminProfileBoostByIdArgs = {
  boostId: Scalars['ID']['input'];
};


export type QueryAdminProfileBoostChartDataArgs = {
  range?: Scalars['String']['input'];
};


export type QueryAdminProfileBoostEarningsArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryAdminProfileBoostInvoicesArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  status?: InputMaybe<InvoiceStatus>;
};


export type QueryAdminProfileBoostPaymentsArgs = {
  boostId: Scalars['ID']['input'];
};


export type QueryAdminProfileBoostPurchasesArgs = {
  boostId?: InputMaybe<Scalars['ID']['input']>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminReconcileInfluenceArgs = {
  input: AdminReconcileInput;
};


export type QueryAdminRoleChangeRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdminSearchBroadcastUsersArgs = {
  query: Scalars['String']['input'];
};


export type QueryAdminSearchInfluenceUsersArgs = {
  query: Scalars['String']['input'];
};


export type QueryAdminSessionAuditLogArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  paymentStatus?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminSessionRefundRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminSigningDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminSigningDocumentsArgs = {
  filters?: InputMaybe<SigningDocumentsFilterInput>;
};


export type QueryAdminSponsorshipPlanArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdminSponsorshipPurchaseArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdminSponsorshipPurchasesArgs = {
  input?: InputMaybe<AdminSponsorshipPurchaseFilterInput>;
};


export type QueryAdminSupportTicketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminSupportTicketsArgs = {
  filter?: InputMaybe<AdminSupportTicketsFilterInput>;
};


export type QueryAdminSupportUserContextArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAdminTopPerformingAdsArgs = {
  limit?: Scalars['Int']['input'];
  source?: InputMaybe<CampaignSource>;
};


export type QueryAdminTopPerformingProfileBoostsArgs = {
  limit?: Scalars['Int']['input'];
};


export type QueryAdminVideoSourceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminVideoSourcesArgs = {
  input?: InputMaybe<GetVideoSourcesInput>;
};


export type QueryAdvisorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdvisorsArgs = {
  input?: InputMaybe<GetAdvisorsInput>;
};


export type QueryAiAgentArgs = {
  agentId: Scalars['ID']['input'];
};


export type QueryAiAgentActionsArgs = {
  input?: InputMaybe<GetAiAgentActionsInput>;
};


export type QueryAiAgentPendingApprovalsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAiAgentsArgs = {
  input?: InputMaybe<GetAiAgentsInput>;
};


export type QueryAllCoursesArgs = {
  pagination?: InputMaybe<GetAllCoursesInput>;
};


export type QueryAllGroupsArgs = {
  filter?: InputMaybe<GroupStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllNewUsersArgs = {
  input?: InputMaybe<GetNewUsersInput>;
};


export type QueryAllServicesArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxPrice?: InputMaybe<Scalars['Int']['input']>;
  minPrice?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ServiceType>;
};


export type QueryAllServicesForAdminArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ServiceStatus>;
  type?: InputMaybe<ServiceType>;
};


export type QueryAllusersArgs = {
  input?: InputMaybe<GetUsersInput>;
};


export type QueryApiRequestLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApiRequestLogsArgs = {
  filter?: InputMaybe<ApiRequestLogsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryApiRequestStatsArgs = {
  rangeHours?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryArticleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryArticleBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryArticlesArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
};


export type QueryAvailabilityArgs = {
  schedulingId: Scalars['ID']['input'];
};


export type QueryBookingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBookingsArgs = {
  schedulingId: Scalars['ID']['input'];
};


export type QueryCampaignByIdArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryCampaignDailyStatsArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryCampaignPurchasesArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryCategoriesArgs = {
  parentId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCategoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryCeCoursesArgs = {
  input?: InputMaybe<CeCoursesInput>;
};


export type QueryCheckCouponAvailabilityArgs = {
  checkCouponAvailabilityInput: CheckCouponAvailabilityInput;
};


export type QueryCheckSignupAvailabilityArgs = {
  input: CheckSignupAvailabilityInput;
};


export type QueryCompanyArgs = {
  id: Scalars['String']['input'];
};


export type QueryCompanyBlockedFollowersArgs = {
  companyId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyFollowersArgs = {
  companyId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyPostsArgs = {
  companyId: Scalars['String']['input'];
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};


export type QueryCompletedCoursesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCouponArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCouponByServiceIdArgs = {
  serviceId: Scalars['ID']['input'];
};


export type QueryCouponDetailWithUsersArgs = {
  serviceId: Scalars['String']['input'];
};


export type QueryCouponRedemptionsByCouponIdArgs = {
  couponId: Scalars['ID']['input'];
};


export type QueryCouponsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCourseArgs = {
  id: Scalars['String']['input'];
};


export type QueryCourseContentStatsArgs = {
  courseId: Scalars['String']['input'];
};


export type QueryCourseDetailArgs = {
  id: Scalars['String']['input'];
};


export type QueryCourseDetailWithProgressArgs = {
  courseId: Scalars['String']['input'];
};


export type QueryCourseStudentStatsArgs = {
  courseId: Scalars['String']['input'];
};


export type QueryDiscoverGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: Scalars['Int']['input'];
  privacy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDownloadSignedSigningDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEnrolledCoursesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryEnrolledStudentsByCourseAndMonthArgs = {
  courseId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExternalEventsArgs = {
  input?: InputMaybe<ExternalEventsInput>;
};


export type QueryFeaturedMentorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFeedArgs = {
  input: FeedInput;
};


export type QueryFindExistingConversationArgs = {
  receiverId: Scalars['String']['input'];
};


export type QueryGetAcceptedConnectionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetActionButtonByCompanyIdArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryGetActionButtonsByUserIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetAdminNotificationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAllCommentsByUserPostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryGetAllEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAllImagesByUserArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryGetAllMentorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllReviewsOfMentorArgs = {
  mentorId: Scalars['String']['input'];
};


export type QueryGetAllRssFeedsArgs = {
  query: RssFeedQueryDto;
};


export type QueryGetAllSourceCompaniesArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};


export type QueryGetAllVideosByUserArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryGetCaseByPostIdArgs = {
  postId: Scalars['String']['input'];
};


export type QueryGetCommentRepliesArgs = {
  input: GetCommentRepliesInput;
};


export type QueryGetCompanyFollowersCountArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryGetCompanyInboxArgs = {
  input: GetCompanyInboxInput;
};


export type QueryGetCompanyPagesArgs = {
  companySize?: InputMaybe<Scalars['String']['input']>;
  companyStatus?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetConnectionByUserIdArgs = {
  otherUserId: Scalars['String']['input'];
};


export type QueryGetConnectionRequestsArgs = {
  input: GetConnectionRequestsInput;
};


export type QueryGetConnectionStatusArgs = {
  input: GetConnectionStatusInput;
};


export type QueryGetConnectionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConnectionStatus>;
};


export type QueryGetConversationMessagesArgs = {
  input: GetConversationMessagesInput;
};


export type QueryGetEventByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetEventByPostIdArgs = {
  postId: Scalars['String']['input'];
};


export type QueryGetEventsByCourseIdArgs = {
  courseId: Scalars['String']['input'];
};


export type QueryGetFaqArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetFollowedCompaniesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetGroupRoleIdsArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGetJoinedEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetJoinedPeopleByEventIdArgs = {
  eventId: Scalars['String']['input'];
};


export type QueryGetLatestRssFeedsArgs = {
  limit?: Scalars['Int']['input'];
};


export type QueryGetLegalInstructionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLinkPreviewArgs = {
  input: GetLinkPreviewInput;
};


export type QueryGetLiveStreamArgs = {
  roomId: Scalars['String']['input'];
};


export type QueryGetMemberPermissionsArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGetMentorAvailableSlotsArgs = {
  input: GetMentorDayAvailableSlotsInput;
};


export type QueryGetMentorFaqsArgs = {
  mentorId: Scalars['ID']['input'];
};


export type QueryGetMentorViewerAvailabilityCalendarArgs = {
  input: GetMentorViewerAvailabilityCalendarInput;
};


export type QueryGetMyEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetOccasionByPostIdArgs = {
  postId: Scalars['String']['input'];
};


export type QueryGetPollByPostIdArgs = {
  postId: Scalars['String']['input'];
};


export type QueryGetPostArgs = {
  input: GetPostInput;
};


export type QueryGetPostByIdArgs = {
  input: GetPostInput;
};


export type QueryGetProfileArgs = {
  input: GetProfileInput;
};


export type QueryGetProfileViewersArgs = {
  input: GetProfileViewersInput;
};


export type QueryGetRecommendedGroupsArgs = {
  limit?: Scalars['Int']['input'];
};


export type QueryGetReelCommentRepliesArgs = {
  input: GetReelCommentRepliesInput;
};


export type QueryGetReelCommentsArgs = {
  input: GetReelCommentsInput;
};


export type QueryGetReelsByUserIdArgs = {
  input: GetReelsByUserIdInput;
};


export type QueryGetReelsFeedArgs = {
  input?: InputMaybe<ReelsFeedInput>;
};


export type QueryGetRssFeedByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetRssFeedsBySourceArgs = {
  query: RssFeedQueryDto;
  source: Scalars['String']['input'];
};


export type QueryGetRssSourceByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryGetSavedPostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetSavedRssFeedsArgs = {
  input: GetSavedRssFeedsInput;
};


export type QueryGetScheduledPostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetSourceCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetStoryReactorsArgs = {
  input: GetStoryReactorsInput;
};


export type QueryGetStoryViewCountArgs = {
  storyId: Scalars['ID']['input'];
};


export type QueryGetStoryViewersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  storyId: Scalars['String']['input'];
};


export type QueryGetSuggestedCompaniesArgs = {
  limit?: Scalars['Int']['input'];
};


export type QueryGetSuggestedProfilesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetTopLevelCommentsArgs = {
  input: GetTopLevelCommentsInput;
};


export type QueryGetTrendingGroupsArgs = {
  limit?: Scalars['Int']['input'];
};


export type QueryGetUserBasicInfoArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserCommunityPostsArgs = {
  input: GetUserCommunityPostsInput;
};


export type QueryGetUserConversationsArgs = {
  input: PaginationInput;
};


export type QueryGetUserDetailForAdminArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserHeadlineArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserNotificationArgs = {
  notificationTypes?: InputMaybe<Array<NotificationType>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetUserPostsArgs = {
  input: GetUserPostsInput;
};


export type QueryGetUserStoriesArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGoogleCalendarAuthUrlArgs = {
  schedulingId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGoogleCalendarEventsArgs = {
  timeMax: Scalars['DateTime']['input'];
  timeMin: Scalars['DateTime']['input'];
};


export type QueryGroupApprovedPostsArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGroupBannedMembersArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGroupByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGroupFeedArgs = {
  input: GroupFeedInput;
};


export type QueryGroupGrowthArgs = {
  groupId: Scalars['String']['input'];
  timeframe?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupMembersArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGroupPendingInvitesArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGroupPendingJoinRequestsArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGroupPendingPostsArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGroupPostsArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGrowNetworkArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInfluenceProfileArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryInvoiceArgs = {
  id: Scalars['String']['input'];
};


export type QueryIsAvailableForReviewArgs = {
  mentorId: Scalars['String']['input'];
};


export type QueryIsFollowingCompanyArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryIsMentorVerifiedArgs = {
  mentorId: Scalars['String']['input'];
};


export type QueryJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobsArgs = {
  input?: InputMaybe<JobsFilterInput>;
};


export type QueryKnowledgeArticleArgs = {
  slug: Scalars['String']['input'];
};


export type QueryKnowledgeArticlesArgs = {
  input?: InputMaybe<KnowledgeArticleSearchInput>;
};


export type QueryLeaderboardArgs = {
  input: LeaderboardInput;
};


export type QueryLibraryEntriesArgs = {
  input: LibraryEntriesInput;
};


export type QueryLibraryShareMembersArgs = {
  resourceId: Scalars['ID']['input'];
  resourceType: LibraryResourceType;
};


export type QueryMentorAvailabilitiesArgs = {
  input: GetMentorAvailabilityInput;
};


export type QueryMyAiConversationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyCampaignChartDataArgs = {
  range?: Scalars['String']['input'];
};


export type QueryMyCampaignsArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  status?: InputMaybe<CampaignStatus>;
};


export type QueryMyCompaniesByOwnerArgs = {
  ownerId: Scalars['String']['input'];
};


export type QueryMyCoursesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMyGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: Scalars['Int']['input'];
};


export type QueryMyLibraryCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyLibraryFolderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyLibraryFoldersArgs = {
  parentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMyLibraryItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyLibraryItemsArgs = {
  input?: InputMaybe<LibraryItemsInput>;
};


export type QueryMyMentorPaymentsArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  paymentStatus?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyPendingGroupInviteArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryMyPostBoostsArgs = {
  status?: InputMaybe<PostBoostStatus>;
};


export type QueryMyServicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMySupportTicketsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMyTopPerformingAdsArgs = {
  limit?: Scalars['Int']['input'];
};


export type QueryMyWalletArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNewsletterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNewsletterRecipientsArgs = {
  input?: InputMaybe<PaginationInput>;
  newsletterId: Scalars['ID']['input'];
};


export type QueryNewsletterSubscriberArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNewsletterSubscribersArgs = {
  input?: InputMaybe<GetSubscribersInput>;
};


export type QueryNewsletterVersionsArgs = {
  newsletterId: Scalars['ID']['input'];
};


export type QueryNewslettersArgs = {
  input?: InputMaybe<GetNewslettersInput>;
};


export type QueryPaginatedDiscoverGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: Scalars['Int']['input'];
  privacy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPendingRoleChangeRequestsArgs = {
  input?: InputMaybe<AdminRoleChangeFilterInput>;
};


export type QueryPlatformEarningsChartArgs = {
  period?: Scalars['String']['input'];
};


export type QueryPodcastArgs = {
  id: Scalars['String']['input'];
};


export type QueryPodcastCommentRepliesArgs = {
  input: GetPodcastCommentRepliesInput;
};


export type QueryPodcastCommentsArgs = {
  input: GetPodcastCommentsInput;
};


export type QueryPodcastCreatorsArgs = {
  input?: InputMaybe<GetPodcastCreatorsInput>;
};


export type QueryPodcastEpisodeArgs = {
  episodeId: Scalars['String']['input'];
};


export type QueryPodcastEpisodesArgs = {
  input?: InputMaybe<GetPodcastEpisodesInput>;
};


export type QueryPodcastEpisodesByUserArgs = {
  input: GetPodcastEpisodesByUserInput;
};


export type QueryPodcastsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPostBoostArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPostBoostDailyStatsArgs = {
  boostId: Scalars['ID']['input'];
};


export type QueryPostGrowthArgs = {
  timeframe: Scalars['String']['input'];
};


export type QueryPostReactionsArgs = {
  input: GetPostReactionsInput;
};


export type QueryPreviewCampaignCostArgs = {
  durationDays?: InputMaybe<Scalars['Int']['input']>;
  durationHours?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryPreviewPostBoostCostArgs = {
  durationHours: Scalars['Int']['input'];
};


export type QueryPreviewProfileBoostCostArgs = {
  durationHours: Scalars['Int']['input'];
};


export type QueryPreviewUpgradeCheckoutArgs = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['ID']['input'];
};


export type QueryProfileBoostByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProfileBoostDailyStatsArgs = {
  boostId: Scalars['ID']['input'];
};


export type QueryPublicDigitalCardArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPublicServicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQuizAttemptStatusArgs = {
  enrollmentId: Scalars['String']['input'];
  quizId: Scalars['String']['input'];
};


export type QueryRecipientSigningLinkArgs = {
  documentId: Scalars['ID']['input'];
  recipientId: Scalars['ID']['input'];
};


export type QueryReferralByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryReferralCampaignsArgs = {
  input?: InputMaybe<ReferralCampaignsFilterInput>;
};


export type QueryReferralSignupsArgs = {
  input?: InputMaybe<ReferralSignupsFilterInput>;
};


export type QueryRelatedPagesArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryReportedPostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReportsByPostArgs = {
  postId: Scalars['String']['input'];
};


export type QueryRoleChangeRequestArgs = {
  id: Scalars['String']['input'];
};


export type QuerySavedArticlesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySchedulingArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySearchArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchApprovedConnectionsByLetterArgs = {
  input: SearchApprovedConnectionsInput;
};


export type QuerySearchCompaniesArgs = {
  input: SearchCompaniesInput;
};


export type QuerySearchGroupsArgs = {
  input: SearchGroupsInput;
};


export type QuerySearchGroupsByNameArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchLibraryShareUsersArgs = {
  q?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchMentorsArgs = {
  input: SearchMentorsInput;
};


export type QuerySearchMyLibraryArgs = {
  input: LibrarySearchInput;
};


export type QuerySearchPreviewArgs = {
  query: Scalars['String']['input'];
};


export type QuerySearchUserOrPostArgs = {
  input: SearchUserOrPostInput;
};


export type QuerySearchUsersArgs = {
  input: SearchUsersInput;
};


export type QuerySearchUsersByNameArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryServiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceReportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  serviceId: Scalars['String']['input'];
};


export type QuerySigningDocumentActivityArgs = {
  documentId: Scalars['ID']['input'];
};


export type QuerySimilarServicesArgs = {
  id: Scalars['String']['input'];
};


export type QuerySponsoredRequestArgs = {
  id: Scalars['String']['input'];
};


export type QuerySponsoredRequestsArgs = {
  input?: InputMaybe<AdminSponsoredRequestFilterInput>;
};


export type QuerySponsorshipPurchaseStatusArgs = {
  reference: Scalars['String']['input'];
};


export type QuerySubscriptionCouponArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySubscriptionCouponsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<SubscriptionCouponStatus>;
  take?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<SubscriptionCouponType>;
};


export type QuerySuggestedCoursesArgs = {
  input: GetSuggestedCoursesInput;
};


export type QuerySuggestedPodcastsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupportTicketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTargetedAdsArgs = {
  limit?: Scalars['Int']['input'];
};


export type QueryUniversityCommunitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniversityGroupArgs = {
  communityId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type QueryUniversityGroupMessagesArgs = {
  groupId: Scalars['String']['input'];
  messages?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryUserAchievementsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserConfirmedOrCompletedSessionCountArgs = {
  input: UserSessionCountInput;
};


export type QueryUserConnectionCountArgs = {
  input: UserConnectionCountInput;
};


export type QueryUserGrowthChartArgs = {
  range?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidateSubscriptionCouponArgs = {
  context?: InputMaybe<Scalars['String']['input']>;
  couponCode: Scalars['String']['input'];
};

export type Quiz = {
  __typename?: 'Quiz';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  moduleId: Scalars['ID']['output'];
  orderIndex: Scalars['Float']['output'];
  passingScore: Scalars['Float']['output'];
  questions?: Maybe<Array<QuizQuestion>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type QuizAnswerInput = {
  questionId: Scalars['ID']['input'];
  selectedOptionId: Scalars['ID']['input'];
};

export type QuizAnswerResponse = {
  __typename?: 'QuizAnswerResponse';
  correctOptionId?: Maybe<Scalars['ID']['output']>;
  correctOptionText?: Maybe<Scalars['String']['output']>;
  isCorrect: Scalars['Boolean']['output'];
  pointsEarned: Scalars['Float']['output'];
  questionId: Scalars['ID']['output'];
  questionNumber: Scalars['Float']['output'];
  questionText: Scalars['String']['output'];
  selectedOptionId: Scalars['ID']['output'];
  selectedOptionText: Scalars['String']['output'];
};

export type QuizAttemptCorrectOption = {
  __typename?: 'QuizAttemptCorrectOption';
  optionId: Scalars['ID']['output'];
  optionText: Scalars['String']['output'];
};

export type QuizAttemptOption = {
  __typename?: 'QuizAttemptOption';
  id: Scalars['ID']['output'];
  isCorrect: Scalars['Boolean']['output'];
  optionText: Scalars['String']['output'];
  orderIndex: Scalars['Float']['output'];
};

export type QuizAttemptQuestion = {
  __typename?: 'QuizAttemptQuestion';
  correctOption?: Maybe<QuizAttemptCorrectOption>;
  options: Array<QuizAttemptOption>;
  questionId: Scalars['ID']['output'];
  questionText: Scalars['String']['output'];
  questionType: Scalars['String']['output'];
  studentAnswer?: Maybe<QuizAttemptStudentAnswer>;
};

export type QuizAttemptResponse = {
  __typename?: 'QuizAttemptResponse';
  answers: Array<QuizAnswerResponse>;
  attemptId: Scalars['ID']['output'];
  attemptNumber: Scalars['Float']['output'];
  correctAnswers: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  endTime?: Maybe<Scalars['DateTime']['output']>;
  enrollmentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  passed: Scalars['Boolean']['output'];
  passingMessage?: Maybe<Scalars['String']['output']>;
  percentage: Scalars['Float']['output'];
  quizId: Scalars['ID']['output'];
  quizTitle: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  startTime: Scalars['DateTime']['output'];
  totalPoints: Scalars['Float']['output'];
  totalQuestions: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type QuizAttemptStatusResponse = {
  __typename?: 'QuizAttemptStatusResponse';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  enrollmentId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  questions?: Maybe<Array<QuizAttemptQuestion>>;
  quizId?: Maybe<Scalars['ID']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  totalPoints?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type QuizAttemptStudentAnswer = {
  __typename?: 'QuizAttemptStudentAnswer';
  isCorrect: Scalars['Boolean']['output'];
  optionId: Scalars['ID']['output'];
  optionText: Scalars['String']['output'];
  pointsEarned: Scalars['Float']['output'];
};

export type QuizDetailWithQuestions = {
  __typename?: 'QuizDetailWithQuestions';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  orderIndex: Scalars['Float']['output'];
  passingScore: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type QuizOption = {
  __typename?: 'QuizOption';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isCorrect: Scalars['Boolean']['output'];
  optionText: Scalars['String']['output'];
  orderIndex: Scalars['Float']['output'];
  questionId: Scalars['ID']['output'];
};

export type QuizProgress = {
  __typename?: 'QuizProgress';
  attemptCount?: Maybe<Scalars['Int']['output']>;
  bestScore?: Maybe<Scalars['Float']['output']>;
  canAttempt: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  hasAttempted: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isPassed: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  isRemaining: Scalars['Boolean']['output'];
  orderIndex: Scalars['Int']['output'];
  passingScore: Scalars['Int']['output'];
  questions: Array<QuizQuestionDetail>;
  title: Scalars['String']['output'];
};

export type QuizQuestion = {
  __typename?: 'QuizQuestion';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  options?: Maybe<Array<QuizOption>>;
  orderIndex: Scalars['Float']['output'];
  points: Scalars['Float']['output'];
  questionText: Scalars['String']['output'];
  questionType: QuizQuestionType;
  quizId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type QuizQuestionDetail = {
  __typename?: 'QuizQuestionDetail';
  id: Scalars['String']['output'];
  options: Array<QuizQuestionOptionDetail>;
  orderIndex: Scalars['Int']['output'];
  points: Scalars['Int']['output'];
  questionText: Scalars['String']['output'];
  questionType: QuizQuestionType;
};

export type QuizQuestionOptionDetail = {
  __typename?: 'QuizQuestionOptionDetail';
  id: Scalars['String']['output'];
  isCorrect: Scalars['Boolean']['output'];
  optionText: Scalars['String']['output'];
  orderIndex: Scalars['Int']['output'];
};

/** The type of quiz question (MULTIPLE_CHOICE, TRUE_FALSE, SHORT_ANSWER) */
export enum QuizQuestionType {
  MultipleChoice = 'MULTIPLE_CHOICE',
  YesOrNo = 'YES_OR_NO'
}

export type QuizStats = {
  __typename?: 'QuizStats';
  id: Scalars['String']['output'];
  percentagePassed: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type RateKnowledgeArticleInput = {
  helpful: Scalars['Boolean']['input'];
  slug: Scalars['String']['input'];
};

/** Action performed on the story reaction */
export enum ReactionAction {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Updated = 'UPDATED'
}

export type ReactionCount = {
  __typename?: 'ReactionCount';
  count: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type ReactionSummary = {
  __typename?: 'ReactionSummary';
  currentUserReaction?: Maybe<Scalars['String']['output']>;
  reactionCounts: Array<ReactionCount>;
  totalReactions: Scalars['Int']['output'];
};

/** The type of reaction (LIKE, LOVE, CELEBRATE, etc.) */
export enum ReactionType {
  Celebrate = 'CELEBRATE',
  Funny = 'FUNNY',
  Insightful = 'INSIGHTFUL',
  Like = 'LIKE',
  Love = 'LOVE',
  Support = 'SUPPORT'
}

export type ReceiptPdfResult = {
  __typename?: 'ReceiptPdfResult';
  base64Pdf: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type RecordPodcastPlayInput = {
  episodeId: Scalars['String']['input'];
};

export type RecordProfileViewInput = {
  profileUserId: Scalars['String']['input'];
};

export type RedeemCouponInput = {
  couponCode: Scalars['String']['input'];
  serviceId: Scalars['ID']['input'];
};

export type RedeemCouponResponse = {
  __typename?: 'RedeemCouponResponse';
  discountPrice?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ReelAuthor = {
  __typename?: 'ReelAuthor';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
};

export type ReelCommentAuthor = {
  __typename?: 'ReelCommentAuthor';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Role;
  title?: Maybe<Scalars['String']['output']>;
};

export type ReelCommentModel = {
  __typename?: 'ReelCommentModel';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isLikedByMe: Scalars['Boolean']['output'];
  likesCount: Scalars['Int']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  reelId: Scalars['String']['output'];
  repliesCount: Scalars['Int']['output'];
  translatedContent?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: ReelCommentAuthor;
  userId: Scalars['String']['output'];
};

export type ReelCommentsPaginated = {
  __typename?: 'ReelCommentsPaginated';
  comments: Array<ReelCommentModel>;
  hasMore: Scalars['Boolean']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type ReelModel = {
  __typename?: 'ReelModel';
  author?: Maybe<ReelAuthor>;
  blurHash?: Maybe<Scalars['String']['output']>;
  channelHandle?: Maybe<Scalars['String']['output']>;
  channelTitle?: Maybe<Scalars['String']['output']>;
  commentsCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  embedUrl?: Maybe<Scalars['String']['output']>;
  hlsUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCurated?: Maybe<Scalars['Boolean']['output']>;
  isLikedByMe?: Maybe<Scalars['Boolean']['output']>;
  /** My Library item holding this content for the current user, or null when not saved. */
  libraryItemId?: Maybe<Scalars['ID']['output']>;
  likesCount: Scalars['Int']['output'];
  provider?: Maybe<VideoProvider>;
  rawKey?: Maybe<Scalars['String']['output']>;
  rawVideoUrl?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  status: ReelStatus;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export enum ReelStatus {
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Ready = 'READY',
  Removed = 'REMOVED'
}

export type ReelsFeedInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  pinnedReelId?: InputMaybe<Scalars['ID']['input']>;
};

export type ReelsPaginated = {
  __typename?: 'ReelsPaginated';
  hasMore: Scalars['Boolean']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  reels: Array<ReelModel>;
  total: Scalars['Int']['output'];
};

export type ReferralCampaign = {
  __typename?: 'ReferralCampaign';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  ownerUser?: Maybe<ReferralCampaignOwner>;
  ownerUserId?: Maybe<Scalars['ID']['output']>;
  signupCount?: Maybe<Scalars['Int']['output']>;
  type: ReferralType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReferralCampaignOwner = {
  __typename?: 'ReferralCampaignOwner';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
};

export type ReferralCampaignsFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ReferralType>;
};

export type ReferralCampaignsResponse = {
  __typename?: 'ReferralCampaignsResponse';
  items: Array<ReferralCampaign>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ReferralSignupCampaign = {
  __typename?: 'ReferralSignupCampaign';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ReferralSignupItem = {
  __typename?: 'ReferralSignupItem';
  campaign: ReferralSignupCampaign;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  user: ReferralSignupUser;
};

export type ReferralSignupUser = {
  __typename?: 'ReferralSignupUser';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type ReferralSignupsFilterInput = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  ownerUserId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ReferralSignupsResponse = {
  __typename?: 'ReferralSignupsResponse';
  items: Array<ReferralSignupItem>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ReferralType {
  Company = 'COMPANY',
  User = 'USER'
}

export type RefreshTokenInput = {
  token: Scalars['JWT']['input'];
};

export type RemoveMemberInput = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ReorderAdvisorsInput = {
  advisorIds: Array<Scalars['ID']['input']>;
};

export type ReorderLibraryCollectionInput = {
  collectionId: Scalars['ID']['input'];
  /** Entry ids in the desired order. May be a subset; other entries keep their places. */
  orderedEntryIds: Array<Scalars['ID']['input']>;
};

export type ReorderSigningRecipientsInput = {
  documentId: Scalars['ID']['input'];
  recipientIds: Array<Scalars['ID']['input']>;
};

export type ReplyCommentInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  mediaURL?: InputMaybe<Scalars['String']['input']>;
  parentId: Scalars['ID']['input'];
};

export type ReportDetail = {
  __typename?: 'ReportDetail';
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  reporter?: Maybe<Scalars['String']['output']>;
  status: ReportedPostStatus;
  violator?: Maybe<Scalars['String']['output']>;
};

export type ReportPodcastPlaybackErrorInput = {
  episodeId: Scalars['String']['input'];
  /** YouTube IFrame API error code the player got; logged only, the server re-checks the video itself */
  errorCode: Scalars['Int']['input'];
};

export type ReportPostInput = {
  postId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type ReportReelPlaybackErrorInput = {
  /** YouTube IFrame API error code the player got; logged only, the server re-checks the video itself */
  errorCode: Scalars['Int']['input'];
  reelId: Scalars['ID']['input'];
};

export type ReportedPostItem = {
  __typename?: 'ReportedPostItem';
  authorId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  postId: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  reportsCount: Scalars['Int']['output'];
  role?: Maybe<Scalars['String']['output']>;
};

export type ReportedPostResult = {
  __typename?: 'ReportedPostResult';
  isNextPage: Scalars['Boolean']['output'];
  items: Array<ReportedPostItem>;
};

/** The status of a post report (REPORTED, IGNORED, ACTED) */
export enum ReportedPostStatus {
  Acted = 'ACTED',
  Ignored = 'IGNORED',
  Reported = 'REPORTED'
}

export type ResetPasswordInput = {
  confirmPassword: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  verificationToken?: InputMaybe<Scalars['String']['input']>;
};

export type ReverseInfluenceEventInput = {
  eventId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type Review = {
  __typename?: 'Review';
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mentorId: Scalars['String']['output'];
  rating: Scalars['Int']['output'];
  reviewer: User;
};

export type RewriteNewsletterInput = {
  instructions: Scalars['String']['input'];
};

/** role */
export enum Role {
  Admin = 'ADMIN',
  Dentist = 'DENTIST',
  IndustryPartners = 'INDUSTRY_PARTNERS',
  Mentor = 'MENTOR',
  PredentalStudent = 'PREDENTAL_STUDENT',
  RegisteredDentalHygienist = 'REGISTERED_DENTAL_HYGIENIST',
  Student = 'STUDENT',
  SuperAdmin = 'SUPER_ADMIN'
}

export type RoleChangeRequestModel = {
  __typename?: 'RoleChangeRequestModel';
  createdAt: Scalars['DateTime']['output'];
  currentRole: Role;
  /** When true, approve does not change role yet (mobile legacy). User applies via roleChangeToggle. false = apply on approve (web v2). */
  deferRoleApply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  requestedRole: Role;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  status: RoleChangeRequestStatus;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<RoleChangeRequestUser>;
  userId: Scalars['String']['output'];
};

/** Status of a role change request */
export enum RoleChangeRequestStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type RoleChangeRequestUser = {
  __typename?: 'RoleChangeRequestUser';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type RssFeed = {
  __typename?: 'RssFeed';
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  guid: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isSaved: Scalars['Boolean']['output'];
  /** My Library item holding this content for the current user, or null when not saved. */
  libraryItemId?: Maybe<Scalars['ID']['output']>;
  link: Scalars['String']['output'];
  profile_image?: Maybe<Scalars['String']['output']>;
  publishedAt: Scalars['DateTime']['output'];
  source: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RssFeedQueryDto = {
  /** Ad ids already shown in this scroll session, so they are not served again */
  excludeAdIds?: InputMaybe<Array<Scalars['String']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type RssPaginatedResponse = {
  __typename?: 'RssPaginatedResponse';
  items: Array<RssFeed>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  /** Sponsored ads for this page, each placed after one of `items` (main RSS feed only) */
  sponsoredItems?: Maybe<Array<RssSponsoredItem>>;
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type RssSource = {
  __typename?: 'RssSource';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type RssSponsoredItem = {
  __typename?: 'RssSponsoredItem';
  ad: Campaign;
  /** 0-based index in `items` of the article this ad is shown after */
  afterItemIndex: Scalars['Int']['output'];
};

export type SaveArticleInput = {
  articleId: Scalars['ID']['input'];
};

export type SaveLibraryItemInput = {
  contentId: Scalars['ID']['input'];
  contentType: LibraryContentType;
  /** Optionally file the item straight into this folder. */
  folderId?: InputMaybe<Scalars['ID']['input']>;
};

export type SavePushTokenInput = {
  token: Scalars['String']['input'];
};

export type SaveRssPostsInput = {
  rssFeedId: Scalars['String']['input'];
};

export type SavedArticle = {
  __typename?: 'SavedArticle';
  article?: Maybe<Article>;
  articleId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type SavedPostsPaginated = {
  __typename?: 'SavedPostsPaginated';
  hasMore: Scalars['Boolean']['output'];
  posts: Array<Post>;
  total: Scalars['Int']['output'];
};

export type Scheduling = {
  __typename?: 'Scheduling';
  bufferAfter: Scalars['Int']['output'];
  bufferBefore: Scalars['Int']['output'];
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  landingUrl: Scalars['String']['output'];
  locationType: SchedulingLocationType;
  publicId: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Location type for a scheduling event */
export enum SchedulingLocationType {
  Custom = 'CUSTOM',
  InPerson = 'IN_PERSON',
  Phone = 'PHONE',
  Video = 'VIDEO'
}

export type SchedulingTimeRange = {
  __typename?: 'SchedulingTimeRange';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type SchedulingTimeRangeInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type SchedulingWeeklyAvailability = {
  __typename?: 'SchedulingWeeklyAvailability';
  friday: Array<SchedulingTimeRange>;
  monday: Array<SchedulingTimeRange>;
  saturday: Array<SchedulingTimeRange>;
  sunday: Array<SchedulingTimeRange>;
  thursday: Array<SchedulingTimeRange>;
  tuesday: Array<SchedulingTimeRange>;
  wednesday: Array<SchedulingTimeRange>;
};

export type SchedulingWeeklyAvailabilityInput = {
  friday: Array<SchedulingTimeRangeInput>;
  monday: Array<SchedulingTimeRangeInput>;
  saturday: Array<SchedulingTimeRangeInput>;
  sunday: Array<SchedulingTimeRangeInput>;
  thursday: Array<SchedulingTimeRangeInput>;
  tuesday: Array<SchedulingTimeRangeInput>;
  wednesday: Array<SchedulingTimeRangeInput>;
};

export type Search = {
  __typename?: 'Search';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  firstName: Scalars['String']['output'];
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Badge the user chose to show beside their name (opt-in, null when none). Batched per request. */
  influenceBadge?: Maybe<AchievementBadge>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Role;
  suffix?: Maybe<Suffix>;
  title?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SearchApprovedConnectionsInput = {
  letter: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchCompaniesInput = {
  limit?: Scalars['Int']['input'];
  ownerOnly?: InputMaybe<Scalars['Boolean']['input']>;
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type SearchGroupsInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  maxMembers?: InputMaybe<Scalars['Int']['input']>;
  minMembers?: InputMaybe<Scalars['Int']['input']>;
  page?: Scalars['Int']['input'];
  privacy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SearchMentorsInput = {
  expertises?: InputMaybe<Array<Expertise>>;
  keywordsArray?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxConsultations?: InputMaybe<Scalars['Int']['input']>;
  minConsultations?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type SearchPreview = {
  __typename?: 'SearchPreview';
  companies?: Maybe<Array<CompanyPreview>>;
  groups?: Maybe<Array<Maybe<GroupPreview>>>;
  posts?: Maybe<Array<Maybe<Post>>>;
  users?: Maybe<Array<Maybe<UserPreview>>>;
};

export type SearchResults = {
  __typename?: 'SearchResults';
  posts?: Maybe<Array<Post>>;
  profiles?: Maybe<Array<User>>;
};

export enum SearchType {
  Group = 'GROUP',
  Post = 'POST',
  User = 'USER'
}

export type SearchUserOrPostInput = {
  groupCategoryFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  groupPrivacyFilter?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  postTimeFilter?: InputMaybe<PostTimeFilter>;
  query: Scalars['String']['input'];
  type: SearchType;
  userRoleFilter?: InputMaybe<Array<Role>>;
};

export type SearchUserOrPostOutput = {
  __typename?: 'SearchUserOrPostOutput';
  groups?: Maybe<Array<GroupPreview>>;
  posts?: Maybe<Array<Post>>;
  users?: Maybe<Array<UserPreview>>;
};

export type SearchUsersInput = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type SendConnectionRequestInput = {
  userId: Scalars['String']['input'];
};

export type SendMessageInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  receiverId?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type SendNewsletterTestInput = {
  /** Defaults to the requesting admin's own email */
  testEmail?: InputMaybe<Scalars['String']['input']>;
};

export type SendSigningDocumentInput = {
  expiresInDays?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  reminderEveryDays?: InputMaybe<Scalars['Int']['input']>;
};

export type SendSigningDocumentResult = {
  __typename?: 'SendSigningDocumentResult';
  documentId: Scalars['ID']['output'];
  recipientLinks: Array<SigningRecipientLink>;
};

export type SendSupportMessageInput = {
  /** Media ids from uploadDocument (module: SUPPORT). */
  attachmentMediaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  message: Scalars['String']['input'];
  ticketId: Scalars['ID']['input'];
};

export type SeriesData = {
  __typename?: 'SeriesData';
  data: Array<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type Service = {
  __typename?: 'Service';
  address: Scalars['String']['output'];
  category: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  fee: Scalars['Float']['output'];
  hasCoupon?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  images: Array<Scalars['String']['output']>;
  langitude: Scalars['Float']['output'];
  latitude: Scalars['Float']['output'];
  /** My Library item holding this content for the current user, or null when not saved. */
  libraryItemId?: Maybe<Scalars['ID']['output']>;
  optimizedImages?: Maybe<Array<Scalars['String']['output']>>;
  priceType: PriceType;
  serviceStatus: ServiceStatus;
  title: Scalars['String']['output'];
  type: ServiceType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ServicePaginatedResponse = {
  __typename?: 'ServicePaginatedResponse';
  data: Array<Service>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalActiveServices: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  totalPendingServices?: Maybe<Scalars['Int']['output']>;
};

export type ServiceReport = {
  __typename?: 'ServiceReport';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  reporter?: Maybe<User>;
  serviceId: Scalars['String']['output'];
  status: ServiceReportStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** Actions that can be taken on a reported service */
export enum ServiceReportAction {
  ClearReports = 'CLEAR_REPORTS',
  DeleteService = 'DELETE_SERVICE',
  SuspendService = 'SUSPEND_SERVICE'
}

export type ServiceReportActionResponse = {
  __typename?: 'ServiceReportActionResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ServiceReportPaginatedResponse = {
  __typename?: 'ServiceReportPaginatedResponse';
  data: Array<ServiceReport>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum ServiceReportStatus {
  Dismissed = 'DISMISSED',
  Pending = 'PENDING',
  Resolved = 'RESOLVED'
}

export type ServiceStats = {
  __typename?: 'ServiceStats';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
};

export type ServiceStatsResponse = {
  __typename?: 'ServiceStatsResponse';
  stats: Array<ServiceStats>;
};

/** The status of a service */
export enum ServiceStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Pending = 'PENDING',
  Suspended = 'SUSPENDED'
}

/** Industry Partner vs Practice Acquisition service type */
export enum ServiceType {
  IndustryPartner = 'INDUSTRY_PARTNER',
  PracticeAcquisition = 'PRACTICE_ACQUISITION'
}

export type Session = {
  __typename?: 'Session';
  bookedTimezone?: Maybe<Scalars['String']['output']>;
  closedReason?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  description: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invoice?: Maybe<SessionInvoice>;
  mentor: SessionUserInfo;
  price?: Maybe<Scalars['Float']['output']>;
  refundRequestReason?: Maybe<Scalars['String']['output']>;
  refundRequestStatus?: Maybe<Scalars['String']['output']>;
  refundRequestedAt?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['String']['output'];
  status: Scalars['String']['output'];
  student: SessionUserInfo;
  subject: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  zoomJoinUrl?: Maybe<Scalars['String']['output']>;
  zoomMeetingId?: Maybe<Scalars['String']['output']>;
  zoomPasscode?: Maybe<Scalars['String']['output']>;
  zoomStartUrl?: Maybe<Scalars['String']['output']>;
};

export type SessionAuditRecord = {
  __typename?: 'SessionAuditRecord';
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  payeeId?: Maybe<Scalars['String']['output']>;
  payeeName?: Maybe<Scalars['String']['output']>;
  payerId?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  platformFeeAmount?: Maybe<Scalars['Float']['output']>;
  sessionDate?: Maybe<Scalars['String']['output']>;
  sessionFeeAmount?: Maybe<Scalars['Float']['output']>;
  sessionTime?: Maybe<Scalars['String']['output']>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  totalPaid?: Maybe<Scalars['Float']['output']>;
};

export type SessionInvoice = {
  __typename?: 'SessionInvoice';
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  invoicePdf?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['String']['output']>;
  receiptUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type SessionRefundRequest = {
  __typename?: 'SessionRefundRequest';
  bookedTimezone?: Maybe<Scalars['String']['output']>;
  closedReason?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  description: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invoice?: Maybe<SessionInvoice>;
  mentor: SessionRefundRequestUser;
  price?: Maybe<Scalars['Float']['output']>;
  refundRequestReason?: Maybe<Scalars['String']['output']>;
  refundRequestStatus?: Maybe<Scalars['String']['output']>;
  refundRequestedAt?: Maybe<Scalars['String']['output']>;
  refundReviewedAt?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['String']['output'];
  status: Scalars['String']['output'];
  student: SessionRefundRequestUser;
  subject: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
};

export type SessionRefundRequestUser = {
  __typename?: 'SessionRefundRequestUser';
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SessionUserInfo = {
  __typename?: 'SessionUserInfo';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Badge the user chose to show beside their name (opt-in, null when none). Batched per request. */
  influenceBadge?: Maybe<AchievementBadge>;
  lastName: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SetDateAvailabilityOverrideInput = {
  applyToAll?: InputMaybe<Scalars['Boolean']['input']>;
  clear?: InputMaybe<Scalars['Boolean']['input']>;
  date: Scalars['String']['input'];
  ranges?: InputMaybe<Array<SchedulingTimeRangeInput>>;
  schedulingId: Scalars['String']['input'];
  type?: InputMaybe<DateAvailabilityOverrideType>;
};

export type SetPodcastEpisodeHiddenInput = {
  episodeId: Scalars['String']['input'];
  /** false = publish (make visible), true = hide again */
  hidden: Scalars['Boolean']['input'];
};

export type ShareLibraryResourceInput = {
  resourceId: Scalars['ID']['input'];
  resourceType: LibraryResourceType;
  role: LibraryShareRole;
  userId: Scalars['ID']['input'];
};

export type SignUpInput = {
  Sociallink?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyLogo?: InputMaybe<Scalars['String']['input']>;
  confirmPassword: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  dentalLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  dentalSchool?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  graduationDate?: InputMaybe<Scalars['DateTime']['input']>;
  homeZip?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  officeFax?: InputMaybe<Scalars['String']['input']>;
  officePhone?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  planId?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  reasonForJoining?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  role: Role;
  specialty?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  universityEmail?: InputMaybe<Scalars['String']['input']>;
  valueToCommunity?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type SignUpResponse = {
  __typename?: 'SignUpResponse';
  accessToken?: Maybe<Scalars['JWT']['output']>;
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['JWT']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SigningActivityEntity = {
  __typename?: 'SigningActivityEntity';
  actorEmail?: Maybe<Scalars['String']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  recipientId?: Maybe<Scalars['String']['output']>;
  state: SigningActivityState;
  type: SigningActivityType;
};

export enum SigningActivityState {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Warning = 'WARNING'
}

export enum SigningActivityType {
  DocumentCancelled = 'DOCUMENT_CANCELLED',
  DocumentCompleted = 'DOCUMENT_COMPLETED',
  DocumentCreated = 'DOCUMENT_CREATED',
  DocumentDeclined = 'DOCUMENT_DECLINED',
  DocumentExpired = 'DOCUMENT_EXPIRED',
  DocumentOpened = 'DOCUMENT_OPENED',
  DocumentSent = 'DOCUMENT_SENT',
  DocumentSigned = 'DOCUMENT_SIGNED',
  DocumentUpdated = 'DOCUMENT_UPDATED',
  DocumentViewed = 'DOCUMENT_VIEWED',
  FieldCompleted = 'FIELD_COMPLETED',
  IdentityVerified = 'IDENTITY_VERIFIED',
  InvitationResent = 'INVITATION_RESENT',
  InvitationSent = 'INVITATION_SENT'
}

export type SigningDocumentEntity = {
  __typename?: 'SigningDocumentEntity';
  activity?: Maybe<Array<SigningActivityEntity>>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByAdminId: Scalars['String']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  expiresInDays: Scalars['Int']['output'];
  fields: Array<SigningFieldEntity>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pageCount: Scalars['Int']['output'];
  pdfMediaId?: Maybe<Scalars['String']['output']>;
  pdfUrl?: Maybe<Scalars['String']['output']>;
  recipients: Array<SigningRecipientEntity>;
  reminderEveryDays: Scalars['Int']['output'];
  requireSigningOrder: Scalars['Boolean']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  signedPdfMediaId?: Maybe<Scalars['String']['output']>;
  signedPdfUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  templateId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
  viewCount: Scalars['Int']['output'];
};

export enum SigningDocumentStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  PartiallyCompleted = 'PARTIALLY_COMPLETED',
  Sent = 'SENT',
  Viewed = 'VIEWED'
}

export type SigningDocumentsFilterInput = {
  dateRange?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SigningDocumentStatus>;
};

export type SigningDocumentsListResult = {
  __typename?: 'SigningDocumentsListResult';
  items: Array<SigningDocumentEntity>;
  total: Scalars['Int']['output'];
};

export type SigningDownloadUrl = {
  __typename?: 'SigningDownloadUrl';
  url: Scalars['String']['output'];
};

export type SigningFieldEntity = {
  __typename?: 'SigningFieldEntity';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  options?: Maybe<Scalars['JSON']['output']>;
  page: Scalars['Int']['output'];
  recipientId: Scalars['ID']['output'];
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export enum SigningFieldType {
  Attachment = 'ATTACHMENT',
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  Dropdown = 'DROPDOWN',
  Email = 'EMAIL',
  Initials = 'INITIALS',
  Name = 'NAME',
  Radio = 'RADIO',
  Signature = 'SIGNATURE',
  Text = 'TEXT'
}

export type SigningRecipientEntity = {
  __typename?: 'SigningRecipientEntity';
  colorIndex: Scalars['Int']['output'];
  declineReason?: Maybe<Scalars['String']['output']>;
  declinedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  role: Scalars['String']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  signingOrder: Scalars['Int']['output'];
  signingUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SigningRecipientLink = {
  __typename?: 'SigningRecipientLink';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  recipientId: Scalars['ID']['output'];
  signingUrl: Scalars['String']['output'];
};

export enum SigningRecipientRole {
  Cc = 'CC',
  Signer = 'SIGNER'
}

export type SigningTemplateEntity = {
  __typename?: 'SigningTemplateEntity';
  createdAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pageCount: Scalars['Int']['output'];
  pdfMediaId: Scalars['String']['output'];
  pdfUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SignupAvailability = {
  __typename?: 'SignupAvailability';
  dentalLicenseNumberTaken: Scalars['Boolean']['output'];
  emailTaken: Scalars['Boolean']['output'];
  universityEmailTaken: Scalars['Boolean']['output'];
};

export enum SignupPaymentProvider {
  Apple = 'APPLE',
  Google = 'GOOGLE',
  Stripe = 'STRIPE'
}

export enum SignupPaymentStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type SkillModel = {
  __typename?: 'SkillModel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SourceCompaniesPaginatedResponse = {
  __typename?: 'SourceCompaniesPaginatedResponse';
  data: Array<SourceCompany>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SourceCompany = {
  __typename?: 'SourceCompany';
  cons: Array<SourcePoint>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pros: Array<SourcePoint>;
  reviews: Array<Maybe<SourceReview>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SourcePoint = {
  __typename?: 'SourcePoint';
  description?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type SourcePointInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type SourceReview = {
  __typename?: 'SourceReview';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reviewer: Scalars['String']['output'];
  sourceCompany?: Maybe<SourceCompany>;
  sourceCompanyId: Scalars['String']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SponsoredRequestModel = {
  __typename?: 'SponsoredRequestModel';
  adminNote?: Maybe<Scalars['String']['output']>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  sponsorshipPurchase?: Maybe<SponsoredRequestPurchaseInfo>;
  status: SponsoredRequestStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type SponsoredRequestPurchaseInfo = {
  __typename?: 'SponsoredRequestPurchaseInfo';
  amountCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  paymentIntentId: Scalars['String']['output'];
  paymentStatus: InvoiceStatus;
  planName: Scalars['String']['output'];
  purchaseReference: Scalars['String']['output'];
  purchaseStatus: Scalars['String']['output'];
  purchasedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Status of a sponsored advisor request */
export enum SponsoredRequestStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type SponsorshipCheckoutResult = {
  __typename?: 'SponsorshipCheckoutResult';
  amountCents: Scalars['Int']['output'];
  clientSecret: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  planName: Scalars['String']['output'];
  publishableKey: Scalars['String']['output'];
  purchaseReference: Scalars['String']['output'];
};

export type SponsorshipEventModel = {
  __typename?: 'SponsorshipEventModel';
  description?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
};

export type SponsorshipOverview = {
  __typename?: 'SponsorshipOverview';
  activePlans: Scalars['Int']['output'];
  approvedSponsors: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  failedPayments: Scalars['Int']['output'];
  paidPurchases: Scalars['Int']['output'];
  pendingApprovals: Scalars['Int']['output'];
  pendingPayments: Scalars['Int']['output'];
  refundedPurchases: Scalars['Int']['output'];
  rejectedSponsors: Scalars['Int']['output'];
  totalPlans: Scalars['Int']['output'];
  totalPurchases: Scalars['Int']['output'];
  /** Net sponsorship revenue in cents (PAID invoices minus refunds). */
  totalRevenueCents: Scalars['Float']['output'];
};

export type SponsorshipPlanModel = {
  __typename?: 'SponsorshipPlanModel';
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  features: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Price in the smallest currency unit (cents). */
  priceCents: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

/** Lifecycle of a sponsorship purchase (separate from payment + approval state) */
export enum SponsorshipPurchaseStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export type SponsorshipPurchaseStatusModel = {
  __typename?: 'SponsorshipPurchaseStatusModel';
  amountCents: Scalars['Int']['output'];
  /** Admin approval state. */
  approvalStatus: SponsoredRequestStatus;
  currency: Scalars['String']['output'];
  /** True only when PAID and APPROVED. */
  isPublic: Scalars['Boolean']['output'];
  /** Stripe payment state. */
  paymentStatus: InvoiceStatus;
  planName: Scalars['String']['output'];
  purchaseReference: Scalars['String']['output'];
  purchaseStatus: SponsorshipPurchaseStatus;
  purchasedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StatsResponse = {
  __typename?: 'StatsResponse';
  active: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Story = {
  __typename?: 'Story';
  content: Array<StoryContent>;
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isSeen: Scalars['Boolean']['output'];
  reactions: ReactionSummary;
  user?: Maybe<StoryUser>;
  userId: Scalars['ID']['output'];
  viewCount: Scalars['Int']['output'];
};

export enum StoryChangeType {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Updated = 'UPDATED'
}

export type StoryChanged = {
  __typename?: 'StoryChanged';
  story?: Maybe<Story>;
  storyId: Scalars['ID']['output'];
  type: StoryChangeType;
  userId: Scalars['ID']['output'];
};

export type StoryContent = {
  __typename?: 'StoryContent';
  caption?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  type: StoryType;
};

export type StoryContentItemInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['Float']['input']>;
  storyPrivacy?: StoryPrivacy;
  type: StoryType;
};

/** Privacy setting for stories */
export enum StoryPrivacy {
  Connections = 'CONNECTIONS',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type StoryReactionResponse = {
  __typename?: 'StoryReactionResponse';
  action: ReactionAction;
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  reactionType?: Maybe<ReactionType>;
};

export type StoryReactionUser = {
  __typename?: 'StoryReactionUser';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  reactionType: Scalars['String']['output'];
  role: Role;
  title?: Maybe<Scalars['String']['output']>;
  totalReactions: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
};

/** Story content type */
export enum StoryType {
  Image = 'IMAGE',
  Text = 'TEXT',
  Video = 'VIDEO'
}

export type StoryUser = {
  __typename?: 'StoryUser';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StoryViewer = {
  __typename?: 'StoryViewer';
  id: Scalars['ID']['output'];
  totalViews: Scalars['Int']['output'];
  viewedAt: Scalars['DateTime']['output'];
  viewer: StoryViewerUser;
};

export type StoryViewerUser = {
  __typename?: 'StoryViewerUser';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StreamActionResponse = {
  __typename?: 'StreamActionResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SubmitQuizInput = {
  answers: Array<QuizAnswerInput>;
  courseId: Scalars['ID']['input'];
  quizId: Scalars['ID']['input'];
};

export type SubmitTicketFeedbackInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Was the issue resolved to the user’s satisfaction? */
  resolved: Scalars['Boolean']['input'];
  ticketId: Scalars['ID']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Live streams of the viewer's connections starting, changing state or ending */
  liveStreamChanged: LiveStreamChanged;
  notificationReceived: Notification;
  /** Live likes, comments and replies on one podcast episode. */
  podcastActivity: PodcastActivity;
  /** Live reactions, comments and replies on one post. */
  postActivity: PostActivity;
  /** The viewer's own post boost after it is created, changes while running, or stops running */
  postBoostActivity: PostBoostChanged;
  /**
   * The viewer's own post boost after its status or stats change
   * @deprecated Use postBoostActivity, which carries a CREATED/UPDATED/DELETED changeType.
   */
  postBoostChanged: PostBoost;
  /** The viewer's own profile boost after it is created, changes while running, or finishes */
  profileBoostActivity: ProfileBoostChanged;
  /**
   * The viewer's own profile boost after its status or stats change
   * @deprecated Use profileBoostActivity, which carries a CREATED/UPDATED/DELETED changeType.
   */
  profileBoostChanged: ProfileBoost;
  storyChanged: StoryChanged;
};


export type SubscriptionPodcastActivityArgs = {
  episodeId: Scalars['ID']['input'];
};


export type SubscriptionPostActivityArgs = {
  postId: Scalars['ID']['input'];
};

/** History action for subscription coupon usage */
export enum SubscriptionCouponAction {
  Applied = 'APPLIED',
  Consumed = 'CONSUMED',
  Removed = 'REMOVED',
  Replaced = 'REPLACED',
  Revoked = 'REVOKED'
}

export type SubscriptionCouponGql = {
  __typename?: 'SubscriptionCouponGql';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['String']['output']>;
  discountPercent: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  revokedById?: Maybe<Scalars['String']['output']>;
  status: SubscriptionCouponStatus;
  stripeCouponId: Scalars['String']['output'];
  stripePromotionCodeId: Scalars['String']['output'];
  subscriptionLabel?: Maybe<Scalars['String']['output']>;
  subscriptions?: Maybe<Array<SubscriptionCouponHolder>>;
  type: SubscriptionCouponType;
  updatedAt: Scalars['DateTime']['output'];
  usageCount?: Maybe<Scalars['Int']['output']>;
  usages?: Maybe<Array<SubscriptionCouponUsageEntry>>;
  usedBy?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionCouponHolder = {
  __typename?: 'SubscriptionCouponHolder';
  id: Scalars['ID']['output'];
  plan?: Maybe<SubscriptionCouponHolderPlan>;
  user?: Maybe<SubscriptionCouponHolderUser>;
};

export type SubscriptionCouponHolderPlan = {
  __typename?: 'SubscriptionCouponHolderPlan';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SubscriptionCouponHolderUser = {
  __typename?: 'SubscriptionCouponHolderUser';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

/** ACTIVE, USED, or REVOKED subscription coupon catalog status */
export enum SubscriptionCouponStatus {
  Active = 'ACTIVE',
  Revoked = 'REVOKED',
  Used = 'USED'
}

/** LIFE_TIME applies every invoice; ONE_TIME applies to the first invoice only */
export enum SubscriptionCouponType {
  LifeTime = 'LIFE_TIME',
  OneTime = 'ONE_TIME'
}

export type SubscriptionCouponUsageEntry = {
  __typename?: 'SubscriptionCouponUsageEntry';
  action: SubscriptionCouponAction;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  planId?: Maybe<Scalars['ID']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  subscriptionId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

export type SubscriptionCouponValidationResult = {
  __typename?: 'SubscriptionCouponValidationResult';
  discountPercent?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SubscriptionCouponType>;
  valid: Scalars['Boolean']['output'];
};

export type SubscriptionInvoice = {
  __typename?: 'SubscriptionInvoice';
  amountDue: Scalars['Int']['output'];
  amountPaid: Scalars['Int']['output'];
  billingReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  finalAmountPaid?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  invoicePdf?: Maybe<Scalars['String']['output']>;
  invoiceType?: Maybe<Scalars['String']['output']>;
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  newPlanPrice?: Maybe<Scalars['Int']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentMethodBrand?: Maybe<Scalars['String']['output']>;
  paymentMethodLast4?: Maybe<Scalars['String']['output']>;
  periodDays?: Maybe<Scalars['Int']['output']>;
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  periodLabel?: Maybe<Scalars['String']['output']>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  previousPlanAmount?: Maybe<Scalars['Int']['output']>;
  previousPlanUnusedCredit?: Maybe<Scalars['Int']['output']>;
  providerInvoiceId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  stripeInvoiceId: Scalars['String']['output'];
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  accessAIChatbot: Scalars['Boolean']['output'];
  actionButtonOnProfile: Scalars['Boolean']['output'];
  appleProductId?: Maybe<Scalars['String']['output']>;
  companyPages?: Maybe<Scalars['Int']['output']>;
  connectionSendingLimits?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  googleProductId?: Maybe<Scalars['String']['output']>;
  groupCreation?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  liveStreaming: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priceMonthly: Scalars['Float']['output'];
  serviceListings?: Maybe<Scalars['Int']['output']>;
  status: PlanStatus;
  stripePriceId?: Maybe<Scalars['String']['output']>;
  stripeProductId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** The status of a subscription (ACTIVE, PAST_DUE, CANCELED, TRIALING, INCOMPLETE) */
export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  PastDue = 'PAST_DUE',
  Trialing = 'TRIALING'
}

export type SubscriptionUserProfile = {
  __typename?: 'SubscriptionUserProfile';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export enum Suffix {
  Dds = 'DDS',
  Dmd = 'DMD',
  None = 'NONE'
}

export type SuggestedCourse = {
  __typename?: 'SuggestedCourse';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  instructor: SuggestedCourseInstructor;
  instructorId: Scalars['ID']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalLessons: Scalars['Int']['output'];
  totalStudentsEnrolled: Scalars['Int']['output'];
};

export type SuggestedCourseInstructor = {
  __typename?: 'SuggestedCourseInstructor';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Badge the user chose to show beside their name (opt-in, null when none). Batched per request. */
  influenceBadge?: Maybe<AchievementBadge>;
  lastName: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SuggestedCoursesResponse = {
  __typename?: 'SuggestedCoursesResponse';
  data: Array<SuggestedCourse>;
};

export type SupportCategory = {
  __typename?: 'SupportCategory';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Stable machine key, e.g. "PAYMENT". */
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type SupportDashboard = {
  __typename?: 'SupportDashboard';
  aiEscalations: Scalars['Int']['output'];
  /** Tickets assigned to the requesting agent and still open. */
  assignedToMe: Scalars['Int']['output'];
  closed: Scalars['Int']['output'];
  inProgress: Scalars['Int']['output'];
  open: Scalars['Int']['output'];
  resolved: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unassigned: Scalars['Int']['output'];
  urgent: Scalars['Int']['output'];
  waitingForInternal: Scalars['Int']['output'];
  waitingForUser: Scalars['Int']['output'];
};

export type SupportMessage = {
  __typename?: 'SupportMessage';
  /** Resolved attachment media rows. */
  attachments: Array<Media>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Internal agent note. Always false on user-facing APIs (filtered server-side). */
  isInternal: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  /** Populated for USER / ADMIN messages; null for AI / SYSTEM. */
  sender?: Maybe<SupportMessageSender>;
  senderId?: Maybe<Scalars['ID']['output']>;
  senderType: SupportSenderType;
  ticketId: Scalars['ID']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A lightweight view of a support message author. */
export type SupportMessageSender = {
  __typename?: 'SupportMessageSender';
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
};

/** DentMent entity a ticket relates to (MENTOR_SESSION, BOOKING, PAYMENT, …) */
export enum SupportRelatedType {
  AdCampaign = 'AD_CAMPAIGN',
  Article = 'ARTICLE',
  Booking = 'BOOKING',
  Community = 'COMMUNITY',
  Company = 'COMPANY',
  ConnectionRequest = 'CONNECTION_REQUEST',
  Course = 'COURSE',
  DigitalCard = 'DIGITAL_CARD',
  Event = 'EVENT',
  Group = 'GROUP',
  Job = 'JOB',
  LiveStream = 'LIVE_STREAM',
  MentorSession = 'MENTOR_SESSION',
  Message = 'MESSAGE',
  Other = 'OTHER',
  Payment = 'PAYMENT',
  Post = 'POST',
  PostBoost = 'POST_BOOST',
  ProfileBoost = 'PROFILE_BOOST',
  Reel = 'REEL',
  Referral = 'REFERRAL',
  RoleChange = 'ROLE_CHANGE',
  Scheduling = 'SCHEDULING',
  Service = 'SERVICE',
  Story = 'STORY',
  Subscription = 'SUBSCRIPTION',
  UserAccount = 'USER_ACCOUNT'
}

/** Author type of a support message (USER, ADMIN, AI, SYSTEM, GUEST) */
export enum SupportSenderType {
  Admin = 'ADMIN',
  Ai = 'AI',
  Guest = 'GUEST',
  System = 'SYSTEM',
  User = 'USER'
}

/** Support ticket as seen by its owner (the user). */
export type SupportTicket = {
  __typename?: 'SupportTicket';
  /** Set when this ticket was escalated from an AI conversation. */
  aiConversationId?: Maybe<Scalars['ID']['output']>;
  category?: Maybe<SupportCategory>;
  categoryId?: Maybe<Scalars['ID']['output']>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  feedbackResolved?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Timestamp of the most recent message on the thread. */
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  /** Preview of the latest visible message. */
  lastMessagePreview?: Maybe<Scalars['String']['output']>;
  /** Number of visible (non-internal) messages. */
  messageCount: Scalars['Int']['output'];
  /** Full visible conversation. Populated by supportTicket(id); null in list results. */
  messages?: Maybe<Array<SupportMessage>>;
  priority: SupportTicketPriority;
  relatedId?: Maybe<Scalars['String']['output']>;
  relatedType?: Maybe<SupportRelatedType>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  source: SupportTicketSource;
  status: SupportTicketStatus;
  subject: Scalars['String']['output'];
  /** Human-readable identifier, e.g. "DM-1042". */
  ticketNumber: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['ID']['output'];
};

export type SupportTicketConnection = {
  __typename?: 'SupportTicketConnection';
  data: Array<SupportTicket>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

/** Support ticket priority (LOW, MEDIUM, HIGH, URGENT). Defaults to MEDIUM; set by rules/agents. */
export enum SupportTicketPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Urgent = 'URGENT'
}

/** Origin of a support ticket (USER, AI, ADMIN, SYSTEM, GUEST_FORM, GUEST_AI) */
export enum SupportTicketSource {
  Admin = 'ADMIN',
  Ai = 'AI',
  GuestAi = 'GUEST_AI',
  GuestForm = 'GUEST_FORM',
  System = 'SYSTEM',
  User = 'USER'
}

/** Support ticket lifecycle: OPEN, IN_PROGRESS, WAITING_FOR_USER, WAITING_FOR_INTERNAL, RESOLVED, CLOSED */
export enum SupportTicketStatus {
  Closed = 'CLOSED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  Resolved = 'RESOLVED',
  WaitingForInternal = 'WAITING_FOR_INTERNAL',
  WaitingForUser = 'WAITING_FOR_USER'
}

export type SupportUserContextBooking = {
  __typename?: 'SupportUserContextBooking';
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mentorName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type SupportUserContextPayment = {
  __typename?: 'SupportUserContextPayment';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  total: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type SupportUserContextSubscription = {
  __typename?: 'SupportUserContextSubscription';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  planName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type SyncStoreSubscriptionInput = {
  changeType?: InputMaybe<Scalars['String']['input']>;
  platform: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  purchaseToken?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type SyncStoreSubscriptionResult = {
  __typename?: 'SyncStoreSubscriptionResult';
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']['output']>;
  changeKind?: Maybe<Scalars['String']['output']>;
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  message: Scalars['String']['output'];
  pendingPlanId?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TakeServiceReportActionInput = {
  action: ServiceReportAction;
  serviceId: Scalars['String']['input'];
};

export type TimeRange = {
  __typename?: 'TimeRange';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type TimeRangeInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export enum Timezone {
  AkstAlaskaStandardTime = 'AKST_ALASKA_STANDARD_TIME',
  AstAtlanticStandardTime = 'AST_ATLANTIC_STANDARD_TIME',
  ChstChamorroStandardTime = 'CHST_CHAMORRO_STANDARD_TIME',
  CstCentralStandardTime = 'CST_CENTRAL_STANDARD_TIME',
  EstEasternStandardTime = 'EST_EASTERN_STANDARD_TIME',
  HstHawaiiStandardTime = 'HST_HAWAII_STANDARD_TIME',
  MstMountainStandardTime = 'MST_MOUNTAIN_STANDARD_TIME',
  PstPacificStandardTime = 'PST_PACIFIC_STANDARD_TIME',
  SstSamoaStandardTime = 'SST_SAMOA_STANDARD_TIME'
}

export type ToggleStoryLikeInput = {
  contentId: Scalars['String']['input'];
  reactionType?: InputMaybe<ReactionType>;
};

export type Token = {
  __typename?: 'Token';
  /** JWT access token */
  accessToken: Scalars['JWT']['output'];
  /** JWT refresh token */
  refreshToken: Scalars['JWT']['output'];
};

export type TotalUsersStats = {
  __typename?: 'TotalUsersStats';
  formattedPercent: Scalars['String']['output'];
  totalUsers: Scalars['Int']['output'];
  trend: Scalars['String']['output'];
};

export enum TransactionDirection {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type TrialConfigResult = {
  __typename?: 'TrialConfigResult';
  enabled: Scalars['Boolean']['output'];
  graceDays: Scalars['Int']['output'];
  trialDays: Scalars['Int']['output'];
};

export type UnSaveRssPostsInput = {
  rssFeedId: Scalars['String']['input'];
};

export type UnbanMemberInput = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UniversityCommunityResult = {
  __typename?: 'UniversityCommunityResult';
  items: Array<Community>;
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type UniversityGroup = {
  __typename?: 'UniversityGroup';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UniversityGroupMessage = {
  __typename?: 'UniversityGroupMessage';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  parent?: Maybe<UniversityGroupMessage>;
  replies?: Maybe<Array<UniversityGroupMessage>>;
  sender: User;
};

export type UnsaveArticleInput = {
  articleId: Scalars['ID']['input'];
};

export type UpdateActionButtonInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isShow: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdDurationPackInput = {
  appleProductId?: InputMaybe<Scalars['String']['input']>;
  googleProductId?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  priceCents?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAdminPermissionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateAdminUserInput = {
  id: Scalars['ID']['input'];
  permissionId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdvisorInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAiAgentInput = {
  activeHoursEnd?: InputMaybe<Scalars['Int']['input']>;
  activeHoursStart?: InputMaybe<Scalars['Int']['input']>;
  agentId: Scalars['String']['input'];
  allowedTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  blockedTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  commentLookbackDays?: InputMaybe<Scalars['Int']['input']>;
  maxCommentsPerDay?: InputMaybe<Scalars['Int']['input']>;
  maxMinutesBetweenActions?: InputMaybe<Scalars['Int']['input']>;
  maxPostsPerDay?: InputMaybe<Scalars['Int']['input']>;
  maxReactionsPerDay?: InputMaybe<Scalars['Int']['input']>;
  maxRepliesPerDay?: InputMaybe<Scalars['Int']['input']>;
  minMinutesBetweenActions?: InputMaybe<Scalars['Int']['input']>;
  personaPrompt?: InputMaybe<Scalars['String']['input']>;
  poolOrder?: InputMaybe<Scalars['Int']['input']>;
  postLookbackDays?: InputMaybe<Scalars['Int']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  reactionLookbackDays?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  tone?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateAiAgentPoolConfigInput = {
  activeCount?: InputMaybe<Scalars['Int']['input']>;
  activeHoursEnd?: InputMaybe<Scalars['Int']['input']>;
  activeHoursStart?: InputMaybe<Scalars['Int']['input']>;
  allowedTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  approvalMode?: InputMaybe<AiAgentApprovalMode>;
  blockedTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  commentLookbackDays?: InputMaybe<Scalars['Int']['input']>;
  consecutiveFailureDisableThreshold?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxActionsPerTick?: InputMaybe<Scalars['Int']['input']>;
  maxActionsPerUserInCooldown?: InputMaybe<Scalars['Int']['input']>;
  maxCommentsPerDay?: InputMaybe<Scalars['Int']['input']>;
  maxMentionRepliesPerHour?: InputMaybe<Scalars['Int']['input']>;
  maxMinutesBetweenActions?: InputMaybe<Scalars['Int']['input']>;
  maxPostsPerDay?: InputMaybe<Scalars['Int']['input']>;
  maxReactionsPerDay?: InputMaybe<Scalars['Int']['input']>;
  maxRepliesPerDay?: InputMaybe<Scalars['Int']['input']>;
  maxRepliesPerThread?: InputMaybe<Scalars['Int']['input']>;
  maxRepliesPerUserPerHour?: InputMaybe<Scalars['Int']['input']>;
  minMinutesBetweenActions?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  postGapMaxMinutes?: InputMaybe<Scalars['Int']['input']>;
  postGapMinMinutes?: InputMaybe<Scalars['Int']['input']>;
  postLookbackDays?: InputMaybe<Scalars['Int']['input']>;
  reactionLookbackDays?: InputMaybe<Scalars['Int']['input']>;
  sameAuthorCooldownHours?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  userCooldownMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateArticleInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  coverImageUrl?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ArticleStatus>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAvailabilityInput = {
  schedulingId: Scalars['ID']['input'];
  weeklyAvailability: SchedulingWeeklyAvailabilityInput;
};

export type UpdateBookingStatusInput = {
  id: Scalars['ID']['input'];
  status: BookingStatus;
};

export type UpdateBroadcastInput = {
  audience?: InputMaybe<BroadcastAudienceInput>;
  channels?: InputMaybe<Array<BroadcastChannel>>;
  /** Plain-text email body (no HTML). */
  emailBody?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** In-app notification text. Required when the In-app channel is on. */
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** App module the in-app notification opens when tapped. Omit/null = the notification is not clickable. */
  redirectTarget?: InputMaybe<BroadcastRedirectTarget>;
};

export type UpdateCampaignInput = {
  adFormat?: InputMaybe<AdFormat>;
  campaignId: Scalars['ID']['input'];
  ctaText?: InputMaybe<Scalars['String']['input']>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationDays?: InputMaybe<Scalars['Int']['input']>;
  durationHours?: InputMaybe<Scalars['Float']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  mediaUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  objective?: InputMaybe<CampaignObjective>;
  targetCompanyTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  targetEducationLevels?: InputMaybe<Array<Scalars['String']['input']>>;
  targetExperienceLevels?: InputMaybe<Array<Scalars['String']['input']>>;
  targetLocations?: InputMaybe<Array<Scalars['String']['input']>>;
  targetRoles?: InputMaybe<Array<Role>>;
  targetSpecializations?: InputMaybe<Array<Expertise>>;
};

export type UpdateCaseMediaInput = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Float']['input'];
  step: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type UpdateCasePostInput = {
  casemedia: Array<UpdateCaseMediaInput>;
  postId: Scalars['String']['input'];
};

export type UpdateCommentInput = {
  commentId: Scalars['ID']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  mediaURL?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  industry?: InputMaybe<Scalars['String']['input']>;
  mission?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgType?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  story?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCouponInput = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  discountPrice?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  serviceId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalCoupons?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateCourseCategoryInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCourseDocumentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  orderIndex?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCourseInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  difficultyLevel?: InputMaybe<DifficultyLevel>;
  durationMinutes?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  introVideoUrl?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  modules?: InputMaybe<Array<UpdateCourseModuleInput>>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCourseModuleInput = {
  documents?: InputMaybe<Array<UpdateCourseDocumentInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lectures?: InputMaybe<Array<UpdateLectureInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: InputMaybe<Scalars['Float']['input']>;
  quizzes?: InputMaybe<Array<UpdateQuizInput>>;
};

export type UpdateCuratedReelInput = {
  channelTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDigitalCardVisibilityInput = {
  about?: InputMaybe<Scalars['Boolean']['input']>;
  education?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  experience?: InputMaybe<Scalars['Boolean']['input']>;
  expertise?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  socialLinks?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEventInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  maxAttendees?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateFaqInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  question?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGroupInput = {
  coverImage?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<Scalars['String']['input']>;
  profileImage?: InputMaybe<Scalars['String']['input']>;
  reviewPosts?: InputMaybe<Scalars['Boolean']['input']>;
  rules?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateLectureInput = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  handoutDocumentsUrl?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  orderIndex?: InputMaybe<Scalars['Float']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLegalInstructionInput = {
  id: Scalars['ID']['input'];
  pdfUrl?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLibraryCollectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLibraryFolderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLibraryShareRoleInput = {
  role: LibraryShareRole;
  shareId: Scalars['ID']['input'];
};

export type UpdateLibraryTagInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateMemberRoleInput = {
  groupId: Scalars['String']['input'];
  newRole: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateNewsletterAutomationInput = {
  aiInstructions: Scalars['String']['input'];
  /** 1-31, clamped to the actual month length */
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  enabled: Scalars['Boolean']['input'];
  frequency: NewsletterAutomationFrequency;
  generationLeadTimeMinutes: Scalars['Int']['input'];
  intervalDays?: InputMaybe<Scalars['Int']['input']>;
  /** "HH:mm", local to `timezone` */
  timeOfDay: Scalars['String']['input'];
  /** IANA timezone, e.g. America/Chicago */
  timezone: Scalars['String']['input'];
  /** 1-7, Monday-Sunday */
  weekday?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateNewsletterDraftInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePermissionActionsInput = {
  actions: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdatePlatformSettingsInput = {
  advertisingHourlyRateCents?: InputMaybe<Scalars['Int']['input']>;
  commissionRate?: InputMaybe<Scalars['Float']['input']>;
  paymentGraceDays?: InputMaybe<Scalars['Int']['input']>;
  postBoostHourlyRateCents?: InputMaybe<Scalars['Int']['input']>;
  profileBoostHourlyRateCents?: InputMaybe<Scalars['Int']['input']>;
  trialDays?: InputMaybe<Scalars['Int']['input']>;
  trialEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePodcastSourceInput = {
  autoPublish?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePostInputForBoth = {
  content?: InputMaybe<Scalars['String']['input']>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  mediaIds?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  mentions?: InputMaybe<Array<Scalars['String']['input']>>;
  postId: Scalars['String']['input'];
  privacy?: InputMaybe<PostPrivacy>;
  repostComment?: InputMaybe<Scalars['String']['input']>;
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProfileBoostPackInput = {
  appleProductId?: InputMaybe<Scalars['String']['input']>;
  googleProductId?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  priceCents?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateQuizInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  orderIndex?: InputMaybe<Scalars['Float']['input']>;
  passingScore?: InputMaybe<Scalars['Float']['input']>;
  questions?: InputMaybe<Array<UpdateQuizQuestionInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQuizOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  optionText?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateQuizQuestionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  options?: InputMaybe<Array<UpdateQuizOptionInput>>;
  orderIndex?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  questionText?: InputMaybe<Scalars['String']['input']>;
  questionType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReelInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  reelId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReferralCampaignInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRssSourceInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScheduleInput = {
  postId: Scalars['String']['input'];
  scheduledAt: Scalars['String']['input'];
};

export type UpdateSchedulingInput = {
  bufferAfter?: InputMaybe<Scalars['Int']['input']>;
  bufferBefore?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locationType?: InputMaybe<SchedulingLocationType>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSelectedBadgesInput = {
  badgeKeys: Array<Scalars['String']['input']>;
  nameBadgeKey?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateServiceInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  langitude?: InputMaybe<Scalars['Float']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<PriceType>;
  serviceStatus?: InputMaybe<ServiceStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ServiceType>;
};

export type UpdateSigningDocumentInput = {
  expiresInDays?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reminderEveryDays?: InputMaybe<Scalars['Int']['input']>;
  requireSigningOrder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSigningFieldInput = {
  documentId: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
  height?: InputMaybe<Scalars['Float']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  recipientId?: InputMaybe<Scalars['ID']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateSigningRecipientInput = {
  documentId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientId: Scalars['ID']['input'];
  role?: InputMaybe<SigningRecipientRole>;
  signingOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSigningTemplateInput = {
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSourceCompanyInput = {
  cons?: InputMaybe<Array<SourcePointInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pros?: InputMaybe<Array<SourcePointInput>>;
};

export type UpdateSponsorshipEventInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSponsorshipPlanInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceCents?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSubscriberInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubscriptionPlanInput = {
  accessAIChatbot?: InputMaybe<Scalars['Boolean']['input']>;
  actionButtonOnProfile?: InputMaybe<Scalars['Boolean']['input']>;
  appleProductId?: InputMaybe<Scalars['String']['input']>;
  companyPages?: InputMaybe<Scalars['Int']['input']>;
  connectionSendingLimits?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  googleProductId?: InputMaybe<Scalars['String']['input']>;
  groupCreation?: InputMaybe<Scalars['Int']['input']>;
  liveStreaming?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceMonthly?: InputMaybe<Scalars['Float']['input']>;
  serviceListings?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateVideoSourceInput = {
  autoPublish?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  includeShorts?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  syncMode?: InputMaybe<VideoSourceSyncMode>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpgradeCheckoutPreview = {
  __typename?: 'UpgradeCheckoutPreview';
  amountDueAfterDiscountCents: Scalars['Int']['output'];
  amountDueCents: Scalars['Int']['output'];
  couponCode?: Maybe<Scalars['String']['output']>;
  couponType?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  currentPlanPriceMonthly: Scalars['Float']['output'];
  discountCents: Scalars['Int']['output'];
  discountPercent?: Maybe<Scalars['Int']['output']>;
  newPlanPriceMonthly: Scalars['Float']['output'];
};

export type UploadBannerImageInput = {
  image: Scalars['Upload']['input'];
};

export type UploadCommentMediaInput = {
  image: Scalars['Upload']['input'];
};

export type UploadGroupImagesInput = {
  coverImage: Scalars['Upload']['input'];
  profileImage: Scalars['Upload']['input'];
};

export type UploadPodcastEpisodeInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  /** Storage key returned by uploadMedia for the cover image */
  coverImageUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  mediaType: PodcastMediaType;
  rawUrl: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};

export type UploadPostMediaInput = {
  media: Scalars['Upload']['input'];
  mediaType: AllowedPostMediaTypes;
  module?: InputMaybe<MediaModule>;
};

export type UploadProfileImageInput = {
  image: Scalars['Upload']['input'];
};

export type UpsertAchievementDefinitionInput = {
  active?: Scalars['Boolean']['input'];
  artworkUrl?: InputMaybe<Scalars['String']['input']>;
  createOnly?: InputMaybe<Scalars['Boolean']['input']>;
  criteria: Scalars['JSON']['input'];
  description: Scalars['String']['input'];
  expiresAfterDays?: InputMaybe<Scalars['Int']['input']>;
  family: AchievementFamily;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tier: Scalars['Int']['input'];
};

export type UpsertKnowledgeArticleInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  /** Omit to create. */
  id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<KnowledgeArticleStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertLibraryNoteInput = {
  body: Scalars['String']['input'];
  itemId: Scalars['ID']['input'];
};

export type UpsertSupportCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** Omit to create. */
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Machine key (create only, uppercase). Auto-derived from name if omitted. */
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type User = {
  __typename?: 'User';
  Sociallinks?: Maybe<Scalars['String']['output']>;
  about?: Maybe<Scalars['String']['output']>;
  bannerImageOptimizedUrl?: Maybe<Scalars['String']['output']>;
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  boostEndsAt?: Maybe<Scalars['DateTime']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dentalLicenseNumber?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  expertise?: Maybe<Expertise>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<Gender>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Badge the user chose to show beside their name (opt-in, null when none). Batched per request. */
  influenceBadge?: Maybe<AchievementBadge>;
  isBoosted?: Maybe<Scalars['Boolean']['output']>;
  isEmailVerified?: Maybe<Scalars['Boolean']['output']>;
  isHiring?: Maybe<Scalars['Boolean']['output']>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mentorSettings?: Maybe<MentorSettings>;
  middleName?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  openToWork?: Maybe<Scalars['Boolean']['output']>;
  phone: Scalars['String']['output'];
  profileImageOptimizedUrl?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  profileVisitsCount: Scalars['Float']['output'];
  referralSource?: Maybe<UserReferralSource>;
  role: Role;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UserStatus>;
  title?: Maybe<Scalars['String']['output']>;
  universityEmail?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserAchievementView = {
  __typename?: 'UserAchievementView';
  badge: AchievementBadge;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  target: Scalars['Int']['output'];
  unlockedAt: Scalars['DateTime']['output'];
};

export type UserBasicInfo = {
  __typename?: 'UserBasicInfo';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  /** Badge the user chose to show beside their name (opt-in, null when none). Batched per request. */
  influenceBadge?: Maybe<AchievementBadge>;
  name: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  title?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type UserConnectionCountInput = {
  userId: Scalars['String']['input'];
};

export type UserFilter = {
  referralCampaignId?: InputMaybe<Scalars['ID']['input']>;
  referralOwnerUserId?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Role>;
  status?: InputMaybe<UserStatus>;
};

export type UserGql = {
  __typename?: 'UserGQL';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEmailVerified: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  userPermissions?: Maybe<Array<Maybe<UserPermissionGql>>>;
};

export type UserHeadlineInput = {
  headline: Scalars['String']['input'];
};

export type UserPermissionGql = {
  __typename?: 'UserPermissionGQL';
  id: Scalars['ID']['output'];
  permission: PermissionGql;
};

export type UserPreview = {
  __typename?: 'UserPreview';
  about?: Maybe<Scalars['String']['output']>;
  boostEndsAt?: Maybe<Scalars['DateTime']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  headline: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Badge the user chose to show beside their name (opt-in, null when none). Batched per request. */
  influenceBadge?: Maybe<AchievementBadge>;
  isBoosted?: Maybe<Scalars['Boolean']['output']>;
  isHiring?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  openToWork?: Maybe<Scalars['Boolean']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalConnections: Scalars['Float']['output'];
};

export type UserReferralSource = {
  __typename?: 'UserReferralSource';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: ReferralType;
};

export type UserSessionCountInput = {
  userId: Scalars['String']['input'];
};

export enum UserStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inreview = 'INREVIEW',
  PendingPayment = 'PENDING_PAYMENT',
  Rejected = 'REJECTED',
  Suspended = 'SUSPENDED'
}

export type UserSubscription = {
  __typename?: 'UserSubscription';
  accessState?: Maybe<Scalars['String']['output']>;
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  coupon?: Maybe<UserSubscriptionCouponSummary>;
  couponId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  graceEndsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invoices?: Maybe<Array<SubscriptionInvoice>>;
  paymentFailedAt?: Maybe<Scalars['DateTime']['output']>;
  pendingCoupon?: Maybe<UserSubscriptionCouponSummary>;
  pendingCouponId?: Maybe<Scalars['String']['output']>;
  pendingPlan?: Maybe<SubscriptionPlan>;
  pendingPlanId?: Maybe<Scalars['String']['output']>;
  plan: SubscriptionPlan;
  planId: Scalars['String']['output'];
  planLimitsPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  planSnapshot?: Maybe<Scalars['JSON']['output']>;
  status: SubscriptionStatus;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeDiscountId?: Maybe<Scalars['String']['output']>;
  stripePromotionCodeId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  trialEndsAt?: Maybe<Scalars['DateTime']['output']>;
  trialStartsAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<SubscriptionUserProfile>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserSubscriptionCouponSummary = {
  __typename?: 'UserSubscriptionCouponSummary';
  code: Scalars['String']['output'];
  discountPercent: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type VerifyEmailInput = {
  email: Scalars['String']['input'];
  verificationToken: Scalars['String']['input'];
};

export type VerifyMentorInput = {
  userId: Scalars['String']['input'];
  verified: Scalars['Boolean']['input'];
};

export type VerifyMobileSubscriptionInput = {
  pendingSignupId: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  purchaseToken?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyMobileSubscriptionResult = {
  __typename?: 'VerifyMobileSubscriptionResult';
  message: Scalars['String']['output'];
  paymentStatus: SignupPaymentStatus;
  pendingSignupId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

/** External video platform for curated reels (YOUTUBE, VIMEO, TIKTOK) */
export enum VideoProvider {
  Tiktok = 'TIKTOK',
  Vimeo = 'VIMEO',
  Youtube = 'YOUTUBE'
}

export type VideoSourceModel = {
  __typename?: 'VideoSourceModel';
  autoPublish: Scalars['Boolean']['output'];
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  handle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  includeShorts: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  lastSyncError?: Maybe<Scalars['String']['output']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  provider: VideoProvider;
  syncMode: VideoSourceSyncMode;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  /** Number of curated videos linked to this source */
  videoCount: Scalars['Int']['output'];
};

/** Curated-reel source ingestion mode (AUTO = job lists uploads, MANUAL = admin adds by URL) */
export enum VideoSourceSyncMode {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export type VideoSourcesPaginatedResponse = {
  __typename?: 'VideoSourcesPaginatedResponse';
  data: Array<VideoSourceModel>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type VideoSyncResult = {
  __typename?: 'VideoSyncResult';
  created: Scalars['Int']['output'];
  errors: Array<Scalars['String']['output']>;
  sourcesProcessed: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type WeeklyAvailability = {
  __typename?: 'WeeklyAvailability';
  day: Day;
  times: Array<TimeRange>;
};

export type WeeklyAvailabilityInput = {
  day: Day;
  times: Array<TimeRangeInput>;
};

/** The difficulty level of the course (BEGINNER, INTERMEDIATE, ADVANCED) */
export enum DifficultyLevel {
  Advanced = 'ADVANCED',
  Beginner = 'BEGINNER',
  Intermediate = 'INTERMEDIATE'
}

export type OrganizedBy = {
  __typename?: 'organizedBy';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Badge the user chose to show beside their name (opt-in, null when none). Batched per request. */
  influenceBadge?: Maybe<AchievementBadge>;
  name?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserInfo = {
  __typename?: 'userInfo';
  /** Industry partner's company name (null for other roles). */
  companyName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type IsMentorVerifiedQueryVariables = Exact<{
  mentorId: Scalars['String']['input'];
}>;


export type IsMentorVerifiedQuery = { __typename?: 'Query', isMentorVerified: boolean };

export type AcceptSessionMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type AcceptSessionMutation = { __typename?: 'Mutation', acceptBooking: boolean };

export type AddActionButtonMutationVariables = Exact<{
  input: AddActionButtonInput;
}>;


export type AddActionButtonMutation = { __typename?: 'Mutation', addActionButton: boolean };

export type UpdateActionButtonMutationVariables = Exact<{
  input: UpdateActionButtonInput;
}>;


export type UpdateActionButtonMutation = { __typename?: 'Mutation', updateActionButton: boolean };

export type GetActionButtonsByUserIdQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetActionButtonsByUserIdQuery = { __typename?: 'Query', getActionButtonsByUserId: Array<{ __typename?: 'ActionButton', id: string, userId?: string | null, companyId?: string | null, name: string, url: string, isShow: boolean, createdAt: any }> };

export type GetActionButtonByCompanyIdQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type GetActionButtonByCompanyIdQuery = { __typename?: 'Query', getActionButtonByCompanyId?: { __typename?: 'ActionButton', id: string, userId?: string | null, companyId?: string | null, name: string, url: string, isShow: boolean, createdAt: any } | null };

export type GetAllImagesByUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllImagesByUserQuery = { __typename?: 'Query', getAllImagesByUser: Array<{ __typename?: 'ActivityMedia', id: string, fileUrl: string, postId: string, createdAt: any }> };

export type GetAllVideosByUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllVideosByUserQuery = { __typename?: 'Query', getAllVideosByUser: Array<{ __typename?: 'ActivityMedia', id: string, fileUrl: string, postId: string, createdAt: any }> };

export type GetAllCommentsByUserPostsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllCommentsByUserPostsQuery = { __typename?: 'Query', getAllCommentsByUserPosts: Array<{ __typename?: 'GetUserAllComments', id: string, postId: string, userId: string, content: string, translatedContent?: string | null, mediaUrls?: Array<string> | null, createdAt: any, updatedAt: any, user: { __typename?: 'userInfo', id: string, firstName: string, lastName: string, title?: string | null, companyName?: string | null } }> };

export type CreateCampaignMutationVariables = Exact<{
  input: CreateCampaignInput;
}>;


export type CreateCampaignMutation = { __typename?: 'Mutation', createCampaign: { __typename?: 'Campaign', id: string, name: string, objective: CampaignObjective, status: CampaignStatus, purchasedDurationSeconds: number, remainingDurationSeconds: number, totalPaidCents: number, adFormat: AdFormat, headline: string, description: string, mediaUrls: Array<string>, ctaText?: string | null, ctaUrl?: string | null, targetRoles: Array<Role>, targetSpecializations: Array<Expertise>, targetLocations: Array<string>, targetExperienceLevels: Array<string>, targetEducationLevels: Array<string>, targetCompanyTypes: Array<string>, impressions: number, clicks: number, createdAt: any, updatedAt: any, user?: { __typename?: 'CampaignOwner', id: string, firstName: string, lastName?: string | null, title?: string | null, organizationName?: string | null, role: Role, companyName?: string | null } | null } };

export type UpdateCampaignMutationVariables = Exact<{
  input: UpdateCampaignInput;
}>;


export type UpdateCampaignMutation = { __typename?: 'Mutation', updateCampaign: { __typename?: 'Campaign', id: string, name: string, objective: CampaignObjective, status: CampaignStatus, purchasedDurationSeconds: number, remainingDurationSeconds: number, headline: string, description: string, mediaUrls: Array<string>, ctaText?: string | null, ctaUrl?: string | null, updatedAt: any } };

export type DeleteCampaignMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type DeleteCampaignMutation = { __typename?: 'Mutation', deleteCampaign: boolean };

export type CancelCampaignMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CancelCampaignMutation = { __typename?: 'Mutation', cancelCampaign: { __typename?: 'Campaign', id: string, status: CampaignStatus } };

export type PauseCampaignMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type PauseCampaignMutation = { __typename?: 'Mutation', pauseCampaign: { __typename?: 'Campaign', id: string, status: CampaignStatus, remainingDurationSeconds: number } };

export type ResumeCampaignMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type ResumeCampaignMutation = { __typename?: 'Mutation', resumeCampaign: { __typename?: 'Campaign', id: string, status: CampaignStatus, remainingDurationSeconds: number } };

export type InitializeCampaignPaymentMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  durationHours?: InputMaybe<Scalars['Float']['input']>;
  durationDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InitializeCampaignPaymentMutation = { __typename?: 'Mutation', initializeCampaignPayment: { __typename?: 'CampaignPaymentInit', clientSecret: string, paymentIntentId: string, amountCents: number, hourlyRateCents: number, durationSeconds: number, publishableKey: string, purchaseId: string } };

export type ConfirmCampaignPaymentMutationVariables = Exact<{
  paymentIntentId: Scalars['String']['input'];
}>;


export type ConfirmCampaignPaymentMutation = { __typename?: 'Mutation', confirmCampaignPayment: { __typename?: 'Campaign', id: string, status: CampaignStatus, submittedAt?: any | null } };

export type InitializeCampaignExtensionMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  durationHours?: InputMaybe<Scalars['Float']['input']>;
  durationDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InitializeCampaignExtensionMutation = { __typename?: 'Mutation', initializeCampaignExtension: { __typename?: 'CampaignPaymentInit', clientSecret: string, paymentIntentId: string, amountCents: number, hourlyRateCents: number, durationSeconds: number, publishableKey: string, purchaseId: string } };

export type ConfirmCampaignExtensionMutationVariables = Exact<{
  paymentIntentId: Scalars['String']['input'];
}>;


export type ConfirmCampaignExtensionMutation = { __typename?: 'Mutation', confirmCampaignExtension: { __typename?: 'Campaign', id: string, remainingDurationSeconds: number, purchasedDurationSeconds: number, totalPaidCents: number } };

export type RecordAdClickMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type RecordAdClickMutation = { __typename?: 'Mutation', recordAdClick: boolean };

export type RecordAdImpressionMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  placement?: InputMaybe<AdPlacement>;
}>;


export type RecordAdImpressionMutation = { __typename?: 'Mutation', recordAdImpression: boolean };

export type MyCampaignsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<CampaignStatus>;
}>;


export type MyCampaignsQuery = { __typename?: 'Query', myCampaigns: { __typename?: 'PaginatedCampaigns', total: number, page: number, limit: number, totalPages: number, hasMore: boolean, data: Array<{ __typename?: 'Campaign', id: string, name: string, source: CampaignSource, objective: CampaignObjective, status: CampaignStatus, purchasedDurationSeconds: number, remainingDurationSeconds: number, consumedActiveSeconds: number, totalPaidCents: number, amountPaid: number, impressions: number, clicks: number, ctr: string, adFormat: AdFormat, mediaUrls: Array<string>, targetRoles: Array<Role>, targetSpecializations: Array<Expertise>, createdAt: any, updatedAt: any, submittedAt?: any | null, approvedAt?: any | null, startedAt?: any | null, completedAt?: any | null, rejectedAt?: any | null, user?: { __typename?: 'CampaignOwner', id: string, firstName: string, lastName?: string | null, title?: string | null, organizationName?: string | null, role: Role, companyName?: string | null } | null }> } };

export type CampaignByIdQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignByIdQuery = { __typename?: 'Query', campaignById: { __typename?: 'Campaign', id: string, name: string, source: CampaignSource, objective: CampaignObjective, status: CampaignStatus, targetRoles: Array<Role>, targetSpecializations: Array<Expertise>, targetLocations: Array<string>, targetExperienceLevels: Array<string>, targetEducationLevels: Array<string>, targetCompanyTypes: Array<string>, purchasedDurationSeconds: number, remainingDurationSeconds: number, consumedActiveSeconds: number, totalPaidCents: number, amountPaid: number, adFormat: AdFormat, headline: string, description: string, mediaUrls: Array<string>, ctaText?: string | null, ctaUrl?: string | null, impressions: number, clicks: number, ctr: string, reviewedBy?: string | null, reviewedAt?: any | null, rejectionReason?: string | null, submittedAt?: any | null, approvedAt?: any | null, startedAt?: any | null, completedAt?: any | null, rejectedAt?: any | null, refundedAt?: any | null, createdAt: any, updatedAt: any, user?: { __typename?: 'CampaignOwner', id: string, firstName: string, lastName?: string | null, title?: string | null, organizationName?: string | null, role: Role, city?: string | null, state?: string | null, profileImageUrl?: string | null, companyName?: string | null } | null } };

export type MyCampaignStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCampaignStatsQuery = { __typename?: 'Query', myCampaignStats: { __typename?: 'CampaignStats', totalCampaigns: number, activeCampaigns: number, pausedCampaigns: number, draftCampaigns: number, pendingApprovalCampaigns: number, completedCampaigns: number, totalImpressions: number, totalClicks: number, ctr: string } };

export type MyCampaignChartDataQueryVariables = Exact<{
  range?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyCampaignChartDataQuery = { __typename?: 'Query', myCampaignChartData: { __typename?: 'CampaignChartData', categories: Array<string>, impressions: Array<number>, clicks: Array<number> } };

export type CampaignDailyStatsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignDailyStatsQuery = { __typename?: 'Query', campaignDailyStats: { __typename?: 'CampaignChartData', categories: Array<string>, impressions: Array<number>, clicks: Array<number> } };

export type MyTopPerformingAdsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyTopPerformingAdsQuery = { __typename?: 'Query', myTopPerformingAds: Array<{ __typename?: 'Campaign', id: string, name: string, objective: CampaignObjective, status: CampaignStatus, adFormat: AdFormat, mediaUrls: Array<string>, optimizedMediaUrls?: Array<string> | null, impressions: number, clicks: number, createdAt: any }> };

export type TargetedAdsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TargetedAdsQuery = { __typename?: 'Query', targetedAds: Array<{ __typename?: 'Campaign', id: string, name: string, headline: string, description: string, adFormat: AdFormat, mediaUrls: Array<string>, ctaText?: string | null, ctaUrl?: string | null, impressions: number, clicks: number, user?: { __typename?: 'CampaignOwner', id: string, organizationName?: string | null, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null } | null }> };

export type AdvertisingHourlyRateQueryVariables = Exact<{ [key: string]: never; }>;


export type AdvertisingHourlyRateQuery = { __typename?: 'Query', advertisingHourlyRate: { __typename?: 'AdvertisingHourlyRate', hourlyRateCents: number } };

export type PreviewCampaignCostQueryVariables = Exact<{
  durationHours?: InputMaybe<Scalars['Float']['input']>;
  durationDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PreviewCampaignCostQuery = { __typename?: 'Query', previewCampaignCost: { __typename?: 'CampaignCostPreview', durationSeconds: number, hourlyRateCents: number, amountCents: number } };

export type CampaignPurchasesQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignPurchasesQuery = { __typename?: 'Query', campaignPurchases: Array<{ __typename?: 'CampaignPurchaseRecord', id: string, campaignId: string, type: string, durationSeconds: number, hourlyRateCents: number, amountCents: number, status: string, createdAt: any }> };

export type CreateArticleMutationVariables = Exact<{
  input: CreateArticleInput;
}>;


export type CreateArticleMutation = { __typename?: 'Mutation', createArticle: { __typename?: 'Article', id: string, title: string, slug: string, status: ArticleStatus, content: string, coverImageUrl?: string | null, subtitle?: string | null, metaTitle?: string | null, metaDescription?: string | null, tags: Array<string>, viewCount: number, readingTimeMinutes: number, createdAt: any, author: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null }, post?: { __typename?: 'Post', id: string, company?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null } | null } | null } };

export type UpdateArticleMutationVariables = Exact<{
  input: UpdateArticleInput;
}>;


export type UpdateArticleMutation = { __typename?: 'Mutation', updateArticle: { __typename?: 'Article', id: string, title: string, slug: string, status: ArticleStatus, content: string, coverImageUrl?: string | null, subtitle?: string | null, metaTitle?: string | null, metaDescription?: string | null, tags: Array<string>, viewCount: number, readingTimeMinutes: number, updatedAt: any } };

export type PublishArticleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PublishArticleMutation = { __typename?: 'Mutation', publishArticle: { __typename?: 'Article', id: string, status: ArticleStatus, updatedAt: any } };

export type ArchiveArticleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveArticleMutation = { __typename?: 'Mutation', archiveArticle: { __typename?: 'Article', id: string, status: ArticleStatus, updatedAt: any } };

export type DeleteArticleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteArticleMutation = { __typename?: 'Mutation', deleteArticle: boolean };

export type SaveArticleMutationVariables = Exact<{
  input: SaveArticleInput;
}>;


export type SaveArticleMutation = { __typename?: 'Mutation', saveArticle: { __typename?: 'SavedArticle', id: string, articleId: string, userId: string, createdAt: any } };

export type UnsaveArticleMutationVariables = Exact<{
  input: UnsaveArticleInput;
}>;


export type UnsaveArticleMutation = { __typename?: 'Mutation', unsaveArticle: boolean };

export type GetArticleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetArticleQuery = { __typename?: 'Query', article: { __typename?: 'Article', id: string, title: string, subtitle?: string | null, content: string, coverImageUrl?: string | null, metaTitle?: string | null, metaDescription?: string | null, slug: string, status: ArticleStatus, viewCount: number, readingTimeMinutes: number, tags: Array<string>, isSaved?: boolean | null, createdAt: any, updatedAt: any, post?: { __typename?: 'Post', id: string, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null }, company?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null } | null } | null } };

export type GetArticleByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetArticleByIdQuery = { __typename?: 'Query', article: { __typename?: 'Article', id: string, title: string, subtitle?: string | null, content: string, coverImageUrl?: string | null, metaTitle?: string | null, metaDescription?: string | null, slug: string, status: ArticleStatus, viewCount: number, readingTimeMinutes: number, tags: Array<string>, isSaved?: boolean | null, createdAt: any, updatedAt: any, post?: { __typename?: 'Post', id: string, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null }, company?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null } | null } | null } };

export type GetArticleBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetArticleBySlugQuery = { __typename?: 'Query', articleBySlug: { __typename?: 'Article', id: string, title: string, subtitle?: string | null, content: string, translatedTitle?: string | null, translatedSubtitle?: string | null, translatedContent?: string | null, coverImageUrl?: string | null, metaTitle?: string | null, metaDescription?: string | null, slug: string, status: ArticleStatus, viewCount: number, readingTimeMinutes: number, tags: Array<string>, isSaved?: boolean | null, createdAt: any, updatedAt: any, companyAuthor?: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null } | null, post?: { __typename?: 'Post', id: string, commentsCount: number, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, role: Role, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> } } | null } };

export type GetMyArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyArticlesQuery = { __typename?: 'Query', myArticles: Array<{ __typename?: 'Article', id: string, title: string, subtitle?: string | null, content: string, coverImageUrl?: string | null, slug: string, status: ArticleStatus, viewCount: number, readingTimeMinutes: number, tags: Array<string>, isSaved?: boolean | null, createdAt: any, updatedAt: any, post?: { __typename?: 'Post', id: string, company?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null } | null } | null }> };

export type GetArticlesQueryVariables = Exact<{
  filters?: InputMaybe<ArticleFiltersInput>;
}>;


export type GetArticlesQuery = { __typename?: 'Query', articles: Array<{ __typename?: 'Article', id: string, title: string, subtitle?: string | null, slug: string, status: ArticleStatus, viewCount: number, readingTimeMinutes: number, tags: Array<string>, isSaved?: boolean | null, createdAt: any, author: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null }, post?: { __typename?: 'Post', id: string, company?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null } | null } | null }> };

export type GetTotalSavedArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTotalSavedArticlesQuery = { __typename?: 'Query', getTotalSavedArticles: number };

export type GetSavedArticlesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSavedArticlesQuery = { __typename?: 'Query', savedArticles: Array<{ __typename?: 'Article', id: string, title: string, subtitle?: string | null, translatedTitle?: string | null, translatedSubtitle?: string | null, translatedExcerpt?: string | null, slug: string, coverImageUrl?: string | null, content: string, status: ArticleStatus, viewCount: number, readingTimeMinutes: number, tags: Array<string>, createdAt: any, postId: string, author: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, role: Role, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }, companyAuthor?: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null } | null, post?: { __typename?: 'Post', id: string, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, role: Role, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }, company?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null } | null } | null }> };

export type UploadBannerImageMutationVariables = Exact<{
  input: UploadBannerImageInput;
}>;


export type UploadBannerImageMutation = { __typename?: 'Mutation', uploadBannerImage: { __typename?: 'Media', id: string, userId?: string | null, fileName: string, fileUrl: string, optimizedUrl?: string | null, mimeType: string, size: number, type: FileType, createdAt?: any | null, updatedAt?: any | null } };

export type DeleteBannerImageMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteBannerImageMutation = { __typename?: 'Mutation', deleteBannerImage: boolean };

export type MyWalletQueryVariables = Exact<{
  currency?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyWalletQuery = { __typename?: 'Query', myWallet?: { __typename?: 'BillingWallet', id: string, availableBalance: number, pendingBalance: number, currency: string, displayName?: string | null, walletKey?: string | null, recentTransactions?: Array<{ __typename?: 'BillingTransaction', id: string, direction: TransactionDirection, type: LedgerTransactionType, amount: number, currency: string, status: string, description?: string | null, createdAt: any }> | null } | null };

export type BookSessionMutationVariables = Exact<{
  input: BookSessionInput;
}>;


export type BookSessionMutation = { __typename?: 'Mutation', bookSession: { __typename?: 'BookSessionResult', bookingId: string, isFree: boolean } };

export type CancelConfirmedSessionMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type CancelConfirmedSessionMutation = { __typename?: 'Mutation', cancelConfirmedSession: boolean };

export type CreateCasePostMutationVariables = Exact<{
  input: CreateCasePostInput;
}>;


export type CreateCasePostMutation = { __typename?: 'Mutation', createCasePost: boolean };

export type GetCaseByPostIdQueryVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type GetCaseByPostIdQuery = { __typename?: 'Query', getCaseByPostId?: { __typename?: 'CasePostModel', id: string, postId: string, createdAt: any, updatedAt: any, media: Array<{ __typename?: 'CaseMediaModel', id: string, step: string, type: string, imageUrl?: string | null, text?: string | null, order: number, createdAt: any }> } | null };

export type UpdateCasePostMediaMutationVariables = Exact<{
  input: UpdateCasePostInput;
}>;


export type UpdateCasePostMediaMutation = { __typename?: 'Mutation', updateCasePostMedia: boolean };

export type CeCourseFieldsFragment = { __typename?: 'CeCourse', id: string, libraryItemId?: string | null, url: string, title: string, description?: string | null, imageUrl?: string | null, provider: string, instructors: Array<string>, category?: string | null, format?: string | null, deliveryMode?: CeCourseDeliveryMode | null, ceCredits?: number | null, price?: number | null, currency?: string | null, isFree?: boolean | null, publishedAt?: any | null, expiresAt?: any | null, startsAt?: any | null };

export type CeCoursesQueryVariables = Exact<{
  input?: InputMaybe<CeCoursesInput>;
}>;


export type CeCoursesQuery = { __typename?: 'Query', ceCourses: { __typename?: 'CeCoursePage', page: number, limit: number, totalCount: number, totalPages: number, items: Array<{ __typename?: 'CeCourse', id: string, libraryItemId?: string | null, url: string, title: string, description?: string | null, imageUrl?: string | null, provider: string, instructors: Array<string>, category?: string | null, format?: string | null, deliveryMode?: CeCourseDeliveryMode | null, ceCredits?: number | null, price?: number | null, currency?: string | null, isFree?: boolean | null, publishedAt?: any | null, expiresAt?: any | null, startsAt?: any | null }> } };

export type CeCourseFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type CeCourseFiltersQuery = { __typename?: 'Query', ceCourseFilters: { __typename?: 'CeCourseFilters', freeCount: number, paidCount: number, providers: Array<{ __typename?: 'CeCourseFacet', name: string, count: number }>, deliveryModes: Array<{ __typename?: 'CeCourseFacet', name: string, count: number }>, categories: Array<{ __typename?: 'CeCourseFacet', name: string, count: number }> } };

export type RoleChangeRequestMutationVariables = Exact<{ [key: string]: never; }>;


export type RoleChangeRequestMutation = { __typename?: 'Mutation', roleChangeRequest: boolean };

export type RoleChangeToggleMutationVariables = Exact<{ [key: string]: never; }>;


export type RoleChangeToggleMutation = { __typename?: 'Mutation', roleChangeToggle: boolean };

export type WithdrawRoleChangeRequestMutationVariables = Exact<{ [key: string]: never; }>;


export type WithdrawRoleChangeRequestMutation = { __typename?: 'Mutation', withdrawRoleChangeRequest: boolean };

export type CommentOnPostMutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type CommentOnPostMutation = { __typename?: 'Mutation', commentOnPost: { __typename?: 'Comment', id: string, content: string, userId: string, mediaUrls: Array<string>, createdAt?: any | null, updatedAt?: any | null, user: { __typename?: 'CommentAuthor', id: string, firstName: string, middleName?: string | null, lastName?: string | null, title?: string | null, role: Role, profileImageUrl?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } } };

export type ReplyOnCommentMutationVariables = Exact<{
  input: ReplyCommentInput;
}>;


export type ReplyOnCommentMutation = { __typename?: 'Mutation', replyOnComment: { __typename?: 'Comment', id: string, content: string, userId: string, mediaUrls: Array<string>, createdAt?: any | null, updatedAt?: any | null, user: { __typename?: 'CommentAuthor', id: string, firstName: string, middleName?: string | null, lastName?: string | null, title?: string | null, role: Role, profileImageUrl?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } } };

export type UpdateCommentMutationVariables = Exact<{
  input: UpdateCommentInput;
}>;


export type UpdateCommentMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'Comment', id: string, content: string, userId: string, mediaUrls: Array<string>, createdAt?: any | null, updatedAt?: any | null, user: { __typename?: 'CommentAuthor', id: string, firstName: string, middleName?: string | null, lastName?: string | null, title?: string | null, role: Role, profileImageUrl?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } } };

export type ToggleCommentReactionMutationVariables = Exact<{
  input: LikeCommentInput;
}>;


export type ToggleCommentReactionMutation = { __typename?: 'Mutation', toggleCommentReaction?: string | null };

export type SendUniversityGroupMessageMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
  senderId: Scalars['String']['input'];
  content: Scalars['String']['input'];
}>;


export type SendUniversityGroupMessageMutation = { __typename?: 'Mutation', sendUniversityGroupMessage: { __typename?: 'UniversityGroupMessage', id: string, content: string, createdAt: any, sender: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null } } };

export type UniversityGroupMessagesQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  messages?: InputMaybe<Scalars['Float']['input']>;
}>;


export type UniversityGroupMessagesQuery = { __typename?: 'Query', universityGroupMessages: Array<{ __typename?: 'UniversityGroupMessage', id: string, content: string, createdAt: any, sender: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null }, replies?: Array<{ __typename?: 'UniversityGroupMessage', id: string, content: string, createdAt: any, sender: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null } }> | null, parent?: { __typename?: 'UniversityGroupMessage', id: string } | null }> };

export type ReplyUniversityGroupMessageMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
  senderId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
}>;


export type ReplyUniversityGroupMessageMutation = { __typename?: 'Mutation', replyUniversityGroupMessage: { __typename?: 'UniversityGroupMessage', id: string, content: string, createdAt: any, sender: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null }, parent?: { __typename?: 'UniversityGroupMessage', id: string } | null } };

export type AccessibleCommunitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessibleCommunitiesQuery = { __typename?: 'Query', accessibleCommunities: Array<{ __typename?: 'Community', id: string, name: string, type: string, description?: string | null, logo?: string | null }> };

export type CreateCompanyMutationVariables = Exact<{
  input: CreateCompanyInput;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany: { __typename?: 'Company', id: string, name: string, slug?: string | null, type: CompanyType, ownerId: string, website?: string | null, tagline?: string | null, industry?: string | null, size?: string | null, orgType?: string | null, city?: string | null, country?: string | null, logoUrl?: string | null, coverUrl?: string | null, mission?: string | null, story?: string | null, specialties?: Array<string> | null, websiteLinks?: any | null, ctaType?: CtaType | null, ctaLabel?: string | null, ctaUrl?: string | null, hashtags?: Array<string> | null, parentId?: string | null, isDeleted: boolean, autoInvite: boolean, createdAt: any, updatedAt: any, owner?: { __typename?: 'User', id: string, email: string, firstName: string, lastName?: string | null, title?: string | null, companyName?: string | null } | null } };

export type MyCompaniesByOwnerQueryVariables = Exact<{
  ownerId: Scalars['String']['input'];
}>;


export type MyCompaniesByOwnerQuery = { __typename?: 'Query', myCompaniesByOwner: Array<{ __typename?: 'Company', id: string, name: string, slug?: string | null, website?: string | null, tagline?: string | null, industry?: string | null, size?: string | null, orgType?: string | null, logoUrl?: string | null, coverUrl?: string | null, hashtags?: Array<string> | null, specialties?: Array<string> | null, parentId?: string | null, ownerId: string, createdAt: any, updatedAt: any }> };

export type GetCompanyQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, name: string, slug?: string | null, website?: string | null, tagline?: string | null, industry?: string | null, size?: string | null, orgType?: string | null, city?: string | null, country?: string | null, mission?: string | null, story?: string | null, logoUrl?: string | null, coverUrl?: string | null, specialties?: Array<string> | null, hashtags?: Array<string> | null, parentId?: string | null, ownerId: string, status?: CompanyStatus | null, createdAt: any, updatedAt: any, owner?: { __typename?: 'User', id: string, email: string, firstName: string, lastName?: string | null, title?: string | null, companyName?: string | null } | null } | null };

export type UpdateLogoMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  logoUrl: Scalars['String']['input'];
}>;


export type UpdateLogoMutation = { __typename?: 'Mutation', updateCompanyLogo: { __typename?: 'Company', id: string, logoUrl?: string | null, coverUrl?: string | null, updatedAt: any } };

export type UpdateCoverMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  coverUrl: Scalars['String']['input'];
}>;


export type UpdateCoverMutation = { __typename?: 'Mutation', updateCompanyCover: { __typename?: 'Company', id: string, logoUrl?: string | null, coverUrl?: string | null, updatedAt: any } };

export type GetCompanyPostsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCompanyPostsQuery = { __typename?: 'Query', companyPosts: Array<{ __typename?: 'Post', id: string, isPinned: boolean, authorId?: string | null, createdAt?: any | null, updatedAt?: any | null, isPublished: boolean, commentsCount: number, mediaUrls: Array<string>, postType: PostType, companyId?: string | null, isRepost: boolean, repostComment?: string | null, isSavedByMe: boolean, isRepostedByMe?: boolean | null, isBoosted?: boolean | null, activeBoostId?: string | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, userId?: string | null, handle?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, userId?: string | null, handle?: string | null, url?: string | null }> | null, article?: { __typename?: 'Article', id: string, title: string, subtitle?: string | null, content: string, coverImageUrl?: string | null, slug: string, readingTimeMinutes: number, tags: Array<string>, status: ArticleStatus, translatedTitle?: string | null, translatedSubtitle?: string | null, translatedExcerpt?: string | null } | null, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, translatedQuestion?: string | null, translatedOptions?: Array<string> | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null, occasion?: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy, translatedTitle?: string | null, translatedDescription?: string | null } | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, profileImageUrl?: string | null, role: Role, companyName?: string | null }, companyAuthor?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null } | null, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> }, originalPost?: { __typename?: 'Post', id: string, createdAt?: any | null, mediaUrls: Array<string>, isBoosted?: boolean | null, activeBoostId?: string | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, userId?: string | null, handle?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, userId?: string | null, handle?: string | null, url?: string | null }> | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, profileImageUrl?: string | null, role: Role, companyName?: string | null }, companyAuthor?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null } | null, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, translatedQuestion?: string | null, translatedOptions?: Array<string> | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null, occasion?: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy, translatedTitle?: string | null, translatedDescription?: string | null } | null } | null }> };

export type FollowCompanyMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type FollowCompanyMutation = { __typename?: 'Mutation', followCompany: boolean };

export type UnfollowCompanyMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type UnfollowCompanyMutation = { __typename?: 'Mutation', unfollowCompany: boolean };

export type RemoveCompanyFollowerMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type RemoveCompanyFollowerMutation = { __typename?: 'Mutation', removeCompanyFollower: boolean };

export type BlockCompanyFollowerMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type BlockCompanyFollowerMutation = { __typename?: 'Mutation', blockCompanyFollower: boolean };

export type UnblockCompanyFollowerMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type UnblockCompanyFollowerMutation = { __typename?: 'Mutation', unblockCompanyFollower: boolean };

export type IsFollowingCompanyQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type IsFollowingCompanyQuery = { __typename?: 'Query', isFollowingCompany: boolean };

export type GetCompanyFollowersCountQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type GetCompanyFollowersCountQuery = { __typename?: 'Query', getCompanyFollowersCount: number };

export type GetSuggestedCompaniesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSuggestedCompaniesQuery = { __typename?: 'Query', getSuggestedCompanies: Array<{ __typename?: 'Company', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null, size?: string | null, followersCount?: number | null }> };

export type GetFollowedCompaniesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFollowedCompaniesQuery = { __typename?: 'Query', getFollowedCompanies: Array<{ __typename?: 'Company', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null, size?: string | null, followersCount?: number | null }> };

export type UpdateCompanyMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateCompanyInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'Company', id: string, name: string, tagline?: string | null, industry?: string | null, size?: string | null, website?: string | null, city?: string | null, country?: string | null, orgType?: string | null, mission?: string | null, story?: string | null } };

export type TogglePinPostMutationVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type TogglePinPostMutation = { __typename?: 'Mutation', togglePinPost: boolean };

export type GetRelatedPagesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type GetRelatedPagesQuery = { __typename?: 'Query', relatedPages: Array<{ __typename?: 'Company', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null, slug?: string | null, type: CompanyType }> };

export type FindCompaniesQueryVariables = Exact<{
  input: SearchCompaniesInput;
}>;


export type FindCompaniesQuery = { __typename?: 'Query', searchCompanies: Array<{ __typename?: 'CompanyPreview', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null, slug?: string | null }> };

export type CompanyFollowersQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CompanyFollowersQuery = { __typename?: 'Query', companyFollowers: { __typename?: 'CompanyFollowersPaginated', totalCount: number, hasMore: boolean, users: Array<{ __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, role: Role, companyName?: string | null }> } };

export type CompanyBlockedFollowersQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CompanyBlockedFollowersQuery = { __typename?: 'Query', companyBlockedFollowers: { __typename?: 'CompanyFollowersPaginated', totalCount: number, hasMore: boolean, users: Array<{ __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, role: Role, companyName?: string | null }> } };

export type DeleteCompanyMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type DeleteCompanyMutation = { __typename?: 'Mutation', deleteCompany: boolean };

export type GetFollowedCompanyIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFollowedCompanyIdsQuery = { __typename?: 'Query', getFollowedCompanyIds: Array<string> };

export type DeleteCompanyLogoMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type DeleteCompanyLogoMutation = { __typename?: 'Mutation', deleteCompanyLogo: { __typename?: 'Company', id: string, logoUrl?: string | null } };

export type DeleteCompanyCoverMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type DeleteCompanyCoverMutation = { __typename?: 'Mutation', deleteCompanyCover: { __typename?: 'Company', id: string, coverUrl?: string | null } };

export type MyCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCompaniesQuery = { __typename?: 'Query', myCompanies: Array<{ __typename?: 'Company', id: string, name: string, type: CompanyType, slug?: string | null, coverUrl?: string | null, logoUrl?: string | null, size?: string | null, status?: CompanyStatus | null, industry?: string | null, story?: string | null, createdAt: any, updatedAt: any, owner?: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null } | null }> };

export type CompleteSessionMutationVariables = Exact<{
  input: AcceptSessionInput;
}>;


export type CompleteSessionMutation = { __typename?: 'Mutation', completeSession: boolean };

export type SendConnectionRequestMutationVariables = Exact<{
  input: SendConnectionRequestInput;
}>;


export type SendConnectionRequestMutation = { __typename?: 'Mutation', sendConnectionRequest: boolean };

export type AcceptConnectionMutationVariables = Exact<{
  input: ConnectionActionInput;
}>;


export type AcceptConnectionMutation = { __typename?: 'Mutation', acceptConnection: boolean };

export type RejectConnectionMutationVariables = Exact<{
  input: ConnectionActionInput;
}>;


export type RejectConnectionMutation = { __typename?: 'Mutation', rejectConnection: boolean };

export type CancelConnectionRequestMutationVariables = Exact<{
  input: DeleteConnectionInput;
}>;


export type CancelConnectionRequestMutation = { __typename?: 'Mutation', cancelConnectionRequest: boolean };

export type DeleteConnectionMutationVariables = Exact<{
  input: DeleteConnectionInput;
}>;


export type DeleteConnectionMutation = { __typename?: 'Mutation', deleteConnection: boolean };

export type GetConnectionStatusQueryVariables = Exact<{
  input: GetConnectionStatusInput;
}>;


export type GetConnectionStatusQuery = { __typename?: 'Query', getConnectionStatus: { __typename?: 'ConnectionStatusType', status: string, direction: string } };

export type GetConnectionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConnectionStatus>;
}>;


export type GetConnectionsQuery = { __typename?: 'Query', getConnections: { __typename?: 'PaginatedConnectionsType', totalConnections: number, hasMore: boolean, page: number, limit: number, connections: Array<{ __typename?: 'ConnectionListItemType', status: string, direction: string, createdAt: any, updatedAt: any, user: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, headline?: string | null, isHiring?: boolean | null, openToWork?: boolean | null, about?: string | null, role: Role, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } }> } };

export type UserConnectionCountQueryVariables = Exact<{
  input: UserConnectionCountInput;
}>;


export type UserConnectionCountQuery = { __typename?: 'Query', userConnectionCount: number };

export type GetConnectionByUserIdQueryVariables = Exact<{
  otherUserId: Scalars['String']['input'];
}>;


export type GetConnectionByUserIdQuery = { __typename?: 'Query', getConnectionByUserId: { __typename?: 'ConnectionListItemType', status: string, direction: string, createdAt: any, updatedAt: any, user: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, companyName?: string | null } } };

export type GetAcceptedConnectionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAcceptedConnectionsQuery = { __typename?: 'Query', getAcceptedConnections: Array<{ __typename?: 'ConnectionListItemType', status: string, direction: string, createdAt: any, updatedAt: any, user: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, headline?: string | null, about?: string | null, phone: string, role: Role, email: string, profileVisitsCount: number, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } }> };

export type GetConnectionRequestsQueryVariables = Exact<{
  input: GetConnectionRequestsInput;
}>;


export type GetConnectionRequestsQuery = { __typename?: 'Query', getConnectionRequests: { __typename?: 'PaginatedConnectionsType', totalConnections: number, hasMore: boolean, page: number, limit: number, connections: Array<{ __typename?: 'ConnectionListItemType', status: string, direction: string, createdAt: any, updatedAt: any, user: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, headline?: string | null, isHiring?: boolean | null, openToWork?: boolean | null, about?: string | null, role: Role, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } }> } };

export type SearchApprovedConnectionsByLetterQueryVariables = Exact<{
  input: SearchApprovedConnectionsInput;
}>;


export type SearchApprovedConnectionsByLetterQuery = { __typename?: 'Query', searchApprovedConnectionsByLetter: Array<{ __typename?: 'Search', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, role: Role, headline?: string | null, companyName?: string | null }> };

export type AddContactMutationVariables = Exact<{
  input: AddContactInput;
}>;


export type AddContactMutation = { __typename?: 'Mutation', addContact: boolean };

export type DeleteContactMutationVariables = Exact<{
  input: DeleteContactInput;
}>;


export type DeleteContactMutation = { __typename?: 'Mutation', deleteContact: boolean };

export type EditContactMutationVariables = Exact<{
  input: EditContactInput;
}>;


export type EditContactMutation = { __typename?: 'Mutation', editContact: boolean };

export type FindExistingConversationQueryVariables = Exact<{
  receiverId: Scalars['String']['input'];
}>;


export type FindExistingConversationQuery = { __typename?: 'Query', findExistingConversation?: { __typename?: 'Conversation', id: string, type: ConversationType, lastMessage?: string | null, lastMessageAt?: any | null, companyId?: string | null, user?: { __typename?: 'ConversationMember', id: string, name: string, profileImageUrl?: string | null, role: string, companyName?: string | null } | null } | null };

export type MarkConversationAsReadMutationVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type MarkConversationAsReadMutation = { __typename?: 'Mutation', markConversationAsRead: boolean };

export type DeleteMessageMutationVariables = Exact<{
  messageId: Scalars['String']['input'];
}>;


export type DeleteMessageMutation = { __typename?: 'Mutation', deleteMessage: boolean };

export type CreateNewCourseMutationVariables = Exact<{
  input: CreateCourseInput;
}>;


export type CreateNewCourseMutation = { __typename?: 'Mutation', createCourse: { __typename?: 'Course', id: string, title: string, description: string, category: string, subcategory?: string | null, difficultyLevel: DifficultyLevel, language: string, durationMinutes: number, isPublished: boolean, thumbnailUrl?: string | null, introVideoUrl?: string | null, createdAt: any, modules?: Array<{ __typename?: 'CourseModule', id: string, name: string, orderIndex: number, lectures?: Array<{ __typename?: 'Lecture', id: string, title: string, summary?: string | null, videoUrl?: string | null, handoutDocumentsUrl?: Array<string> | null, duration?: number | null, orderIndex: number }> | null, quizzes?: Array<{ __typename?: 'Quiz', id: string, title: string, description?: string | null, passingScore: number, orderIndex: number, isPublished: boolean, questions?: Array<{ __typename?: 'QuizQuestion', id: string, questionText: string, questionType: QuizQuestionType, orderIndex: number, points: number, options?: Array<{ __typename?: 'QuizOption', id: string, optionText: string, isCorrect: boolean, orderIndex: number }> | null }> | null }> | null, documents?: Array<{ __typename?: 'CourseDocument', id: string, title: string, description?: string | null, documentUrl: string, orderIndex?: number | null }> | null }> | null } };

export type UpdateCourseMutationVariables = Exact<{
  updateCourseInput: UpdateCourseInput;
}>;


export type UpdateCourseMutation = { __typename?: 'Mutation', updateCourse: { __typename?: 'Course', id: string, title: string, description: string, category: string, subcategory?: string | null, difficultyLevel: DifficultyLevel, language: string, durationMinutes: number, isPublished: boolean, thumbnailUrl?: string | null, introVideoUrl?: string | null, instructorId?: string | null, createdAt: any, updatedAt: any, modules?: Array<{ __typename?: 'CourseModule', id: string, name: string, orderIndex: number, lectures?: Array<{ __typename?: 'Lecture', id: string, title: string, summary?: string | null, videoUrl?: string | null, handoutDocumentsUrl?: Array<string> | null, duration?: number | null, orderIndex: number }> | null, quizzes?: Array<{ __typename?: 'Quiz', id: string, title: string, description?: string | null, passingScore: number, orderIndex: number, isPublished: boolean, questions?: Array<{ __typename?: 'QuizQuestion', id: string, questionText: string, questionType: QuizQuestionType, orderIndex: number, points: number, options?: Array<{ __typename?: 'QuizOption', id: string, optionText: string, isCorrect: boolean, orderIndex: number }> | null }> | null }> | null, documents?: Array<{ __typename?: 'CourseDocument', id: string, title: string, description?: string | null, documentUrl: string, orderIndex?: number | null }> | null }> | null } };

export type DeleteCourseMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCourseMutation = { __typename?: 'Mutation', removeCourse: { __typename?: 'Course', id: string, title: string, description: string } };

export type GetMyCoursesWithPaginationQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetMyCoursesWithPaginationQuery = { __typename?: 'Query', myCourses: { __typename?: 'CoursePaginatedResponse', total: number, page: number, limit: number, totalPages: number, hasMore: boolean, data: Array<{ __typename?: 'Course', id: string, title: string, description: string, category: string, language: string, difficultyLevel: DifficultyLevel, durationMinutes: number, isPublished: boolean, createdAt: any, updatedAt: any }> } };

export type GetCourseDetailQueryVariables = Exact<{
  courseId: Scalars['String']['input'];
}>;


export type GetCourseDetailQuery = { __typename?: 'Query', course: { __typename?: 'Course', id: string, title: string, description: string, thumbnailUrl?: string | null, introVideoUrl?: string | null, category: string, difficultyLevel: DifficultyLevel, language: string, subcategory?: string | null, durationMinutes: number, instructorId?: string | null, isPublished: boolean, createdAt: any, updatedAt: any, modules?: Array<{ __typename?: 'CourseModule', id: string, name: string, orderIndex: number, courseId: string, createdAt: any, updatedAt: any, lectures?: Array<{ __typename?: 'Lecture', id: string, title: string, summary?: string | null, videoUrl?: string | null, handoutDocumentsUrl?: Array<string> | null, orderIndex: number, duration?: number | null, moduleId: string, createdAt: any, updatedAt: any }> | null, quizzes?: Array<{ __typename?: 'Quiz', id: string, title: string, description?: string | null, passingScore: number, orderIndex: number, moduleId: string, isPublished: boolean, createdAt: any, updatedAt: any, questions?: Array<{ __typename?: 'QuizQuestion', id: string, questionText: string, questionType: QuizQuestionType, orderIndex: number, points: number, quizId: string, createdAt: any, updatedAt: any, options?: Array<{ __typename?: 'QuizOption', id: string, optionText: string, isCorrect: boolean, orderIndex: number, questionId: string, createdAt: any }> | null }> | null }> | null, documents?: Array<{ __typename?: 'CourseDocument', id: string, title: string, description?: string | null, documentUrl: string, orderIndex?: number | null, moduleId: string, createdAt: any, updatedAt: any }> | null }> | null } };

export type AllCoursesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  instructors?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  reviews?: InputMaybe<Array<Scalars['Float']['input']> | Scalars['Float']['input']>;
  levels?: InputMaybe<Array<DifficultyLevel> | DifficultyLevel>;
}>;


export type AllCoursesQuery = { __typename?: 'Query', allCourses: { __typename?: 'AllCoursesPaginatedResponse', total: number, page: number, limit: number, totalPages: number, hasMore: boolean, data: Array<{ __typename?: 'CourseWithTotalLectures', id: string, libraryItemId?: string | null, title: string, description: string, category: string, difficultyLevel: DifficultyLevel, durationMinutes: number, thumbnailUrl?: string | null, language: string, isPublished: boolean, totalLectures: number, averageRating: number, totalRatings: number, createdAt: any, instructor?: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } | null }> } };

export type GetCourseDetailforUserQueryVariables = Exact<{
  courseId: Scalars['String']['input'];
}>;


export type GetCourseDetailforUserQuery = { __typename?: 'Query', courseDetail: { __typename?: 'CourseDetail', id: string, title: string, description: string, category: string, subcategory?: string | null, language: string, difficultyLevel: DifficultyLevel, durationMinutes: number, thumbnailUrl?: string | null, introVideoUrl?: string | null, isPublished: boolean, createdAt: any, updatedAt: any, completedAt?: any | null, totalEnrolledStudents: number, averageRating?: number | null, totalRatings: number, enrollmentStatus?: string | null, isEnrolledByMe: boolean, instructor?: { __typename?: 'InstructorDetail', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, role: Role, headline?: string | null, about?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } | null, modules?: Array<{ __typename?: 'ModuleDetail', id: string, name: string, orderIndex: number, lectures?: Array<{ __typename?: 'LectureDetail', id: string, title: string, summary?: string | null, videoUrl?: string | null, handoutDocumentsUrl?: Array<string> | null, orderIndex: number, duration?: number | null }> | null, quizzes?: Array<{ __typename?: 'QuizDetailWithQuestions', id: string, title: string, description?: string | null, passingScore: number, orderIndex: number, isPublished: boolean }> | null, documents?: Array<{ __typename?: 'DocumentDetail', id: string, title: string, description?: string | null, documentUrl: string, orderIndex?: number | null }> | null }> | null } };

export type GetSuggestedCoursesQueryVariables = Exact<{
  instructorId: Scalars['ID']['input'];
  courseId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSuggestedCoursesQuery = { __typename?: 'Query', suggestedCourses: { __typename?: 'SuggestedCoursesResponse', data: Array<{ __typename?: 'SuggestedCourse', id: string, title: string, description: string, thumbnailUrl?: string | null, totalStudentsEnrolled: number, totalLessons: number, instructorId: string, instructor: { __typename?: 'SuggestedCourseInstructor', id: string, firstName: string, lastName: string, title?: string | null, profileImageUrl?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } }> } };

export type EnrollCourseMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type EnrollCourseMutation = { __typename?: 'Mutation', enrollCourse: { __typename?: 'EnrollmentResponse', id: string, studentId: string, courseId: string, status: string, progressPercentage: number, enrolledAt: any, completedAt?: any | null, lecturesCompleted: number, quizzesCompleted: number, updatedAt: any, message?: string | null } };

export type LeaveCourseMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type LeaveCourseMutation = { __typename?: 'Mutation', leaveCourse: { __typename?: 'EnrollmentResponse', id: string, studentId: string, courseId: string, status: string, progressPercentage: number, enrolledAt: any, completedAt?: any | null, lecturesCompleted: number, quizzesCompleted: number, updatedAt: any, message?: string | null } };

export type GetEnrolledCoursesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetEnrolledCoursesQuery = { __typename?: 'Query', enrolledCourses: { __typename?: 'EnrolledCoursePaginatedResponse', total: number, page: number, limit: number, totalPages: number, hasMore: boolean, data: Array<{ __typename?: 'EnrolledCourse', id: string, title: string, description: string, thumbnailUrl: string, progressPercentage: number, averageRating?: number | null, totalRatings: number, category?: string | null, subcategory?: string | null, difficultyLevel?: string | null, instructor?: { __typename?: 'InstructorInfo', id: string, firstName: string, lastName: string, title?: string | null, profileImageUrl?: string | null, headline?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } | null }> } };

export type GetCourseDetailWithProgressQueryVariables = Exact<{
  courseId: Scalars['String']['input'];
}>;


export type GetCourseDetailWithProgressQuery = { __typename?: 'Query', courseDetailWithProgress: { __typename?: 'CourseDetailWithProgress', id: string, title: string, description: string, thumbnailUrl: string, introVideoUrl: string, category: string, subcategory: string, language: string, difficultyLevel: string, durationMinutes: number, isPublished: boolean, createdAt: string, updatedAt: string, overallProgress: number, completedLectures: number, totalLectures: number, completedQuizzes: number, totalQuizzes: number, totalDocuments: number, enrollmentStatus: string, isEnrolled: boolean, isCourseRatedByMe: boolean, completedAt?: string | null, enrollmentId?: string | null, instructor: { __typename?: 'InstructorInfo', id: string, firstName: string, lastName: string, title?: string | null, profileImageUrl?: string | null, headline?: string | null, about?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }, modules: Array<{ __typename?: 'ModuleWithProgress', id: string, name: string, orderIndex: number, moduleProgress: number, completedLectures: number, totalLectures: number, completedQuizzes: number, totalQuizzes: number, lectures: Array<{ __typename?: 'LectureProgress', id: string, title: string, summary?: string | null, videoUrl?: string | null, handoutDocumentsUrl?: Array<string> | null, duration?: number | null, orderIndex: number, isCompleted: boolean, isRemaining: boolean }>, quizzes: Array<{ __typename?: 'QuizProgress', id: string, title: string, description: string, passingScore: number, orderIndex: number, isPublished: boolean, canAttempt: boolean, hasAttempted: boolean, isPassed: boolean, bestScore?: number | null, attemptCount?: number | null, isRemaining: boolean, questions: Array<{ __typename?: 'QuizQuestionDetail', id: string, questionText: string, orderIndex: number, questionType: QuizQuestionType, points: number, options: Array<{ __typename?: 'QuizQuestionOptionDetail', id: string, optionText: string, orderIndex: number }> }> }>, documents: Array<{ __typename?: 'DocumentProgress', id: string, title: string, description?: string | null, documentUrl: string, orderIndex: number, isAccessible: boolean, isRemaining: boolean }> }> } };

export type MarkContentViewedMutationVariables = Exact<{
  input: MarkContentViewedInput;
}>;


export type MarkContentViewedMutation = { __typename?: 'Mutation', markContentViewed: { __typename?: 'ContentViewResponse', id: string, contentId: string, contentType: ContentViewType, success: boolean, message: string, viewedAt: any } };

export type SubmitQuizMutationVariables = Exact<{
  input: SubmitQuizInput;
}>;


export type SubmitQuizMutation = { __typename?: 'Mutation', submitQuiz: { __typename?: 'QuizAttemptResponse', id: string, quizId: string, quizTitle: string, attemptId: string, attemptNumber: number, score: number, totalPoints: number, percentage: number, passed: boolean, passingMessage?: string | null, totalQuestions: number, correctAnswers: number, startTime: any, endTime?: any | null, createdAt: any, answers: Array<{ __typename?: 'QuizAnswerResponse', questionId: string, questionText: string, questionNumber: number, selectedOptionId: string, selectedOptionText: string, correctOptionId?: string | null, correctOptionText?: string | null, isCorrect: boolean, pointsEarned: number }> } };

export type CompletedCoursesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type CompletedCoursesQuery = { __typename?: 'Query', completedCourses: { __typename?: 'AllCoursesPaginatedResponse', total: number, page: number, limit: number, totalPages: number, hasMore: boolean, data: Array<{ __typename?: 'CourseWithTotalLectures', id: string, title: string, description: string, thumbnailUrl?: string | null, introVideoUrl?: string | null, category: string, subcategory?: string | null, language: string, difficultyLevel: DifficultyLevel, durationMinutes: number, isPublished: boolean, createdAt: any, updatedAt: any, totalLectures: number, completedAt?: string | null, instructor?: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, headline?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } | null }> } };

export type CourseStudentStatsQueryVariables = Exact<{
  courseId: Scalars['String']['input'];
}>;


export type CourseStudentStatsQuery = { __typename?: 'Query', courseStudentStats: { __typename?: 'StatsResponse', total: number, completed: number, active: number } };

export type CourseContentStatsQueryVariables = Exact<{
  courseId: Scalars['String']['input'];
}>;


export type CourseContentStatsQuery = { __typename?: 'Query', courseContentStats: { __typename?: 'CourseContentStatsResponse', lectures: Array<{ __typename?: 'LectureStats', id: string, title: string, totalStudentsViewed: number, percentageViewed: number }>, quizzes: Array<{ __typename?: 'QuizStats', id: string, title: string, percentagePassed: number }> } };

export type EnrolledStudentsByCourseAndMonthQueryVariables = Exact<{
  courseId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EnrolledStudentsByCourseAndMonthQuery = { __typename?: 'Query', enrolledStudentsByCourseAndMonth: { __typename?: 'EnrolledStudentStatsPaginatedResponse', total: number, page: number, limit: number, totalPages: number, hasMore: boolean, data: Array<{ __typename?: 'EnrolledStudentStats', studentId: string, firstName: string, lastName?: string | null, title?: string | null, dateJoined: any, courseProgress: number, totalQuizzes: number, quizzesCompleted: number, totalLessons: number, lessonsCompleted: number, companyName?: string | null }> } };

export type QuizAttemptStatusQueryVariables = Exact<{
  quizId: Scalars['String']['input'];
  enrollmentId: Scalars['String']['input'];
}>;


export type QuizAttemptStatusQuery = { __typename?: 'Query', quizAttemptStatus: { __typename?: 'QuizAttemptStatusResponse', status: string, id?: string | null, quizId?: string | null, enrollmentId?: string | null, score?: number | null, totalPoints?: number | null, percentage?: number | null, startTime?: any | null, endTime?: any | null, createdAt?: any | null, updatedAt?: any | null, questions?: Array<{ __typename?: 'QuizAttemptQuestion', questionId: string, questionText: string, questionType: string, options: Array<{ __typename?: 'QuizAttemptOption', id: string, optionText: string, isCorrect: boolean, orderIndex: number }>, studentAnswer?: { __typename?: 'QuizAttemptStudentAnswer', optionId: string, optionText: string, isCorrect: boolean, pointsEarned: number } | null, correctOption?: { __typename?: 'QuizAttemptCorrectOption', optionId: string, optionText: string } | null }> | null } };

export type RateCourseMutationVariables = Exact<{
  courseId: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
}>;


export type RateCourseMutation = { __typename?: 'Mutation', rateCourse: boolean };

export type GenerateCertificateMutationVariables = Exact<{
  courseId: Scalars['String']['input'];
}>;


export type GenerateCertificateMutation = { __typename?: 'Mutation', generateCertificate: string };

export type GetCourseFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCourseFiltersQuery = { __typename?: 'Query', filters: { __typename?: 'FiltersResponseEntity', categories: Array<{ __typename?: 'FilterCategoryEntity', name: string, count: number }>, instructors: Array<{ __typename?: 'FilterInstructorEntity', name: string, count: number }>, reviews: Array<{ __typename?: 'FilterReviewEntity', rating: number, count: number }>, levels: Array<{ __typename?: 'FilterLevelEntity', name: string, count: number }> } };

export type GetAllCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCategoriesQuery = { __typename?: 'Query', allCategories: Array<{ __typename?: 'CourseCategory', id: string, name: string, parentId?: string | null, children?: Array<{ __typename?: 'CourseCategory', id: string, name: string, parentId?: string | null }> | null }> };

export type CreateSessionPaymentIntentMutationVariables = Exact<{
  bookingId: Scalars['String']['input'];
}>;


export type CreateSessionPaymentIntentMutation = { __typename?: 'Mutation', createSessionPaymentIntent: { __typename?: 'PaymentIntentResult', clientSecret: string, paymentIntentId: string, amount: number, currency: string, publishableKey: string } };

export type UploadPostMediaMutationVariables = Exact<{
  input: UploadPostMediaInput;
}>;


export type UploadPostMediaMutation = { __typename?: 'Mutation', uploadPostMedia: { __typename?: 'Media', id: string, createdAt?: any | null, updatedAt?: any | null, userId?: string | null, fileName: string, fileUrl: string, optimizedUrl?: string | null, mimeType: string, size: number, type: FileType } };

export type CreatePostMutationVariables = Exact<{
  input: CreatePostInput;
}>;


export type CreatePostMutation = { __typename?: 'Mutation', createPost: boolean };

export type CreateRepostMutationVariables = Exact<{
  input: CreateRepostInput;
}>;


export type CreateRepostMutation = { __typename?: 'Mutation', createRepost: boolean };

export type DeleteMyAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteMyAccountMutation = { __typename?: 'Mutation', deleteMyAccount: boolean };

export type DeleteCommentMutationVariables = Exact<{
  input: DeleteCommentInput;
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteComment: boolean };

export type DeletePostMutationVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type DeletePostMutation = { __typename?: 'Mutation', deletePost: boolean };

export type DeleteProfileImageMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteProfileImageMutation = { __typename?: 'Mutation', deleteProfileImage: boolean };

export type InitializeDigitalCardPaymentMutationVariables = Exact<{ [key: string]: never; }>;


export type InitializeDigitalCardPaymentMutation = { __typename?: 'Mutation', initializeDigitalCardPayment: { __typename?: 'DigitalCardPaymentInit', clientSecret: string, paymentIntentId: string, amountCents: number, publishableKey: string } };

export type ActivateDigitalCardMutationVariables = Exact<{ [key: string]: never; }>;


export type ActivateDigitalCardMutation = { __typename?: 'Mutation', activateDigitalCard: { __typename?: 'MyDigitalCard', id: string, slug: string, enabled: boolean, publicUrl: string, purchasedAt: any, amountPaidCents: number, visibility: { __typename?: 'DigitalCardVisibilitySettings', about: boolean, email: boolean, phone: boolean, education: boolean, experience: boolean, expertise: boolean, socialLinks: boolean, website: boolean } } };

export type ConfirmDigitalCardPaymentMutationVariables = Exact<{
  paymentIntentId: Scalars['String']['input'];
}>;


export type ConfirmDigitalCardPaymentMutation = { __typename?: 'Mutation', confirmDigitalCardPayment: { __typename?: 'MyDigitalCard', id: string, slug: string, enabled: boolean, publicUrl: string, purchasedAt: any, amountPaidCents: number, visibility: { __typename?: 'DigitalCardVisibilitySettings', about: boolean, email: boolean, phone: boolean, education: boolean, experience: boolean, expertise: boolean, socialLinks: boolean, website: boolean } } };

export type UpdateDigitalCardVisibilityMutationVariables = Exact<{
  input: UpdateDigitalCardVisibilityInput;
}>;


export type UpdateDigitalCardVisibilityMutation = { __typename?: 'Mutation', updateDigitalCardVisibility: { __typename?: 'MyDigitalCard', id: string, slug: string, enabled: boolean, publicUrl: string, purchasedAt: any, amountPaidCents: number, visibility: { __typename?: 'DigitalCardVisibilitySettings', about: boolean, email: boolean, phone: boolean, education: boolean, experience: boolean, expertise: boolean, socialLinks: boolean, website: boolean } } };

export type MyDigitalCardQueryVariables = Exact<{ [key: string]: never; }>;


export type MyDigitalCardQuery = { __typename?: 'Query', myDigitalCard?: { __typename?: 'MyDigitalCard', id: string, slug: string, enabled: boolean, publicUrl: string, purchasedAt: any, amountPaidCents: number, visibility: { __typename?: 'DigitalCardVisibilitySettings', about: boolean, email: boolean, phone: boolean, education: boolean, experience: boolean, expertise: boolean, socialLinks: boolean, website: boolean } } | null };

export type DigitalCardPriceCentsQueryVariables = Exact<{ [key: string]: never; }>;


export type DigitalCardPriceCentsQuery = { __typename?: 'Query', digitalCardPriceCents: number };

export type EditAboutMutationVariables = Exact<{
  input: EditAboutInput;
}>;


export type EditAboutMutation = { __typename?: 'Mutation', editAbout: boolean };

export type EditBasicAccountMutationVariables = Exact<{
  input: EditBasicAccountInput;
}>;


export type EditBasicAccountMutation = { __typename?: 'Mutation', editBasicAccount: boolean };

export type AddEducationMutationVariables = Exact<{
  input: AddEducationInput;
}>;


export type AddEducationMutation = { __typename?: 'Mutation', addEducation: boolean };

export type DeleteEducationMutationVariables = Exact<{
  input: DeleteEducationInput;
}>;


export type DeleteEducationMutation = { __typename?: 'Mutation', deleteEducation: boolean };

export type EditEducationMutationVariables = Exact<{
  input: EditEducationInput;
}>;


export type EditEducationMutation = { __typename?: 'Mutation', editEducation: boolean };

export type CreateEventMutationVariables = Exact<{
  input: CreateEventInput;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent: { __typename?: 'Event', id: string, name: string, createdById?: string | null, imageUrl?: string | null, description?: string | null, startTime: any, endTime: any, location?: string | null, maxAttendees?: number | null, category: string, participantsCount: number, isjoinedbyMe: boolean, createdAt: any, updatedAt: any, organizedby: { __typename?: 'organizedBy', userId?: string | null, imageUrl?: string | null, name?: string | null, companyName?: string | null } } };

export type UpdateEventMutationVariables = Exact<{
  input: UpdateEventInput;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent: { __typename?: 'Event', id: string, name: string, createdById?: string | null, imageUrl?: string | null, description?: string | null, startTime: any, endTime: any, location?: string | null, maxAttendees?: number | null, category: string, participantsCount: number, isjoinedbyMe: boolean, updatedAt: any, organizedby: { __typename?: 'organizedBy', userId?: string | null, imageUrl?: string | null, name?: string | null, companyName?: string | null } } };

export type GetAllEventsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllEventsQuery = { __typename?: 'Query', getAllEvents: { __typename?: 'EventsConnection', total: number, page: number, limit: number, totalPages: number, hasNextPage: boolean, data: Array<{ __typename?: 'Event', id: string, libraryItemId?: string | null, name: string, createdById?: string | null, imageUrl?: string | null, description?: string | null, startTime: any, endTime: any, location?: string | null, maxAttendees?: number | null, category: string, participantsCount: number, isjoinedbyMe: boolean, createdAt: any, updatedAt: any, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null, organizedby: { __typename?: 'organizedBy', userId?: string | null, imageUrl?: string | null, name?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } }> } };

export type GetMyEventsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMyEventsQuery = { __typename?: 'Query', getMyEvents: { __typename?: 'EventsConnection', total: number, page: number, limit: number, totalPages: number, hasNextPage: boolean, data: Array<{ __typename?: 'Event', id: string, libraryItemId?: string | null, name: string, createdById?: string | null, imageUrl?: string | null, description?: string | null, startTime: any, endTime: any, location?: string | null, maxAttendees?: number | null, category: string, participantsCount: number, isjoinedbyMe: boolean, createdAt: any, updatedAt: any, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null, organizedby: { __typename?: 'organizedBy', userId?: string | null, imageUrl?: string | null, name?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } }> } };

export type JoinEventMutationVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type JoinEventMutation = { __typename?: 'Mutation', joinEvent: string };

export type LeaveEventMutationVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type LeaveEventMutation = { __typename?: 'Mutation', leaveEvent: string };

export type GetJoinedEventsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetJoinedEventsQuery = { __typename?: 'Query', getJoinedEvents: { __typename?: 'EventsConnection', total: number, page: number, limit: number, totalPages: number, hasNextPage: boolean, data: Array<{ __typename?: 'Event', id: string, libraryItemId?: string | null, name: string, createdById?: string | null, imageUrl?: string | null, description?: string | null, startTime: any, endTime: any, location?: string | null, maxAttendees?: number | null, category: string, participantsCount: number, isjoinedbyMe: boolean, createdAt: any, updatedAt: any, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null, organizedby: { __typename?: 'organizedBy', userId?: string | null, imageUrl?: string | null, name?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } }> } };

export type DeleteEventMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', deleteEvent: string };

export type GetEventByIdQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type GetEventByIdQuery = { __typename?: 'Query', getEventById: { __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, maxAttendees?: number | null, category: string, participantsCount: number, isjoinedbyMe: boolean, createdAt: any, updatedAt: any, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null, organizedby: { __typename?: 'organizedBy', userId?: string | null, imageUrl?: string | null, name?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } } };

export type GetJoinedPeopleByEventIdQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type GetJoinedPeopleByEventIdQuery = { __typename?: 'Query', getJoinedPeopleByEventId: Array<{ __typename?: 'User', id: string, imageUrl?: string | null, firstName: string, lastName?: string | null, title?: string | null, email: string, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }> };

export type SearchGroupsByNameQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchGroupsByNameQuery = { __typename?: 'Query', searchGroupsByName: Array<{ __typename?: 'GroupPreview', id: string, name: string, description?: string | null, profileImage?: string | null, coverImage?: string | null, privacy: string, membersCount: number, postsCount: number, isJoined: boolean, createdAt: any, owner: { __typename?: 'UserPreview', id: string, name: string, profileImageUrl?: string | null, role: string } }> };

export type SearchUsersByNameQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchUsersByNameQuery = { __typename?: 'Query', searchUsersByName: Array<{ __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, role: Role, companyName?: string | null }> };

export type GetLivekitTokenForEventMutationVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type GetLivekitTokenForEventMutation = { __typename?: 'Mutation', getLivekitTokenForEvent: { __typename?: 'LivekitTokenResponse', token: string, room: string } };

export type KickParticipantMutationVariables = Exact<{
  eventId: Scalars['String']['input'];
  participantId: Scalars['String']['input'];
}>;


export type KickParticipantMutation = { __typename?: 'Mutation', kickParticipant: boolean };

export type GetEventsByCourseIdQueryVariables = Exact<{
  courseId: Scalars['String']['input'];
}>;


export type GetEventsByCourseIdQuery = { __typename?: 'Query', getEventsByCourseId: { __typename?: 'EventsConnection', data: Array<{ __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, maxAttendees?: number | null, category: string, participantsCount: number, isjoinedbyMe: boolean, createdAt: any, updatedAt: any, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null, organizedby: { __typename?: 'organizedBy', userId?: string | null, imageUrl?: string | null, name?: string | null, companyName?: string | null } }> } };

export type AddExperienceMutationVariables = Exact<{
  input: AddExperienceInput;
}>;


export type AddExperienceMutation = { __typename?: 'Mutation', addExperience: boolean };

export type DeleteExperienceMutationVariables = Exact<{
  input: DeleteExperienceInput;
}>;


export type DeleteExperienceMutation = { __typename?: 'Mutation', deleteExperience: boolean };

export type EditExperienceMutationVariables = Exact<{
  input: EditExperienceInput;
}>;


export type EditExperienceMutation = { __typename?: 'Mutation', editExperience: boolean };

export type CreateFaqMutationVariables = Exact<{
  input: CreateFaqInput;
}>;


export type CreateFaqMutation = { __typename?: 'Mutation', createFaq: { __typename?: 'Faq', id: string, mentorId: string, question: string, answer: string, createdAt: any, updatedAt: any } };

export type UpdateFaqMutationVariables = Exact<{
  input: UpdateFaqInput;
}>;


export type UpdateFaqMutation = { __typename?: 'Mutation', updateFaq: { __typename?: 'Faq', id: string, mentorId: string, question: string, answer: string, createdAt: any, updatedAt: any } };

export type DeleteFaqMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFaqMutation = { __typename?: 'Mutation', deleteFaq: boolean };

export type GetFaqQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFaqQuery = { __typename?: 'Query', getFaq: { __typename?: 'Faq', id: string, mentorId: string, question: string, answer: string, createdAt: any, updatedAt: any } };

export type GetMentorFaqsQueryVariables = Exact<{
  mentorId: Scalars['ID']['input'];
}>;


export type GetMentorFaqsQuery = { __typename?: 'Query', getMentorFaqs: { __typename?: 'FaqResponse', total: number, faqs: Array<{ __typename?: 'Faq', id: string, mentorId: string, question: string, answer: string, createdAt: any, updatedAt: any }> } };

export type FeedQueryVariables = Exact<{
  input: FeedInput;
}>;


export type FeedQuery = { __typename?: 'Query', feed: { __typename?: 'FeedResponse', pageInfo: { __typename?: 'FeedPageInfo', nextCursor?: string | null, hasNextPage: boolean }, items: Array<{ __typename?: 'FeedItem', id: string, type: FeedItemType, cursor: string, advertisement?: { __typename?: 'Campaign', id: string, name: string, headline: string, description: string, adFormat: AdFormat, mediaUrls: Array<string>, ctaText?: string | null, ctaUrl?: string | null, user?: { __typename?: 'CampaignOwner', id: string, organizationName?: string | null, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null } | null } | null, profileBoost?: { __typename?: 'ProfileBoostFeedCard', id: string, headline?: string | null, videoUrl?: string | null, mentor: { __typename?: 'ProfileBoostFeedMentor', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, role: Role, headline?: string | null, isMentorVerified?: boolean | null, companyName?: string | null } } | null, postBoost?: { __typename?: 'PostBoost', id: string, postId: string, userId: string, status: PostBoostStatus, durationHours: number, durationSeconds: number, hourlyRateCents: number, amountCents: number, currency: string, startsAt?: any | null, expiresAt?: any | null, remainingDurationSeconds: number, paymentIntentId?: string | null, invoiceId?: string | null, createdAt: any, updatedAt: any } | null, reels?: Array<{ __typename?: 'ReelModel', id: string, userId: string, title: string, hlsUrl?: string | null, rawVideoUrl?: string | null, blurHash?: string | null, isCurated?: boolean | null, embedUrl?: string | null, sourceUrl?: string | null, thumbnailUrl?: string | null, provider?: VideoProvider | null, channelTitle?: string | null, author?: { __typename?: 'ReelAuthor', id: string, name: string, profileImageUrl?: string | null, companyName?: string | null } | null }> | null, post?: { __typename?: 'Post', id: string, createdAt?: any | null, updatedAt?: any | null, isPublished: boolean, commentsCount: number, mediaUrls: Array<string>, optimizedMediaUrls?: Array<string> | null, postType: PostType, companyId?: string | null, groupId?: string | null, isRepost: boolean, repostComment?: string | null, isSavedByMe: boolean, isRepostedByMe?: boolean | null, isBoosted?: boolean | null, activeBoostId?: string | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, userId?: string | null, handle?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, userId?: string | null, handle?: string | null, url?: string | null }> | null, group?: { __typename?: 'PostGroup', id: string, name: string, privacy: string, slug?: string | null, profileImage?: string | null, profileImageOptimizedUrl?: string | null, coverImage?: string | null, coverImageOptimizedUrl?: string | null } | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, profileImageUrl?: string | null, profileImageOptimizedUrl?: string | null, role: Role, headline?: string | null, isHiring?: boolean | null, openToWork?: boolean | null, isMentorVerified?: boolean | null, companyName?: string | null, connection?: { __typename?: 'ConnectionStatusModel', status: string, direction?: string | null } | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null, actionButtons?: Array<{ __typename?: 'ActionButton', id: string, name: string, url: string, isShow: boolean, createdAt: any }> | null }, companyAuthor?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null, logoOptimizedUrl?: string | null, industry?: string | null, tagline?: string | null, followersCount?: number | null, isFollowing?: boolean | null } | null, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> }, article?: { __typename?: 'Article', id: string, title: string, subtitle?: string | null, coverImageUrl?: string | null, slug: string, readingTimeMinutes: number, status: ArticleStatus, content: string, tags: Array<string>, translatedTitle?: string | null, translatedSubtitle?: string | null, translatedExcerpt?: string | null } | null, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, translatedQuestion?: string | null, translatedOptions?: Array<string> | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null, occasion?: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy, translatedTitle?: string | null, translatedDescription?: string | null } | null, event?: { __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, category: string, maxAttendees?: number | null, participantsCount: number, isjoinedbyMe: boolean, organizedby: { __typename?: 'organizedBy', userId?: string | null, name?: string | null, imageUrl?: string | null, companyName?: string | null }, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null } | null, case?: { __typename?: 'CasePostModel', id: string, postId: string, createdAt: any, updatedAt: any, media: Array<{ __typename?: 'CaseMediaModel', id: string, step: string, type: string, imageUrl?: string | null, text?: string | null, order: number, createdAt: any, translatedText?: string | null }> } | null, originalPost?: { __typename?: 'Post', id: string, createdAt?: any | null, mediaUrls: Array<string>, optimizedMediaUrls?: Array<string> | null, isBoosted?: boolean | null, activeBoostId?: string | null, groupId?: string | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, userId?: string | null, handle?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, userId?: string | null, handle?: string | null, url?: string | null }> | null, group?: { __typename?: 'PostGroup', id: string, name: string, privacy: string, slug?: string | null, profileImage?: string | null, profileImageOptimizedUrl?: string | null, coverImage?: string | null, coverImageOptimizedUrl?: string | null } | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, middleName?: string | null, title?: string | null, profileImageUrl?: string | null, role: Role, headline?: string | null, isHiring?: boolean | null, openToWork?: boolean | null, isMentorVerified?: boolean | null, companyName?: string | null, connection?: { __typename?: 'ConnectionStatusModel', status: string, direction?: string | null } | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null, actionButtons?: Array<{ __typename?: 'ActionButton', id: string, name: string, url: string, isShow: boolean, createdAt: any }> | null }, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, translatedQuestion?: string | null, translatedOptions?: Array<string> | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null, occasion?: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy, translatedTitle?: string | null, translatedDescription?: string | null } | null, event?: { __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, category: string, maxAttendees?: number | null, participantsCount: number, isjoinedbyMe: boolean, organizedby: { __typename?: 'organizedBy', userId?: string | null, name?: string | null, imageUrl?: string | null, companyName?: string | null }, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null } | null, case?: { __typename?: 'CasePostModel', id: string, postId: string, createdAt: any, updatedAt: any, media: Array<{ __typename?: 'CaseMediaModel', id: string, step: string, type: string, imageUrl?: string | null, text?: string | null, order: number, createdAt: any, translatedText?: string | null }> } | null, article?: { __typename?: 'Article', id: string, title: string, subtitle?: string | null, coverImageUrl?: string | null, slug: string, readingTimeMinutes: number, status: ArticleStatus, content: string, tags: Array<string>, translatedTitle?: string | null, translatedSubtitle?: string | null, translatedExcerpt?: string | null } | null, companyAuthor?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null, followersCount?: number | null, isFollowing?: boolean | null } | null } | null } | null }> } };

export type ForgetPasswordMutationVariables = Exact<{
  input: ForgetPasswordInput;
}>;


export type ForgetPasswordMutation = { __typename?: 'Mutation', forgetPassword: boolean };

export type GetUserCommunityPostsQueryVariables = Exact<{
  input: GetUserCommunityPostsInput;
}>;


export type GetUserCommunityPostsQuery = { __typename?: 'Query', getUserCommunityPosts: Array<{ __typename?: 'Post', id: string, isRepost: boolean, repostComment?: string | null, originalPostId?: string | null, postType: PostType, companyId?: string | null, mediaUrls: Array<string>, commentsCount: number, isSavedByMe: boolean, isRepostedByMe?: boolean | null, isPublished: boolean, createdAt?: any | null, updatedAt?: any | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, profileImageUrl?: string | null, role: Role, headline?: string | null, isHiring?: boolean | null, openToWork?: boolean | null, isMentorVerified?: boolean | null, createdAt?: any | null, updatedAt?: any | null, companyName?: string | null, connection?: { __typename?: 'ConnectionStatusModel', status: string, direction?: string | null } | null, actionButtons?: Array<{ __typename?: 'ActionButton', id: string, name: string, url: string, isShow: boolean, createdAt: any }> | null }, originalPost?: { __typename?: 'Post', id: string, mediaUrls: Array<string>, commentsCount: number, isSavedByMe: boolean, isRepostedByMe?: boolean | null, isPublished: boolean, createdAt?: any | null, updatedAt?: any | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, profileImageUrl?: string | null, role: Role, headline?: string | null, isHiring?: boolean | null, openToWork?: boolean | null, isMentorVerified?: boolean | null, createdAt?: any | null, updatedAt?: any | null, companyName?: string | null, connection?: { __typename?: 'ConnectionStatusModel', status: string, direction?: string | null } | null, actionButtons?: Array<{ __typename?: 'ActionButton', id: string, name: string, url: string, isShow: boolean, createdAt: any }> | null }, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> }, article?: { __typename?: 'Article', id: string, title: string, subtitle?: string | null, coverImageUrl?: string | null, slug: string, readingTimeMinutes: number, tags: Array<string>, content: string, status: ArticleStatus, translatedTitle?: string | null, translatedSubtitle?: string | null, translatedExcerpt?: string | null } | null, companyAuthor?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null, followersCount?: number | null, isFollowing?: boolean | null } | null, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, translatedQuestion?: string | null, translatedOptions?: Array<string> | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null, occasion?: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy, translatedTitle?: string | null, translatedDescription?: string | null } | null, event?: { __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, category: string, maxAttendees?: number | null, participantsCount: number, isjoinedbyMe: boolean, organizedby: { __typename?: 'organizedBy', userId?: string | null, name?: string | null, imageUrl?: string | null, companyName?: string | null }, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null } | null, case?: { __typename?: 'CasePostModel', id: string, postId: string, createdAt: any, updatedAt: any, media: Array<{ __typename?: 'CaseMediaModel', id: string, step: string, type: string, imageUrl?: string | null, text?: string | null, order: number, createdAt: any, translatedText?: string | null }> } | null } | null, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> }, article?: { __typename?: 'Article', id: string, title: string, subtitle?: string | null, coverImageUrl?: string | null, slug: string, readingTimeMinutes: number, tags: Array<string>, content: string, status: ArticleStatus, translatedTitle?: string | null, translatedSubtitle?: string | null, translatedExcerpt?: string | null } | null, companyAuthor?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null, followersCount?: number | null, isFollowing?: boolean | null } | null, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, translatedQuestion?: string | null, translatedOptions?: Array<string> | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null, occasion?: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy, translatedTitle?: string | null, translatedDescription?: string | null } | null, event?: { __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, category: string, maxAttendees?: number | null, participantsCount: number, isjoinedbyMe: boolean, organizedby: { __typename?: 'organizedBy', userId?: string | null, name?: string | null, imageUrl?: string | null, companyName?: string | null }, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null } | null, case?: { __typename?: 'CasePostModel', id: string, postId: string, createdAt: any, updatedAt: any, media: Array<{ __typename?: 'CaseMediaModel', id: string, step: string, type: string, imageUrl?: string | null, text?: string | null, order: number, createdAt: any, translatedText?: string | null }> } | null }> };

export type GetSavedRssFeedsQueryVariables = Exact<{
  input: GetSavedRssFeedsInput;
}>;


export type GetSavedRssFeedsQuery = { __typename?: 'Query', getSavedRssFeeds: Array<{ __typename?: 'RssFeed', id: string, guid: string, title: string, source: string, link: string, publishedAt: any, summary?: string | null, imageUrl?: string | null, profile_image?: string | null }> };

export type GetTotalSavedRssFeedsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTotalSavedRssFeedsQuery = { __typename?: 'Query', getTotalSavedRssFeeds: number };

export type GetCommentRepliesQueryVariables = Exact<{
  input: GetCommentRepliesInput;
}>;


export type GetCommentRepliesQuery = { __typename?: 'Query', getCommentReplies: Array<{ __typename?: 'Comment', id: string, content: string, translatedContent?: string | null, mediaUrls: Array<string>, createdAt?: any | null, updatedAt?: any | null, repliesCount?: number | null, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> }, user: { __typename?: 'CommentAuthor', id: string, firstName: string, lastName?: string | null, middleName?: string | null, title?: string | null, profileImageUrl?: string | null, role: Role, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } }> };

export type GetCompanyInboxQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCompanyInboxQuery = { __typename?: 'Query', getCompanyInbox: { __typename?: 'CompanyInboxResponse', totalCount: number, unreadCount: number, page: number, limit: number, totalPages: number, messages: Array<{ __typename?: 'CompanyInboxMessage', id: string, conversationId: string, senderId: string, senderName: string, senderAvatar?: string | null, subject?: string | null, content: string, status: string, createdAt: any, hasReplies: boolean, repliesCount: number, unreadCount: number, totalMessages: number, lastMessageAt: any, replies: Array<{ __typename?: 'CompanyInboxMessageReply', id: string, content: string, createdAt: any, senderId: string, isAuthor: boolean }>, allMessages: Array<{ __typename?: 'CompanyInboxMessageReply', id: string, content: string, createdAt: any, senderId: string, isAuthor: boolean }> }> } };

export type MarkCompanyMessageAsReadMutationVariables = Exact<{
  messageId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
}>;


export type MarkCompanyMessageAsReadMutation = { __typename?: 'Mutation', markCompanyMessageAsRead: boolean };

export type GetConversationMessagesQueryVariables = Exact<{
  input: GetConversationMessagesInput;
}>;


export type GetConversationMessagesQuery = { __typename?: 'Query', getConversationMessages: { __typename?: 'Conversation', id: string, createdAt?: any | null, updatedAt?: any | null, lastMessage?: string | null, lastMessageAt?: any | null, type: ConversationType, companyId?: string | null, company?: { __typename?: 'CompanyInfo', id: string, name: string, logoUrl?: string | null, ownerId: string } | null, user?: { __typename?: 'ConversationMember', id: string, name: string, profileImageUrl?: string | null, role: string, companyName?: string | null } | null, messages?: Array<{ __typename?: 'Message', id: string, createdAt?: any | null, updatedAt?: any | null, conversationId: string, senderId: string, receiverId?: string | null, content: string, read: boolean, status?: CompanyMessageStatus | null, isAuthor: boolean }> | null } };

export type GetUserConversationsQueryVariables = Exact<{
  input: PaginationInput;
}>;


export type GetUserConversationsQuery = { __typename?: 'Query', getUserConversations: Array<{ __typename?: 'Conversation', id: string, lastMessage?: string | null, lastMessageAt?: any | null, unreadCount: number, type: ConversationType, companyId?: string | null, company?: { __typename?: 'CompanyInfo', id: string, name: string, logoUrl?: string | null, ownerId: string } | null, user?: { __typename?: 'ConversationMember', id: string, name: string, profileImageUrl?: string | null, role: string, companyName?: string | null } | null }> };

export type MentorAvailabilitiesQueryVariables = Exact<{
  input: GetMentorAvailabilityInput;
}>;


export type MentorAvailabilitiesQuery = { __typename?: 'Query', mentorAvailabilities: { __typename?: 'MentorAvailabilityWithDayOff', dayOffDates: Array<string>, availabilities: Array<{ __typename?: 'MentorAvailabilityData', id: string, day: Array<Day>, isRecurring: boolean, timezone: string, price: number, currency: Currency, createdAt: any, timeSlots: Array<{ __typename?: 'MentorTimeRange', start: string, end: string }> }> } };

export type GetMentorAvailableSlotsQueryVariables = Exact<{
  input: GetMentorDayAvailableSlotsInput;
}>;


export type GetMentorAvailableSlotsQuery = { __typename?: 'Query', getMentorAvailableSlots: Array<{ __typename?: 'TimeRange', start: string, end: string }> };

export type GetMentorViewerAvailabilityCalendarQueryVariables = Exact<{
  input: GetMentorViewerAvailabilityCalendarInput;
}>;


export type GetMentorViewerAvailabilityCalendarQuery = { __typename?: 'Query', getMentorViewerAvailabilityCalendar: { __typename?: 'MentorViewerAvailabilityCalendar', availableDays: Array<Day>, dayOffDates: Array<string> } };

export type GetUserNotificationQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  notificationTypes?: InputMaybe<Array<NotificationType> | NotificationType>;
}>;


export type GetUserNotificationQuery = { __typename?: 'Query', getUserNotification: Array<{ __typename?: 'Notification', id: string, createdAt?: any | null, type: NotificationType, message?: string | null, isRead: boolean, status?: InviteStatus | null, companyId?: string | null, companyName?: string | null, companyLogoUrl?: string | null, conversationId?: string | null, supportTicketId?: string | null, campaignId?: string | null, redirectTarget?: BroadcastRedirectTarget | null, postId?: string | null, sessionId?: string | null, actor?: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null } | null, session?: { __typename?: 'Session', id: string, subject: string, startTime: string, endTime: string, status: string } | null, group?: { __typename?: 'Group', id: string } | null }> };

export type GetPostQueryVariables = Exact<{
  input: GetPostInput;
}>;


export type GetPostQuery = { __typename?: 'Query', getPost: { __typename?: 'Post', id: string, isRepost: boolean, repostComment?: string | null, originalPostId?: string | null, postType: PostType, companyId?: string | null, mediaUrls: Array<string>, commentsCount: number, isSavedByMe: boolean, isRepostedByMe?: boolean | null, isPublished: boolean, isBoosted?: boolean | null, activeBoostId?: string | null, createdAt?: any | null, updatedAt?: any | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, middleName?: string | null, title?: string | null, profileImageUrl?: string | null, role: Role, headline?: string | null, isHiring?: boolean | null, openToWork?: boolean | null, isMentorVerified?: boolean | null, createdAt?: any | null, updatedAt?: any | null, companyName?: string | null, connection?: { __typename?: 'ConnectionStatusModel', status: string, direction?: string | null } | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null, actionButtons?: Array<{ __typename?: 'ActionButton', id: string, name: string, url: string, isShow: boolean, createdAt: any }> | null }, companyAuthor?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null, followersCount?: number | null, isFollowing?: boolean | null } | null, originalPost?: { __typename?: 'Post', id: string, createdAt?: any | null, mediaUrls: Array<string>, isBoosted?: boolean | null, activeBoostId?: string | null, commentsCount: number, isSavedByMe: boolean, isRepostedByMe?: boolean | null, isPublished: boolean, updatedAt?: any | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, middleName?: string | null, title?: string | null, profileImageUrl?: string | null, role: Role, headline?: string | null, isHiring?: boolean | null, openToWork?: boolean | null, isMentorVerified?: boolean | null, createdAt?: any | null, updatedAt?: any | null, companyName?: string | null, connection?: { __typename?: 'ConnectionStatusModel', status: string, direction?: string | null } | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null, actionButtons?: Array<{ __typename?: 'ActionButton', id: string, name: string, url: string, isShow: boolean, createdAt: any }> | null }, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, translatedQuestion?: string | null, translatedOptions?: Array<string> | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null, occasion?: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy, translatedTitle?: string | null, translatedDescription?: string | null } | null, event?: { __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, category: string, maxAttendees?: number | null, participantsCount: number, isjoinedbyMe: boolean, organizedby: { __typename?: 'organizedBy', userId?: string | null, name?: string | null, imageUrl?: string | null, companyName?: string | null }, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null } | null, case?: { __typename?: 'CasePostModel', id: string, postId: string, createdAt: any, updatedAt: any, media: Array<{ __typename?: 'CaseMediaModel', id: string, step: string, type: string, imageUrl?: string | null, text?: string | null, order: number, createdAt: any, translatedText?: string | null }> } | null, article?: { __typename?: 'Article', id: string, title: string, subtitle?: string | null, coverImageUrl?: string | null, slug: string, readingTimeMinutes: number, status: ArticleStatus, content: string, tags: Array<string>, translatedTitle?: string | null, translatedSubtitle?: string | null, translatedExcerpt?: string | null } | null, companyAuthor?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null, followersCount?: number | null, isFollowing?: boolean | null } | null, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> } } | null, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> }, article?: { __typename?: 'Article', id: string, title: string, subtitle?: string | null, coverImageUrl?: string | null, slug: string, readingTimeMinutes: number, status: ArticleStatus, content: string, tags: Array<string>, translatedTitle?: string | null, translatedSubtitle?: string | null, translatedExcerpt?: string | null } | null, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, translatedQuestion?: string | null, translatedOptions?: Array<string> | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null, occasion?: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy, translatedTitle?: string | null, translatedDescription?: string | null } | null, event?: { __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, category: string, maxAttendees?: number | null, participantsCount: number, isjoinedbyMe: boolean, organizedby: { __typename?: 'organizedBy', userId?: string | null, name?: string | null, imageUrl?: string | null, companyName?: string | null }, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null } | null, case?: { __typename?: 'CasePostModel', id: string, postId: string, createdAt: any, updatedAt: any, media: Array<{ __typename?: 'CaseMediaModel', id: string, step: string, type: string, imageUrl?: string | null, text?: string | null, order: number, createdAt: any, translatedText?: string | null }> } | null } };

export type GetProfileQueryVariables = Exact<{
  input: GetProfileInput;
}>;


export type GetProfileQuery = { __typename?: 'Query', getProfile: { __typename?: 'Profile', editable: boolean, influence?: { __typename?: 'InfluenceProfileView', hideFromLeaderboards?: boolean | null, userId: string, lifetimeInfluence: number, contributionCount: number, postsCount: number, periodKey: string, monthlyInfluence: number, monthlyRank?: number | null, tier?: { __typename?: 'InfluenceTierView', threshold: number, badge: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } } | null, nextTier?: { __typename?: 'InfluenceTierView', threshold: number, badge: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } } | null, selectedBadges: Array<{ __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null }>, nameBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null, nextAchievement?: { __typename?: 'AchievementProgressView', progress: number, target: number, remaining: number, unlocked: boolean, unlockedAt?: any | null, expiresAt?: any | null, badge: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } } | null } | null, headline: { __typename?: 'Headline', name: string, title?: string | null, profileImageUrl?: string | null, role: Role, expertise?: Expertise | null, state?: string | null, bannerImageUrl?: string | null, openToWork?: boolean | null, isHiring?: boolean | null, headline?: string | null, isMentorVerified?: boolean | null, isBoosted?: boolean | null, boostEndsAt?: any | null, organizationName?: string | null, profileVisitsCount?: number | null, consultationsCount?: number | null, experienceYearsCount?: number | null, rate?: number | null, mentorshipPrice?: string | null, companyName?: string | null }, overview: { __typename?: 'Overview', about?: string | null, recentPosts?: Array<{ __typename?: 'Post', id: string, createdAt?: any | null, updatedAt?: any | null, postType: PostType, companyId?: string | null, isPublished: boolean, commentsCount: number, mediaUrls: Array<string>, isRepost: boolean, repostComment?: string | null, originalPostId?: string | null, isBoosted?: boolean | null, activeBoostId?: string | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> }, article?: { __typename?: 'Article', id: string, title: string, subtitle?: string | null, coverImageUrl?: string | null, slug: string, readingTimeMinutes: number, tags: Array<string>, content: string, status: ArticleStatus, translatedTitle?: string | null, translatedSubtitle?: string | null, translatedExcerpt?: string | null } | null, companyAuthor?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null, followersCount?: number | null, isFollowing?: boolean | null } | null, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, translatedQuestion?: string | null, translatedOptions?: Array<string> | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null, occasion?: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy, translatedTitle?: string | null, translatedDescription?: string | null } | null, event?: { __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, category: string, maxAttendees?: number | null, participantsCount: number, isjoinedbyMe: boolean, organizedby: { __typename?: 'organizedBy', userId?: string | null, name?: string | null, imageUrl?: string | null, companyName?: string | null }, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null } | null, case?: { __typename?: 'CasePostModel', id: string, postId: string, createdAt: any, updatedAt: any, media: Array<{ __typename?: 'CaseMediaModel', id: string, step: string, type: string, imageUrl?: string | null, text?: string | null, order: number, createdAt: any, translatedText?: string | null }> } | null, author: { __typename?: 'PostAuthor', id: string, role: Role, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, headline?: string | null, isHiring?: boolean | null, openToWork?: boolean | null, isMentorVerified?: boolean | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null, connection?: { __typename?: 'ConnectionStatusModel', status: string, direction?: string | null } | null, actionButtons?: Array<{ __typename?: 'ActionButton', id: string, name: string, url: string, isShow: boolean, createdAt: any }> | null }, originalPost?: { __typename?: 'Post', id: string, mediaUrls: Array<string>, commentsCount: number, isPublished: boolean, isBoosted?: boolean | null, activeBoostId?: string | null, createdAt?: any | null, updatedAt?: any | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, author: { __typename?: 'PostAuthor', id: string, role: Role, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, headline?: string | null, isHiring?: boolean | null, openToWork?: boolean | null, isMentorVerified?: boolean | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null, connection?: { __typename?: 'ConnectionStatusModel', status: string, direction?: string | null } | null, actionButtons?: Array<{ __typename?: 'ActionButton', id: string, name: string, url: string, isShow: boolean, createdAt: any }> | null }, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> }, article?: { __typename?: 'Article', id: string, title: string, subtitle?: string | null, coverImageUrl?: string | null, slug: string, readingTimeMinutes: number, tags: Array<string>, content: string, status: ArticleStatus, translatedTitle?: string | null, translatedSubtitle?: string | null, translatedExcerpt?: string | null } | null, companyAuthor?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null, followersCount?: number | null, isFollowing?: boolean | null } | null, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, translatedQuestion?: string | null, translatedOptions?: Array<string> | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null, occasion?: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy, translatedTitle?: string | null, translatedDescription?: string | null } | null, event?: { __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, category: string, maxAttendees?: number | null, participantsCount: number, isjoinedbyMe: boolean, organizedby: { __typename?: 'organizedBy', userId?: string | null, name?: string | null, imageUrl?: string | null, companyName?: string | null }, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null } | null, case?: { __typename?: 'CasePostModel', id: string, postId: string, createdAt: any, updatedAt: any, media: Array<{ __typename?: 'CaseMediaModel', id: string, step: string, type: string, imageUrl?: string | null, text?: string | null, order: number, createdAt: any, translatedText?: string | null }> } | null } | null }> | null, experiences?: Array<{ __typename?: 'Experience', id: string, position: string, company?: string | null, location?: string | null, startDate?: any | null, endDate?: any | null, isCurrent?: boolean | null }> | null, contacts?: Array<{ __typename?: 'Contact', id: string, platform: ContactPlatform, url: string, showOnProfile: boolean }> | null, educations?: Array<{ __typename?: 'Education', id: string, fieldOfStudy: string, institution: string, degree: string, startYear?: number | null, startMonth?: number | null, startDay?: number | null, endYear?: number | null, endMonth?: number | null, endDay?: number | null }> | null, basicAccount?: { __typename?: 'BasicAccount', firstName: string, lastName?: string | null, middleName?: string | null, title?: string | null, phone: string, email: string, expertise?: Expertise | null, suffix?: Suffix | null, country?: string | null, city?: string | null, state?: string | null, gender?: Gender | null, organizationName?: string | null, position?: string | null, Sociallink?: string | null, businessType?: string | null, valueToCommunity?: string | null, reasonForJoining?: string | null, companyLogo?: string | null } | null, licenses?: Array<{ __typename?: 'License', id: string, title: string, organization: string, licenseID: string, licenseURL: string, issueDate: any, expiryDate?: any | null, url?: string | null }> | null, skills?: Array<{ __typename?: 'SkillModel', id: string, name: string, title: string }> | null } } };

export type GetRoleChangeRequestStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoleChangeRequestStatusQuery = { __typename?: 'Query', roleChangeRequestStatus: string };

export type GetScheduledPostsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetScheduledPostsQuery = { __typename?: 'Query', getScheduledPosts: Array<{ __typename?: 'Post', id: string, mediaUrls: Array<string>, postType: PostType, createdAt?: any | null, updatedAt?: any | null, isScheduled?: boolean | null, scheduledAt?: string | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, userId?: string | null, url?: string | null }>, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, options: Array<{ __typename?: 'PollOption', id: string, text: string }> } | null, occasion?: { __typename?: 'Occasion', id: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy } | null, case?: { __typename?: 'CasePostModel', id: string, media: Array<{ __typename?: 'CaseMediaModel', id: string, step: string, type: string, imageUrl?: string | null, text?: string | null, order: number }> } | null, event?: { __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, category: string, participantsCount: number, organizedby: { __typename?: 'organizedBy', name?: string | null } } | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, profileImageUrl?: string | null, role: Role, companyName?: string | null }, company?: { __typename?: 'CompanyAuthor', id: string, name: string } | null }> };

export type AllSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSessionsQuery = { __typename?: 'Query', allSessions: Array<{ __typename?: 'Session', id: string, status: string, closedReason?: string | null, refundRequestStatus?: string | null, refundRequestedAt?: string | null, refundRequestReason?: string | null, subject: string, description: string, date: string, startTime: string, endTime: string, timezone: string, bookedTimezone?: string | null, duration: number, zoomJoinUrl?: string | null, zoomStartUrl?: string | null, zoomMeetingId?: string | null, zoomPasscode?: string | null, price?: number | null, currency?: string | null, mentor: { __typename?: 'SessionUserInfo', id: string, firstName: string, lastName: string, title?: string | null, profileImageUrl?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }, student: { __typename?: 'SessionUserInfo', id: string, firstName: string, lastName: string, title?: string | null, profileImageUrl?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }, invoice?: { __typename?: 'SessionInvoice', id: string, invoiceNumber: string, status: string, total: number, currency: string, paidAt?: string | null, receiptUrl?: string | null, invoicePdf?: string | null } | null }> };

export type UserConfirmedOrCompletedSessionCountQueryVariables = Exact<{
  input: UserSessionCountInput;
}>;


export type UserConfirmedOrCompletedSessionCountQuery = { __typename?: 'Query', userConfirmedOrCompletedSessionCount: number };

export type GetTopLevelCommentsQueryVariables = Exact<{
  input: GetTopLevelCommentsInput;
}>;


export type GetTopLevelCommentsQuery = { __typename?: 'Query', getTopLevelComments: Array<{ __typename?: 'Comment', id: string, createdAt?: any | null, updatedAt?: any | null, content: string, translatedContent?: string | null, mediaUrls: Array<string>, repliesCount?: number | null, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> }, user: { __typename?: 'CommentAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, role: Role, profileImageUrl?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } }> };

export type GetProfileViewersQueryVariables = Exact<{
  input: GetProfileViewersInput;
}>;


export type GetProfileViewersQuery = { __typename?: 'Query', getProfileViewers: { __typename?: 'PaginatedProfileViewers', total: number, page: number, limit: number, items: Array<{ __typename?: 'ProfileViewer', viewedDate: any, viewer: { __typename?: 'ProfileViewerUser', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null } }> } };

export type CreateGroupMutationVariables = Exact<{
  input: CreateGroupInput;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup: { __typename?: 'Group', id: string, name: string, slug: string, description: string, privacy: string, coverImage?: string | null, profileImage?: string | null, tags: Array<string>, categories: Array<string>, location?: string | null, rules?: string | null, reviewPosts: boolean, createdAt: any, updatedAt: any } };

export type MyOwnedGroupsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type MyOwnedGroupsCountQuery = { __typename?: 'Query', myOwnedGroupsCount: number };

export type MyGroupsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type MyGroupsQuery = { __typename?: 'Query', myGroups: Array<{ __typename?: 'Group', id: string, name: string, slug: string, description: string, coverImage?: string | null, profileImage?: string | null, privacy: string, tags: Array<string>, categories: Array<string>, rules?: string | null, reviewPosts: boolean, ownerId: string, membersCount: number, postsCount: number, createdAt: any, updatedAt: any, memberships?: Array<{ __typename?: 'GroupMembership', id: string, userId: string, role: string, status: MembershipStatus, isBanned: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, email: string, companyName?: string | null } } | null> | null }> };

export type DiscoverGroupsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<Scalars['String']['input']>;
}>;


export type DiscoverGroupsQuery = { __typename?: 'Query', discoverGroups: Array<{ __typename?: 'Group', id: string, name: string, slug: string, description: string, coverImage?: string | null, profileImage?: string | null, privacy: string, tags: Array<string>, categories: Array<string>, rules?: string | null, reviewPosts: boolean, ownerId: string, membersCount: number, postsCount: number, createdAt: any, updatedAt: any, memberships?: Array<{ __typename?: 'GroupMembership', id: string, status: MembershipStatus, user: { __typename?: 'User', id: string } } | null> | null }> };

export type PaginatedDiscoverGroupsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaginatedDiscoverGroupsQuery = { __typename?: 'Query', paginatedDiscoverGroups: { __typename?: 'DiscoverGroupsResponse', total: number, page: number, limit: number, hasNext: boolean, groups: Array<{ __typename?: 'Group', id: string, name: string, slug: string, description: string, coverImage?: string | null, profileImage?: string | null, privacy: string, tags: Array<string>, categories: Array<string>, rules?: string | null, reviewPosts: boolean, ownerId: string, membersCount: number, postsCount: number, createdAt: any, updatedAt: any, memberships?: Array<{ __typename?: 'GroupMembership', id: string, status: MembershipStatus, user: { __typename?: 'User', id: string } } | null> | null }> } };

export type SearchGroupsQueryVariables = Exact<{
  input: SearchGroupsInput;
}>;


export type SearchGroupsQuery = { __typename?: 'Query', searchGroups: Array<{ __typename?: 'GroupPreview', id: string, name: string, description?: string | null, profileImage?: string | null, coverImage?: string | null, privacy: string, membersCount: number, tags: Array<string>, categories: Array<string>, location?: string | null, isJoined: boolean, owner: { __typename?: 'UserPreview', id: string } }> };

export type GroupByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GroupByIdQuery = { __typename?: 'Query', groupById?: { __typename?: 'Group', id: string, name: string, slug: string, description: string, privacy: string, coverImage?: string | null, profileImage?: string | null, membersCount: number, tags: Array<string>, categories: Array<string>, status: string, rules?: string | null, reviewPosts: boolean, ownerId: string, createdAt: any, updatedAt: any } | null };

export type JoinGroupMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type JoinGroupMutation = { __typename?: 'Mutation', joinGroup: boolean };

export type LeaveGroupMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type LeaveGroupMutation = { __typename?: 'Mutation', leaveGroup: boolean };

export type WithdrawJoinRequestMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type WithdrawJoinRequestMutation = { __typename?: 'Mutation', withdrawJoinRequest: boolean };

export type GroupMembersQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type GroupMembersQuery = { __typename?: 'Query', groupMembers: Array<{ __typename?: 'GroupMembership', id: string, role: string, status: MembershipStatus, isBanned: boolean, joinedAt?: any | null, user: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } }> };

export type GroupBannedMembersQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type GroupBannedMembersQuery = { __typename?: 'Query', groupBannedMembers: Array<{ __typename?: 'GroupMembership', id: string, role: string, status: MembershipStatus, isBanned: boolean, joinedAt?: any | null, user: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } }> };

export type GroupPendingInvitesQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type GroupPendingInvitesQuery = { __typename?: 'Query', groupPendingInvites: Array<{ __typename?: 'GroupInvite', id: string, groupId: string, inviteeEmail: string, status: InviteStatus, createdAt: any, expiresAt: any, invitee?: { __typename?: 'GroupInviteUserPreview', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, role?: Role | null, companyName?: string | null } | null, inviter?: { __typename?: 'GroupInviteUserPreview', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null } | null }> };

export type GroupPendingJoinRequestsQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type GroupPendingJoinRequestsQuery = { __typename?: 'Query', groupPendingJoinRequests: Array<{ __typename?: 'GroupMembership', id: string, role: string, status: MembershipStatus, joinedAt?: any | null, user: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, headline?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } }> };

export type GroupPostsQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type GroupPostsQuery = { __typename?: 'Query', groupPosts: Array<{ __typename?: 'Post', id: string, createdAt?: any | null, mediaUrls: Array<string>, isPublished: boolean, commentsCount: number, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, role: Role, companyName?: string | null } }> };

export type GroupApprovedPostsQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type GroupApprovedPostsQuery = { __typename?: 'Query', groupApprovedPosts: Array<{ __typename?: 'Post', id: string, isRepost: boolean, repostComment?: string | null, originalPostId?: string | null, postType: PostType, mediaUrls: Array<string>, commentsCount: number, isSavedByMe: boolean, isRepostedByMe?: boolean | null, isPublished: boolean, isBoosted?: boolean | null, activeBoostId?: string | null, createdAt?: any | null, updatedAt?: any | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, profileImageUrl?: string | null, role: Role, createdAt?: any | null, updatedAt?: any | null, companyName?: string | null }, companyAuthor?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null, followersCount?: number | null, isFollowing?: boolean | null } | null, article?: { __typename?: 'Article', id: string, title: string, subtitle?: string | null, coverImageUrl?: string | null, slug: string, readingTimeMinutes: number, tags: Array<string>, content: string, status: ArticleStatus, translatedTitle?: string | null, translatedSubtitle?: string | null, translatedExcerpt?: string | null } | null, occasion?: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy, translatedTitle?: string | null, translatedDescription?: string | null } | null, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, translatedQuestion?: string | null, translatedOptions?: Array<string> | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null, event?: { __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, category: string, maxAttendees?: number | null, participantsCount: number, isjoinedbyMe: boolean, organizedby: { __typename?: 'organizedBy', userId?: string | null, name?: string | null, imageUrl?: string | null, companyName?: string | null }, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null } | null, case?: { __typename?: 'CasePostModel', id: string, postId: string, createdAt: any, updatedAt: any, media: Array<{ __typename?: 'CaseMediaModel', id: string, step: string, type: string, imageUrl?: string | null, text?: string | null, order: number, createdAt: any, translatedText?: string | null }> } | null, originalPost?: { __typename?: 'Post', id: string, mediaUrls: Array<string>, commentsCount: number, isSavedByMe: boolean, isRepostedByMe?: boolean | null, isPublished: boolean, createdAt?: any | null, updatedAt?: any | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, profileImageUrl?: string | null, role: Role, createdAt?: any | null, updatedAt?: any | null, companyName?: string | null }, occasion?: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy, translatedTitle?: string | null, translatedDescription?: string | null } | null, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, translatedQuestion?: string | null, translatedOptions?: Array<string> | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null, event?: { __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, category: string, maxAttendees?: number | null, participantsCount: number, isjoinedbyMe: boolean, organizedby: { __typename?: 'organizedBy', userId?: string | null, name?: string | null, imageUrl?: string | null, companyName?: string | null }, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null } | null, case?: { __typename?: 'CasePostModel', id: string, postId: string, createdAt: any, updatedAt: any, media: Array<{ __typename?: 'CaseMediaModel', id: string, step: string, type: string, imageUrl?: string | null, text?: string | null, order: number, createdAt: any, translatedText?: string | null }> } | null, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> } } | null, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> } }> };

export type GroupFeedQueryVariables = Exact<{
  input: GroupFeedInput;
}>;


export type GroupFeedQuery = { __typename?: 'Query', groupFeed: { __typename?: 'FeedResponse', pageInfo: { __typename?: 'FeedPageInfo', nextCursor?: string | null, hasNextPage: boolean }, items: Array<{ __typename?: 'FeedItem', id: string, type: FeedItemType, cursor: string, postBoost?: { __typename?: 'PostBoost', id: string, postId: string, userId: string, status: PostBoostStatus, durationHours: number, durationSeconds: number, hourlyRateCents: number, amountCents: number, currency: string, startsAt?: any | null, expiresAt?: any | null, remainingDurationSeconds: number, paymentIntentId?: string | null, invoiceId?: string | null, createdAt: any, updatedAt: any } | null, post?: { __typename?: 'Post', id: string, isRepost: boolean, repostComment?: string | null, originalPostId?: string | null, postType: PostType, mediaUrls: Array<string>, commentsCount: number, isSavedByMe: boolean, isRepostedByMe?: boolean | null, isPublished: boolean, isBoosted?: boolean | null, activeBoostId?: string | null, createdAt?: any | null, updatedAt?: any | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, profileImageUrl?: string | null, role: Role, headline?: string | null, isHiring?: boolean | null, openToWork?: boolean | null, createdAt?: any | null, updatedAt?: any | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }, companyAuthor?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null, followersCount?: number | null, isFollowing?: boolean | null } | null, article?: { __typename?: 'Article', id: string, title: string, subtitle?: string | null, coverImageUrl?: string | null, slug: string, readingTimeMinutes: number, tags: Array<string>, content: string, status: ArticleStatus, translatedTitle?: string | null, translatedSubtitle?: string | null, translatedExcerpt?: string | null } | null, occasion?: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy, translatedTitle?: string | null, translatedDescription?: string | null } | null, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, translatedQuestion?: string | null, translatedOptions?: Array<string> | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null, event?: { __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, category: string, maxAttendees?: number | null, participantsCount: number, isjoinedbyMe: boolean, organizedby: { __typename?: 'organizedBy', userId?: string | null, name?: string | null, imageUrl?: string | null, companyName?: string | null }, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null } | null, case?: { __typename?: 'CasePostModel', id: string, postId: string, createdAt: any, updatedAt: any, media: Array<{ __typename?: 'CaseMediaModel', id: string, step: string, type: string, imageUrl?: string | null, text?: string | null, order: number, createdAt: any, translatedText?: string | null }> } | null, originalPost?: { __typename?: 'Post', id: string, mediaUrls: Array<string>, isBoosted?: boolean | null, activeBoostId?: string | null, commentsCount: number, isSavedByMe: boolean, isRepostedByMe?: boolean | null, isPublished: boolean, createdAt?: any | null, updatedAt?: any | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, profileImageUrl?: string | null, role: Role, createdAt?: any | null, updatedAt?: any | null, companyName?: string | null }, occasion?: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy, translatedTitle?: string | null, translatedDescription?: string | null } | null, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, translatedQuestion?: string | null, translatedOptions?: Array<string> | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null, event?: { __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, category: string, maxAttendees?: number | null, participantsCount: number, isjoinedbyMe: boolean, organizedby: { __typename?: 'organizedBy', userId?: string | null, name?: string | null, imageUrl?: string | null, companyName?: string | null }, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null } | null, case?: { __typename?: 'CasePostModel', id: string, postId: string, createdAt: any, updatedAt: any, media: Array<{ __typename?: 'CaseMediaModel', id: string, step: string, type: string, imageUrl?: string | null, text?: string | null, order: number, createdAt: any, translatedText?: string | null }> } | null, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> } } | null, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> } } | null }> } };

export type GroupPendingPostsQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type GroupPendingPostsQuery = { __typename?: 'Query', groupPendingPosts: Array<{ __typename?: 'Post', id: string, postType: PostType, createdAt?: any | null, mediaUrls: Array<string>, isPublished: boolean, commentsCount: number, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, profileImageUrl?: string | null, role: Role, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }, article?: { __typename?: 'Article', id: string, title: string, subtitle?: string | null, coverImageUrl?: string | null, slug: string, readingTimeMinutes: number, tags: Array<string>, content: string, status: ArticleStatus, translatedTitle?: string | null, translatedSubtitle?: string | null, translatedExcerpt?: string | null } | null, occasion?: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy, translatedTitle?: string | null, translatedDescription?: string | null } | null, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, translatedQuestion?: string | null, translatedOptions?: Array<string> | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null, event?: { __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, category: string, maxAttendees?: number | null, participantsCount: number, isjoinedbyMe: boolean, organizedby: { __typename?: 'organizedBy', userId?: string | null, name?: string | null, imageUrl?: string | null, companyName?: string | null }, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null } | null, case?: { __typename?: 'CasePostModel', id: string, postId: string, createdAt: any, updatedAt: any, media: Array<{ __typename?: 'CaseMediaModel', id: string, step: string, type: string, imageUrl?: string | null, text?: string | null, order: number, createdAt: any, translatedText?: string | null }> } | null }> };

export type ApprovePostMutationVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type ApprovePostMutation = { __typename?: 'Mutation', approvePost: boolean };

export type RejectPostMutationVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type RejectPostMutation = { __typename?: 'Mutation', rejectPost: boolean };

export type GetGroupRoleIdsQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type GetGroupRoleIdsQuery = { __typename?: 'Query', getGroupRoleIds: { __typename?: 'GroupRoleIds', ownerId: string, admins: Array<string>, moderators: Array<string> } };

export type MyGroupsWithPendingRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyGroupsWithPendingRequestsQuery = { __typename?: 'Query', myGroupsWithPendingRequests: Array<{ __typename?: 'Group', id: string, name: string, memberships?: Array<{ __typename?: 'GroupMembership', id: string, status: MembershipStatus, joinedAt?: any | null, user: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, email: string, role: Role, headline?: string | null, isHiring?: boolean | null, openToWork?: boolean | null, profileImageUrl?: string | null, companyName?: string | null } } | null> | null }> };

export type ApproveMembershipMutationVariables = Exact<{
  membershipId: Scalars['String']['input'];
}>;


export type ApproveMembershipMutation = { __typename?: 'Mutation', approveMembership: boolean };

export type RejectMembershipMutationVariables = Exact<{
  membershipId: Scalars['String']['input'];
}>;


export type RejectMembershipMutation = { __typename?: 'Mutation', rejectMembership: boolean };

export type GetMemberPermissionsQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type GetMemberPermissionsQuery = { __typename?: 'Query', getMemberPermissions: { __typename?: 'MemberPermissions', canPost: boolean, canModerate: boolean, canManageMembers: boolean, canEditSettings: boolean, canDelete: boolean, canAssignRoles: boolean, canRemoveMembers: boolean, canInvite: boolean, role?: string | null, membershipStatus?: string | null, isMember: boolean } };

export type UpdateMemberRoleMutationVariables = Exact<{
  input: UpdateMemberRoleInput;
}>;


export type UpdateMemberRoleMutation = { __typename?: 'Mutation', updateMemberRole: boolean };

export type RemoveMemberFromGroupMutationVariables = Exact<{
  input: RemoveMemberInput;
}>;


export type RemoveMemberFromGroupMutation = { __typename?: 'Mutation', removeMemberFromGroup: boolean };

export type UpdateGroupMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
  input: UpdateGroupInput;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', updateGroup: { __typename?: 'Group', id: string, name: string, description: string, location?: string | null, rules?: string | null, privacy: string, coverImage?: string | null, profileImage?: string | null, tags: Array<string>, reviewPosts: boolean } };

export type DeleteGroupMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type DeleteGroupMutation = { __typename?: 'Mutation', deleteGroup: boolean };

export type BanMutationVariables = Exact<{
  input: BanMemberInput;
}>;


export type BanMutation = { __typename?: 'Mutation', banMember: boolean };

export type UnbanMutationVariables = Exact<{
  input: UnbanMemberInput;
}>;


export type UnbanMutation = { __typename?: 'Mutation', unbanMember: boolean };

export type InviteToGroupMutationVariables = Exact<{
  input: InviteToGroupInput;
}>;


export type InviteToGroupMutation = { __typename?: 'Mutation', inviteToGroup: { __typename?: 'InviteToGroupResponse', success: boolean, message: string, invitedCount: number, skippedCount: number } };

export type AcceptGroupInviteMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type AcceptGroupInviteMutation = { __typename?: 'Mutation', acceptGroupInvite: { __typename?: 'AcceptGroupInviteResponse', joinedInstantly: boolean } };

export type DeclineGroupInviteMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type DeclineGroupInviteMutation = { __typename?: 'Mutation', declineGroupInvite: boolean };

export type MyPendingGroupInviteQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type MyPendingGroupInviteQuery = { __typename?: 'Query', myPendingGroupInvite?: { __typename?: 'GroupInvite', id: string, groupId: string, inviterId: string, inviteeEmail: string, status: InviteStatus, expiresAt: any, createdAt: any, groupName?: string | null, inviter?: { __typename?: 'GroupInviteUserPreview', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null } | null } | null };

export type UpsertUserHeadlineMutationVariables = Exact<{
  input: UserHeadlineInput;
}>;


export type UpsertUserHeadlineMutation = { __typename?: 'Mutation', upsertUserHeadline: boolean };

export type UpdateSelectedBadgesMutationVariables = Exact<{
  input: UpdateSelectedBadgesInput;
}>;


export type UpdateSelectedBadgesMutation = { __typename?: 'Mutation', updateSelectedBadges: Array<{ __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null }> };

export type SetLeaderboardVisibilityMutationVariables = Exact<{
  hidden: Scalars['Boolean']['input'];
}>;


export type SetLeaderboardVisibilityMutation = { __typename?: 'Mutation', setLeaderboardVisibility: boolean };

export type InfluenceBadgeFieldsFragment = { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null };

export type InfluenceProgressFieldsFragment = { __typename?: 'AchievementProgressView', progress: number, target: number, remaining: number, unlocked: boolean, unlockedAt?: any | null, expiresAt?: any | null, badge: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } };

export type InfluenceProfileFieldsFragment = { __typename?: 'InfluenceProfileView', userId: string, lifetimeInfluence: number, contributionCount: number, postsCount: number, periodKey: string, monthlyInfluence: number, monthlyRank?: number | null, tier?: { __typename?: 'InfluenceTierView', threshold: number, badge: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } } | null, nextTier?: { __typename?: 'InfluenceTierView', threshold: number, badge: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } } | null, selectedBadges: Array<{ __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null }>, nameBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null, nextAchievement?: { __typename?: 'AchievementProgressView', progress: number, target: number, remaining: number, unlocked: boolean, unlockedAt?: any | null, expiresAt?: any | null, badge: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } } | null };

export type MyInfluenceProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MyInfluenceProfileQuery = { __typename?: 'Query', myInfluenceProfile: { __typename?: 'InfluenceProfileView', hideFromLeaderboards?: boolean | null, userId: string, lifetimeInfluence: number, contributionCount: number, postsCount: number, periodKey: string, monthlyInfluence: number, monthlyRank?: number | null, tier?: { __typename?: 'InfluenceTierView', threshold: number, badge: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } } | null, nextTier?: { __typename?: 'InfluenceTierView', threshold: number, badge: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } } | null, selectedBadges: Array<{ __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null }>, nameBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null, nextAchievement?: { __typename?: 'AchievementProgressView', progress: number, target: number, remaining: number, unlocked: boolean, unlockedAt?: any | null, expiresAt?: any | null, badge: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } } | null } };

export type InfluenceProfileQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type InfluenceProfileQuery = { __typename?: 'Query', influenceProfile: { __typename?: 'InfluenceProfileView', userId: string, lifetimeInfluence: number, contributionCount: number, postsCount: number, periodKey: string, monthlyInfluence: number, monthlyRank?: number | null, tier?: { __typename?: 'InfluenceTierView', threshold: number, badge: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } } | null, nextTier?: { __typename?: 'InfluenceTierView', threshold: number, badge: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } } | null, selectedBadges: Array<{ __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null }>, nameBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null, nextAchievement?: { __typename?: 'AchievementProgressView', progress: number, target: number, remaining: number, unlocked: boolean, unlockedAt?: any | null, expiresAt?: any | null, badge: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } } | null } };

export type UserAchievementsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserAchievementsQuery = { __typename?: 'Query', userAchievements: Array<{ __typename?: 'UserAchievementView', target: number, unlockedAt: any, expiresAt?: any | null, badge: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } }> };

export type MyAchievementProgressQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAchievementProgressQuery = { __typename?: 'Query', myAchievementProgress: Array<{ __typename?: 'AchievementProgressView', progress: number, target: number, remaining: number, unlocked: boolean, unlockedAt?: any | null, expiresAt?: any | null, badge: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } }> };

export type LeaderboardQueryVariables = Exact<{
  input: LeaderboardInput;
}>;


export type LeaderboardQuery = { __typename?: 'Query', leaderboard: { __typename?: 'LeaderboardPage', category: LeaderboardCategory, periodKey: string, total: number, page: number, limit: number, hasMore: boolean, me: { __typename?: 'LeaderboardPosition', rank?: number | null, score: number }, entries: Array<{ __typename?: 'LeaderboardEntryView', rank: number, userId: string, score: number, isCurrentUser: boolean, user?: { __typename?: 'LeaderboardUserView', id: string, firstName: string, middleName?: string | null, lastName?: string | null, title?: string | null, role: string, profileImageUrl?: string | null, companyName?: string | null } | null }> } };

export type InitializeSessionPaymentMutationVariables = Exact<{
  input: InitializeSessionPaymentInput;
}>;


export type InitializeSessionPaymentMutation = { __typename?: 'Mutation', initializeSessionPayment: { __typename?: 'PaymentIntentResult', clientSecret: string, paymentIntentId: string, amount: number, currency: string, publishableKey: string } };

export type UpdateIsHiringMutationVariables = Exact<{
  isHiring: Scalars['Boolean']['input'];
}>;


export type UpdateIsHiringMutation = { __typename?: 'Mutation', updateIsHiring: boolean };

export type GetIsHiringQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIsHiringQuery = { __typename?: 'Query', getIsHiring: boolean };

export type JobsQueryVariables = Exact<{
  input?: InputMaybe<JobsFilterInput>;
}>;


export type JobsQuery = { __typename?: 'Query', jobs: { __typename?: 'JobsPaginatedResponse', page: number, limit: number, total: number, totalPages: number, hasMore: boolean, items: Array<{ __typename?: 'JobListing', id: string, roleNeeded: string, companyName: string, location?: string | null, createdAt: any, applyUrl: string }> } };

export type JobQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type JobQuery = { __typename?: 'Query', job: { __typename?: 'JobListing', id: string, roleNeeded: string, companyName: string, location?: string | null, createdAt: any, applyUrl: string, status?: string | null, roleType?: JobRoleType | null, specialty?: JobSpecialty | null, headcount?: number | null, additionalLocations?: Array<string> | null, employmentType?: JobEmploymentType | null, workerClassification?: string | null, requiredDaysHours?: string | null, startDate?: string | null, annualCompMin?: number | null, annualCompMax?: number | null, guaranteedDailyRate?: number | null, guaranteeType?: string | null, productionPercentage?: number | null, upsideBasis?: string | null, labFeeResponsibility?: string | null, tieredCommission?: boolean | null, dailyProductionGoal?: number | null, benefits?: Array<string> | null, yearsOfExperience?: JobYearsOfExperience | null, experienceLevel?: string | null, requiredProcedures?: Array<string> | null, microscopeUse?: string | null, requiredLicenses?: Array<string> | null, nonNegotiableAvailability?: string | null, openToMentoring?: boolean | null, challenge?: string | null, officeDescription?: string | null, whyAttractive?: string | null, neighborhoodDescription?: string | null, techLevel?: number | null, majorEquipment?: Array<string> | null, specialistCaseVolume?: string | null } };

export type JobFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type JobFilterOptionsQuery = { __typename?: 'Query', jobFilterOptions: { __typename?: 'JobFilterOptions', roleTypes: Array<{ __typename?: 'JobFilterOption', value: string, label: string }>, specialties: Array<{ __typename?: 'JobFilterOption', value: string, label: string }>, employmentTypes: Array<{ __typename?: 'JobFilterOption', value: string, label: string }>, yearsOfExperience: Array<{ __typename?: 'JobFilterOption', value: string, label: string }>, sort: Array<{ __typename?: 'JobFilterOption', value: string, label: string }> } };

export type LibraryContentCardFieldsFragment = { __typename?: 'LibraryContentCard', contentType: LibraryContentType, contentId: string, title: string, subtitle?: string | null, thumbnailUrl?: string | null, authorId?: string | null, authorName?: string | null, authorImageUrl?: string | null, provider?: string | null, publishedAt?: any | null, updatedAt?: any | null, slug?: string | null, externalUrl?: string | null, subKind?: string | null, details?: { __typename?: 'LibraryCardDetails', description?: string | null, excerpt?: string | null, mediaUrls?: Array<string> | null, likesCount?: number | null, commentsCount?: number | null, playsCount?: number | null, category?: string | null, difficultyLevel?: string | null, language?: string | null, durationMinutes?: number | null, totalLectures?: number | null, averageRating?: number | null, totalRatings?: number | null, instructors?: Array<string> | null, ceCredits?: number | null, price?: number | null, currency?: string | null, isFree?: boolean | null, deliveryMode?: string | null, format?: string | null, startsAt?: any | null, expiresAt?: any | null, readingTimeMinutes?: number | null, durationSeconds?: number | null, mediaType?: string | null, isCurated?: boolean | null, location?: string | null, postId?: string | null, participantsCount?: number | null, priceType?: string | null } | null };

export type LibraryItemFieldsFragment = { __typename?: 'LibraryItemModel', id: string, contentType: LibraryContentType, contentId: string, isFavorite: boolean, savedAt: any, availability: LibraryAvailability, content?: { __typename?: 'LibraryContentCard', contentType: LibraryContentType, contentId: string, title: string, subtitle?: string | null, thumbnailUrl?: string | null, authorId?: string | null, authorName?: string | null, authorImageUrl?: string | null, provider?: string | null, publishedAt?: any | null, updatedAt?: any | null, slug?: string | null, externalUrl?: string | null, subKind?: string | null, details?: { __typename?: 'LibraryCardDetails', description?: string | null, excerpt?: string | null, mediaUrls?: Array<string> | null, likesCount?: number | null, commentsCount?: number | null, playsCount?: number | null, category?: string | null, difficultyLevel?: string | null, language?: string | null, durationMinutes?: number | null, totalLectures?: number | null, averageRating?: number | null, totalRatings?: number | null, instructors?: Array<string> | null, ceCredits?: number | null, price?: number | null, currency?: string | null, isFree?: boolean | null, deliveryMode?: string | null, format?: string | null, startsAt?: any | null, expiresAt?: any | null, readingTimeMinutes?: number | null, durationSeconds?: number | null, mediaType?: string | null, isCurated?: boolean | null, location?: string | null, postId?: string | null, participantsCount?: number | null, priceType?: string | null } | null } | null, folders: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, collections: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, tags: Array<{ __typename?: 'LibraryTagModel', id: string, name: string }>, note?: { __typename?: 'LibraryNoteModel', id: string, body: string, updatedAt: any } | null };

export type LibraryEntryFieldsFragment = { __typename?: 'LibraryEntryModel', id: string, contentType: LibraryContentType, contentId: string, addedById: string, addedByName?: string | null, addedAt: any, availability: LibraryAvailability, mySavedItemId?: string | null, isFavorite: boolean, content?: { __typename?: 'LibraryContentCard', contentType: LibraryContentType, contentId: string, title: string, subtitle?: string | null, thumbnailUrl?: string | null, authorId?: string | null, authorName?: string | null, authorImageUrl?: string | null, provider?: string | null, publishedAt?: any | null, updatedAt?: any | null, slug?: string | null, externalUrl?: string | null, subKind?: string | null, details?: { __typename?: 'LibraryCardDetails', description?: string | null, excerpt?: string | null, mediaUrls?: Array<string> | null, likesCount?: number | null, commentsCount?: number | null, playsCount?: number | null, category?: string | null, difficultyLevel?: string | null, language?: string | null, durationMinutes?: number | null, totalLectures?: number | null, averageRating?: number | null, totalRatings?: number | null, instructors?: Array<string> | null, ceCredits?: number | null, price?: number | null, currency?: string | null, isFree?: boolean | null, deliveryMode?: string | null, format?: string | null, startsAt?: any | null, expiresAt?: any | null, readingTimeMinutes?: number | null, durationSeconds?: number | null, mediaType?: string | null, isCurated?: boolean | null, location?: string | null, postId?: string | null, participantsCount?: number | null, priceType?: string | null } | null } | null };

export type LibraryFolderFieldsFragment = { __typename?: 'LibraryFolderModel', id: string, name: string, description?: string | null, parentId?: string | null, depth: number, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, subfolderCount: number, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null };

export type LibraryCollectionFieldsFragment = { __typename?: 'LibraryCollectionModel', id: string, name: string, description?: string | null, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null };

export type LibrarySearchResultFieldsFragment = { __typename?: 'LibrarySearchResultModel', key: string, contentType: LibraryContentType, contentId: string, availability: LibraryAvailability, date: any, addedByName?: string | null, content?: { __typename?: 'LibraryContentCard', contentType: LibraryContentType, contentId: string, title: string, subtitle?: string | null, thumbnailUrl?: string | null, authorId?: string | null, authorName?: string | null, authorImageUrl?: string | null, provider?: string | null, publishedAt?: any | null, updatedAt?: any | null, slug?: string | null, externalUrl?: string | null, subKind?: string | null, details?: { __typename?: 'LibraryCardDetails', description?: string | null, excerpt?: string | null, mediaUrls?: Array<string> | null, likesCount?: number | null, commentsCount?: number | null, playsCount?: number | null, category?: string | null, difficultyLevel?: string | null, language?: string | null, durationMinutes?: number | null, totalLectures?: number | null, averageRating?: number | null, totalRatings?: number | null, instructors?: Array<string> | null, ceCredits?: number | null, price?: number | null, currency?: string | null, isFree?: boolean | null, deliveryMode?: string | null, format?: string | null, startsAt?: any | null, expiresAt?: any | null, readingTimeMinutes?: number | null, durationSeconds?: number | null, mediaType?: string | null, isCurated?: boolean | null, location?: string | null, postId?: string | null, participantsCount?: number | null, priceType?: string | null } | null } | null, savedItem?: { __typename?: 'LibraryItemModel', id: string, contentType: LibraryContentType, contentId: string, isFavorite: boolean, savedAt: any, availability: LibraryAvailability, content?: { __typename?: 'LibraryContentCard', contentType: LibraryContentType, contentId: string, title: string, subtitle?: string | null, thumbnailUrl?: string | null, authorId?: string | null, authorName?: string | null, authorImageUrl?: string | null, provider?: string | null, publishedAt?: any | null, updatedAt?: any | null, slug?: string | null, externalUrl?: string | null, subKind?: string | null, details?: { __typename?: 'LibraryCardDetails', description?: string | null, excerpt?: string | null, mediaUrls?: Array<string> | null, likesCount?: number | null, commentsCount?: number | null, playsCount?: number | null, category?: string | null, difficultyLevel?: string | null, language?: string | null, durationMinutes?: number | null, totalLectures?: number | null, averageRating?: number | null, totalRatings?: number | null, instructors?: Array<string> | null, ceCredits?: number | null, price?: number | null, currency?: string | null, isFree?: boolean | null, deliveryMode?: string | null, format?: string | null, startsAt?: any | null, expiresAt?: any | null, readingTimeMinutes?: number | null, durationSeconds?: number | null, mediaType?: string | null, isCurated?: boolean | null, location?: string | null, postId?: string | null, participantsCount?: number | null, priceType?: string | null } | null } | null, folders: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, collections: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, tags: Array<{ __typename?: 'LibraryTagModel', id: string, name: string }>, note?: { __typename?: 'LibraryNoteModel', id: string, body: string, updatedAt: any } | null } | null, locations: Array<{ __typename?: 'LibraryLocationModel', id: string, name: string, resourceType: LibraryResourceType, sharedByName?: string | null }> };

export type SaveLibraryItemMutationVariables = Exact<{
  input: SaveLibraryItemInput;
}>;


export type SaveLibraryItemMutation = { __typename?: 'Mutation', saveLibraryItem: { __typename?: 'LibraryItemModel', id: string, contentType: LibraryContentType, contentId: string, isFavorite: boolean, savedAt: any, availability: LibraryAvailability, content?: { __typename?: 'LibraryContentCard', contentType: LibraryContentType, contentId: string, title: string, subtitle?: string | null, thumbnailUrl?: string | null, authorId?: string | null, authorName?: string | null, authorImageUrl?: string | null, provider?: string | null, publishedAt?: any | null, updatedAt?: any | null, slug?: string | null, externalUrl?: string | null, subKind?: string | null, details?: { __typename?: 'LibraryCardDetails', description?: string | null, excerpt?: string | null, mediaUrls?: Array<string> | null, likesCount?: number | null, commentsCount?: number | null, playsCount?: number | null, category?: string | null, difficultyLevel?: string | null, language?: string | null, durationMinutes?: number | null, totalLectures?: number | null, averageRating?: number | null, totalRatings?: number | null, instructors?: Array<string> | null, ceCredits?: number | null, price?: number | null, currency?: string | null, isFree?: boolean | null, deliveryMode?: string | null, format?: string | null, startsAt?: any | null, expiresAt?: any | null, readingTimeMinutes?: number | null, durationSeconds?: number | null, mediaType?: string | null, isCurated?: boolean | null, location?: string | null, postId?: string | null, participantsCount?: number | null, priceType?: string | null } | null } | null, folders: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, collections: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, tags: Array<{ __typename?: 'LibraryTagModel', id: string, name: string }>, note?: { __typename?: 'LibraryNoteModel', id: string, body: string, updatedAt: any } | null } };

export type UnsaveLibraryItemMutationVariables = Exact<{
  itemId: Scalars['ID']['input'];
}>;


export type UnsaveLibraryItemMutation = { __typename?: 'Mutation', unsaveLibraryItem: boolean };

export type ToggleLibraryFavoriteMutationVariables = Exact<{
  itemId: Scalars['ID']['input'];
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ToggleLibraryFavoriteMutation = { __typename?: 'Mutation', toggleLibraryFavorite: { __typename?: 'LibraryItemModel', id: string, isFavorite: boolean } };

export type CreateLibraryFolderMutationVariables = Exact<{
  input: CreateLibraryFolderInput;
}>;


export type CreateLibraryFolderMutation = { __typename?: 'Mutation', createLibraryFolder: { __typename?: 'LibraryFolderModel', id: string, name: string, description?: string | null, parentId?: string | null, depth: number, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, subfolderCount: number, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null } };

export type UpdateLibraryFolderMutationVariables = Exact<{
  input: UpdateLibraryFolderInput;
}>;


export type UpdateLibraryFolderMutation = { __typename?: 'Mutation', updateLibraryFolder: { __typename?: 'LibraryFolderModel', id: string, name: string, description?: string | null, parentId?: string | null, depth: number, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, subfolderCount: number, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null } };

export type MoveLibraryFolderMutationVariables = Exact<{
  input: MoveLibraryFolderInput;
}>;


export type MoveLibraryFolderMutation = { __typename?: 'Mutation', moveLibraryFolder: { __typename?: 'LibraryFolderModel', id: string, name: string, description?: string | null, parentId?: string | null, depth: number, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, subfolderCount: number, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null } };

export type DeleteLibraryFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteLibraryFolderMutation = { __typename?: 'Mutation', deleteLibraryFolder: boolean };

export type RestoreLibraryFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RestoreLibraryFolderMutation = { __typename?: 'Mutation', restoreLibraryFolder: { __typename?: 'LibraryFolderModel', id: string, name: string, description?: string | null, parentId?: string | null, depth: number, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, subfolderCount: number, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null } };

export type RestoreLibraryCollectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RestoreLibraryCollectionMutation = { __typename?: 'Mutation', restoreLibraryCollection: { __typename?: 'LibraryCollectionModel', id: string, name: string, description?: string | null, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null } };

export type CreateLibraryCollectionMutationVariables = Exact<{
  input: CreateLibraryCollectionInput;
}>;


export type CreateLibraryCollectionMutation = { __typename?: 'Mutation', createLibraryCollection: { __typename?: 'LibraryCollectionModel', id: string, name: string, description?: string | null, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null } };

export type UpdateLibraryCollectionMutationVariables = Exact<{
  input: UpdateLibraryCollectionInput;
}>;


export type UpdateLibraryCollectionMutation = { __typename?: 'Mutation', updateLibraryCollection: { __typename?: 'LibraryCollectionModel', id: string, name: string, description?: string | null, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null } };

export type DeleteLibraryCollectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteLibraryCollectionMutation = { __typename?: 'Mutation', deleteLibraryCollection: boolean };

export type AddLibraryEntryMutationVariables = Exact<{
  input: LibraryEntryInput;
}>;


export type AddLibraryEntryMutation = { __typename?: 'Mutation', addLibraryEntry: { __typename?: 'LibraryEntryModel', id: string, contentType: LibraryContentType, contentId: string, addedById: string, addedByName?: string | null, addedAt: any, availability: LibraryAvailability, mySavedItemId?: string | null, isFavorite: boolean, content?: { __typename?: 'LibraryContentCard', contentType: LibraryContentType, contentId: string, title: string, subtitle?: string | null, thumbnailUrl?: string | null, authorId?: string | null, authorName?: string | null, authorImageUrl?: string | null, provider?: string | null, publishedAt?: any | null, updatedAt?: any | null, slug?: string | null, externalUrl?: string | null, subKind?: string | null, details?: { __typename?: 'LibraryCardDetails', description?: string | null, excerpt?: string | null, mediaUrls?: Array<string> | null, likesCount?: number | null, commentsCount?: number | null, playsCount?: number | null, category?: string | null, difficultyLevel?: string | null, language?: string | null, durationMinutes?: number | null, totalLectures?: number | null, averageRating?: number | null, totalRatings?: number | null, instructors?: Array<string> | null, ceCredits?: number | null, price?: number | null, currency?: string | null, isFree?: boolean | null, deliveryMode?: string | null, format?: string | null, startsAt?: any | null, expiresAt?: any | null, readingTimeMinutes?: number | null, durationSeconds?: number | null, mediaType?: string | null, isCurated?: boolean | null, location?: string | null, postId?: string | null, participantsCount?: number | null, priceType?: string | null } | null } | null } };

export type RemoveLibraryEntryMutationVariables = Exact<{
  input: LibraryEntryInput;
}>;


export type RemoveLibraryEntryMutation = { __typename?: 'Mutation', removeLibraryEntry: boolean };

export type MoveLibraryItemMutationVariables = Exact<{
  input: MoveLibraryItemInput;
}>;


export type MoveLibraryItemMutation = { __typename?: 'Mutation', moveLibraryItem: boolean };

export type ReorderLibraryCollectionItemsMutationVariables = Exact<{
  input: ReorderLibraryCollectionInput;
}>;


export type ReorderLibraryCollectionItemsMutation = { __typename?: 'Mutation', reorderLibraryCollectionItems: boolean };

export type CreateLibraryTagMutationVariables = Exact<{
  input: CreateLibraryTagInput;
}>;


export type CreateLibraryTagMutation = { __typename?: 'Mutation', createLibraryTag: { __typename?: 'LibraryTagModel', id: string, name: string, itemCount?: number | null } };

export type UpdateLibraryTagMutationVariables = Exact<{
  input: UpdateLibraryTagInput;
}>;


export type UpdateLibraryTagMutation = { __typename?: 'Mutation', updateLibraryTag: { __typename?: 'LibraryTagModel', id: string, name: string } };

export type DeleteLibraryTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteLibraryTagMutation = { __typename?: 'Mutation', deleteLibraryTag: boolean };

export type AddLibraryItemTagMutationVariables = Exact<{
  input: LibraryItemTagInput;
}>;


export type AddLibraryItemTagMutation = { __typename?: 'Mutation', addLibraryItemTag: { __typename?: 'LibraryItemModel', id: string, contentType: LibraryContentType, contentId: string, isFavorite: boolean, savedAt: any, availability: LibraryAvailability, content?: { __typename?: 'LibraryContentCard', contentType: LibraryContentType, contentId: string, title: string, subtitle?: string | null, thumbnailUrl?: string | null, authorId?: string | null, authorName?: string | null, authorImageUrl?: string | null, provider?: string | null, publishedAt?: any | null, updatedAt?: any | null, slug?: string | null, externalUrl?: string | null, subKind?: string | null, details?: { __typename?: 'LibraryCardDetails', description?: string | null, excerpt?: string | null, mediaUrls?: Array<string> | null, likesCount?: number | null, commentsCount?: number | null, playsCount?: number | null, category?: string | null, difficultyLevel?: string | null, language?: string | null, durationMinutes?: number | null, totalLectures?: number | null, averageRating?: number | null, totalRatings?: number | null, instructors?: Array<string> | null, ceCredits?: number | null, price?: number | null, currency?: string | null, isFree?: boolean | null, deliveryMode?: string | null, format?: string | null, startsAt?: any | null, expiresAt?: any | null, readingTimeMinutes?: number | null, durationSeconds?: number | null, mediaType?: string | null, isCurated?: boolean | null, location?: string | null, postId?: string | null, participantsCount?: number | null, priceType?: string | null } | null } | null, folders: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, collections: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, tags: Array<{ __typename?: 'LibraryTagModel', id: string, name: string }>, note?: { __typename?: 'LibraryNoteModel', id: string, body: string, updatedAt: any } | null } };

export type RemoveLibraryItemTagMutationVariables = Exact<{
  input: LibraryItemTagInput;
}>;


export type RemoveLibraryItemTagMutation = { __typename?: 'Mutation', removeLibraryItemTag: { __typename?: 'LibraryItemModel', id: string, contentType: LibraryContentType, contentId: string, isFavorite: boolean, savedAt: any, availability: LibraryAvailability, content?: { __typename?: 'LibraryContentCard', contentType: LibraryContentType, contentId: string, title: string, subtitle?: string | null, thumbnailUrl?: string | null, authorId?: string | null, authorName?: string | null, authorImageUrl?: string | null, provider?: string | null, publishedAt?: any | null, updatedAt?: any | null, slug?: string | null, externalUrl?: string | null, subKind?: string | null, details?: { __typename?: 'LibraryCardDetails', description?: string | null, excerpt?: string | null, mediaUrls?: Array<string> | null, likesCount?: number | null, commentsCount?: number | null, playsCount?: number | null, category?: string | null, difficultyLevel?: string | null, language?: string | null, durationMinutes?: number | null, totalLectures?: number | null, averageRating?: number | null, totalRatings?: number | null, instructors?: Array<string> | null, ceCredits?: number | null, price?: number | null, currency?: string | null, isFree?: boolean | null, deliveryMode?: string | null, format?: string | null, startsAt?: any | null, expiresAt?: any | null, readingTimeMinutes?: number | null, durationSeconds?: number | null, mediaType?: string | null, isCurated?: boolean | null, location?: string | null, postId?: string | null, participantsCount?: number | null, priceType?: string | null } | null } | null, folders: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, collections: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, tags: Array<{ __typename?: 'LibraryTagModel', id: string, name: string }>, note?: { __typename?: 'LibraryNoteModel', id: string, body: string, updatedAt: any } | null } };

export type UpsertLibraryNoteMutationVariables = Exact<{
  input: UpsertLibraryNoteInput;
}>;


export type UpsertLibraryNoteMutation = { __typename?: 'Mutation', upsertLibraryNote: { __typename?: 'LibraryItemModel', id: string, contentType: LibraryContentType, contentId: string, isFavorite: boolean, savedAt: any, availability: LibraryAvailability, content?: { __typename?: 'LibraryContentCard', contentType: LibraryContentType, contentId: string, title: string, subtitle?: string | null, thumbnailUrl?: string | null, authorId?: string | null, authorName?: string | null, authorImageUrl?: string | null, provider?: string | null, publishedAt?: any | null, updatedAt?: any | null, slug?: string | null, externalUrl?: string | null, subKind?: string | null, details?: { __typename?: 'LibraryCardDetails', description?: string | null, excerpt?: string | null, mediaUrls?: Array<string> | null, likesCount?: number | null, commentsCount?: number | null, playsCount?: number | null, category?: string | null, difficultyLevel?: string | null, language?: string | null, durationMinutes?: number | null, totalLectures?: number | null, averageRating?: number | null, totalRatings?: number | null, instructors?: Array<string> | null, ceCredits?: number | null, price?: number | null, currency?: string | null, isFree?: boolean | null, deliveryMode?: string | null, format?: string | null, startsAt?: any | null, expiresAt?: any | null, readingTimeMinutes?: number | null, durationSeconds?: number | null, mediaType?: string | null, isCurated?: boolean | null, location?: string | null, postId?: string | null, participantsCount?: number | null, priceType?: string | null } | null } | null, folders: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, collections: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, tags: Array<{ __typename?: 'LibraryTagModel', id: string, name: string }>, note?: { __typename?: 'LibraryNoteModel', id: string, body: string, updatedAt: any } | null } };

export type DeleteLibraryNoteMutationVariables = Exact<{
  itemId: Scalars['ID']['input'];
}>;


export type DeleteLibraryNoteMutation = { __typename?: 'Mutation', deleteLibraryNote: { __typename?: 'LibraryItemModel', id: string, contentType: LibraryContentType, contentId: string, isFavorite: boolean, savedAt: any, availability: LibraryAvailability, content?: { __typename?: 'LibraryContentCard', contentType: LibraryContentType, contentId: string, title: string, subtitle?: string | null, thumbnailUrl?: string | null, authorId?: string | null, authorName?: string | null, authorImageUrl?: string | null, provider?: string | null, publishedAt?: any | null, updatedAt?: any | null, slug?: string | null, externalUrl?: string | null, subKind?: string | null, details?: { __typename?: 'LibraryCardDetails', description?: string | null, excerpt?: string | null, mediaUrls?: Array<string> | null, likesCount?: number | null, commentsCount?: number | null, playsCount?: number | null, category?: string | null, difficultyLevel?: string | null, language?: string | null, durationMinutes?: number | null, totalLectures?: number | null, averageRating?: number | null, totalRatings?: number | null, instructors?: Array<string> | null, ceCredits?: number | null, price?: number | null, currency?: string | null, isFree?: boolean | null, deliveryMode?: string | null, format?: string | null, startsAt?: any | null, expiresAt?: any | null, readingTimeMinutes?: number | null, durationSeconds?: number | null, mediaType?: string | null, isCurated?: boolean | null, location?: string | null, postId?: string | null, participantsCount?: number | null, priceType?: string | null } | null } | null, folders: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, collections: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, tags: Array<{ __typename?: 'LibraryTagModel', id: string, name: string }>, note?: { __typename?: 'LibraryNoteModel', id: string, body: string, updatedAt: any } | null } };

export type ShareLibraryResourceMutationVariables = Exact<{
  input: ShareLibraryResourceInput;
}>;


export type ShareLibraryResourceMutation = { __typename?: 'Mutation', shareLibraryResource: { __typename?: 'LibraryShareMember', shareId: string, userId: string, name: string, profileImageUrl?: string | null, headline?: string | null, role: LibraryShareRole, resourceType: LibraryResourceType, resourceId: string, createdAt: any } };

export type UpdateLibraryShareRoleMutationVariables = Exact<{
  input: UpdateLibraryShareRoleInput;
}>;


export type UpdateLibraryShareRoleMutation = { __typename?: 'Mutation', updateLibraryShareRole: boolean };

export type RevokeLibraryShareMutationVariables = Exact<{
  shareId: Scalars['ID']['input'];
}>;


export type RevokeLibraryShareMutation = { __typename?: 'Mutation', revokeLibraryShare: boolean };

export type LeaveLibraryShareMutationVariables = Exact<{
  shareId: Scalars['ID']['input'];
}>;


export type LeaveLibraryShareMutation = { __typename?: 'Mutation', leaveLibraryShare: boolean };

export type MyLibraryItemsQueryVariables = Exact<{
  input?: InputMaybe<LibraryItemsInput>;
}>;


export type MyLibraryItemsQuery = { __typename?: 'Query', myLibraryItems: { __typename?: 'LibraryItemPage', total: number, hasMore: boolean, page: number, limit: number, typeCounts?: Array<{ __typename?: 'LibraryTypeCount', filter: LibraryTypeFilter, count: number }> | null, items: Array<{ __typename?: 'LibraryItemModel', id: string, contentType: LibraryContentType, contentId: string, isFavorite: boolean, savedAt: any, availability: LibraryAvailability, content?: { __typename?: 'LibraryContentCard', contentType: LibraryContentType, contentId: string, title: string, subtitle?: string | null, thumbnailUrl?: string | null, authorId?: string | null, authorName?: string | null, authorImageUrl?: string | null, provider?: string | null, publishedAt?: any | null, updatedAt?: any | null, slug?: string | null, externalUrl?: string | null, subKind?: string | null, details?: { __typename?: 'LibraryCardDetails', description?: string | null, excerpt?: string | null, mediaUrls?: Array<string> | null, likesCount?: number | null, commentsCount?: number | null, playsCount?: number | null, category?: string | null, difficultyLevel?: string | null, language?: string | null, durationMinutes?: number | null, totalLectures?: number | null, averageRating?: number | null, totalRatings?: number | null, instructors?: Array<string> | null, ceCredits?: number | null, price?: number | null, currency?: string | null, isFree?: boolean | null, deliveryMode?: string | null, format?: string | null, startsAt?: any | null, expiresAt?: any | null, readingTimeMinutes?: number | null, durationSeconds?: number | null, mediaType?: string | null, isCurated?: boolean | null, location?: string | null, postId?: string | null, participantsCount?: number | null, priceType?: string | null } | null } | null, folders: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, collections: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, tags: Array<{ __typename?: 'LibraryTagModel', id: string, name: string }>, note?: { __typename?: 'LibraryNoteModel', id: string, body: string, updatedAt: any } | null }> } };

export type SearchMyLibraryQueryVariables = Exact<{
  input: LibrarySearchInput;
}>;


export type SearchMyLibraryQuery = { __typename?: 'Query', searchMyLibrary: { __typename?: 'LibrarySearchPage', total: number, hasMore: boolean, page: number, limit: number, typeCounts: Array<{ __typename?: 'LibraryTypeCount', filter: LibraryTypeFilter, count: number }>, results: Array<{ __typename?: 'LibrarySearchResultModel', key: string, contentType: LibraryContentType, contentId: string, availability: LibraryAvailability, date: any, addedByName?: string | null, content?: { __typename?: 'LibraryContentCard', contentType: LibraryContentType, contentId: string, title: string, subtitle?: string | null, thumbnailUrl?: string | null, authorId?: string | null, authorName?: string | null, authorImageUrl?: string | null, provider?: string | null, publishedAt?: any | null, updatedAt?: any | null, slug?: string | null, externalUrl?: string | null, subKind?: string | null, details?: { __typename?: 'LibraryCardDetails', description?: string | null, excerpt?: string | null, mediaUrls?: Array<string> | null, likesCount?: number | null, commentsCount?: number | null, playsCount?: number | null, category?: string | null, difficultyLevel?: string | null, language?: string | null, durationMinutes?: number | null, totalLectures?: number | null, averageRating?: number | null, totalRatings?: number | null, instructors?: Array<string> | null, ceCredits?: number | null, price?: number | null, currency?: string | null, isFree?: boolean | null, deliveryMode?: string | null, format?: string | null, startsAt?: any | null, expiresAt?: any | null, readingTimeMinutes?: number | null, durationSeconds?: number | null, mediaType?: string | null, isCurated?: boolean | null, location?: string | null, postId?: string | null, participantsCount?: number | null, priceType?: string | null } | null } | null, savedItem?: { __typename?: 'LibraryItemModel', id: string, contentType: LibraryContentType, contentId: string, isFavorite: boolean, savedAt: any, availability: LibraryAvailability, content?: { __typename?: 'LibraryContentCard', contentType: LibraryContentType, contentId: string, title: string, subtitle?: string | null, thumbnailUrl?: string | null, authorId?: string | null, authorName?: string | null, authorImageUrl?: string | null, provider?: string | null, publishedAt?: any | null, updatedAt?: any | null, slug?: string | null, externalUrl?: string | null, subKind?: string | null, details?: { __typename?: 'LibraryCardDetails', description?: string | null, excerpt?: string | null, mediaUrls?: Array<string> | null, likesCount?: number | null, commentsCount?: number | null, playsCount?: number | null, category?: string | null, difficultyLevel?: string | null, language?: string | null, durationMinutes?: number | null, totalLectures?: number | null, averageRating?: number | null, totalRatings?: number | null, instructors?: Array<string> | null, ceCredits?: number | null, price?: number | null, currency?: string | null, isFree?: boolean | null, deliveryMode?: string | null, format?: string | null, startsAt?: any | null, expiresAt?: any | null, readingTimeMinutes?: number | null, durationSeconds?: number | null, mediaType?: string | null, isCurated?: boolean | null, location?: string | null, postId?: string | null, participantsCount?: number | null, priceType?: string | null } | null } | null, folders: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, collections: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, tags: Array<{ __typename?: 'LibraryTagModel', id: string, name: string }>, note?: { __typename?: 'LibraryNoteModel', id: string, body: string, updatedAt: any } | null } | null, locations: Array<{ __typename?: 'LibraryLocationModel', id: string, name: string, resourceType: LibraryResourceType, sharedByName?: string | null }> }> } };

export type MyLibraryItemQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MyLibraryItemQuery = { __typename?: 'Query', myLibraryItem: { __typename?: 'LibraryItemModel', id: string, contentType: LibraryContentType, contentId: string, isFavorite: boolean, savedAt: any, availability: LibraryAvailability, content?: { __typename?: 'LibraryContentCard', contentType: LibraryContentType, contentId: string, title: string, subtitle?: string | null, thumbnailUrl?: string | null, authorId?: string | null, authorName?: string | null, authorImageUrl?: string | null, provider?: string | null, publishedAt?: any | null, updatedAt?: any | null, slug?: string | null, externalUrl?: string | null, subKind?: string | null, details?: { __typename?: 'LibraryCardDetails', description?: string | null, excerpt?: string | null, mediaUrls?: Array<string> | null, likesCount?: number | null, commentsCount?: number | null, playsCount?: number | null, category?: string | null, difficultyLevel?: string | null, language?: string | null, durationMinutes?: number | null, totalLectures?: number | null, averageRating?: number | null, totalRatings?: number | null, instructors?: Array<string> | null, ceCredits?: number | null, price?: number | null, currency?: string | null, isFree?: boolean | null, deliveryMode?: string | null, format?: string | null, startsAt?: any | null, expiresAt?: any | null, readingTimeMinutes?: number | null, durationSeconds?: number | null, mediaType?: string | null, isCurated?: boolean | null, location?: string | null, postId?: string | null, participantsCount?: number | null, priceType?: string | null } | null } | null, folders: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, collections: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }>, tags: Array<{ __typename?: 'LibraryTagModel', id: string, name: string }>, note?: { __typename?: 'LibraryNoteModel', id: string, body: string, updatedAt: any } | null } };

export type MyLibraryStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyLibraryStatsQuery = { __typename?: 'Query', myLibraryStats: { __typename?: 'LibraryStats', total: number, favorites: number, unfiled: number, posts: number, cases: number, articles: number, ceCourses: number, media: number, folders: number, collections: number, sharedWithMe: number } };

export type MyLibraryOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type MyLibraryOverviewQuery = { __typename?: 'Query', myLibraryStats: { __typename?: 'LibraryStats', total: number, favorites: number, unfiled: number, posts: number, cases: number, articles: number, ceCourses: number, media: number, folders: number, collections: number, sharedWithMe: number }, myLibraryFolders: Array<{ __typename?: 'LibraryFolderModel', id: string, name: string, description?: string | null, parentId?: string | null, depth: number, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, subfolderCount: number, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null }>, myLibraryCollections: Array<{ __typename?: 'LibraryCollectionModel', id: string, name: string, description?: string | null, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null }> };

export type LibrarySaveDestinationsQueryVariables = Exact<{ [key: string]: never; }>;


export type LibrarySaveDestinationsQuery = { __typename?: 'Query', myLibraryFolders: Array<{ __typename?: 'LibraryFolderModel', id: string, name: string, description?: string | null, parentId?: string | null, depth: number, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, subfolderCount: number, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null }>, myLibraryCollections: Array<{ __typename?: 'LibraryCollectionModel', id: string, name: string, description?: string | null, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null }>, sharedWithMeLibrary: { __typename?: 'LibrarySharedWithMe', folders: Array<{ __typename?: 'LibraryFolderModel', id: string, name: string, description?: string | null, parentId?: string | null, depth: number, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, subfolderCount: number, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null }>, collections: Array<{ __typename?: 'LibraryCollectionModel', id: string, name: string, description?: string | null, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null }> } };

export type MyLibraryFoldersQueryVariables = Exact<{
  parentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type MyLibraryFoldersQuery = { __typename?: 'Query', myLibraryFolders: Array<{ __typename?: 'LibraryFolderModel', id: string, name: string, description?: string | null, parentId?: string | null, depth: number, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, subfolderCount: number, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null }> };

export type MyLibraryFolderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MyLibraryFolderQuery = { __typename?: 'Query', myLibraryFolder: { __typename?: 'LibraryFolderModel', id: string, name: string, description?: string | null, parentId?: string | null, depth: number, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, subfolderCount: number, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null, breadcrumb?: Array<{ __typename?: 'LibraryFolderRef', id: string, name: string }> | null } };

export type MyLibraryTrashQueryVariables = Exact<{ [key: string]: never; }>;


export type MyLibraryTrashQuery = { __typename?: 'Query', myLibraryTrash: { __typename?: 'LibraryTrash', folders: Array<{ __typename?: 'LibraryFolderModel', id: string, name: string, description?: string | null, parentId?: string | null, depth: number, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, subfolderCount: number, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null }>, collections: Array<{ __typename?: 'LibraryCollectionModel', id: string, name: string, description?: string | null, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null }> } };

export type MyTrashedLibraryFoldersQueryVariables = Exact<{ [key: string]: never; }>;


export type MyTrashedLibraryFoldersQuery = { __typename?: 'Query', myTrashedLibraryFolders: Array<{ __typename?: 'LibraryFolderModel', id: string, name: string, description?: string | null, parentId?: string | null, depth: number, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, subfolderCount: number, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null }> };

export type MyLibraryCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyLibraryCollectionsQuery = { __typename?: 'Query', myLibraryCollections: Array<{ __typename?: 'LibraryCollectionModel', id: string, name: string, description?: string | null, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null }> };

export type MyLibraryCollectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MyLibraryCollectionQuery = { __typename?: 'Query', myLibraryCollection: { __typename?: 'LibraryCollectionModel', id: string, name: string, description?: string | null, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null } };

export type MyLibraryTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyLibraryTagsQuery = { __typename?: 'Query', myLibraryTags: Array<{ __typename?: 'LibraryTagModel', id: string, name: string, itemCount?: number | null }> };

export type LibraryEntriesQueryVariables = Exact<{
  input: LibraryEntriesInput;
}>;


export type LibraryEntriesQuery = { __typename?: 'Query', libraryEntries: { __typename?: 'LibraryEntryPage', total: number, hasMore: boolean, page: number, limit: number, typeCounts?: Array<{ __typename?: 'LibraryTypeCount', filter: LibraryTypeFilter, count: number }> | null, entries: Array<{ __typename?: 'LibraryEntryModel', id: string, contentType: LibraryContentType, contentId: string, addedById: string, addedByName?: string | null, addedAt: any, availability: LibraryAvailability, mySavedItemId?: string | null, isFavorite: boolean, content?: { __typename?: 'LibraryContentCard', contentType: LibraryContentType, contentId: string, title: string, subtitle?: string | null, thumbnailUrl?: string | null, authorId?: string | null, authorName?: string | null, authorImageUrl?: string | null, provider?: string | null, publishedAt?: any | null, updatedAt?: any | null, slug?: string | null, externalUrl?: string | null, subKind?: string | null, details?: { __typename?: 'LibraryCardDetails', description?: string | null, excerpt?: string | null, mediaUrls?: Array<string> | null, likesCount?: number | null, commentsCount?: number | null, playsCount?: number | null, category?: string | null, difficultyLevel?: string | null, language?: string | null, durationMinutes?: number | null, totalLectures?: number | null, averageRating?: number | null, totalRatings?: number | null, instructors?: Array<string> | null, ceCredits?: number | null, price?: number | null, currency?: string | null, isFree?: boolean | null, deliveryMode?: string | null, format?: string | null, startsAt?: any | null, expiresAt?: any | null, readingTimeMinutes?: number | null, durationSeconds?: number | null, mediaType?: string | null, isCurated?: boolean | null, location?: string | null, postId?: string | null, participantsCount?: number | null, priceType?: string | null } | null } | null }> } };

export type SharedWithMeLibraryQueryVariables = Exact<{ [key: string]: never; }>;


export type SharedWithMeLibraryQuery = { __typename?: 'Query', sharedWithMeLibrary: { __typename?: 'LibrarySharedWithMe', folders: Array<{ __typename?: 'LibraryFolderModel', id: string, name: string, description?: string | null, parentId?: string | null, depth: number, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, subfolderCount: number, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null }>, collections: Array<{ __typename?: 'LibraryCollectionModel', id: string, name: string, description?: string | null, ownerId: string, ownerName?: string | null, myRole: LibraryAccessRole, myShareId?: string | null, isShared: boolean, itemCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, restorableUntil?: any | null }> } };

export type LibraryShareMembersQueryVariables = Exact<{
  resourceType: LibraryResourceType;
  resourceId: Scalars['ID']['input'];
}>;


export type LibraryShareMembersQuery = { __typename?: 'Query', libraryShareMembers: Array<{ __typename?: 'LibraryShareMember', shareId: string, userId: string, name: string, profileImageUrl?: string | null, headline?: string | null, role: LibraryShareRole, resourceType: LibraryResourceType, resourceId: string, createdAt: any }> };

export type LibraryShareDialogQueryVariables = Exact<{
  resourceType: LibraryResourceType;
  resourceId: Scalars['ID']['input'];
  q?: InputMaybe<Scalars['String']['input']>;
}>;


export type LibraryShareDialogQuery = { __typename?: 'Query', libraryShareMembers: Array<{ __typename?: 'LibraryShareMember', shareId: string, userId: string, name: string, profileImageUrl?: string | null, headline?: string | null, role: LibraryShareRole, resourceType: LibraryResourceType, resourceId: string, createdAt: any }>, searchLibraryShareUsers: Array<{ __typename?: 'LibraryShareCandidate', userId: string, name: string, profileImageUrl?: string | null, headline?: string | null }> };

export type SearchLibraryShareUsersQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchLibraryShareUsersQuery = { __typename?: 'Query', searchLibraryShareUsers: Array<{ __typename?: 'LibraryShareCandidate', userId: string, name: string, profileImageUrl?: string | null, headline?: string | null }> };

export type PostLibraryItemQueryVariables = Exact<{
  input: GetPostInput;
}>;


export type PostLibraryItemQuery = { __typename?: 'Query', getPost: { __typename?: 'Post', id: string, libraryItemId?: string | null } };

export type ArticleLibraryItemQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArticleLibraryItemQuery = { __typename?: 'Query', article: { __typename?: 'Article', id: string, libraryItemId?: string | null } };

export type AddLicenseMutationVariables = Exact<{
  input: AddLicenseInput;
}>;


export type AddLicenseMutation = { __typename?: 'Mutation', addLicense: boolean };

export type DeleteLicenseMutationVariables = Exact<{
  input: DeleteLicenseInput;
}>;


export type DeleteLicenseMutation = { __typename?: 'Mutation', deleteLicense: boolean };

export type EditLicenseMutationVariables = Exact<{
  input: EditLicenseInput;
}>;


export type EditLicenseMutation = { __typename?: 'Mutation', editLicense: boolean };

export type GetLinkPreviewQueryVariables = Exact<{
  input: GetLinkPreviewInput;
}>;


export type GetLinkPreviewQuery = { __typename?: 'Query', getLinkPreview?: { __typename?: 'LinkPreview', title?: string | null, description?: string | null, image?: string | null, url: string, siteName?: string | null, type?: string | null } | null };

export type CreateLiveStreamMutationVariables = Exact<{
  input: CreateLiveStreamInput;
}>;


export type CreateLiveStreamMutation = { __typename?: 'Mutation', createLiveStream: { __typename?: 'LiveStream', id: string, roomId: string, description?: string | null, status: LiveStreamStatus, livekitToken?: string | null, createdAt: any, updatedAt: any } };

export type LiveStreamListFieldsFragment = { __typename?: 'LiveStream', id: string, roomId: string, description?: string | null, status: LiveStreamStatus, createdAt: any, updatedAt: any, isHostOnline?: boolean | null, user?: { __typename?: 'User', id: string, profileImageUrl?: string | null, firstName: string, lastName?: string | null, title?: string | null, companyName?: string | null } | null };

export type FindAllLiveStreamsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllLiveStreamsQuery = { __typename?: 'Query', findAllLiveStreams: Array<{ __typename?: 'LiveStream', id: string, roomId: string, description?: string | null, status: LiveStreamStatus, createdAt: any, updatedAt: any, isHostOnline?: boolean | null, user?: { __typename?: 'User', id: string, profileImageUrl?: string | null, firstName: string, lastName?: string | null, title?: string | null, companyName?: string | null } | null }> };

export type GetLiveStreamQueryVariables = Exact<{
  roomId: Scalars['String']['input'];
}>;


export type GetLiveStreamQuery = { __typename?: 'Query', getLiveStream: { __typename?: 'LiveStream', id: string, roomId: string, description?: string | null, status: LiveStreamStatus, isHostOnline?: boolean | null, user?: { __typename?: 'User', id: string, profileImageUrl?: string | null, firstName: string, lastName?: string | null, title?: string | null, companyName?: string | null } | null } };

export type ResumeLiveStreamMutationVariables = Exact<{
  roomId: Scalars['String']['input'];
}>;


export type ResumeLiveStreamMutation = { __typename?: 'Mutation', resumeLiveStream: { __typename?: 'LiveStream', id: string, roomId: string, description?: string | null, status: LiveStreamStatus, livekitToken?: string | null, createdAt: any, updatedAt: any } };

export type HostHeartbeatMutationVariables = Exact<{
  roomId: Scalars['String']['input'];
}>;


export type HostHeartbeatMutation = { __typename?: 'Mutation', hostHeartbeat: { __typename?: 'StreamActionResponse', success: boolean, message: string } };

export type MarkHostAwayMutationVariables = Exact<{
  roomId: Scalars['String']['input'];
}>;


export type MarkHostAwayMutation = { __typename?: 'Mutation', markHostAway: { __typename?: 'StreamActionResponse', success: boolean, message: string } };

export type KickParticipantInLiveStreamMutationVariables = Exact<{
  roomId: Scalars['String']['input'];
  participantIdentity: Scalars['String']['input'];
}>;


export type KickParticipantInLiveStreamMutation = { __typename?: 'Mutation', kickParticipantInStream: { __typename?: 'StreamActionResponse', message: string, success: boolean } };

export type JoinLiveStreamMutationVariables = Exact<{
  roomId: Scalars['String']['input'];
}>;


export type JoinLiveStreamMutation = { __typename?: 'Mutation', joinLiveStream: { __typename?: 'LiveStream', id: string, roomId: string, description?: string | null, status: LiveStreamStatus, livekitToken?: string | null, createdAt: any, updatedAt: any } };

export type InviteToLiveStreamMutationVariables = Exact<{
  input: InviteToLiveStreamInput;
}>;


export type InviteToLiveStreamMutation = { __typename?: 'Mutation', inviteToLiveStream: { __typename?: 'InviteLiveStreamResponse', success: boolean, message: string, invitedCount: number, skippedCount: number } };

export type EndLiveStreamMutationVariables = Exact<{
  roomId: Scalars['String']['input'];
}>;


export type EndLiveStreamMutation = { __typename?: 'Mutation', endLiveStream: { __typename?: 'StreamActionResponse', message: string, success: boolean } };

export type DeleteRoomMutationVariables = Exact<{
  roomId: Scalars['String']['input'];
}>;


export type DeleteRoomMutation = { __typename?: 'Mutation', deleteRoom: { __typename?: 'StreamActionResponse', success: boolean, message: string } };

export type OnLiveStreamChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnLiveStreamChangedSubscription = { __typename?: 'Subscription', liveStreamChanged: { __typename?: 'LiveStreamChanged', type: LiveStreamChangeType, changeType: ChangeType, roomId: string, stream?: { __typename?: 'LiveStream', id: string, roomId: string, description?: string | null, status: LiveStreamStatus, createdAt: any, updatedAt: any, isHostOnline?: boolean | null, user?: { __typename?: 'User', id: string, profileImageUrl?: string | null, firstName: string, lastName?: string | null, title?: string | null, companyName?: string | null } | null } | null } };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginResponse', accessToken: any, refreshToken: any, redirectToPlans: boolean, subscription?: { __typename?: 'UserSubscription', id: string, planId: string, status: SubscriptionStatus, currentPeriodStart?: any | null, currentPeriodEnd?: any | null, planLimitsPeriodStart?: any | null, cancelAtPeriodEnd: boolean, planSnapshot?: any | null, trialEndsAt?: any | null, graceEndsAt?: any | null, accessState?: string | null, plan: { __typename?: 'SubscriptionPlan', id: string, name: string, priceMonthly: number, description?: string | null, companyPages?: number | null, connectionSendingLimits?: number | null, serviceListings?: number | null, groupCreation?: number | null, actionButtonOnProfile: boolean, liveStreaming: boolean, accessAIChatbot: boolean } } | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type MarkNotificationAsReadMutationVariables = Exact<{
  input: MarkNotificationReadInput;
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', markNotificationAsRead: boolean };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', myConnectionCount?: number | null, myProfileViewsLast7Days?: number | null, me: { __typename?: 'User', id: string, createdAt?: any | null, updatedAt?: any | null, firstName: string, lastName?: string | null, middleName?: string | null, title?: string | null, phone: string, role: Role, status?: UserStatus | null, expertise?: Expertise | null, email: string, profileImageUrl?: string | null, profileImageOptimizedUrl?: string | null, bannerImageOptimizedUrl?: string | null, imageUrl?: string | null, bannerImageUrl?: string | null, state?: string | null, profileVisitsCount: number, dentalLicenseNumber?: string | null, isHiring?: boolean | null, openToWork?: boolean | null, isVerified?: boolean | null, headline?: string | null, about?: string | null, universityEmail?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null, mentorSettings?: { __typename?: 'MentorSettings', pricing?: { __typename?: 'MentorPrice', price: number, duration: number, currency: Currency } | null, availability?: { __typename?: 'MentorAvailability', timezone: string, weekly: Array<{ __typename?: 'WeeklyAvailability', day: Day, times: Array<{ __typename?: 'TimeRange', start: string, end: string }> }> } | null } | null }, influenceStatus: { __typename?: 'InfluenceStatus', enabled: boolean, leaderboardsEnabled: boolean }, myActiveProfileBoost?: { __typename?: 'ProfileBoost', id: string, mentorId: string, packId?: string | null, headline?: string | null, videoUrl?: string | null, status: ProfileBoostStatus, purchasedDurationSeconds: number, remainingDurationSeconds: number, consumedActiveSeconds: number, activeSegmentStartedAt?: any | null, totalPaidCents: number, currency?: string | null, hours: number, hourlyRateCents: number, startedAt?: any | null, completedAt?: any | null, endsAt?: any | null, impressions?: number | null, profileVisits?: number | null, clicks?: number | null, ctr?: string | null, createdAt: any, updatedAt: any } | null };

export type UpsertMentorDayAvailabilityMutationVariables = Exact<{
  input: EditMentorDayAvailabilityInput;
}>;


export type UpsertMentorDayAvailabilityMutation = { __typename?: 'Mutation', upsertMentorDayAvailability: boolean };

export type ToggleMentorDayOffMutationVariables = Exact<{
  input: MentorDayOffInput;
}>;


export type ToggleMentorDayOffMutation = { __typename?: 'Mutation', toggleMentorDayOff: boolean };

export type MyMentorEarningsStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyMentorEarningsStatsQuery = { __typename?: 'Query', myMentorEarningsStats: { __typename?: 'MentorEarningsStats', totalEarned: number, thisMonthEarned: number, totalSessions: number, thisMonthSessions: number, totalGrossVolume: number, thisMonthGrossVolume: number, totalRefunded: number, thisMonthRefunded: number, totalPlatformFees: number, thisMonthPlatformFees: number, totalNetEarned: number, avgEarningPerSession: number, currency?: string | null, monthlyBreakdown: Array<{ __typename?: 'MentorMonthlyEarning', month: string, label: string, earned: number, refunded: number, net: number, sessions: number }> } };

export type MyMentorPaymentsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  paymentStatus?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyMentorPaymentsQuery = { __typename?: 'Query', myMentorPayments: { __typename?: 'PaginatedMentorPayments', total: number, page: number, limit: number, totalPages: number, hasMore: boolean, data: Array<{ __typename?: 'MentorPaymentRecord', id: string, studentName?: string | null, subject?: string | null, sessionStatus?: string | null, paymentStatus?: string | null, paidAmount?: number | null, sessionFeeAmount?: number | null, platformFeeAmount?: number | null, currency?: string | null, sessionDate?: string | null, sessionTime?: string | null, paidAt?: any | null, receiptUrl?: string | null, invoiceNumber?: string | null, invoiceId?: string | null, createdAt: any }> } };

export type GenerateMentorReceiptPdfMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type GenerateMentorReceiptPdfMutation = { __typename?: 'Mutation', generateMentorReceiptPdf: { __typename?: 'ReceiptPdfResult', base64Pdf: string, filename: string } };

export type InitiateMultipartUploadMutationVariables = Exact<{
  input: InitiateMultipartUploadInput;
}>;


export type InitiateMultipartUploadMutation = { __typename?: 'Mutation', initiateMultipartUpload: { __typename?: 'MultipartUploadSession', uploadId: string, key: string, fileUrl: string, partSize: number, totalParts: number } };

export type UploadMultipartPartMutationVariables = Exact<{
  input: MultipartUploadPartInput;
}>;


export type UploadMultipartPartMutation = { __typename?: 'Mutation', uploadMultipartPart: { __typename?: 'MultipartUploadedPart', partNumber: number, eTag: string } };

export type CompleteMultipartUploadMutationVariables = Exact<{
  input: CompleteMultipartUploadInput;
}>;


export type CompleteMultipartUploadMutation = { __typename?: 'Mutation', completeMultipartUpload: { __typename?: 'MultipartCompleteUploadResult', id?: string | null, fileName: string, fileUrl: string, mimeType: string, size: any, type: FileType } };

export type AbortMultipartUploadMutationVariables = Exact<{
  input: AbortMultipartUploadInput;
}>;


export type AbortMultipartUploadMutation = { __typename?: 'Mutation', abortMultipartUpload: boolean };

export type GetUserPostsQueryVariables = Exact<{
  input: GetUserPostsInput;
}>;


export type GetUserPostsQuery = { __typename?: 'Query', getUserPosts: Array<{ __typename?: 'Post', id: string, isRepost: boolean, repostComment?: string | null, originalPostId?: string | null, postType: PostType, companyId?: string | null, mediaUrls: Array<string>, isSavedByMe: boolean, isRepostedByMe?: boolean | null, isPublished: boolean, isBoosted?: boolean | null, activeBoostId?: string | null, createdAt?: any | null, updatedAt?: any | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, profileImageUrl?: string | null, role: Role, headline?: string | null, isHiring?: boolean | null, openToWork?: boolean | null, isMentorVerified?: boolean | null, createdAt?: any | null, updatedAt?: any | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null, connection?: { __typename?: 'ConnectionStatusModel', status: string, direction?: string | null } | null, actionButtons?: Array<{ __typename?: 'ActionButton', id: string, name: string, url: string, isShow: boolean, createdAt: any }> | null }, originalPost?: { __typename?: 'Post', id: string, mediaUrls: Array<string>, commentsCount: number, isSavedByMe: boolean, isRepostedByMe?: boolean | null, isPublished: boolean, isBoosted?: boolean | null, activeBoostId?: string | null, createdAt?: any | null, updatedAt?: any | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, profileImageUrl?: string | null, role: Role, headline?: string | null, isHiring?: boolean | null, openToWork?: boolean | null, isMentorVerified?: boolean | null, createdAt?: any | null, updatedAt?: any | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null, connection?: { __typename?: 'ConnectionStatusModel', status: string, direction?: string | null } | null, actionButtons?: Array<{ __typename?: 'ActionButton', id: string, name: string, url: string, isShow: boolean, createdAt: any }> | null }, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> }, article?: { __typename?: 'Article', id: string, title: string, subtitle?: string | null, coverImageUrl?: string | null, slug: string, readingTimeMinutes: number, tags: Array<string>, content: string, status: ArticleStatus, translatedTitle?: string | null, translatedSubtitle?: string | null, translatedExcerpt?: string | null } | null, companyAuthor?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null, followersCount?: number | null, isFollowing?: boolean | null } | null, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, translatedQuestion?: string | null, translatedOptions?: Array<string> | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null, occasion?: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy, translatedTitle?: string | null, translatedDescription?: string | null } | null, event?: { __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, category: string, maxAttendees?: number | null, participantsCount: number, isjoinedbyMe: boolean, organizedby: { __typename?: 'organizedBy', userId?: string | null, name?: string | null, imageUrl?: string | null, companyName?: string | null }, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null } | null, case?: { __typename?: 'CasePostModel', id: string, postId: string, createdAt: any, updatedAt: any, media: Array<{ __typename?: 'CaseMediaModel', id: string, step: string, type: string, imageUrl?: string | null, text?: string | null, order: number, createdAt: any, translatedText?: string | null }> } | null } | null, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> }, article?: { __typename?: 'Article', id: string, title: string, subtitle?: string | null, coverImageUrl?: string | null, slug: string, readingTimeMinutes: number, tags: Array<string>, content: string, status: ArticleStatus, translatedTitle?: string | null, translatedSubtitle?: string | null, translatedExcerpt?: string | null } | null, companyAuthor?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null, followersCount?: number | null, isFollowing?: boolean | null } | null, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, translatedQuestion?: string | null, translatedOptions?: Array<string> | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null, occasion?: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy, translatedTitle?: string | null, translatedDescription?: string | null } | null, event?: { __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, category: string, maxAttendees?: number | null, participantsCount: number, isjoinedbyMe: boolean, organizedby: { __typename?: 'organizedBy', userId?: string | null, name?: string | null, imageUrl?: string | null, companyName?: string | null }, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null } | null, case?: { __typename?: 'CasePostModel', id: string, postId: string, createdAt: any, updatedAt: any, media: Array<{ __typename?: 'CaseMediaModel', id: string, step: string, type: string, imageUrl?: string | null, text?: string | null, order: number, createdAt: any, translatedText?: string | null }> } | null }> };

export type CreateNewsletterMutationVariables = Exact<{
  input: CreateNewsletterInput;
}>;


export type CreateNewsletterMutation = { __typename?: 'Mutation', createNewsletter: boolean };

export type MarkPostNotInterestedMutationVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type MarkPostNotInterestedMutation = { __typename?: 'Mutation', markPostNotInterested: boolean };

export type CreateOccasionPostMutationVariables = Exact<{
  input: CreateOccasionPostInput;
}>;


export type CreateOccasionPostMutation = { __typename?: 'Mutation', createOccasionPost: boolean };

export type GetOccasionByPostIdQueryVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type GetOccasionByPostIdQuery = { __typename?: 'Query', getOccasionByPostId: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy } };

export type CallSendMutationVariables = Exact<{
  input: CallSendInput;
}>;


export type CallSendMutation = { __typename?: 'Mutation', callSend: { __typename?: 'CallResponse', success: boolean, message: string, room?: string | null, token?: string | null } };

export type ReceiveCallMutationVariables = Exact<{
  input: CallSendInput;
}>;


export type ReceiveCallMutation = { __typename?: 'Mutation', receiveCall: { __typename?: 'CallResponse', success: boolean, message: string, room?: string | null, token?: string | null } };

export type RejectCallMutationVariables = Exact<{
  input: CallSendInput;
}>;


export type RejectCallMutation = { __typename?: 'Mutation', rejectCall: { __typename?: 'CallResponse', success: boolean, message: string, room?: string | null, token?: string | null } };

export type CallMissedMutationVariables = Exact<{
  input: CallSendInput;
}>;


export type CallMissedMutation = { __typename?: 'Mutation', callMissed: { __typename?: 'CallResponse', success: boolean, message: string, room?: string | null, token?: string | null } };

export type CallCancleMutationVariables = Exact<{
  input: CallSendInput;
}>;


export type CallCancleMutation = { __typename?: 'Mutation', callCancle: { __typename?: 'CallResponse', success: boolean, message: string, room?: string | null, token?: string | null } };

export type UpdateOpenToWorkMutationVariables = Exact<{
  openToWork: Scalars['Boolean']['input'];
}>;


export type UpdateOpenToWorkMutation = { __typename?: 'Mutation', updateOpenToWork: boolean };

export type GetOpenToWorkQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOpenToWorkQuery = { __typename?: 'Query', getOpenToWork: boolean };

export type PayoutOnboardingLinkMutationVariables = Exact<{ [key: string]: never; }>;


export type PayoutOnboardingLinkMutation = { __typename?: 'Mutation', payoutOnboardingLink: string };

export type ReVerifyPayoutAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type ReVerifyPayoutAccountMutation = { __typename?: 'Mutation', reVerifyPayoutAccount: { __typename?: 'PayoutAccount', id: string, verified: boolean, verifiedAt?: any | null, status: PayoutAccountStatus, isPaymentsActive: boolean, isProviderAccountClosed: boolean, disconnectedAt?: any | null, providerAccountId: string, chargesEnabled: boolean, payoutsEnabled: boolean, detailsSubmitted: boolean, businessType?: string | null, businessUrl?: string | null, supportEmail?: string | null, supportPhone?: string | null, mcc?: string | null, defaultCurrency?: string | null, providerAccountCreatedAt?: any | null, cardPaymentsStatus?: string | null, transfersStatus?: string | null, requirementsCurrentlyDue: Array<string>, requirementsPastDue: Array<string>, requirementsEventuallyDue: Array<string>, requirementsDisabledReason?: string | null, externalAccountBankName?: string | null, externalAccountLast4?: string | null } };

export type DisconnectPayoutAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DisconnectPayoutAccountMutation = { __typename?: 'Mutation', disconnectPayoutAccount: boolean };

export type ReconnectPayoutAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type ReconnectPayoutAccountMutation = { __typename?: 'Mutation', reconnectPayoutAccount: { __typename?: 'PayoutAccount', id: string, status: PayoutAccountStatus, verified: boolean, verifiedAt?: any | null, disconnectedAt?: any | null, isPaymentsActive: boolean, isProviderAccountClosed: boolean, providerAccountId: string, chargesEnabled: boolean, payoutsEnabled: boolean, detailsSubmitted: boolean, accountName?: string | null, accountEmail?: string | null } };

export type PayoutDashboardLinkMutationVariables = Exact<{ [key: string]: never; }>;


export type PayoutDashboardLinkMutation = { __typename?: 'Mutation', payoutDashboardLink: string };

export type MyPayoutAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPayoutAccountQuery = { __typename?: 'Query', myPayoutAccount?: { __typename?: 'PayoutAccount', id: string, userId: string, provider: PaymentProvider, providerAccountId: string, status: PayoutAccountStatus, verified: boolean, verifiedAt?: any | null, disconnectedAt?: any | null, isPaymentsActive: boolean, isProviderAccountClosed: boolean, mode?: string | null, accountName?: string | null, accountEmail?: string | null, accountCountry?: string | null, chargesEnabled: boolean, payoutsEnabled: boolean, detailsSubmitted: boolean, businessType?: string | null, businessUrl?: string | null, supportEmail?: string | null, supportPhone?: string | null, mcc?: string | null, defaultCurrency?: string | null, providerAccountCreatedAt?: any | null, cardPaymentsStatus?: string | null, transfersStatus?: string | null, requirementsCurrentlyDue: Array<string>, requirementsPastDue: Array<string>, requirementsEventuallyDue: Array<string>, requirementsDisabledReason?: string | null, externalAccountBankName?: string | null, externalAccountLast4?: string | null, createdAt: any, updatedAt: any } | null };

export type PlatformCommissionRateQueryVariables = Exact<{ [key: string]: never; }>;


export type PlatformCommissionRateQuery = { __typename?: 'Query', platformCommissionRate: number };

export type PlatformStripePublishableKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type PlatformStripePublishableKeyQuery = { __typename?: 'Query', platformStripePublishableKey?: string | null };

export type OnPodcastActivitySubscriptionVariables = Exact<{
  episodeId: Scalars['ID']['input'];
}>;


export type OnPodcastActivitySubscription = { __typename?: 'Subscription', podcastActivity: { __typename?: 'PodcastActivity', type: PodcastActivityType, changeType: ChangeType, episodeId: string, actorId: string, likesCount?: number | null, actorLiked?: boolean | null, commentsCount?: number | null, commentId?: string | null, parentCommentId?: string | null, repliesCount?: number | null, commentLikesCount?: number | null, actorCommentLiked?: boolean | null, comment?: { __typename?: 'PodcastCommentModel', id: string, episodeId: string, content: string, translatedContent?: string | null, parentId?: string | null, repliesCount: number, likesCount: number, isLikedByMe: boolean, createdAt: any, updatedAt: any, user: { __typename?: 'PodcastAuthor', id: string, name: string, profileImageUrl?: string | null, organizationName?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }, replies?: Array<{ __typename?: 'PodcastCommentModel', id: string, episodeId: string, content: string, translatedContent?: string | null, parentId?: string | null, repliesCount: number, likesCount: number, isLikedByMe: boolean, createdAt: any, updatedAt: any, user: { __typename?: 'PodcastAuthor', id: string, name: string, profileImageUrl?: string | null, organizationName?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } }> | null } | null } };

export type PodcastEpisodeFieldsFragment = { __typename?: 'PodcastEpisodeModel', id: string, libraryItemId?: string | null, userId: string, title: string, description?: string | null, category?: string | null, tags: Array<string>, mediaType: PodcastMediaType, mediaUrl?: string | null, embedUrl?: string | null, provider?: VideoProvider | null, sourceId?: string | null, isHidden: boolean, blurHash?: string | null, coverImageUrl?: string | null, durationSeconds?: number | null, status: PodcastStatus, playsCount: number, likesCount: number, commentsCount: number, isLikedByMe: boolean, createdAt: any, updatedAt: any, author?: { __typename?: 'PodcastAuthor', id: string, name: string, profileImageUrl?: string | null, organizationName?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } | null };

export type PodcastSourceFieldsFragment = { __typename?: 'PodcastSourceModel', id: string, userId: string, provider: VideoProvider, name?: string | null, handle?: string | null, channelId?: string | null, url: string, imageUrl?: string | null, isActive: boolean, autoPublish: boolean, lastSyncedAt?: any | null, lastSyncError?: string | null, createdAt: any, updatedAt: any };

export type PodcastReplyFieldsFragment = { __typename?: 'PodcastCommentModel', id: string, episodeId: string, content: string, translatedContent?: string | null, parentId?: string | null, repliesCount: number, likesCount: number, isLikedByMe: boolean, createdAt: any, updatedAt: any, user: { __typename?: 'PodcastAuthor', id: string, name: string, profileImageUrl?: string | null, organizationName?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } };

export type PodcastCommentFieldsFragment = { __typename?: 'PodcastCommentModel', id: string, episodeId: string, content: string, translatedContent?: string | null, parentId?: string | null, repliesCount: number, likesCount: number, isLikedByMe: boolean, createdAt: any, updatedAt: any, user: { __typename?: 'PodcastAuthor', id: string, name: string, profileImageUrl?: string | null, organizationName?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }, replies?: Array<{ __typename?: 'PodcastCommentModel', id: string, episodeId: string, content: string, translatedContent?: string | null, parentId?: string | null, repliesCount: number, likesCount: number, isLikedByMe: boolean, createdAt: any, updatedAt: any, user: { __typename?: 'PodcastAuthor', id: string, name: string, profileImageUrl?: string | null, organizationName?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } }> | null };

export type PodcastEpisodesQueryVariables = Exact<{
  input?: InputMaybe<GetPodcastEpisodesInput>;
}>;


export type PodcastEpisodesQuery = { __typename?: 'Query', podcastEpisodes: { __typename?: 'PodcastEpisodesPaginated', total: number, hasMore: boolean, nextCursor?: string | null, items: Array<{ __typename?: 'PodcastEpisodeModel', id: string, libraryItemId?: string | null, userId: string, title: string, description?: string | null, category?: string | null, tags: Array<string>, mediaType: PodcastMediaType, mediaUrl?: string | null, embedUrl?: string | null, provider?: VideoProvider | null, sourceId?: string | null, isHidden: boolean, blurHash?: string | null, coverImageUrl?: string | null, durationSeconds?: number | null, status: PodcastStatus, playsCount: number, likesCount: number, commentsCount: number, isLikedByMe: boolean, createdAt: any, updatedAt: any, author?: { __typename?: 'PodcastAuthor', id: string, name: string, profileImageUrl?: string | null, organizationName?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } | null }> } };

export type PodcastCreatorsQueryVariables = Exact<{
  input?: InputMaybe<GetPodcastCreatorsInput>;
}>;


export type PodcastCreatorsQuery = { __typename?: 'Query', podcastCreators: { __typename?: 'PodcastCreatorsPaginated', total: number, hasMore: boolean, nextCursor?: string | null, items: Array<{ __typename?: 'PodcastCreator', id: string, name: string, profileImageUrl?: string | null, organizationName?: string | null, role?: Role | null, episodesCount: number, latestEpisodeAt?: any | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }> } };

export type PodcastEpisodesByUserQueryVariables = Exact<{
  input: GetPodcastEpisodesByUserInput;
}>;


export type PodcastEpisodesByUserQuery = { __typename?: 'Query', podcastEpisodesByUser: { __typename?: 'PodcastEpisodesPaginated', total: number, hasMore: boolean, nextCursor?: string | null, items: Array<{ __typename?: 'PodcastEpisodeModel', id: string, libraryItemId?: string | null, userId: string, title: string, description?: string | null, category?: string | null, tags: Array<string>, mediaType: PodcastMediaType, mediaUrl?: string | null, embedUrl?: string | null, provider?: VideoProvider | null, sourceId?: string | null, isHidden: boolean, blurHash?: string | null, coverImageUrl?: string | null, durationSeconds?: number | null, status: PodcastStatus, playsCount: number, likesCount: number, commentsCount: number, isLikedByMe: boolean, createdAt: any, updatedAt: any, author?: { __typename?: 'PodcastAuthor', id: string, name: string, profileImageUrl?: string | null, organizationName?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } | null }> } };

export type PodcastEpisodeQueryVariables = Exact<{
  episodeId: Scalars['String']['input'];
}>;


export type PodcastEpisodeQuery = { __typename?: 'Query', podcastEpisode: { __typename?: 'PodcastEpisodeModel', id: string, libraryItemId?: string | null, userId: string, title: string, description?: string | null, category?: string | null, tags: Array<string>, mediaType: PodcastMediaType, mediaUrl?: string | null, embedUrl?: string | null, provider?: VideoProvider | null, sourceId?: string | null, isHidden: boolean, blurHash?: string | null, coverImageUrl?: string | null, durationSeconds?: number | null, status: PodcastStatus, playsCount: number, likesCount: number, commentsCount: number, isLikedByMe: boolean, createdAt: any, updatedAt: any, author?: { __typename?: 'PodcastAuthor', id: string, name: string, profileImageUrl?: string | null, organizationName?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } | null } };

export type PodcastCommentsQueryVariables = Exact<{
  input: GetPodcastCommentsInput;
}>;


export type PodcastCommentsQuery = { __typename?: 'Query', podcastComments: { __typename?: 'PodcastCommentsPaginated', total: number, hasMore: boolean, nextCursor?: string | null, items: Array<{ __typename?: 'PodcastCommentModel', id: string, episodeId: string, content: string, translatedContent?: string | null, parentId?: string | null, repliesCount: number, likesCount: number, isLikedByMe: boolean, createdAt: any, updatedAt: any, user: { __typename?: 'PodcastAuthor', id: string, name: string, profileImageUrl?: string | null, organizationName?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }, replies?: Array<{ __typename?: 'PodcastCommentModel', id: string, episodeId: string, content: string, translatedContent?: string | null, parentId?: string | null, repliesCount: number, likesCount: number, isLikedByMe: boolean, createdAt: any, updatedAt: any, user: { __typename?: 'PodcastAuthor', id: string, name: string, profileImageUrl?: string | null, organizationName?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } }> | null }> } };

export type UploadPodcastEpisodeMutationVariables = Exact<{
  input: UploadPodcastEpisodeInput;
}>;


export type UploadPodcastEpisodeMutation = { __typename?: 'Mutation', uploadPodcastEpisode: { __typename?: 'PodcastEpisodeModel', id: string, libraryItemId?: string | null, userId: string, title: string, description?: string | null, category?: string | null, tags: Array<string>, mediaType: PodcastMediaType, mediaUrl?: string | null, embedUrl?: string | null, provider?: VideoProvider | null, sourceId?: string | null, isHidden: boolean, blurHash?: string | null, coverImageUrl?: string | null, durationSeconds?: number | null, status: PodcastStatus, playsCount: number, likesCount: number, commentsCount: number, isLikedByMe: boolean, createdAt: any, updatedAt: any, author?: { __typename?: 'PodcastAuthor', id: string, name: string, profileImageUrl?: string | null, organizationName?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } | null } };

export type DeletePodcastEpisodeMutationVariables = Exact<{
  input: DeletePodcastEpisodeInput;
}>;


export type DeletePodcastEpisodeMutation = { __typename?: 'Mutation', deletePodcastEpisode: boolean };

export type RecordPodcastPlayMutationVariables = Exact<{
  input: RecordPodcastPlayInput;
}>;


export type RecordPodcastPlayMutation = { __typename?: 'Mutation', recordPodcastPlay: boolean };

export type ReportPodcastPlaybackErrorMutationVariables = Exact<{
  input: ReportPodcastPlaybackErrorInput;
}>;


export type ReportPodcastPlaybackErrorMutation = { __typename?: 'Mutation', reportPodcastPlaybackError: boolean };

export type LikePodcastEpisodeMutationVariables = Exact<{
  episodeId: Scalars['String']['input'];
}>;


export type LikePodcastEpisodeMutation = { __typename?: 'Mutation', likePodcastEpisode: { __typename?: 'PodcastEpisodeModel', id: string, likesCount: number, isLikedByMe: boolean } };

export type UnlikePodcastEpisodeMutationVariables = Exact<{
  episodeId: Scalars['String']['input'];
}>;


export type UnlikePodcastEpisodeMutation = { __typename?: 'Mutation', unlikePodcastEpisode: { __typename?: 'PodcastEpisodeModel', id: string, likesCount: number, isLikedByMe: boolean } };

export type CreatePodcastCommentMutationVariables = Exact<{
  input: CreatePodcastCommentInput;
}>;


export type CreatePodcastCommentMutation = { __typename?: 'Mutation', createPodcastComment: { __typename?: 'PodcastCommentModel', id: string, episodeId: string, content: string, translatedContent?: string | null, parentId?: string | null, repliesCount: number, likesCount: number, isLikedByMe: boolean, createdAt: any, updatedAt: any, user: { __typename?: 'PodcastAuthor', id: string, name: string, profileImageUrl?: string | null, organizationName?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }, replies?: Array<{ __typename?: 'PodcastCommentModel', id: string, episodeId: string, content: string, translatedContent?: string | null, parentId?: string | null, repliesCount: number, likesCount: number, isLikedByMe: boolean, createdAt: any, updatedAt: any, user: { __typename?: 'PodcastAuthor', id: string, name: string, profileImageUrl?: string | null, organizationName?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } }> | null } };

export type DeletePodcastCommentMutationVariables = Exact<{
  commentId: Scalars['String']['input'];
}>;


export type DeletePodcastCommentMutation = { __typename?: 'Mutation', deletePodcastComment: boolean };

export type LikePodcastCommentMutationVariables = Exact<{
  commentId: Scalars['String']['input'];
}>;


export type LikePodcastCommentMutation = { __typename?: 'Mutation', likePodcastComment: { __typename?: 'PodcastCommentModel', id: string, likesCount: number, isLikedByMe: boolean } };

export type UnlikePodcastCommentMutationVariables = Exact<{
  commentId: Scalars['String']['input'];
}>;


export type UnlikePodcastCommentMutation = { __typename?: 'Mutation', unlikePodcastComment: { __typename?: 'PodcastCommentModel', id: string, likesCount: number, isLikedByMe: boolean } };

export type SetPodcastEpisodeHiddenMutationVariables = Exact<{
  input: SetPodcastEpisodeHiddenInput;
}>;


export type SetPodcastEpisodeHiddenMutation = { __typename?: 'Mutation', setPodcastEpisodeHidden: { __typename?: 'PodcastEpisodeModel', id: string, libraryItemId?: string | null, userId: string, title: string, description?: string | null, category?: string | null, tags: Array<string>, mediaType: PodcastMediaType, mediaUrl?: string | null, embedUrl?: string | null, provider?: VideoProvider | null, sourceId?: string | null, isHidden: boolean, blurHash?: string | null, coverImageUrl?: string | null, durationSeconds?: number | null, status: PodcastStatus, playsCount: number, likesCount: number, commentsCount: number, isLikedByMe: boolean, createdAt: any, updatedAt: any, author?: { __typename?: 'PodcastAuthor', id: string, name: string, profileImageUrl?: string | null, organizationName?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } | null } };

export type PodcastSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type PodcastSourcesQuery = { __typename?: 'Query', podcastSources: Array<{ __typename?: 'PodcastSourceModel', id: string, userId: string, provider: VideoProvider, name?: string | null, handle?: string | null, channelId?: string | null, url: string, imageUrl?: string | null, isActive: boolean, autoPublish: boolean, lastSyncedAt?: any | null, lastSyncError?: string | null, createdAt: any, updatedAt: any }> };

export type CreatePodcastSourceMutationVariables = Exact<{
  input: CreatePodcastSourceInput;
}>;


export type CreatePodcastSourceMutation = { __typename?: 'Mutation', createPodcastSource: { __typename?: 'PodcastSourceModel', id: string, userId: string, provider: VideoProvider, name?: string | null, handle?: string | null, channelId?: string | null, url: string, imageUrl?: string | null, isActive: boolean, autoPublish: boolean, lastSyncedAt?: any | null, lastSyncError?: string | null, createdAt: any, updatedAt: any } };

export type UpdatePodcastSourceMutationVariables = Exact<{
  input: UpdatePodcastSourceInput;
}>;


export type UpdatePodcastSourceMutation = { __typename?: 'Mutation', updatePodcastSource: { __typename?: 'PodcastSourceModel', id: string, userId: string, provider: VideoProvider, name?: string | null, handle?: string | null, channelId?: string | null, url: string, imageUrl?: string | null, isActive: boolean, autoPublish: boolean, lastSyncedAt?: any | null, lastSyncError?: string | null, createdAt: any, updatedAt: any } };

export type DeletePodcastSourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePodcastSourceMutation = { __typename?: 'Mutation', deletePodcastSource: boolean };

export type SyncPodcastSourceNowMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SyncPodcastSourceNowMutation = { __typename?: 'Mutation', syncPodcastSourceNow: { __typename?: 'PodcastSourceSyncResult', sourcesProcessed: number, created: number, updated: number, errors: Array<string> } };

export type CreatePollPostMutationVariables = Exact<{
  input: CreatePollPostInput;
}>;


export type CreatePollPostMutation = { __typename?: 'Mutation', createPollPost: boolean };

export type GetPollByPostIdQueryVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type GetPollByPostIdQuery = { __typename?: 'Query', getPollByPostId?: { __typename?: 'Poll', question: string, expiresAt?: any | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null };

export type VoteInPollMutationVariables = Exact<{
  postId: Scalars['String']['input'];
  optionId: Scalars['String']['input'];
}>;


export type VoteInPollMutation = { __typename?: 'Mutation', voteInPoll: { __typename?: 'Poll', question: string, expiresAt?: any | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } };

export type OnPostActivitySubscriptionVariables = Exact<{
  postId: Scalars['ID']['input'];
}>;


export type OnPostActivitySubscription = { __typename?: 'Subscription', postActivity: { __typename?: 'PostActivity', type: PostActivityType, changeType: ChangeType, postId: string, actorId: string, actorReaction?: string | null, totalReactions?: number | null, commentsCount?: number | null, commentId?: string | null, parentCommentId?: string | null, repliesCount?: number | null, deletedCommentIds?: Array<string> | null, reactionCounts?: Array<{ __typename?: 'ReactionCount', type: string, count: number }> | null, comment?: { __typename?: 'Comment', id: string, content: string, translatedContent?: string | null, userId: string, mediaUrls: Array<string>, createdAt?: any | null, updatedAt?: any | null, repliesCount?: number | null, user: { __typename?: 'CommentAuthor', id: string, firstName: string, middleName?: string | null, lastName?: string | null, title?: string | null, role: Role, profileImageUrl?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } } | null } };

export type InitializePostBoostPaymentMutationVariables = Exact<{
  input: InitializePostBoostPaymentInput;
}>;


export type InitializePostBoostPaymentMutation = { __typename?: 'Mutation', initializePostBoostPayment: { __typename?: 'PostBoostPaymentInit', clientSecret: string, paymentIntentId: string, amountCents: number, hours: number, durationSeconds: number, packLabel: string, postBoostId: string, postId: string, publishableKey: string } };

export type ConfirmPostBoostPaymentMutationVariables = Exact<{
  paymentIntentId: Scalars['String']['input'];
}>;


export type ConfirmPostBoostPaymentMutation = { __typename?: 'Mutation', confirmPostBoostPayment: { __typename?: 'PostBoost', id: string, postId: string, userId: string, status: PostBoostStatus, durationHours: number, durationSeconds: number, hourlyRateCents: number, amountCents: number, currency: string, startsAt?: any | null, expiresAt?: any | null, remainingDurationSeconds: number, paymentIntentId?: string | null, invoiceId?: string | null, impressions?: number | null, clicks?: number | null, ctr?: string | null, createdAt: any, updatedAt: any } };

export type CancelPendingPostBoostMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelPendingPostBoostMutation = { __typename?: 'Mutation', cancelPendingPostBoost: { __typename?: 'PostBoost', id: string, postId: string, userId: string, status: PostBoostStatus, durationHours: number, durationSeconds: number, hourlyRateCents: number, amountCents: number, currency: string, startsAt?: any | null, expiresAt?: any | null, remainingDurationSeconds: number, paymentIntentId?: string | null, invoiceId?: string | null, impressions?: number | null, clicks?: number | null, ctr?: string | null, createdAt: any, updatedAt: any } };

export type PausePostBoostMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PausePostBoostMutation = { __typename?: 'Mutation', pausePostBoost: { __typename?: 'PostBoost', id: string, postId: string, userId: string, status: PostBoostStatus, durationHours: number, durationSeconds: number, hourlyRateCents: number, amountCents: number, currency: string, startsAt?: any | null, expiresAt?: any | null, remainingDurationSeconds: number, paymentIntentId?: string | null, invoiceId?: string | null, impressions?: number | null, clicks?: number | null, ctr?: string | null, createdAt: any, updatedAt: any } };

export type ResumePostBoostMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResumePostBoostMutation = { __typename?: 'Mutation', resumePostBoost: { __typename?: 'PostBoost', id: string, postId: string, userId: string, status: PostBoostStatus, durationHours: number, durationSeconds: number, hourlyRateCents: number, amountCents: number, currency: string, startsAt?: any | null, expiresAt?: any | null, remainingDurationSeconds: number, paymentIntentId?: string | null, invoiceId?: string | null, impressions?: number | null, clicks?: number | null, ctr?: string | null, createdAt: any, updatedAt: any } };

export type RecordPostBoostImpressionMutationVariables = Exact<{
  boostId: Scalars['ID']['input'];
}>;


export type RecordPostBoostImpressionMutation = { __typename?: 'Mutation', recordPostBoostImpression: boolean };

export type RecordPostBoostClickMutationVariables = Exact<{
  boostId: Scalars['ID']['input'];
}>;


export type RecordPostBoostClickMutation = { __typename?: 'Mutation', recordPostBoostClick: boolean };

export type PostBoostFieldsFragment = { __typename?: 'PostBoost', id: string, postId: string, userId: string, status: PostBoostStatus, durationHours: number, durationSeconds: number, hourlyRateCents: number, amountCents: number, currency: string, startsAt?: any | null, expiresAt?: any | null, remainingDurationSeconds: number, paymentIntentId?: string | null, invoiceId?: string | null, impressions?: number | null, clicks?: number | null, ctr?: string | null, createdAt: any, updatedAt: any };

export type PostBoostHourlyRateQueryVariables = Exact<{ [key: string]: never; }>;


export type PostBoostHourlyRateQuery = { __typename?: 'Query', postBoostHourlyRate: { __typename?: 'PostBoostHourlyRate', hourlyRateCents: number } };

export type PreviewPostBoostCostQueryVariables = Exact<{
  durationHours: Scalars['Int']['input'];
}>;


export type PreviewPostBoostCostQuery = { __typename?: 'Query', previewPostBoostCost: { __typename?: 'PostBoostCostPreview', durationHours: number, durationSeconds: number, hourlyRateCents: number, amountCents: number } };

export type MyPostBoostsQueryVariables = Exact<{
  status?: InputMaybe<PostBoostStatus>;
}>;


export type MyPostBoostsQuery = { __typename?: 'Query', myPostBoosts: Array<{ __typename?: 'PostBoost', id: string, postId: string, userId: string, status: PostBoostStatus, durationHours: number, durationSeconds: number, hourlyRateCents: number, amountCents: number, currency: string, startsAt?: any | null, expiresAt?: any | null, remainingDurationSeconds: number, paymentIntentId?: string | null, invoiceId?: string | null, impressions?: number | null, clicks?: number | null, ctr?: string | null, createdAt: any, updatedAt: any }> };

export type PostBoostByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PostBoostByIdQuery = { __typename?: 'Query', postBoost: { __typename?: 'PostBoost', id: string, postId: string, userId: string, status: PostBoostStatus, durationHours: number, durationSeconds: number, hourlyRateCents: number, amountCents: number, currency: string, startsAt?: any | null, expiresAt?: any | null, remainingDurationSeconds: number, paymentIntentId?: string | null, invoiceId?: string | null, impressions?: number | null, clicks?: number | null, ctr?: string | null, createdAt: any, updatedAt: any } };

export type PostBoostDailyStatsQueryVariables = Exact<{
  boostId: Scalars['ID']['input'];
}>;


export type PostBoostDailyStatsQuery = { __typename?: 'Query', postBoostDailyStats: { __typename?: 'PostBoostDailyStats', categories: Array<string>, impressions: Array<number>, clicks: Array<number> } };

export type OnPostBoostActivitySubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnPostBoostActivitySubscription = { __typename?: 'Subscription', postBoostActivity: { __typename?: 'PostBoostChanged', changeType: ChangeType, boostId: string, boost?: { __typename?: 'PostBoost', id: string, postId: string, userId: string, status: PostBoostStatus, durationHours: number, durationSeconds: number, hourlyRateCents: number, amountCents: number, currency: string, startsAt?: any | null, expiresAt?: any | null, remainingDurationSeconds: number, paymentIntentId?: string | null, invoiceId?: string | null, impressions?: number | null, clicks?: number | null, ctr?: string | null, createdAt: any, updatedAt: any } | null } };

export type PostNowMutationVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type PostNowMutation = { __typename?: 'Mutation', postNow: boolean };

export type PostReactionsQueryVariables = Exact<{
  input: GetPostReactionsInput;
}>;


export type PostReactionsQuery = { __typename?: 'Query', postReactions: { __typename?: 'PostReactionsPaginated', total: number, hasMore: boolean, nextCursor?: string | null, reactors: Array<{ __typename?: 'PostReactor', id: string, reactionType: ReactionType, isCurrentUser: boolean, user: { __typename?: 'UserBasicInfo', userId: string, name: string, profileImageUrl?: string | null, role?: Role | null, headline?: string | null, title?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } }> } };

export type InitializeProfileBoostPaymentMutationVariables = Exact<{
  input: InitializeProfileBoostPaymentInput;
}>;


export type InitializeProfileBoostPaymentMutation = { __typename?: 'Mutation', initializeProfileBoostPayment: { __typename?: 'ProfileBoostPaymentInit', clientSecret: string, paymentIntentId: string, amountCents: number, hours: number, durationSeconds: number, packLabel: string, packId?: string | null, boostId?: string | null, publishableKey: string } };

export type ConfirmProfileBoostPaymentMutationVariables = Exact<{
  paymentIntentId: Scalars['String']['input'];
}>;


export type ConfirmProfileBoostPaymentMutation = { __typename?: 'Mutation', confirmProfileBoostPayment: { __typename?: 'ProfileBoost', id: string, mentorId: string, packId?: string | null, headline?: string | null, videoUrl?: string | null, status: ProfileBoostStatus, purchasedDurationSeconds: number, remainingDurationSeconds: number, consumedActiveSeconds: number, activeSegmentStartedAt?: any | null, totalPaidCents: number, currency?: string | null, hours: number, hourlyRateCents: number, startedAt?: any | null, completedAt?: any | null, endsAt?: any | null, impressions?: number | null, profileVisits?: number | null, clicks?: number | null, ctr?: string | null, createdAt: any, updatedAt: any } };

export type InitializeProfileBoostExtensionMutationVariables = Exact<{
  input: InitializeProfileBoostExtensionInput;
}>;


export type InitializeProfileBoostExtensionMutation = { __typename?: 'Mutation', initializeProfileBoostExtension: { __typename?: 'ProfileBoostPaymentInit', clientSecret: string, paymentIntentId: string, amountCents: number, hours: number, durationSeconds: number, packLabel: string, packId?: string | null, boostId?: string | null, publishableKey: string } };

export type ConfirmProfileBoostExtensionMutationVariables = Exact<{
  paymentIntentId: Scalars['String']['input'];
}>;


export type ConfirmProfileBoostExtensionMutation = { __typename?: 'Mutation', confirmProfileBoostExtension: { __typename?: 'ProfileBoost', id: string, mentorId: string, packId?: string | null, headline?: string | null, videoUrl?: string | null, status: ProfileBoostStatus, purchasedDurationSeconds: number, remainingDurationSeconds: number, consumedActiveSeconds: number, activeSegmentStartedAt?: any | null, totalPaidCents: number, currency?: string | null, hours: number, hourlyRateCents: number, startedAt?: any | null, completedAt?: any | null, endsAt?: any | null, impressions?: number | null, profileVisits?: number | null, clicks?: number | null, ctr?: string | null, createdAt: any, updatedAt: any } };

export type PauseProfileBoostMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PauseProfileBoostMutation = { __typename?: 'Mutation', pauseProfileBoost: { __typename?: 'ProfileBoost', id: string, mentorId: string, packId?: string | null, headline?: string | null, videoUrl?: string | null, status: ProfileBoostStatus, purchasedDurationSeconds: number, remainingDurationSeconds: number, consumedActiveSeconds: number, activeSegmentStartedAt?: any | null, totalPaidCents: number, currency?: string | null, hours: number, hourlyRateCents: number, startedAt?: any | null, completedAt?: any | null, endsAt?: any | null, impressions?: number | null, profileVisits?: number | null, clicks?: number | null, ctr?: string | null, createdAt: any, updatedAt: any } };

export type ResumeProfileBoostMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResumeProfileBoostMutation = { __typename?: 'Mutation', resumeProfileBoost: { __typename?: 'ProfileBoost', id: string, mentorId: string, packId?: string | null, headline?: string | null, videoUrl?: string | null, status: ProfileBoostStatus, purchasedDurationSeconds: number, remainingDurationSeconds: number, consumedActiveSeconds: number, activeSegmentStartedAt?: any | null, totalPaidCents: number, currency?: string | null, hours: number, hourlyRateCents: number, startedAt?: any | null, completedAt?: any | null, endsAt?: any | null, impressions?: number | null, profileVisits?: number | null, clicks?: number | null, ctr?: string | null, createdAt: any, updatedAt: any } };

export type RecordProfileBoostImpressionMutationVariables = Exact<{
  boostId: Scalars['ID']['input'];
}>;


export type RecordProfileBoostImpressionMutation = { __typename?: 'Mutation', recordProfileBoostImpression: boolean };

export type RecordProfileBoostClickMutationVariables = Exact<{
  boostId: Scalars['ID']['input'];
}>;


export type RecordProfileBoostClickMutation = { __typename?: 'Mutation', recordProfileBoostClick: boolean };

export type RecordProfileBoostProfileVisitMutationVariables = Exact<{
  boostId: Scalars['ID']['input'];
}>;


export type RecordProfileBoostProfileVisitMutation = { __typename?: 'Mutation', recordProfileBoostProfileVisit: boolean };

export type ProfileBoostFieldsFragment = { __typename?: 'ProfileBoost', id: string, mentorId: string, packId?: string | null, headline?: string | null, videoUrl?: string | null, status: ProfileBoostStatus, purchasedDurationSeconds: number, remainingDurationSeconds: number, consumedActiveSeconds: number, activeSegmentStartedAt?: any | null, totalPaidCents: number, currency?: string | null, hours: number, hourlyRateCents: number, startedAt?: any | null, completedAt?: any | null, endsAt?: any | null, impressions?: number | null, profileVisits?: number | null, clicks?: number | null, ctr?: string | null, createdAt: any, updatedAt: any };

export type FeaturedMentorsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FeaturedMentorsQuery = { __typename?: 'Query', featuredMentors: Array<{ __typename?: 'MentorSearchResult', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, role: string, about?: string | null, totalConsultations: number, totalConnections: number, isBoosted?: boolean | null, boostEndsAt?: any | null, companyName?: string | null }> };

export type ActiveProfileBoostPacksQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveProfileBoostPacksQuery = { __typename?: 'Query', activeProfileBoostPacks: Array<{ __typename?: 'ProfileBoostPack', id: string, label: string, hours: number, priceCents: number, status: PlanStatus }> };

export type ProfileBoostHourlyRateQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileBoostHourlyRateQuery = { __typename?: 'Query', profileBoostHourlyRate: { __typename?: 'ProfileBoostHourlyRate', hourlyRateCents: number } };

export type PreviewProfileBoostCostQueryVariables = Exact<{
  durationHours: Scalars['Int']['input'];
}>;


export type PreviewProfileBoostCostQuery = { __typename?: 'Query', previewProfileBoostCost: { __typename?: 'ProfileBoostCostPreview', durationHours: number, durationSeconds: number, hourlyRateCents: number, amountCents: number } };

export type MyActiveProfileBoostQueryVariables = Exact<{ [key: string]: never; }>;


export type MyActiveProfileBoostQuery = { __typename?: 'Query', myActiveProfileBoost?: { __typename?: 'ProfileBoost', id: string, mentorId: string, packId?: string | null, headline?: string | null, videoUrl?: string | null, status: ProfileBoostStatus, purchasedDurationSeconds: number, remainingDurationSeconds: number, consumedActiveSeconds: number, activeSegmentStartedAt?: any | null, totalPaidCents: number, currency?: string | null, hours: number, hourlyRateCents: number, startedAt?: any | null, completedAt?: any | null, endsAt?: any | null, impressions?: number | null, profileVisits?: number | null, clicks?: number | null, ctr?: string | null, createdAt: any, updatedAt: any } | null };

export type MyProfileBoostsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProfileBoostsQuery = { __typename?: 'Query', myProfileBoosts: Array<{ __typename?: 'ProfileBoost', id: string, mentorId: string, packId?: string | null, headline?: string | null, videoUrl?: string | null, status: ProfileBoostStatus, purchasedDurationSeconds: number, remainingDurationSeconds: number, consumedActiveSeconds: number, activeSegmentStartedAt?: any | null, totalPaidCents: number, currency?: string | null, hours: number, hourlyRateCents: number, startedAt?: any | null, completedAt?: any | null, endsAt?: any | null, impressions?: number | null, profileVisits?: number | null, clicks?: number | null, ctr?: string | null, createdAt: any, updatedAt: any }> };

export type ProfileBoostByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProfileBoostByIdQuery = { __typename?: 'Query', profileBoostById: { __typename?: 'ProfileBoost', id: string, mentorId: string, packId?: string | null, headline?: string | null, videoUrl?: string | null, status: ProfileBoostStatus, purchasedDurationSeconds: number, remainingDurationSeconds: number, consumedActiveSeconds: number, activeSegmentStartedAt?: any | null, totalPaidCents: number, currency?: string | null, hours: number, hourlyRateCents: number, startedAt?: any | null, completedAt?: any | null, endsAt?: any | null, impressions?: number | null, profileVisits?: number | null, clicks?: number | null, ctr?: string | null, createdAt: any, updatedAt: any } };

export type ProfileBoostDailyStatsQueryVariables = Exact<{
  boostId: Scalars['ID']['input'];
}>;


export type ProfileBoostDailyStatsQuery = { __typename?: 'Query', profileBoostDailyStats: { __typename?: 'ProfileBoostDailyStats', categories: Array<string>, impressions: Array<number>, profileVisits: Array<number>, clicks: Array<number> } };

export type OnProfileBoostActivitySubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnProfileBoostActivitySubscription = { __typename?: 'Subscription', profileBoostActivity: { __typename?: 'ProfileBoostChanged', changeType: ChangeType, boostId: string, boost?: { __typename?: 'ProfileBoost', id: string, mentorId: string, packId?: string | null, headline?: string | null, videoUrl?: string | null, status: ProfileBoostStatus, purchasedDurationSeconds: number, remainingDurationSeconds: number, consumedActiveSeconds: number, activeSegmentStartedAt?: any | null, totalPaidCents: number, currency?: string | null, hours: number, hourlyRateCents: number, startedAt?: any | null, completedAt?: any | null, endsAt?: any | null, impressions?: number | null, profileVisits?: number | null, clicks?: number | null, ctr?: string | null, createdAt: any, updatedAt: any } | null } };

export type RecordProfileViewMutationVariables = Exact<{
  input: RecordProfileViewInput;
}>;


export type RecordProfileViewMutation = { __typename?: 'Mutation', recordProfileView: boolean };

export type TogglePostReactionMutationVariables = Exact<{
  input: LikePostInput;
}>;


export type TogglePostReactionMutation = { __typename?: 'Mutation', togglePostReaction?: string | null };

export type GetReelsFeedQueryVariables = Exact<{
  input?: InputMaybe<ReelsFeedInput>;
}>;


export type GetReelsFeedQuery = { __typename?: 'Query', getReelsFeed: Array<{ __typename?: 'ReelModel', id: string, libraryItemId?: string | null, userId: string, title: string, description?: string | null, hlsUrl?: string | null, rawVideoUrl?: string | null, blurHash?: string | null, status: ReelStatus, likesCount: number, commentsCount: number, isLikedByMe?: boolean | null, createdAt: any, isCurated?: boolean | null, embedUrl?: string | null, sourceUrl?: string | null, thumbnailUrl?: string | null, provider?: VideoProvider | null, channelTitle?: string | null }> };

export type GetReelsByUserIdQueryVariables = Exact<{
  input: GetReelsByUserIdInput;
}>;


export type GetReelsByUserIdQuery = { __typename?: 'Query', getReelsByUserId: { __typename?: 'ReelsPaginated', total: number, hasMore: boolean, nextCursor?: string | null, reels: Array<{ __typename?: 'ReelModel', id: string, userId: string, title: string, description?: string | null, hlsUrl?: string | null, rawVideoUrl?: string | null, blurHash?: string | null, status: ReelStatus, likesCount: number, commentsCount: number, createdAt: any, isCurated?: boolean | null, embedUrl?: string | null, sourceUrl?: string | null, thumbnailUrl?: string | null, provider?: VideoProvider | null, channelTitle?: string | null }> } };

export type GetMyReelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyReelsQuery = { __typename?: 'Query', getMyReels: Array<{ __typename?: 'ReelModel', id: string, userId: string, title: string, description?: string | null, hlsUrl?: string | null, rawVideoUrl?: string | null, blurHash?: string | null, status: ReelStatus, likesCount: number, commentsCount: number, createdAt: any }> };

export type GetReelUploadUrlMutationVariables = Exact<{
  input: GetUploadUrlInput;
}>;


export type GetReelUploadUrlMutation = { __typename?: 'Mutation', getReelUploadUrl: { __typename?: 'PresignedUploadUrl', uploadUrl: string, key: string } };

export type ConfirmReelUploadMutationVariables = Exact<{
  input: ConfirmUploadInput;
}>;


export type ConfirmReelUploadMutation = { __typename?: 'Mutation', confirmReelUpload: { __typename?: 'ReelModel', id: string, title: string, status: ReelStatus } };

export type DeleteReelMutationVariables = Exact<{
  input: DeleteReelInput;
}>;


export type DeleteReelMutation = { __typename?: 'Mutation', deleteReel: boolean };

export type ReportReelPlaybackErrorMutationVariables = Exact<{
  input: ReportReelPlaybackErrorInput;
}>;


export type ReportReelPlaybackErrorMutation = { __typename?: 'Mutation', reportReelPlaybackError: boolean };

export type UpdateReelMutationVariables = Exact<{
  input: UpdateReelInput;
}>;


export type UpdateReelMutation = { __typename?: 'Mutation', updateReel: { __typename?: 'ReelModel', id: string, userId: string, title: string, description?: string | null, hlsUrl?: string | null, rawVideoUrl?: string | null, blurHash?: string | null, status: ReelStatus, likesCount: number, commentsCount: number, createdAt: any } };

export type LikeReelMutationVariables = Exact<{
  reelId: Scalars['String']['input'];
}>;


export type LikeReelMutation = { __typename?: 'Mutation', likeReel: { __typename?: 'ReelModel', id: string, likesCount: number, isLikedByMe?: boolean | null } };

export type UnlikeReelMutationVariables = Exact<{
  reelId: Scalars['String']['input'];
}>;


export type UnlikeReelMutation = { __typename?: 'Mutation', unlikeReel: { __typename?: 'ReelModel', id: string, likesCount: number, isLikedByMe?: boolean | null } };

export type CreateReelCommentMutationVariables = Exact<{
  input: CreateReelCommentInput;
}>;


export type CreateReelCommentMutation = { __typename?: 'Mutation', createReelComment: { __typename?: 'ReelCommentModel', id: string, reelId: string, userId: string, content: string, translatedContent?: string | null, parentId?: string | null, repliesCount: number, likesCount: number, isLikedByMe: boolean, createdAt: any, updatedAt: any, user: { __typename?: 'ReelCommentAuthor', id: string, firstName: string, middleName?: string | null, lastName?: string | null, title?: string | null, role: Role, profileImageUrl?: string | null, companyName?: string | null } } };

export type LikeReelCommentMutationVariables = Exact<{
  commentId: Scalars['String']['input'];
}>;


export type LikeReelCommentMutation = { __typename?: 'Mutation', likeReelComment: { __typename?: 'ReelCommentModel', id: string, likesCount: number, isLikedByMe: boolean } };

export type UnlikeReelCommentMutationVariables = Exact<{
  commentId: Scalars['String']['input'];
}>;


export type UnlikeReelCommentMutation = { __typename?: 'Mutation', unlikeReelComment: { __typename?: 'ReelCommentModel', id: string, likesCount: number, isLikedByMe: boolean } };

export type GetReelCommentsQueryVariables = Exact<{
  input: GetReelCommentsInput;
}>;


export type GetReelCommentsQuery = { __typename?: 'Query', getReelComments: { __typename?: 'ReelCommentsPaginated', total: number, hasMore: boolean, nextCursor?: string | null, comments: Array<{ __typename?: 'ReelCommentModel', id: string, reelId: string, userId: string, content: string, translatedContent?: string | null, parentId?: string | null, repliesCount: number, likesCount: number, isLikedByMe: boolean, createdAt: any, updatedAt: any, user: { __typename?: 'ReelCommentAuthor', id: string, firstName: string, middleName?: string | null, lastName?: string | null, title?: string | null, role: Role, profileImageUrl?: string | null, companyName?: string | null } }> } };

export type GetReelCommentRepliesQueryVariables = Exact<{
  input: GetReelCommentRepliesInput;
}>;


export type GetReelCommentRepliesQuery = { __typename?: 'Query', getReelCommentReplies: { __typename?: 'ReelCommentsPaginated', total: number, hasMore: boolean, nextCursor?: string | null, comments: Array<{ __typename?: 'ReelCommentModel', id: string, reelId: string, userId: string, content: string, translatedContent?: string | null, parentId?: string | null, repliesCount: number, likesCount: number, isLikedByMe: boolean, createdAt: any, updatedAt: any, user: { __typename?: 'ReelCommentAuthor', id: string, firstName: string, middleName?: string | null, lastName?: string | null, title?: string | null, role: Role, profileImageUrl?: string | null, companyName?: string | null } }> } };

export type GenerateMyReferralCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateMyReferralCodeMutation = { __typename?: 'Mutation', generateMyReferralCode: { __typename?: 'ReferralCampaign', id: string, code: string, name: string, description?: string | null, isActive: boolean, signupCount?: number | null, createdAt: any } };

export type MyReferralCampaignQueryVariables = Exact<{ [key: string]: never; }>;


export type MyReferralCampaignQuery = { __typename?: 'Query', myReferralCampaign?: { __typename?: 'ReferralCampaign', id: string, code: string, name: string, description?: string | null, isActive: boolean, signupCount?: number | null, createdAt: any } | null };

export type RejectSessionMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type RejectSessionMutation = { __typename?: 'Mutation', rejectBooking: boolean };

export type WithdrawBookingMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type WithdrawBookingMutation = { __typename?: 'Mutation', withdrawBooking: boolean };

export type ReportPostMutationVariables = Exact<{
  input: ReportPostInput;
}>;


export type ReportPostMutation = { __typename?: 'Mutation', reportPost: boolean };

export type RequestSessionRefundMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestSessionRefundMutation = { __typename?: 'Mutation', requestSessionRefund: boolean };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type ResetUserPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetUserPasswordMutation = { __typename?: 'Mutation', resetUserPassword: boolean };

export type CreateReviewMutationVariables = Exact<{
  input: CreateReviewInput;
}>;


export type CreateReviewMutation = { __typename?: 'Mutation', createReview: { __typename?: 'Review', id: string, rating: number, comment: string, createdAt: any, mentorId: string, reviewer: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, companyName?: string | null } } };

export type GetAllReviewsOfMentorQueryVariables = Exact<{
  mentorId: Scalars['String']['input'];
}>;


export type GetAllReviewsOfMentorQuery = { __typename?: 'Query', getAllReviewsOfMentor: Array<{ __typename?: 'Review', id: string, rating: number, comment: string, createdAt: any, reviewer: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null } }> };

export type IsAvailableForReviewQueryVariables = Exact<{
  mentorId: Scalars['String']['input'];
}>;


export type IsAvailableForReviewQuery = { __typename?: 'Query', isAvailableForReview: boolean };

export type CreateRoleChangeRequestMutationVariables = Exact<{
  input: CreateRoleChangeRequestInput;
}>;


export type CreateRoleChangeRequestMutation = { __typename?: 'Mutation', createRoleChangeRequest: { __typename?: 'RoleChangeRequestModel', id: string, currentRole: Role, requestedRole: Role, reason: string, status: RoleChangeRequestStatus, createdAt: any } };

export type CancelRoleChangeRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CancelRoleChangeRequestMutation = { __typename?: 'Mutation', cancelRoleChangeRequest: { __typename?: 'RoleChangeRequestModel', id: string, status: RoleChangeRequestStatus } };

export type MyRoleChangeRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyRoleChangeRequestsQuery = { __typename?: 'Query', myRoleChangeRequests: Array<{ __typename?: 'RoleChangeRequestModel', id: string, userId: string, currentRole: Role, requestedRole: Role, reason: string, status: RoleChangeRequestStatus, reviewedBy?: string | null, reviewedAt?: any | null, rejectionReason?: string | null, createdAt: any, updatedAt: any }> };

export type AllowedRoleChangeTargetsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllowedRoleChangeTargetsQuery = { __typename?: 'Query', allowedRoleChangeTargets: Array<Role> };

export type GetAllRssFeedsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  excludeAdIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetAllRssFeedsQuery = { __typename?: 'Query', getAllRssFeeds: { __typename?: 'RssPaginatedResponse', total: number, totalPages: number, items: Array<{ __typename?: 'RssFeed', id: string, guid: string, summary?: string | null, imageUrl?: string | null, profile_image?: string | null, link: string, title: string, source: string, publishedAt: any, isSaved: boolean, libraryItemId?: string | null }>, sponsoredItems?: Array<{ __typename?: 'RssSponsoredItem', afterItemIndex: number, ad: { __typename?: 'Campaign', id: string, name: string, headline: string, description: string, adFormat: AdFormat, mediaUrls: Array<string>, ctaText?: string | null, ctaUrl?: string | null, user?: { __typename?: 'CampaignOwner', id: string, organizationName?: string | null, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null } | null } }> | null } };

export type GetRssFeedsBySourceQueryVariables = Exact<{
  source: Scalars['String']['input'];
  query: RssFeedQueryDto;
}>;


export type GetRssFeedsBySourceQuery = { __typename?: 'Query', getRssFeedsBySource: { __typename?: 'RssPaginatedResponse', page: number, limit: number, total: number, totalPages: number, items: Array<{ __typename?: 'RssFeed', id: string, guid: string, title: string, source: string, link: string, publishedAt: any, summary?: string | null, imageUrl?: string | null, profile_image?: string | null, isSaved: boolean, libraryItemId?: string | null }> } };

export type GetRssFeedByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetRssFeedByIdQuery = { __typename?: 'Query', getRssFeedById: { __typename?: 'RssFeed', id: string, guid: string, source: string, title: string, link: string, publishedAt: any, summary?: string | null, content?: string | null, imageUrl?: string | null, profile_image?: string | null, createdAt: any, updatedAt: any, isSaved: boolean, libraryItemId?: string | null } };

export type GetRssSourceByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetRssSourceByNameQuery = { __typename?: 'Query', getRssSourceByName?: { __typename?: 'RssSource', id: string, name: string, url: string, description?: string | null, imageUrl?: string | null, createdAt: any, updatedAt: any } | null };

export type GetSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSourcesQuery = { __typename?: 'Query', getSources: Array<{ __typename?: 'RssSource', id: string, name: string, url: string, description?: string | null, imageUrl?: string | null, createdAt: any }> };

export type SavePostMutationVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type SavePostMutation = { __typename?: 'Mutation', savePost: boolean };

export type UnsavePostMutationVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type UnsavePostMutation = { __typename?: 'Mutation', unsavePost: boolean };

export type GetSavedPostsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSavedPostsQuery = { __typename?: 'Query', getSavedPosts: { __typename?: 'SavedPostsPaginated', total: number, hasMore: boolean, posts: Array<{ __typename?: 'Post', id: string, isRepost: boolean, repostComment?: string | null, originalPostId?: string | null, postType: PostType, companyId?: string | null, mediaUrls: Array<string>, createdAt?: any | null, updatedAt?: any | null, isPublished: boolean, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> }, article?: { __typename?: 'Article', id: string, title: string, subtitle?: string | null, coverImageUrl?: string | null, slug: string, readingTimeMinutes: number, tags: Array<string>, content: string, status: ArticleStatus, translatedTitle?: string | null, translatedSubtitle?: string | null, translatedExcerpt?: string | null } | null, companyAuthor?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null, followersCount?: number | null, isFollowing?: boolean | null } | null, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, translatedQuestion?: string | null, translatedOptions?: Array<string> | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null, occasion?: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy, translatedTitle?: string | null, translatedDescription?: string | null } | null, event?: { __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, category: string, maxAttendees?: number | null, participantsCount: number, isjoinedbyMe: boolean, organizedby: { __typename?: 'organizedBy', userId?: string | null, name?: string | null, imageUrl?: string | null, companyName?: string | null }, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null } | null, case?: { __typename?: 'CasePostModel', id: string, postId: string, createdAt: any, updatedAt: any, media: Array<{ __typename?: 'CaseMediaModel', id: string, step: string, type: string, imageUrl?: string | null, text?: string | null, order: number, createdAt: any, translatedText?: string | null }> } | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, profileImageUrl?: string | null, role: Role, headline?: string | null, isHiring?: boolean | null, openToWork?: boolean | null, isMentorVerified?: boolean | null, companyName?: string | null, connection?: { __typename?: 'ConnectionStatusModel', status: string, direction?: string | null } | null, actionButtons?: Array<{ __typename?: 'ActionButton', id: string, name: string, url: string, isShow: boolean, createdAt: any }> | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }, originalPost?: { __typename?: 'Post', id: string, mediaUrls: Array<string>, createdAt?: any | null, updatedAt?: any | null, isPublished: boolean, commentsCount: number, isSavedByMe: boolean, isRepost: boolean, originalPostId?: string | null, repostComment?: string | null, isRepostedByMe?: boolean | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> }, article?: { __typename?: 'Article', id: string, title: string, subtitle?: string | null, coverImageUrl?: string | null, slug: string, readingTimeMinutes: number, tags: Array<string>, content: string, status: ArticleStatus, translatedTitle?: string | null, translatedSubtitle?: string | null, translatedExcerpt?: string | null } | null, companyAuthor?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null, followersCount?: number | null, isFollowing?: boolean | null } | null, poll?: { __typename?: 'Poll', question: string, expiresAt?: any | null, translatedQuestion?: string | null, translatedOptions?: Array<string> | null, options: Array<{ __typename?: 'PollOption', id: string, text: string, votes: number, isChosen: boolean }> } | null, occasion?: { __typename?: 'Occasion', id: string, postId: string, title: string, description?: string | null, imageUrl?: string | null, privacy: PostPrivacy, translatedTitle?: string | null, translatedDescription?: string | null } | null, event?: { __typename?: 'Event', id: string, name: string, description?: string | null, imageUrl?: string | null, startTime: any, endTime: any, location?: string | null, category: string, maxAttendees?: number | null, participantsCount: number, isjoinedbyMe: boolean, organizedby: { __typename?: 'organizedBy', userId?: string | null, name?: string | null, imageUrl?: string | null, companyName?: string | null }, course?: { __typename?: 'EventCourse', id?: string | null, title?: string | null, thumbnailUrl?: string | null } | null } | null, case?: { __typename?: 'CasePostModel', id: string, postId: string, createdAt: any, updatedAt: any, media: Array<{ __typename?: 'CaseMediaModel', id: string, step: string, type: string, imageUrl?: string | null, text?: string | null, order: number, createdAt: any, translatedText?: string | null }> } | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, profileImageUrl?: string | null, role: Role, headline?: string | null, isHiring?: boolean | null, openToWork?: boolean | null, isMentorVerified?: boolean | null, companyName?: string | null, connection?: { __typename?: 'ConnectionStatusModel', status: string, direction?: string | null } | null, actionButtons?: Array<{ __typename?: 'ActionButton', id: string, name: string, url: string, isShow: boolean, createdAt: any }> | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } } | null }> } };

export type SaveRssFeedMutationVariables = Exact<{
  input: SaveRssPostsInput;
}>;


export type SaveRssFeedMutation = { __typename?: 'Mutation', saveRssFeed: boolean };

export type SearchCompaniesQueryVariables = Exact<{
  input: SearchCompaniesInput;
}>;


export type SearchCompaniesQuery = { __typename?: 'Query', searchCompanies: Array<{ __typename?: 'CompanyPreview', id: string, name: string, slug?: string | null, logoUrl?: string | null, tagline?: string | null, industry?: string | null, type?: CompanyType | null, hashtags?: Array<string> | null, followersCount?: number | null, city?: string | null, country?: string | null, isFollowing: boolean }> };

export type SearchMentorsQueryVariables = Exact<{
  input: SearchMentorsInput;
}>;


export type SearchMentorsQuery = { __typename?: 'Query', searchMentors: Array<{ __typename?: 'MentorSearchResult', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, role: string, about?: string | null, totalConsultations: number, totalConnections: number, isBoosted?: boolean | null, boostEndsAt?: any | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }> };

export type SearchPreviewQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SearchPreviewQuery = { __typename?: 'Query', searchPreview: { __typename?: 'SearchPreview', users?: Array<{ __typename?: 'UserPreview', id: string, name: string, title?: string | null, profileImageUrl?: string | null, role: string, about?: string | null, headline: string, totalConnections: number, companyName?: string | null, state?: string | null, country?: string | null, city?: string | null, isHiring?: boolean | null, openToWork?: boolean | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } | null> | null, posts?: Array<{ __typename?: 'Post', id: string, isRepost: boolean, repostComment?: string | null, originalPostId?: string | null, mediaUrls: Array<string>, commentsCount: number, isSavedByMe: boolean, isRepostedByMe?: boolean | null, isPublished: boolean, isBoosted?: boolean | null, activeBoostId?: string | null, createdAt?: any | null, updatedAt?: any | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, profileImageUrl?: string | null, openToWork?: boolean | null, isHiring?: boolean | null, role: Role, createdAt?: any | null, updatedAt?: any | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }, companyAuthor?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null, followersCount?: number | null, isFollowing?: boolean | null } | null, originalPost?: { __typename?: 'Post', id: string, mediaUrls: Array<string>, commentsCount: number, isSavedByMe: boolean, isRepostedByMe?: boolean | null, isPublished: boolean, isBoosted?: boolean | null, activeBoostId?: string | null, createdAt?: any | null, updatedAt?: any | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, profileImageUrl?: string | null, openToWork?: boolean | null, isHiring?: boolean | null, role: Role, createdAt?: any | null, updatedAt?: any | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> } } | null, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> } } | null> | null, groups?: Array<{ __typename?: 'GroupPreview', id: string, name: string, description?: string | null, profileImage?: string | null, coverImage?: string | null, privacy: string, membersCount: number, postsCount: number, tags: Array<string>, categories: Array<string>, location?: string | null, isJoined: boolean, membershipStatus?: string | null, createdAt: any, lastActivityAt?: any | null, owner: { __typename?: 'UserPreview', id: string, name: string, profileImageUrl?: string | null, role: string, about?: string | null, totalConnections: number, headline: string, companyName?: string | null, state?: string | null, country?: string | null, city?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } } | null> | null, companies?: Array<{ __typename?: 'CompanyPreview', id: string, name: string, slug?: string | null, logoUrl?: string | null, tagline?: string | null, industry?: string | null, type?: CompanyType | null, hashtags?: Array<string> | null, followersCount?: number | null, city?: string | null, country?: string | null, isFollowing: boolean }> | null } };

export type SearchUserOrPostQueryVariables = Exact<{
  input: SearchUserOrPostInput;
}>;


export type SearchUserOrPostQuery = { __typename?: 'Query', searchUserOrPost: { __typename?: 'SearchUserOrPostOutput', users?: Array<{ __typename?: 'UserPreview', id: string, name: string, title?: string | null, profileImageUrl?: string | null, role: string, about?: string | null, headline: string, totalConnections: number, companyName?: string | null, state?: string | null, country?: string | null, city?: string | null, isHiring?: boolean | null, openToWork?: boolean | null, isBoosted?: boolean | null, boostEndsAt?: any | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }> | null, posts?: Array<{ __typename?: 'Post', id: string, isRepost: boolean, repostComment?: string | null, originalPostId?: string | null, mediaUrls: Array<string>, commentsCount: number, isSavedByMe: boolean, isRepostedByMe?: boolean | null, isPublished: boolean, isBoosted?: boolean | null, activeBoostId?: string | null, createdAt?: any | null, updatedAt?: any | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, profileImageUrl?: string | null, role: Role, createdAt?: any | null, updatedAt?: any | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }, companyAuthor?: { __typename?: 'CompanyAuthor', id: string, name: string, logoUrl?: string | null, industry?: string | null, tagline?: string | null, followersCount?: number | null, isFollowing?: boolean | null } | null, originalPost?: { __typename?: 'Post', id: string, mediaUrls: Array<string>, commentsCount: number, isSavedByMe: boolean, isRepostedByMe?: boolean | null, isPublished: boolean, isBoosted?: boolean | null, activeBoostId?: string | null, createdAt?: any | null, updatedAt?: any | null, contentTokens: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }>, translatedContentTokens?: Array<{ __typename?: 'ContentToken', type: ContentTokenType, value?: string | null, handle?: string | null, userId?: string | null, url?: string | null }> | null, author: { __typename?: 'PostAuthor', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, profileImageUrl?: string | null, role: Role, createdAt?: any | null, updatedAt?: any | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> } } | null, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> } }> | null } };

export type SearchUsersQueryVariables = Exact<{
  input: SearchUsersInput;
}>;


export type SearchUsersQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'Search', id: string, firstName: string, lastName?: string | null, title?: string | null, middleName?: string | null, suffix?: Suffix | null, profileImageUrl?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }> };

export type UpdateRssFiltersMutationVariables = Exact<{
  filters: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateRssFiltersMutation = { __typename?: 'Mutation', updateRssFilters: boolean };

export type GetRssFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRssFiltersQuery = { __typename?: 'Query', getRssFilters: Array<string> };

export type CreateServiceMutationVariables = Exact<{
  input: CreateServiceInput;
}>;


export type CreateServiceMutation = { __typename?: 'Mutation', createService: { __typename?: 'Service', id: string, title: string, category: string, type: ServiceType, fee: number, serviceStatus: ServiceStatus, priceType: PriceType, description: string, images: Array<string>, optimizedImages?: Array<string> | null, userId?: string | null, createdAt: any, updatedAt: any, user?: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, role: Role, profileImageUrl?: string | null, companyName?: string | null } | null } };

export type UpdateServiceMutationVariables = Exact<{
  input: UpdateServiceInput;
}>;


export type UpdateServiceMutation = { __typename?: 'Mutation', updateService: { __typename?: 'Service', id: string, title: string, category: string, type: ServiceType, fee: number, serviceStatus: ServiceStatus, priceType: PriceType, description: string, images: Array<string>, optimizedImages?: Array<string> | null, userId?: string | null, createdAt: any, updatedAt: any, user?: { __typename?: 'User', id: string, email: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null } | null } };

export type RemoveServiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveServiceMutation = { __typename?: 'Mutation', removeService: { __typename?: 'Service', id: string, title: string, description: string } };

export type ServiceDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ServiceDetailQuery = { __typename?: 'Query', service: { __typename?: 'Service', id: string, title: string, category: string, type: ServiceType, fee: number, currency: string, address: string, langitude: number, latitude: number, serviceStatus: ServiceStatus, priceType: PriceType, description: string, images: Array<string>, optimizedImages?: Array<string> | null, createdAt: any, updatedAt: any, user?: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, bannerImageUrl?: string | null, createdAt?: any | null, role: Role, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } | null } };

export type MyServicesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyServicesQuery = { __typename?: 'Query', myServices: { __typename?: 'ServicePaginatedResponse', total: number, page: number, limit: number, totalActiveServices: number, totalPendingServices?: number | null, totalPages: number, hasMore: boolean, data: Array<{ __typename?: 'Service', id: string, title: string, category: string, type: ServiceType, fee: number, currency: string, address: string, langitude: number, latitude: number, serviceStatus: ServiceStatus, priceType: PriceType, description: string, images: Array<string>, optimizedImages?: Array<string> | null, hasCoupon?: boolean | null, user?: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, role: Role, companyName?: string | null } | null }> } };

export type AllServicesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  minPrice?: InputMaybe<Scalars['Int']['input']>;
  maxPrice?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ServiceType>;
}>;


export type AllServicesQuery = { __typename?: 'Query', allServices: { __typename?: 'ServicePaginatedResponse', total: number, page: number, limit: number, totalPages: number, hasMore: boolean, data: Array<{ __typename?: 'Service', id: string, libraryItemId?: string | null, title: string, category: string, type: ServiceType, fee: number, currency: string, address: string, langitude: number, latitude: number, serviceStatus: ServiceStatus, priceType: PriceType, description: string, images: Array<string>, optimizedImages?: Array<string> | null, createdAt: any, user?: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, role: Role, companyName?: string | null } | null }> } };

export type SimilarServicesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SimilarServicesQuery = { __typename?: 'Query', similarServices: Array<{ __typename?: 'Service', id: string, title: string, category: string, type: ServiceType, fee: number, currency: string, address: string, langitude: number, latitude: number, serviceStatus: ServiceStatus, priceType: PriceType, description: string, images: Array<string>, optimizedImages?: Array<string> | null, createdAt: any, user?: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, role: Role, companyName?: string | null } | null }> };

export type ReportServiceMutationVariables = Exact<{
  createServiceReportInput: CreateServiceReportInput;
}>;


export type ReportServiceMutation = { __typename?: 'Mutation', reportService: boolean };

export type CheckCouponAvailabilityQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
}>;


export type CheckCouponAvailabilityQuery = { __typename?: 'Query', checkCouponAvailability: { __typename?: 'CouponAvailabilityResponse', isAvailable: boolean, status: CouponStatus, couponCode?: string | null, title?: string | null, discountPrice?: number | null, redeemedCoupons?: number | null, totalCoupons?: number | null, message?: string | null, isReportedByMe?: boolean | null, isRedeemedByMe?: boolean | null } };

export type RedeemCouponMutationVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  couponCode: Scalars['String']['input'];
}>;


export type RedeemCouponMutation = { __typename?: 'Mutation', redeemCoupon: { __typename?: 'RedeemCouponResponse', success: boolean, message: string, discountPrice?: number | null } };

export type PublicServicesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublicServicesQuery = { __typename?: 'Query', publicServices: { __typename?: 'PublicServicePaginatedResponse', total: number, page: number, limit: number, totalPages: number, hasMore: boolean, data: Array<{ __typename?: 'PublicServiceItem', id: string, image: string, title: string, description?: string | null, createAT: any, location: string, category: string, postedBy: { __typename?: 'PublicServicePostedBy', name: string, avatar?: string | null, companyName?: string | null } }> } };

export type ChangeMyServiceStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: ServiceStatus;
}>;


export type ChangeMyServiceStatusMutation = { __typename?: 'Mutation', changeMyServiceStatus: { __typename?: 'Service', id: string, title: string, category: string, type: ServiceType, fee: number, currency: string, address: string, langitude: number, latitude: number, serviceStatus: ServiceStatus, priceType: PriceType, description: string, images: Array<string>, optimizedImages?: Array<string> | null, createdAt: any, updatedAt: any, user?: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, bannerImageUrl?: string | null, createdAt?: any | null, role: Role, companyName?: string | null } | null } };

export type CouponDetailWithUsersQueryVariables = Exact<{
  serviceId: Scalars['String']['input'];
}>;


export type CouponDetailWithUsersQuery = { __typename?: 'Query', couponDetailWithUsers: { __typename?: 'CouponDetailWithUsers', id: string, couponCode: string, title: string, discountPrice: number, status: CouponStatus, startDate: any, endDate: any, redeemedCoupons: number, totalCoupons: number, users: Array<{ __typename?: 'CouponUser', id: string, firstName?: string | null, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, email?: string | null, role: Role, companyName?: string | null }> } };

export type SignUpMutationVariables = Exact<{
  input: SignUpInput;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp: { __typename?: 'SignUpResponse', success: boolean, checkoutUrl?: string | null, accessToken?: any | null, refreshToken?: any | null } };

export type CheckSignupAvailabilityQueryVariables = Exact<{
  input: CheckSignupAvailabilityInput;
}>;


export type CheckSignupAvailabilityQuery = { __typename?: 'Query', checkSignupAvailability: { __typename?: 'SignupAvailability', emailTaken: boolean, dentalLicenseNumberTaken: boolean, universityEmailTaken: boolean } };

export type AddSkillsToUserMutationVariables = Exact<{
  input: AddSkillsInput;
}>;


export type AddSkillsToUserMutation = { __typename?: 'Mutation', addSkillsToUser: boolean };

export type DeleteSkillFromUserMutationVariables = Exact<{
  input: DeleteSkillInput;
}>;


export type DeleteSkillFromUserMutation = { __typename?: 'Mutation', deleteSkillFromUser: boolean };

export type StoryFieldsFragment = { __typename?: 'Story', id: string, userId: string, createdAt: any, expiresAt: any, viewCount: number, isSeen: boolean, user?: { __typename?: 'StoryUser', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null } | null, content: Array<{ __typename?: 'StoryContent', id: string, content: string, caption?: string | null, type: StoryType, duration?: number | null, order: number, createdAt: any }>, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> } };

export type CreateStoryMutationVariables = Exact<{
  input: CreateStoryInput;
}>;


export type CreateStoryMutation = { __typename?: 'Mutation', createStory: { __typename?: 'Story', id: string, userId: string, createdAt: any, expiresAt: any, viewCount: number, isSeen: boolean, user?: { __typename?: 'StoryUser', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null } | null, content: Array<{ __typename?: 'StoryContent', id: string, content: string, caption?: string | null, type: StoryType, duration?: number | null, order: number, createdAt: any }>, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> } } };

export type GetConnectedUsersStoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConnectedUsersStoriesQuery = { __typename?: 'Query', getConnectedUsersStories: Array<{ __typename?: 'Story', id: string, userId: string, createdAt: any, expiresAt: any, viewCount: number, isSeen: boolean, user?: { __typename?: 'StoryUser', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null } | null, content: Array<{ __typename?: 'StoryContent', id: string, content: string, caption?: string | null, type: StoryType, duration?: number | null, order: number, createdAt: any }>, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> } }> };

export type OnStoryChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnStoryChangedSubscription = { __typename?: 'Subscription', storyChanged: { __typename?: 'StoryChanged', type: StoryChangeType, storyId: string, userId: string, story?: { __typename?: 'Story', id: string, userId: string, createdAt: any, expiresAt: any, viewCount: number, isSeen: boolean, user?: { __typename?: 'StoryUser', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null } | null, content: Array<{ __typename?: 'StoryContent', id: string, content: string, caption?: string | null, type: StoryType, duration?: number | null, order: number, createdAt: any }>, reactions: { __typename?: 'ReactionSummary', totalReactions: number, currentUserReaction?: string | null, reactionCounts: Array<{ __typename?: 'ReactionCount', type: string, count: number }> } } | null } };

export type DeleteStoryMutationVariables = Exact<{
  input: DeleteContentInput;
}>;


export type DeleteStoryMutation = { __typename?: 'Mutation', deleteStory: boolean };

export type MarkStoryViewedMutationVariables = Exact<{
  input: MarkStoryViewedInput;
}>;


export type MarkStoryViewedMutation = { __typename?: 'Mutation', markStoryViewed: boolean };

export type GetUserStoriesQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetUserStoriesQuery = { __typename?: 'Query', getUserStories: Array<{ __typename?: 'Story', id: string, userId: string, isSeen: boolean, createdAt: any, expiresAt: any, viewCount: number, user?: { __typename?: 'StoryUser', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null } | null, content: Array<{ __typename?: 'StoryContent', id: string, content: string, type: StoryType, caption?: string | null, duration?: number | null, order: number, createdAt: any }> }> };

export type GetStoryViewersQueryVariables = Exact<{
  storyId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetStoryViewersQuery = { __typename?: 'Query', getStoryViewers: Array<{ __typename?: 'StoryViewer', id: string, viewedAt: any, totalViews: number, viewer: { __typename?: 'StoryViewerUser', id: string, firstName: string, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, companyName?: string | null } }> };

export type ToggleStoryReactionMutationVariables = Exact<{
  input: ToggleStoryLikeInput;
}>;


export type ToggleStoryReactionMutation = { __typename?: 'Mutation', toggleStoryReaction: { __typename?: 'StoryReactionResponse', id: string, action: ReactionAction, reactionType?: ReactionType | null, message: string } };

export type GetStoryReactorsQueryVariables = Exact<{
  input: GetStoryReactorsInput;
}>;


export type GetStoryReactorsQuery = { __typename?: 'Query', getStoryReactors: Array<{ __typename?: 'StoryReactionUser', id: string, reactionType: string, userId: string, firstName?: string | null, lastName?: string | null, title?: string | null, profileImageUrl?: string | null, role: Role, totalReactions: number, companyName?: string | null }> };

export type MyInvoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyInvoicesQuery = { __typename?: 'Query', myInvoices: Array<{ __typename?: 'SubscriptionInvoice', id: string, invoiceNumber: string, stripeInvoiceId: string, providerInvoiceId?: string | null, status: string, amountPaid: number, amountDue: number, currency: string, invoiceUrl?: string | null, invoicePdf?: string | null, periodStart?: any | null, periodEnd?: any | null, periodLabel?: string | null, periodDays?: number | null, previousPlanAmount?: number | null, previousPlanUnusedCredit?: number | null, newPlanPrice?: number | null, finalAmountPaid?: number | null, paidAt?: any | null, planName?: string | null, invoiceType?: string | null, createdAt: any }> };

export type ActivePlansQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivePlansQuery = { __typename?: 'Query', activePlans: Array<{ __typename?: 'SubscriptionPlan', id: string, name: string, stripePriceId?: string | null, stripeProductId?: string | null, priceMonthly: number, description?: string | null, status: PlanStatus, companyPages?: number | null, connectionSendingLimits?: number | null, serviceListings?: number | null, groupCreation?: number | null, actionButtonOnProfile: boolean, liveStreaming: boolean, accessAIChatbot: boolean, createdAt: any, updatedAt: any }> };

export type MySubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type MySubscriptionQuery = { __typename?: 'Query', mySubscription?: { __typename?: 'UserSubscription', id: string, userId?: string | null, planId: string, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, status: SubscriptionStatus, currentPeriodStart?: any | null, currentPeriodEnd?: any | null, planLimitsPeriodStart?: any | null, cancelAtPeriodEnd: boolean, pendingPlanId?: string | null, planSnapshot?: any | null, trialStartsAt?: any | null, trialEndsAt?: any | null, paymentFailedAt?: any | null, graceEndsAt?: any | null, accessState?: string | null, couponId?: string | null, stripeDiscountId?: string | null, stripePromotionCodeId?: string | null, createdAt: any, updatedAt: any, coupon?: { __typename?: 'UserSubscriptionCouponSummary', id: string, code: string, discountPercent: number, type: string, status: string } | null, pendingCoupon?: { __typename?: 'UserSubscriptionCouponSummary', id: string, code: string, discountPercent: number, type: string, status: string } | null, plan: { __typename?: 'SubscriptionPlan', id: string, name: string, stripePriceId?: string | null, stripeProductId?: string | null, priceMonthly: number, description?: string | null, status: PlanStatus, companyPages?: number | null, connectionSendingLimits?: number | null, serviceListings?: number | null, groupCreation?: number | null, actionButtonOnProfile: boolean, liveStreaming: boolean, accessAIChatbot: boolean, createdAt: any, updatedAt: any }, pendingPlan?: { __typename?: 'SubscriptionPlan', id: string, name: string, priceMonthly: number, description?: string | null } | null, invoices?: Array<{ __typename?: 'SubscriptionInvoice', id: string, stripeInvoiceId: string, status: string, amountPaid: number, amountDue: number, currency: string, invoiceUrl?: string | null, invoicePdf?: string | null, periodStart?: any | null, periodEnd?: any | null, paidAt?: any | null, paymentMethodBrand?: string | null, paymentMethodLast4?: string | null, billingReason?: string | null, createdAt: any }> | null } | null };

export type ValidateSubscriptionCouponQueryVariables = Exact<{
  couponCode: Scalars['String']['input'];
  context?: InputMaybe<Scalars['String']['input']>;
}>;


export type ValidateSubscriptionCouponQuery = { __typename?: 'Query', validateSubscriptionCoupon: { __typename?: 'SubscriptionCouponValidationResult', valid: boolean, message?: string | null, discountPercent?: number | null, type?: SubscriptionCouponType | null } };

export type PreviewUpgradeCheckoutQueryVariables = Exact<{
  planId: Scalars['ID']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type PreviewUpgradeCheckoutQuery = { __typename?: 'Query', previewUpgradeCheckout: { __typename?: 'UpgradeCheckoutPreview', amountDueCents: number, discountCents: number, amountDueAfterDiscountCents: number, currency: string, newPlanPriceMonthly: number, currentPlanPriceMonthly: number, discountPercent?: number | null, couponType?: string | null, couponCode?: string | null } };

export type CreateSubscriptionCheckoutMutationVariables = Exact<{
  planId: Scalars['ID']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSubscriptionCheckoutMutation = { __typename?: 'Mutation', createSubscriptionCheckout: { __typename?: 'CheckoutSessionResult', checkoutUrl: string } };

export type CreateUpgradeCheckoutMutationVariables = Exact<{
  planId: Scalars['ID']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateUpgradeCheckoutMutation = { __typename?: 'Mutation', createUpgradeCheckout: { __typename?: 'CheckoutSessionResult', checkoutUrl: string } };

export type RetryTrialSignupWithNewCardMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type RetryTrialSignupWithNewCardMutation = { __typename?: 'Mutation', retryTrialSignupWithNewCard: { __typename?: 'CheckoutSessionResult', checkoutUrl: string } };

export type ContinueSignupWithoutTrialMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type ContinueSignupWithoutTrialMutation = { __typename?: 'Mutation', continueSignupWithoutTrial: { __typename?: 'CheckoutSessionResult', checkoutUrl: string } };

export type VerifyCheckoutSessionMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type VerifyCheckoutSessionMutation = { __typename?: 'Mutation', verifyCheckoutSession?: { __typename?: 'UserSubscription', id: string, planId: string, status: SubscriptionStatus, currentPeriodStart?: any | null, currentPeriodEnd?: any | null, planLimitsPeriodStart?: any | null, cancelAtPeriodEnd: boolean, planSnapshot?: any | null, coupon?: { __typename?: 'UserSubscriptionCouponSummary', id: string, code: string, discountPercent: number, type: string, status: string } | null, plan: { __typename?: 'SubscriptionPlan', id: string, name: string, priceMonthly: number, description?: string | null, companyPages?: number | null, connectionSendingLimits?: number | null, serviceListings?: number | null, groupCreation?: number | null, actionButtonOnProfile: boolean, liveStreaming: boolean, accessAIChatbot: boolean } } | null };

export type VerifyUpgradeCheckoutSessionMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type VerifyUpgradeCheckoutSessionMutation = { __typename?: 'Mutation', verifyUpgradeCheckoutSession?: { __typename?: 'UserSubscription', id: string, planId: string, status: SubscriptionStatus, currentPeriodStart?: any | null, currentPeriodEnd?: any | null, planLimitsPeriodStart?: any | null, cancelAtPeriodEnd: boolean, planSnapshot?: any | null, coupon?: { __typename?: 'UserSubscriptionCouponSummary', id: string, code: string, discountPercent: number, type: string, status: string } | null, plan: { __typename?: 'SubscriptionPlan', id: string, name: string, priceMonthly: number, description?: string | null, companyPages?: number | null, connectionSendingLimits?: number | null, serviceListings?: number | null, groupCreation?: number | null, actionButtonOnProfile: boolean, liveStreaming: boolean, accessAIChatbot: boolean } } | null };

export type CancelMySubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelMySubscriptionMutation = { __typename?: 'Mutation', cancelMySubscription: boolean };

export type ChangeSubscriptionPlanMutationVariables = Exact<{
  planId: Scalars['ID']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangeSubscriptionPlanMutation = { __typename?: 'Mutation', changeSubscriptionPlan?: { __typename?: 'UserSubscription', id: string, planId: string, status: SubscriptionStatus, currentPeriodStart?: any | null, currentPeriodEnd?: any | null, planLimitsPeriodStart?: any | null, cancelAtPeriodEnd: boolean, pendingPlanId?: string | null, planSnapshot?: any | null, coupon?: { __typename?: 'UserSubscriptionCouponSummary', id: string, code: string, discountPercent: number, type: string, status: string } | null, pendingCoupon?: { __typename?: 'UserSubscriptionCouponSummary', id: string, code: string, discountPercent: number, type: string, status: string } | null, plan: { __typename?: 'SubscriptionPlan', id: string, name: string, priceMonthly: number, description?: string | null, companyPages?: number | null, connectionSendingLimits?: number | null, serviceListings?: number | null, groupCreation?: number | null, actionButtonOnProfile: boolean, liveStreaming: boolean, accessAIChatbot: boolean }, pendingPlan?: { __typename?: 'SubscriptionPlan', id: string, name: string, priceMonthly: number } | null } | null };

export type ApplySubscriptionCouponMutationVariables = Exact<{
  couponCode: Scalars['String']['input'];
}>;


export type ApplySubscriptionCouponMutation = { __typename?: 'Mutation', applySubscriptionCoupon?: { __typename?: 'UserSubscription', id: string, couponId?: string | null, coupon?: { __typename?: 'UserSubscriptionCouponSummary', id: string, code: string, discountPercent: number, type: string, status: string } | null, plan: { __typename?: 'SubscriptionPlan', id: string, name: string, priceMonthly: number } } | null };

export type ResumeMySubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type ResumeMySubscriptionMutation = { __typename?: 'Mutation', resumeMySubscription?: { __typename?: 'UserSubscription', id: string, status: SubscriptionStatus, cancelAtPeriodEnd: boolean, currentPeriodEnd?: any | null, plan: { __typename?: 'SubscriptionPlan', id: string, name: string, priceMonthly: number } } | null };

export type CancelPendingPlanChangeMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelPendingPlanChangeMutation = { __typename?: 'Mutation', cancelPendingPlanChange?: { __typename?: 'UserSubscription', id: string, pendingPlanId?: string | null, pendingPlan?: { __typename?: 'SubscriptionPlan', id: string, name: string } | null } | null };

export type GenerateReceiptPdfMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type GenerateReceiptPdfMutation = { __typename?: 'Mutation', generateReceiptPdf: { __typename?: 'ReceiptPdfResult', base64Pdf: string, filename: string } };

export type TrialConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type TrialConfigQuery = { __typename?: 'Query', trialConfig: { __typename?: 'TrialConfigResult', enabled: boolean, trialDays: number } };

export type CreateBillingPortalSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateBillingPortalSessionMutation = { __typename?: 'Mutation', createBillingPortalSession: { __typename?: 'BillingPortalResult', url: string } };

export type PayMyOpenInvoiceMutationVariables = Exact<{ [key: string]: never; }>;


export type PayMyOpenInvoiceMutation = { __typename?: 'Mutation', payMyOpenInvoice: boolean };

export type MyOpenInvoicePaymentUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type MyOpenInvoicePaymentUrlMutation = { __typename?: 'Mutation', myOpenInvoicePaymentUrl: { __typename?: 'BillingPortalResult', url: string } };

export type GetSuggestedProfilesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
}>;


export type GetSuggestedProfilesQuery = { __typename?: 'Query', getSuggestedProfiles: Array<{ __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, openToWork?: boolean | null, isHiring?: boolean | null, profileImageUrl?: string | null, role: Role, isBoosted?: boolean | null, boostEndsAt?: any | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }> };

export type GrowNetworkQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GrowNetworkQuery = { __typename?: 'Query', growNetwork: Array<{ __typename?: 'User', id: string, firstName: string, lastName?: string | null, title?: string | null, openToWork?: boolean | null, isHiring?: boolean | null, profileImageUrl?: string | null, role: Role, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null }> };

export type CreateSupportTicketFromAiMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type CreateSupportTicketFromAiMutation = { __typename?: 'Mutation', createSupportTicketFromAI: { __typename?: 'SupportTicket', id: string, ticketNumber: string, subject: string, status: SupportTicketStatus } };

export type SubmitAiConversationFeedbackMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
  helpful: Scalars['Boolean']['input'];
}>;


export type SubmitAiConversationFeedbackMutation = { __typename?: 'Mutation', submitAiConversationFeedback: boolean };

export type CreateSupportTicketMutationVariables = Exact<{
  input: CreateSupportTicketInput;
}>;


export type CreateSupportTicketMutation = { __typename?: 'Mutation', createSupportTicket: { __typename?: 'SupportTicket', description: string, id: string, ticketNumber: string, subject: string, status: SupportTicketStatus, priority: SupportTicketPriority, source: SupportTicketSource, categoryId?: string | null, messageCount: number, lastMessageAt?: any | null, lastMessagePreview?: string | null, createdAt?: any | null, updatedAt?: any | null, resolvedAt?: any | null, closedAt?: any | null, feedbackResolved?: boolean | null, messages?: Array<{ __typename?: 'SupportMessage', id: string, ticketId: string, senderId?: string | null, senderType: SupportSenderType, isInternal: boolean, message: string, createdAt?: any | null, sender?: { __typename?: 'SupportMessageSender', id: string, firstName: string, lastName?: string | null, profileImageUrl?: string | null } | null, attachments: Array<{ __typename?: 'Media', id: string, fileName: string, fileUrl: string, mimeType: string, size: number }> }> | null, category?: { __typename?: 'SupportCategory', id: string, name: string, key: string } | null } };

export type SendSupportMessageMutationVariables = Exact<{
  input: SendSupportMessageInput;
}>;


export type SendSupportMessageMutation = { __typename?: 'Mutation', sendSupportMessage: { __typename?: 'SupportMessage', id: string, ticketId: string, senderId?: string | null, senderType: SupportSenderType, isInternal: boolean, message: string, createdAt?: any | null, sender?: { __typename?: 'SupportMessageSender', id: string, firstName: string, lastName?: string | null, profileImageUrl?: string | null } | null, attachments: Array<{ __typename?: 'Media', id: string, fileName: string, fileUrl: string, mimeType: string, size: number }> } };

export type CloseSupportTicketMutationVariables = Exact<{
  ticketId: Scalars['ID']['input'];
}>;


export type CloseSupportTicketMutation = { __typename?: 'Mutation', closeSupportTicket: { __typename?: 'SupportTicket', id: string, ticketNumber: string, subject: string, status: SupportTicketStatus, priority: SupportTicketPriority, source: SupportTicketSource, categoryId?: string | null, messageCount: number, lastMessageAt?: any | null, lastMessagePreview?: string | null, createdAt?: any | null, updatedAt?: any | null, resolvedAt?: any | null, closedAt?: any | null, feedbackResolved?: boolean | null, category?: { __typename?: 'SupportCategory', id: string, name: string, key: string } | null } };

export type SubmitSupportTicketFeedbackMutationVariables = Exact<{
  input: SubmitTicketFeedbackInput;
}>;


export type SubmitSupportTicketFeedbackMutation = { __typename?: 'Mutation', submitSupportTicketFeedback: { __typename?: 'SupportTicket', id: string, ticketNumber: string, subject: string, status: SupportTicketStatus, priority: SupportTicketPriority, source: SupportTicketSource, categoryId?: string | null, messageCount: number, lastMessageAt?: any | null, lastMessagePreview?: string | null, createdAt?: any | null, updatedAt?: any | null, resolvedAt?: any | null, closedAt?: any | null, feedbackResolved?: boolean | null, category?: { __typename?: 'SupportCategory', id: string, name: string, key: string } | null } };

export type RateKnowledgeArticleMutationVariables = Exact<{
  input: RateKnowledgeArticleInput;
}>;


export type RateKnowledgeArticleMutation = { __typename?: 'Mutation', rateKnowledgeArticle: { __typename?: 'KnowledgeArticle', id: string, helpfulCount: number, notHelpfulCount: number } };

export type SupportCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type SupportCategoriesQuery = { __typename?: 'Query', supportCategories: Array<{ __typename?: 'SupportCategory', id: string, key: string, name: string, description?: string | null, isActive: boolean, sortOrder: number }> };

export type SupportMessageFieldsFragment = { __typename?: 'SupportMessage', id: string, ticketId: string, senderId?: string | null, senderType: SupportSenderType, isInternal: boolean, message: string, createdAt?: any | null, sender?: { __typename?: 'SupportMessageSender', id: string, firstName: string, lastName?: string | null, profileImageUrl?: string | null } | null, attachments: Array<{ __typename?: 'Media', id: string, fileName: string, fileUrl: string, mimeType: string, size: number }> };

export type SupportTicketRowFragment = { __typename?: 'SupportTicket', id: string, ticketNumber: string, subject: string, status: SupportTicketStatus, priority: SupportTicketPriority, source: SupportTicketSource, categoryId?: string | null, messageCount: number, lastMessageAt?: any | null, lastMessagePreview?: string | null, createdAt?: any | null, updatedAt?: any | null, resolvedAt?: any | null, closedAt?: any | null, feedbackResolved?: boolean | null, category?: { __typename?: 'SupportCategory', id: string, name: string, key: string } | null };

export type MySupportTicketsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type MySupportTicketsQuery = { __typename?: 'Query', mySupportTickets: { __typename?: 'SupportTicketConnection', total: number, page: number, limit: number, totalPages: number, hasMore: boolean, data: Array<{ __typename?: 'SupportTicket', id: string, ticketNumber: string, subject: string, status: SupportTicketStatus, priority: SupportTicketPriority, source: SupportTicketSource, categoryId?: string | null, messageCount: number, lastMessageAt?: any | null, lastMessagePreview?: string | null, createdAt?: any | null, updatedAt?: any | null, resolvedAt?: any | null, closedAt?: any | null, feedbackResolved?: boolean | null, category?: { __typename?: 'SupportCategory', id: string, name: string, key: string } | null }> } };

export type SupportTicketQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SupportTicketQuery = { __typename?: 'Query', supportTicket: { __typename?: 'SupportTicket', description: string, relatedType?: SupportRelatedType | null, relatedId?: string | null, aiConversationId?: string | null, id: string, ticketNumber: string, subject: string, status: SupportTicketStatus, priority: SupportTicketPriority, source: SupportTicketSource, categoryId?: string | null, messageCount: number, lastMessageAt?: any | null, lastMessagePreview?: string | null, createdAt?: any | null, updatedAt?: any | null, resolvedAt?: any | null, closedAt?: any | null, feedbackResolved?: boolean | null, messages?: Array<{ __typename?: 'SupportMessage', id: string, ticketId: string, senderId?: string | null, senderType: SupportSenderType, isInternal: boolean, message: string, createdAt?: any | null, sender?: { __typename?: 'SupportMessageSender', id: string, firstName: string, lastName?: string | null, profileImageUrl?: string | null } | null, attachments: Array<{ __typename?: 'Media', id: string, fileName: string, fileUrl: string, mimeType: string, size: number }> }> | null, category?: { __typename?: 'SupportCategory', id: string, name: string, key: string } | null } };

export type KnowledgeArticlesQueryVariables = Exact<{
  input?: InputMaybe<KnowledgeArticleSearchInput>;
}>;


export type KnowledgeArticlesQuery = { __typename?: 'Query', knowledgeArticles: { __typename?: 'KnowledgeArticleConnection', total: number, page: number, limit: number, totalPages: number, hasMore: boolean, data: Array<{ __typename?: 'KnowledgeArticle', id: string, title: string, slug: string, excerpt?: string | null, tags: Array<string>, helpfulCount: number, notHelpfulCount: number, publishedAt?: any | null, category?: { __typename?: 'SupportCategory', id: string, name: string } | null }> } };

export type KnowledgeArticleQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type KnowledgeArticleQuery = { __typename?: 'Query', knowledgeArticle: { __typename?: 'KnowledgeArticle', id: string, title: string, slug: string, content: string, excerpt?: string | null, tags: Array<string>, helpfulCount: number, notHelpfulCount: number, publishedAt?: any | null, updatedAt: any, category?: { __typename?: 'SupportCategory', id: string, name: string } | null } };

export type UnsaveRssFeedMutationVariables = Exact<{
  input: UnSaveRssPostsInput;
}>;


export type UnsaveRssFeedMutation = { __typename?: 'Mutation', unsaveRssFeed: boolean };

export type UniversityGroupQueryVariables = Exact<{
  communityId: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type UniversityGroupQuery = { __typename?: 'Query', universityGroup?: { __typename?: 'UniversityGroup', id: string, name: string, type: string, description?: string | null } | null };

export type UpdateScheduleMutationVariables = Exact<{
  input: UpdateScheduleInput;
}>;


export type UpdateScheduleMutation = { __typename?: 'Mutation', updateSchedule: boolean };

export type UpdatePostMutationVariables = Exact<{
  input: UpdatePostInputForBoth;
}>;


export type UpdatePostMutation = { __typename?: 'Mutation', updatePost: boolean };

export type UploadCommentMediaMutationVariables = Exact<{
  input: UploadCommentMediaInput;
}>;


export type UploadCommentMediaMutation = { __typename?: 'Mutation', uploadCommentMedia: string };

export type UploadGroupImagesMutationVariables = Exact<{
  coverImage: Scalars['Upload']['input'];
  profileImage: Scalars['Upload']['input'];
}>;


export type UploadGroupImagesMutation = { __typename?: 'Mutation', uploadGroupImages: { __typename?: 'GroupImagesResult', coverImageUrl: string, profileImageUrl: string } };

export type UploadProfileImageMutationVariables = Exact<{
  input: UploadProfileImageInput;
}>;


export type UploadProfileImageMutation = { __typename?: 'Mutation', uploadProfileImage: { __typename?: 'Media', id: string, createdAt?: any | null, updatedAt?: any | null, userId?: string | null, fileName: string, fileUrl: string, optimizedUrl?: string | null, mimeType: string, size: number, type: FileType } };

export type GetUserBasicInfoQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserBasicInfoQuery = { __typename?: 'Query', getUserBasicInfo?: { __typename?: 'UserBasicInfo', userId: string, name: string, profileImageUrl?: string | null, role?: Role | null, title?: string | null, headline?: string | null, companyName?: string | null, influenceBadge?: { __typename?: 'AchievementBadge', key: string, name: string, description: string, family: AchievementFamily, tier: number, artworkUrl?: string | null } | null } | null };

export type VerifyEmailMutationVariables = Exact<{
  input: VerifyEmailInput;
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail: boolean };

export type ResendVerificationEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResendVerificationEmailMutation = { __typename?: 'Mutation', resendVerificationEmail: boolean };

export const CeCourseFieldsFragmentDoc = gql`
    fragment CeCourseFields on CeCourse {
  id
  libraryItemId
  url
  title
  description
  imageUrl
  provider
  instructors
  category
  format
  deliveryMode
  ceCredits
  price
  currency
  isFree
  publishedAt
  expiresAt
  startsAt
}
    `;
export const InfluenceBadgeFieldsFragmentDoc = gql`
    fragment InfluenceBadgeFields on AchievementBadge {
  key
  name
  description
  family
  tier
  artworkUrl
}
    `;
export const InfluenceProgressFieldsFragmentDoc = gql`
    fragment InfluenceProgressFields on AchievementProgressView {
  badge {
    ...InfluenceBadgeFields
  }
  progress
  target
  remaining
  unlocked
  unlockedAt
  expiresAt
}
    ${InfluenceBadgeFieldsFragmentDoc}`;
export const InfluenceProfileFieldsFragmentDoc = gql`
    fragment InfluenceProfileFields on InfluenceProfileView {
  userId
  lifetimeInfluence
  contributionCount
  postsCount
  periodKey
  monthlyInfluence
  monthlyRank
  tier {
    threshold
    badge {
      ...InfluenceBadgeFields
    }
  }
  nextTier {
    threshold
    badge {
      ...InfluenceBadgeFields
    }
  }
  selectedBadges {
    ...InfluenceBadgeFields
  }
  nameBadge {
    ...InfluenceBadgeFields
  }
  nextAchievement {
    ...InfluenceProgressFields
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}
${InfluenceProgressFieldsFragmentDoc}`;
export const LibraryContentCardFieldsFragmentDoc = gql`
    fragment LibraryContentCardFields on LibraryContentCard {
  contentType
  contentId
  title
  subtitle
  thumbnailUrl
  authorId
  authorName
  authorImageUrl
  provider
  publishedAt
  updatedAt
  slug
  externalUrl
  subKind
  details {
    description
    excerpt
    mediaUrls
    likesCount
    commentsCount
    playsCount
    category
    difficultyLevel
    language
    durationMinutes
    totalLectures
    averageRating
    totalRatings
    instructors
    ceCredits
    price
    currency
    isFree
    deliveryMode
    format
    startsAt
    expiresAt
    readingTimeMinutes
    durationSeconds
    mediaType
    isCurated
    location
    postId
    participantsCount
    priceType
  }
}
    `;
export const LibraryEntryFieldsFragmentDoc = gql`
    fragment LibraryEntryFields on LibraryEntryModel {
  id
  contentType
  contentId
  addedById
  addedByName
  addedAt
  availability
  mySavedItemId
  isFavorite
  content {
    ...LibraryContentCardFields
  }
}
    ${LibraryContentCardFieldsFragmentDoc}`;
export const LibraryFolderFieldsFragmentDoc = gql`
    fragment LibraryFolderFields on LibraryFolderModel {
  id
  name
  description
  parentId
  depth
  ownerId
  ownerName
  myRole
  myShareId
  isShared
  subfolderCount
  itemCount
  createdAt
  updatedAt
  deletedAt
  restorableUntil
}
    `;
export const LibraryCollectionFieldsFragmentDoc = gql`
    fragment LibraryCollectionFields on LibraryCollectionModel {
  id
  name
  description
  ownerId
  ownerName
  myRole
  myShareId
  isShared
  itemCount
  createdAt
  updatedAt
  deletedAt
  restorableUntil
}
    `;
export const LibraryItemFieldsFragmentDoc = gql`
    fragment LibraryItemFields on LibraryItemModel {
  id
  contentType
  contentId
  isFavorite
  savedAt
  availability
  content {
    ...LibraryContentCardFields
  }
  folders {
    id
    name
  }
  collections {
    id
    name
  }
  tags {
    id
    name
  }
  note {
    id
    body
    updatedAt
  }
}
    ${LibraryContentCardFieldsFragmentDoc}`;
export const LibrarySearchResultFieldsFragmentDoc = gql`
    fragment LibrarySearchResultFields on LibrarySearchResultModel {
  key
  contentType
  contentId
  availability
  date
  addedByName
  content {
    ...LibraryContentCardFields
  }
  savedItem {
    ...LibraryItemFields
  }
  locations {
    id
    name
    resourceType
    sharedByName
  }
}
    ${LibraryContentCardFieldsFragmentDoc}
${LibraryItemFieldsFragmentDoc}`;
export const LiveStreamListFieldsFragmentDoc = gql`
    fragment LiveStreamListFields on LiveStream {
  id
  roomId
  description
  status
  createdAt
  updatedAt
  isHostOnline
  user {
    id
    profileImageUrl
    firstName
    lastName
    title
    companyName
  }
}
    `;
export const PodcastEpisodeFieldsFragmentDoc = gql`
    fragment PodcastEpisodeFields on PodcastEpisodeModel {
  id
  libraryItemId
  userId
  title
  description
  category
  tags
  mediaType
  mediaUrl
  embedUrl
  provider
  sourceId
  isHidden
  blurHash
  coverImageUrl
  durationSeconds
  status
  playsCount
  likesCount
  commentsCount
  isLikedByMe
  createdAt
  updatedAt
  author {
    id
    name
    profileImageUrl
    organizationName
    influenceBadge {
      ...InfluenceBadgeFields
    }
    companyName
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;
export const PodcastSourceFieldsFragmentDoc = gql`
    fragment PodcastSourceFields on PodcastSourceModel {
  id
  userId
  provider
  name
  handle
  channelId
  url
  imageUrl
  isActive
  autoPublish
  lastSyncedAt
  lastSyncError
  createdAt
  updatedAt
}
    `;
export const PodcastReplyFieldsFragmentDoc = gql`
    fragment PodcastReplyFields on PodcastCommentModel {
  id
  episodeId
  content
  translatedContent
  parentId
  repliesCount
  likesCount
  isLikedByMe
  createdAt
  updatedAt
  user {
    id
    name
    profileImageUrl
    organizationName
    influenceBadge {
      ...InfluenceBadgeFields
    }
    companyName
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;
export const PodcastCommentFieldsFragmentDoc = gql`
    fragment PodcastCommentFields on PodcastCommentModel {
  id
  episodeId
  content
  translatedContent
  parentId
  repliesCount
  likesCount
  isLikedByMe
  createdAt
  updatedAt
  user {
    id
    name
    profileImageUrl
    organizationName
    influenceBadge {
      ...InfluenceBadgeFields
    }
    companyName
  }
  replies {
    ...PodcastReplyFields
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}
${PodcastReplyFieldsFragmentDoc}`;
export const PostBoostFieldsFragmentDoc = gql`
    fragment PostBoostFields on PostBoost {
  id
  postId
  userId
  status
  durationHours
  durationSeconds
  hourlyRateCents
  amountCents
  currency
  startsAt
  expiresAt
  remainingDurationSeconds
  paymentIntentId
  invoiceId
  impressions
  clicks
  ctr
  createdAt
  updatedAt
}
    `;
export const ProfileBoostFieldsFragmentDoc = gql`
    fragment ProfileBoostFields on ProfileBoost {
  id
  mentorId
  packId
  headline
  videoUrl
  status
  purchasedDurationSeconds
  remainingDurationSeconds
  consumedActiveSeconds
  activeSegmentStartedAt
  totalPaidCents
  currency
  hours
  hourlyRateCents
  startedAt
  completedAt
  endsAt
  impressions
  profileVisits
  clicks
  ctr
  createdAt
  updatedAt
}
    `;
export const StoryFieldsFragmentDoc = gql`
    fragment StoryFields on Story {
  id
  userId
  user {
    id
    firstName
    lastName
    title
    profileImageUrl
    companyName
  }
  content {
    id
    content
    caption
    type
    duration
    order
    createdAt
  }
  createdAt
  expiresAt
  viewCount
  isSeen
  reactions {
    reactionCounts {
      type
      count
    }
    totalReactions
    currentUserReaction
  }
}
    `;
export const SupportMessageFieldsFragmentDoc = gql`
    fragment SupportMessageFields on SupportMessage {
  id
  ticketId
  senderId
  senderType
  isInternal
  message
  createdAt
  sender {
    id
    firstName
    lastName
    profileImageUrl
  }
  attachments {
    id
    fileName
    fileUrl
    mimeType
    size
  }
}
    `;
export const SupportTicketRowFragmentDoc = gql`
    fragment SupportTicketRow on SupportTicket {
  id
  ticketNumber
  subject
  status
  priority
  source
  categoryId
  category {
    id
    name
    key
  }
  messageCount
  lastMessageAt
  lastMessagePreview
  createdAt
  updatedAt
  resolvedAt
  closedAt
  feedbackResolved
}
    `;
export const IsMentorVerifiedDocument = gql`
    query IsMentorVerified($mentorId: String!) {
  isMentorVerified(mentorId: $mentorId)
}
    `;

/**
 * __useIsMentorVerifiedQuery__
 *
 * To run a query within a React component, call `useIsMentorVerifiedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsMentorVerifiedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsMentorVerifiedQuery({
 *   variables: {
 *      mentorId: // value for 'mentorId'
 *   },
 * });
 */
export function useIsMentorVerifiedQuery(baseOptions: Apollo.QueryHookOptions<IsMentorVerifiedQuery, IsMentorVerifiedQueryVariables> & ({ variables: IsMentorVerifiedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsMentorVerifiedQuery, IsMentorVerifiedQueryVariables>(IsMentorVerifiedDocument, options);
      }
export function useIsMentorVerifiedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsMentorVerifiedQuery, IsMentorVerifiedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsMentorVerifiedQuery, IsMentorVerifiedQueryVariables>(IsMentorVerifiedDocument, options);
        }
// @ts-ignore
export function useIsMentorVerifiedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsMentorVerifiedQuery, IsMentorVerifiedQueryVariables>): Apollo.UseSuspenseQueryResult<IsMentorVerifiedQuery, IsMentorVerifiedQueryVariables>;
export function useIsMentorVerifiedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsMentorVerifiedQuery, IsMentorVerifiedQueryVariables>): Apollo.UseSuspenseQueryResult<IsMentorVerifiedQuery | undefined, IsMentorVerifiedQueryVariables>;
export function useIsMentorVerifiedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsMentorVerifiedQuery, IsMentorVerifiedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsMentorVerifiedQuery, IsMentorVerifiedQueryVariables>(IsMentorVerifiedDocument, options);
        }
export type IsMentorVerifiedQueryHookResult = ReturnType<typeof useIsMentorVerifiedQuery>;
export type IsMentorVerifiedLazyQueryHookResult = ReturnType<typeof useIsMentorVerifiedLazyQuery>;
export type IsMentorVerifiedSuspenseQueryHookResult = ReturnType<typeof useIsMentorVerifiedSuspenseQuery>;
export type IsMentorVerifiedQueryResult = Apollo.QueryResult<IsMentorVerifiedQuery, IsMentorVerifiedQueryVariables>;
export const AcceptSessionDocument = gql`
    mutation AcceptSession($sessionId: String!) {
  acceptBooking(sessionId: $sessionId)
}
    `;
export type AcceptSessionMutationFn = Apollo.MutationFunction<AcceptSessionMutation, AcceptSessionMutationVariables>;

/**
 * __useAcceptSessionMutation__
 *
 * To run a mutation, you first call `useAcceptSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptSessionMutation, { data, loading, error }] = useAcceptSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useAcceptSessionMutation(baseOptions?: Apollo.MutationHookOptions<AcceptSessionMutation, AcceptSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptSessionMutation, AcceptSessionMutationVariables>(AcceptSessionDocument, options);
      }
export type AcceptSessionMutationHookResult = ReturnType<typeof useAcceptSessionMutation>;
export type AcceptSessionMutationResult = Apollo.MutationResult<AcceptSessionMutation>;
export type AcceptSessionMutationOptions = Apollo.BaseMutationOptions<AcceptSessionMutation, AcceptSessionMutationVariables>;
export const AddActionButtonDocument = gql`
    mutation AddActionButton($input: AddActionButtonInput!) {
  addActionButton(input: $input)
}
    `;
export type AddActionButtonMutationFn = Apollo.MutationFunction<AddActionButtonMutation, AddActionButtonMutationVariables>;

/**
 * __useAddActionButtonMutation__
 *
 * To run a mutation, you first call `useAddActionButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddActionButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addActionButtonMutation, { data, loading, error }] = useAddActionButtonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddActionButtonMutation(baseOptions?: Apollo.MutationHookOptions<AddActionButtonMutation, AddActionButtonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddActionButtonMutation, AddActionButtonMutationVariables>(AddActionButtonDocument, options);
      }
export type AddActionButtonMutationHookResult = ReturnType<typeof useAddActionButtonMutation>;
export type AddActionButtonMutationResult = Apollo.MutationResult<AddActionButtonMutation>;
export type AddActionButtonMutationOptions = Apollo.BaseMutationOptions<AddActionButtonMutation, AddActionButtonMutationVariables>;
export const UpdateActionButtonDocument = gql`
    mutation UpdateActionButton($input: UpdateActionButtonInput!) {
  updateActionButton(input: $input)
}
    `;
export type UpdateActionButtonMutationFn = Apollo.MutationFunction<UpdateActionButtonMutation, UpdateActionButtonMutationVariables>;

/**
 * __useUpdateActionButtonMutation__
 *
 * To run a mutation, you first call `useUpdateActionButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActionButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActionButtonMutation, { data, loading, error }] = useUpdateActionButtonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActionButtonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActionButtonMutation, UpdateActionButtonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActionButtonMutation, UpdateActionButtonMutationVariables>(UpdateActionButtonDocument, options);
      }
export type UpdateActionButtonMutationHookResult = ReturnType<typeof useUpdateActionButtonMutation>;
export type UpdateActionButtonMutationResult = Apollo.MutationResult<UpdateActionButtonMutation>;
export type UpdateActionButtonMutationOptions = Apollo.BaseMutationOptions<UpdateActionButtonMutation, UpdateActionButtonMutationVariables>;
export const GetActionButtonsByUserIdDocument = gql`
    query GetActionButtonsByUserId($userId: String!) {
  getActionButtonsByUserId(userId: $userId) {
    id
    userId
    companyId
    name
    url
    isShow
    createdAt
  }
}
    `;

/**
 * __useGetActionButtonsByUserIdQuery__
 *
 * To run a query within a React component, call `useGetActionButtonsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionButtonsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionButtonsByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetActionButtonsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetActionButtonsByUserIdQuery, GetActionButtonsByUserIdQueryVariables> & ({ variables: GetActionButtonsByUserIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionButtonsByUserIdQuery, GetActionButtonsByUserIdQueryVariables>(GetActionButtonsByUserIdDocument, options);
      }
export function useGetActionButtonsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActionButtonsByUserIdQuery, GetActionButtonsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionButtonsByUserIdQuery, GetActionButtonsByUserIdQueryVariables>(GetActionButtonsByUserIdDocument, options);
        }
// @ts-ignore
export function useGetActionButtonsByUserIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActionButtonsByUserIdQuery, GetActionButtonsByUserIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetActionButtonsByUserIdQuery, GetActionButtonsByUserIdQueryVariables>;
export function useGetActionButtonsByUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActionButtonsByUserIdQuery, GetActionButtonsByUserIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetActionButtonsByUserIdQuery | undefined, GetActionButtonsByUserIdQueryVariables>;
export function useGetActionButtonsByUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActionButtonsByUserIdQuery, GetActionButtonsByUserIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActionButtonsByUserIdQuery, GetActionButtonsByUserIdQueryVariables>(GetActionButtonsByUserIdDocument, options);
        }
export type GetActionButtonsByUserIdQueryHookResult = ReturnType<typeof useGetActionButtonsByUserIdQuery>;
export type GetActionButtonsByUserIdLazyQueryHookResult = ReturnType<typeof useGetActionButtonsByUserIdLazyQuery>;
export type GetActionButtonsByUserIdSuspenseQueryHookResult = ReturnType<typeof useGetActionButtonsByUserIdSuspenseQuery>;
export type GetActionButtonsByUserIdQueryResult = Apollo.QueryResult<GetActionButtonsByUserIdQuery, GetActionButtonsByUserIdQueryVariables>;
export const GetActionButtonByCompanyIdDocument = gql`
    query GetActionButtonByCompanyId($companyId: String!) {
  getActionButtonByCompanyId(companyId: $companyId) {
    id
    userId
    companyId
    name
    url
    isShow
    createdAt
  }
}
    `;

/**
 * __useGetActionButtonByCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetActionButtonByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionButtonByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionButtonByCompanyIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetActionButtonByCompanyIdQuery(baseOptions: Apollo.QueryHookOptions<GetActionButtonByCompanyIdQuery, GetActionButtonByCompanyIdQueryVariables> & ({ variables: GetActionButtonByCompanyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionButtonByCompanyIdQuery, GetActionButtonByCompanyIdQueryVariables>(GetActionButtonByCompanyIdDocument, options);
      }
export function useGetActionButtonByCompanyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActionButtonByCompanyIdQuery, GetActionButtonByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionButtonByCompanyIdQuery, GetActionButtonByCompanyIdQueryVariables>(GetActionButtonByCompanyIdDocument, options);
        }
// @ts-ignore
export function useGetActionButtonByCompanyIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActionButtonByCompanyIdQuery, GetActionButtonByCompanyIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetActionButtonByCompanyIdQuery, GetActionButtonByCompanyIdQueryVariables>;
export function useGetActionButtonByCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActionButtonByCompanyIdQuery, GetActionButtonByCompanyIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetActionButtonByCompanyIdQuery | undefined, GetActionButtonByCompanyIdQueryVariables>;
export function useGetActionButtonByCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActionButtonByCompanyIdQuery, GetActionButtonByCompanyIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActionButtonByCompanyIdQuery, GetActionButtonByCompanyIdQueryVariables>(GetActionButtonByCompanyIdDocument, options);
        }
export type GetActionButtonByCompanyIdQueryHookResult = ReturnType<typeof useGetActionButtonByCompanyIdQuery>;
export type GetActionButtonByCompanyIdLazyQueryHookResult = ReturnType<typeof useGetActionButtonByCompanyIdLazyQuery>;
export type GetActionButtonByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useGetActionButtonByCompanyIdSuspenseQuery>;
export type GetActionButtonByCompanyIdQueryResult = Apollo.QueryResult<GetActionButtonByCompanyIdQuery, GetActionButtonByCompanyIdQueryVariables>;
export const GetAllImagesByUserDocument = gql`
    query GetAllImagesByUser($userId: String!, $page: Int = 1, $limit: Int = 10) {
  getAllImagesByUser(userId: $userId, page: $page, limit: $limit) {
    id
    fileUrl
    postId
    createdAt
  }
}
    `;

/**
 * __useGetAllImagesByUserQuery__
 *
 * To run a query within a React component, call `useGetAllImagesByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllImagesByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllImagesByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAllImagesByUserQuery(baseOptions: Apollo.QueryHookOptions<GetAllImagesByUserQuery, GetAllImagesByUserQueryVariables> & ({ variables: GetAllImagesByUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllImagesByUserQuery, GetAllImagesByUserQueryVariables>(GetAllImagesByUserDocument, options);
      }
export function useGetAllImagesByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllImagesByUserQuery, GetAllImagesByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllImagesByUserQuery, GetAllImagesByUserQueryVariables>(GetAllImagesByUserDocument, options);
        }
// @ts-ignore
export function useGetAllImagesByUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllImagesByUserQuery, GetAllImagesByUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllImagesByUserQuery, GetAllImagesByUserQueryVariables>;
export function useGetAllImagesByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllImagesByUserQuery, GetAllImagesByUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllImagesByUserQuery | undefined, GetAllImagesByUserQueryVariables>;
export function useGetAllImagesByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllImagesByUserQuery, GetAllImagesByUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllImagesByUserQuery, GetAllImagesByUserQueryVariables>(GetAllImagesByUserDocument, options);
        }
export type GetAllImagesByUserQueryHookResult = ReturnType<typeof useGetAllImagesByUserQuery>;
export type GetAllImagesByUserLazyQueryHookResult = ReturnType<typeof useGetAllImagesByUserLazyQuery>;
export type GetAllImagesByUserSuspenseQueryHookResult = ReturnType<typeof useGetAllImagesByUserSuspenseQuery>;
export type GetAllImagesByUserQueryResult = Apollo.QueryResult<GetAllImagesByUserQuery, GetAllImagesByUserQueryVariables>;
export const GetAllVideosByUserDocument = gql`
    query GetAllVideosByUser($userId: String!, $page: Int = 1, $limit: Int = 10) {
  getAllVideosByUser(userId: $userId, page: $page, limit: $limit) {
    id
    fileUrl
    postId
    createdAt
  }
}
    `;

/**
 * __useGetAllVideosByUserQuery__
 *
 * To run a query within a React component, call `useGetAllVideosByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllVideosByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllVideosByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAllVideosByUserQuery(baseOptions: Apollo.QueryHookOptions<GetAllVideosByUserQuery, GetAllVideosByUserQueryVariables> & ({ variables: GetAllVideosByUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllVideosByUserQuery, GetAllVideosByUserQueryVariables>(GetAllVideosByUserDocument, options);
      }
export function useGetAllVideosByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllVideosByUserQuery, GetAllVideosByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllVideosByUserQuery, GetAllVideosByUserQueryVariables>(GetAllVideosByUserDocument, options);
        }
// @ts-ignore
export function useGetAllVideosByUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllVideosByUserQuery, GetAllVideosByUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllVideosByUserQuery, GetAllVideosByUserQueryVariables>;
export function useGetAllVideosByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllVideosByUserQuery, GetAllVideosByUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllVideosByUserQuery | undefined, GetAllVideosByUserQueryVariables>;
export function useGetAllVideosByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllVideosByUserQuery, GetAllVideosByUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllVideosByUserQuery, GetAllVideosByUserQueryVariables>(GetAllVideosByUserDocument, options);
        }
export type GetAllVideosByUserQueryHookResult = ReturnType<typeof useGetAllVideosByUserQuery>;
export type GetAllVideosByUserLazyQueryHookResult = ReturnType<typeof useGetAllVideosByUserLazyQuery>;
export type GetAllVideosByUserSuspenseQueryHookResult = ReturnType<typeof useGetAllVideosByUserSuspenseQuery>;
export type GetAllVideosByUserQueryResult = Apollo.QueryResult<GetAllVideosByUserQuery, GetAllVideosByUserQueryVariables>;
export const GetAllCommentsByUserPostsDocument = gql`
    query GetAllCommentsByUserPosts($userId: String!, $page: Int = 1, $limit: Int = 10) {
  getAllCommentsByUserPosts(userId: $userId, page: $page, limit: $limit) {
    id
    postId
    userId
    content
    translatedContent
    mediaUrls
    createdAt
    updatedAt
    user {
      id
      firstName
      lastName
      title
      companyName
    }
  }
}
    `;

/**
 * __useGetAllCommentsByUserPostsQuery__
 *
 * To run a query within a React component, call `useGetAllCommentsByUserPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCommentsByUserPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCommentsByUserPostsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAllCommentsByUserPostsQuery(baseOptions: Apollo.QueryHookOptions<GetAllCommentsByUserPostsQuery, GetAllCommentsByUserPostsQueryVariables> & ({ variables: GetAllCommentsByUserPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCommentsByUserPostsQuery, GetAllCommentsByUserPostsQueryVariables>(GetAllCommentsByUserPostsDocument, options);
      }
export function useGetAllCommentsByUserPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCommentsByUserPostsQuery, GetAllCommentsByUserPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCommentsByUserPostsQuery, GetAllCommentsByUserPostsQueryVariables>(GetAllCommentsByUserPostsDocument, options);
        }
// @ts-ignore
export function useGetAllCommentsByUserPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllCommentsByUserPostsQuery, GetAllCommentsByUserPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCommentsByUserPostsQuery, GetAllCommentsByUserPostsQueryVariables>;
export function useGetAllCommentsByUserPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCommentsByUserPostsQuery, GetAllCommentsByUserPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCommentsByUserPostsQuery | undefined, GetAllCommentsByUserPostsQueryVariables>;
export function useGetAllCommentsByUserPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCommentsByUserPostsQuery, GetAllCommentsByUserPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCommentsByUserPostsQuery, GetAllCommentsByUserPostsQueryVariables>(GetAllCommentsByUserPostsDocument, options);
        }
export type GetAllCommentsByUserPostsQueryHookResult = ReturnType<typeof useGetAllCommentsByUserPostsQuery>;
export type GetAllCommentsByUserPostsLazyQueryHookResult = ReturnType<typeof useGetAllCommentsByUserPostsLazyQuery>;
export type GetAllCommentsByUserPostsSuspenseQueryHookResult = ReturnType<typeof useGetAllCommentsByUserPostsSuspenseQuery>;
export type GetAllCommentsByUserPostsQueryResult = Apollo.QueryResult<GetAllCommentsByUserPostsQuery, GetAllCommentsByUserPostsQueryVariables>;
export const CreateCampaignDocument = gql`
    mutation CreateCampaign($input: CreateCampaignInput!) {
  createCampaign(input: $input) {
    id
    name
    objective
    status
    purchasedDurationSeconds
    remainingDurationSeconds
    totalPaidCents
    adFormat
    headline
    description
    mediaUrls
    ctaText
    ctaUrl
    targetRoles
    targetSpecializations
    targetLocations
    targetExperienceLevels
    targetEducationLevels
    targetCompanyTypes
    impressions
    clicks
    createdAt
    updatedAt
    user {
      id
      firstName
      lastName
      title
      organizationName
      role
      companyName
    }
  }
}
    `;
export type CreateCampaignMutationFn = Apollo.MutationFunction<CreateCampaignMutation, CreateCampaignMutationVariables>;

/**
 * __useCreateCampaignMutation__
 *
 * To run a mutation, you first call `useCreateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignMutation, { data, loading, error }] = useCreateCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignMutation, CreateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignMutation, CreateCampaignMutationVariables>(CreateCampaignDocument, options);
      }
export type CreateCampaignMutationHookResult = ReturnType<typeof useCreateCampaignMutation>;
export type CreateCampaignMutationResult = Apollo.MutationResult<CreateCampaignMutation>;
export type CreateCampaignMutationOptions = Apollo.BaseMutationOptions<CreateCampaignMutation, CreateCampaignMutationVariables>;
export const UpdateCampaignDocument = gql`
    mutation UpdateCampaign($input: UpdateCampaignInput!) {
  updateCampaign(input: $input) {
    id
    name
    objective
    status
    purchasedDurationSeconds
    remainingDurationSeconds
    headline
    description
    mediaUrls
    ctaText
    ctaUrl
    updatedAt
  }
}
    `;
export type UpdateCampaignMutationFn = Apollo.MutationFunction<UpdateCampaignMutation, UpdateCampaignMutationVariables>;

/**
 * __useUpdateCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignMutation, { data, loading, error }] = useUpdateCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignMutation, UpdateCampaignMutationVariables>(UpdateCampaignDocument, options);
      }
export type UpdateCampaignMutationHookResult = ReturnType<typeof useUpdateCampaignMutation>;
export type UpdateCampaignMutationResult = Apollo.MutationResult<UpdateCampaignMutation>;
export type UpdateCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>;
export const DeleteCampaignDocument = gql`
    mutation DeleteCampaign($campaignId: ID!) {
  deleteCampaign(campaignId: $campaignId)
}
    `;
export type DeleteCampaignMutationFn = Apollo.MutationFunction<DeleteCampaignMutation, DeleteCampaignMutationVariables>;

/**
 * __useDeleteCampaignMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignMutation, { data, loading, error }] = useDeleteCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useDeleteCampaignMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampaignMutation, DeleteCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampaignMutation, DeleteCampaignMutationVariables>(DeleteCampaignDocument, options);
      }
export type DeleteCampaignMutationHookResult = ReturnType<typeof useDeleteCampaignMutation>;
export type DeleteCampaignMutationResult = Apollo.MutationResult<DeleteCampaignMutation>;
export type DeleteCampaignMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignMutation, DeleteCampaignMutationVariables>;
export const CancelCampaignDocument = gql`
    mutation CancelCampaign($campaignId: ID!) {
  cancelCampaign(campaignId: $campaignId) {
    id
    status
  }
}
    `;
export type CancelCampaignMutationFn = Apollo.MutationFunction<CancelCampaignMutation, CancelCampaignMutationVariables>;

/**
 * __useCancelCampaignMutation__
 *
 * To run a mutation, you first call `useCancelCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCampaignMutation, { data, loading, error }] = useCancelCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCancelCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CancelCampaignMutation, CancelCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelCampaignMutation, CancelCampaignMutationVariables>(CancelCampaignDocument, options);
      }
export type CancelCampaignMutationHookResult = ReturnType<typeof useCancelCampaignMutation>;
export type CancelCampaignMutationResult = Apollo.MutationResult<CancelCampaignMutation>;
export type CancelCampaignMutationOptions = Apollo.BaseMutationOptions<CancelCampaignMutation, CancelCampaignMutationVariables>;
export const PauseCampaignDocument = gql`
    mutation PauseCampaign($campaignId: ID!) {
  pauseCampaign(campaignId: $campaignId) {
    id
    status
    remainingDurationSeconds
  }
}
    `;
export type PauseCampaignMutationFn = Apollo.MutationFunction<PauseCampaignMutation, PauseCampaignMutationVariables>;

/**
 * __usePauseCampaignMutation__
 *
 * To run a mutation, you first call `usePauseCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseCampaignMutation, { data, loading, error }] = usePauseCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function usePauseCampaignMutation(baseOptions?: Apollo.MutationHookOptions<PauseCampaignMutation, PauseCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseCampaignMutation, PauseCampaignMutationVariables>(PauseCampaignDocument, options);
      }
export type PauseCampaignMutationHookResult = ReturnType<typeof usePauseCampaignMutation>;
export type PauseCampaignMutationResult = Apollo.MutationResult<PauseCampaignMutation>;
export type PauseCampaignMutationOptions = Apollo.BaseMutationOptions<PauseCampaignMutation, PauseCampaignMutationVariables>;
export const ResumeCampaignDocument = gql`
    mutation ResumeCampaign($campaignId: ID!) {
  resumeCampaign(campaignId: $campaignId) {
    id
    status
    remainingDurationSeconds
  }
}
    `;
export type ResumeCampaignMutationFn = Apollo.MutationFunction<ResumeCampaignMutation, ResumeCampaignMutationVariables>;

/**
 * __useResumeCampaignMutation__
 *
 * To run a mutation, you first call `useResumeCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeCampaignMutation, { data, loading, error }] = useResumeCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useResumeCampaignMutation(baseOptions?: Apollo.MutationHookOptions<ResumeCampaignMutation, ResumeCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeCampaignMutation, ResumeCampaignMutationVariables>(ResumeCampaignDocument, options);
      }
export type ResumeCampaignMutationHookResult = ReturnType<typeof useResumeCampaignMutation>;
export type ResumeCampaignMutationResult = Apollo.MutationResult<ResumeCampaignMutation>;
export type ResumeCampaignMutationOptions = Apollo.BaseMutationOptions<ResumeCampaignMutation, ResumeCampaignMutationVariables>;
export const InitializeCampaignPaymentDocument = gql`
    mutation InitializeCampaignPayment($campaignId: ID!, $durationHours: Float, $durationDays: Int) {
  initializeCampaignPayment(
    campaignId: $campaignId
    durationHours: $durationHours
    durationDays: $durationDays
  ) {
    clientSecret
    paymentIntentId
    amountCents
    hourlyRateCents
    durationSeconds
    publishableKey
    purchaseId
  }
}
    `;
export type InitializeCampaignPaymentMutationFn = Apollo.MutationFunction<InitializeCampaignPaymentMutation, InitializeCampaignPaymentMutationVariables>;

/**
 * __useInitializeCampaignPaymentMutation__
 *
 * To run a mutation, you first call `useInitializeCampaignPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeCampaignPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeCampaignPaymentMutation, { data, loading, error }] = useInitializeCampaignPaymentMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      durationHours: // value for 'durationHours'
 *      durationDays: // value for 'durationDays'
 *   },
 * });
 */
export function useInitializeCampaignPaymentMutation(baseOptions?: Apollo.MutationHookOptions<InitializeCampaignPaymentMutation, InitializeCampaignPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitializeCampaignPaymentMutation, InitializeCampaignPaymentMutationVariables>(InitializeCampaignPaymentDocument, options);
      }
export type InitializeCampaignPaymentMutationHookResult = ReturnType<typeof useInitializeCampaignPaymentMutation>;
export type InitializeCampaignPaymentMutationResult = Apollo.MutationResult<InitializeCampaignPaymentMutation>;
export type InitializeCampaignPaymentMutationOptions = Apollo.BaseMutationOptions<InitializeCampaignPaymentMutation, InitializeCampaignPaymentMutationVariables>;
export const ConfirmCampaignPaymentDocument = gql`
    mutation ConfirmCampaignPayment($paymentIntentId: String!) {
  confirmCampaignPayment(paymentIntentId: $paymentIntentId) {
    id
    status
    submittedAt
  }
}
    `;
export type ConfirmCampaignPaymentMutationFn = Apollo.MutationFunction<ConfirmCampaignPaymentMutation, ConfirmCampaignPaymentMutationVariables>;

/**
 * __useConfirmCampaignPaymentMutation__
 *
 * To run a mutation, you first call `useConfirmCampaignPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmCampaignPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmCampaignPaymentMutation, { data, loading, error }] = useConfirmCampaignPaymentMutation({
 *   variables: {
 *      paymentIntentId: // value for 'paymentIntentId'
 *   },
 * });
 */
export function useConfirmCampaignPaymentMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmCampaignPaymentMutation, ConfirmCampaignPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmCampaignPaymentMutation, ConfirmCampaignPaymentMutationVariables>(ConfirmCampaignPaymentDocument, options);
      }
export type ConfirmCampaignPaymentMutationHookResult = ReturnType<typeof useConfirmCampaignPaymentMutation>;
export type ConfirmCampaignPaymentMutationResult = Apollo.MutationResult<ConfirmCampaignPaymentMutation>;
export type ConfirmCampaignPaymentMutationOptions = Apollo.BaseMutationOptions<ConfirmCampaignPaymentMutation, ConfirmCampaignPaymentMutationVariables>;
export const InitializeCampaignExtensionDocument = gql`
    mutation InitializeCampaignExtension($campaignId: ID!, $durationHours: Float, $durationDays: Int) {
  initializeCampaignExtension(
    campaignId: $campaignId
    durationHours: $durationHours
    durationDays: $durationDays
  ) {
    clientSecret
    paymentIntentId
    amountCents
    hourlyRateCents
    durationSeconds
    publishableKey
    purchaseId
  }
}
    `;
export type InitializeCampaignExtensionMutationFn = Apollo.MutationFunction<InitializeCampaignExtensionMutation, InitializeCampaignExtensionMutationVariables>;

/**
 * __useInitializeCampaignExtensionMutation__
 *
 * To run a mutation, you first call `useInitializeCampaignExtensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeCampaignExtensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeCampaignExtensionMutation, { data, loading, error }] = useInitializeCampaignExtensionMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      durationHours: // value for 'durationHours'
 *      durationDays: // value for 'durationDays'
 *   },
 * });
 */
export function useInitializeCampaignExtensionMutation(baseOptions?: Apollo.MutationHookOptions<InitializeCampaignExtensionMutation, InitializeCampaignExtensionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitializeCampaignExtensionMutation, InitializeCampaignExtensionMutationVariables>(InitializeCampaignExtensionDocument, options);
      }
export type InitializeCampaignExtensionMutationHookResult = ReturnType<typeof useInitializeCampaignExtensionMutation>;
export type InitializeCampaignExtensionMutationResult = Apollo.MutationResult<InitializeCampaignExtensionMutation>;
export type InitializeCampaignExtensionMutationOptions = Apollo.BaseMutationOptions<InitializeCampaignExtensionMutation, InitializeCampaignExtensionMutationVariables>;
export const ConfirmCampaignExtensionDocument = gql`
    mutation ConfirmCampaignExtension($paymentIntentId: String!) {
  confirmCampaignExtension(paymentIntentId: $paymentIntentId) {
    id
    remainingDurationSeconds
    purchasedDurationSeconds
    totalPaidCents
  }
}
    `;
export type ConfirmCampaignExtensionMutationFn = Apollo.MutationFunction<ConfirmCampaignExtensionMutation, ConfirmCampaignExtensionMutationVariables>;

/**
 * __useConfirmCampaignExtensionMutation__
 *
 * To run a mutation, you first call `useConfirmCampaignExtensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmCampaignExtensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmCampaignExtensionMutation, { data, loading, error }] = useConfirmCampaignExtensionMutation({
 *   variables: {
 *      paymentIntentId: // value for 'paymentIntentId'
 *   },
 * });
 */
export function useConfirmCampaignExtensionMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmCampaignExtensionMutation, ConfirmCampaignExtensionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmCampaignExtensionMutation, ConfirmCampaignExtensionMutationVariables>(ConfirmCampaignExtensionDocument, options);
      }
export type ConfirmCampaignExtensionMutationHookResult = ReturnType<typeof useConfirmCampaignExtensionMutation>;
export type ConfirmCampaignExtensionMutationResult = Apollo.MutationResult<ConfirmCampaignExtensionMutation>;
export type ConfirmCampaignExtensionMutationOptions = Apollo.BaseMutationOptions<ConfirmCampaignExtensionMutation, ConfirmCampaignExtensionMutationVariables>;
export const RecordAdClickDocument = gql`
    mutation RecordAdClick($campaignId: ID!) {
  recordAdClick(campaignId: $campaignId)
}
    `;
export type RecordAdClickMutationFn = Apollo.MutationFunction<RecordAdClickMutation, RecordAdClickMutationVariables>;

/**
 * __useRecordAdClickMutation__
 *
 * To run a mutation, you first call `useRecordAdClickMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordAdClickMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordAdClickMutation, { data, loading, error }] = useRecordAdClickMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useRecordAdClickMutation(baseOptions?: Apollo.MutationHookOptions<RecordAdClickMutation, RecordAdClickMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordAdClickMutation, RecordAdClickMutationVariables>(RecordAdClickDocument, options);
      }
export type RecordAdClickMutationHookResult = ReturnType<typeof useRecordAdClickMutation>;
export type RecordAdClickMutationResult = Apollo.MutationResult<RecordAdClickMutation>;
export type RecordAdClickMutationOptions = Apollo.BaseMutationOptions<RecordAdClickMutation, RecordAdClickMutationVariables>;
export const RecordAdImpressionDocument = gql`
    mutation RecordAdImpression($campaignId: ID!, $placement: AdPlacement) {
  recordAdImpression(campaignId: $campaignId, placement: $placement)
}
    `;
export type RecordAdImpressionMutationFn = Apollo.MutationFunction<RecordAdImpressionMutation, RecordAdImpressionMutationVariables>;

/**
 * __useRecordAdImpressionMutation__
 *
 * To run a mutation, you first call `useRecordAdImpressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordAdImpressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordAdImpressionMutation, { data, loading, error }] = useRecordAdImpressionMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      placement: // value for 'placement'
 *   },
 * });
 */
export function useRecordAdImpressionMutation(baseOptions?: Apollo.MutationHookOptions<RecordAdImpressionMutation, RecordAdImpressionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordAdImpressionMutation, RecordAdImpressionMutationVariables>(RecordAdImpressionDocument, options);
      }
export type RecordAdImpressionMutationHookResult = ReturnType<typeof useRecordAdImpressionMutation>;
export type RecordAdImpressionMutationResult = Apollo.MutationResult<RecordAdImpressionMutation>;
export type RecordAdImpressionMutationOptions = Apollo.BaseMutationOptions<RecordAdImpressionMutation, RecordAdImpressionMutationVariables>;
export const MyCampaignsDocument = gql`
    query MyCampaigns($page: Int, $limit: Int, $status: CampaignStatus) {
  myCampaigns(page: $page, limit: $limit, status: $status) {
    data {
      id
      name
      source
      objective
      status
      purchasedDurationSeconds
      remainingDurationSeconds
      consumedActiveSeconds
      totalPaidCents
      amountPaid
      impressions
      clicks
      ctr
      adFormat
      mediaUrls
      targetRoles
      targetSpecializations
      createdAt
      updatedAt
      submittedAt
      approvedAt
      startedAt
      completedAt
      rejectedAt
      user {
        id
        firstName
        lastName
        title
        organizationName
        role
        companyName
      }
    }
    total
    page
    limit
    totalPages
    hasMore
  }
}
    `;

/**
 * __useMyCampaignsQuery__
 *
 * To run a query within a React component, call `useMyCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCampaignsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useMyCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<MyCampaignsQuery, MyCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCampaignsQuery, MyCampaignsQueryVariables>(MyCampaignsDocument, options);
      }
export function useMyCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCampaignsQuery, MyCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCampaignsQuery, MyCampaignsQueryVariables>(MyCampaignsDocument, options);
        }
// @ts-ignore
export function useMyCampaignsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyCampaignsQuery, MyCampaignsQueryVariables>): Apollo.UseSuspenseQueryResult<MyCampaignsQuery, MyCampaignsQueryVariables>;
export function useMyCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyCampaignsQuery, MyCampaignsQueryVariables>): Apollo.UseSuspenseQueryResult<MyCampaignsQuery | undefined, MyCampaignsQueryVariables>;
export function useMyCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyCampaignsQuery, MyCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyCampaignsQuery, MyCampaignsQueryVariables>(MyCampaignsDocument, options);
        }
export type MyCampaignsQueryHookResult = ReturnType<typeof useMyCampaignsQuery>;
export type MyCampaignsLazyQueryHookResult = ReturnType<typeof useMyCampaignsLazyQuery>;
export type MyCampaignsSuspenseQueryHookResult = ReturnType<typeof useMyCampaignsSuspenseQuery>;
export type MyCampaignsQueryResult = Apollo.QueryResult<MyCampaignsQuery, MyCampaignsQueryVariables>;
export const CampaignByIdDocument = gql`
    query CampaignById($campaignId: ID!) {
  campaignById(campaignId: $campaignId) {
    id
    name
    source
    objective
    status
    targetRoles
    targetSpecializations
    targetLocations
    targetExperienceLevels
    targetEducationLevels
    targetCompanyTypes
    purchasedDurationSeconds
    remainingDurationSeconds
    consumedActiveSeconds
    totalPaidCents
    amountPaid
    adFormat
    headline
    description
    mediaUrls
    ctaText
    ctaUrl
    impressions
    clicks
    ctr
    reviewedBy
    reviewedAt
    rejectionReason
    submittedAt
    approvedAt
    startedAt
    completedAt
    rejectedAt
    refundedAt
    createdAt
    updatedAt
    user {
      id
      firstName
      lastName
      title
      organizationName
      role
      city
      state
      profileImageUrl
      companyName
    }
  }
}
    `;

/**
 * __useCampaignByIdQuery__
 *
 * To run a query within a React component, call `useCampaignByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignByIdQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignByIdQuery(baseOptions: Apollo.QueryHookOptions<CampaignByIdQuery, CampaignByIdQueryVariables> & ({ variables: CampaignByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignByIdQuery, CampaignByIdQueryVariables>(CampaignByIdDocument, options);
      }
export function useCampaignByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignByIdQuery, CampaignByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignByIdQuery, CampaignByIdQueryVariables>(CampaignByIdDocument, options);
        }
// @ts-ignore
export function useCampaignByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampaignByIdQuery, CampaignByIdQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignByIdQuery, CampaignByIdQueryVariables>;
export function useCampaignByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignByIdQuery, CampaignByIdQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignByIdQuery | undefined, CampaignByIdQueryVariables>;
export function useCampaignByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignByIdQuery, CampaignByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignByIdQuery, CampaignByIdQueryVariables>(CampaignByIdDocument, options);
        }
export type CampaignByIdQueryHookResult = ReturnType<typeof useCampaignByIdQuery>;
export type CampaignByIdLazyQueryHookResult = ReturnType<typeof useCampaignByIdLazyQuery>;
export type CampaignByIdSuspenseQueryHookResult = ReturnType<typeof useCampaignByIdSuspenseQuery>;
export type CampaignByIdQueryResult = Apollo.QueryResult<CampaignByIdQuery, CampaignByIdQueryVariables>;
export const MyCampaignStatsDocument = gql`
    query MyCampaignStats {
  myCampaignStats {
    totalCampaigns
    activeCampaigns
    pausedCampaigns
    draftCampaigns
    pendingApprovalCampaigns
    completedCampaigns
    totalImpressions
    totalClicks
    ctr
  }
}
    `;

/**
 * __useMyCampaignStatsQuery__
 *
 * To run a query within a React component, call `useMyCampaignStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCampaignStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCampaignStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCampaignStatsQuery(baseOptions?: Apollo.QueryHookOptions<MyCampaignStatsQuery, MyCampaignStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCampaignStatsQuery, MyCampaignStatsQueryVariables>(MyCampaignStatsDocument, options);
      }
export function useMyCampaignStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCampaignStatsQuery, MyCampaignStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCampaignStatsQuery, MyCampaignStatsQueryVariables>(MyCampaignStatsDocument, options);
        }
// @ts-ignore
export function useMyCampaignStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyCampaignStatsQuery, MyCampaignStatsQueryVariables>): Apollo.UseSuspenseQueryResult<MyCampaignStatsQuery, MyCampaignStatsQueryVariables>;
export function useMyCampaignStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyCampaignStatsQuery, MyCampaignStatsQueryVariables>): Apollo.UseSuspenseQueryResult<MyCampaignStatsQuery | undefined, MyCampaignStatsQueryVariables>;
export function useMyCampaignStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyCampaignStatsQuery, MyCampaignStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyCampaignStatsQuery, MyCampaignStatsQueryVariables>(MyCampaignStatsDocument, options);
        }
export type MyCampaignStatsQueryHookResult = ReturnType<typeof useMyCampaignStatsQuery>;
export type MyCampaignStatsLazyQueryHookResult = ReturnType<typeof useMyCampaignStatsLazyQuery>;
export type MyCampaignStatsSuspenseQueryHookResult = ReturnType<typeof useMyCampaignStatsSuspenseQuery>;
export type MyCampaignStatsQueryResult = Apollo.QueryResult<MyCampaignStatsQuery, MyCampaignStatsQueryVariables>;
export const MyCampaignChartDataDocument = gql`
    query MyCampaignChartData($range: String) {
  myCampaignChartData(range: $range) {
    categories
    impressions
    clicks
  }
}
    `;

/**
 * __useMyCampaignChartDataQuery__
 *
 * To run a query within a React component, call `useMyCampaignChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCampaignChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCampaignChartDataQuery({
 *   variables: {
 *      range: // value for 'range'
 *   },
 * });
 */
export function useMyCampaignChartDataQuery(baseOptions?: Apollo.QueryHookOptions<MyCampaignChartDataQuery, MyCampaignChartDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCampaignChartDataQuery, MyCampaignChartDataQueryVariables>(MyCampaignChartDataDocument, options);
      }
export function useMyCampaignChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCampaignChartDataQuery, MyCampaignChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCampaignChartDataQuery, MyCampaignChartDataQueryVariables>(MyCampaignChartDataDocument, options);
        }
// @ts-ignore
export function useMyCampaignChartDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyCampaignChartDataQuery, MyCampaignChartDataQueryVariables>): Apollo.UseSuspenseQueryResult<MyCampaignChartDataQuery, MyCampaignChartDataQueryVariables>;
export function useMyCampaignChartDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyCampaignChartDataQuery, MyCampaignChartDataQueryVariables>): Apollo.UseSuspenseQueryResult<MyCampaignChartDataQuery | undefined, MyCampaignChartDataQueryVariables>;
export function useMyCampaignChartDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyCampaignChartDataQuery, MyCampaignChartDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyCampaignChartDataQuery, MyCampaignChartDataQueryVariables>(MyCampaignChartDataDocument, options);
        }
export type MyCampaignChartDataQueryHookResult = ReturnType<typeof useMyCampaignChartDataQuery>;
export type MyCampaignChartDataLazyQueryHookResult = ReturnType<typeof useMyCampaignChartDataLazyQuery>;
export type MyCampaignChartDataSuspenseQueryHookResult = ReturnType<typeof useMyCampaignChartDataSuspenseQuery>;
export type MyCampaignChartDataQueryResult = Apollo.QueryResult<MyCampaignChartDataQuery, MyCampaignChartDataQueryVariables>;
export const CampaignDailyStatsDocument = gql`
    query CampaignDailyStats($campaignId: ID!) {
  campaignDailyStats(campaignId: $campaignId) {
    categories
    impressions
    clicks
  }
}
    `;

/**
 * __useCampaignDailyStatsQuery__
 *
 * To run a query within a React component, call `useCampaignDailyStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignDailyStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignDailyStatsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignDailyStatsQuery(baseOptions: Apollo.QueryHookOptions<CampaignDailyStatsQuery, CampaignDailyStatsQueryVariables> & ({ variables: CampaignDailyStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignDailyStatsQuery, CampaignDailyStatsQueryVariables>(CampaignDailyStatsDocument, options);
      }
export function useCampaignDailyStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignDailyStatsQuery, CampaignDailyStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignDailyStatsQuery, CampaignDailyStatsQueryVariables>(CampaignDailyStatsDocument, options);
        }
// @ts-ignore
export function useCampaignDailyStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampaignDailyStatsQuery, CampaignDailyStatsQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignDailyStatsQuery, CampaignDailyStatsQueryVariables>;
export function useCampaignDailyStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignDailyStatsQuery, CampaignDailyStatsQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignDailyStatsQuery | undefined, CampaignDailyStatsQueryVariables>;
export function useCampaignDailyStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignDailyStatsQuery, CampaignDailyStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignDailyStatsQuery, CampaignDailyStatsQueryVariables>(CampaignDailyStatsDocument, options);
        }
export type CampaignDailyStatsQueryHookResult = ReturnType<typeof useCampaignDailyStatsQuery>;
export type CampaignDailyStatsLazyQueryHookResult = ReturnType<typeof useCampaignDailyStatsLazyQuery>;
export type CampaignDailyStatsSuspenseQueryHookResult = ReturnType<typeof useCampaignDailyStatsSuspenseQuery>;
export type CampaignDailyStatsQueryResult = Apollo.QueryResult<CampaignDailyStatsQuery, CampaignDailyStatsQueryVariables>;
export const MyTopPerformingAdsDocument = gql`
    query MyTopPerformingAds($limit: Int) {
  myTopPerformingAds(limit: $limit) {
    id
    name
    objective
    status
    adFormat
    mediaUrls
    optimizedMediaUrls
    impressions
    clicks
    createdAt
  }
}
    `;

/**
 * __useMyTopPerformingAdsQuery__
 *
 * To run a query within a React component, call `useMyTopPerformingAdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTopPerformingAdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTopPerformingAdsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMyTopPerformingAdsQuery(baseOptions?: Apollo.QueryHookOptions<MyTopPerformingAdsQuery, MyTopPerformingAdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTopPerformingAdsQuery, MyTopPerformingAdsQueryVariables>(MyTopPerformingAdsDocument, options);
      }
export function useMyTopPerformingAdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTopPerformingAdsQuery, MyTopPerformingAdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTopPerformingAdsQuery, MyTopPerformingAdsQueryVariables>(MyTopPerformingAdsDocument, options);
        }
// @ts-ignore
export function useMyTopPerformingAdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyTopPerformingAdsQuery, MyTopPerformingAdsQueryVariables>): Apollo.UseSuspenseQueryResult<MyTopPerformingAdsQuery, MyTopPerformingAdsQueryVariables>;
export function useMyTopPerformingAdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyTopPerformingAdsQuery, MyTopPerformingAdsQueryVariables>): Apollo.UseSuspenseQueryResult<MyTopPerformingAdsQuery | undefined, MyTopPerformingAdsQueryVariables>;
export function useMyTopPerformingAdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyTopPerformingAdsQuery, MyTopPerformingAdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyTopPerformingAdsQuery, MyTopPerformingAdsQueryVariables>(MyTopPerformingAdsDocument, options);
        }
export type MyTopPerformingAdsQueryHookResult = ReturnType<typeof useMyTopPerformingAdsQuery>;
export type MyTopPerformingAdsLazyQueryHookResult = ReturnType<typeof useMyTopPerformingAdsLazyQuery>;
export type MyTopPerformingAdsSuspenseQueryHookResult = ReturnType<typeof useMyTopPerformingAdsSuspenseQuery>;
export type MyTopPerformingAdsQueryResult = Apollo.QueryResult<MyTopPerformingAdsQuery, MyTopPerformingAdsQueryVariables>;
export const TargetedAdsDocument = gql`
    query TargetedAds($limit: Int) {
  targetedAds(limit: $limit) {
    id
    name
    headline
    description
    adFormat
    mediaUrls
    ctaText
    ctaUrl
    impressions
    clicks
    user {
      id
      organizationName
      firstName
      lastName
      title
      profileImageUrl
      companyName
    }
  }
}
    `;

/**
 * __useTargetedAdsQuery__
 *
 * To run a query within a React component, call `useTargetedAdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetedAdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetedAdsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTargetedAdsQuery(baseOptions?: Apollo.QueryHookOptions<TargetedAdsQuery, TargetedAdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TargetedAdsQuery, TargetedAdsQueryVariables>(TargetedAdsDocument, options);
      }
export function useTargetedAdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TargetedAdsQuery, TargetedAdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TargetedAdsQuery, TargetedAdsQueryVariables>(TargetedAdsDocument, options);
        }
// @ts-ignore
export function useTargetedAdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TargetedAdsQuery, TargetedAdsQueryVariables>): Apollo.UseSuspenseQueryResult<TargetedAdsQuery, TargetedAdsQueryVariables>;
export function useTargetedAdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TargetedAdsQuery, TargetedAdsQueryVariables>): Apollo.UseSuspenseQueryResult<TargetedAdsQuery | undefined, TargetedAdsQueryVariables>;
export function useTargetedAdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TargetedAdsQuery, TargetedAdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TargetedAdsQuery, TargetedAdsQueryVariables>(TargetedAdsDocument, options);
        }
export type TargetedAdsQueryHookResult = ReturnType<typeof useTargetedAdsQuery>;
export type TargetedAdsLazyQueryHookResult = ReturnType<typeof useTargetedAdsLazyQuery>;
export type TargetedAdsSuspenseQueryHookResult = ReturnType<typeof useTargetedAdsSuspenseQuery>;
export type TargetedAdsQueryResult = Apollo.QueryResult<TargetedAdsQuery, TargetedAdsQueryVariables>;
export const AdvertisingHourlyRateDocument = gql`
    query AdvertisingHourlyRate {
  advertisingHourlyRate {
    hourlyRateCents
  }
}
    `;

/**
 * __useAdvertisingHourlyRateQuery__
 *
 * To run a query within a React component, call `useAdvertisingHourlyRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvertisingHourlyRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvertisingHourlyRateQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdvertisingHourlyRateQuery(baseOptions?: Apollo.QueryHookOptions<AdvertisingHourlyRateQuery, AdvertisingHourlyRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdvertisingHourlyRateQuery, AdvertisingHourlyRateQueryVariables>(AdvertisingHourlyRateDocument, options);
      }
export function useAdvertisingHourlyRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdvertisingHourlyRateQuery, AdvertisingHourlyRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdvertisingHourlyRateQuery, AdvertisingHourlyRateQueryVariables>(AdvertisingHourlyRateDocument, options);
        }
// @ts-ignore
export function useAdvertisingHourlyRateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdvertisingHourlyRateQuery, AdvertisingHourlyRateQueryVariables>): Apollo.UseSuspenseQueryResult<AdvertisingHourlyRateQuery, AdvertisingHourlyRateQueryVariables>;
export function useAdvertisingHourlyRateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdvertisingHourlyRateQuery, AdvertisingHourlyRateQueryVariables>): Apollo.UseSuspenseQueryResult<AdvertisingHourlyRateQuery | undefined, AdvertisingHourlyRateQueryVariables>;
export function useAdvertisingHourlyRateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdvertisingHourlyRateQuery, AdvertisingHourlyRateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdvertisingHourlyRateQuery, AdvertisingHourlyRateQueryVariables>(AdvertisingHourlyRateDocument, options);
        }
export type AdvertisingHourlyRateQueryHookResult = ReturnType<typeof useAdvertisingHourlyRateQuery>;
export type AdvertisingHourlyRateLazyQueryHookResult = ReturnType<typeof useAdvertisingHourlyRateLazyQuery>;
export type AdvertisingHourlyRateSuspenseQueryHookResult = ReturnType<typeof useAdvertisingHourlyRateSuspenseQuery>;
export type AdvertisingHourlyRateQueryResult = Apollo.QueryResult<AdvertisingHourlyRateQuery, AdvertisingHourlyRateQueryVariables>;
export const PreviewCampaignCostDocument = gql`
    query PreviewCampaignCost($durationHours: Float, $durationDays: Int) {
  previewCampaignCost(durationHours: $durationHours, durationDays: $durationDays) {
    durationSeconds
    hourlyRateCents
    amountCents
  }
}
    `;

/**
 * __usePreviewCampaignCostQuery__
 *
 * To run a query within a React component, call `usePreviewCampaignCostQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewCampaignCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewCampaignCostQuery({
 *   variables: {
 *      durationHours: // value for 'durationHours'
 *      durationDays: // value for 'durationDays'
 *   },
 * });
 */
export function usePreviewCampaignCostQuery(baseOptions?: Apollo.QueryHookOptions<PreviewCampaignCostQuery, PreviewCampaignCostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewCampaignCostQuery, PreviewCampaignCostQueryVariables>(PreviewCampaignCostDocument, options);
      }
export function usePreviewCampaignCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewCampaignCostQuery, PreviewCampaignCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewCampaignCostQuery, PreviewCampaignCostQueryVariables>(PreviewCampaignCostDocument, options);
        }
// @ts-ignore
export function usePreviewCampaignCostSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreviewCampaignCostQuery, PreviewCampaignCostQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewCampaignCostQuery, PreviewCampaignCostQueryVariables>;
export function usePreviewCampaignCostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewCampaignCostQuery, PreviewCampaignCostQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewCampaignCostQuery | undefined, PreviewCampaignCostQueryVariables>;
export function usePreviewCampaignCostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewCampaignCostQuery, PreviewCampaignCostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewCampaignCostQuery, PreviewCampaignCostQueryVariables>(PreviewCampaignCostDocument, options);
        }
export type PreviewCampaignCostQueryHookResult = ReturnType<typeof usePreviewCampaignCostQuery>;
export type PreviewCampaignCostLazyQueryHookResult = ReturnType<typeof usePreviewCampaignCostLazyQuery>;
export type PreviewCampaignCostSuspenseQueryHookResult = ReturnType<typeof usePreviewCampaignCostSuspenseQuery>;
export type PreviewCampaignCostQueryResult = Apollo.QueryResult<PreviewCampaignCostQuery, PreviewCampaignCostQueryVariables>;
export const CampaignPurchasesDocument = gql`
    query CampaignPurchases($campaignId: ID!) {
  campaignPurchases(campaignId: $campaignId) {
    id
    campaignId
    type
    durationSeconds
    hourlyRateCents
    amountCents
    status
    createdAt
  }
}
    `;

/**
 * __useCampaignPurchasesQuery__
 *
 * To run a query within a React component, call `useCampaignPurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignPurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignPurchasesQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignPurchasesQuery(baseOptions: Apollo.QueryHookOptions<CampaignPurchasesQuery, CampaignPurchasesQueryVariables> & ({ variables: CampaignPurchasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignPurchasesQuery, CampaignPurchasesQueryVariables>(CampaignPurchasesDocument, options);
      }
export function useCampaignPurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignPurchasesQuery, CampaignPurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignPurchasesQuery, CampaignPurchasesQueryVariables>(CampaignPurchasesDocument, options);
        }
// @ts-ignore
export function useCampaignPurchasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampaignPurchasesQuery, CampaignPurchasesQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignPurchasesQuery, CampaignPurchasesQueryVariables>;
export function useCampaignPurchasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignPurchasesQuery, CampaignPurchasesQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignPurchasesQuery | undefined, CampaignPurchasesQueryVariables>;
export function useCampaignPurchasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignPurchasesQuery, CampaignPurchasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignPurchasesQuery, CampaignPurchasesQueryVariables>(CampaignPurchasesDocument, options);
        }
export type CampaignPurchasesQueryHookResult = ReturnType<typeof useCampaignPurchasesQuery>;
export type CampaignPurchasesLazyQueryHookResult = ReturnType<typeof useCampaignPurchasesLazyQuery>;
export type CampaignPurchasesSuspenseQueryHookResult = ReturnType<typeof useCampaignPurchasesSuspenseQuery>;
export type CampaignPurchasesQueryResult = Apollo.QueryResult<CampaignPurchasesQuery, CampaignPurchasesQueryVariables>;
export const CreateArticleDocument = gql`
    mutation CreateArticle($input: CreateArticleInput!) {
  createArticle(input: $input) {
    id
    title
    slug
    status
    content
    coverImageUrl
    subtitle
    metaTitle
    metaDescription
    tags
    viewCount
    readingTimeMinutes
    createdAt
    author {
      id
      firstName
      lastName
      title
      profileImageUrl
      companyName
    }
    post {
      id
      company {
        id
        name
        logoUrl
      }
    }
  }
}
    `;
export type CreateArticleMutationFn = Apollo.MutationFunction<CreateArticleMutation, CreateArticleMutationVariables>;

/**
 * __useCreateArticleMutation__
 *
 * To run a mutation, you first call `useCreateArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArticleMutation, { data, loading, error }] = useCreateArticleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateArticleMutation(baseOptions?: Apollo.MutationHookOptions<CreateArticleMutation, CreateArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateArticleMutation, CreateArticleMutationVariables>(CreateArticleDocument, options);
      }
export type CreateArticleMutationHookResult = ReturnType<typeof useCreateArticleMutation>;
export type CreateArticleMutationResult = Apollo.MutationResult<CreateArticleMutation>;
export type CreateArticleMutationOptions = Apollo.BaseMutationOptions<CreateArticleMutation, CreateArticleMutationVariables>;
export const UpdateArticleDocument = gql`
    mutation UpdateArticle($input: UpdateArticleInput!) {
  updateArticle(input: $input) {
    id
    title
    slug
    status
    content
    coverImageUrl
    subtitle
    metaTitle
    metaDescription
    tags
    viewCount
    readingTimeMinutes
    updatedAt
  }
}
    `;
export type UpdateArticleMutationFn = Apollo.MutationFunction<UpdateArticleMutation, UpdateArticleMutationVariables>;

/**
 * __useUpdateArticleMutation__
 *
 * To run a mutation, you first call `useUpdateArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArticleMutation, { data, loading, error }] = useUpdateArticleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateArticleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArticleMutation, UpdateArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArticleMutation, UpdateArticleMutationVariables>(UpdateArticleDocument, options);
      }
export type UpdateArticleMutationHookResult = ReturnType<typeof useUpdateArticleMutation>;
export type UpdateArticleMutationResult = Apollo.MutationResult<UpdateArticleMutation>;
export type UpdateArticleMutationOptions = Apollo.BaseMutationOptions<UpdateArticleMutation, UpdateArticleMutationVariables>;
export const PublishArticleDocument = gql`
    mutation PublishArticle($id: ID!) {
  publishArticle(id: $id) {
    id
    status
    updatedAt
  }
}
    `;
export type PublishArticleMutationFn = Apollo.MutationFunction<PublishArticleMutation, PublishArticleMutationVariables>;

/**
 * __usePublishArticleMutation__
 *
 * To run a mutation, you first call `usePublishArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishArticleMutation, { data, loading, error }] = usePublishArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishArticleMutation(baseOptions?: Apollo.MutationHookOptions<PublishArticleMutation, PublishArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishArticleMutation, PublishArticleMutationVariables>(PublishArticleDocument, options);
      }
export type PublishArticleMutationHookResult = ReturnType<typeof usePublishArticleMutation>;
export type PublishArticleMutationResult = Apollo.MutationResult<PublishArticleMutation>;
export type PublishArticleMutationOptions = Apollo.BaseMutationOptions<PublishArticleMutation, PublishArticleMutationVariables>;
export const ArchiveArticleDocument = gql`
    mutation ArchiveArticle($id: ID!) {
  archiveArticle(id: $id) {
    id
    status
    updatedAt
  }
}
    `;
export type ArchiveArticleMutationFn = Apollo.MutationFunction<ArchiveArticleMutation, ArchiveArticleMutationVariables>;

/**
 * __useArchiveArticleMutation__
 *
 * To run a mutation, you first call `useArchiveArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveArticleMutation, { data, loading, error }] = useArchiveArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveArticleMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveArticleMutation, ArchiveArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveArticleMutation, ArchiveArticleMutationVariables>(ArchiveArticleDocument, options);
      }
export type ArchiveArticleMutationHookResult = ReturnType<typeof useArchiveArticleMutation>;
export type ArchiveArticleMutationResult = Apollo.MutationResult<ArchiveArticleMutation>;
export type ArchiveArticleMutationOptions = Apollo.BaseMutationOptions<ArchiveArticleMutation, ArchiveArticleMutationVariables>;
export const DeleteArticleDocument = gql`
    mutation DeleteArticle($id: ID!) {
  deleteArticle(id: $id)
}
    `;
export type DeleteArticleMutationFn = Apollo.MutationFunction<DeleteArticleMutation, DeleteArticleMutationVariables>;

/**
 * __useDeleteArticleMutation__
 *
 * To run a mutation, you first call `useDeleteArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArticleMutation, { data, loading, error }] = useDeleteArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArticleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteArticleMutation, DeleteArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteArticleMutation, DeleteArticleMutationVariables>(DeleteArticleDocument, options);
      }
export type DeleteArticleMutationHookResult = ReturnType<typeof useDeleteArticleMutation>;
export type DeleteArticleMutationResult = Apollo.MutationResult<DeleteArticleMutation>;
export type DeleteArticleMutationOptions = Apollo.BaseMutationOptions<DeleteArticleMutation, DeleteArticleMutationVariables>;
export const SaveArticleDocument = gql`
    mutation SaveArticle($input: SaveArticleInput!) {
  saveArticle(input: $input) {
    id
    articleId
    userId
    createdAt
  }
}
    `;
export type SaveArticleMutationFn = Apollo.MutationFunction<SaveArticleMutation, SaveArticleMutationVariables>;

/**
 * __useSaveArticleMutation__
 *
 * To run a mutation, you first call `useSaveArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveArticleMutation, { data, loading, error }] = useSaveArticleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveArticleMutation(baseOptions?: Apollo.MutationHookOptions<SaveArticleMutation, SaveArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveArticleMutation, SaveArticleMutationVariables>(SaveArticleDocument, options);
      }
export type SaveArticleMutationHookResult = ReturnType<typeof useSaveArticleMutation>;
export type SaveArticleMutationResult = Apollo.MutationResult<SaveArticleMutation>;
export type SaveArticleMutationOptions = Apollo.BaseMutationOptions<SaveArticleMutation, SaveArticleMutationVariables>;
export const UnsaveArticleDocument = gql`
    mutation UnsaveArticle($input: UnsaveArticleInput!) {
  unsaveArticle(input: $input)
}
    `;
export type UnsaveArticleMutationFn = Apollo.MutationFunction<UnsaveArticleMutation, UnsaveArticleMutationVariables>;

/**
 * __useUnsaveArticleMutation__
 *
 * To run a mutation, you first call `useUnsaveArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsaveArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsaveArticleMutation, { data, loading, error }] = useUnsaveArticleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnsaveArticleMutation(baseOptions?: Apollo.MutationHookOptions<UnsaveArticleMutation, UnsaveArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsaveArticleMutation, UnsaveArticleMutationVariables>(UnsaveArticleDocument, options);
      }
export type UnsaveArticleMutationHookResult = ReturnType<typeof useUnsaveArticleMutation>;
export type UnsaveArticleMutationResult = Apollo.MutationResult<UnsaveArticleMutation>;
export type UnsaveArticleMutationOptions = Apollo.BaseMutationOptions<UnsaveArticleMutation, UnsaveArticleMutationVariables>;
export const GetArticleDocument = gql`
    query GetArticle($id: ID!) {
  article(id: $id) {
    id
    title
    subtitle
    content
    coverImageUrl
    metaTitle
    metaDescription
    slug
    status
    viewCount
    readingTimeMinutes
    tags
    isSaved
    createdAt
    updatedAt
    post {
      id
      author {
        id
        firstName
        lastName
        title
        profileImageUrl
        companyName
      }
      company {
        id
        name
        logoUrl
      }
    }
  }
}
    `;

/**
 * __useGetArticleQuery__
 *
 * To run a query within a React component, call `useGetArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetArticleQuery(baseOptions: Apollo.QueryHookOptions<GetArticleQuery, GetArticleQueryVariables> & ({ variables: GetArticleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticleQuery, GetArticleQueryVariables>(GetArticleDocument, options);
      }
export function useGetArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticleQuery, GetArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticleQuery, GetArticleQueryVariables>(GetArticleDocument, options);
        }
// @ts-ignore
export function useGetArticleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArticleQuery, GetArticleQueryVariables>): Apollo.UseSuspenseQueryResult<GetArticleQuery, GetArticleQueryVariables>;
export function useGetArticleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArticleQuery, GetArticleQueryVariables>): Apollo.UseSuspenseQueryResult<GetArticleQuery | undefined, GetArticleQueryVariables>;
export function useGetArticleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArticleQuery, GetArticleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArticleQuery, GetArticleQueryVariables>(GetArticleDocument, options);
        }
export type GetArticleQueryHookResult = ReturnType<typeof useGetArticleQuery>;
export type GetArticleLazyQueryHookResult = ReturnType<typeof useGetArticleLazyQuery>;
export type GetArticleSuspenseQueryHookResult = ReturnType<typeof useGetArticleSuspenseQuery>;
export type GetArticleQueryResult = Apollo.QueryResult<GetArticleQuery, GetArticleQueryVariables>;
export const GetArticleByIdDocument = gql`
    query GetArticleById($id: ID!) {
  article(id: $id) {
    id
    title
    subtitle
    content
    coverImageUrl
    metaTitle
    metaDescription
    slug
    status
    viewCount
    readingTimeMinutes
    tags
    isSaved
    createdAt
    updatedAt
    post {
      id
      author {
        id
        firstName
        lastName
        title
        profileImageUrl
        companyName
      }
      company {
        id
        name
        logoUrl
      }
    }
  }
}
    `;

/**
 * __useGetArticleByIdQuery__
 *
 * To run a query within a React component, call `useGetArticleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticleByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetArticleByIdQuery(baseOptions: Apollo.QueryHookOptions<GetArticleByIdQuery, GetArticleByIdQueryVariables> & ({ variables: GetArticleByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticleByIdQuery, GetArticleByIdQueryVariables>(GetArticleByIdDocument, options);
      }
export function useGetArticleByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticleByIdQuery, GetArticleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticleByIdQuery, GetArticleByIdQueryVariables>(GetArticleByIdDocument, options);
        }
// @ts-ignore
export function useGetArticleByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArticleByIdQuery, GetArticleByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetArticleByIdQuery, GetArticleByIdQueryVariables>;
export function useGetArticleByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArticleByIdQuery, GetArticleByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetArticleByIdQuery | undefined, GetArticleByIdQueryVariables>;
export function useGetArticleByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArticleByIdQuery, GetArticleByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArticleByIdQuery, GetArticleByIdQueryVariables>(GetArticleByIdDocument, options);
        }
export type GetArticleByIdQueryHookResult = ReturnType<typeof useGetArticleByIdQuery>;
export type GetArticleByIdLazyQueryHookResult = ReturnType<typeof useGetArticleByIdLazyQuery>;
export type GetArticleByIdSuspenseQueryHookResult = ReturnType<typeof useGetArticleByIdSuspenseQuery>;
export type GetArticleByIdQueryResult = Apollo.QueryResult<GetArticleByIdQuery, GetArticleByIdQueryVariables>;
export const GetArticleBySlugDocument = gql`
    query GetArticleBySlug($slug: String!) {
  articleBySlug(slug: $slug) {
    id
    title
    subtitle
    content
    translatedTitle
    translatedSubtitle
    translatedContent
    coverImageUrl
    metaTitle
    metaDescription
    slug
    status
    viewCount
    readingTimeMinutes
    tags
    isSaved
    createdAt
    updatedAt
    companyAuthor {
      id
      name
      logoUrl
    }
    post {
      id
      commentsCount
      author {
        id
        firstName
        lastName
        title
        profileImageUrl
        role
        influenceBadge {
          ...InfluenceBadgeFields
        }
        companyName
      }
      reactions {
        reactionCounts {
          type
          count
        }
        totalReactions
        currentUserReaction
      }
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetArticleBySlugQuery__
 *
 * To run a query within a React component, call `useGetArticleBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticleBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetArticleBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetArticleBySlugQuery, GetArticleBySlugQueryVariables> & ({ variables: GetArticleBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticleBySlugQuery, GetArticleBySlugQueryVariables>(GetArticleBySlugDocument, options);
      }
export function useGetArticleBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticleBySlugQuery, GetArticleBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticleBySlugQuery, GetArticleBySlugQueryVariables>(GetArticleBySlugDocument, options);
        }
// @ts-ignore
export function useGetArticleBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArticleBySlugQuery, GetArticleBySlugQueryVariables>): Apollo.UseSuspenseQueryResult<GetArticleBySlugQuery, GetArticleBySlugQueryVariables>;
export function useGetArticleBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArticleBySlugQuery, GetArticleBySlugQueryVariables>): Apollo.UseSuspenseQueryResult<GetArticleBySlugQuery | undefined, GetArticleBySlugQueryVariables>;
export function useGetArticleBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArticleBySlugQuery, GetArticleBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArticleBySlugQuery, GetArticleBySlugQueryVariables>(GetArticleBySlugDocument, options);
        }
export type GetArticleBySlugQueryHookResult = ReturnType<typeof useGetArticleBySlugQuery>;
export type GetArticleBySlugLazyQueryHookResult = ReturnType<typeof useGetArticleBySlugLazyQuery>;
export type GetArticleBySlugSuspenseQueryHookResult = ReturnType<typeof useGetArticleBySlugSuspenseQuery>;
export type GetArticleBySlugQueryResult = Apollo.QueryResult<GetArticleBySlugQuery, GetArticleBySlugQueryVariables>;
export const GetMyArticlesDocument = gql`
    query GetMyArticles {
  myArticles {
    id
    title
    subtitle
    content
    coverImageUrl
    slug
    status
    viewCount
    readingTimeMinutes
    tags
    isSaved
    createdAt
    updatedAt
    post {
      id
      company {
        id
        name
        logoUrl
      }
    }
  }
}
    `;

/**
 * __useGetMyArticlesQuery__
 *
 * To run a query within a React component, call `useGetMyArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyArticlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyArticlesQuery(baseOptions?: Apollo.QueryHookOptions<GetMyArticlesQuery, GetMyArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyArticlesQuery, GetMyArticlesQueryVariables>(GetMyArticlesDocument, options);
      }
export function useGetMyArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyArticlesQuery, GetMyArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyArticlesQuery, GetMyArticlesQueryVariables>(GetMyArticlesDocument, options);
        }
// @ts-ignore
export function useGetMyArticlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyArticlesQuery, GetMyArticlesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyArticlesQuery, GetMyArticlesQueryVariables>;
export function useGetMyArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyArticlesQuery, GetMyArticlesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyArticlesQuery | undefined, GetMyArticlesQueryVariables>;
export function useGetMyArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyArticlesQuery, GetMyArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyArticlesQuery, GetMyArticlesQueryVariables>(GetMyArticlesDocument, options);
        }
export type GetMyArticlesQueryHookResult = ReturnType<typeof useGetMyArticlesQuery>;
export type GetMyArticlesLazyQueryHookResult = ReturnType<typeof useGetMyArticlesLazyQuery>;
export type GetMyArticlesSuspenseQueryHookResult = ReturnType<typeof useGetMyArticlesSuspenseQuery>;
export type GetMyArticlesQueryResult = Apollo.QueryResult<GetMyArticlesQuery, GetMyArticlesQueryVariables>;
export const GetArticlesDocument = gql`
    query GetArticles($filters: ArticleFiltersInput) {
  articles(filters: $filters) {
    id
    title
    subtitle
    slug
    status
    viewCount
    readingTimeMinutes
    tags
    isSaved
    createdAt
    author {
      id
      firstName
      lastName
      title
      profileImageUrl
      companyName
    }
    post {
      id
      company {
        id
        name
        logoUrl
      }
    }
  }
}
    `;

/**
 * __useGetArticlesQuery__
 *
 * To run a query within a React component, call `useGetArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticlesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetArticlesQuery(baseOptions?: Apollo.QueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, options);
      }
export function useGetArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, options);
        }
// @ts-ignore
export function useGetArticlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>): Apollo.UseSuspenseQueryResult<GetArticlesQuery, GetArticlesQueryVariables>;
export function useGetArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>): Apollo.UseSuspenseQueryResult<GetArticlesQuery | undefined, GetArticlesQueryVariables>;
export function useGetArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, options);
        }
export type GetArticlesQueryHookResult = ReturnType<typeof useGetArticlesQuery>;
export type GetArticlesLazyQueryHookResult = ReturnType<typeof useGetArticlesLazyQuery>;
export type GetArticlesSuspenseQueryHookResult = ReturnType<typeof useGetArticlesSuspenseQuery>;
export type GetArticlesQueryResult = Apollo.QueryResult<GetArticlesQuery, GetArticlesQueryVariables>;
export const GetTotalSavedArticlesDocument = gql`
    query GetTotalSavedArticles {
  getTotalSavedArticles
}
    `;

/**
 * __useGetTotalSavedArticlesQuery__
 *
 * To run a query within a React component, call `useGetTotalSavedArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalSavedArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalSavedArticlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTotalSavedArticlesQuery(baseOptions?: Apollo.QueryHookOptions<GetTotalSavedArticlesQuery, GetTotalSavedArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotalSavedArticlesQuery, GetTotalSavedArticlesQueryVariables>(GetTotalSavedArticlesDocument, options);
      }
export function useGetTotalSavedArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotalSavedArticlesQuery, GetTotalSavedArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotalSavedArticlesQuery, GetTotalSavedArticlesQueryVariables>(GetTotalSavedArticlesDocument, options);
        }
// @ts-ignore
export function useGetTotalSavedArticlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTotalSavedArticlesQuery, GetTotalSavedArticlesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTotalSavedArticlesQuery, GetTotalSavedArticlesQueryVariables>;
export function useGetTotalSavedArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotalSavedArticlesQuery, GetTotalSavedArticlesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTotalSavedArticlesQuery | undefined, GetTotalSavedArticlesQueryVariables>;
export function useGetTotalSavedArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotalSavedArticlesQuery, GetTotalSavedArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTotalSavedArticlesQuery, GetTotalSavedArticlesQueryVariables>(GetTotalSavedArticlesDocument, options);
        }
export type GetTotalSavedArticlesQueryHookResult = ReturnType<typeof useGetTotalSavedArticlesQuery>;
export type GetTotalSavedArticlesLazyQueryHookResult = ReturnType<typeof useGetTotalSavedArticlesLazyQuery>;
export type GetTotalSavedArticlesSuspenseQueryHookResult = ReturnType<typeof useGetTotalSavedArticlesSuspenseQuery>;
export type GetTotalSavedArticlesQueryResult = Apollo.QueryResult<GetTotalSavedArticlesQuery, GetTotalSavedArticlesQueryVariables>;
export const GetSavedArticlesDocument = gql`
    query GetSavedArticles($page: Int = 1, $limit: Int = 10) {
  savedArticles(page: $page, limit: $limit) {
    id
    title
    subtitle
    translatedTitle
    translatedSubtitle
    translatedExcerpt
    slug
    coverImageUrl
    content
    status
    viewCount
    readingTimeMinutes
    tags
    createdAt
    postId
    author {
      id
      firstName
      lastName
      title
      profileImageUrl
      role
      influenceBadge {
        ...InfluenceBadgeFields
      }
      companyName
    }
    companyAuthor {
      id
      name
      logoUrl
    }
    post {
      id
      author {
        id
        firstName
        lastName
        title
        profileImageUrl
        role
        influenceBadge {
          ...InfluenceBadgeFields
        }
        companyName
      }
      company {
        id
        name
        logoUrl
      }
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetSavedArticlesQuery__
 *
 * To run a query within a React component, call `useGetSavedArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedArticlesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSavedArticlesQuery(baseOptions?: Apollo.QueryHookOptions<GetSavedArticlesQuery, GetSavedArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavedArticlesQuery, GetSavedArticlesQueryVariables>(GetSavedArticlesDocument, options);
      }
export function useGetSavedArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavedArticlesQuery, GetSavedArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavedArticlesQuery, GetSavedArticlesQueryVariables>(GetSavedArticlesDocument, options);
        }
// @ts-ignore
export function useGetSavedArticlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSavedArticlesQuery, GetSavedArticlesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSavedArticlesQuery, GetSavedArticlesQueryVariables>;
export function useGetSavedArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavedArticlesQuery, GetSavedArticlesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSavedArticlesQuery | undefined, GetSavedArticlesQueryVariables>;
export function useGetSavedArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavedArticlesQuery, GetSavedArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSavedArticlesQuery, GetSavedArticlesQueryVariables>(GetSavedArticlesDocument, options);
        }
export type GetSavedArticlesQueryHookResult = ReturnType<typeof useGetSavedArticlesQuery>;
export type GetSavedArticlesLazyQueryHookResult = ReturnType<typeof useGetSavedArticlesLazyQuery>;
export type GetSavedArticlesSuspenseQueryHookResult = ReturnType<typeof useGetSavedArticlesSuspenseQuery>;
export type GetSavedArticlesQueryResult = Apollo.QueryResult<GetSavedArticlesQuery, GetSavedArticlesQueryVariables>;
export const UploadBannerImageDocument = gql`
    mutation UploadBannerImage($input: UploadBannerImageInput!) {
  uploadBannerImage(input: $input) {
    id
    userId
    fileName
    fileUrl
    optimizedUrl
    mimeType
    size
    type
    createdAt
    updatedAt
  }
}
    `;
export type UploadBannerImageMutationFn = Apollo.MutationFunction<UploadBannerImageMutation, UploadBannerImageMutationVariables>;

/**
 * __useUploadBannerImageMutation__
 *
 * To run a mutation, you first call `useUploadBannerImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadBannerImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadBannerImageMutation, { data, loading, error }] = useUploadBannerImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadBannerImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadBannerImageMutation, UploadBannerImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadBannerImageMutation, UploadBannerImageMutationVariables>(UploadBannerImageDocument, options);
      }
export type UploadBannerImageMutationHookResult = ReturnType<typeof useUploadBannerImageMutation>;
export type UploadBannerImageMutationResult = Apollo.MutationResult<UploadBannerImageMutation>;
export type UploadBannerImageMutationOptions = Apollo.BaseMutationOptions<UploadBannerImageMutation, UploadBannerImageMutationVariables>;
export const DeleteBannerImageDocument = gql`
    mutation DeleteBannerImage {
  deleteBannerImage
}
    `;
export type DeleteBannerImageMutationFn = Apollo.MutationFunction<DeleteBannerImageMutation, DeleteBannerImageMutationVariables>;

/**
 * __useDeleteBannerImageMutation__
 *
 * To run a mutation, you first call `useDeleteBannerImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBannerImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBannerImageMutation, { data, loading, error }] = useDeleteBannerImageMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteBannerImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBannerImageMutation, DeleteBannerImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBannerImageMutation, DeleteBannerImageMutationVariables>(DeleteBannerImageDocument, options);
      }
export type DeleteBannerImageMutationHookResult = ReturnType<typeof useDeleteBannerImageMutation>;
export type DeleteBannerImageMutationResult = Apollo.MutationResult<DeleteBannerImageMutation>;
export type DeleteBannerImageMutationOptions = Apollo.BaseMutationOptions<DeleteBannerImageMutation, DeleteBannerImageMutationVariables>;
export const MyWalletDocument = gql`
    query MyWallet($currency: String) {
  myWallet(currency: $currency) {
    id
    availableBalance
    pendingBalance
    currency
    displayName
    walletKey
    recentTransactions {
      id
      direction
      type
      amount
      currency
      status
      description
      createdAt
    }
  }
}
    `;

/**
 * __useMyWalletQuery__
 *
 * To run a query within a React component, call `useMyWalletQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyWalletQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyWalletQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useMyWalletQuery(baseOptions?: Apollo.QueryHookOptions<MyWalletQuery, MyWalletQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyWalletQuery, MyWalletQueryVariables>(MyWalletDocument, options);
      }
export function useMyWalletLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyWalletQuery, MyWalletQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyWalletQuery, MyWalletQueryVariables>(MyWalletDocument, options);
        }
// @ts-ignore
export function useMyWalletSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyWalletQuery, MyWalletQueryVariables>): Apollo.UseSuspenseQueryResult<MyWalletQuery, MyWalletQueryVariables>;
export function useMyWalletSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyWalletQuery, MyWalletQueryVariables>): Apollo.UseSuspenseQueryResult<MyWalletQuery | undefined, MyWalletQueryVariables>;
export function useMyWalletSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyWalletQuery, MyWalletQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyWalletQuery, MyWalletQueryVariables>(MyWalletDocument, options);
        }
export type MyWalletQueryHookResult = ReturnType<typeof useMyWalletQuery>;
export type MyWalletLazyQueryHookResult = ReturnType<typeof useMyWalletLazyQuery>;
export type MyWalletSuspenseQueryHookResult = ReturnType<typeof useMyWalletSuspenseQuery>;
export type MyWalletQueryResult = Apollo.QueryResult<MyWalletQuery, MyWalletQueryVariables>;
export const BookSessionDocument = gql`
    mutation BookSession($input: BookSessionInput!) {
  bookSession(input: $input) {
    bookingId
    isFree
  }
}
    `;
export type BookSessionMutationFn = Apollo.MutationFunction<BookSessionMutation, BookSessionMutationVariables>;

/**
 * __useBookSessionMutation__
 *
 * To run a mutation, you first call `useBookSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookSessionMutation, { data, loading, error }] = useBookSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBookSessionMutation(baseOptions?: Apollo.MutationHookOptions<BookSessionMutation, BookSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookSessionMutation, BookSessionMutationVariables>(BookSessionDocument, options);
      }
export type BookSessionMutationHookResult = ReturnType<typeof useBookSessionMutation>;
export type BookSessionMutationResult = Apollo.MutationResult<BookSessionMutation>;
export type BookSessionMutationOptions = Apollo.BaseMutationOptions<BookSessionMutation, BookSessionMutationVariables>;
export const CancelConfirmedSessionDocument = gql`
    mutation CancelConfirmedSession($sessionId: String!) {
  cancelConfirmedSession(sessionId: $sessionId)
}
    `;
export type CancelConfirmedSessionMutationFn = Apollo.MutationFunction<CancelConfirmedSessionMutation, CancelConfirmedSessionMutationVariables>;

/**
 * __useCancelConfirmedSessionMutation__
 *
 * To run a mutation, you first call `useCancelConfirmedSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelConfirmedSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelConfirmedSessionMutation, { data, loading, error }] = useCancelConfirmedSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useCancelConfirmedSessionMutation(baseOptions?: Apollo.MutationHookOptions<CancelConfirmedSessionMutation, CancelConfirmedSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelConfirmedSessionMutation, CancelConfirmedSessionMutationVariables>(CancelConfirmedSessionDocument, options);
      }
export type CancelConfirmedSessionMutationHookResult = ReturnType<typeof useCancelConfirmedSessionMutation>;
export type CancelConfirmedSessionMutationResult = Apollo.MutationResult<CancelConfirmedSessionMutation>;
export type CancelConfirmedSessionMutationOptions = Apollo.BaseMutationOptions<CancelConfirmedSessionMutation, CancelConfirmedSessionMutationVariables>;
export const CreateCasePostDocument = gql`
    mutation CreateCasePost($input: CreateCasePostInput!) {
  createCasePost(input: $input)
}
    `;
export type CreateCasePostMutationFn = Apollo.MutationFunction<CreateCasePostMutation, CreateCasePostMutationVariables>;

/**
 * __useCreateCasePostMutation__
 *
 * To run a mutation, you first call `useCreateCasePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCasePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCasePostMutation, { data, loading, error }] = useCreateCasePostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCasePostMutation(baseOptions?: Apollo.MutationHookOptions<CreateCasePostMutation, CreateCasePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCasePostMutation, CreateCasePostMutationVariables>(CreateCasePostDocument, options);
      }
export type CreateCasePostMutationHookResult = ReturnType<typeof useCreateCasePostMutation>;
export type CreateCasePostMutationResult = Apollo.MutationResult<CreateCasePostMutation>;
export type CreateCasePostMutationOptions = Apollo.BaseMutationOptions<CreateCasePostMutation, CreateCasePostMutationVariables>;
export const GetCaseByPostIdDocument = gql`
    query GetCaseByPostId($postId: String!) {
  getCaseByPostId(postId: $postId) {
    id
    postId
    media {
      id
      step
      type
      imageUrl
      text
      order
      createdAt
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetCaseByPostIdQuery__
 *
 * To run a query within a React component, call `useGetCaseByPostIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseByPostIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseByPostIdQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetCaseByPostIdQuery(baseOptions: Apollo.QueryHookOptions<GetCaseByPostIdQuery, GetCaseByPostIdQueryVariables> & ({ variables: GetCaseByPostIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseByPostIdQuery, GetCaseByPostIdQueryVariables>(GetCaseByPostIdDocument, options);
      }
export function useGetCaseByPostIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseByPostIdQuery, GetCaseByPostIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseByPostIdQuery, GetCaseByPostIdQueryVariables>(GetCaseByPostIdDocument, options);
        }
// @ts-ignore
export function useGetCaseByPostIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseByPostIdQuery, GetCaseByPostIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseByPostIdQuery, GetCaseByPostIdQueryVariables>;
export function useGetCaseByPostIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseByPostIdQuery, GetCaseByPostIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseByPostIdQuery | undefined, GetCaseByPostIdQueryVariables>;
export function useGetCaseByPostIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseByPostIdQuery, GetCaseByPostIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseByPostIdQuery, GetCaseByPostIdQueryVariables>(GetCaseByPostIdDocument, options);
        }
export type GetCaseByPostIdQueryHookResult = ReturnType<typeof useGetCaseByPostIdQuery>;
export type GetCaseByPostIdLazyQueryHookResult = ReturnType<typeof useGetCaseByPostIdLazyQuery>;
export type GetCaseByPostIdSuspenseQueryHookResult = ReturnType<typeof useGetCaseByPostIdSuspenseQuery>;
export type GetCaseByPostIdQueryResult = Apollo.QueryResult<GetCaseByPostIdQuery, GetCaseByPostIdQueryVariables>;
export const UpdateCasePostMediaDocument = gql`
    mutation UpdateCasePostMedia($input: UpdateCasePostInput!) {
  updateCasePostMedia(input: $input)
}
    `;
export type UpdateCasePostMediaMutationFn = Apollo.MutationFunction<UpdateCasePostMediaMutation, UpdateCasePostMediaMutationVariables>;

/**
 * __useUpdateCasePostMediaMutation__
 *
 * To run a mutation, you first call `useUpdateCasePostMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCasePostMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCasePostMediaMutation, { data, loading, error }] = useUpdateCasePostMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCasePostMediaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCasePostMediaMutation, UpdateCasePostMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCasePostMediaMutation, UpdateCasePostMediaMutationVariables>(UpdateCasePostMediaDocument, options);
      }
export type UpdateCasePostMediaMutationHookResult = ReturnType<typeof useUpdateCasePostMediaMutation>;
export type UpdateCasePostMediaMutationResult = Apollo.MutationResult<UpdateCasePostMediaMutation>;
export type UpdateCasePostMediaMutationOptions = Apollo.BaseMutationOptions<UpdateCasePostMediaMutation, UpdateCasePostMediaMutationVariables>;
export const CeCoursesDocument = gql`
    query CeCourses($input: CeCoursesInput) {
  ceCourses(input: $input) {
    items {
      ...CeCourseFields
    }
    page
    limit
    totalCount
    totalPages
  }
}
    ${CeCourseFieldsFragmentDoc}`;

/**
 * __useCeCoursesQuery__
 *
 * To run a query within a React component, call `useCeCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCeCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCeCoursesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCeCoursesQuery(baseOptions?: Apollo.QueryHookOptions<CeCoursesQuery, CeCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CeCoursesQuery, CeCoursesQueryVariables>(CeCoursesDocument, options);
      }
export function useCeCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CeCoursesQuery, CeCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CeCoursesQuery, CeCoursesQueryVariables>(CeCoursesDocument, options);
        }
// @ts-ignore
export function useCeCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CeCoursesQuery, CeCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<CeCoursesQuery, CeCoursesQueryVariables>;
export function useCeCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CeCoursesQuery, CeCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<CeCoursesQuery | undefined, CeCoursesQueryVariables>;
export function useCeCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CeCoursesQuery, CeCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CeCoursesQuery, CeCoursesQueryVariables>(CeCoursesDocument, options);
        }
export type CeCoursesQueryHookResult = ReturnType<typeof useCeCoursesQuery>;
export type CeCoursesLazyQueryHookResult = ReturnType<typeof useCeCoursesLazyQuery>;
export type CeCoursesSuspenseQueryHookResult = ReturnType<typeof useCeCoursesSuspenseQuery>;
export type CeCoursesQueryResult = Apollo.QueryResult<CeCoursesQuery, CeCoursesQueryVariables>;
export const CeCourseFiltersDocument = gql`
    query CeCourseFilters {
  ceCourseFilters {
    providers {
      name
      count
    }
    deliveryModes {
      name
      count
    }
    freeCount
    paidCount
    categories {
      name
      count
    }
  }
}
    `;

/**
 * __useCeCourseFiltersQuery__
 *
 * To run a query within a React component, call `useCeCourseFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCeCourseFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCeCourseFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCeCourseFiltersQuery(baseOptions?: Apollo.QueryHookOptions<CeCourseFiltersQuery, CeCourseFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CeCourseFiltersQuery, CeCourseFiltersQueryVariables>(CeCourseFiltersDocument, options);
      }
export function useCeCourseFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CeCourseFiltersQuery, CeCourseFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CeCourseFiltersQuery, CeCourseFiltersQueryVariables>(CeCourseFiltersDocument, options);
        }
// @ts-ignore
export function useCeCourseFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CeCourseFiltersQuery, CeCourseFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<CeCourseFiltersQuery, CeCourseFiltersQueryVariables>;
export function useCeCourseFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CeCourseFiltersQuery, CeCourseFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<CeCourseFiltersQuery | undefined, CeCourseFiltersQueryVariables>;
export function useCeCourseFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CeCourseFiltersQuery, CeCourseFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CeCourseFiltersQuery, CeCourseFiltersQueryVariables>(CeCourseFiltersDocument, options);
        }
export type CeCourseFiltersQueryHookResult = ReturnType<typeof useCeCourseFiltersQuery>;
export type CeCourseFiltersLazyQueryHookResult = ReturnType<typeof useCeCourseFiltersLazyQuery>;
export type CeCourseFiltersSuspenseQueryHookResult = ReturnType<typeof useCeCourseFiltersSuspenseQuery>;
export type CeCourseFiltersQueryResult = Apollo.QueryResult<CeCourseFiltersQuery, CeCourseFiltersQueryVariables>;
export const RoleChangeRequestDocument = gql`
    mutation RoleChangeRequest {
  roleChangeRequest
}
    `;
export type RoleChangeRequestMutationFn = Apollo.MutationFunction<RoleChangeRequestMutation, RoleChangeRequestMutationVariables>;

/**
 * __useRoleChangeRequestMutation__
 *
 * To run a mutation, you first call `useRoleChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoleChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roleChangeRequestMutation, { data, loading, error }] = useRoleChangeRequestMutation({
 *   variables: {
 *   },
 * });
 */
export function useRoleChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<RoleChangeRequestMutation, RoleChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RoleChangeRequestMutation, RoleChangeRequestMutationVariables>(RoleChangeRequestDocument, options);
      }
export type RoleChangeRequestMutationHookResult = ReturnType<typeof useRoleChangeRequestMutation>;
export type RoleChangeRequestMutationResult = Apollo.MutationResult<RoleChangeRequestMutation>;
export type RoleChangeRequestMutationOptions = Apollo.BaseMutationOptions<RoleChangeRequestMutation, RoleChangeRequestMutationVariables>;
export const RoleChangeToggleDocument = gql`
    mutation RoleChangeToggle {
  roleChangeToggle
}
    `;
export type RoleChangeToggleMutationFn = Apollo.MutationFunction<RoleChangeToggleMutation, RoleChangeToggleMutationVariables>;

/**
 * __useRoleChangeToggleMutation__
 *
 * To run a mutation, you first call `useRoleChangeToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoleChangeToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roleChangeToggleMutation, { data, loading, error }] = useRoleChangeToggleMutation({
 *   variables: {
 *   },
 * });
 */
export function useRoleChangeToggleMutation(baseOptions?: Apollo.MutationHookOptions<RoleChangeToggleMutation, RoleChangeToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RoleChangeToggleMutation, RoleChangeToggleMutationVariables>(RoleChangeToggleDocument, options);
      }
export type RoleChangeToggleMutationHookResult = ReturnType<typeof useRoleChangeToggleMutation>;
export type RoleChangeToggleMutationResult = Apollo.MutationResult<RoleChangeToggleMutation>;
export type RoleChangeToggleMutationOptions = Apollo.BaseMutationOptions<RoleChangeToggleMutation, RoleChangeToggleMutationVariables>;
export const WithdrawRoleChangeRequestDocument = gql`
    mutation WithdrawRoleChangeRequest {
  withdrawRoleChangeRequest
}
    `;
export type WithdrawRoleChangeRequestMutationFn = Apollo.MutationFunction<WithdrawRoleChangeRequestMutation, WithdrawRoleChangeRequestMutationVariables>;

/**
 * __useWithdrawRoleChangeRequestMutation__
 *
 * To run a mutation, you first call `useWithdrawRoleChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawRoleChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawRoleChangeRequestMutation, { data, loading, error }] = useWithdrawRoleChangeRequestMutation({
 *   variables: {
 *   },
 * });
 */
export function useWithdrawRoleChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<WithdrawRoleChangeRequestMutation, WithdrawRoleChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WithdrawRoleChangeRequestMutation, WithdrawRoleChangeRequestMutationVariables>(WithdrawRoleChangeRequestDocument, options);
      }
export type WithdrawRoleChangeRequestMutationHookResult = ReturnType<typeof useWithdrawRoleChangeRequestMutation>;
export type WithdrawRoleChangeRequestMutationResult = Apollo.MutationResult<WithdrawRoleChangeRequestMutation>;
export type WithdrawRoleChangeRequestMutationOptions = Apollo.BaseMutationOptions<WithdrawRoleChangeRequestMutation, WithdrawRoleChangeRequestMutationVariables>;
export const CommentOnPostDocument = gql`
    mutation CommentOnPost($input: CreateCommentInput!) {
  commentOnPost(input: $input) {
    id
    content
    userId
    mediaUrls
    createdAt
    updatedAt
    user {
      id
      firstName
      middleName
      lastName
      title
      role
      profileImageUrl
      influenceBadge {
        ...InfluenceBadgeFields
      }
      companyName
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;
export type CommentOnPostMutationFn = Apollo.MutationFunction<CommentOnPostMutation, CommentOnPostMutationVariables>;

/**
 * __useCommentOnPostMutation__
 *
 * To run a mutation, you first call `useCommentOnPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentOnPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentOnPostMutation, { data, loading, error }] = useCommentOnPostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommentOnPostMutation(baseOptions?: Apollo.MutationHookOptions<CommentOnPostMutation, CommentOnPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommentOnPostMutation, CommentOnPostMutationVariables>(CommentOnPostDocument, options);
      }
export type CommentOnPostMutationHookResult = ReturnType<typeof useCommentOnPostMutation>;
export type CommentOnPostMutationResult = Apollo.MutationResult<CommentOnPostMutation>;
export type CommentOnPostMutationOptions = Apollo.BaseMutationOptions<CommentOnPostMutation, CommentOnPostMutationVariables>;
export const ReplyOnCommentDocument = gql`
    mutation ReplyOnComment($input: ReplyCommentInput!) {
  replyOnComment(input: $input) {
    id
    content
    userId
    mediaUrls
    createdAt
    updatedAt
    user {
      id
      firstName
      middleName
      lastName
      title
      role
      profileImageUrl
      influenceBadge {
        ...InfluenceBadgeFields
      }
      companyName
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;
export type ReplyOnCommentMutationFn = Apollo.MutationFunction<ReplyOnCommentMutation, ReplyOnCommentMutationVariables>;

/**
 * __useReplyOnCommentMutation__
 *
 * To run a mutation, you first call `useReplyOnCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplyOnCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replyOnCommentMutation, { data, loading, error }] = useReplyOnCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReplyOnCommentMutation(baseOptions?: Apollo.MutationHookOptions<ReplyOnCommentMutation, ReplyOnCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplyOnCommentMutation, ReplyOnCommentMutationVariables>(ReplyOnCommentDocument, options);
      }
export type ReplyOnCommentMutationHookResult = ReturnType<typeof useReplyOnCommentMutation>;
export type ReplyOnCommentMutationResult = Apollo.MutationResult<ReplyOnCommentMutation>;
export type ReplyOnCommentMutationOptions = Apollo.BaseMutationOptions<ReplyOnCommentMutation, ReplyOnCommentMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation UpdateComment($input: UpdateCommentInput!) {
  updateComment(input: $input) {
    id
    content
    userId
    mediaUrls
    createdAt
    updatedAt
    user {
      id
      firstName
      middleName
      lastName
      title
      role
      profileImageUrl
      influenceBadge {
        ...InfluenceBadgeFields
      }
      companyName
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;
export type UpdateCommentMutationFn = Apollo.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const ToggleCommentReactionDocument = gql`
    mutation ToggleCommentReaction($input: LikeCommentInput!) {
  toggleCommentReaction(input: $input)
}
    `;
export type ToggleCommentReactionMutationFn = Apollo.MutationFunction<ToggleCommentReactionMutation, ToggleCommentReactionMutationVariables>;

/**
 * __useToggleCommentReactionMutation__
 *
 * To run a mutation, you first call `useToggleCommentReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCommentReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCommentReactionMutation, { data, loading, error }] = useToggleCommentReactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleCommentReactionMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCommentReactionMutation, ToggleCommentReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCommentReactionMutation, ToggleCommentReactionMutationVariables>(ToggleCommentReactionDocument, options);
      }
export type ToggleCommentReactionMutationHookResult = ReturnType<typeof useToggleCommentReactionMutation>;
export type ToggleCommentReactionMutationResult = Apollo.MutationResult<ToggleCommentReactionMutation>;
export type ToggleCommentReactionMutationOptions = Apollo.BaseMutationOptions<ToggleCommentReactionMutation, ToggleCommentReactionMutationVariables>;
export const SendUniversityGroupMessageDocument = gql`
    mutation SendUniversityGroupMessage($groupId: String!, $senderId: String!, $content: String!) {
  sendUniversityGroupMessage(
    groupId: $groupId
    senderId: $senderId
    content: $content
  ) {
    id
    content
    createdAt
    sender {
      id
      firstName
      lastName
      title
      profileImageUrl
      companyName
    }
  }
}
    `;
export type SendUniversityGroupMessageMutationFn = Apollo.MutationFunction<SendUniversityGroupMessageMutation, SendUniversityGroupMessageMutationVariables>;

/**
 * __useSendUniversityGroupMessageMutation__
 *
 * To run a mutation, you first call `useSendUniversityGroupMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendUniversityGroupMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendUniversityGroupMessageMutation, { data, loading, error }] = useSendUniversityGroupMessageMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      senderId: // value for 'senderId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useSendUniversityGroupMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendUniversityGroupMessageMutation, SendUniversityGroupMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendUniversityGroupMessageMutation, SendUniversityGroupMessageMutationVariables>(SendUniversityGroupMessageDocument, options);
      }
export type SendUniversityGroupMessageMutationHookResult = ReturnType<typeof useSendUniversityGroupMessageMutation>;
export type SendUniversityGroupMessageMutationResult = Apollo.MutationResult<SendUniversityGroupMessageMutation>;
export type SendUniversityGroupMessageMutationOptions = Apollo.BaseMutationOptions<SendUniversityGroupMessageMutation, SendUniversityGroupMessageMutationVariables>;
export const UniversityGroupMessagesDocument = gql`
    query UniversityGroupMessages($groupId: String!, $page: Float, $messages: Float) {
  universityGroupMessages(groupId: $groupId, page: $page, messages: $messages) {
    id
    content
    createdAt
    sender {
      id
      firstName
      lastName
      title
      profileImageUrl
      companyName
    }
    replies {
      id
      content
      createdAt
      sender {
        id
        firstName
        lastName
        title
        profileImageUrl
        companyName
      }
    }
    parent {
      id
    }
  }
}
    `;

/**
 * __useUniversityGroupMessagesQuery__
 *
 * To run a query within a React component, call `useUniversityGroupMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniversityGroupMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniversityGroupMessagesQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      page: // value for 'page'
 *      messages: // value for 'messages'
 *   },
 * });
 */
export function useUniversityGroupMessagesQuery(baseOptions: Apollo.QueryHookOptions<UniversityGroupMessagesQuery, UniversityGroupMessagesQueryVariables> & ({ variables: UniversityGroupMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniversityGroupMessagesQuery, UniversityGroupMessagesQueryVariables>(UniversityGroupMessagesDocument, options);
      }
export function useUniversityGroupMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniversityGroupMessagesQuery, UniversityGroupMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniversityGroupMessagesQuery, UniversityGroupMessagesQueryVariables>(UniversityGroupMessagesDocument, options);
        }
// @ts-ignore
export function useUniversityGroupMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UniversityGroupMessagesQuery, UniversityGroupMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<UniversityGroupMessagesQuery, UniversityGroupMessagesQueryVariables>;
export function useUniversityGroupMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UniversityGroupMessagesQuery, UniversityGroupMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<UniversityGroupMessagesQuery | undefined, UniversityGroupMessagesQueryVariables>;
export function useUniversityGroupMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UniversityGroupMessagesQuery, UniversityGroupMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UniversityGroupMessagesQuery, UniversityGroupMessagesQueryVariables>(UniversityGroupMessagesDocument, options);
        }
export type UniversityGroupMessagesQueryHookResult = ReturnType<typeof useUniversityGroupMessagesQuery>;
export type UniversityGroupMessagesLazyQueryHookResult = ReturnType<typeof useUniversityGroupMessagesLazyQuery>;
export type UniversityGroupMessagesSuspenseQueryHookResult = ReturnType<typeof useUniversityGroupMessagesSuspenseQuery>;
export type UniversityGroupMessagesQueryResult = Apollo.QueryResult<UniversityGroupMessagesQuery, UniversityGroupMessagesQueryVariables>;
export const ReplyUniversityGroupMessageDocument = gql`
    mutation ReplyUniversityGroupMessage($groupId: String!, $senderId: String!, $content: String!, $parentId: String!) {
  replyUniversityGroupMessage(
    groupId: $groupId
    senderId: $senderId
    content: $content
    parentId: $parentId
  ) {
    id
    content
    createdAt
    sender {
      id
      firstName
      lastName
      title
      profileImageUrl
      companyName
    }
    parent {
      id
    }
  }
}
    `;
export type ReplyUniversityGroupMessageMutationFn = Apollo.MutationFunction<ReplyUniversityGroupMessageMutation, ReplyUniversityGroupMessageMutationVariables>;

/**
 * __useReplyUniversityGroupMessageMutation__
 *
 * To run a mutation, you first call `useReplyUniversityGroupMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplyUniversityGroupMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replyUniversityGroupMessageMutation, { data, loading, error }] = useReplyUniversityGroupMessageMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      senderId: // value for 'senderId'
 *      content: // value for 'content'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useReplyUniversityGroupMessageMutation(baseOptions?: Apollo.MutationHookOptions<ReplyUniversityGroupMessageMutation, ReplyUniversityGroupMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplyUniversityGroupMessageMutation, ReplyUniversityGroupMessageMutationVariables>(ReplyUniversityGroupMessageDocument, options);
      }
export type ReplyUniversityGroupMessageMutationHookResult = ReturnType<typeof useReplyUniversityGroupMessageMutation>;
export type ReplyUniversityGroupMessageMutationResult = Apollo.MutationResult<ReplyUniversityGroupMessageMutation>;
export type ReplyUniversityGroupMessageMutationOptions = Apollo.BaseMutationOptions<ReplyUniversityGroupMessageMutation, ReplyUniversityGroupMessageMutationVariables>;
export const AccessibleCommunitiesDocument = gql`
    query AccessibleCommunities {
  accessibleCommunities {
    id
    name
    type
    description
    logo
  }
}
    `;

/**
 * __useAccessibleCommunitiesQuery__
 *
 * To run a query within a React component, call `useAccessibleCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessibleCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessibleCommunitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccessibleCommunitiesQuery(baseOptions?: Apollo.QueryHookOptions<AccessibleCommunitiesQuery, AccessibleCommunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessibleCommunitiesQuery, AccessibleCommunitiesQueryVariables>(AccessibleCommunitiesDocument, options);
      }
export function useAccessibleCommunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessibleCommunitiesQuery, AccessibleCommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessibleCommunitiesQuery, AccessibleCommunitiesQueryVariables>(AccessibleCommunitiesDocument, options);
        }
// @ts-ignore
export function useAccessibleCommunitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccessibleCommunitiesQuery, AccessibleCommunitiesQueryVariables>): Apollo.UseSuspenseQueryResult<AccessibleCommunitiesQuery, AccessibleCommunitiesQueryVariables>;
export function useAccessibleCommunitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccessibleCommunitiesQuery, AccessibleCommunitiesQueryVariables>): Apollo.UseSuspenseQueryResult<AccessibleCommunitiesQuery | undefined, AccessibleCommunitiesQueryVariables>;
export function useAccessibleCommunitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccessibleCommunitiesQuery, AccessibleCommunitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccessibleCommunitiesQuery, AccessibleCommunitiesQueryVariables>(AccessibleCommunitiesDocument, options);
        }
export type AccessibleCommunitiesQueryHookResult = ReturnType<typeof useAccessibleCommunitiesQuery>;
export type AccessibleCommunitiesLazyQueryHookResult = ReturnType<typeof useAccessibleCommunitiesLazyQuery>;
export type AccessibleCommunitiesSuspenseQueryHookResult = ReturnType<typeof useAccessibleCommunitiesSuspenseQuery>;
export type AccessibleCommunitiesQueryResult = Apollo.QueryResult<AccessibleCommunitiesQuery, AccessibleCommunitiesQueryVariables>;
export const CreateCompanyDocument = gql`
    mutation CreateCompany($input: CreateCompanyInput!) {
  createCompany(input: $input) {
    id
    name
    slug
    type
    ownerId
    owner {
      id
      email
      firstName
      lastName
      title
      companyName
    }
    website
    tagline
    industry
    size
    orgType
    city
    country
    logoUrl
    coverUrl
    mission
    story
    specialties
    websiteLinks
    ctaType
    ctaLabel
    ctaUrl
    hashtags
    parentId
    isDeleted
    autoInvite
    createdAt
    updatedAt
  }
}
    `;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const MyCompaniesByOwnerDocument = gql`
    query MyCompaniesByOwner($ownerId: String!) {
  myCompaniesByOwner(ownerId: $ownerId) {
    id
    name
    slug
    website
    tagline
    industry
    size
    orgType
    logoUrl
    coverUrl
    hashtags
    specialties
    parentId
    ownerId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useMyCompaniesByOwnerQuery__
 *
 * To run a query within a React component, call `useMyCompaniesByOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCompaniesByOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCompaniesByOwnerQuery({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *   },
 * });
 */
export function useMyCompaniesByOwnerQuery(baseOptions: Apollo.QueryHookOptions<MyCompaniesByOwnerQuery, MyCompaniesByOwnerQueryVariables> & ({ variables: MyCompaniesByOwnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCompaniesByOwnerQuery, MyCompaniesByOwnerQueryVariables>(MyCompaniesByOwnerDocument, options);
      }
export function useMyCompaniesByOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCompaniesByOwnerQuery, MyCompaniesByOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCompaniesByOwnerQuery, MyCompaniesByOwnerQueryVariables>(MyCompaniesByOwnerDocument, options);
        }
// @ts-ignore
export function useMyCompaniesByOwnerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyCompaniesByOwnerQuery, MyCompaniesByOwnerQueryVariables>): Apollo.UseSuspenseQueryResult<MyCompaniesByOwnerQuery, MyCompaniesByOwnerQueryVariables>;
export function useMyCompaniesByOwnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyCompaniesByOwnerQuery, MyCompaniesByOwnerQueryVariables>): Apollo.UseSuspenseQueryResult<MyCompaniesByOwnerQuery | undefined, MyCompaniesByOwnerQueryVariables>;
export function useMyCompaniesByOwnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyCompaniesByOwnerQuery, MyCompaniesByOwnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyCompaniesByOwnerQuery, MyCompaniesByOwnerQueryVariables>(MyCompaniesByOwnerDocument, options);
        }
export type MyCompaniesByOwnerQueryHookResult = ReturnType<typeof useMyCompaniesByOwnerQuery>;
export type MyCompaniesByOwnerLazyQueryHookResult = ReturnType<typeof useMyCompaniesByOwnerLazyQuery>;
export type MyCompaniesByOwnerSuspenseQueryHookResult = ReturnType<typeof useMyCompaniesByOwnerSuspenseQuery>;
export type MyCompaniesByOwnerQueryResult = Apollo.QueryResult<MyCompaniesByOwnerQuery, MyCompaniesByOwnerQueryVariables>;
export const GetCompanyDocument = gql`
    query GetCompany($id: String!) {
  company(id: $id) {
    id
    name
    slug
    website
    tagline
    industry
    size
    orgType
    city
    country
    mission
    story
    logoUrl
    coverUrl
    specialties
    hashtags
    parentId
    ownerId
    status
    owner {
      id
      email
      firstName
      lastName
      title
      companyName
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables> & ({ variables: GetCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
      }
export function useGetCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
// @ts-ignore
export function useGetCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export function useGetCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyQuery | undefined, GetCompanyQueryVariables>;
export function useGetCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanySuspenseQueryHookResult = ReturnType<typeof useGetCompanySuspenseQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export const UpdateLogoDocument = gql`
    mutation UpdateLogo($companyId: String!, $logoUrl: String!) {
  updateCompanyLogo(companyId: $companyId, logoUrl: $logoUrl) {
    id
    logoUrl
    coverUrl
    updatedAt
  }
}
    `;
export type UpdateLogoMutationFn = Apollo.MutationFunction<UpdateLogoMutation, UpdateLogoMutationVariables>;

/**
 * __useUpdateLogoMutation__
 *
 * To run a mutation, you first call `useUpdateLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLogoMutation, { data, loading, error }] = useUpdateLogoMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      logoUrl: // value for 'logoUrl'
 *   },
 * });
 */
export function useUpdateLogoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLogoMutation, UpdateLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLogoMutation, UpdateLogoMutationVariables>(UpdateLogoDocument, options);
      }
export type UpdateLogoMutationHookResult = ReturnType<typeof useUpdateLogoMutation>;
export type UpdateLogoMutationResult = Apollo.MutationResult<UpdateLogoMutation>;
export type UpdateLogoMutationOptions = Apollo.BaseMutationOptions<UpdateLogoMutation, UpdateLogoMutationVariables>;
export const UpdateCoverDocument = gql`
    mutation UpdateCover($companyId: String!, $coverUrl: String!) {
  updateCompanyCover(companyId: $companyId, coverUrl: $coverUrl) {
    id
    logoUrl
    coverUrl
    updatedAt
  }
}
    `;
export type UpdateCoverMutationFn = Apollo.MutationFunction<UpdateCoverMutation, UpdateCoverMutationVariables>;

/**
 * __useUpdateCoverMutation__
 *
 * To run a mutation, you first call `useUpdateCoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoverMutation, { data, loading, error }] = useUpdateCoverMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      coverUrl: // value for 'coverUrl'
 *   },
 * });
 */
export function useUpdateCoverMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoverMutation, UpdateCoverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoverMutation, UpdateCoverMutationVariables>(UpdateCoverDocument, options);
      }
export type UpdateCoverMutationHookResult = ReturnType<typeof useUpdateCoverMutation>;
export type UpdateCoverMutationResult = Apollo.MutationResult<UpdateCoverMutation>;
export type UpdateCoverMutationOptions = Apollo.BaseMutationOptions<UpdateCoverMutation, UpdateCoverMutationVariables>;
export const GetCompanyPostsDocument = gql`
    query GetCompanyPosts($companyId: String!, $page: Int, $limit: Int) {
  companyPosts(companyId: $companyId, page: $page, limit: $limit) {
    id
    isPinned
    authorId
    contentTokens {
      type
      value
      userId
      handle
      url
    }
    translatedContentTokens {
      type
      value
      userId
      handle
      url
    }
    createdAt
    updatedAt
    isPublished
    commentsCount
    mediaUrls
    postType
    article {
      id
      title
      subtitle
      content
      coverImageUrl
      slug
      readingTimeMinutes
      tags
      status
      translatedTitle
      translatedSubtitle
      translatedExcerpt
    }
    poll {
      question
      expiresAt
      options {
        id
        text
        votes
        isChosen
      }
      translatedQuestion
      translatedOptions
    }
    occasion {
      id
      postId
      title
      description
      imageUrl
      privacy
      translatedTitle
      translatedDescription
    }
    companyId
    isRepost
    repostComment
    isSavedByMe
    isRepostedByMe
    isBoosted
    activeBoostId
    author {
      id
      firstName
      lastName
      title
      middleName
      profileImageUrl
      role
      companyName
    }
    companyAuthor {
      id
      name
      logoUrl
      industry
      tagline
    }
    reactions {
      totalReactions
      currentUserReaction
      reactionCounts {
        type
        count
      }
    }
    originalPost {
      id
      contentTokens {
        type
        value
        userId
        handle
        url
      }
      translatedContentTokens {
        type
        value
        userId
        handle
        url
      }
      createdAt
      mediaUrls
      isBoosted
      activeBoostId
      author {
        id
        firstName
        lastName
        title
        middleName
        profileImageUrl
        role
        companyName
      }
      companyAuthor {
        id
        name
        logoUrl
        industry
        tagline
      }
      poll {
        question
        expiresAt
        options {
          id
          text
          votes
          isChosen
        }
        translatedQuestion
        translatedOptions
      }
      occasion {
        id
        postId
        title
        description
        imageUrl
        privacy
        translatedTitle
        translatedDescription
      }
    }
  }
}
    `;

/**
 * __useGetCompanyPostsQuery__
 *
 * To run a query within a React component, call `useGetCompanyPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyPostsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCompanyPostsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyPostsQuery, GetCompanyPostsQueryVariables> & ({ variables: GetCompanyPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyPostsQuery, GetCompanyPostsQueryVariables>(GetCompanyPostsDocument, options);
      }
export function useGetCompanyPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyPostsQuery, GetCompanyPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyPostsQuery, GetCompanyPostsQueryVariables>(GetCompanyPostsDocument, options);
        }
// @ts-ignore
export function useGetCompanyPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyPostsQuery, GetCompanyPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyPostsQuery, GetCompanyPostsQueryVariables>;
export function useGetCompanyPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyPostsQuery, GetCompanyPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyPostsQuery | undefined, GetCompanyPostsQueryVariables>;
export function useGetCompanyPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyPostsQuery, GetCompanyPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyPostsQuery, GetCompanyPostsQueryVariables>(GetCompanyPostsDocument, options);
        }
export type GetCompanyPostsQueryHookResult = ReturnType<typeof useGetCompanyPostsQuery>;
export type GetCompanyPostsLazyQueryHookResult = ReturnType<typeof useGetCompanyPostsLazyQuery>;
export type GetCompanyPostsSuspenseQueryHookResult = ReturnType<typeof useGetCompanyPostsSuspenseQuery>;
export type GetCompanyPostsQueryResult = Apollo.QueryResult<GetCompanyPostsQuery, GetCompanyPostsQueryVariables>;
export const FollowCompanyDocument = gql`
    mutation FollowCompany($companyId: String!) {
  followCompany(companyId: $companyId)
}
    `;
export type FollowCompanyMutationFn = Apollo.MutationFunction<FollowCompanyMutation, FollowCompanyMutationVariables>;

/**
 * __useFollowCompanyMutation__
 *
 * To run a mutation, you first call `useFollowCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followCompanyMutation, { data, loading, error }] = useFollowCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useFollowCompanyMutation(baseOptions?: Apollo.MutationHookOptions<FollowCompanyMutation, FollowCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowCompanyMutation, FollowCompanyMutationVariables>(FollowCompanyDocument, options);
      }
export type FollowCompanyMutationHookResult = ReturnType<typeof useFollowCompanyMutation>;
export type FollowCompanyMutationResult = Apollo.MutationResult<FollowCompanyMutation>;
export type FollowCompanyMutationOptions = Apollo.BaseMutationOptions<FollowCompanyMutation, FollowCompanyMutationVariables>;
export const UnfollowCompanyDocument = gql`
    mutation UnfollowCompany($companyId: String!) {
  unfollowCompany(companyId: $companyId)
}
    `;
export type UnfollowCompanyMutationFn = Apollo.MutationFunction<UnfollowCompanyMutation, UnfollowCompanyMutationVariables>;

/**
 * __useUnfollowCompanyMutation__
 *
 * To run a mutation, you first call `useUnfollowCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowCompanyMutation, { data, loading, error }] = useUnfollowCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useUnfollowCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowCompanyMutation, UnfollowCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowCompanyMutation, UnfollowCompanyMutationVariables>(UnfollowCompanyDocument, options);
      }
export type UnfollowCompanyMutationHookResult = ReturnType<typeof useUnfollowCompanyMutation>;
export type UnfollowCompanyMutationResult = Apollo.MutationResult<UnfollowCompanyMutation>;
export type UnfollowCompanyMutationOptions = Apollo.BaseMutationOptions<UnfollowCompanyMutation, UnfollowCompanyMutationVariables>;
export const RemoveCompanyFollowerDocument = gql`
    mutation RemoveCompanyFollower($companyId: String!, $userId: String!) {
  removeCompanyFollower(companyId: $companyId, userId: $userId)
}
    `;
export type RemoveCompanyFollowerMutationFn = Apollo.MutationFunction<RemoveCompanyFollowerMutation, RemoveCompanyFollowerMutationVariables>;

/**
 * __useRemoveCompanyFollowerMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyFollowerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyFollowerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyFollowerMutation, { data, loading, error }] = useRemoveCompanyFollowerMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveCompanyFollowerMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyFollowerMutation, RemoveCompanyFollowerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyFollowerMutation, RemoveCompanyFollowerMutationVariables>(RemoveCompanyFollowerDocument, options);
      }
export type RemoveCompanyFollowerMutationHookResult = ReturnType<typeof useRemoveCompanyFollowerMutation>;
export type RemoveCompanyFollowerMutationResult = Apollo.MutationResult<RemoveCompanyFollowerMutation>;
export type RemoveCompanyFollowerMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyFollowerMutation, RemoveCompanyFollowerMutationVariables>;
export const BlockCompanyFollowerDocument = gql`
    mutation BlockCompanyFollower($companyId: String!, $userId: String!) {
  blockCompanyFollower(companyId: $companyId, userId: $userId)
}
    `;
export type BlockCompanyFollowerMutationFn = Apollo.MutationFunction<BlockCompanyFollowerMutation, BlockCompanyFollowerMutationVariables>;

/**
 * __useBlockCompanyFollowerMutation__
 *
 * To run a mutation, you first call `useBlockCompanyFollowerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockCompanyFollowerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockCompanyFollowerMutation, { data, loading, error }] = useBlockCompanyFollowerMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBlockCompanyFollowerMutation(baseOptions?: Apollo.MutationHookOptions<BlockCompanyFollowerMutation, BlockCompanyFollowerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockCompanyFollowerMutation, BlockCompanyFollowerMutationVariables>(BlockCompanyFollowerDocument, options);
      }
export type BlockCompanyFollowerMutationHookResult = ReturnType<typeof useBlockCompanyFollowerMutation>;
export type BlockCompanyFollowerMutationResult = Apollo.MutationResult<BlockCompanyFollowerMutation>;
export type BlockCompanyFollowerMutationOptions = Apollo.BaseMutationOptions<BlockCompanyFollowerMutation, BlockCompanyFollowerMutationVariables>;
export const UnblockCompanyFollowerDocument = gql`
    mutation UnblockCompanyFollower($companyId: String!, $userId: String!) {
  unblockCompanyFollower(companyId: $companyId, userId: $userId)
}
    `;
export type UnblockCompanyFollowerMutationFn = Apollo.MutationFunction<UnblockCompanyFollowerMutation, UnblockCompanyFollowerMutationVariables>;

/**
 * __useUnblockCompanyFollowerMutation__
 *
 * To run a mutation, you first call `useUnblockCompanyFollowerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockCompanyFollowerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockCompanyFollowerMutation, { data, loading, error }] = useUnblockCompanyFollowerMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnblockCompanyFollowerMutation(baseOptions?: Apollo.MutationHookOptions<UnblockCompanyFollowerMutation, UnblockCompanyFollowerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnblockCompanyFollowerMutation, UnblockCompanyFollowerMutationVariables>(UnblockCompanyFollowerDocument, options);
      }
export type UnblockCompanyFollowerMutationHookResult = ReturnType<typeof useUnblockCompanyFollowerMutation>;
export type UnblockCompanyFollowerMutationResult = Apollo.MutationResult<UnblockCompanyFollowerMutation>;
export type UnblockCompanyFollowerMutationOptions = Apollo.BaseMutationOptions<UnblockCompanyFollowerMutation, UnblockCompanyFollowerMutationVariables>;
export const IsFollowingCompanyDocument = gql`
    query IsFollowingCompany($companyId: String!) {
  isFollowingCompany(companyId: $companyId)
}
    `;

/**
 * __useIsFollowingCompanyQuery__
 *
 * To run a query within a React component, call `useIsFollowingCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsFollowingCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsFollowingCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useIsFollowingCompanyQuery(baseOptions: Apollo.QueryHookOptions<IsFollowingCompanyQuery, IsFollowingCompanyQueryVariables> & ({ variables: IsFollowingCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsFollowingCompanyQuery, IsFollowingCompanyQueryVariables>(IsFollowingCompanyDocument, options);
      }
export function useIsFollowingCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsFollowingCompanyQuery, IsFollowingCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsFollowingCompanyQuery, IsFollowingCompanyQueryVariables>(IsFollowingCompanyDocument, options);
        }
// @ts-ignore
export function useIsFollowingCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsFollowingCompanyQuery, IsFollowingCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<IsFollowingCompanyQuery, IsFollowingCompanyQueryVariables>;
export function useIsFollowingCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsFollowingCompanyQuery, IsFollowingCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<IsFollowingCompanyQuery | undefined, IsFollowingCompanyQueryVariables>;
export function useIsFollowingCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsFollowingCompanyQuery, IsFollowingCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsFollowingCompanyQuery, IsFollowingCompanyQueryVariables>(IsFollowingCompanyDocument, options);
        }
export type IsFollowingCompanyQueryHookResult = ReturnType<typeof useIsFollowingCompanyQuery>;
export type IsFollowingCompanyLazyQueryHookResult = ReturnType<typeof useIsFollowingCompanyLazyQuery>;
export type IsFollowingCompanySuspenseQueryHookResult = ReturnType<typeof useIsFollowingCompanySuspenseQuery>;
export type IsFollowingCompanyQueryResult = Apollo.QueryResult<IsFollowingCompanyQuery, IsFollowingCompanyQueryVariables>;
export const GetCompanyFollowersCountDocument = gql`
    query GetCompanyFollowersCount($companyId: String!) {
  getCompanyFollowersCount(companyId: $companyId)
}
    `;

/**
 * __useGetCompanyFollowersCountQuery__
 *
 * To run a query within a React component, call `useGetCompanyFollowersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyFollowersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyFollowersCountQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyFollowersCountQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyFollowersCountQuery, GetCompanyFollowersCountQueryVariables> & ({ variables: GetCompanyFollowersCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyFollowersCountQuery, GetCompanyFollowersCountQueryVariables>(GetCompanyFollowersCountDocument, options);
      }
export function useGetCompanyFollowersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyFollowersCountQuery, GetCompanyFollowersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyFollowersCountQuery, GetCompanyFollowersCountQueryVariables>(GetCompanyFollowersCountDocument, options);
        }
// @ts-ignore
export function useGetCompanyFollowersCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyFollowersCountQuery, GetCompanyFollowersCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyFollowersCountQuery, GetCompanyFollowersCountQueryVariables>;
export function useGetCompanyFollowersCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyFollowersCountQuery, GetCompanyFollowersCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyFollowersCountQuery | undefined, GetCompanyFollowersCountQueryVariables>;
export function useGetCompanyFollowersCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyFollowersCountQuery, GetCompanyFollowersCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyFollowersCountQuery, GetCompanyFollowersCountQueryVariables>(GetCompanyFollowersCountDocument, options);
        }
export type GetCompanyFollowersCountQueryHookResult = ReturnType<typeof useGetCompanyFollowersCountQuery>;
export type GetCompanyFollowersCountLazyQueryHookResult = ReturnType<typeof useGetCompanyFollowersCountLazyQuery>;
export type GetCompanyFollowersCountSuspenseQueryHookResult = ReturnType<typeof useGetCompanyFollowersCountSuspenseQuery>;
export type GetCompanyFollowersCountQueryResult = Apollo.QueryResult<GetCompanyFollowersCountQuery, GetCompanyFollowersCountQueryVariables>;
export const GetSuggestedCompaniesDocument = gql`
    query GetSuggestedCompanies($limit: Int) {
  getSuggestedCompanies(limit: $limit) {
    id
    name
    logoUrl
    industry
    tagline
    size
    followersCount
  }
}
    `;

/**
 * __useGetSuggestedCompaniesQuery__
 *
 * To run a query within a React component, call `useGetSuggestedCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedCompaniesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSuggestedCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetSuggestedCompaniesQuery, GetSuggestedCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestedCompaniesQuery, GetSuggestedCompaniesQueryVariables>(GetSuggestedCompaniesDocument, options);
      }
export function useGetSuggestedCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestedCompaniesQuery, GetSuggestedCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestedCompaniesQuery, GetSuggestedCompaniesQueryVariables>(GetSuggestedCompaniesDocument, options);
        }
// @ts-ignore
export function useGetSuggestedCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSuggestedCompaniesQuery, GetSuggestedCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSuggestedCompaniesQuery, GetSuggestedCompaniesQueryVariables>;
export function useGetSuggestedCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuggestedCompaniesQuery, GetSuggestedCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSuggestedCompaniesQuery | undefined, GetSuggestedCompaniesQueryVariables>;
export function useGetSuggestedCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuggestedCompaniesQuery, GetSuggestedCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuggestedCompaniesQuery, GetSuggestedCompaniesQueryVariables>(GetSuggestedCompaniesDocument, options);
        }
export type GetSuggestedCompaniesQueryHookResult = ReturnType<typeof useGetSuggestedCompaniesQuery>;
export type GetSuggestedCompaniesLazyQueryHookResult = ReturnType<typeof useGetSuggestedCompaniesLazyQuery>;
export type GetSuggestedCompaniesSuspenseQueryHookResult = ReturnType<typeof useGetSuggestedCompaniesSuspenseQuery>;
export type GetSuggestedCompaniesQueryResult = Apollo.QueryResult<GetSuggestedCompaniesQuery, GetSuggestedCompaniesQueryVariables>;
export const GetFollowedCompaniesDocument = gql`
    query GetFollowedCompanies($page: Int, $limit: Int) {
  getFollowedCompanies(page: $page, limit: $limit) {
    id
    name
    logoUrl
    industry
    tagline
    size
    followersCount
  }
}
    `;

/**
 * __useGetFollowedCompaniesQuery__
 *
 * To run a query within a React component, call `useGetFollowedCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFollowedCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFollowedCompaniesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetFollowedCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetFollowedCompaniesQuery, GetFollowedCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFollowedCompaniesQuery, GetFollowedCompaniesQueryVariables>(GetFollowedCompaniesDocument, options);
      }
export function useGetFollowedCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFollowedCompaniesQuery, GetFollowedCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFollowedCompaniesQuery, GetFollowedCompaniesQueryVariables>(GetFollowedCompaniesDocument, options);
        }
// @ts-ignore
export function useGetFollowedCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFollowedCompaniesQuery, GetFollowedCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFollowedCompaniesQuery, GetFollowedCompaniesQueryVariables>;
export function useGetFollowedCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFollowedCompaniesQuery, GetFollowedCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFollowedCompaniesQuery | undefined, GetFollowedCompaniesQueryVariables>;
export function useGetFollowedCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFollowedCompaniesQuery, GetFollowedCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFollowedCompaniesQuery, GetFollowedCompaniesQueryVariables>(GetFollowedCompaniesDocument, options);
        }
export type GetFollowedCompaniesQueryHookResult = ReturnType<typeof useGetFollowedCompaniesQuery>;
export type GetFollowedCompaniesLazyQueryHookResult = ReturnType<typeof useGetFollowedCompaniesLazyQuery>;
export type GetFollowedCompaniesSuspenseQueryHookResult = ReturnType<typeof useGetFollowedCompaniesSuspenseQuery>;
export type GetFollowedCompaniesQueryResult = Apollo.QueryResult<GetFollowedCompaniesQuery, GetFollowedCompaniesQueryVariables>;
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($id: String!, $input: UpdateCompanyInput!) {
  updateCompany(id: $id, input: $input) {
    id
    name
    tagline
    industry
    size
    website
    city
    country
    orgType
    mission
    story
  }
}
    `;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const TogglePinPostDocument = gql`
    mutation TogglePinPost($postId: String!) {
  togglePinPost(postId: $postId)
}
    `;
export type TogglePinPostMutationFn = Apollo.MutationFunction<TogglePinPostMutation, TogglePinPostMutationVariables>;

/**
 * __useTogglePinPostMutation__
 *
 * To run a mutation, you first call `useTogglePinPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePinPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePinPostMutation, { data, loading, error }] = useTogglePinPostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useTogglePinPostMutation(baseOptions?: Apollo.MutationHookOptions<TogglePinPostMutation, TogglePinPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TogglePinPostMutation, TogglePinPostMutationVariables>(TogglePinPostDocument, options);
      }
export type TogglePinPostMutationHookResult = ReturnType<typeof useTogglePinPostMutation>;
export type TogglePinPostMutationResult = Apollo.MutationResult<TogglePinPostMutation>;
export type TogglePinPostMutationOptions = Apollo.BaseMutationOptions<TogglePinPostMutation, TogglePinPostMutationVariables>;
export const GetRelatedPagesDocument = gql`
    query GetRelatedPages($companyId: String!) {
  relatedPages(companyId: $companyId) {
    id
    name
    logoUrl
    industry
    tagline
    slug
    type
  }
}
    `;

/**
 * __useGetRelatedPagesQuery__
 *
 * To run a query within a React component, call `useGetRelatedPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelatedPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelatedPagesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetRelatedPagesQuery(baseOptions: Apollo.QueryHookOptions<GetRelatedPagesQuery, GetRelatedPagesQueryVariables> & ({ variables: GetRelatedPagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelatedPagesQuery, GetRelatedPagesQueryVariables>(GetRelatedPagesDocument, options);
      }
export function useGetRelatedPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelatedPagesQuery, GetRelatedPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelatedPagesQuery, GetRelatedPagesQueryVariables>(GetRelatedPagesDocument, options);
        }
// @ts-ignore
export function useGetRelatedPagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRelatedPagesQuery, GetRelatedPagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRelatedPagesQuery, GetRelatedPagesQueryVariables>;
export function useGetRelatedPagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRelatedPagesQuery, GetRelatedPagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRelatedPagesQuery | undefined, GetRelatedPagesQueryVariables>;
export function useGetRelatedPagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRelatedPagesQuery, GetRelatedPagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRelatedPagesQuery, GetRelatedPagesQueryVariables>(GetRelatedPagesDocument, options);
        }
export type GetRelatedPagesQueryHookResult = ReturnType<typeof useGetRelatedPagesQuery>;
export type GetRelatedPagesLazyQueryHookResult = ReturnType<typeof useGetRelatedPagesLazyQuery>;
export type GetRelatedPagesSuspenseQueryHookResult = ReturnType<typeof useGetRelatedPagesSuspenseQuery>;
export type GetRelatedPagesQueryResult = Apollo.QueryResult<GetRelatedPagesQuery, GetRelatedPagesQueryVariables>;
export const FindCompaniesDocument = gql`
    query FindCompanies($input: SearchCompaniesInput!) {
  searchCompanies(input: $input) {
    id
    name
    logoUrl
    industry
    tagline
    slug
  }
}
    `;

/**
 * __useFindCompaniesQuery__
 *
 * To run a query within a React component, call `useFindCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCompaniesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindCompaniesQuery(baseOptions: Apollo.QueryHookOptions<FindCompaniesQuery, FindCompaniesQueryVariables> & ({ variables: FindCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCompaniesQuery, FindCompaniesQueryVariables>(FindCompaniesDocument, options);
      }
export function useFindCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCompaniesQuery, FindCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCompaniesQuery, FindCompaniesQueryVariables>(FindCompaniesDocument, options);
        }
// @ts-ignore
export function useFindCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindCompaniesQuery, FindCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<FindCompaniesQuery, FindCompaniesQueryVariables>;
export function useFindCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindCompaniesQuery, FindCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<FindCompaniesQuery | undefined, FindCompaniesQueryVariables>;
export function useFindCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindCompaniesQuery, FindCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindCompaniesQuery, FindCompaniesQueryVariables>(FindCompaniesDocument, options);
        }
export type FindCompaniesQueryHookResult = ReturnType<typeof useFindCompaniesQuery>;
export type FindCompaniesLazyQueryHookResult = ReturnType<typeof useFindCompaniesLazyQuery>;
export type FindCompaniesSuspenseQueryHookResult = ReturnType<typeof useFindCompaniesSuspenseQuery>;
export type FindCompaniesQueryResult = Apollo.QueryResult<FindCompaniesQuery, FindCompaniesQueryVariables>;
export const CompanyFollowersDocument = gql`
    query CompanyFollowers($companyId: String!, $page: Int, $limit: Int) {
  companyFollowers(companyId: $companyId, page: $page, limit: $limit) {
    users {
      id
      firstName
      lastName
      title
      profileImageUrl
      role
      companyName
    }
    totalCount
    hasMore
  }
}
    `;

/**
 * __useCompanyFollowersQuery__
 *
 * To run a query within a React component, call `useCompanyFollowersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyFollowersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyFollowersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCompanyFollowersQuery(baseOptions: Apollo.QueryHookOptions<CompanyFollowersQuery, CompanyFollowersQueryVariables> & ({ variables: CompanyFollowersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyFollowersQuery, CompanyFollowersQueryVariables>(CompanyFollowersDocument, options);
      }
export function useCompanyFollowersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyFollowersQuery, CompanyFollowersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyFollowersQuery, CompanyFollowersQueryVariables>(CompanyFollowersDocument, options);
        }
// @ts-ignore
export function useCompanyFollowersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyFollowersQuery, CompanyFollowersQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyFollowersQuery, CompanyFollowersQueryVariables>;
export function useCompanyFollowersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyFollowersQuery, CompanyFollowersQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyFollowersQuery | undefined, CompanyFollowersQueryVariables>;
export function useCompanyFollowersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyFollowersQuery, CompanyFollowersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyFollowersQuery, CompanyFollowersQueryVariables>(CompanyFollowersDocument, options);
        }
export type CompanyFollowersQueryHookResult = ReturnType<typeof useCompanyFollowersQuery>;
export type CompanyFollowersLazyQueryHookResult = ReturnType<typeof useCompanyFollowersLazyQuery>;
export type CompanyFollowersSuspenseQueryHookResult = ReturnType<typeof useCompanyFollowersSuspenseQuery>;
export type CompanyFollowersQueryResult = Apollo.QueryResult<CompanyFollowersQuery, CompanyFollowersQueryVariables>;
export const CompanyBlockedFollowersDocument = gql`
    query CompanyBlockedFollowers($companyId: String!, $page: Int, $limit: Int) {
  companyBlockedFollowers(companyId: $companyId, page: $page, limit: $limit) {
    users {
      id
      firstName
      lastName
      title
      profileImageUrl
      role
      companyName
    }
    totalCount
    hasMore
  }
}
    `;

/**
 * __useCompanyBlockedFollowersQuery__
 *
 * To run a query within a React component, call `useCompanyBlockedFollowersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyBlockedFollowersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyBlockedFollowersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCompanyBlockedFollowersQuery(baseOptions: Apollo.QueryHookOptions<CompanyBlockedFollowersQuery, CompanyBlockedFollowersQueryVariables> & ({ variables: CompanyBlockedFollowersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyBlockedFollowersQuery, CompanyBlockedFollowersQueryVariables>(CompanyBlockedFollowersDocument, options);
      }
export function useCompanyBlockedFollowersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyBlockedFollowersQuery, CompanyBlockedFollowersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyBlockedFollowersQuery, CompanyBlockedFollowersQueryVariables>(CompanyBlockedFollowersDocument, options);
        }
// @ts-ignore
export function useCompanyBlockedFollowersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyBlockedFollowersQuery, CompanyBlockedFollowersQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyBlockedFollowersQuery, CompanyBlockedFollowersQueryVariables>;
export function useCompanyBlockedFollowersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyBlockedFollowersQuery, CompanyBlockedFollowersQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyBlockedFollowersQuery | undefined, CompanyBlockedFollowersQueryVariables>;
export function useCompanyBlockedFollowersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyBlockedFollowersQuery, CompanyBlockedFollowersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyBlockedFollowersQuery, CompanyBlockedFollowersQueryVariables>(CompanyBlockedFollowersDocument, options);
        }
export type CompanyBlockedFollowersQueryHookResult = ReturnType<typeof useCompanyBlockedFollowersQuery>;
export type CompanyBlockedFollowersLazyQueryHookResult = ReturnType<typeof useCompanyBlockedFollowersLazyQuery>;
export type CompanyBlockedFollowersSuspenseQueryHookResult = ReturnType<typeof useCompanyBlockedFollowersSuspenseQuery>;
export type CompanyBlockedFollowersQueryResult = Apollo.QueryResult<CompanyBlockedFollowersQuery, CompanyBlockedFollowersQueryVariables>;
export const DeleteCompanyDocument = gql`
    mutation DeleteCompany($companyId: String!) {
  deleteCompany(companyId: $companyId)
}
    `;
export type DeleteCompanyMutationFn = Apollo.MutationFunction<DeleteCompanyMutation, DeleteCompanyMutationVariables>;

/**
 * __useDeleteCompanyMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyMutation, { data, loading, error }] = useDeleteCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDeleteCompanyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyMutation, DeleteCompanyMutationVariables>(DeleteCompanyDocument, options);
      }
export type DeleteCompanyMutationHookResult = ReturnType<typeof useDeleteCompanyMutation>;
export type DeleteCompanyMutationResult = Apollo.MutationResult<DeleteCompanyMutation>;
export type DeleteCompanyMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>;
export const GetFollowedCompanyIdsDocument = gql`
    query GetFollowedCompanyIds {
  getFollowedCompanyIds
}
    `;

/**
 * __useGetFollowedCompanyIdsQuery__
 *
 * To run a query within a React component, call `useGetFollowedCompanyIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFollowedCompanyIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFollowedCompanyIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFollowedCompanyIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetFollowedCompanyIdsQuery, GetFollowedCompanyIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFollowedCompanyIdsQuery, GetFollowedCompanyIdsQueryVariables>(GetFollowedCompanyIdsDocument, options);
      }
export function useGetFollowedCompanyIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFollowedCompanyIdsQuery, GetFollowedCompanyIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFollowedCompanyIdsQuery, GetFollowedCompanyIdsQueryVariables>(GetFollowedCompanyIdsDocument, options);
        }
// @ts-ignore
export function useGetFollowedCompanyIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFollowedCompanyIdsQuery, GetFollowedCompanyIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetFollowedCompanyIdsQuery, GetFollowedCompanyIdsQueryVariables>;
export function useGetFollowedCompanyIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFollowedCompanyIdsQuery, GetFollowedCompanyIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetFollowedCompanyIdsQuery | undefined, GetFollowedCompanyIdsQueryVariables>;
export function useGetFollowedCompanyIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFollowedCompanyIdsQuery, GetFollowedCompanyIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFollowedCompanyIdsQuery, GetFollowedCompanyIdsQueryVariables>(GetFollowedCompanyIdsDocument, options);
        }
export type GetFollowedCompanyIdsQueryHookResult = ReturnType<typeof useGetFollowedCompanyIdsQuery>;
export type GetFollowedCompanyIdsLazyQueryHookResult = ReturnType<typeof useGetFollowedCompanyIdsLazyQuery>;
export type GetFollowedCompanyIdsSuspenseQueryHookResult = ReturnType<typeof useGetFollowedCompanyIdsSuspenseQuery>;
export type GetFollowedCompanyIdsQueryResult = Apollo.QueryResult<GetFollowedCompanyIdsQuery, GetFollowedCompanyIdsQueryVariables>;
export const DeleteCompanyLogoDocument = gql`
    mutation deleteCompanyLogo($companyId: String!) {
  deleteCompanyLogo(companyId: $companyId) {
    id
    logoUrl
  }
}
    `;
export type DeleteCompanyLogoMutationFn = Apollo.MutationFunction<DeleteCompanyLogoMutation, DeleteCompanyLogoMutationVariables>;

/**
 * __useDeleteCompanyLogoMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyLogoMutation, { data, loading, error }] = useDeleteCompanyLogoMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDeleteCompanyLogoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyLogoMutation, DeleteCompanyLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyLogoMutation, DeleteCompanyLogoMutationVariables>(DeleteCompanyLogoDocument, options);
      }
export type DeleteCompanyLogoMutationHookResult = ReturnType<typeof useDeleteCompanyLogoMutation>;
export type DeleteCompanyLogoMutationResult = Apollo.MutationResult<DeleteCompanyLogoMutation>;
export type DeleteCompanyLogoMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyLogoMutation, DeleteCompanyLogoMutationVariables>;
export const DeleteCompanyCoverDocument = gql`
    mutation deleteCompanyCover($companyId: String!) {
  deleteCompanyCover(companyId: $companyId) {
    id
    coverUrl
  }
}
    `;
export type DeleteCompanyCoverMutationFn = Apollo.MutationFunction<DeleteCompanyCoverMutation, DeleteCompanyCoverMutationVariables>;

/**
 * __useDeleteCompanyCoverMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyCoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyCoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyCoverMutation, { data, loading, error }] = useDeleteCompanyCoverMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDeleteCompanyCoverMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyCoverMutation, DeleteCompanyCoverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyCoverMutation, DeleteCompanyCoverMutationVariables>(DeleteCompanyCoverDocument, options);
      }
export type DeleteCompanyCoverMutationHookResult = ReturnType<typeof useDeleteCompanyCoverMutation>;
export type DeleteCompanyCoverMutationResult = Apollo.MutationResult<DeleteCompanyCoverMutation>;
export type DeleteCompanyCoverMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyCoverMutation, DeleteCompanyCoverMutationVariables>;
export const MyCompaniesDocument = gql`
    query MyCompanies {
  myCompanies {
    id
    name
    type
    slug
    coverUrl
    logoUrl
    size
    status
    owner {
      id
      firstName
      lastName
      title
      profileImageUrl
      companyName
    }
    industry
    story
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useMyCompaniesQuery__
 *
 * To run a query within a React component, call `useMyCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<MyCompaniesQuery, MyCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCompaniesQuery, MyCompaniesQueryVariables>(MyCompaniesDocument, options);
      }
export function useMyCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCompaniesQuery, MyCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCompaniesQuery, MyCompaniesQueryVariables>(MyCompaniesDocument, options);
        }
// @ts-ignore
export function useMyCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyCompaniesQuery, MyCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<MyCompaniesQuery, MyCompaniesQueryVariables>;
export function useMyCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyCompaniesQuery, MyCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<MyCompaniesQuery | undefined, MyCompaniesQueryVariables>;
export function useMyCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyCompaniesQuery, MyCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyCompaniesQuery, MyCompaniesQueryVariables>(MyCompaniesDocument, options);
        }
export type MyCompaniesQueryHookResult = ReturnType<typeof useMyCompaniesQuery>;
export type MyCompaniesLazyQueryHookResult = ReturnType<typeof useMyCompaniesLazyQuery>;
export type MyCompaniesSuspenseQueryHookResult = ReturnType<typeof useMyCompaniesSuspenseQuery>;
export type MyCompaniesQueryResult = Apollo.QueryResult<MyCompaniesQuery, MyCompaniesQueryVariables>;
export const CompleteSessionDocument = gql`
    mutation CompleteSession($input: AcceptSessionInput!) {
  completeSession(input: $input)
}
    `;
export type CompleteSessionMutationFn = Apollo.MutationFunction<CompleteSessionMutation, CompleteSessionMutationVariables>;

/**
 * __useCompleteSessionMutation__
 *
 * To run a mutation, you first call `useCompleteSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeSessionMutation, { data, loading, error }] = useCompleteSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteSessionMutation(baseOptions?: Apollo.MutationHookOptions<CompleteSessionMutation, CompleteSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteSessionMutation, CompleteSessionMutationVariables>(CompleteSessionDocument, options);
      }
export type CompleteSessionMutationHookResult = ReturnType<typeof useCompleteSessionMutation>;
export type CompleteSessionMutationResult = Apollo.MutationResult<CompleteSessionMutation>;
export type CompleteSessionMutationOptions = Apollo.BaseMutationOptions<CompleteSessionMutation, CompleteSessionMutationVariables>;
export const SendConnectionRequestDocument = gql`
    mutation SendConnectionRequest($input: SendConnectionRequestInput!) {
  sendConnectionRequest(input: $input)
}
    `;
export type SendConnectionRequestMutationFn = Apollo.MutationFunction<SendConnectionRequestMutation, SendConnectionRequestMutationVariables>;

/**
 * __useSendConnectionRequestMutation__
 *
 * To run a mutation, you first call `useSendConnectionRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendConnectionRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendConnectionRequestMutation, { data, loading, error }] = useSendConnectionRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendConnectionRequestMutation(baseOptions?: Apollo.MutationHookOptions<SendConnectionRequestMutation, SendConnectionRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendConnectionRequestMutation, SendConnectionRequestMutationVariables>(SendConnectionRequestDocument, options);
      }
export type SendConnectionRequestMutationHookResult = ReturnType<typeof useSendConnectionRequestMutation>;
export type SendConnectionRequestMutationResult = Apollo.MutationResult<SendConnectionRequestMutation>;
export type SendConnectionRequestMutationOptions = Apollo.BaseMutationOptions<SendConnectionRequestMutation, SendConnectionRequestMutationVariables>;
export const AcceptConnectionDocument = gql`
    mutation AcceptConnection($input: ConnectionActionInput!) {
  acceptConnection(input: $input)
}
    `;
export type AcceptConnectionMutationFn = Apollo.MutationFunction<AcceptConnectionMutation, AcceptConnectionMutationVariables>;

/**
 * __useAcceptConnectionMutation__
 *
 * To run a mutation, you first call `useAcceptConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptConnectionMutation, { data, loading, error }] = useAcceptConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptConnectionMutation(baseOptions?: Apollo.MutationHookOptions<AcceptConnectionMutation, AcceptConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptConnectionMutation, AcceptConnectionMutationVariables>(AcceptConnectionDocument, options);
      }
export type AcceptConnectionMutationHookResult = ReturnType<typeof useAcceptConnectionMutation>;
export type AcceptConnectionMutationResult = Apollo.MutationResult<AcceptConnectionMutation>;
export type AcceptConnectionMutationOptions = Apollo.BaseMutationOptions<AcceptConnectionMutation, AcceptConnectionMutationVariables>;
export const RejectConnectionDocument = gql`
    mutation RejectConnection($input: ConnectionActionInput!) {
  rejectConnection(input: $input)
}
    `;
export type RejectConnectionMutationFn = Apollo.MutationFunction<RejectConnectionMutation, RejectConnectionMutationVariables>;

/**
 * __useRejectConnectionMutation__
 *
 * To run a mutation, you first call `useRejectConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectConnectionMutation, { data, loading, error }] = useRejectConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectConnectionMutation(baseOptions?: Apollo.MutationHookOptions<RejectConnectionMutation, RejectConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectConnectionMutation, RejectConnectionMutationVariables>(RejectConnectionDocument, options);
      }
export type RejectConnectionMutationHookResult = ReturnType<typeof useRejectConnectionMutation>;
export type RejectConnectionMutationResult = Apollo.MutationResult<RejectConnectionMutation>;
export type RejectConnectionMutationOptions = Apollo.BaseMutationOptions<RejectConnectionMutation, RejectConnectionMutationVariables>;
export const CancelConnectionRequestDocument = gql`
    mutation CancelConnectionRequest($input: DeleteConnectionInput!) {
  cancelConnectionRequest(input: $input)
}
    `;
export type CancelConnectionRequestMutationFn = Apollo.MutationFunction<CancelConnectionRequestMutation, CancelConnectionRequestMutationVariables>;

/**
 * __useCancelConnectionRequestMutation__
 *
 * To run a mutation, you first call `useCancelConnectionRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelConnectionRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelConnectionRequestMutation, { data, loading, error }] = useCancelConnectionRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelConnectionRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelConnectionRequestMutation, CancelConnectionRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelConnectionRequestMutation, CancelConnectionRequestMutationVariables>(CancelConnectionRequestDocument, options);
      }
export type CancelConnectionRequestMutationHookResult = ReturnType<typeof useCancelConnectionRequestMutation>;
export type CancelConnectionRequestMutationResult = Apollo.MutationResult<CancelConnectionRequestMutation>;
export type CancelConnectionRequestMutationOptions = Apollo.BaseMutationOptions<CancelConnectionRequestMutation, CancelConnectionRequestMutationVariables>;
export const DeleteConnectionDocument = gql`
    mutation DeleteConnection($input: DeleteConnectionInput!) {
  deleteConnection(input: $input)
}
    `;
export type DeleteConnectionMutationFn = Apollo.MutationFunction<DeleteConnectionMutation, DeleteConnectionMutationVariables>;

/**
 * __useDeleteConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConnectionMutation, { data, loading, error }] = useDeleteConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteConnectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConnectionMutation, DeleteConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConnectionMutation, DeleteConnectionMutationVariables>(DeleteConnectionDocument, options);
      }
export type DeleteConnectionMutationHookResult = ReturnType<typeof useDeleteConnectionMutation>;
export type DeleteConnectionMutationResult = Apollo.MutationResult<DeleteConnectionMutation>;
export type DeleteConnectionMutationOptions = Apollo.BaseMutationOptions<DeleteConnectionMutation, DeleteConnectionMutationVariables>;
export const GetConnectionStatusDocument = gql`
    query GetConnectionStatus($input: GetConnectionStatusInput!) {
  getConnectionStatus(input: $input) {
    status
    direction
  }
}
    `;

/**
 * __useGetConnectionStatusQuery__
 *
 * To run a query within a React component, call `useGetConnectionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectionStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetConnectionStatusQuery(baseOptions: Apollo.QueryHookOptions<GetConnectionStatusQuery, GetConnectionStatusQueryVariables> & ({ variables: GetConnectionStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectionStatusQuery, GetConnectionStatusQueryVariables>(GetConnectionStatusDocument, options);
      }
export function useGetConnectionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectionStatusQuery, GetConnectionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectionStatusQuery, GetConnectionStatusQueryVariables>(GetConnectionStatusDocument, options);
        }
// @ts-ignore
export function useGetConnectionStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConnectionStatusQuery, GetConnectionStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetConnectionStatusQuery, GetConnectionStatusQueryVariables>;
export function useGetConnectionStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConnectionStatusQuery, GetConnectionStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetConnectionStatusQuery | undefined, GetConnectionStatusQueryVariables>;
export function useGetConnectionStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConnectionStatusQuery, GetConnectionStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConnectionStatusQuery, GetConnectionStatusQueryVariables>(GetConnectionStatusDocument, options);
        }
export type GetConnectionStatusQueryHookResult = ReturnType<typeof useGetConnectionStatusQuery>;
export type GetConnectionStatusLazyQueryHookResult = ReturnType<typeof useGetConnectionStatusLazyQuery>;
export type GetConnectionStatusSuspenseQueryHookResult = ReturnType<typeof useGetConnectionStatusSuspenseQuery>;
export type GetConnectionStatusQueryResult = Apollo.QueryResult<GetConnectionStatusQuery, GetConnectionStatusQueryVariables>;
export const GetConnectionsDocument = gql`
    query GetConnections($limit: Int, $page: Int, $query: String, $status: ConnectionStatus) {
  getConnections(limit: $limit, page: $page, query: $query, status: $status) {
    connections {
      user {
        id
        firstName
        lastName
        title
        profileImageUrl
        headline
        isHiring
        openToWork
        about
        role
        influenceBadge {
          ...InfluenceBadgeFields
        }
        companyName
      }
      status
      direction
      createdAt
      updatedAt
    }
    totalConnections
    hasMore
    page
    limit
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetConnectionsQuery__
 *
 * To run a query within a React component, call `useGetConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      query: // value for 'query'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<GetConnectionsQuery, GetConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectionsQuery, GetConnectionsQueryVariables>(GetConnectionsDocument, options);
      }
export function useGetConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectionsQuery, GetConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectionsQuery, GetConnectionsQueryVariables>(GetConnectionsDocument, options);
        }
// @ts-ignore
export function useGetConnectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConnectionsQuery, GetConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetConnectionsQuery, GetConnectionsQueryVariables>;
export function useGetConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConnectionsQuery, GetConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetConnectionsQuery | undefined, GetConnectionsQueryVariables>;
export function useGetConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConnectionsQuery, GetConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConnectionsQuery, GetConnectionsQueryVariables>(GetConnectionsDocument, options);
        }
export type GetConnectionsQueryHookResult = ReturnType<typeof useGetConnectionsQuery>;
export type GetConnectionsLazyQueryHookResult = ReturnType<typeof useGetConnectionsLazyQuery>;
export type GetConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetConnectionsSuspenseQuery>;
export type GetConnectionsQueryResult = Apollo.QueryResult<GetConnectionsQuery, GetConnectionsQueryVariables>;
export const UserConnectionCountDocument = gql`
    query UserConnectionCount($input: UserConnectionCountInput!) {
  userConnectionCount(input: $input)
}
    `;

/**
 * __useUserConnectionCountQuery__
 *
 * To run a query within a React component, call `useUserConnectionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserConnectionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserConnectionCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserConnectionCountQuery(baseOptions: Apollo.QueryHookOptions<UserConnectionCountQuery, UserConnectionCountQueryVariables> & ({ variables: UserConnectionCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserConnectionCountQuery, UserConnectionCountQueryVariables>(UserConnectionCountDocument, options);
      }
export function useUserConnectionCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserConnectionCountQuery, UserConnectionCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserConnectionCountQuery, UserConnectionCountQueryVariables>(UserConnectionCountDocument, options);
        }
// @ts-ignore
export function useUserConnectionCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserConnectionCountQuery, UserConnectionCountQueryVariables>): Apollo.UseSuspenseQueryResult<UserConnectionCountQuery, UserConnectionCountQueryVariables>;
export function useUserConnectionCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserConnectionCountQuery, UserConnectionCountQueryVariables>): Apollo.UseSuspenseQueryResult<UserConnectionCountQuery | undefined, UserConnectionCountQueryVariables>;
export function useUserConnectionCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserConnectionCountQuery, UserConnectionCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserConnectionCountQuery, UserConnectionCountQueryVariables>(UserConnectionCountDocument, options);
        }
export type UserConnectionCountQueryHookResult = ReturnType<typeof useUserConnectionCountQuery>;
export type UserConnectionCountLazyQueryHookResult = ReturnType<typeof useUserConnectionCountLazyQuery>;
export type UserConnectionCountSuspenseQueryHookResult = ReturnType<typeof useUserConnectionCountSuspenseQuery>;
export type UserConnectionCountQueryResult = Apollo.QueryResult<UserConnectionCountQuery, UserConnectionCountQueryVariables>;
export const GetConnectionByUserIdDocument = gql`
    query GetConnectionByUserId($otherUserId: String!) {
  getConnectionByUserId(otherUserId: $otherUserId) {
    user {
      id
      firstName
      lastName
      title
      companyName
    }
    status
    direction
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetConnectionByUserIdQuery__
 *
 * To run a query within a React component, call `useGetConnectionByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectionByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectionByUserIdQuery({
 *   variables: {
 *      otherUserId: // value for 'otherUserId'
 *   },
 * });
 */
export function useGetConnectionByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetConnectionByUserIdQuery, GetConnectionByUserIdQueryVariables> & ({ variables: GetConnectionByUserIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectionByUserIdQuery, GetConnectionByUserIdQueryVariables>(GetConnectionByUserIdDocument, options);
      }
export function useGetConnectionByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectionByUserIdQuery, GetConnectionByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectionByUserIdQuery, GetConnectionByUserIdQueryVariables>(GetConnectionByUserIdDocument, options);
        }
// @ts-ignore
export function useGetConnectionByUserIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConnectionByUserIdQuery, GetConnectionByUserIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetConnectionByUserIdQuery, GetConnectionByUserIdQueryVariables>;
export function useGetConnectionByUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConnectionByUserIdQuery, GetConnectionByUserIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetConnectionByUserIdQuery | undefined, GetConnectionByUserIdQueryVariables>;
export function useGetConnectionByUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConnectionByUserIdQuery, GetConnectionByUserIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConnectionByUserIdQuery, GetConnectionByUserIdQueryVariables>(GetConnectionByUserIdDocument, options);
        }
export type GetConnectionByUserIdQueryHookResult = ReturnType<typeof useGetConnectionByUserIdQuery>;
export type GetConnectionByUserIdLazyQueryHookResult = ReturnType<typeof useGetConnectionByUserIdLazyQuery>;
export type GetConnectionByUserIdSuspenseQueryHookResult = ReturnType<typeof useGetConnectionByUserIdSuspenseQuery>;
export type GetConnectionByUserIdQueryResult = Apollo.QueryResult<GetConnectionByUserIdQuery, GetConnectionByUserIdQueryVariables>;
export const GetAcceptedConnectionsDocument = gql`
    query GetAcceptedConnections($limit: Int = 10) {
  getAcceptedConnections(limit: $limit) {
    user {
      id
      firstName
      lastName
      title
      profileImageUrl
      headline
      about
      phone
      role
      email
      profileVisitsCount
      influenceBadge {
        ...InfluenceBadgeFields
      }
      companyName
    }
    status
    direction
    createdAt
    updatedAt
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetAcceptedConnectionsQuery__
 *
 * To run a query within a React component, call `useGetAcceptedConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcceptedConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcceptedConnectionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAcceptedConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAcceptedConnectionsQuery, GetAcceptedConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAcceptedConnectionsQuery, GetAcceptedConnectionsQueryVariables>(GetAcceptedConnectionsDocument, options);
      }
export function useGetAcceptedConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAcceptedConnectionsQuery, GetAcceptedConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAcceptedConnectionsQuery, GetAcceptedConnectionsQueryVariables>(GetAcceptedConnectionsDocument, options);
        }
// @ts-ignore
export function useGetAcceptedConnectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAcceptedConnectionsQuery, GetAcceptedConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAcceptedConnectionsQuery, GetAcceptedConnectionsQueryVariables>;
export function useGetAcceptedConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAcceptedConnectionsQuery, GetAcceptedConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAcceptedConnectionsQuery | undefined, GetAcceptedConnectionsQueryVariables>;
export function useGetAcceptedConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAcceptedConnectionsQuery, GetAcceptedConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAcceptedConnectionsQuery, GetAcceptedConnectionsQueryVariables>(GetAcceptedConnectionsDocument, options);
        }
export type GetAcceptedConnectionsQueryHookResult = ReturnType<typeof useGetAcceptedConnectionsQuery>;
export type GetAcceptedConnectionsLazyQueryHookResult = ReturnType<typeof useGetAcceptedConnectionsLazyQuery>;
export type GetAcceptedConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetAcceptedConnectionsSuspenseQuery>;
export type GetAcceptedConnectionsQueryResult = Apollo.QueryResult<GetAcceptedConnectionsQuery, GetAcceptedConnectionsQueryVariables>;
export const GetConnectionRequestsDocument = gql`
    query GetConnectionRequests($input: GetConnectionRequestsInput!) {
  getConnectionRequests(input: $input) {
    connections {
      user {
        id
        firstName
        lastName
        title
        profileImageUrl
        headline
        isHiring
        openToWork
        about
        role
        influenceBadge {
          ...InfluenceBadgeFields
        }
        companyName
      }
      status
      direction
      createdAt
      updatedAt
    }
    totalConnections
    hasMore
    page
    limit
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetConnectionRequestsQuery__
 *
 * To run a query within a React component, call `useGetConnectionRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectionRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectionRequestsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetConnectionRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetConnectionRequestsQuery, GetConnectionRequestsQueryVariables> & ({ variables: GetConnectionRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectionRequestsQuery, GetConnectionRequestsQueryVariables>(GetConnectionRequestsDocument, options);
      }
export function useGetConnectionRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectionRequestsQuery, GetConnectionRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectionRequestsQuery, GetConnectionRequestsQueryVariables>(GetConnectionRequestsDocument, options);
        }
// @ts-ignore
export function useGetConnectionRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConnectionRequestsQuery, GetConnectionRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetConnectionRequestsQuery, GetConnectionRequestsQueryVariables>;
export function useGetConnectionRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConnectionRequestsQuery, GetConnectionRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetConnectionRequestsQuery | undefined, GetConnectionRequestsQueryVariables>;
export function useGetConnectionRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConnectionRequestsQuery, GetConnectionRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConnectionRequestsQuery, GetConnectionRequestsQueryVariables>(GetConnectionRequestsDocument, options);
        }
export type GetConnectionRequestsQueryHookResult = ReturnType<typeof useGetConnectionRequestsQuery>;
export type GetConnectionRequestsLazyQueryHookResult = ReturnType<typeof useGetConnectionRequestsLazyQuery>;
export type GetConnectionRequestsSuspenseQueryHookResult = ReturnType<typeof useGetConnectionRequestsSuspenseQuery>;
export type GetConnectionRequestsQueryResult = Apollo.QueryResult<GetConnectionRequestsQuery, GetConnectionRequestsQueryVariables>;
export const SearchApprovedConnectionsByLetterDocument = gql`
    query SearchApprovedConnectionsByLetter($input: SearchApprovedConnectionsInput!) {
  searchApprovedConnectionsByLetter(input: $input) {
    id
    firstName
    lastName
    title
    profileImageUrl
    role
    headline
    companyName
  }
}
    `;

/**
 * __useSearchApprovedConnectionsByLetterQuery__
 *
 * To run a query within a React component, call `useSearchApprovedConnectionsByLetterQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchApprovedConnectionsByLetterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchApprovedConnectionsByLetterQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchApprovedConnectionsByLetterQuery(baseOptions: Apollo.QueryHookOptions<SearchApprovedConnectionsByLetterQuery, SearchApprovedConnectionsByLetterQueryVariables> & ({ variables: SearchApprovedConnectionsByLetterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchApprovedConnectionsByLetterQuery, SearchApprovedConnectionsByLetterQueryVariables>(SearchApprovedConnectionsByLetterDocument, options);
      }
export function useSearchApprovedConnectionsByLetterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchApprovedConnectionsByLetterQuery, SearchApprovedConnectionsByLetterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchApprovedConnectionsByLetterQuery, SearchApprovedConnectionsByLetterQueryVariables>(SearchApprovedConnectionsByLetterDocument, options);
        }
// @ts-ignore
export function useSearchApprovedConnectionsByLetterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchApprovedConnectionsByLetterQuery, SearchApprovedConnectionsByLetterQueryVariables>): Apollo.UseSuspenseQueryResult<SearchApprovedConnectionsByLetterQuery, SearchApprovedConnectionsByLetterQueryVariables>;
export function useSearchApprovedConnectionsByLetterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchApprovedConnectionsByLetterQuery, SearchApprovedConnectionsByLetterQueryVariables>): Apollo.UseSuspenseQueryResult<SearchApprovedConnectionsByLetterQuery | undefined, SearchApprovedConnectionsByLetterQueryVariables>;
export function useSearchApprovedConnectionsByLetterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchApprovedConnectionsByLetterQuery, SearchApprovedConnectionsByLetterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchApprovedConnectionsByLetterQuery, SearchApprovedConnectionsByLetterQueryVariables>(SearchApprovedConnectionsByLetterDocument, options);
        }
export type SearchApprovedConnectionsByLetterQueryHookResult = ReturnType<typeof useSearchApprovedConnectionsByLetterQuery>;
export type SearchApprovedConnectionsByLetterLazyQueryHookResult = ReturnType<typeof useSearchApprovedConnectionsByLetterLazyQuery>;
export type SearchApprovedConnectionsByLetterSuspenseQueryHookResult = ReturnType<typeof useSearchApprovedConnectionsByLetterSuspenseQuery>;
export type SearchApprovedConnectionsByLetterQueryResult = Apollo.QueryResult<SearchApprovedConnectionsByLetterQuery, SearchApprovedConnectionsByLetterQueryVariables>;
export const AddContactDocument = gql`
    mutation AddContact($input: AddContactInput!) {
  addContact(input: $input)
}
    `;
export type AddContactMutationFn = Apollo.MutationFunction<AddContactMutation, AddContactMutationVariables>;

/**
 * __useAddContactMutation__
 *
 * To run a mutation, you first call `useAddContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactMutation, { data, loading, error }] = useAddContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddContactMutation(baseOptions?: Apollo.MutationHookOptions<AddContactMutation, AddContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContactMutation, AddContactMutationVariables>(AddContactDocument, options);
      }
export type AddContactMutationHookResult = ReturnType<typeof useAddContactMutation>;
export type AddContactMutationResult = Apollo.MutationResult<AddContactMutation>;
export type AddContactMutationOptions = Apollo.BaseMutationOptions<AddContactMutation, AddContactMutationVariables>;
export const DeleteContactDocument = gql`
    mutation DeleteContact($input: DeleteContactInput!) {
  deleteContact(input: $input)
}
    `;
export type DeleteContactMutationFn = Apollo.MutationFunction<DeleteContactMutation, DeleteContactMutationVariables>;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactMutation, DeleteContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactMutation, DeleteContactMutationVariables>(DeleteContactDocument, options);
      }
export type DeleteContactMutationHookResult = ReturnType<typeof useDeleteContactMutation>;
export type DeleteContactMutationResult = Apollo.MutationResult<DeleteContactMutation>;
export type DeleteContactMutationOptions = Apollo.BaseMutationOptions<DeleteContactMutation, DeleteContactMutationVariables>;
export const EditContactDocument = gql`
    mutation EditContact($input: EditContactInput!) {
  editContact(input: $input)
}
    `;
export type EditContactMutationFn = Apollo.MutationFunction<EditContactMutation, EditContactMutationVariables>;

/**
 * __useEditContactMutation__
 *
 * To run a mutation, you first call `useEditContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editContactMutation, { data, loading, error }] = useEditContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditContactMutation(baseOptions?: Apollo.MutationHookOptions<EditContactMutation, EditContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditContactMutation, EditContactMutationVariables>(EditContactDocument, options);
      }
export type EditContactMutationHookResult = ReturnType<typeof useEditContactMutation>;
export type EditContactMutationResult = Apollo.MutationResult<EditContactMutation>;
export type EditContactMutationOptions = Apollo.BaseMutationOptions<EditContactMutation, EditContactMutationVariables>;
export const FindExistingConversationDocument = gql`
    query FindExistingConversation($receiverId: String!) {
  findExistingConversation(receiverId: $receiverId) {
    id
    type
    lastMessage
    lastMessageAt
    companyId
    user {
      id
      name
      profileImageUrl
      role
      companyName
    }
  }
}
    `;

/**
 * __useFindExistingConversationQuery__
 *
 * To run a query within a React component, call `useFindExistingConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindExistingConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindExistingConversationQuery({
 *   variables: {
 *      receiverId: // value for 'receiverId'
 *   },
 * });
 */
export function useFindExistingConversationQuery(baseOptions: Apollo.QueryHookOptions<FindExistingConversationQuery, FindExistingConversationQueryVariables> & ({ variables: FindExistingConversationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindExistingConversationQuery, FindExistingConversationQueryVariables>(FindExistingConversationDocument, options);
      }
export function useFindExistingConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindExistingConversationQuery, FindExistingConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindExistingConversationQuery, FindExistingConversationQueryVariables>(FindExistingConversationDocument, options);
        }
// @ts-ignore
export function useFindExistingConversationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindExistingConversationQuery, FindExistingConversationQueryVariables>): Apollo.UseSuspenseQueryResult<FindExistingConversationQuery, FindExistingConversationQueryVariables>;
export function useFindExistingConversationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindExistingConversationQuery, FindExistingConversationQueryVariables>): Apollo.UseSuspenseQueryResult<FindExistingConversationQuery | undefined, FindExistingConversationQueryVariables>;
export function useFindExistingConversationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindExistingConversationQuery, FindExistingConversationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindExistingConversationQuery, FindExistingConversationQueryVariables>(FindExistingConversationDocument, options);
        }
export type FindExistingConversationQueryHookResult = ReturnType<typeof useFindExistingConversationQuery>;
export type FindExistingConversationLazyQueryHookResult = ReturnType<typeof useFindExistingConversationLazyQuery>;
export type FindExistingConversationSuspenseQueryHookResult = ReturnType<typeof useFindExistingConversationSuspenseQuery>;
export type FindExistingConversationQueryResult = Apollo.QueryResult<FindExistingConversationQuery, FindExistingConversationQueryVariables>;
export const MarkConversationAsReadDocument = gql`
    mutation MarkConversationAsRead($conversationId: String!) {
  markConversationAsRead(conversationId: $conversationId)
}
    `;
export type MarkConversationAsReadMutationFn = Apollo.MutationFunction<MarkConversationAsReadMutation, MarkConversationAsReadMutationVariables>;

/**
 * __useMarkConversationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkConversationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkConversationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markConversationAsReadMutation, { data, loading, error }] = useMarkConversationAsReadMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useMarkConversationAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkConversationAsReadMutation, MarkConversationAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkConversationAsReadMutation, MarkConversationAsReadMutationVariables>(MarkConversationAsReadDocument, options);
      }
export type MarkConversationAsReadMutationHookResult = ReturnType<typeof useMarkConversationAsReadMutation>;
export type MarkConversationAsReadMutationResult = Apollo.MutationResult<MarkConversationAsReadMutation>;
export type MarkConversationAsReadMutationOptions = Apollo.BaseMutationOptions<MarkConversationAsReadMutation, MarkConversationAsReadMutationVariables>;
export const DeleteMessageDocument = gql`
    mutation DeleteMessage($messageId: String!) {
  deleteMessage(messageId: $messageId)
}
    `;
export type DeleteMessageMutationFn = Apollo.MutationFunction<DeleteMessageMutation, DeleteMessageMutationVariables>;

/**
 * __useDeleteMessageMutation__
 *
 * To run a mutation, you first call `useDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageMutation, { data, loading, error }] = useDeleteMessageMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useDeleteMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMessageMutation, DeleteMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMessageMutation, DeleteMessageMutationVariables>(DeleteMessageDocument, options);
      }
export type DeleteMessageMutationHookResult = ReturnType<typeof useDeleteMessageMutation>;
export type DeleteMessageMutationResult = Apollo.MutationResult<DeleteMessageMutation>;
export type DeleteMessageMutationOptions = Apollo.BaseMutationOptions<DeleteMessageMutation, DeleteMessageMutationVariables>;
export const CreateNewCourseDocument = gql`
    mutation CreateNewCourse($input: CreateCourseInput!) {
  createCourse(createCourseInput: $input) {
    id
    title
    description
    category
    subcategory
    difficultyLevel
    language
    durationMinutes
    isPublished
    thumbnailUrl
    introVideoUrl
    createdAt
    modules {
      id
      name
      orderIndex
      lectures {
        id
        title
        summary
        videoUrl
        handoutDocumentsUrl
        duration
        orderIndex
      }
      quizzes {
        id
        title
        description
        passingScore
        orderIndex
        isPublished
        questions {
          id
          questionText
          questionType
          orderIndex
          points
          options {
            id
            optionText
            isCorrect
            orderIndex
          }
        }
      }
      documents {
        id
        title
        description
        documentUrl
        orderIndex
      }
    }
  }
}
    `;
export type CreateNewCourseMutationFn = Apollo.MutationFunction<CreateNewCourseMutation, CreateNewCourseMutationVariables>;

/**
 * __useCreateNewCourseMutation__
 *
 * To run a mutation, you first call `useCreateNewCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewCourseMutation, { data, loading, error }] = useCreateNewCourseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewCourseMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewCourseMutation, CreateNewCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewCourseMutation, CreateNewCourseMutationVariables>(CreateNewCourseDocument, options);
      }
export type CreateNewCourseMutationHookResult = ReturnType<typeof useCreateNewCourseMutation>;
export type CreateNewCourseMutationResult = Apollo.MutationResult<CreateNewCourseMutation>;
export type CreateNewCourseMutationOptions = Apollo.BaseMutationOptions<CreateNewCourseMutation, CreateNewCourseMutationVariables>;
export const UpdateCourseDocument = gql`
    mutation UpdateCourse($updateCourseInput: UpdateCourseInput!) {
  updateCourse(updateCourseInput: $updateCourseInput) {
    id
    title
    description
    category
    subcategory
    difficultyLevel
    language
    durationMinutes
    isPublished
    thumbnailUrl
    introVideoUrl
    instructorId
    createdAt
    updatedAt
    modules {
      id
      name
      orderIndex
      lectures {
        id
        title
        summary
        videoUrl
        handoutDocumentsUrl
        duration
        orderIndex
      }
      quizzes {
        id
        title
        description
        passingScore
        orderIndex
        isPublished
        questions {
          id
          questionText
          questionType
          orderIndex
          points
          options {
            id
            optionText
            isCorrect
            orderIndex
          }
        }
      }
      documents {
        id
        title
        description
        documentUrl
        orderIndex
      }
    }
  }
}
    `;
export type UpdateCourseMutationFn = Apollo.MutationFunction<UpdateCourseMutation, UpdateCourseMutationVariables>;

/**
 * __useUpdateCourseMutation__
 *
 * To run a mutation, you first call `useUpdateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseMutation, { data, loading, error }] = useUpdateCourseMutation({
 *   variables: {
 *      updateCourseInput: // value for 'updateCourseInput'
 *   },
 * });
 */
export function useUpdateCourseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCourseMutation, UpdateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCourseMutation, UpdateCourseMutationVariables>(UpdateCourseDocument, options);
      }
export type UpdateCourseMutationHookResult = ReturnType<typeof useUpdateCourseMutation>;
export type UpdateCourseMutationResult = Apollo.MutationResult<UpdateCourseMutation>;
export type UpdateCourseMutationOptions = Apollo.BaseMutationOptions<UpdateCourseMutation, UpdateCourseMutationVariables>;
export const DeleteCourseDocument = gql`
    mutation DeleteCourse($id: String!) {
  removeCourse(id: $id) {
    id
    title
    description
  }
}
    `;
export type DeleteCourseMutationFn = Apollo.MutationFunction<DeleteCourseMutation, DeleteCourseMutationVariables>;

/**
 * __useDeleteCourseMutation__
 *
 * To run a mutation, you first call `useDeleteCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCourseMutation, { data, loading, error }] = useDeleteCourseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCourseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCourseMutation, DeleteCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCourseMutation, DeleteCourseMutationVariables>(DeleteCourseDocument, options);
      }
export type DeleteCourseMutationHookResult = ReturnType<typeof useDeleteCourseMutation>;
export type DeleteCourseMutationResult = Apollo.MutationResult<DeleteCourseMutation>;
export type DeleteCourseMutationOptions = Apollo.BaseMutationOptions<DeleteCourseMutation, DeleteCourseMutationVariables>;
export const GetMyCoursesWithPaginationDocument = gql`
    query GetMyCoursesWithPagination($page: Int!, $limit: Int!) {
  myCourses(pagination: {page: $page, limit: $limit}) {
    data {
      id
      title
      description
      category
      language
      difficultyLevel
      durationMinutes
      isPublished
      createdAt
      updatedAt
    }
    total
    page
    limit
    totalPages
    hasMore
  }
}
    `;

/**
 * __useGetMyCoursesWithPaginationQuery__
 *
 * To run a query within a React component, call `useGetMyCoursesWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCoursesWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCoursesWithPaginationQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMyCoursesWithPaginationQuery(baseOptions: Apollo.QueryHookOptions<GetMyCoursesWithPaginationQuery, GetMyCoursesWithPaginationQueryVariables> & ({ variables: GetMyCoursesWithPaginationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCoursesWithPaginationQuery, GetMyCoursesWithPaginationQueryVariables>(GetMyCoursesWithPaginationDocument, options);
      }
export function useGetMyCoursesWithPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCoursesWithPaginationQuery, GetMyCoursesWithPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCoursesWithPaginationQuery, GetMyCoursesWithPaginationQueryVariables>(GetMyCoursesWithPaginationDocument, options);
        }
// @ts-ignore
export function useGetMyCoursesWithPaginationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyCoursesWithPaginationQuery, GetMyCoursesWithPaginationQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyCoursesWithPaginationQuery, GetMyCoursesWithPaginationQueryVariables>;
export function useGetMyCoursesWithPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyCoursesWithPaginationQuery, GetMyCoursesWithPaginationQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyCoursesWithPaginationQuery | undefined, GetMyCoursesWithPaginationQueryVariables>;
export function useGetMyCoursesWithPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyCoursesWithPaginationQuery, GetMyCoursesWithPaginationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCoursesWithPaginationQuery, GetMyCoursesWithPaginationQueryVariables>(GetMyCoursesWithPaginationDocument, options);
        }
export type GetMyCoursesWithPaginationQueryHookResult = ReturnType<typeof useGetMyCoursesWithPaginationQuery>;
export type GetMyCoursesWithPaginationLazyQueryHookResult = ReturnType<typeof useGetMyCoursesWithPaginationLazyQuery>;
export type GetMyCoursesWithPaginationSuspenseQueryHookResult = ReturnType<typeof useGetMyCoursesWithPaginationSuspenseQuery>;
export type GetMyCoursesWithPaginationQueryResult = Apollo.QueryResult<GetMyCoursesWithPaginationQuery, GetMyCoursesWithPaginationQueryVariables>;
export const GetCourseDetailDocument = gql`
    query GetCourseDetail($courseId: String!) {
  course(id: $courseId) {
    id
    title
    description
    thumbnailUrl
    introVideoUrl
    category
    difficultyLevel
    language
    subcategory
    durationMinutes
    instructorId
    isPublished
    createdAt
    updatedAt
    modules {
      id
      name
      orderIndex
      courseId
      createdAt
      updatedAt
      lectures {
        id
        title
        summary
        videoUrl
        handoutDocumentsUrl
        orderIndex
        duration
        moduleId
        createdAt
        updatedAt
      }
      quizzes {
        id
        title
        description
        passingScore
        orderIndex
        moduleId
        isPublished
        createdAt
        updatedAt
        questions {
          id
          questionText
          questionType
          orderIndex
          points
          quizId
          createdAt
          updatedAt
          options {
            id
            optionText
            isCorrect
            orderIndex
            questionId
            createdAt
          }
        }
      }
      documents {
        id
        title
        description
        documentUrl
        orderIndex
        moduleId
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetCourseDetailQuery__
 *
 * To run a query within a React component, call `useGetCourseDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseDetailQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseDetailQuery(baseOptions: Apollo.QueryHookOptions<GetCourseDetailQuery, GetCourseDetailQueryVariables> & ({ variables: GetCourseDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseDetailQuery, GetCourseDetailQueryVariables>(GetCourseDetailDocument, options);
      }
export function useGetCourseDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseDetailQuery, GetCourseDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseDetailQuery, GetCourseDetailQueryVariables>(GetCourseDetailDocument, options);
        }
// @ts-ignore
export function useGetCourseDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseDetailQuery, GetCourseDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseDetailQuery, GetCourseDetailQueryVariables>;
export function useGetCourseDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseDetailQuery, GetCourseDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseDetailQuery | undefined, GetCourseDetailQueryVariables>;
export function useGetCourseDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseDetailQuery, GetCourseDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseDetailQuery, GetCourseDetailQueryVariables>(GetCourseDetailDocument, options);
        }
export type GetCourseDetailQueryHookResult = ReturnType<typeof useGetCourseDetailQuery>;
export type GetCourseDetailLazyQueryHookResult = ReturnType<typeof useGetCourseDetailLazyQuery>;
export type GetCourseDetailSuspenseQueryHookResult = ReturnType<typeof useGetCourseDetailSuspenseQuery>;
export type GetCourseDetailQueryResult = Apollo.QueryResult<GetCourseDetailQuery, GetCourseDetailQueryVariables>;
export const AllCoursesDocument = gql`
    query AllCourses($page: Int, $limit: Int, $query: String, $categories: [String!], $instructors: [String!], $reviews: [Float!], $levels: [difficultyLevel!]) {
  allCourses(
    pagination: {page: $page, limit: $limit, query: $query, categories: $categories, instructors: $instructors, reviews: $reviews, levels: $levels}
  ) {
    data {
      id
      libraryItemId
      title
      description
      category
      difficultyLevel
      durationMinutes
      thumbnailUrl
      language
      isPublished
      totalLectures
      averageRating
      totalRatings
      createdAt
      instructor {
        id
        firstName
        lastName
        title
        profileImageUrl
        influenceBadge {
          ...InfluenceBadgeFields
        }
        companyName
      }
    }
    total
    page
    limit
    totalPages
    hasMore
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useAllCoursesQuery__
 *
 * To run a query within a React component, call `useAllCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCoursesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *      categories: // value for 'categories'
 *      instructors: // value for 'instructors'
 *      reviews: // value for 'reviews'
 *      levels: // value for 'levels'
 *   },
 * });
 */
export function useAllCoursesQuery(baseOptions?: Apollo.QueryHookOptions<AllCoursesQuery, AllCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCoursesQuery, AllCoursesQueryVariables>(AllCoursesDocument, options);
      }
export function useAllCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCoursesQuery, AllCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCoursesQuery, AllCoursesQueryVariables>(AllCoursesDocument, options);
        }
// @ts-ignore
export function useAllCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllCoursesQuery, AllCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<AllCoursesQuery, AllCoursesQueryVariables>;
export function useAllCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCoursesQuery, AllCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<AllCoursesQuery | undefined, AllCoursesQueryVariables>;
export function useAllCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCoursesQuery, AllCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCoursesQuery, AllCoursesQueryVariables>(AllCoursesDocument, options);
        }
export type AllCoursesQueryHookResult = ReturnType<typeof useAllCoursesQuery>;
export type AllCoursesLazyQueryHookResult = ReturnType<typeof useAllCoursesLazyQuery>;
export type AllCoursesSuspenseQueryHookResult = ReturnType<typeof useAllCoursesSuspenseQuery>;
export type AllCoursesQueryResult = Apollo.QueryResult<AllCoursesQuery, AllCoursesQueryVariables>;
export const GetCourseDetailforUserDocument = gql`
    query GetCourseDetailforUser($courseId: String!) {
  courseDetail(id: $courseId) {
    id
    title
    description
    category
    subcategory
    language
    difficultyLevel
    durationMinutes
    thumbnailUrl
    introVideoUrl
    isPublished
    createdAt
    updatedAt
    completedAt
    totalEnrolledStudents
    averageRating
    totalRatings
    enrollmentStatus
    isEnrolledByMe
    instructor {
      id
      firstName
      lastName
      title
      profileImageUrl
      role
      headline
      about
      influenceBadge {
        ...InfluenceBadgeFields
      }
      companyName
    }
    modules {
      id
      name
      orderIndex
      lectures {
        id
        title
        summary
        videoUrl
        handoutDocumentsUrl
        orderIndex
        duration
      }
      quizzes {
        id
        title
        description
        passingScore
        orderIndex
        isPublished
      }
      documents {
        id
        title
        description
        documentUrl
        orderIndex
      }
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetCourseDetailforUserQuery__
 *
 * To run a query within a React component, call `useGetCourseDetailforUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseDetailforUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseDetailforUserQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseDetailforUserQuery(baseOptions: Apollo.QueryHookOptions<GetCourseDetailforUserQuery, GetCourseDetailforUserQueryVariables> & ({ variables: GetCourseDetailforUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseDetailforUserQuery, GetCourseDetailforUserQueryVariables>(GetCourseDetailforUserDocument, options);
      }
export function useGetCourseDetailforUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseDetailforUserQuery, GetCourseDetailforUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseDetailforUserQuery, GetCourseDetailforUserQueryVariables>(GetCourseDetailforUserDocument, options);
        }
// @ts-ignore
export function useGetCourseDetailforUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseDetailforUserQuery, GetCourseDetailforUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseDetailforUserQuery, GetCourseDetailforUserQueryVariables>;
export function useGetCourseDetailforUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseDetailforUserQuery, GetCourseDetailforUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseDetailforUserQuery | undefined, GetCourseDetailforUserQueryVariables>;
export function useGetCourseDetailforUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseDetailforUserQuery, GetCourseDetailforUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseDetailforUserQuery, GetCourseDetailforUserQueryVariables>(GetCourseDetailforUserDocument, options);
        }
export type GetCourseDetailforUserQueryHookResult = ReturnType<typeof useGetCourseDetailforUserQuery>;
export type GetCourseDetailforUserLazyQueryHookResult = ReturnType<typeof useGetCourseDetailforUserLazyQuery>;
export type GetCourseDetailforUserSuspenseQueryHookResult = ReturnType<typeof useGetCourseDetailforUserSuspenseQuery>;
export type GetCourseDetailforUserQueryResult = Apollo.QueryResult<GetCourseDetailforUserQuery, GetCourseDetailforUserQueryVariables>;
export const GetSuggestedCoursesDocument = gql`
    query GetSuggestedCourses($instructorId: ID!, $courseId: ID) {
  suggestedCourses(input: {instructorId: $instructorId, courseId: $courseId}) {
    data {
      id
      title
      description
      thumbnailUrl
      totalStudentsEnrolled
      totalLessons
      instructorId
      instructor {
        id
        firstName
        lastName
        title
        profileImageUrl
        influenceBadge {
          ...InfluenceBadgeFields
        }
        companyName
      }
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetSuggestedCoursesQuery__
 *
 * To run a query within a React component, call `useGetSuggestedCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedCoursesQuery({
 *   variables: {
 *      instructorId: // value for 'instructorId'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetSuggestedCoursesQuery(baseOptions: Apollo.QueryHookOptions<GetSuggestedCoursesQuery, GetSuggestedCoursesQueryVariables> & ({ variables: GetSuggestedCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestedCoursesQuery, GetSuggestedCoursesQueryVariables>(GetSuggestedCoursesDocument, options);
      }
export function useGetSuggestedCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestedCoursesQuery, GetSuggestedCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestedCoursesQuery, GetSuggestedCoursesQueryVariables>(GetSuggestedCoursesDocument, options);
        }
// @ts-ignore
export function useGetSuggestedCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSuggestedCoursesQuery, GetSuggestedCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSuggestedCoursesQuery, GetSuggestedCoursesQueryVariables>;
export function useGetSuggestedCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuggestedCoursesQuery, GetSuggestedCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSuggestedCoursesQuery | undefined, GetSuggestedCoursesQueryVariables>;
export function useGetSuggestedCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuggestedCoursesQuery, GetSuggestedCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuggestedCoursesQuery, GetSuggestedCoursesQueryVariables>(GetSuggestedCoursesDocument, options);
        }
export type GetSuggestedCoursesQueryHookResult = ReturnType<typeof useGetSuggestedCoursesQuery>;
export type GetSuggestedCoursesLazyQueryHookResult = ReturnType<typeof useGetSuggestedCoursesLazyQuery>;
export type GetSuggestedCoursesSuspenseQueryHookResult = ReturnType<typeof useGetSuggestedCoursesSuspenseQuery>;
export type GetSuggestedCoursesQueryResult = Apollo.QueryResult<GetSuggestedCoursesQuery, GetSuggestedCoursesQueryVariables>;
export const EnrollCourseDocument = gql`
    mutation EnrollCourse($courseId: ID!) {
  enrollCourse(enrollCourseInput: {courseId: $courseId}) {
    id
    studentId
    courseId
    status
    progressPercentage
    enrolledAt
    completedAt
    lecturesCompleted
    quizzesCompleted
    updatedAt
    message
  }
}
    `;
export type EnrollCourseMutationFn = Apollo.MutationFunction<EnrollCourseMutation, EnrollCourseMutationVariables>;

/**
 * __useEnrollCourseMutation__
 *
 * To run a mutation, you first call `useEnrollCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollCourseMutation, { data, loading, error }] = useEnrollCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useEnrollCourseMutation(baseOptions?: Apollo.MutationHookOptions<EnrollCourseMutation, EnrollCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollCourseMutation, EnrollCourseMutationVariables>(EnrollCourseDocument, options);
      }
export type EnrollCourseMutationHookResult = ReturnType<typeof useEnrollCourseMutation>;
export type EnrollCourseMutationResult = Apollo.MutationResult<EnrollCourseMutation>;
export type EnrollCourseMutationOptions = Apollo.BaseMutationOptions<EnrollCourseMutation, EnrollCourseMutationVariables>;
export const LeaveCourseDocument = gql`
    mutation LeaveCourse($courseId: ID!) {
  leaveCourse(leaveCourseInput: {courseId: $courseId}) {
    id
    studentId
    courseId
    status
    progressPercentage
    enrolledAt
    completedAt
    lecturesCompleted
    quizzesCompleted
    updatedAt
    message
  }
}
    `;
export type LeaveCourseMutationFn = Apollo.MutationFunction<LeaveCourseMutation, LeaveCourseMutationVariables>;

/**
 * __useLeaveCourseMutation__
 *
 * To run a mutation, you first call `useLeaveCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveCourseMutation, { data, loading, error }] = useLeaveCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useLeaveCourseMutation(baseOptions?: Apollo.MutationHookOptions<LeaveCourseMutation, LeaveCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveCourseMutation, LeaveCourseMutationVariables>(LeaveCourseDocument, options);
      }
export type LeaveCourseMutationHookResult = ReturnType<typeof useLeaveCourseMutation>;
export type LeaveCourseMutationResult = Apollo.MutationResult<LeaveCourseMutation>;
export type LeaveCourseMutationOptions = Apollo.BaseMutationOptions<LeaveCourseMutation, LeaveCourseMutationVariables>;
export const GetEnrolledCoursesDocument = gql`
    query GetEnrolledCourses($pagination: PaginationInput) {
  enrolledCourses(pagination: $pagination) {
    data {
      id
      title
      description
      thumbnailUrl
      progressPercentage
      averageRating
      totalRatings
      category
      subcategory
      difficultyLevel
      instructor {
        id
        firstName
        lastName
        title
        profileImageUrl
        headline
        influenceBadge {
          ...InfluenceBadgeFields
        }
        companyName
      }
    }
    total
    page
    limit
    totalPages
    hasMore
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetEnrolledCoursesQuery__
 *
 * To run a query within a React component, call `useGetEnrolledCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnrolledCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnrolledCoursesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetEnrolledCoursesQuery(baseOptions?: Apollo.QueryHookOptions<GetEnrolledCoursesQuery, GetEnrolledCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnrolledCoursesQuery, GetEnrolledCoursesQueryVariables>(GetEnrolledCoursesDocument, options);
      }
export function useGetEnrolledCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnrolledCoursesQuery, GetEnrolledCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnrolledCoursesQuery, GetEnrolledCoursesQueryVariables>(GetEnrolledCoursesDocument, options);
        }
// @ts-ignore
export function useGetEnrolledCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEnrolledCoursesQuery, GetEnrolledCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<GetEnrolledCoursesQuery, GetEnrolledCoursesQueryVariables>;
export function useGetEnrolledCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEnrolledCoursesQuery, GetEnrolledCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<GetEnrolledCoursesQuery | undefined, GetEnrolledCoursesQueryVariables>;
export function useGetEnrolledCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEnrolledCoursesQuery, GetEnrolledCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEnrolledCoursesQuery, GetEnrolledCoursesQueryVariables>(GetEnrolledCoursesDocument, options);
        }
export type GetEnrolledCoursesQueryHookResult = ReturnType<typeof useGetEnrolledCoursesQuery>;
export type GetEnrolledCoursesLazyQueryHookResult = ReturnType<typeof useGetEnrolledCoursesLazyQuery>;
export type GetEnrolledCoursesSuspenseQueryHookResult = ReturnType<typeof useGetEnrolledCoursesSuspenseQuery>;
export type GetEnrolledCoursesQueryResult = Apollo.QueryResult<GetEnrolledCoursesQuery, GetEnrolledCoursesQueryVariables>;
export const GetCourseDetailWithProgressDocument = gql`
    query GetCourseDetailWithProgress($courseId: String!) {
  courseDetailWithProgress(courseId: $courseId) {
    id
    title
    description
    thumbnailUrl
    introVideoUrl
    category
    subcategory
    language
    difficultyLevel
    durationMinutes
    isPublished
    createdAt
    updatedAt
    overallProgress
    completedLectures
    totalLectures
    completedQuizzes
    totalQuizzes
    totalDocuments
    enrollmentStatus
    isEnrolled
    isCourseRatedByMe
    completedAt
    enrollmentId
    instructor {
      id
      firstName
      lastName
      title
      profileImageUrl
      headline
      about
      influenceBadge {
        ...InfluenceBadgeFields
      }
      companyName
    }
    modules {
      id
      name
      orderIndex
      moduleProgress
      completedLectures
      totalLectures
      completedQuizzes
      totalQuizzes
      lectures {
        id
        title
        summary
        videoUrl
        handoutDocumentsUrl
        duration
        orderIndex
        isCompleted
        isRemaining
      }
      quizzes {
        id
        title
        description
        passingScore
        orderIndex
        isPublished
        canAttempt
        hasAttempted
        isPassed
        bestScore
        attemptCount
        isRemaining
        questions {
          id
          questionText
          orderIndex
          questionType
          points
          options {
            id
            optionText
            orderIndex
          }
        }
      }
      documents {
        id
        title
        description
        documentUrl
        orderIndex
        isAccessible
        isRemaining
      }
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetCourseDetailWithProgressQuery__
 *
 * To run a query within a React component, call `useGetCourseDetailWithProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseDetailWithProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseDetailWithProgressQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseDetailWithProgressQuery(baseOptions: Apollo.QueryHookOptions<GetCourseDetailWithProgressQuery, GetCourseDetailWithProgressQueryVariables> & ({ variables: GetCourseDetailWithProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseDetailWithProgressQuery, GetCourseDetailWithProgressQueryVariables>(GetCourseDetailWithProgressDocument, options);
      }
export function useGetCourseDetailWithProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseDetailWithProgressQuery, GetCourseDetailWithProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseDetailWithProgressQuery, GetCourseDetailWithProgressQueryVariables>(GetCourseDetailWithProgressDocument, options);
        }
// @ts-ignore
export function useGetCourseDetailWithProgressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseDetailWithProgressQuery, GetCourseDetailWithProgressQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseDetailWithProgressQuery, GetCourseDetailWithProgressQueryVariables>;
export function useGetCourseDetailWithProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseDetailWithProgressQuery, GetCourseDetailWithProgressQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseDetailWithProgressQuery | undefined, GetCourseDetailWithProgressQueryVariables>;
export function useGetCourseDetailWithProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseDetailWithProgressQuery, GetCourseDetailWithProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseDetailWithProgressQuery, GetCourseDetailWithProgressQueryVariables>(GetCourseDetailWithProgressDocument, options);
        }
export type GetCourseDetailWithProgressQueryHookResult = ReturnType<typeof useGetCourseDetailWithProgressQuery>;
export type GetCourseDetailWithProgressLazyQueryHookResult = ReturnType<typeof useGetCourseDetailWithProgressLazyQuery>;
export type GetCourseDetailWithProgressSuspenseQueryHookResult = ReturnType<typeof useGetCourseDetailWithProgressSuspenseQuery>;
export type GetCourseDetailWithProgressQueryResult = Apollo.QueryResult<GetCourseDetailWithProgressQuery, GetCourseDetailWithProgressQueryVariables>;
export const MarkContentViewedDocument = gql`
    mutation MarkContentViewed($input: MarkContentViewedInput!) {
  markContentViewed(input: $input) {
    id
    contentId
    contentType
    success
    message
    viewedAt
  }
}
    `;
export type MarkContentViewedMutationFn = Apollo.MutationFunction<MarkContentViewedMutation, MarkContentViewedMutationVariables>;

/**
 * __useMarkContentViewedMutation__
 *
 * To run a mutation, you first call `useMarkContentViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkContentViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markContentViewedMutation, { data, loading, error }] = useMarkContentViewedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkContentViewedMutation(baseOptions?: Apollo.MutationHookOptions<MarkContentViewedMutation, MarkContentViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkContentViewedMutation, MarkContentViewedMutationVariables>(MarkContentViewedDocument, options);
      }
export type MarkContentViewedMutationHookResult = ReturnType<typeof useMarkContentViewedMutation>;
export type MarkContentViewedMutationResult = Apollo.MutationResult<MarkContentViewedMutation>;
export type MarkContentViewedMutationOptions = Apollo.BaseMutationOptions<MarkContentViewedMutation, MarkContentViewedMutationVariables>;
export const SubmitQuizDocument = gql`
    mutation SubmitQuiz($input: SubmitQuizInput!) {
  submitQuiz(input: $input) {
    id
    quizId
    quizTitle
    attemptId
    attemptNumber
    score
    totalPoints
    percentage
    passed
    passingMessage
    totalQuestions
    correctAnswers
    answers {
      questionId
      questionText
      questionNumber
      selectedOptionId
      selectedOptionText
      correctOptionId
      correctOptionText
      isCorrect
      pointsEarned
    }
    startTime
    endTime
    createdAt
  }
}
    `;
export type SubmitQuizMutationFn = Apollo.MutationFunction<SubmitQuizMutation, SubmitQuizMutationVariables>;

/**
 * __useSubmitQuizMutation__
 *
 * To run a mutation, you first call `useSubmitQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitQuizMutation, { data, loading, error }] = useSubmitQuizMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitQuizMutation(baseOptions?: Apollo.MutationHookOptions<SubmitQuizMutation, SubmitQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitQuizMutation, SubmitQuizMutationVariables>(SubmitQuizDocument, options);
      }
export type SubmitQuizMutationHookResult = ReturnType<typeof useSubmitQuizMutation>;
export type SubmitQuizMutationResult = Apollo.MutationResult<SubmitQuizMutation>;
export type SubmitQuizMutationOptions = Apollo.BaseMutationOptions<SubmitQuizMutation, SubmitQuizMutationVariables>;
export const CompletedCoursesDocument = gql`
    query CompletedCourses($pagination: PaginationInput) {
  completedCourses(pagination: $pagination) {
    data {
      id
      title
      description
      thumbnailUrl
      introVideoUrl
      category
      subcategory
      language
      difficultyLevel
      durationMinutes
      isPublished
      createdAt
      updatedAt
      totalLectures
      completedAt
      instructor {
        id
        firstName
        lastName
        title
        profileImageUrl
        headline
        influenceBadge {
          ...InfluenceBadgeFields
        }
        companyName
      }
    }
    total
    page
    limit
    totalPages
    hasMore
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useCompletedCoursesQuery__
 *
 * To run a query within a React component, call `useCompletedCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedCoursesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCompletedCoursesQuery(baseOptions?: Apollo.QueryHookOptions<CompletedCoursesQuery, CompletedCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompletedCoursesQuery, CompletedCoursesQueryVariables>(CompletedCoursesDocument, options);
      }
export function useCompletedCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompletedCoursesQuery, CompletedCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompletedCoursesQuery, CompletedCoursesQueryVariables>(CompletedCoursesDocument, options);
        }
// @ts-ignore
export function useCompletedCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompletedCoursesQuery, CompletedCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<CompletedCoursesQuery, CompletedCoursesQueryVariables>;
export function useCompletedCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompletedCoursesQuery, CompletedCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<CompletedCoursesQuery | undefined, CompletedCoursesQueryVariables>;
export function useCompletedCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompletedCoursesQuery, CompletedCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompletedCoursesQuery, CompletedCoursesQueryVariables>(CompletedCoursesDocument, options);
        }
export type CompletedCoursesQueryHookResult = ReturnType<typeof useCompletedCoursesQuery>;
export type CompletedCoursesLazyQueryHookResult = ReturnType<typeof useCompletedCoursesLazyQuery>;
export type CompletedCoursesSuspenseQueryHookResult = ReturnType<typeof useCompletedCoursesSuspenseQuery>;
export type CompletedCoursesQueryResult = Apollo.QueryResult<CompletedCoursesQuery, CompletedCoursesQueryVariables>;
export const CourseStudentStatsDocument = gql`
    query CourseStudentStats($courseId: String!) {
  courseStudentStats(courseId: $courseId) {
    total
    completed
    active
  }
}
    `;

/**
 * __useCourseStudentStatsQuery__
 *
 * To run a query within a React component, call `useCourseStudentStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseStudentStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseStudentStatsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCourseStudentStatsQuery(baseOptions: Apollo.QueryHookOptions<CourseStudentStatsQuery, CourseStudentStatsQueryVariables> & ({ variables: CourseStudentStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseStudentStatsQuery, CourseStudentStatsQueryVariables>(CourseStudentStatsDocument, options);
      }
export function useCourseStudentStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseStudentStatsQuery, CourseStudentStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseStudentStatsQuery, CourseStudentStatsQueryVariables>(CourseStudentStatsDocument, options);
        }
// @ts-ignore
export function useCourseStudentStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseStudentStatsQuery, CourseStudentStatsQueryVariables>): Apollo.UseSuspenseQueryResult<CourseStudentStatsQuery, CourseStudentStatsQueryVariables>;
export function useCourseStudentStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseStudentStatsQuery, CourseStudentStatsQueryVariables>): Apollo.UseSuspenseQueryResult<CourseStudentStatsQuery | undefined, CourseStudentStatsQueryVariables>;
export function useCourseStudentStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseStudentStatsQuery, CourseStudentStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseStudentStatsQuery, CourseStudentStatsQueryVariables>(CourseStudentStatsDocument, options);
        }
export type CourseStudentStatsQueryHookResult = ReturnType<typeof useCourseStudentStatsQuery>;
export type CourseStudentStatsLazyQueryHookResult = ReturnType<typeof useCourseStudentStatsLazyQuery>;
export type CourseStudentStatsSuspenseQueryHookResult = ReturnType<typeof useCourseStudentStatsSuspenseQuery>;
export type CourseStudentStatsQueryResult = Apollo.QueryResult<CourseStudentStatsQuery, CourseStudentStatsQueryVariables>;
export const CourseContentStatsDocument = gql`
    query CourseContentStats($courseId: String!) {
  courseContentStats(courseId: $courseId) {
    lectures {
      id
      title
      totalStudentsViewed
      percentageViewed
    }
    quizzes {
      id
      title
      percentagePassed
    }
  }
}
    `;

/**
 * __useCourseContentStatsQuery__
 *
 * To run a query within a React component, call `useCourseContentStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseContentStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseContentStatsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCourseContentStatsQuery(baseOptions: Apollo.QueryHookOptions<CourseContentStatsQuery, CourseContentStatsQueryVariables> & ({ variables: CourseContentStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseContentStatsQuery, CourseContentStatsQueryVariables>(CourseContentStatsDocument, options);
      }
export function useCourseContentStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseContentStatsQuery, CourseContentStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseContentStatsQuery, CourseContentStatsQueryVariables>(CourseContentStatsDocument, options);
        }
// @ts-ignore
export function useCourseContentStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseContentStatsQuery, CourseContentStatsQueryVariables>): Apollo.UseSuspenseQueryResult<CourseContentStatsQuery, CourseContentStatsQueryVariables>;
export function useCourseContentStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseContentStatsQuery, CourseContentStatsQueryVariables>): Apollo.UseSuspenseQueryResult<CourseContentStatsQuery | undefined, CourseContentStatsQueryVariables>;
export function useCourseContentStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseContentStatsQuery, CourseContentStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseContentStatsQuery, CourseContentStatsQueryVariables>(CourseContentStatsDocument, options);
        }
export type CourseContentStatsQueryHookResult = ReturnType<typeof useCourseContentStatsQuery>;
export type CourseContentStatsLazyQueryHookResult = ReturnType<typeof useCourseContentStatsLazyQuery>;
export type CourseContentStatsSuspenseQueryHookResult = ReturnType<typeof useCourseContentStatsSuspenseQuery>;
export type CourseContentStatsQueryResult = Apollo.QueryResult<CourseContentStatsQuery, CourseContentStatsQueryVariables>;
export const EnrolledStudentsByCourseAndMonthDocument = gql`
    query EnrolledStudentsByCourseAndMonth($courseId: String!, $page: Int, $limit: Int) {
  enrolledStudentsByCourseAndMonth(
    courseId: $courseId
    page: $page
    limit: $limit
  ) {
    data {
      studentId
      firstName
      lastName
      title
      dateJoined
      courseProgress
      totalQuizzes
      quizzesCompleted
      totalLessons
      lessonsCompleted
      companyName
    }
    total
    page
    limit
    totalPages
    hasMore
  }
}
    `;

/**
 * __useEnrolledStudentsByCourseAndMonthQuery__
 *
 * To run a query within a React component, call `useEnrolledStudentsByCourseAndMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrolledStudentsByCourseAndMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrolledStudentsByCourseAndMonthQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useEnrolledStudentsByCourseAndMonthQuery(baseOptions: Apollo.QueryHookOptions<EnrolledStudentsByCourseAndMonthQuery, EnrolledStudentsByCourseAndMonthQueryVariables> & ({ variables: EnrolledStudentsByCourseAndMonthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnrolledStudentsByCourseAndMonthQuery, EnrolledStudentsByCourseAndMonthQueryVariables>(EnrolledStudentsByCourseAndMonthDocument, options);
      }
export function useEnrolledStudentsByCourseAndMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnrolledStudentsByCourseAndMonthQuery, EnrolledStudentsByCourseAndMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnrolledStudentsByCourseAndMonthQuery, EnrolledStudentsByCourseAndMonthQueryVariables>(EnrolledStudentsByCourseAndMonthDocument, options);
        }
// @ts-ignore
export function useEnrolledStudentsByCourseAndMonthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EnrolledStudentsByCourseAndMonthQuery, EnrolledStudentsByCourseAndMonthQueryVariables>): Apollo.UseSuspenseQueryResult<EnrolledStudentsByCourseAndMonthQuery, EnrolledStudentsByCourseAndMonthQueryVariables>;
export function useEnrolledStudentsByCourseAndMonthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EnrolledStudentsByCourseAndMonthQuery, EnrolledStudentsByCourseAndMonthQueryVariables>): Apollo.UseSuspenseQueryResult<EnrolledStudentsByCourseAndMonthQuery | undefined, EnrolledStudentsByCourseAndMonthQueryVariables>;
export function useEnrolledStudentsByCourseAndMonthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EnrolledStudentsByCourseAndMonthQuery, EnrolledStudentsByCourseAndMonthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnrolledStudentsByCourseAndMonthQuery, EnrolledStudentsByCourseAndMonthQueryVariables>(EnrolledStudentsByCourseAndMonthDocument, options);
        }
export type EnrolledStudentsByCourseAndMonthQueryHookResult = ReturnType<typeof useEnrolledStudentsByCourseAndMonthQuery>;
export type EnrolledStudentsByCourseAndMonthLazyQueryHookResult = ReturnType<typeof useEnrolledStudentsByCourseAndMonthLazyQuery>;
export type EnrolledStudentsByCourseAndMonthSuspenseQueryHookResult = ReturnType<typeof useEnrolledStudentsByCourseAndMonthSuspenseQuery>;
export type EnrolledStudentsByCourseAndMonthQueryResult = Apollo.QueryResult<EnrolledStudentsByCourseAndMonthQuery, EnrolledStudentsByCourseAndMonthQueryVariables>;
export const QuizAttemptStatusDocument = gql`
    query QuizAttemptStatus($quizId: String!, $enrollmentId: String!) {
  quizAttemptStatus(quizId: $quizId, enrollmentId: $enrollmentId) {
    status
    id
    quizId
    enrollmentId
    score
    totalPoints
    percentage
    startTime
    endTime
    createdAt
    updatedAt
    questions {
      questionId
      questionText
      questionType
      options {
        id
        optionText
        isCorrect
        orderIndex
      }
      studentAnswer {
        optionId
        optionText
        isCorrect
        pointsEarned
      }
      correctOption {
        optionId
        optionText
      }
    }
  }
}
    `;

/**
 * __useQuizAttemptStatusQuery__
 *
 * To run a query within a React component, call `useQuizAttemptStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizAttemptStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizAttemptStatusQuery({
 *   variables: {
 *      quizId: // value for 'quizId'
 *      enrollmentId: // value for 'enrollmentId'
 *   },
 * });
 */
export function useQuizAttemptStatusQuery(baseOptions: Apollo.QueryHookOptions<QuizAttemptStatusQuery, QuizAttemptStatusQueryVariables> & ({ variables: QuizAttemptStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuizAttemptStatusQuery, QuizAttemptStatusQueryVariables>(QuizAttemptStatusDocument, options);
      }
export function useQuizAttemptStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuizAttemptStatusQuery, QuizAttemptStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuizAttemptStatusQuery, QuizAttemptStatusQueryVariables>(QuizAttemptStatusDocument, options);
        }
// @ts-ignore
export function useQuizAttemptStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QuizAttemptStatusQuery, QuizAttemptStatusQueryVariables>): Apollo.UseSuspenseQueryResult<QuizAttemptStatusQuery, QuizAttemptStatusQueryVariables>;
export function useQuizAttemptStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuizAttemptStatusQuery, QuizAttemptStatusQueryVariables>): Apollo.UseSuspenseQueryResult<QuizAttemptStatusQuery | undefined, QuizAttemptStatusQueryVariables>;
export function useQuizAttemptStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuizAttemptStatusQuery, QuizAttemptStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuizAttemptStatusQuery, QuizAttemptStatusQueryVariables>(QuizAttemptStatusDocument, options);
        }
export type QuizAttemptStatusQueryHookResult = ReturnType<typeof useQuizAttemptStatusQuery>;
export type QuizAttemptStatusLazyQueryHookResult = ReturnType<typeof useQuizAttemptStatusLazyQuery>;
export type QuizAttemptStatusSuspenseQueryHookResult = ReturnType<typeof useQuizAttemptStatusSuspenseQuery>;
export type QuizAttemptStatusQueryResult = Apollo.QueryResult<QuizAttemptStatusQuery, QuizAttemptStatusQueryVariables>;
export const RateCourseDocument = gql`
    mutation RateCourse($courseId: String!, $rating: Int!) {
  rateCourse(courseId: $courseId, rating: $rating)
}
    `;
export type RateCourseMutationFn = Apollo.MutationFunction<RateCourseMutation, RateCourseMutationVariables>;

/**
 * __useRateCourseMutation__
 *
 * To run a mutation, you first call `useRateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateCourseMutation, { data, loading, error }] = useRateCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      rating: // value for 'rating'
 *   },
 * });
 */
export function useRateCourseMutation(baseOptions?: Apollo.MutationHookOptions<RateCourseMutation, RateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RateCourseMutation, RateCourseMutationVariables>(RateCourseDocument, options);
      }
export type RateCourseMutationHookResult = ReturnType<typeof useRateCourseMutation>;
export type RateCourseMutationResult = Apollo.MutationResult<RateCourseMutation>;
export type RateCourseMutationOptions = Apollo.BaseMutationOptions<RateCourseMutation, RateCourseMutationVariables>;
export const GenerateCertificateDocument = gql`
    mutation GenerateCertificate($courseId: String!) {
  generateCertificate(courseId: $courseId)
}
    `;
export type GenerateCertificateMutationFn = Apollo.MutationFunction<GenerateCertificateMutation, GenerateCertificateMutationVariables>;

/**
 * __useGenerateCertificateMutation__
 *
 * To run a mutation, you first call `useGenerateCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCertificateMutation, { data, loading, error }] = useGenerateCertificateMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGenerateCertificateMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCertificateMutation, GenerateCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCertificateMutation, GenerateCertificateMutationVariables>(GenerateCertificateDocument, options);
      }
export type GenerateCertificateMutationHookResult = ReturnType<typeof useGenerateCertificateMutation>;
export type GenerateCertificateMutationResult = Apollo.MutationResult<GenerateCertificateMutation>;
export type GenerateCertificateMutationOptions = Apollo.BaseMutationOptions<GenerateCertificateMutation, GenerateCertificateMutationVariables>;
export const GetCourseFiltersDocument = gql`
    query GetCourseFilters {
  filters {
    categories {
      name
      count
    }
    instructors {
      name
      count
    }
    reviews {
      rating
      count
    }
    levels {
      name
      count
    }
  }
}
    `;

/**
 * __useGetCourseFiltersQuery__
 *
 * To run a query within a React component, call `useGetCourseFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCourseFiltersQuery(baseOptions?: Apollo.QueryHookOptions<GetCourseFiltersQuery, GetCourseFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseFiltersQuery, GetCourseFiltersQueryVariables>(GetCourseFiltersDocument, options);
      }
export function useGetCourseFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseFiltersQuery, GetCourseFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseFiltersQuery, GetCourseFiltersQueryVariables>(GetCourseFiltersDocument, options);
        }
// @ts-ignore
export function useGetCourseFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseFiltersQuery, GetCourseFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseFiltersQuery, GetCourseFiltersQueryVariables>;
export function useGetCourseFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseFiltersQuery, GetCourseFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseFiltersQuery | undefined, GetCourseFiltersQueryVariables>;
export function useGetCourseFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseFiltersQuery, GetCourseFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseFiltersQuery, GetCourseFiltersQueryVariables>(GetCourseFiltersDocument, options);
        }
export type GetCourseFiltersQueryHookResult = ReturnType<typeof useGetCourseFiltersQuery>;
export type GetCourseFiltersLazyQueryHookResult = ReturnType<typeof useGetCourseFiltersLazyQuery>;
export type GetCourseFiltersSuspenseQueryHookResult = ReturnType<typeof useGetCourseFiltersSuspenseQuery>;
export type GetCourseFiltersQueryResult = Apollo.QueryResult<GetCourseFiltersQuery, GetCourseFiltersQueryVariables>;
export const GetAllCategoriesDocument = gql`
    query GetAllCategories {
  allCategories {
    id
    name
    parentId
    children {
      id
      name
      parentId
    }
  }
}
    `;

/**
 * __useGetAllCategoriesQuery__
 *
 * To run a query within a React component, call `useGetAllCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>(GetAllCategoriesDocument, options);
      }
export function useGetAllCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>(GetAllCategoriesDocument, options);
        }
// @ts-ignore
export function useGetAllCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>;
export function useGetAllCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCategoriesQuery | undefined, GetAllCategoriesQueryVariables>;
export function useGetAllCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>(GetAllCategoriesDocument, options);
        }
export type GetAllCategoriesQueryHookResult = ReturnType<typeof useGetAllCategoriesQuery>;
export type GetAllCategoriesLazyQueryHookResult = ReturnType<typeof useGetAllCategoriesLazyQuery>;
export type GetAllCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetAllCategoriesSuspenseQuery>;
export type GetAllCategoriesQueryResult = Apollo.QueryResult<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>;
export const CreateSessionPaymentIntentDocument = gql`
    mutation CreateSessionPaymentIntent($bookingId: String!) {
  createSessionPaymentIntent(bookingId: $bookingId) {
    clientSecret
    paymentIntentId
    amount
    currency
    publishableKey
  }
}
    `;
export type CreateSessionPaymentIntentMutationFn = Apollo.MutationFunction<CreateSessionPaymentIntentMutation, CreateSessionPaymentIntentMutationVariables>;

/**
 * __useCreateSessionPaymentIntentMutation__
 *
 * To run a mutation, you first call `useCreateSessionPaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionPaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSessionPaymentIntentMutation, { data, loading, error }] = useCreateSessionPaymentIntentMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useCreateSessionPaymentIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSessionPaymentIntentMutation, CreateSessionPaymentIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSessionPaymentIntentMutation, CreateSessionPaymentIntentMutationVariables>(CreateSessionPaymentIntentDocument, options);
      }
export type CreateSessionPaymentIntentMutationHookResult = ReturnType<typeof useCreateSessionPaymentIntentMutation>;
export type CreateSessionPaymentIntentMutationResult = Apollo.MutationResult<CreateSessionPaymentIntentMutation>;
export type CreateSessionPaymentIntentMutationOptions = Apollo.BaseMutationOptions<CreateSessionPaymentIntentMutation, CreateSessionPaymentIntentMutationVariables>;
export const UploadPostMediaDocument = gql`
    mutation UploadPostMedia($input: UploadPostMediaInput!) {
  uploadPostMedia(input: $input) {
    id
    createdAt
    updatedAt
    userId
    fileName
    fileUrl
    optimizedUrl
    mimeType
    size
    type
  }
}
    `;
export type UploadPostMediaMutationFn = Apollo.MutationFunction<UploadPostMediaMutation, UploadPostMediaMutationVariables>;

/**
 * __useUploadPostMediaMutation__
 *
 * To run a mutation, you first call `useUploadPostMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPostMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPostMediaMutation, { data, loading, error }] = useUploadPostMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadPostMediaMutation(baseOptions?: Apollo.MutationHookOptions<UploadPostMediaMutation, UploadPostMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadPostMediaMutation, UploadPostMediaMutationVariables>(UploadPostMediaDocument, options);
      }
export type UploadPostMediaMutationHookResult = ReturnType<typeof useUploadPostMediaMutation>;
export type UploadPostMediaMutationResult = Apollo.MutationResult<UploadPostMediaMutation>;
export type UploadPostMediaMutationOptions = Apollo.BaseMutationOptions<UploadPostMediaMutation, UploadPostMediaMutationVariables>;
export const CreatePostDocument = gql`
    mutation CreatePost($input: CreatePostInput!) {
  createPost(input: $input)
}
    `;
export type CreatePostMutationFn = Apollo.MutationFunction<CreatePostMutation, CreatePostMutationVariables>;

/**
 * __useCreatePostMutation__
 *
 * To run a mutation, you first call `useCreatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostMutation, { data, loading, error }] = useCreatePostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePostMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostMutation, CreatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostMutation, CreatePostMutationVariables>(CreatePostDocument, options);
      }
export type CreatePostMutationHookResult = ReturnType<typeof useCreatePostMutation>;
export type CreatePostMutationResult = Apollo.MutationResult<CreatePostMutation>;
export type CreatePostMutationOptions = Apollo.BaseMutationOptions<CreatePostMutation, CreatePostMutationVariables>;
export const CreateRepostDocument = gql`
    mutation CreateRepost($input: CreateRepostInput!) {
  createRepost(input: $input)
}
    `;
export type CreateRepostMutationFn = Apollo.MutationFunction<CreateRepostMutation, CreateRepostMutationVariables>;

/**
 * __useCreateRepostMutation__
 *
 * To run a mutation, you first call `useCreateRepostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRepostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRepostMutation, { data, loading, error }] = useCreateRepostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRepostMutation(baseOptions?: Apollo.MutationHookOptions<CreateRepostMutation, CreateRepostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRepostMutation, CreateRepostMutationVariables>(CreateRepostDocument, options);
      }
export type CreateRepostMutationHookResult = ReturnType<typeof useCreateRepostMutation>;
export type CreateRepostMutationResult = Apollo.MutationResult<CreateRepostMutation>;
export type CreateRepostMutationOptions = Apollo.BaseMutationOptions<CreateRepostMutation, CreateRepostMutationVariables>;
export const DeleteMyAccountDocument = gql`
    mutation DeleteMyAccount {
  deleteMyAccount
}
    `;
export type DeleteMyAccountMutationFn = Apollo.MutationFunction<DeleteMyAccountMutation, DeleteMyAccountMutationVariables>;

/**
 * __useDeleteMyAccountMutation__
 *
 * To run a mutation, you first call `useDeleteMyAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyAccountMutation, { data, loading, error }] = useDeleteMyAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteMyAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMyAccountMutation, DeleteMyAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMyAccountMutation, DeleteMyAccountMutationVariables>(DeleteMyAccountDocument, options);
      }
export type DeleteMyAccountMutationHookResult = ReturnType<typeof useDeleteMyAccountMutation>;
export type DeleteMyAccountMutationResult = Apollo.MutationResult<DeleteMyAccountMutation>;
export type DeleteMyAccountMutationOptions = Apollo.BaseMutationOptions<DeleteMyAccountMutation, DeleteMyAccountMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($input: DeleteCommentInput!) {
  deleteComment(input: $input)
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const DeletePostDocument = gql`
    mutation DeletePost($postId: String!) {
  deletePost(postId: $postId)
}
    `;
export type DeletePostMutationFn = Apollo.MutationFunction<DeletePostMutation, DeletePostMutationVariables>;

/**
 * __useDeletePostMutation__
 *
 * To run a mutation, you first call `useDeletePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostMutation, { data, loading, error }] = useDeletePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useDeletePostMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostMutation, DeletePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostMutation, DeletePostMutationVariables>(DeletePostDocument, options);
      }
export type DeletePostMutationHookResult = ReturnType<typeof useDeletePostMutation>;
export type DeletePostMutationResult = Apollo.MutationResult<DeletePostMutation>;
export type DeletePostMutationOptions = Apollo.BaseMutationOptions<DeletePostMutation, DeletePostMutationVariables>;
export const DeleteProfileImageDocument = gql`
    mutation DeleteProfileImage {
  deleteProfileImage
}
    `;
export type DeleteProfileImageMutationFn = Apollo.MutationFunction<DeleteProfileImageMutation, DeleteProfileImageMutationVariables>;

/**
 * __useDeleteProfileImageMutation__
 *
 * To run a mutation, you first call `useDeleteProfileImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProfileImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProfileImageMutation, { data, loading, error }] = useDeleteProfileImageMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteProfileImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProfileImageMutation, DeleteProfileImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProfileImageMutation, DeleteProfileImageMutationVariables>(DeleteProfileImageDocument, options);
      }
export type DeleteProfileImageMutationHookResult = ReturnType<typeof useDeleteProfileImageMutation>;
export type DeleteProfileImageMutationResult = Apollo.MutationResult<DeleteProfileImageMutation>;
export type DeleteProfileImageMutationOptions = Apollo.BaseMutationOptions<DeleteProfileImageMutation, DeleteProfileImageMutationVariables>;
export const InitializeDigitalCardPaymentDocument = gql`
    mutation InitializeDigitalCardPayment {
  initializeDigitalCardPayment {
    clientSecret
    paymentIntentId
    amountCents
    publishableKey
  }
}
    `;
export type InitializeDigitalCardPaymentMutationFn = Apollo.MutationFunction<InitializeDigitalCardPaymentMutation, InitializeDigitalCardPaymentMutationVariables>;

/**
 * __useInitializeDigitalCardPaymentMutation__
 *
 * To run a mutation, you first call `useInitializeDigitalCardPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeDigitalCardPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeDigitalCardPaymentMutation, { data, loading, error }] = useInitializeDigitalCardPaymentMutation({
 *   variables: {
 *   },
 * });
 */
export function useInitializeDigitalCardPaymentMutation(baseOptions?: Apollo.MutationHookOptions<InitializeDigitalCardPaymentMutation, InitializeDigitalCardPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitializeDigitalCardPaymentMutation, InitializeDigitalCardPaymentMutationVariables>(InitializeDigitalCardPaymentDocument, options);
      }
export type InitializeDigitalCardPaymentMutationHookResult = ReturnType<typeof useInitializeDigitalCardPaymentMutation>;
export type InitializeDigitalCardPaymentMutationResult = Apollo.MutationResult<InitializeDigitalCardPaymentMutation>;
export type InitializeDigitalCardPaymentMutationOptions = Apollo.BaseMutationOptions<InitializeDigitalCardPaymentMutation, InitializeDigitalCardPaymentMutationVariables>;
export const ActivateDigitalCardDocument = gql`
    mutation ActivateDigitalCard {
  activateDigitalCard {
    id
    slug
    enabled
    publicUrl
    purchasedAt
    amountPaidCents
    visibility {
      about
      email
      phone
      education
      experience
      expertise
      socialLinks
      website
    }
  }
}
    `;
export type ActivateDigitalCardMutationFn = Apollo.MutationFunction<ActivateDigitalCardMutation, ActivateDigitalCardMutationVariables>;

/**
 * __useActivateDigitalCardMutation__
 *
 * To run a mutation, you first call `useActivateDigitalCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateDigitalCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateDigitalCardMutation, { data, loading, error }] = useActivateDigitalCardMutation({
 *   variables: {
 *   },
 * });
 */
export function useActivateDigitalCardMutation(baseOptions?: Apollo.MutationHookOptions<ActivateDigitalCardMutation, ActivateDigitalCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateDigitalCardMutation, ActivateDigitalCardMutationVariables>(ActivateDigitalCardDocument, options);
      }
export type ActivateDigitalCardMutationHookResult = ReturnType<typeof useActivateDigitalCardMutation>;
export type ActivateDigitalCardMutationResult = Apollo.MutationResult<ActivateDigitalCardMutation>;
export type ActivateDigitalCardMutationOptions = Apollo.BaseMutationOptions<ActivateDigitalCardMutation, ActivateDigitalCardMutationVariables>;
export const ConfirmDigitalCardPaymentDocument = gql`
    mutation ConfirmDigitalCardPayment($paymentIntentId: String!) {
  confirmDigitalCardPayment(paymentIntentId: $paymentIntentId) {
    id
    slug
    enabled
    publicUrl
    purchasedAt
    amountPaidCents
    visibility {
      about
      email
      phone
      education
      experience
      expertise
      socialLinks
      website
    }
  }
}
    `;
export type ConfirmDigitalCardPaymentMutationFn = Apollo.MutationFunction<ConfirmDigitalCardPaymentMutation, ConfirmDigitalCardPaymentMutationVariables>;

/**
 * __useConfirmDigitalCardPaymentMutation__
 *
 * To run a mutation, you first call `useConfirmDigitalCardPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmDigitalCardPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmDigitalCardPaymentMutation, { data, loading, error }] = useConfirmDigitalCardPaymentMutation({
 *   variables: {
 *      paymentIntentId: // value for 'paymentIntentId'
 *   },
 * });
 */
export function useConfirmDigitalCardPaymentMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmDigitalCardPaymentMutation, ConfirmDigitalCardPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmDigitalCardPaymentMutation, ConfirmDigitalCardPaymentMutationVariables>(ConfirmDigitalCardPaymentDocument, options);
      }
export type ConfirmDigitalCardPaymentMutationHookResult = ReturnType<typeof useConfirmDigitalCardPaymentMutation>;
export type ConfirmDigitalCardPaymentMutationResult = Apollo.MutationResult<ConfirmDigitalCardPaymentMutation>;
export type ConfirmDigitalCardPaymentMutationOptions = Apollo.BaseMutationOptions<ConfirmDigitalCardPaymentMutation, ConfirmDigitalCardPaymentMutationVariables>;
export const UpdateDigitalCardVisibilityDocument = gql`
    mutation UpdateDigitalCardVisibility($input: UpdateDigitalCardVisibilityInput!) {
  updateDigitalCardVisibility(input: $input) {
    id
    slug
    enabled
    publicUrl
    purchasedAt
    amountPaidCents
    visibility {
      about
      email
      phone
      education
      experience
      expertise
      socialLinks
      website
    }
  }
}
    `;
export type UpdateDigitalCardVisibilityMutationFn = Apollo.MutationFunction<UpdateDigitalCardVisibilityMutation, UpdateDigitalCardVisibilityMutationVariables>;

/**
 * __useUpdateDigitalCardVisibilityMutation__
 *
 * To run a mutation, you first call `useUpdateDigitalCardVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDigitalCardVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDigitalCardVisibilityMutation, { data, loading, error }] = useUpdateDigitalCardVisibilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDigitalCardVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDigitalCardVisibilityMutation, UpdateDigitalCardVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDigitalCardVisibilityMutation, UpdateDigitalCardVisibilityMutationVariables>(UpdateDigitalCardVisibilityDocument, options);
      }
export type UpdateDigitalCardVisibilityMutationHookResult = ReturnType<typeof useUpdateDigitalCardVisibilityMutation>;
export type UpdateDigitalCardVisibilityMutationResult = Apollo.MutationResult<UpdateDigitalCardVisibilityMutation>;
export type UpdateDigitalCardVisibilityMutationOptions = Apollo.BaseMutationOptions<UpdateDigitalCardVisibilityMutation, UpdateDigitalCardVisibilityMutationVariables>;
export const MyDigitalCardDocument = gql`
    query MyDigitalCard {
  myDigitalCard {
    id
    slug
    enabled
    publicUrl
    purchasedAt
    amountPaidCents
    visibility {
      about
      email
      phone
      education
      experience
      expertise
      socialLinks
      website
    }
  }
}
    `;

/**
 * __useMyDigitalCardQuery__
 *
 * To run a query within a React component, call `useMyDigitalCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyDigitalCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyDigitalCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyDigitalCardQuery(baseOptions?: Apollo.QueryHookOptions<MyDigitalCardQuery, MyDigitalCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyDigitalCardQuery, MyDigitalCardQueryVariables>(MyDigitalCardDocument, options);
      }
export function useMyDigitalCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyDigitalCardQuery, MyDigitalCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyDigitalCardQuery, MyDigitalCardQueryVariables>(MyDigitalCardDocument, options);
        }
// @ts-ignore
export function useMyDigitalCardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyDigitalCardQuery, MyDigitalCardQueryVariables>): Apollo.UseSuspenseQueryResult<MyDigitalCardQuery, MyDigitalCardQueryVariables>;
export function useMyDigitalCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyDigitalCardQuery, MyDigitalCardQueryVariables>): Apollo.UseSuspenseQueryResult<MyDigitalCardQuery | undefined, MyDigitalCardQueryVariables>;
export function useMyDigitalCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyDigitalCardQuery, MyDigitalCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyDigitalCardQuery, MyDigitalCardQueryVariables>(MyDigitalCardDocument, options);
        }
export type MyDigitalCardQueryHookResult = ReturnType<typeof useMyDigitalCardQuery>;
export type MyDigitalCardLazyQueryHookResult = ReturnType<typeof useMyDigitalCardLazyQuery>;
export type MyDigitalCardSuspenseQueryHookResult = ReturnType<typeof useMyDigitalCardSuspenseQuery>;
export type MyDigitalCardQueryResult = Apollo.QueryResult<MyDigitalCardQuery, MyDigitalCardQueryVariables>;
export const DigitalCardPriceCentsDocument = gql`
    query DigitalCardPriceCents {
  digitalCardPriceCents
}
    `;

/**
 * __useDigitalCardPriceCentsQuery__
 *
 * To run a query within a React component, call `useDigitalCardPriceCentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDigitalCardPriceCentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDigitalCardPriceCentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDigitalCardPriceCentsQuery(baseOptions?: Apollo.QueryHookOptions<DigitalCardPriceCentsQuery, DigitalCardPriceCentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DigitalCardPriceCentsQuery, DigitalCardPriceCentsQueryVariables>(DigitalCardPriceCentsDocument, options);
      }
export function useDigitalCardPriceCentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DigitalCardPriceCentsQuery, DigitalCardPriceCentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DigitalCardPriceCentsQuery, DigitalCardPriceCentsQueryVariables>(DigitalCardPriceCentsDocument, options);
        }
// @ts-ignore
export function useDigitalCardPriceCentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DigitalCardPriceCentsQuery, DigitalCardPriceCentsQueryVariables>): Apollo.UseSuspenseQueryResult<DigitalCardPriceCentsQuery, DigitalCardPriceCentsQueryVariables>;
export function useDigitalCardPriceCentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DigitalCardPriceCentsQuery, DigitalCardPriceCentsQueryVariables>): Apollo.UseSuspenseQueryResult<DigitalCardPriceCentsQuery | undefined, DigitalCardPriceCentsQueryVariables>;
export function useDigitalCardPriceCentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DigitalCardPriceCentsQuery, DigitalCardPriceCentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DigitalCardPriceCentsQuery, DigitalCardPriceCentsQueryVariables>(DigitalCardPriceCentsDocument, options);
        }
export type DigitalCardPriceCentsQueryHookResult = ReturnType<typeof useDigitalCardPriceCentsQuery>;
export type DigitalCardPriceCentsLazyQueryHookResult = ReturnType<typeof useDigitalCardPriceCentsLazyQuery>;
export type DigitalCardPriceCentsSuspenseQueryHookResult = ReturnType<typeof useDigitalCardPriceCentsSuspenseQuery>;
export type DigitalCardPriceCentsQueryResult = Apollo.QueryResult<DigitalCardPriceCentsQuery, DigitalCardPriceCentsQueryVariables>;
export const EditAboutDocument = gql`
    mutation EditAbout($input: EditAboutInput!) {
  editAbout(input: $input)
}
    `;
export type EditAboutMutationFn = Apollo.MutationFunction<EditAboutMutation, EditAboutMutationVariables>;

/**
 * __useEditAboutMutation__
 *
 * To run a mutation, you first call `useEditAboutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAboutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAboutMutation, { data, loading, error }] = useEditAboutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditAboutMutation(baseOptions?: Apollo.MutationHookOptions<EditAboutMutation, EditAboutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAboutMutation, EditAboutMutationVariables>(EditAboutDocument, options);
      }
export type EditAboutMutationHookResult = ReturnType<typeof useEditAboutMutation>;
export type EditAboutMutationResult = Apollo.MutationResult<EditAboutMutation>;
export type EditAboutMutationOptions = Apollo.BaseMutationOptions<EditAboutMutation, EditAboutMutationVariables>;
export const EditBasicAccountDocument = gql`
    mutation EditBasicAccount($input: EditBasicAccountInput!) {
  editBasicAccount(input: $input)
}
    `;
export type EditBasicAccountMutationFn = Apollo.MutationFunction<EditBasicAccountMutation, EditBasicAccountMutationVariables>;

/**
 * __useEditBasicAccountMutation__
 *
 * To run a mutation, you first call `useEditBasicAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBasicAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBasicAccountMutation, { data, loading, error }] = useEditBasicAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditBasicAccountMutation(baseOptions?: Apollo.MutationHookOptions<EditBasicAccountMutation, EditBasicAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditBasicAccountMutation, EditBasicAccountMutationVariables>(EditBasicAccountDocument, options);
      }
export type EditBasicAccountMutationHookResult = ReturnType<typeof useEditBasicAccountMutation>;
export type EditBasicAccountMutationResult = Apollo.MutationResult<EditBasicAccountMutation>;
export type EditBasicAccountMutationOptions = Apollo.BaseMutationOptions<EditBasicAccountMutation, EditBasicAccountMutationVariables>;
export const AddEducationDocument = gql`
    mutation AddEducation($input: AddEducationInput!) {
  addEducation(input: $input)
}
    `;
export type AddEducationMutationFn = Apollo.MutationFunction<AddEducationMutation, AddEducationMutationVariables>;

/**
 * __useAddEducationMutation__
 *
 * To run a mutation, you first call `useAddEducationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEducationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEducationMutation, { data, loading, error }] = useAddEducationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEducationMutation(baseOptions?: Apollo.MutationHookOptions<AddEducationMutation, AddEducationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEducationMutation, AddEducationMutationVariables>(AddEducationDocument, options);
      }
export type AddEducationMutationHookResult = ReturnType<typeof useAddEducationMutation>;
export type AddEducationMutationResult = Apollo.MutationResult<AddEducationMutation>;
export type AddEducationMutationOptions = Apollo.BaseMutationOptions<AddEducationMutation, AddEducationMutationVariables>;
export const DeleteEducationDocument = gql`
    mutation DeleteEducation($input: DeleteEducationInput!) {
  deleteEducation(input: $input)
}
    `;
export type DeleteEducationMutationFn = Apollo.MutationFunction<DeleteEducationMutation, DeleteEducationMutationVariables>;

/**
 * __useDeleteEducationMutation__
 *
 * To run a mutation, you first call `useDeleteEducationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEducationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEducationMutation, { data, loading, error }] = useDeleteEducationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEducationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEducationMutation, DeleteEducationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEducationMutation, DeleteEducationMutationVariables>(DeleteEducationDocument, options);
      }
export type DeleteEducationMutationHookResult = ReturnType<typeof useDeleteEducationMutation>;
export type DeleteEducationMutationResult = Apollo.MutationResult<DeleteEducationMutation>;
export type DeleteEducationMutationOptions = Apollo.BaseMutationOptions<DeleteEducationMutation, DeleteEducationMutationVariables>;
export const EditEducationDocument = gql`
    mutation EditEducation($input: EditEducationInput!) {
  editEducation(input: $input)
}
    `;
export type EditEducationMutationFn = Apollo.MutationFunction<EditEducationMutation, EditEducationMutationVariables>;

/**
 * __useEditEducationMutation__
 *
 * To run a mutation, you first call `useEditEducationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditEducationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editEducationMutation, { data, loading, error }] = useEditEducationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditEducationMutation(baseOptions?: Apollo.MutationHookOptions<EditEducationMutation, EditEducationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditEducationMutation, EditEducationMutationVariables>(EditEducationDocument, options);
      }
export type EditEducationMutationHookResult = ReturnType<typeof useEditEducationMutation>;
export type EditEducationMutationResult = Apollo.MutationResult<EditEducationMutation>;
export type EditEducationMutationOptions = Apollo.BaseMutationOptions<EditEducationMutation, EditEducationMutationVariables>;
export const CreateEventDocument = gql`
    mutation CreateEvent($input: CreateEventInput!) {
  createEvent(createEventInput: $input) {
    id
    name
    createdById
    imageUrl
    description
    startTime
    endTime
    location
    maxAttendees
    category
    participantsCount
    organizedby {
      userId
      imageUrl
      name
      companyName
    }
    isjoinedbyMe
    createdAt
    updatedAt
  }
}
    `;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const UpdateEventDocument = gql`
    mutation UpdateEvent($input: UpdateEventInput!) {
  updateEvent(updateEventInput: $input) {
    id
    name
    createdById
    imageUrl
    description
    startTime
    endTime
    location
    maxAttendees
    category
    participantsCount
    organizedby {
      userId
      imageUrl
      name
      companyName
    }
    isjoinedbyMe
    updatedAt
  }
}
    `;
export type UpdateEventMutationFn = Apollo.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, options);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;
export const GetAllEventsDocument = gql`
    query GetAllEvents($page: Int, $limit: Int) {
  getAllEvents(page: $page, limit: $limit) {
    data {
      id
      libraryItemId
      name
      createdById
      imageUrl
      description
      startTime
      endTime
      location
      maxAttendees
      category
      course {
        id
        title
        thumbnailUrl
      }
      participantsCount
      organizedby {
        userId
        imageUrl
        name
        influenceBadge {
          ...InfluenceBadgeFields
        }
        companyName
      }
      isjoinedbyMe
      createdAt
      updatedAt
    }
    total
    page
    limit
    totalPages
    hasNextPage
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetAllEventsQuery__
 *
 * To run a query within a React component, call `useGetAllEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEventsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAllEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEventsQuery, GetAllEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEventsQuery, GetAllEventsQueryVariables>(GetAllEventsDocument, options);
      }
export function useGetAllEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEventsQuery, GetAllEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEventsQuery, GetAllEventsQueryVariables>(GetAllEventsDocument, options);
        }
// @ts-ignore
export function useGetAllEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllEventsQuery, GetAllEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllEventsQuery, GetAllEventsQueryVariables>;
export function useGetAllEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllEventsQuery, GetAllEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllEventsQuery | undefined, GetAllEventsQueryVariables>;
export function useGetAllEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllEventsQuery, GetAllEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllEventsQuery, GetAllEventsQueryVariables>(GetAllEventsDocument, options);
        }
export type GetAllEventsQueryHookResult = ReturnType<typeof useGetAllEventsQuery>;
export type GetAllEventsLazyQueryHookResult = ReturnType<typeof useGetAllEventsLazyQuery>;
export type GetAllEventsSuspenseQueryHookResult = ReturnType<typeof useGetAllEventsSuspenseQuery>;
export type GetAllEventsQueryResult = Apollo.QueryResult<GetAllEventsQuery, GetAllEventsQueryVariables>;
export const GetMyEventsDocument = gql`
    query GetMyEvents($page: Int, $limit: Int) {
  getMyEvents(page: $page, limit: $limit) {
    data {
      id
      libraryItemId
      name
      createdById
      imageUrl
      description
      startTime
      endTime
      location
      maxAttendees
      category
      participantsCount
      course {
        id
        title
        thumbnailUrl
      }
      organizedby {
        userId
        imageUrl
        name
        influenceBadge {
          ...InfluenceBadgeFields
        }
        companyName
      }
      isjoinedbyMe
      createdAt
      updatedAt
    }
    total
    page
    limit
    totalPages
    hasNextPage
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetMyEventsQuery__
 *
 * To run a query within a React component, call `useGetMyEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyEventsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMyEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyEventsQuery, GetMyEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyEventsQuery, GetMyEventsQueryVariables>(GetMyEventsDocument, options);
      }
export function useGetMyEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyEventsQuery, GetMyEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyEventsQuery, GetMyEventsQueryVariables>(GetMyEventsDocument, options);
        }
// @ts-ignore
export function useGetMyEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyEventsQuery, GetMyEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyEventsQuery, GetMyEventsQueryVariables>;
export function useGetMyEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyEventsQuery, GetMyEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyEventsQuery | undefined, GetMyEventsQueryVariables>;
export function useGetMyEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyEventsQuery, GetMyEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyEventsQuery, GetMyEventsQueryVariables>(GetMyEventsDocument, options);
        }
export type GetMyEventsQueryHookResult = ReturnType<typeof useGetMyEventsQuery>;
export type GetMyEventsLazyQueryHookResult = ReturnType<typeof useGetMyEventsLazyQuery>;
export type GetMyEventsSuspenseQueryHookResult = ReturnType<typeof useGetMyEventsSuspenseQuery>;
export type GetMyEventsQueryResult = Apollo.QueryResult<GetMyEventsQuery, GetMyEventsQueryVariables>;
export const JoinEventDocument = gql`
    mutation JoinEvent($eventId: String!) {
  joinEvent(eventId: $eventId)
}
    `;
export type JoinEventMutationFn = Apollo.MutationFunction<JoinEventMutation, JoinEventMutationVariables>;

/**
 * __useJoinEventMutation__
 *
 * To run a mutation, you first call `useJoinEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinEventMutation, { data, loading, error }] = useJoinEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useJoinEventMutation(baseOptions?: Apollo.MutationHookOptions<JoinEventMutation, JoinEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinEventMutation, JoinEventMutationVariables>(JoinEventDocument, options);
      }
export type JoinEventMutationHookResult = ReturnType<typeof useJoinEventMutation>;
export type JoinEventMutationResult = Apollo.MutationResult<JoinEventMutation>;
export type JoinEventMutationOptions = Apollo.BaseMutationOptions<JoinEventMutation, JoinEventMutationVariables>;
export const LeaveEventDocument = gql`
    mutation LeaveEvent($eventId: String!) {
  leaveEvent(eventId: $eventId)
}
    `;
export type LeaveEventMutationFn = Apollo.MutationFunction<LeaveEventMutation, LeaveEventMutationVariables>;

/**
 * __useLeaveEventMutation__
 *
 * To run a mutation, you first call `useLeaveEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveEventMutation, { data, loading, error }] = useLeaveEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useLeaveEventMutation(baseOptions?: Apollo.MutationHookOptions<LeaveEventMutation, LeaveEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveEventMutation, LeaveEventMutationVariables>(LeaveEventDocument, options);
      }
export type LeaveEventMutationHookResult = ReturnType<typeof useLeaveEventMutation>;
export type LeaveEventMutationResult = Apollo.MutationResult<LeaveEventMutation>;
export type LeaveEventMutationOptions = Apollo.BaseMutationOptions<LeaveEventMutation, LeaveEventMutationVariables>;
export const GetJoinedEventsDocument = gql`
    query GetJoinedEvents($page: Int, $limit: Int) {
  getJoinedEvents(page: $page, limit: $limit) {
    data {
      id
      libraryItemId
      name
      createdById
      imageUrl
      description
      startTime
      endTime
      location
      maxAttendees
      category
      course {
        id
        title
        thumbnailUrl
      }
      participantsCount
      organizedby {
        userId
        imageUrl
        name
        influenceBadge {
          ...InfluenceBadgeFields
        }
        companyName
      }
      isjoinedbyMe
      createdAt
      updatedAt
    }
    total
    page
    limit
    totalPages
    hasNextPage
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetJoinedEventsQuery__
 *
 * To run a query within a React component, call `useGetJoinedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJoinedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJoinedEventsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetJoinedEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetJoinedEventsQuery, GetJoinedEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJoinedEventsQuery, GetJoinedEventsQueryVariables>(GetJoinedEventsDocument, options);
      }
export function useGetJoinedEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJoinedEventsQuery, GetJoinedEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJoinedEventsQuery, GetJoinedEventsQueryVariables>(GetJoinedEventsDocument, options);
        }
// @ts-ignore
export function useGetJoinedEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJoinedEventsQuery, GetJoinedEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetJoinedEventsQuery, GetJoinedEventsQueryVariables>;
export function useGetJoinedEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJoinedEventsQuery, GetJoinedEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetJoinedEventsQuery | undefined, GetJoinedEventsQueryVariables>;
export function useGetJoinedEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJoinedEventsQuery, GetJoinedEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJoinedEventsQuery, GetJoinedEventsQueryVariables>(GetJoinedEventsDocument, options);
        }
export type GetJoinedEventsQueryHookResult = ReturnType<typeof useGetJoinedEventsQuery>;
export type GetJoinedEventsLazyQueryHookResult = ReturnType<typeof useGetJoinedEventsLazyQuery>;
export type GetJoinedEventsSuspenseQueryHookResult = ReturnType<typeof useGetJoinedEventsSuspenseQuery>;
export type GetJoinedEventsQueryResult = Apollo.QueryResult<GetJoinedEventsQuery, GetJoinedEventsQueryVariables>;
export const DeleteEventDocument = gql`
    mutation DeleteEvent($id: String!) {
  deleteEvent(id: $id)
}
    `;
export type DeleteEventMutationFn = Apollo.MutationFunction<DeleteEventMutation, DeleteEventMutationVariables>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventMutation, DeleteEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(DeleteEventDocument, options);
      }
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>;
export type DeleteEventMutationResult = Apollo.MutationResult<DeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<DeleteEventMutation, DeleteEventMutationVariables>;
export const GetEventByIdDocument = gql`
    query GetEventById($eventId: String!) {
  getEventById(id: $eventId) {
    id
    name
    description
    imageUrl
    startTime
    endTime
    location
    maxAttendees
    category
    course {
      id
      title
      thumbnailUrl
    }
    participantsCount
    organizedby {
      userId
      imageUrl
      name
      influenceBadge {
        ...InfluenceBadgeFields
      }
      companyName
    }
    isjoinedbyMe
    createdAt
    updatedAt
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetEventByIdQuery__
 *
 * To run a query within a React component, call `useGetEventByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventByIdQuery(baseOptions: Apollo.QueryHookOptions<GetEventByIdQuery, GetEventByIdQueryVariables> & ({ variables: GetEventByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventByIdQuery, GetEventByIdQueryVariables>(GetEventByIdDocument, options);
      }
export function useGetEventByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventByIdQuery, GetEventByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventByIdQuery, GetEventByIdQueryVariables>(GetEventByIdDocument, options);
        }
// @ts-ignore
export function useGetEventByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventByIdQuery, GetEventByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventByIdQuery, GetEventByIdQueryVariables>;
export function useGetEventByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventByIdQuery, GetEventByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventByIdQuery | undefined, GetEventByIdQueryVariables>;
export function useGetEventByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventByIdQuery, GetEventByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventByIdQuery, GetEventByIdQueryVariables>(GetEventByIdDocument, options);
        }
export type GetEventByIdQueryHookResult = ReturnType<typeof useGetEventByIdQuery>;
export type GetEventByIdLazyQueryHookResult = ReturnType<typeof useGetEventByIdLazyQuery>;
export type GetEventByIdSuspenseQueryHookResult = ReturnType<typeof useGetEventByIdSuspenseQuery>;
export type GetEventByIdQueryResult = Apollo.QueryResult<GetEventByIdQuery, GetEventByIdQueryVariables>;
export const GetJoinedPeopleByEventIdDocument = gql`
    query GetJoinedPeopleByEventId($eventId: String!) {
  getJoinedPeopleByEventId(eventId: $eventId) {
    id
    imageUrl
    firstName
    lastName
    title
    email
    influenceBadge {
      ...InfluenceBadgeFields
    }
    companyName
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetJoinedPeopleByEventIdQuery__
 *
 * To run a query within a React component, call `useGetJoinedPeopleByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJoinedPeopleByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJoinedPeopleByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetJoinedPeopleByEventIdQuery(baseOptions: Apollo.QueryHookOptions<GetJoinedPeopleByEventIdQuery, GetJoinedPeopleByEventIdQueryVariables> & ({ variables: GetJoinedPeopleByEventIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJoinedPeopleByEventIdQuery, GetJoinedPeopleByEventIdQueryVariables>(GetJoinedPeopleByEventIdDocument, options);
      }
export function useGetJoinedPeopleByEventIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJoinedPeopleByEventIdQuery, GetJoinedPeopleByEventIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJoinedPeopleByEventIdQuery, GetJoinedPeopleByEventIdQueryVariables>(GetJoinedPeopleByEventIdDocument, options);
        }
// @ts-ignore
export function useGetJoinedPeopleByEventIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJoinedPeopleByEventIdQuery, GetJoinedPeopleByEventIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetJoinedPeopleByEventIdQuery, GetJoinedPeopleByEventIdQueryVariables>;
export function useGetJoinedPeopleByEventIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJoinedPeopleByEventIdQuery, GetJoinedPeopleByEventIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetJoinedPeopleByEventIdQuery | undefined, GetJoinedPeopleByEventIdQueryVariables>;
export function useGetJoinedPeopleByEventIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJoinedPeopleByEventIdQuery, GetJoinedPeopleByEventIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJoinedPeopleByEventIdQuery, GetJoinedPeopleByEventIdQueryVariables>(GetJoinedPeopleByEventIdDocument, options);
        }
export type GetJoinedPeopleByEventIdQueryHookResult = ReturnType<typeof useGetJoinedPeopleByEventIdQuery>;
export type GetJoinedPeopleByEventIdLazyQueryHookResult = ReturnType<typeof useGetJoinedPeopleByEventIdLazyQuery>;
export type GetJoinedPeopleByEventIdSuspenseQueryHookResult = ReturnType<typeof useGetJoinedPeopleByEventIdSuspenseQuery>;
export type GetJoinedPeopleByEventIdQueryResult = Apollo.QueryResult<GetJoinedPeopleByEventIdQuery, GetJoinedPeopleByEventIdQueryVariables>;
export const SearchGroupsByNameDocument = gql`
    query SearchGroupsByName($query: String) {
  searchGroupsByName(query: $query) {
    id
    name
    description
    profileImage
    coverImage
    privacy
    membersCount
    postsCount
    owner {
      id
      name
      profileImageUrl
      role
    }
    isJoined
    createdAt
  }
}
    `;

/**
 * __useSearchGroupsByNameQuery__
 *
 * To run a query within a React component, call `useSearchGroupsByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchGroupsByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchGroupsByNameQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchGroupsByNameQuery(baseOptions?: Apollo.QueryHookOptions<SearchGroupsByNameQuery, SearchGroupsByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchGroupsByNameQuery, SearchGroupsByNameQueryVariables>(SearchGroupsByNameDocument, options);
      }
export function useSearchGroupsByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchGroupsByNameQuery, SearchGroupsByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchGroupsByNameQuery, SearchGroupsByNameQueryVariables>(SearchGroupsByNameDocument, options);
        }
// @ts-ignore
export function useSearchGroupsByNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchGroupsByNameQuery, SearchGroupsByNameQueryVariables>): Apollo.UseSuspenseQueryResult<SearchGroupsByNameQuery, SearchGroupsByNameQueryVariables>;
export function useSearchGroupsByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchGroupsByNameQuery, SearchGroupsByNameQueryVariables>): Apollo.UseSuspenseQueryResult<SearchGroupsByNameQuery | undefined, SearchGroupsByNameQueryVariables>;
export function useSearchGroupsByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchGroupsByNameQuery, SearchGroupsByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchGroupsByNameQuery, SearchGroupsByNameQueryVariables>(SearchGroupsByNameDocument, options);
        }
export type SearchGroupsByNameQueryHookResult = ReturnType<typeof useSearchGroupsByNameQuery>;
export type SearchGroupsByNameLazyQueryHookResult = ReturnType<typeof useSearchGroupsByNameLazyQuery>;
export type SearchGroupsByNameSuspenseQueryHookResult = ReturnType<typeof useSearchGroupsByNameSuspenseQuery>;
export type SearchGroupsByNameQueryResult = Apollo.QueryResult<SearchGroupsByNameQuery, SearchGroupsByNameQueryVariables>;
export const SearchUsersByNameDocument = gql`
    query SearchUsersByName($query: String) {
  searchUsersByName(query: $query) {
    id
    firstName
    lastName
    title
    profileImageUrl
    role
    companyName
  }
}
    `;

/**
 * __useSearchUsersByNameQuery__
 *
 * To run a query within a React component, call `useSearchUsersByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersByNameQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchUsersByNameQuery(baseOptions?: Apollo.QueryHookOptions<SearchUsersByNameQuery, SearchUsersByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersByNameQuery, SearchUsersByNameQueryVariables>(SearchUsersByNameDocument, options);
      }
export function useSearchUsersByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersByNameQuery, SearchUsersByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersByNameQuery, SearchUsersByNameQueryVariables>(SearchUsersByNameDocument, options);
        }
// @ts-ignore
export function useSearchUsersByNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchUsersByNameQuery, SearchUsersByNameQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUsersByNameQuery, SearchUsersByNameQueryVariables>;
export function useSearchUsersByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUsersByNameQuery, SearchUsersByNameQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUsersByNameQuery | undefined, SearchUsersByNameQueryVariables>;
export function useSearchUsersByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUsersByNameQuery, SearchUsersByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUsersByNameQuery, SearchUsersByNameQueryVariables>(SearchUsersByNameDocument, options);
        }
export type SearchUsersByNameQueryHookResult = ReturnType<typeof useSearchUsersByNameQuery>;
export type SearchUsersByNameLazyQueryHookResult = ReturnType<typeof useSearchUsersByNameLazyQuery>;
export type SearchUsersByNameSuspenseQueryHookResult = ReturnType<typeof useSearchUsersByNameSuspenseQuery>;
export type SearchUsersByNameQueryResult = Apollo.QueryResult<SearchUsersByNameQuery, SearchUsersByNameQueryVariables>;
export const GetLivekitTokenForEventDocument = gql`
    mutation GetLivekitTokenForEvent($eventId: String!) {
  getLivekitTokenForEvent(eventId: $eventId) {
    token
    room
  }
}
    `;
export type GetLivekitTokenForEventMutationFn = Apollo.MutationFunction<GetLivekitTokenForEventMutation, GetLivekitTokenForEventMutationVariables>;

/**
 * __useGetLivekitTokenForEventMutation__
 *
 * To run a mutation, you first call `useGetLivekitTokenForEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetLivekitTokenForEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getLivekitTokenForEventMutation, { data, loading, error }] = useGetLivekitTokenForEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetLivekitTokenForEventMutation(baseOptions?: Apollo.MutationHookOptions<GetLivekitTokenForEventMutation, GetLivekitTokenForEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetLivekitTokenForEventMutation, GetLivekitTokenForEventMutationVariables>(GetLivekitTokenForEventDocument, options);
      }
export type GetLivekitTokenForEventMutationHookResult = ReturnType<typeof useGetLivekitTokenForEventMutation>;
export type GetLivekitTokenForEventMutationResult = Apollo.MutationResult<GetLivekitTokenForEventMutation>;
export type GetLivekitTokenForEventMutationOptions = Apollo.BaseMutationOptions<GetLivekitTokenForEventMutation, GetLivekitTokenForEventMutationVariables>;
export const KickParticipantDocument = gql`
    mutation KickParticipant($eventId: String!, $participantId: String!) {
  kickParticipant(eventId: $eventId, participantId: $participantId)
}
    `;
export type KickParticipantMutationFn = Apollo.MutationFunction<KickParticipantMutation, KickParticipantMutationVariables>;

/**
 * __useKickParticipantMutation__
 *
 * To run a mutation, you first call `useKickParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKickParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kickParticipantMutation, { data, loading, error }] = useKickParticipantMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useKickParticipantMutation(baseOptions?: Apollo.MutationHookOptions<KickParticipantMutation, KickParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KickParticipantMutation, KickParticipantMutationVariables>(KickParticipantDocument, options);
      }
export type KickParticipantMutationHookResult = ReturnType<typeof useKickParticipantMutation>;
export type KickParticipantMutationResult = Apollo.MutationResult<KickParticipantMutation>;
export type KickParticipantMutationOptions = Apollo.BaseMutationOptions<KickParticipantMutation, KickParticipantMutationVariables>;
export const GetEventsByCourseIdDocument = gql`
    query GetEventsByCourseId($courseId: String!) {
  getEventsByCourseId(courseId: $courseId) {
    data {
      id
      name
      description
      imageUrl
      startTime
      endTime
      location
      maxAttendees
      category
      course {
        id
        title
        thumbnailUrl
      }
      participantsCount
      organizedby {
        userId
        imageUrl
        name
        companyName
      }
      isjoinedbyMe
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetEventsByCourseIdQuery__
 *
 * To run a query within a React component, call `useGetEventsByCourseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsByCourseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsByCourseIdQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetEventsByCourseIdQuery(baseOptions: Apollo.QueryHookOptions<GetEventsByCourseIdQuery, GetEventsByCourseIdQueryVariables> & ({ variables: GetEventsByCourseIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsByCourseIdQuery, GetEventsByCourseIdQueryVariables>(GetEventsByCourseIdDocument, options);
      }
export function useGetEventsByCourseIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsByCourseIdQuery, GetEventsByCourseIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsByCourseIdQuery, GetEventsByCourseIdQueryVariables>(GetEventsByCourseIdDocument, options);
        }
// @ts-ignore
export function useGetEventsByCourseIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventsByCourseIdQuery, GetEventsByCourseIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventsByCourseIdQuery, GetEventsByCourseIdQueryVariables>;
export function useGetEventsByCourseIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventsByCourseIdQuery, GetEventsByCourseIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventsByCourseIdQuery | undefined, GetEventsByCourseIdQueryVariables>;
export function useGetEventsByCourseIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventsByCourseIdQuery, GetEventsByCourseIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventsByCourseIdQuery, GetEventsByCourseIdQueryVariables>(GetEventsByCourseIdDocument, options);
        }
export type GetEventsByCourseIdQueryHookResult = ReturnType<typeof useGetEventsByCourseIdQuery>;
export type GetEventsByCourseIdLazyQueryHookResult = ReturnType<typeof useGetEventsByCourseIdLazyQuery>;
export type GetEventsByCourseIdSuspenseQueryHookResult = ReturnType<typeof useGetEventsByCourseIdSuspenseQuery>;
export type GetEventsByCourseIdQueryResult = Apollo.QueryResult<GetEventsByCourseIdQuery, GetEventsByCourseIdQueryVariables>;
export const AddExperienceDocument = gql`
    mutation AddExperience($input: AddExperienceInput!) {
  addExperience(input: $input)
}
    `;
export type AddExperienceMutationFn = Apollo.MutationFunction<AddExperienceMutation, AddExperienceMutationVariables>;

/**
 * __useAddExperienceMutation__
 *
 * To run a mutation, you first call `useAddExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExperienceMutation, { data, loading, error }] = useAddExperienceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddExperienceMutation(baseOptions?: Apollo.MutationHookOptions<AddExperienceMutation, AddExperienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExperienceMutation, AddExperienceMutationVariables>(AddExperienceDocument, options);
      }
export type AddExperienceMutationHookResult = ReturnType<typeof useAddExperienceMutation>;
export type AddExperienceMutationResult = Apollo.MutationResult<AddExperienceMutation>;
export type AddExperienceMutationOptions = Apollo.BaseMutationOptions<AddExperienceMutation, AddExperienceMutationVariables>;
export const DeleteExperienceDocument = gql`
    mutation DeleteExperience($input: DeleteExperienceInput!) {
  deleteExperience(input: $input)
}
    `;
export type DeleteExperienceMutationFn = Apollo.MutationFunction<DeleteExperienceMutation, DeleteExperienceMutationVariables>;

/**
 * __useDeleteExperienceMutation__
 *
 * To run a mutation, you first call `useDeleteExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExperienceMutation, { data, loading, error }] = useDeleteExperienceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteExperienceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExperienceMutation, DeleteExperienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExperienceMutation, DeleteExperienceMutationVariables>(DeleteExperienceDocument, options);
      }
export type DeleteExperienceMutationHookResult = ReturnType<typeof useDeleteExperienceMutation>;
export type DeleteExperienceMutationResult = Apollo.MutationResult<DeleteExperienceMutation>;
export type DeleteExperienceMutationOptions = Apollo.BaseMutationOptions<DeleteExperienceMutation, DeleteExperienceMutationVariables>;
export const EditExperienceDocument = gql`
    mutation EditExperience($input: EditExperienceInput!) {
  editExperience(input: $input)
}
    `;
export type EditExperienceMutationFn = Apollo.MutationFunction<EditExperienceMutation, EditExperienceMutationVariables>;

/**
 * __useEditExperienceMutation__
 *
 * To run a mutation, you first call `useEditExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editExperienceMutation, { data, loading, error }] = useEditExperienceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditExperienceMutation(baseOptions?: Apollo.MutationHookOptions<EditExperienceMutation, EditExperienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditExperienceMutation, EditExperienceMutationVariables>(EditExperienceDocument, options);
      }
export type EditExperienceMutationHookResult = ReturnType<typeof useEditExperienceMutation>;
export type EditExperienceMutationResult = Apollo.MutationResult<EditExperienceMutation>;
export type EditExperienceMutationOptions = Apollo.BaseMutationOptions<EditExperienceMutation, EditExperienceMutationVariables>;
export const CreateFaqDocument = gql`
    mutation CreateFaq($input: CreateFaqInput!) {
  createFaq(input: $input) {
    id
    mentorId
    question
    answer
    createdAt
    updatedAt
  }
}
    `;
export type CreateFaqMutationFn = Apollo.MutationFunction<CreateFaqMutation, CreateFaqMutationVariables>;

/**
 * __useCreateFaqMutation__
 *
 * To run a mutation, you first call `useCreateFaqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFaqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFaqMutation, { data, loading, error }] = useCreateFaqMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFaqMutation(baseOptions?: Apollo.MutationHookOptions<CreateFaqMutation, CreateFaqMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFaqMutation, CreateFaqMutationVariables>(CreateFaqDocument, options);
      }
export type CreateFaqMutationHookResult = ReturnType<typeof useCreateFaqMutation>;
export type CreateFaqMutationResult = Apollo.MutationResult<CreateFaqMutation>;
export type CreateFaqMutationOptions = Apollo.BaseMutationOptions<CreateFaqMutation, CreateFaqMutationVariables>;
export const UpdateFaqDocument = gql`
    mutation UpdateFaq($input: UpdateFaqInput!) {
  updateFaq(input: $input) {
    id
    mentorId
    question
    answer
    createdAt
    updatedAt
  }
}
    `;
export type UpdateFaqMutationFn = Apollo.MutationFunction<UpdateFaqMutation, UpdateFaqMutationVariables>;

/**
 * __useUpdateFaqMutation__
 *
 * To run a mutation, you first call `useUpdateFaqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFaqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFaqMutation, { data, loading, error }] = useUpdateFaqMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFaqMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFaqMutation, UpdateFaqMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFaqMutation, UpdateFaqMutationVariables>(UpdateFaqDocument, options);
      }
export type UpdateFaqMutationHookResult = ReturnType<typeof useUpdateFaqMutation>;
export type UpdateFaqMutationResult = Apollo.MutationResult<UpdateFaqMutation>;
export type UpdateFaqMutationOptions = Apollo.BaseMutationOptions<UpdateFaqMutation, UpdateFaqMutationVariables>;
export const DeleteFaqDocument = gql`
    mutation DeleteFaq($id: ID!) {
  deleteFaq(id: $id)
}
    `;
export type DeleteFaqMutationFn = Apollo.MutationFunction<DeleteFaqMutation, DeleteFaqMutationVariables>;

/**
 * __useDeleteFaqMutation__
 *
 * To run a mutation, you first call `useDeleteFaqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFaqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFaqMutation, { data, loading, error }] = useDeleteFaqMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFaqMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFaqMutation, DeleteFaqMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFaqMutation, DeleteFaqMutationVariables>(DeleteFaqDocument, options);
      }
export type DeleteFaqMutationHookResult = ReturnType<typeof useDeleteFaqMutation>;
export type DeleteFaqMutationResult = Apollo.MutationResult<DeleteFaqMutation>;
export type DeleteFaqMutationOptions = Apollo.BaseMutationOptions<DeleteFaqMutation, DeleteFaqMutationVariables>;
export const GetFaqDocument = gql`
    query GetFaq($id: ID!) {
  getFaq(id: $id) {
    id
    mentorId
    question
    answer
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetFaqQuery__
 *
 * To run a query within a React component, call `useGetFaqQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFaqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFaqQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFaqQuery(baseOptions: Apollo.QueryHookOptions<GetFaqQuery, GetFaqQueryVariables> & ({ variables: GetFaqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFaqQuery, GetFaqQueryVariables>(GetFaqDocument, options);
      }
export function useGetFaqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFaqQuery, GetFaqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFaqQuery, GetFaqQueryVariables>(GetFaqDocument, options);
        }
// @ts-ignore
export function useGetFaqSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFaqQuery, GetFaqQueryVariables>): Apollo.UseSuspenseQueryResult<GetFaqQuery, GetFaqQueryVariables>;
export function useGetFaqSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFaqQuery, GetFaqQueryVariables>): Apollo.UseSuspenseQueryResult<GetFaqQuery | undefined, GetFaqQueryVariables>;
export function useGetFaqSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFaqQuery, GetFaqQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFaqQuery, GetFaqQueryVariables>(GetFaqDocument, options);
        }
export type GetFaqQueryHookResult = ReturnType<typeof useGetFaqQuery>;
export type GetFaqLazyQueryHookResult = ReturnType<typeof useGetFaqLazyQuery>;
export type GetFaqSuspenseQueryHookResult = ReturnType<typeof useGetFaqSuspenseQuery>;
export type GetFaqQueryResult = Apollo.QueryResult<GetFaqQuery, GetFaqQueryVariables>;
export const GetMentorFaqsDocument = gql`
    query GetMentorFaqs($mentorId: ID!) {
  getMentorFaqs(mentorId: $mentorId) {
    faqs {
      id
      mentorId
      question
      answer
      createdAt
      updatedAt
    }
    total
  }
}
    `;

/**
 * __useGetMentorFaqsQuery__
 *
 * To run a query within a React component, call `useGetMentorFaqsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentorFaqsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentorFaqsQuery({
 *   variables: {
 *      mentorId: // value for 'mentorId'
 *   },
 * });
 */
export function useGetMentorFaqsQuery(baseOptions: Apollo.QueryHookOptions<GetMentorFaqsQuery, GetMentorFaqsQueryVariables> & ({ variables: GetMentorFaqsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMentorFaqsQuery, GetMentorFaqsQueryVariables>(GetMentorFaqsDocument, options);
      }
export function useGetMentorFaqsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMentorFaqsQuery, GetMentorFaqsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMentorFaqsQuery, GetMentorFaqsQueryVariables>(GetMentorFaqsDocument, options);
        }
// @ts-ignore
export function useGetMentorFaqsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMentorFaqsQuery, GetMentorFaqsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMentorFaqsQuery, GetMentorFaqsQueryVariables>;
export function useGetMentorFaqsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMentorFaqsQuery, GetMentorFaqsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMentorFaqsQuery | undefined, GetMentorFaqsQueryVariables>;
export function useGetMentorFaqsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMentorFaqsQuery, GetMentorFaqsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMentorFaqsQuery, GetMentorFaqsQueryVariables>(GetMentorFaqsDocument, options);
        }
export type GetMentorFaqsQueryHookResult = ReturnType<typeof useGetMentorFaqsQuery>;
export type GetMentorFaqsLazyQueryHookResult = ReturnType<typeof useGetMentorFaqsLazyQuery>;
export type GetMentorFaqsSuspenseQueryHookResult = ReturnType<typeof useGetMentorFaqsSuspenseQuery>;
export type GetMentorFaqsQueryResult = Apollo.QueryResult<GetMentorFaqsQuery, GetMentorFaqsQueryVariables>;
export const FeedDocument = gql`
    query Feed($input: FeedInput!) {
  feed(input: $input) {
    pageInfo {
      nextCursor
      hasNextPage
    }
    items {
      id
      type
      cursor
      advertisement {
        id
        name
        headline
        description
        adFormat
        mediaUrls
        ctaText
        ctaUrl
        user {
          id
          organizationName
          firstName
          lastName
          title
          profileImageUrl
          companyName
        }
      }
      profileBoost {
        id
        headline
        videoUrl
        mentor {
          id
          firstName
          lastName
          title
          profileImageUrl
          role
          headline
          isMentorVerified
          companyName
        }
      }
      postBoost {
        id
        postId
        userId
        status
        durationHours
        durationSeconds
        hourlyRateCents
        amountCents
        currency
        startsAt
        expiresAt
        remainingDurationSeconds
        paymentIntentId
        invoiceId
        createdAt
        updatedAt
      }
      reels {
        id
        userId
        title
        hlsUrl
        rawVideoUrl
        blurHash
        isCurated
        embedUrl
        sourceUrl
        thumbnailUrl
        provider
        channelTitle
        author {
          id
          name
          profileImageUrl
          companyName
        }
      }
      post {
        id
        contentTokens {
          type
          value
          userId
          handle
          url
        }
        translatedContentTokens {
          type
          value
          userId
          handle
          url
        }
        createdAt
        updatedAt
        isPublished
        commentsCount
        mediaUrls
        optimizedMediaUrls
        postType
        companyId
        groupId
        group {
          id
          name
          privacy
          slug
          profileImage
          profileImageOptimizedUrl
          coverImage
          coverImageOptimizedUrl
        }
        isRepost
        repostComment
        isSavedByMe
        isRepostedByMe
        isBoosted
        activeBoostId
        author {
          id
          firstName
          lastName
          title
          middleName
          profileImageUrl
          profileImageOptimizedUrl
          role
          headline
          isHiring
          openToWork
          connection {
            status
            direction
          }
          isMentorVerified
          influenceBadge {
            ...InfluenceBadgeFields
          }
          actionButtons {
            id
            name
            url
            isShow
            createdAt
          }
          companyName
        }
        companyAuthor {
          id
          name
          logoUrl
          logoOptimizedUrl
          industry
          tagline
          followersCount
          isFollowing
        }
        reactions {
          totalReactions
          currentUserReaction
          reactionCounts {
            type
            count
          }
        }
        article {
          id
          title
          subtitle
          coverImageUrl
          slug
          readingTimeMinutes
          status
          content
          tags
          translatedTitle
          translatedSubtitle
          translatedExcerpt
        }
        poll {
          question
          expiresAt
          options {
            id
            text
            votes
            isChosen
          }
          translatedQuestion
          translatedOptions
        }
        occasion {
          id
          postId
          title
          description
          imageUrl
          privacy
          translatedTitle
          translatedDescription
        }
        event {
          id
          name
          description
          imageUrl
          startTime
          endTime
          location
          category
          maxAttendees
          participantsCount
          organizedby {
            userId
            name
            imageUrl
            companyName
          }
          course {
            id
            title
            thumbnailUrl
          }
          isjoinedbyMe
        }
        case {
          id
          postId
          createdAt
          updatedAt
          media {
            id
            step
            type
            imageUrl
            text
            order
            createdAt
            translatedText
          }
        }
        originalPost {
          id
          contentTokens {
            type
            value
            userId
            handle
            url
          }
          translatedContentTokens {
            type
            value
            userId
            handle
            url
          }
          createdAt
          mediaUrls
          optimizedMediaUrls
          isBoosted
          activeBoostId
          groupId
          group {
            id
            name
            privacy
            slug
            profileImage
            profileImageOptimizedUrl
            coverImage
            coverImageOptimizedUrl
          }
          author {
            id
            firstName
            lastName
            middleName
            title
            profileImageUrl
            role
            headline
            isHiring
            openToWork
            connection {
              status
              direction
            }
            isMentorVerified
            influenceBadge {
              ...InfluenceBadgeFields
            }
            actionButtons {
              id
              name
              url
              isShow
              createdAt
            }
            companyName
          }
          poll {
            question
            expiresAt
            options {
              id
              text
              votes
              isChosen
            }
            translatedQuestion
            translatedOptions
          }
          occasion {
            id
            postId
            title
            description
            imageUrl
            privacy
            translatedTitle
            translatedDescription
          }
          event {
            id
            name
            description
            imageUrl
            startTime
            endTime
            location
            category
            maxAttendees
            participantsCount
            organizedby {
              userId
              name
              imageUrl
              companyName
            }
            course {
              id
              title
              thumbnailUrl
            }
            isjoinedbyMe
          }
          case {
            id
            postId
            createdAt
            updatedAt
            media {
              id
              step
              type
              imageUrl
              text
              order
              createdAt
              translatedText
            }
          }
          article {
            id
            title
            subtitle
            coverImageUrl
            slug
            readingTimeMinutes
            status
            content
            tags
            translatedTitle
            translatedSubtitle
            translatedExcerpt
          }
          companyAuthor {
            id
            name
            logoUrl
            industry
            tagline
            followersCount
            isFollowing
          }
        }
      }
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useFeedQuery__
 *
 * To run a query within a React component, call `useFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFeedQuery(baseOptions: Apollo.QueryHookOptions<FeedQuery, FeedQueryVariables> & ({ variables: FeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedQuery, FeedQueryVariables>(FeedDocument, options);
      }
export function useFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedQuery, FeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedQuery, FeedQueryVariables>(FeedDocument, options);
        }
// @ts-ignore
export function useFeedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeedQuery, FeedQueryVariables>): Apollo.UseSuspenseQueryResult<FeedQuery, FeedQueryVariables>;
export function useFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedQuery, FeedQueryVariables>): Apollo.UseSuspenseQueryResult<FeedQuery | undefined, FeedQueryVariables>;
export function useFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedQuery, FeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedQuery, FeedQueryVariables>(FeedDocument, options);
        }
export type FeedQueryHookResult = ReturnType<typeof useFeedQuery>;
export type FeedLazyQueryHookResult = ReturnType<typeof useFeedLazyQuery>;
export type FeedSuspenseQueryHookResult = ReturnType<typeof useFeedSuspenseQuery>;
export type FeedQueryResult = Apollo.QueryResult<FeedQuery, FeedQueryVariables>;
export const ForgetPasswordDocument = gql`
    mutation ForgetPassword($input: ForgetPasswordInput!) {
  forgetPassword(input: $input)
}
    `;
export type ForgetPasswordMutationFn = Apollo.MutationFunction<ForgetPasswordMutation, ForgetPasswordMutationVariables>;

/**
 * __useForgetPasswordMutation__
 *
 * To run a mutation, you first call `useForgetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgetPasswordMutation, { data, loading, error }] = useForgetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForgetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgetPasswordMutation, ForgetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgetPasswordMutation, ForgetPasswordMutationVariables>(ForgetPasswordDocument, options);
      }
export type ForgetPasswordMutationHookResult = ReturnType<typeof useForgetPasswordMutation>;
export type ForgetPasswordMutationResult = Apollo.MutationResult<ForgetPasswordMutation>;
export type ForgetPasswordMutationOptions = Apollo.BaseMutationOptions<ForgetPasswordMutation, ForgetPasswordMutationVariables>;
export const GetUserCommunityPostsDocument = gql`
    query GetUserCommunityPosts($input: GetUserCommunityPostsInput!) {
  getUserCommunityPosts(input: $input) {
    id
    isRepost
    repostComment
    originalPostId
    postType
    companyId
    contentTokens {
      type
      value
      handle
      userId
      url
    }
    translatedContentTokens {
      type
      value
      handle
      userId
      url
    }
    author {
      id
      firstName
      lastName
      title
      middleName
      profileImageUrl
      role
      headline
      isHiring
      openToWork
      isMentorVerified
      connection {
        status
        direction
      }
      actionButtons {
        id
        name
        url
        isShow
        createdAt
      }
      createdAt
      updatedAt
      companyName
    }
    originalPost {
      id
      contentTokens {
        type
        value
        handle
        userId
        url
      }
      translatedContentTokens {
        type
        value
        handle
        userId
        url
      }
      author {
        id
        firstName
        lastName
        title
        middleName
        profileImageUrl
        role
        headline
        isHiring
        openToWork
        isMentorVerified
        connection {
          status
          direction
        }
        actionButtons {
          id
          name
          url
          isShow
          createdAt
        }
        createdAt
        updatedAt
        companyName
      }
      mediaUrls
      reactions {
        reactionCounts {
          type
          count
        }
        totalReactions
        currentUserReaction
      }
      article {
        id
        title
        subtitle
        coverImageUrl
        slug
        readingTimeMinutes
        tags
        content
        status
        translatedTitle
        translatedSubtitle
        translatedExcerpt
      }
      companyAuthor {
        id
        name
        logoUrl
        industry
        tagline
        followersCount
        isFollowing
      }
      poll {
        question
        expiresAt
        options {
          id
          text
          votes
          isChosen
        }
        translatedQuestion
        translatedOptions
      }
      occasion {
        id
        postId
        title
        description
        imageUrl
        privacy
        translatedTitle
        translatedDescription
      }
      event {
        id
        name
        description
        imageUrl
        startTime
        endTime
        location
        category
        maxAttendees
        participantsCount
        isjoinedbyMe
        organizedby {
          userId
          name
          imageUrl
          companyName
        }
        course {
          id
          title
          thumbnailUrl
        }
      }
      case {
        id
        postId
        createdAt
        updatedAt
        media {
          id
          step
          type
          imageUrl
          text
          order
          createdAt
          translatedText
        }
      }
      commentsCount
      isSavedByMe
      isRepostedByMe
      isPublished
      createdAt
      updatedAt
    }
    mediaUrls
    reactions {
      reactionCounts {
        type
        count
      }
      totalReactions
      currentUserReaction
    }
    article {
      id
      title
      subtitle
      coverImageUrl
      slug
      readingTimeMinutes
      tags
      content
      status
      translatedTitle
      translatedSubtitle
      translatedExcerpt
    }
    companyAuthor {
      id
      name
      logoUrl
      industry
      tagline
      followersCount
      isFollowing
    }
    poll {
      question
      expiresAt
      options {
        id
        text
        votes
        isChosen
      }
      translatedQuestion
      translatedOptions
    }
    occasion {
      id
      postId
      title
      description
      imageUrl
      privacy
      translatedTitle
      translatedDescription
    }
    event {
      id
      name
      description
      imageUrl
      startTime
      endTime
      location
      category
      maxAttendees
      participantsCount
      isjoinedbyMe
      organizedby {
        userId
        name
        imageUrl
        companyName
      }
      course {
        id
        title
        thumbnailUrl
      }
    }
    case {
      id
      postId
      createdAt
      updatedAt
      media {
        id
        step
        type
        imageUrl
        text
        order
        createdAt
        translatedText
      }
    }
    commentsCount
    isSavedByMe
    isRepostedByMe
    isPublished
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetUserCommunityPostsQuery__
 *
 * To run a query within a React component, call `useGetUserCommunityPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCommunityPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCommunityPostsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserCommunityPostsQuery(baseOptions: Apollo.QueryHookOptions<GetUserCommunityPostsQuery, GetUserCommunityPostsQueryVariables> & ({ variables: GetUserCommunityPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCommunityPostsQuery, GetUserCommunityPostsQueryVariables>(GetUserCommunityPostsDocument, options);
      }
export function useGetUserCommunityPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCommunityPostsQuery, GetUserCommunityPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCommunityPostsQuery, GetUserCommunityPostsQueryVariables>(GetUserCommunityPostsDocument, options);
        }
// @ts-ignore
export function useGetUserCommunityPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserCommunityPostsQuery, GetUserCommunityPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserCommunityPostsQuery, GetUserCommunityPostsQueryVariables>;
export function useGetUserCommunityPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserCommunityPostsQuery, GetUserCommunityPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserCommunityPostsQuery | undefined, GetUserCommunityPostsQueryVariables>;
export function useGetUserCommunityPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserCommunityPostsQuery, GetUserCommunityPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserCommunityPostsQuery, GetUserCommunityPostsQueryVariables>(GetUserCommunityPostsDocument, options);
        }
export type GetUserCommunityPostsQueryHookResult = ReturnType<typeof useGetUserCommunityPostsQuery>;
export type GetUserCommunityPostsLazyQueryHookResult = ReturnType<typeof useGetUserCommunityPostsLazyQuery>;
export type GetUserCommunityPostsSuspenseQueryHookResult = ReturnType<typeof useGetUserCommunityPostsSuspenseQuery>;
export type GetUserCommunityPostsQueryResult = Apollo.QueryResult<GetUserCommunityPostsQuery, GetUserCommunityPostsQueryVariables>;
export const GetSavedRssFeedsDocument = gql`
    query GetSavedRssFeeds($input: GetSavedRssFeedsInput!) {
  getSavedRssFeeds(input: $input) {
    id
    guid
    title
    source
    link
    publishedAt
    summary
    imageUrl
    profile_image
  }
}
    `;

/**
 * __useGetSavedRssFeedsQuery__
 *
 * To run a query within a React component, call `useGetSavedRssFeedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedRssFeedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedRssFeedsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSavedRssFeedsQuery(baseOptions: Apollo.QueryHookOptions<GetSavedRssFeedsQuery, GetSavedRssFeedsQueryVariables> & ({ variables: GetSavedRssFeedsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavedRssFeedsQuery, GetSavedRssFeedsQueryVariables>(GetSavedRssFeedsDocument, options);
      }
export function useGetSavedRssFeedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavedRssFeedsQuery, GetSavedRssFeedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavedRssFeedsQuery, GetSavedRssFeedsQueryVariables>(GetSavedRssFeedsDocument, options);
        }
// @ts-ignore
export function useGetSavedRssFeedsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSavedRssFeedsQuery, GetSavedRssFeedsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSavedRssFeedsQuery, GetSavedRssFeedsQueryVariables>;
export function useGetSavedRssFeedsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavedRssFeedsQuery, GetSavedRssFeedsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSavedRssFeedsQuery | undefined, GetSavedRssFeedsQueryVariables>;
export function useGetSavedRssFeedsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavedRssFeedsQuery, GetSavedRssFeedsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSavedRssFeedsQuery, GetSavedRssFeedsQueryVariables>(GetSavedRssFeedsDocument, options);
        }
export type GetSavedRssFeedsQueryHookResult = ReturnType<typeof useGetSavedRssFeedsQuery>;
export type GetSavedRssFeedsLazyQueryHookResult = ReturnType<typeof useGetSavedRssFeedsLazyQuery>;
export type GetSavedRssFeedsSuspenseQueryHookResult = ReturnType<typeof useGetSavedRssFeedsSuspenseQuery>;
export type GetSavedRssFeedsQueryResult = Apollo.QueryResult<GetSavedRssFeedsQuery, GetSavedRssFeedsQueryVariables>;
export const GetTotalSavedRssFeedsDocument = gql`
    query GetTotalSavedRssFeeds {
  getTotalSavedRssFeeds
}
    `;

/**
 * __useGetTotalSavedRssFeedsQuery__
 *
 * To run a query within a React component, call `useGetTotalSavedRssFeedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalSavedRssFeedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalSavedRssFeedsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTotalSavedRssFeedsQuery(baseOptions?: Apollo.QueryHookOptions<GetTotalSavedRssFeedsQuery, GetTotalSavedRssFeedsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotalSavedRssFeedsQuery, GetTotalSavedRssFeedsQueryVariables>(GetTotalSavedRssFeedsDocument, options);
      }
export function useGetTotalSavedRssFeedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotalSavedRssFeedsQuery, GetTotalSavedRssFeedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotalSavedRssFeedsQuery, GetTotalSavedRssFeedsQueryVariables>(GetTotalSavedRssFeedsDocument, options);
        }
// @ts-ignore
export function useGetTotalSavedRssFeedsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTotalSavedRssFeedsQuery, GetTotalSavedRssFeedsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTotalSavedRssFeedsQuery, GetTotalSavedRssFeedsQueryVariables>;
export function useGetTotalSavedRssFeedsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotalSavedRssFeedsQuery, GetTotalSavedRssFeedsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTotalSavedRssFeedsQuery | undefined, GetTotalSavedRssFeedsQueryVariables>;
export function useGetTotalSavedRssFeedsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotalSavedRssFeedsQuery, GetTotalSavedRssFeedsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTotalSavedRssFeedsQuery, GetTotalSavedRssFeedsQueryVariables>(GetTotalSavedRssFeedsDocument, options);
        }
export type GetTotalSavedRssFeedsQueryHookResult = ReturnType<typeof useGetTotalSavedRssFeedsQuery>;
export type GetTotalSavedRssFeedsLazyQueryHookResult = ReturnType<typeof useGetTotalSavedRssFeedsLazyQuery>;
export type GetTotalSavedRssFeedsSuspenseQueryHookResult = ReturnType<typeof useGetTotalSavedRssFeedsSuspenseQuery>;
export type GetTotalSavedRssFeedsQueryResult = Apollo.QueryResult<GetTotalSavedRssFeedsQuery, GetTotalSavedRssFeedsQueryVariables>;
export const GetCommentRepliesDocument = gql`
    query GetCommentReplies($input: GetCommentRepliesInput!) {
  getCommentReplies(input: $input) {
    id
    content
    translatedContent
    mediaUrls
    createdAt
    updatedAt
    repliesCount
    reactions {
      reactionCounts {
        type
        count
      }
      totalReactions
      currentUserReaction
    }
    user {
      id
      firstName
      lastName
      middleName
      title
      profileImageUrl
      role
      influenceBadge {
        ...InfluenceBadgeFields
      }
      companyName
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetCommentRepliesQuery__
 *
 * To run a query within a React component, call `useGetCommentRepliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentRepliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentRepliesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCommentRepliesQuery(baseOptions: Apollo.QueryHookOptions<GetCommentRepliesQuery, GetCommentRepliesQueryVariables> & ({ variables: GetCommentRepliesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentRepliesQuery, GetCommentRepliesQueryVariables>(GetCommentRepliesDocument, options);
      }
export function useGetCommentRepliesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentRepliesQuery, GetCommentRepliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentRepliesQuery, GetCommentRepliesQueryVariables>(GetCommentRepliesDocument, options);
        }
// @ts-ignore
export function useGetCommentRepliesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommentRepliesQuery, GetCommentRepliesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommentRepliesQuery, GetCommentRepliesQueryVariables>;
export function useGetCommentRepliesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommentRepliesQuery, GetCommentRepliesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommentRepliesQuery | undefined, GetCommentRepliesQueryVariables>;
export function useGetCommentRepliesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommentRepliesQuery, GetCommentRepliesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommentRepliesQuery, GetCommentRepliesQueryVariables>(GetCommentRepliesDocument, options);
        }
export type GetCommentRepliesQueryHookResult = ReturnType<typeof useGetCommentRepliesQuery>;
export type GetCommentRepliesLazyQueryHookResult = ReturnType<typeof useGetCommentRepliesLazyQuery>;
export type GetCommentRepliesSuspenseQueryHookResult = ReturnType<typeof useGetCommentRepliesSuspenseQuery>;
export type GetCommentRepliesQueryResult = Apollo.QueryResult<GetCommentRepliesQuery, GetCommentRepliesQueryVariables>;
export const GetCompanyInboxDocument = gql`
    query GetCompanyInbox($companyId: String!, $page: Int, $limit: Int, $status: String, $searchQuery: String) {
  getCompanyInbox(
    input: {companyId: $companyId, page: $page, limit: $limit, status: $status, searchQuery: $searchQuery}
  ) {
    messages {
      id
      conversationId
      senderId
      senderName
      senderAvatar
      subject
      content
      status
      createdAt
      hasReplies
      repliesCount
      replies {
        id
        content
        createdAt
        senderId
        isAuthor
      }
      allMessages {
        id
        content
        createdAt
        senderId
        isAuthor
      }
      unreadCount
      totalMessages
      lastMessageAt
    }
    totalCount
    unreadCount
    page
    limit
    totalPages
  }
}
    `;

/**
 * __useGetCompanyInboxQuery__
 *
 * To run a query within a React component, call `useGetCompanyInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyInboxQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      status: // value for 'status'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetCompanyInboxQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyInboxQuery, GetCompanyInboxQueryVariables> & ({ variables: GetCompanyInboxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyInboxQuery, GetCompanyInboxQueryVariables>(GetCompanyInboxDocument, options);
      }
export function useGetCompanyInboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyInboxQuery, GetCompanyInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyInboxQuery, GetCompanyInboxQueryVariables>(GetCompanyInboxDocument, options);
        }
// @ts-ignore
export function useGetCompanyInboxSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyInboxQuery, GetCompanyInboxQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyInboxQuery, GetCompanyInboxQueryVariables>;
export function useGetCompanyInboxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyInboxQuery, GetCompanyInboxQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyInboxQuery | undefined, GetCompanyInboxQueryVariables>;
export function useGetCompanyInboxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyInboxQuery, GetCompanyInboxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyInboxQuery, GetCompanyInboxQueryVariables>(GetCompanyInboxDocument, options);
        }
export type GetCompanyInboxQueryHookResult = ReturnType<typeof useGetCompanyInboxQuery>;
export type GetCompanyInboxLazyQueryHookResult = ReturnType<typeof useGetCompanyInboxLazyQuery>;
export type GetCompanyInboxSuspenseQueryHookResult = ReturnType<typeof useGetCompanyInboxSuspenseQuery>;
export type GetCompanyInboxQueryResult = Apollo.QueryResult<GetCompanyInboxQuery, GetCompanyInboxQueryVariables>;
export const MarkCompanyMessageAsReadDocument = gql`
    mutation MarkCompanyMessageAsRead($messageId: String!, $companyId: String!) {
  markCompanyMessageAsRead(messageId: $messageId, companyId: $companyId)
}
    `;
export type MarkCompanyMessageAsReadMutationFn = Apollo.MutationFunction<MarkCompanyMessageAsReadMutation, MarkCompanyMessageAsReadMutationVariables>;

/**
 * __useMarkCompanyMessageAsReadMutation__
 *
 * To run a mutation, you first call `useMarkCompanyMessageAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCompanyMessageAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCompanyMessageAsReadMutation, { data, loading, error }] = useMarkCompanyMessageAsReadMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useMarkCompanyMessageAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkCompanyMessageAsReadMutation, MarkCompanyMessageAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkCompanyMessageAsReadMutation, MarkCompanyMessageAsReadMutationVariables>(MarkCompanyMessageAsReadDocument, options);
      }
export type MarkCompanyMessageAsReadMutationHookResult = ReturnType<typeof useMarkCompanyMessageAsReadMutation>;
export type MarkCompanyMessageAsReadMutationResult = Apollo.MutationResult<MarkCompanyMessageAsReadMutation>;
export type MarkCompanyMessageAsReadMutationOptions = Apollo.BaseMutationOptions<MarkCompanyMessageAsReadMutation, MarkCompanyMessageAsReadMutationVariables>;
export const GetConversationMessagesDocument = gql`
    query GetConversationMessages($input: GetConversationMessagesInput!) {
  getConversationMessages(input: $input) {
    id
    createdAt
    updatedAt
    lastMessage
    lastMessageAt
    type
    companyId
    company {
      id
      name
      logoUrl
      ownerId
    }
    user {
      id
      name
      profileImageUrl
      role
      companyName
    }
    messages {
      id
      createdAt
      updatedAt
      conversationId
      senderId
      receiverId
      content
      read
      status
      isAuthor
    }
  }
}
    `;

/**
 * __useGetConversationMessagesQuery__
 *
 * To run a query within a React component, call `useGetConversationMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationMessagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetConversationMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables> & ({ variables: GetConversationMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>(GetConversationMessagesDocument, options);
      }
export function useGetConversationMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>(GetConversationMessagesDocument, options);
        }
// @ts-ignore
export function useGetConversationMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>;
export function useGetConversationMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversationMessagesQuery | undefined, GetConversationMessagesQueryVariables>;
export function useGetConversationMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>(GetConversationMessagesDocument, options);
        }
export type GetConversationMessagesQueryHookResult = ReturnType<typeof useGetConversationMessagesQuery>;
export type GetConversationMessagesLazyQueryHookResult = ReturnType<typeof useGetConversationMessagesLazyQuery>;
export type GetConversationMessagesSuspenseQueryHookResult = ReturnType<typeof useGetConversationMessagesSuspenseQuery>;
export type GetConversationMessagesQueryResult = Apollo.QueryResult<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>;
export const GetUserConversationsDocument = gql`
    query GetUserConversations($input: PaginationInput!) {
  getUserConversations(input: $input) {
    id
    lastMessage
    lastMessageAt
    unreadCount
    type
    companyId
    company {
      id
      name
      logoUrl
      ownerId
    }
    user {
      id
      name
      profileImageUrl
      role
      companyName
    }
  }
}
    `;

/**
 * __useGetUserConversationsQuery__
 *
 * To run a query within a React component, call `useGetUserConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserConversationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserConversationsQuery(baseOptions: Apollo.QueryHookOptions<GetUserConversationsQuery, GetUserConversationsQueryVariables> & ({ variables: GetUserConversationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserConversationsQuery, GetUserConversationsQueryVariables>(GetUserConversationsDocument, options);
      }
export function useGetUserConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserConversationsQuery, GetUserConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserConversationsQuery, GetUserConversationsQueryVariables>(GetUserConversationsDocument, options);
        }
// @ts-ignore
export function useGetUserConversationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserConversationsQuery, GetUserConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserConversationsQuery, GetUserConversationsQueryVariables>;
export function useGetUserConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserConversationsQuery, GetUserConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserConversationsQuery | undefined, GetUserConversationsQueryVariables>;
export function useGetUserConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserConversationsQuery, GetUserConversationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserConversationsQuery, GetUserConversationsQueryVariables>(GetUserConversationsDocument, options);
        }
export type GetUserConversationsQueryHookResult = ReturnType<typeof useGetUserConversationsQuery>;
export type GetUserConversationsLazyQueryHookResult = ReturnType<typeof useGetUserConversationsLazyQuery>;
export type GetUserConversationsSuspenseQueryHookResult = ReturnType<typeof useGetUserConversationsSuspenseQuery>;
export type GetUserConversationsQueryResult = Apollo.QueryResult<GetUserConversationsQuery, GetUserConversationsQueryVariables>;
export const MentorAvailabilitiesDocument = gql`
    query MentorAvailabilities($input: GetMentorAvailabilityInput!) {
  mentorAvailabilities(input: $input) {
    availabilities {
      id
      day
      timeSlots {
        start
        end
      }
      isRecurring
      timezone
      price
      currency
      createdAt
    }
    dayOffDates
  }
}
    `;

/**
 * __useMentorAvailabilitiesQuery__
 *
 * To run a query within a React component, call `useMentorAvailabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentorAvailabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentorAvailabilitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMentorAvailabilitiesQuery(baseOptions: Apollo.QueryHookOptions<MentorAvailabilitiesQuery, MentorAvailabilitiesQueryVariables> & ({ variables: MentorAvailabilitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MentorAvailabilitiesQuery, MentorAvailabilitiesQueryVariables>(MentorAvailabilitiesDocument, options);
      }
export function useMentorAvailabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MentorAvailabilitiesQuery, MentorAvailabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MentorAvailabilitiesQuery, MentorAvailabilitiesQueryVariables>(MentorAvailabilitiesDocument, options);
        }
// @ts-ignore
export function useMentorAvailabilitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MentorAvailabilitiesQuery, MentorAvailabilitiesQueryVariables>): Apollo.UseSuspenseQueryResult<MentorAvailabilitiesQuery, MentorAvailabilitiesQueryVariables>;
export function useMentorAvailabilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MentorAvailabilitiesQuery, MentorAvailabilitiesQueryVariables>): Apollo.UseSuspenseQueryResult<MentorAvailabilitiesQuery | undefined, MentorAvailabilitiesQueryVariables>;
export function useMentorAvailabilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MentorAvailabilitiesQuery, MentorAvailabilitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MentorAvailabilitiesQuery, MentorAvailabilitiesQueryVariables>(MentorAvailabilitiesDocument, options);
        }
export type MentorAvailabilitiesQueryHookResult = ReturnType<typeof useMentorAvailabilitiesQuery>;
export type MentorAvailabilitiesLazyQueryHookResult = ReturnType<typeof useMentorAvailabilitiesLazyQuery>;
export type MentorAvailabilitiesSuspenseQueryHookResult = ReturnType<typeof useMentorAvailabilitiesSuspenseQuery>;
export type MentorAvailabilitiesQueryResult = Apollo.QueryResult<MentorAvailabilitiesQuery, MentorAvailabilitiesQueryVariables>;
export const GetMentorAvailableSlotsDocument = gql`
    query GetMentorAvailableSlots($input: GetMentorDayAvailableSlotsInput!) {
  getMentorAvailableSlots(input: $input) {
    start
    end
  }
}
    `;

/**
 * __useGetMentorAvailableSlotsQuery__
 *
 * To run a query within a React component, call `useGetMentorAvailableSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentorAvailableSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentorAvailableSlotsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMentorAvailableSlotsQuery(baseOptions: Apollo.QueryHookOptions<GetMentorAvailableSlotsQuery, GetMentorAvailableSlotsQueryVariables> & ({ variables: GetMentorAvailableSlotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMentorAvailableSlotsQuery, GetMentorAvailableSlotsQueryVariables>(GetMentorAvailableSlotsDocument, options);
      }
export function useGetMentorAvailableSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMentorAvailableSlotsQuery, GetMentorAvailableSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMentorAvailableSlotsQuery, GetMentorAvailableSlotsQueryVariables>(GetMentorAvailableSlotsDocument, options);
        }
// @ts-ignore
export function useGetMentorAvailableSlotsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMentorAvailableSlotsQuery, GetMentorAvailableSlotsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMentorAvailableSlotsQuery, GetMentorAvailableSlotsQueryVariables>;
export function useGetMentorAvailableSlotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMentorAvailableSlotsQuery, GetMentorAvailableSlotsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMentorAvailableSlotsQuery | undefined, GetMentorAvailableSlotsQueryVariables>;
export function useGetMentorAvailableSlotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMentorAvailableSlotsQuery, GetMentorAvailableSlotsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMentorAvailableSlotsQuery, GetMentorAvailableSlotsQueryVariables>(GetMentorAvailableSlotsDocument, options);
        }
export type GetMentorAvailableSlotsQueryHookResult = ReturnType<typeof useGetMentorAvailableSlotsQuery>;
export type GetMentorAvailableSlotsLazyQueryHookResult = ReturnType<typeof useGetMentorAvailableSlotsLazyQuery>;
export type GetMentorAvailableSlotsSuspenseQueryHookResult = ReturnType<typeof useGetMentorAvailableSlotsSuspenseQuery>;
export type GetMentorAvailableSlotsQueryResult = Apollo.QueryResult<GetMentorAvailableSlotsQuery, GetMentorAvailableSlotsQueryVariables>;
export const GetMentorViewerAvailabilityCalendarDocument = gql`
    query GetMentorViewerAvailabilityCalendar($input: GetMentorViewerAvailabilityCalendarInput!) {
  getMentorViewerAvailabilityCalendar(input: $input) {
    availableDays
    dayOffDates
  }
}
    `;

/**
 * __useGetMentorViewerAvailabilityCalendarQuery__
 *
 * To run a query within a React component, call `useGetMentorViewerAvailabilityCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentorViewerAvailabilityCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentorViewerAvailabilityCalendarQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMentorViewerAvailabilityCalendarQuery(baseOptions: Apollo.QueryHookOptions<GetMentorViewerAvailabilityCalendarQuery, GetMentorViewerAvailabilityCalendarQueryVariables> & ({ variables: GetMentorViewerAvailabilityCalendarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMentorViewerAvailabilityCalendarQuery, GetMentorViewerAvailabilityCalendarQueryVariables>(GetMentorViewerAvailabilityCalendarDocument, options);
      }
export function useGetMentorViewerAvailabilityCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMentorViewerAvailabilityCalendarQuery, GetMentorViewerAvailabilityCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMentorViewerAvailabilityCalendarQuery, GetMentorViewerAvailabilityCalendarQueryVariables>(GetMentorViewerAvailabilityCalendarDocument, options);
        }
// @ts-ignore
export function useGetMentorViewerAvailabilityCalendarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMentorViewerAvailabilityCalendarQuery, GetMentorViewerAvailabilityCalendarQueryVariables>): Apollo.UseSuspenseQueryResult<GetMentorViewerAvailabilityCalendarQuery, GetMentorViewerAvailabilityCalendarQueryVariables>;
export function useGetMentorViewerAvailabilityCalendarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMentorViewerAvailabilityCalendarQuery, GetMentorViewerAvailabilityCalendarQueryVariables>): Apollo.UseSuspenseQueryResult<GetMentorViewerAvailabilityCalendarQuery | undefined, GetMentorViewerAvailabilityCalendarQueryVariables>;
export function useGetMentorViewerAvailabilityCalendarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMentorViewerAvailabilityCalendarQuery, GetMentorViewerAvailabilityCalendarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMentorViewerAvailabilityCalendarQuery, GetMentorViewerAvailabilityCalendarQueryVariables>(GetMentorViewerAvailabilityCalendarDocument, options);
        }
export type GetMentorViewerAvailabilityCalendarQueryHookResult = ReturnType<typeof useGetMentorViewerAvailabilityCalendarQuery>;
export type GetMentorViewerAvailabilityCalendarLazyQueryHookResult = ReturnType<typeof useGetMentorViewerAvailabilityCalendarLazyQuery>;
export type GetMentorViewerAvailabilityCalendarSuspenseQueryHookResult = ReturnType<typeof useGetMentorViewerAvailabilityCalendarSuspenseQuery>;
export type GetMentorViewerAvailabilityCalendarQueryResult = Apollo.QueryResult<GetMentorViewerAvailabilityCalendarQuery, GetMentorViewerAvailabilityCalendarQueryVariables>;
export const GetUserNotificationDocument = gql`
    query GetUserNotification($page: Int, $pageSize: Int, $notificationTypes: [NotificationType!]) {
  getUserNotification(
    page: $page
    pageSize: $pageSize
    notificationTypes: $notificationTypes
  ) {
    id
    createdAt
    type
    message
    isRead
    status
    companyId
    companyName
    companyLogoUrl
    conversationId
    supportTicketId
    campaignId
    redirectTarget
    actor {
      id
      firstName
      lastName
      title
      profileImageUrl
      companyName
    }
    postId
    sessionId
    session {
      id
      subject
      startTime
      endTime
      status
    }
    group {
      id
    }
  }
}
    `;

/**
 * __useGetUserNotificationQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      notificationTypes: // value for 'notificationTypes'
 *   },
 * });
 */
export function useGetUserNotificationQuery(baseOptions?: Apollo.QueryHookOptions<GetUserNotificationQuery, GetUserNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserNotificationQuery, GetUserNotificationQueryVariables>(GetUserNotificationDocument, options);
      }
export function useGetUserNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserNotificationQuery, GetUserNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserNotificationQuery, GetUserNotificationQueryVariables>(GetUserNotificationDocument, options);
        }
// @ts-ignore
export function useGetUserNotificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserNotificationQuery, GetUserNotificationQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserNotificationQuery, GetUserNotificationQueryVariables>;
export function useGetUserNotificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserNotificationQuery, GetUserNotificationQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserNotificationQuery | undefined, GetUserNotificationQueryVariables>;
export function useGetUserNotificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserNotificationQuery, GetUserNotificationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserNotificationQuery, GetUserNotificationQueryVariables>(GetUserNotificationDocument, options);
        }
export type GetUserNotificationQueryHookResult = ReturnType<typeof useGetUserNotificationQuery>;
export type GetUserNotificationLazyQueryHookResult = ReturnType<typeof useGetUserNotificationLazyQuery>;
export type GetUserNotificationSuspenseQueryHookResult = ReturnType<typeof useGetUserNotificationSuspenseQuery>;
export type GetUserNotificationQueryResult = Apollo.QueryResult<GetUserNotificationQuery, GetUserNotificationQueryVariables>;
export const GetPostDocument = gql`
    query GetPost($input: GetPostInput!) {
  getPost(input: $input) {
    id
    isRepost
    repostComment
    originalPostId
    postType
    companyId
    contentTokens {
      type
      value
      handle
      userId
      url
    }
    translatedContentTokens {
      type
      value
      handle
      userId
      url
    }
    author {
      id
      firstName
      lastName
      middleName
      title
      profileImageUrl
      role
      headline
      isHiring
      openToWork
      connection {
        status
        direction
      }
      isMentorVerified
      influenceBadge {
        ...InfluenceBadgeFields
      }
      actionButtons {
        id
        name
        url
        isShow
        createdAt
      }
      createdAt
      updatedAt
      companyName
    }
    companyAuthor {
      id
      name
      logoUrl
      industry
      tagline
      followersCount
      isFollowing
    }
    originalPost {
      id
      contentTokens {
        type
        value
        handle
        userId
        url
      }
      translatedContentTokens {
        type
        value
        handle
        userId
        url
      }
      createdAt
      mediaUrls
      isBoosted
      activeBoostId
      author {
        id
        firstName
        lastName
        middleName
        title
        profileImageUrl
        role
        headline
        isHiring
        openToWork
        connection {
          status
          direction
        }
        isMentorVerified
        influenceBadge {
          ...InfluenceBadgeFields
        }
        actionButtons {
          id
          name
          url
          isShow
          createdAt
        }
        createdAt
        updatedAt
        companyName
      }
      poll {
        question
        expiresAt
        options {
          id
          text
          votes
          isChosen
        }
        translatedQuestion
        translatedOptions
      }
      occasion {
        id
        postId
        title
        description
        imageUrl
        privacy
        translatedTitle
        translatedDescription
      }
      event {
        id
        name
        description
        imageUrl
        startTime
        endTime
        location
        category
        maxAttendees
        participantsCount
        organizedby {
          userId
          name
          imageUrl
          companyName
        }
        course {
          id
          title
          thumbnailUrl
        }
        isjoinedbyMe
      }
      case {
        id
        postId
        createdAt
        updatedAt
        media {
          id
          step
          type
          imageUrl
          text
          order
          createdAt
          translatedText
        }
      }
      article {
        id
        title
        subtitle
        coverImageUrl
        slug
        readingTimeMinutes
        status
        content
        tags
        translatedTitle
        translatedSubtitle
        translatedExcerpt
      }
      companyAuthor {
        id
        name
        logoUrl
        industry
        tagline
        followersCount
        isFollowing
      }
      reactions {
        reactionCounts {
          type
          count
        }
        totalReactions
        currentUserReaction
      }
      commentsCount
      isSavedByMe
      isRepostedByMe
      isPublished
      createdAt
      updatedAt
    }
    mediaUrls
    reactions {
      reactionCounts {
        type
        count
      }
      totalReactions
      currentUserReaction
    }
    article {
      id
      title
      subtitle
      coverImageUrl
      slug
      readingTimeMinutes
      status
      content
      tags
      translatedTitle
      translatedSubtitle
      translatedExcerpt
    }
    poll {
      question
      expiresAt
      options {
        id
        text
        votes
        isChosen
      }
      translatedQuestion
      translatedOptions
    }
    occasion {
      id
      postId
      title
      description
      imageUrl
      privacy
      translatedTitle
      translatedDescription
    }
    event {
      id
      name
      description
      imageUrl
      startTime
      endTime
      location
      category
      maxAttendees
      participantsCount
      organizedby {
        userId
        name
        imageUrl
        companyName
      }
      course {
        id
        title
        thumbnailUrl
      }
      isjoinedbyMe
    }
    case {
      id
      postId
      createdAt
      updatedAt
      media {
        id
        step
        type
        imageUrl
        text
        order
        createdAt
        translatedText
      }
    }
    commentsCount
    isSavedByMe
    isRepostedByMe
    isPublished
    isBoosted
    activeBoostId
    createdAt
    updatedAt
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetPostQuery__
 *
 * To run a query within a React component, call `useGetPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPostQuery(baseOptions: Apollo.QueryHookOptions<GetPostQuery, GetPostQueryVariables> & ({ variables: GetPostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostQuery, GetPostQueryVariables>(GetPostDocument, options);
      }
export function useGetPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostQuery, GetPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostQuery, GetPostQueryVariables>(GetPostDocument, options);
        }
// @ts-ignore
export function useGetPostSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPostQuery, GetPostQueryVariables>): Apollo.UseSuspenseQueryResult<GetPostQuery, GetPostQueryVariables>;
export function useGetPostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPostQuery, GetPostQueryVariables>): Apollo.UseSuspenseQueryResult<GetPostQuery | undefined, GetPostQueryVariables>;
export function useGetPostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPostQuery, GetPostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPostQuery, GetPostQueryVariables>(GetPostDocument, options);
        }
export type GetPostQueryHookResult = ReturnType<typeof useGetPostQuery>;
export type GetPostLazyQueryHookResult = ReturnType<typeof useGetPostLazyQuery>;
export type GetPostSuspenseQueryHookResult = ReturnType<typeof useGetPostSuspenseQuery>;
export type GetPostQueryResult = Apollo.QueryResult<GetPostQuery, GetPostQueryVariables>;
export const GetProfileDocument = gql`
    query GetProfile($input: GetProfileInput!) {
  getProfile(input: $input) {
    editable
    influence {
      ...InfluenceProfileFields
      hideFromLeaderboards
    }
    headline {
      name
      title
      profileImageUrl
      role
      expertise
      state
      bannerImageUrl
      openToWork
      isHiring
      headline
      isMentorVerified
      isBoosted
      boostEndsAt
      organizationName
      profileVisitsCount
      consultationsCount
      experienceYearsCount
      rate
      mentorshipPrice
      companyName
    }
    overview {
      about
      recentPosts {
        id
        createdAt
        updatedAt
        postType
        companyId
        contentTokens {
          type
          value
          handle
          userId
          url
        }
        translatedContentTokens {
          type
          value
          handle
          userId
          url
        }
        isPublished
        reactions {
          reactionCounts {
            type
            count
          }
          totalReactions
          currentUserReaction
        }
        commentsCount
        mediaUrls
        isRepost
        repostComment
        originalPostId
        isBoosted
        activeBoostId
        article {
          id
          title
          subtitle
          coverImageUrl
          slug
          readingTimeMinutes
          tags
          content
          status
          translatedTitle
          translatedSubtitle
          translatedExcerpt
        }
        companyAuthor {
          id
          name
          logoUrl
          industry
          tagline
          followersCount
          isFollowing
        }
        poll {
          question
          expiresAt
          options {
            id
            text
            votes
            isChosen
          }
          translatedQuestion
          translatedOptions
        }
        occasion {
          id
          postId
          title
          description
          imageUrl
          privacy
          translatedTitle
          translatedDescription
        }
        event {
          id
          name
          description
          imageUrl
          startTime
          endTime
          location
          category
          maxAttendees
          participantsCount
          isjoinedbyMe
          organizedby {
            userId
            name
            imageUrl
            companyName
          }
          course {
            id
            title
            thumbnailUrl
          }
        }
        case {
          id
          postId
          createdAt
          updatedAt
          media {
            id
            step
            type
            imageUrl
            text
            order
            createdAt
            translatedText
          }
        }
        author {
          id
          role
          firstName
          lastName
          title
          profileImageUrl
          headline
          isHiring
          openToWork
          isMentorVerified
          influenceBadge {
            ...InfluenceBadgeFields
          }
          connection {
            status
            direction
          }
          actionButtons {
            id
            name
            url
            isShow
            createdAt
          }
          companyName
        }
        originalPost {
          id
          contentTokens {
            type
            value
            handle
            userId
            url
          }
          translatedContentTokens {
            type
            value
            handle
            userId
            url
          }
          author {
            id
            role
            firstName
            lastName
            title
            profileImageUrl
            headline
            isHiring
            openToWork
            isMentorVerified
            influenceBadge {
              ...InfluenceBadgeFields
            }
            connection {
              status
              direction
            }
            actionButtons {
              id
              name
              url
              isShow
              createdAt
            }
            companyName
          }
          mediaUrls
          reactions {
            reactionCounts {
              type
              count
            }
            totalReactions
            currentUserReaction
          }
          article {
            id
            title
            subtitle
            coverImageUrl
            slug
            readingTimeMinutes
            tags
            content
            status
            translatedTitle
            translatedSubtitle
            translatedExcerpt
          }
          companyAuthor {
            id
            name
            logoUrl
            industry
            tagline
            followersCount
            isFollowing
          }
          poll {
            question
            expiresAt
            options {
              id
              text
              votes
              isChosen
            }
            translatedQuestion
            translatedOptions
          }
          occasion {
            id
            postId
            title
            description
            imageUrl
            privacy
            translatedTitle
            translatedDescription
          }
          event {
            id
            name
            description
            imageUrl
            startTime
            endTime
            location
            category
            maxAttendees
            participantsCount
            isjoinedbyMe
            organizedby {
              userId
              name
              imageUrl
              companyName
            }
            course {
              id
              title
              thumbnailUrl
            }
          }
          case {
            id
            postId
            createdAt
            updatedAt
            media {
              id
              step
              type
              imageUrl
              text
              order
              createdAt
              translatedText
            }
          }
          commentsCount
          isPublished
          isBoosted
          activeBoostId
          createdAt
          updatedAt
        }
      }
      experiences {
        id
        position
        company
        location
        startDate
        endDate
        isCurrent
      }
      contacts {
        id
        platform
        url
        showOnProfile
      }
      educations {
        id
        fieldOfStudy
        institution
        degree
        startYear
        startMonth
        startDay
        endYear
        endMonth
        endDay
      }
      basicAccount {
        firstName
        lastName
        middleName
        title
        phone
        email
        expertise
        suffix
        country
        city
        state
        gender
        organizationName
        position
        Sociallink
        businessType
        valueToCommunity
        reasonForJoining
        companyLogo
      }
      licenses {
        id
        title
        organization
        licenseID
        licenseURL
        issueDate
        expiryDate
        url
      }
      skills {
        id
        name
        title
      }
    }
  }
}
    ${InfluenceProfileFieldsFragmentDoc}
${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProfileQuery(baseOptions: Apollo.QueryHookOptions<GetProfileQuery, GetProfileQueryVariables> & ({ variables: GetProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
      }
export function useGetProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
        }
// @ts-ignore
export function useGetProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GetProfileQuery, GetProfileQueryVariables>;
export function useGetProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GetProfileQuery | undefined, GetProfileQueryVariables>;
export function useGetProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
        }
export type GetProfileQueryHookResult = ReturnType<typeof useGetProfileQuery>;
export type GetProfileLazyQueryHookResult = ReturnType<typeof useGetProfileLazyQuery>;
export type GetProfileSuspenseQueryHookResult = ReturnType<typeof useGetProfileSuspenseQuery>;
export type GetProfileQueryResult = Apollo.QueryResult<GetProfileQuery, GetProfileQueryVariables>;
export const GetRoleChangeRequestStatusDocument = gql`
    query GetRoleChangeRequestStatus {
  roleChangeRequestStatus
}
    `;

/**
 * __useGetRoleChangeRequestStatusQuery__
 *
 * To run a query within a React component, call `useGetRoleChangeRequestStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleChangeRequestStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleChangeRequestStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRoleChangeRequestStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetRoleChangeRequestStatusQuery, GetRoleChangeRequestStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleChangeRequestStatusQuery, GetRoleChangeRequestStatusQueryVariables>(GetRoleChangeRequestStatusDocument, options);
      }
export function useGetRoleChangeRequestStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleChangeRequestStatusQuery, GetRoleChangeRequestStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleChangeRequestStatusQuery, GetRoleChangeRequestStatusQueryVariables>(GetRoleChangeRequestStatusDocument, options);
        }
// @ts-ignore
export function useGetRoleChangeRequestStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoleChangeRequestStatusQuery, GetRoleChangeRequestStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetRoleChangeRequestStatusQuery, GetRoleChangeRequestStatusQueryVariables>;
export function useGetRoleChangeRequestStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoleChangeRequestStatusQuery, GetRoleChangeRequestStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetRoleChangeRequestStatusQuery | undefined, GetRoleChangeRequestStatusQueryVariables>;
export function useGetRoleChangeRequestStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoleChangeRequestStatusQuery, GetRoleChangeRequestStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoleChangeRequestStatusQuery, GetRoleChangeRequestStatusQueryVariables>(GetRoleChangeRequestStatusDocument, options);
        }
export type GetRoleChangeRequestStatusQueryHookResult = ReturnType<typeof useGetRoleChangeRequestStatusQuery>;
export type GetRoleChangeRequestStatusLazyQueryHookResult = ReturnType<typeof useGetRoleChangeRequestStatusLazyQuery>;
export type GetRoleChangeRequestStatusSuspenseQueryHookResult = ReturnType<typeof useGetRoleChangeRequestStatusSuspenseQuery>;
export type GetRoleChangeRequestStatusQueryResult = Apollo.QueryResult<GetRoleChangeRequestStatusQuery, GetRoleChangeRequestStatusQueryVariables>;
export const GetScheduledPostsDocument = gql`
    query GetScheduledPosts($page: Int = 1, $limit: Int = 10) {
  getScheduledPosts(page: $page, limit: $limit) {
    id
    contentTokens {
      type
      value
      userId
      url
    }
    mediaUrls
    postType
    createdAt
    updatedAt
    isScheduled
    scheduledAt
    poll {
      question
      expiresAt
      options {
        id
        text
      }
    }
    occasion {
      id
      title
      description
      imageUrl
      privacy
    }
    case {
      id
      media {
        id
        step
        type
        imageUrl
        text
        order
      }
    }
    event {
      id
      name
      description
      imageUrl
      startTime
      endTime
      location
      category
      participantsCount
      organizedby {
        name
      }
    }
    author {
      id
      firstName
      lastName
      title
      middleName
      profileImageUrl
      role
      companyName
    }
    company {
      id
      name
    }
  }
}
    `;

/**
 * __useGetScheduledPostsQuery__
 *
 * To run a query within a React component, call `useGetScheduledPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledPostsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetScheduledPostsQuery(baseOptions?: Apollo.QueryHookOptions<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>(GetScheduledPostsDocument, options);
      }
export function useGetScheduledPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>(GetScheduledPostsDocument, options);
        }
// @ts-ignore
export function useGetScheduledPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>;
export function useGetScheduledPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetScheduledPostsQuery | undefined, GetScheduledPostsQueryVariables>;
export function useGetScheduledPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>(GetScheduledPostsDocument, options);
        }
export type GetScheduledPostsQueryHookResult = ReturnType<typeof useGetScheduledPostsQuery>;
export type GetScheduledPostsLazyQueryHookResult = ReturnType<typeof useGetScheduledPostsLazyQuery>;
export type GetScheduledPostsSuspenseQueryHookResult = ReturnType<typeof useGetScheduledPostsSuspenseQuery>;
export type GetScheduledPostsQueryResult = Apollo.QueryResult<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>;
export const AllSessionsDocument = gql`
    query AllSessions {
  allSessions {
    id
    status
    closedReason
    refundRequestStatus
    refundRequestedAt
    refundRequestReason
    subject
    description
    date
    startTime
    endTime
    timezone
    bookedTimezone
    duration
    mentor {
      id
      firstName
      lastName
      title
      profileImageUrl
      influenceBadge {
        ...InfluenceBadgeFields
      }
      companyName
    }
    student {
      id
      firstName
      lastName
      title
      profileImageUrl
      influenceBadge {
        ...InfluenceBadgeFields
      }
      companyName
    }
    zoomJoinUrl
    zoomStartUrl
    zoomMeetingId
    zoomPasscode
    price
    currency
    invoice {
      id
      invoiceNumber
      status
      total
      currency
      paidAt
      receiptUrl
      invoicePdf
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useAllSessionsQuery__
 *
 * To run a query within a React component, call `useAllSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSessionsQuery(baseOptions?: Apollo.QueryHookOptions<AllSessionsQuery, AllSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSessionsQuery, AllSessionsQueryVariables>(AllSessionsDocument, options);
      }
export function useAllSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSessionsQuery, AllSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSessionsQuery, AllSessionsQueryVariables>(AllSessionsDocument, options);
        }
// @ts-ignore
export function useAllSessionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllSessionsQuery, AllSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<AllSessionsQuery, AllSessionsQueryVariables>;
export function useAllSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllSessionsQuery, AllSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<AllSessionsQuery | undefined, AllSessionsQueryVariables>;
export function useAllSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllSessionsQuery, AllSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllSessionsQuery, AllSessionsQueryVariables>(AllSessionsDocument, options);
        }
export type AllSessionsQueryHookResult = ReturnType<typeof useAllSessionsQuery>;
export type AllSessionsLazyQueryHookResult = ReturnType<typeof useAllSessionsLazyQuery>;
export type AllSessionsSuspenseQueryHookResult = ReturnType<typeof useAllSessionsSuspenseQuery>;
export type AllSessionsQueryResult = Apollo.QueryResult<AllSessionsQuery, AllSessionsQueryVariables>;
export const UserConfirmedOrCompletedSessionCountDocument = gql`
    query UserConfirmedOrCompletedSessionCount($input: UserSessionCountInput!) {
  userConfirmedOrCompletedSessionCount(input: $input)
}
    `;

/**
 * __useUserConfirmedOrCompletedSessionCountQuery__
 *
 * To run a query within a React component, call `useUserConfirmedOrCompletedSessionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserConfirmedOrCompletedSessionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserConfirmedOrCompletedSessionCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserConfirmedOrCompletedSessionCountQuery(baseOptions: Apollo.QueryHookOptions<UserConfirmedOrCompletedSessionCountQuery, UserConfirmedOrCompletedSessionCountQueryVariables> & ({ variables: UserConfirmedOrCompletedSessionCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserConfirmedOrCompletedSessionCountQuery, UserConfirmedOrCompletedSessionCountQueryVariables>(UserConfirmedOrCompletedSessionCountDocument, options);
      }
export function useUserConfirmedOrCompletedSessionCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserConfirmedOrCompletedSessionCountQuery, UserConfirmedOrCompletedSessionCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserConfirmedOrCompletedSessionCountQuery, UserConfirmedOrCompletedSessionCountQueryVariables>(UserConfirmedOrCompletedSessionCountDocument, options);
        }
// @ts-ignore
export function useUserConfirmedOrCompletedSessionCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserConfirmedOrCompletedSessionCountQuery, UserConfirmedOrCompletedSessionCountQueryVariables>): Apollo.UseSuspenseQueryResult<UserConfirmedOrCompletedSessionCountQuery, UserConfirmedOrCompletedSessionCountQueryVariables>;
export function useUserConfirmedOrCompletedSessionCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserConfirmedOrCompletedSessionCountQuery, UserConfirmedOrCompletedSessionCountQueryVariables>): Apollo.UseSuspenseQueryResult<UserConfirmedOrCompletedSessionCountQuery | undefined, UserConfirmedOrCompletedSessionCountQueryVariables>;
export function useUserConfirmedOrCompletedSessionCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserConfirmedOrCompletedSessionCountQuery, UserConfirmedOrCompletedSessionCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserConfirmedOrCompletedSessionCountQuery, UserConfirmedOrCompletedSessionCountQueryVariables>(UserConfirmedOrCompletedSessionCountDocument, options);
        }
export type UserConfirmedOrCompletedSessionCountQueryHookResult = ReturnType<typeof useUserConfirmedOrCompletedSessionCountQuery>;
export type UserConfirmedOrCompletedSessionCountLazyQueryHookResult = ReturnType<typeof useUserConfirmedOrCompletedSessionCountLazyQuery>;
export type UserConfirmedOrCompletedSessionCountSuspenseQueryHookResult = ReturnType<typeof useUserConfirmedOrCompletedSessionCountSuspenseQuery>;
export type UserConfirmedOrCompletedSessionCountQueryResult = Apollo.QueryResult<UserConfirmedOrCompletedSessionCountQuery, UserConfirmedOrCompletedSessionCountQueryVariables>;
export const GetTopLevelCommentsDocument = gql`
    query GetTopLevelComments($input: GetTopLevelCommentsInput!) {
  getTopLevelComments(input: $input) {
    id
    createdAt
    updatedAt
    content
    translatedContent
    mediaUrls
    reactions {
      reactionCounts {
        type
        count
      }
      totalReactions
      currentUserReaction
    }
    repliesCount
    user {
      id
      firstName
      lastName
      title
      role
      profileImageUrl
      influenceBadge {
        ...InfluenceBadgeFields
      }
      companyName
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetTopLevelCommentsQuery__
 *
 * To run a query within a React component, call `useGetTopLevelCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopLevelCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopLevelCommentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTopLevelCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetTopLevelCommentsQuery, GetTopLevelCommentsQueryVariables> & ({ variables: GetTopLevelCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopLevelCommentsQuery, GetTopLevelCommentsQueryVariables>(GetTopLevelCommentsDocument, options);
      }
export function useGetTopLevelCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopLevelCommentsQuery, GetTopLevelCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopLevelCommentsQuery, GetTopLevelCommentsQueryVariables>(GetTopLevelCommentsDocument, options);
        }
// @ts-ignore
export function useGetTopLevelCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTopLevelCommentsQuery, GetTopLevelCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTopLevelCommentsQuery, GetTopLevelCommentsQueryVariables>;
export function useGetTopLevelCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTopLevelCommentsQuery, GetTopLevelCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTopLevelCommentsQuery | undefined, GetTopLevelCommentsQueryVariables>;
export function useGetTopLevelCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTopLevelCommentsQuery, GetTopLevelCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTopLevelCommentsQuery, GetTopLevelCommentsQueryVariables>(GetTopLevelCommentsDocument, options);
        }
export type GetTopLevelCommentsQueryHookResult = ReturnType<typeof useGetTopLevelCommentsQuery>;
export type GetTopLevelCommentsLazyQueryHookResult = ReturnType<typeof useGetTopLevelCommentsLazyQuery>;
export type GetTopLevelCommentsSuspenseQueryHookResult = ReturnType<typeof useGetTopLevelCommentsSuspenseQuery>;
export type GetTopLevelCommentsQueryResult = Apollo.QueryResult<GetTopLevelCommentsQuery, GetTopLevelCommentsQueryVariables>;
export const GetProfileViewersDocument = gql`
    query GetProfileViewers($input: GetProfileViewersInput!) {
  getProfileViewers(input: $input) {
    items {
      viewedDate
      viewer {
        id
        firstName
        lastName
        title
        profileImageUrl
        companyName
      }
    }
    total
    page
    limit
  }
}
    `;

/**
 * __useGetProfileViewersQuery__
 *
 * To run a query within a React component, call `useGetProfileViewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileViewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileViewersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProfileViewersQuery(baseOptions: Apollo.QueryHookOptions<GetProfileViewersQuery, GetProfileViewersQueryVariables> & ({ variables: GetProfileViewersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileViewersQuery, GetProfileViewersQueryVariables>(GetProfileViewersDocument, options);
      }
export function useGetProfileViewersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileViewersQuery, GetProfileViewersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileViewersQuery, GetProfileViewersQueryVariables>(GetProfileViewersDocument, options);
        }
// @ts-ignore
export function useGetProfileViewersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProfileViewersQuery, GetProfileViewersQueryVariables>): Apollo.UseSuspenseQueryResult<GetProfileViewersQuery, GetProfileViewersQueryVariables>;
export function useGetProfileViewersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProfileViewersQuery, GetProfileViewersQueryVariables>): Apollo.UseSuspenseQueryResult<GetProfileViewersQuery | undefined, GetProfileViewersQueryVariables>;
export function useGetProfileViewersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProfileViewersQuery, GetProfileViewersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProfileViewersQuery, GetProfileViewersQueryVariables>(GetProfileViewersDocument, options);
        }
export type GetProfileViewersQueryHookResult = ReturnType<typeof useGetProfileViewersQuery>;
export type GetProfileViewersLazyQueryHookResult = ReturnType<typeof useGetProfileViewersLazyQuery>;
export type GetProfileViewersSuspenseQueryHookResult = ReturnType<typeof useGetProfileViewersSuspenseQuery>;
export type GetProfileViewersQueryResult = Apollo.QueryResult<GetProfileViewersQuery, GetProfileViewersQueryVariables>;
export const CreateGroupDocument = gql`
    mutation CreateGroup($input: CreateGroupInput!) {
  createGroup(input: $input) {
    id
    name
    slug
    description
    privacy
    coverImage
    profileImage
    tags
    categories
    location
    rules
    reviewPosts
    createdAt
    updatedAt
  }
}
    `;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const MyOwnedGroupsCountDocument = gql`
    query MyOwnedGroupsCount {
  myOwnedGroupsCount
}
    `;

/**
 * __useMyOwnedGroupsCountQuery__
 *
 * To run a query within a React component, call `useMyOwnedGroupsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyOwnedGroupsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyOwnedGroupsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyOwnedGroupsCountQuery(baseOptions?: Apollo.QueryHookOptions<MyOwnedGroupsCountQuery, MyOwnedGroupsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyOwnedGroupsCountQuery, MyOwnedGroupsCountQueryVariables>(MyOwnedGroupsCountDocument, options);
      }
export function useMyOwnedGroupsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyOwnedGroupsCountQuery, MyOwnedGroupsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyOwnedGroupsCountQuery, MyOwnedGroupsCountQueryVariables>(MyOwnedGroupsCountDocument, options);
        }
// @ts-ignore
export function useMyOwnedGroupsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyOwnedGroupsCountQuery, MyOwnedGroupsCountQueryVariables>): Apollo.UseSuspenseQueryResult<MyOwnedGroupsCountQuery, MyOwnedGroupsCountQueryVariables>;
export function useMyOwnedGroupsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyOwnedGroupsCountQuery, MyOwnedGroupsCountQueryVariables>): Apollo.UseSuspenseQueryResult<MyOwnedGroupsCountQuery | undefined, MyOwnedGroupsCountQueryVariables>;
export function useMyOwnedGroupsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyOwnedGroupsCountQuery, MyOwnedGroupsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyOwnedGroupsCountQuery, MyOwnedGroupsCountQueryVariables>(MyOwnedGroupsCountDocument, options);
        }
export type MyOwnedGroupsCountQueryHookResult = ReturnType<typeof useMyOwnedGroupsCountQuery>;
export type MyOwnedGroupsCountLazyQueryHookResult = ReturnType<typeof useMyOwnedGroupsCountLazyQuery>;
export type MyOwnedGroupsCountSuspenseQueryHookResult = ReturnType<typeof useMyOwnedGroupsCountSuspenseQuery>;
export type MyOwnedGroupsCountQueryResult = Apollo.QueryResult<MyOwnedGroupsCountQuery, MyOwnedGroupsCountQueryVariables>;
export const MyGroupsDocument = gql`
    query MyGroups($page: Int!, $limit: Int!) {
  myGroups(page: $page, limit: $limit) {
    id
    name
    slug
    description
    coverImage
    profileImage
    privacy
    tags
    categories
    rules
    reviewPosts
    ownerId
    membersCount
    postsCount
    createdAt
    updatedAt
    memberships {
      id
      userId
      role
      status
      isBanned
      user {
        id
        firstName
        lastName
        title
        profileImageUrl
        email
        companyName
      }
    }
  }
}
    `;

/**
 * __useMyGroupsQuery__
 *
 * To run a query within a React component, call `useMyGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGroupsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMyGroupsQuery(baseOptions: Apollo.QueryHookOptions<MyGroupsQuery, MyGroupsQueryVariables> & ({ variables: MyGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyGroupsQuery, MyGroupsQueryVariables>(MyGroupsDocument, options);
      }
export function useMyGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyGroupsQuery, MyGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyGroupsQuery, MyGroupsQueryVariables>(MyGroupsDocument, options);
        }
// @ts-ignore
export function useMyGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyGroupsQuery, MyGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<MyGroupsQuery, MyGroupsQueryVariables>;
export function useMyGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyGroupsQuery, MyGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<MyGroupsQuery | undefined, MyGroupsQueryVariables>;
export function useMyGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyGroupsQuery, MyGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyGroupsQuery, MyGroupsQueryVariables>(MyGroupsDocument, options);
        }
export type MyGroupsQueryHookResult = ReturnType<typeof useMyGroupsQuery>;
export type MyGroupsLazyQueryHookResult = ReturnType<typeof useMyGroupsLazyQuery>;
export type MyGroupsSuspenseQueryHookResult = ReturnType<typeof useMyGroupsSuspenseQuery>;
export type MyGroupsQueryResult = Apollo.QueryResult<MyGroupsQuery, MyGroupsQueryVariables>;
export const DiscoverGroupsDocument = gql`
    query DiscoverGroups($page: Int!, $limit: Int!, $search: String, $privacy: String) {
  discoverGroups(page: $page, limit: $limit, search: $search, privacy: $privacy) {
    id
    name
    slug
    description
    coverImage
    profileImage
    privacy
    tags
    categories
    rules
    reviewPosts
    ownerId
    membersCount
    postsCount
    createdAt
    updatedAt
    memberships {
      id
      status
      user {
        id
      }
    }
  }
}
    `;

/**
 * __useDiscoverGroupsQuery__
 *
 * To run a query within a React component, call `useDiscoverGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverGroupsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      privacy: // value for 'privacy'
 *   },
 * });
 */
export function useDiscoverGroupsQuery(baseOptions: Apollo.QueryHookOptions<DiscoverGroupsQuery, DiscoverGroupsQueryVariables> & ({ variables: DiscoverGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscoverGroupsQuery, DiscoverGroupsQueryVariables>(DiscoverGroupsDocument, options);
      }
export function useDiscoverGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscoverGroupsQuery, DiscoverGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscoverGroupsQuery, DiscoverGroupsQueryVariables>(DiscoverGroupsDocument, options);
        }
// @ts-ignore
export function useDiscoverGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DiscoverGroupsQuery, DiscoverGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<DiscoverGroupsQuery, DiscoverGroupsQueryVariables>;
export function useDiscoverGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscoverGroupsQuery, DiscoverGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<DiscoverGroupsQuery | undefined, DiscoverGroupsQueryVariables>;
export function useDiscoverGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscoverGroupsQuery, DiscoverGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiscoverGroupsQuery, DiscoverGroupsQueryVariables>(DiscoverGroupsDocument, options);
        }
export type DiscoverGroupsQueryHookResult = ReturnType<typeof useDiscoverGroupsQuery>;
export type DiscoverGroupsLazyQueryHookResult = ReturnType<typeof useDiscoverGroupsLazyQuery>;
export type DiscoverGroupsSuspenseQueryHookResult = ReturnType<typeof useDiscoverGroupsSuspenseQuery>;
export type DiscoverGroupsQueryResult = Apollo.QueryResult<DiscoverGroupsQuery, DiscoverGroupsQueryVariables>;
export const PaginatedDiscoverGroupsDocument = gql`
    query PaginatedDiscoverGroups($page: Int!, $limit: Int!, $search: String, $privacy: String) {
  paginatedDiscoverGroups(
    page: $page
    limit: $limit
    search: $search
    privacy: $privacy
  ) {
    groups {
      id
      name
      slug
      description
      coverImage
      profileImage
      privacy
      tags
      categories
      rules
      reviewPosts
      ownerId
      membersCount
      postsCount
      createdAt
      updatedAt
      memberships {
        id
        status
        user {
          id
        }
      }
    }
    total
    page
    limit
    hasNext
  }
}
    `;

/**
 * __usePaginatedDiscoverGroupsQuery__
 *
 * To run a query within a React component, call `usePaginatedDiscoverGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedDiscoverGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedDiscoverGroupsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      privacy: // value for 'privacy'
 *   },
 * });
 */
export function usePaginatedDiscoverGroupsQuery(baseOptions: Apollo.QueryHookOptions<PaginatedDiscoverGroupsQuery, PaginatedDiscoverGroupsQueryVariables> & ({ variables: PaginatedDiscoverGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedDiscoverGroupsQuery, PaginatedDiscoverGroupsQueryVariables>(PaginatedDiscoverGroupsDocument, options);
      }
export function usePaginatedDiscoverGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedDiscoverGroupsQuery, PaginatedDiscoverGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedDiscoverGroupsQuery, PaginatedDiscoverGroupsQueryVariables>(PaginatedDiscoverGroupsDocument, options);
        }
// @ts-ignore
export function usePaginatedDiscoverGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaginatedDiscoverGroupsQuery, PaginatedDiscoverGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<PaginatedDiscoverGroupsQuery, PaginatedDiscoverGroupsQueryVariables>;
export function usePaginatedDiscoverGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaginatedDiscoverGroupsQuery, PaginatedDiscoverGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<PaginatedDiscoverGroupsQuery | undefined, PaginatedDiscoverGroupsQueryVariables>;
export function usePaginatedDiscoverGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaginatedDiscoverGroupsQuery, PaginatedDiscoverGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaginatedDiscoverGroupsQuery, PaginatedDiscoverGroupsQueryVariables>(PaginatedDiscoverGroupsDocument, options);
        }
export type PaginatedDiscoverGroupsQueryHookResult = ReturnType<typeof usePaginatedDiscoverGroupsQuery>;
export type PaginatedDiscoverGroupsLazyQueryHookResult = ReturnType<typeof usePaginatedDiscoverGroupsLazyQuery>;
export type PaginatedDiscoverGroupsSuspenseQueryHookResult = ReturnType<typeof usePaginatedDiscoverGroupsSuspenseQuery>;
export type PaginatedDiscoverGroupsQueryResult = Apollo.QueryResult<PaginatedDiscoverGroupsQuery, PaginatedDiscoverGroupsQueryVariables>;
export const SearchGroupsDocument = gql`
    query SearchGroups($input: SearchGroupsInput!) {
  searchGroups(input: $input) {
    id
    name
    description
    profileImage
    coverImage
    privacy
    membersCount
    tags
    categories
    location
    owner {
      id
    }
    isJoined
  }
}
    `;

/**
 * __useSearchGroupsQuery__
 *
 * To run a query within a React component, call `useSearchGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchGroupsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchGroupsQuery(baseOptions: Apollo.QueryHookOptions<SearchGroupsQuery, SearchGroupsQueryVariables> & ({ variables: SearchGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchGroupsQuery, SearchGroupsQueryVariables>(SearchGroupsDocument, options);
      }
export function useSearchGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchGroupsQuery, SearchGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchGroupsQuery, SearchGroupsQueryVariables>(SearchGroupsDocument, options);
        }
// @ts-ignore
export function useSearchGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchGroupsQuery, SearchGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchGroupsQuery, SearchGroupsQueryVariables>;
export function useSearchGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchGroupsQuery, SearchGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchGroupsQuery | undefined, SearchGroupsQueryVariables>;
export function useSearchGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchGroupsQuery, SearchGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchGroupsQuery, SearchGroupsQueryVariables>(SearchGroupsDocument, options);
        }
export type SearchGroupsQueryHookResult = ReturnType<typeof useSearchGroupsQuery>;
export type SearchGroupsLazyQueryHookResult = ReturnType<typeof useSearchGroupsLazyQuery>;
export type SearchGroupsSuspenseQueryHookResult = ReturnType<typeof useSearchGroupsSuspenseQuery>;
export type SearchGroupsQueryResult = Apollo.QueryResult<SearchGroupsQuery, SearchGroupsQueryVariables>;
export const GroupByIdDocument = gql`
    query GroupById($id: String!) {
  groupById(id: $id) {
    id
    name
    slug
    description
    privacy
    coverImage
    profileImage
    membersCount
    tags
    categories
    status
    rules
    reviewPosts
    ownerId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGroupByIdQuery__
 *
 * To run a query within a React component, call `useGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<GroupByIdQuery, GroupByIdQueryVariables> & ({ variables: GroupByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupByIdQuery, GroupByIdQueryVariables>(GroupByIdDocument, options);
      }
export function useGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupByIdQuery, GroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupByIdQuery, GroupByIdQueryVariables>(GroupByIdDocument, options);
        }
// @ts-ignore
export function useGroupByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupByIdQuery, GroupByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GroupByIdQuery, GroupByIdQueryVariables>;
export function useGroupByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupByIdQuery, GroupByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GroupByIdQuery | undefined, GroupByIdQueryVariables>;
export function useGroupByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupByIdQuery, GroupByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupByIdQuery, GroupByIdQueryVariables>(GroupByIdDocument, options);
        }
export type GroupByIdQueryHookResult = ReturnType<typeof useGroupByIdQuery>;
export type GroupByIdLazyQueryHookResult = ReturnType<typeof useGroupByIdLazyQuery>;
export type GroupByIdSuspenseQueryHookResult = ReturnType<typeof useGroupByIdSuspenseQuery>;
export type GroupByIdQueryResult = Apollo.QueryResult<GroupByIdQuery, GroupByIdQueryVariables>;
export const JoinGroupDocument = gql`
    mutation JoinGroup($groupId: String!) {
  joinGroup(groupId: $groupId)
}
    `;
export type JoinGroupMutationFn = Apollo.MutationFunction<JoinGroupMutation, JoinGroupMutationVariables>;

/**
 * __useJoinGroupMutation__
 *
 * To run a mutation, you first call `useJoinGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinGroupMutation, { data, loading, error }] = useJoinGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useJoinGroupMutation(baseOptions?: Apollo.MutationHookOptions<JoinGroupMutation, JoinGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinGroupMutation, JoinGroupMutationVariables>(JoinGroupDocument, options);
      }
export type JoinGroupMutationHookResult = ReturnType<typeof useJoinGroupMutation>;
export type JoinGroupMutationResult = Apollo.MutationResult<JoinGroupMutation>;
export type JoinGroupMutationOptions = Apollo.BaseMutationOptions<JoinGroupMutation, JoinGroupMutationVariables>;
export const LeaveGroupDocument = gql`
    mutation LeaveGroup($groupId: String!) {
  leaveGroup(groupId: $groupId)
}
    `;
export type LeaveGroupMutationFn = Apollo.MutationFunction<LeaveGroupMutation, LeaveGroupMutationVariables>;

/**
 * __useLeaveGroupMutation__
 *
 * To run a mutation, you first call `useLeaveGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveGroupMutation, { data, loading, error }] = useLeaveGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useLeaveGroupMutation(baseOptions?: Apollo.MutationHookOptions<LeaveGroupMutation, LeaveGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveGroupMutation, LeaveGroupMutationVariables>(LeaveGroupDocument, options);
      }
export type LeaveGroupMutationHookResult = ReturnType<typeof useLeaveGroupMutation>;
export type LeaveGroupMutationResult = Apollo.MutationResult<LeaveGroupMutation>;
export type LeaveGroupMutationOptions = Apollo.BaseMutationOptions<LeaveGroupMutation, LeaveGroupMutationVariables>;
export const WithdrawJoinRequestDocument = gql`
    mutation WithdrawJoinRequest($groupId: String!) {
  withdrawJoinRequest(groupId: $groupId)
}
    `;
export type WithdrawJoinRequestMutationFn = Apollo.MutationFunction<WithdrawJoinRequestMutation, WithdrawJoinRequestMutationVariables>;

/**
 * __useWithdrawJoinRequestMutation__
 *
 * To run a mutation, you first call `useWithdrawJoinRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawJoinRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawJoinRequestMutation, { data, loading, error }] = useWithdrawJoinRequestMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useWithdrawJoinRequestMutation(baseOptions?: Apollo.MutationHookOptions<WithdrawJoinRequestMutation, WithdrawJoinRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WithdrawJoinRequestMutation, WithdrawJoinRequestMutationVariables>(WithdrawJoinRequestDocument, options);
      }
export type WithdrawJoinRequestMutationHookResult = ReturnType<typeof useWithdrawJoinRequestMutation>;
export type WithdrawJoinRequestMutationResult = Apollo.MutationResult<WithdrawJoinRequestMutation>;
export type WithdrawJoinRequestMutationOptions = Apollo.BaseMutationOptions<WithdrawJoinRequestMutation, WithdrawJoinRequestMutationVariables>;
export const GroupMembersDocument = gql`
    query GroupMembers($groupId: String!) {
  groupMembers(groupId: $groupId) {
    id
    role
    status
    isBanned
    joinedAt
    user {
      id
      firstName
      lastName
      title
      profileImageUrl
      influenceBadge {
        ...InfluenceBadgeFields
      }
      companyName
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGroupMembersQuery__
 *
 * To run a query within a React component, call `useGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupMembersQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupMembersQuery(baseOptions: Apollo.QueryHookOptions<GroupMembersQuery, GroupMembersQueryVariables> & ({ variables: GroupMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupMembersQuery, GroupMembersQueryVariables>(GroupMembersDocument, options);
      }
export function useGroupMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupMembersQuery, GroupMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupMembersQuery, GroupMembersQueryVariables>(GroupMembersDocument, options);
        }
// @ts-ignore
export function useGroupMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupMembersQuery, GroupMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GroupMembersQuery, GroupMembersQueryVariables>;
export function useGroupMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupMembersQuery, GroupMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GroupMembersQuery | undefined, GroupMembersQueryVariables>;
export function useGroupMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupMembersQuery, GroupMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupMembersQuery, GroupMembersQueryVariables>(GroupMembersDocument, options);
        }
export type GroupMembersQueryHookResult = ReturnType<typeof useGroupMembersQuery>;
export type GroupMembersLazyQueryHookResult = ReturnType<typeof useGroupMembersLazyQuery>;
export type GroupMembersSuspenseQueryHookResult = ReturnType<typeof useGroupMembersSuspenseQuery>;
export type GroupMembersQueryResult = Apollo.QueryResult<GroupMembersQuery, GroupMembersQueryVariables>;
export const GroupBannedMembersDocument = gql`
    query GroupBannedMembers($groupId: String!) {
  groupBannedMembers(groupId: $groupId) {
    id
    role
    status
    isBanned
    joinedAt
    user {
      id
      firstName
      lastName
      title
      profileImageUrl
      influenceBadge {
        ...InfluenceBadgeFields
      }
      companyName
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGroupBannedMembersQuery__
 *
 * To run a query within a React component, call `useGroupBannedMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupBannedMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupBannedMembersQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupBannedMembersQuery(baseOptions: Apollo.QueryHookOptions<GroupBannedMembersQuery, GroupBannedMembersQueryVariables> & ({ variables: GroupBannedMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupBannedMembersQuery, GroupBannedMembersQueryVariables>(GroupBannedMembersDocument, options);
      }
export function useGroupBannedMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupBannedMembersQuery, GroupBannedMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupBannedMembersQuery, GroupBannedMembersQueryVariables>(GroupBannedMembersDocument, options);
        }
// @ts-ignore
export function useGroupBannedMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupBannedMembersQuery, GroupBannedMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GroupBannedMembersQuery, GroupBannedMembersQueryVariables>;
export function useGroupBannedMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupBannedMembersQuery, GroupBannedMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GroupBannedMembersQuery | undefined, GroupBannedMembersQueryVariables>;
export function useGroupBannedMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupBannedMembersQuery, GroupBannedMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupBannedMembersQuery, GroupBannedMembersQueryVariables>(GroupBannedMembersDocument, options);
        }
export type GroupBannedMembersQueryHookResult = ReturnType<typeof useGroupBannedMembersQuery>;
export type GroupBannedMembersLazyQueryHookResult = ReturnType<typeof useGroupBannedMembersLazyQuery>;
export type GroupBannedMembersSuspenseQueryHookResult = ReturnType<typeof useGroupBannedMembersSuspenseQuery>;
export type GroupBannedMembersQueryResult = Apollo.QueryResult<GroupBannedMembersQuery, GroupBannedMembersQueryVariables>;
export const GroupPendingInvitesDocument = gql`
    query GroupPendingInvites($groupId: String!) {
  groupPendingInvites(groupId: $groupId) {
    id
    groupId
    inviteeEmail
    status
    createdAt
    expiresAt
    invitee {
      id
      firstName
      lastName
      title
      profileImageUrl
      role
      companyName
    }
    inviter {
      id
      firstName
      lastName
      title
      profileImageUrl
      companyName
    }
  }
}
    `;

/**
 * __useGroupPendingInvitesQuery__
 *
 * To run a query within a React component, call `useGroupPendingInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupPendingInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupPendingInvitesQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupPendingInvitesQuery(baseOptions: Apollo.QueryHookOptions<GroupPendingInvitesQuery, GroupPendingInvitesQueryVariables> & ({ variables: GroupPendingInvitesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupPendingInvitesQuery, GroupPendingInvitesQueryVariables>(GroupPendingInvitesDocument, options);
      }
export function useGroupPendingInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupPendingInvitesQuery, GroupPendingInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupPendingInvitesQuery, GroupPendingInvitesQueryVariables>(GroupPendingInvitesDocument, options);
        }
// @ts-ignore
export function useGroupPendingInvitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupPendingInvitesQuery, GroupPendingInvitesQueryVariables>): Apollo.UseSuspenseQueryResult<GroupPendingInvitesQuery, GroupPendingInvitesQueryVariables>;
export function useGroupPendingInvitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupPendingInvitesQuery, GroupPendingInvitesQueryVariables>): Apollo.UseSuspenseQueryResult<GroupPendingInvitesQuery | undefined, GroupPendingInvitesQueryVariables>;
export function useGroupPendingInvitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupPendingInvitesQuery, GroupPendingInvitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupPendingInvitesQuery, GroupPendingInvitesQueryVariables>(GroupPendingInvitesDocument, options);
        }
export type GroupPendingInvitesQueryHookResult = ReturnType<typeof useGroupPendingInvitesQuery>;
export type GroupPendingInvitesLazyQueryHookResult = ReturnType<typeof useGroupPendingInvitesLazyQuery>;
export type GroupPendingInvitesSuspenseQueryHookResult = ReturnType<typeof useGroupPendingInvitesSuspenseQuery>;
export type GroupPendingInvitesQueryResult = Apollo.QueryResult<GroupPendingInvitesQuery, GroupPendingInvitesQueryVariables>;
export const GroupPendingJoinRequestsDocument = gql`
    query GroupPendingJoinRequests($groupId: String!) {
  groupPendingJoinRequests(groupId: $groupId) {
    id
    role
    status
    joinedAt
    user {
      id
      firstName
      lastName
      title
      profileImageUrl
      headline
      influenceBadge {
        ...InfluenceBadgeFields
      }
      companyName
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGroupPendingJoinRequestsQuery__
 *
 * To run a query within a React component, call `useGroupPendingJoinRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupPendingJoinRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupPendingJoinRequestsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupPendingJoinRequestsQuery(baseOptions: Apollo.QueryHookOptions<GroupPendingJoinRequestsQuery, GroupPendingJoinRequestsQueryVariables> & ({ variables: GroupPendingJoinRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupPendingJoinRequestsQuery, GroupPendingJoinRequestsQueryVariables>(GroupPendingJoinRequestsDocument, options);
      }
export function useGroupPendingJoinRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupPendingJoinRequestsQuery, GroupPendingJoinRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupPendingJoinRequestsQuery, GroupPendingJoinRequestsQueryVariables>(GroupPendingJoinRequestsDocument, options);
        }
// @ts-ignore
export function useGroupPendingJoinRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupPendingJoinRequestsQuery, GroupPendingJoinRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupPendingJoinRequestsQuery, GroupPendingJoinRequestsQueryVariables>;
export function useGroupPendingJoinRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupPendingJoinRequestsQuery, GroupPendingJoinRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupPendingJoinRequestsQuery | undefined, GroupPendingJoinRequestsQueryVariables>;
export function useGroupPendingJoinRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupPendingJoinRequestsQuery, GroupPendingJoinRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupPendingJoinRequestsQuery, GroupPendingJoinRequestsQueryVariables>(GroupPendingJoinRequestsDocument, options);
        }
export type GroupPendingJoinRequestsQueryHookResult = ReturnType<typeof useGroupPendingJoinRequestsQuery>;
export type GroupPendingJoinRequestsLazyQueryHookResult = ReturnType<typeof useGroupPendingJoinRequestsLazyQuery>;
export type GroupPendingJoinRequestsSuspenseQueryHookResult = ReturnType<typeof useGroupPendingJoinRequestsSuspenseQuery>;
export type GroupPendingJoinRequestsQueryResult = Apollo.QueryResult<GroupPendingJoinRequestsQuery, GroupPendingJoinRequestsQueryVariables>;
export const GroupPostsDocument = gql`
    query GroupPosts($groupId: String!) {
  groupPosts(groupId: $groupId) {
    id
    contentTokens {
      type
      value
      handle
      userId
      url
    }
    translatedContentTokens {
      type
      value
      handle
      userId
      url
    }
    createdAt
    author {
      id
      firstName
      lastName
      title
      profileImageUrl
      role
      companyName
    }
    mediaUrls
    isPublished
    commentsCount
  }
}
    `;

/**
 * __useGroupPostsQuery__
 *
 * To run a query within a React component, call `useGroupPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupPostsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupPostsQuery(baseOptions: Apollo.QueryHookOptions<GroupPostsQuery, GroupPostsQueryVariables> & ({ variables: GroupPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupPostsQuery, GroupPostsQueryVariables>(GroupPostsDocument, options);
      }
export function useGroupPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupPostsQuery, GroupPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupPostsQuery, GroupPostsQueryVariables>(GroupPostsDocument, options);
        }
// @ts-ignore
export function useGroupPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupPostsQuery, GroupPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupPostsQuery, GroupPostsQueryVariables>;
export function useGroupPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupPostsQuery, GroupPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupPostsQuery | undefined, GroupPostsQueryVariables>;
export function useGroupPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupPostsQuery, GroupPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupPostsQuery, GroupPostsQueryVariables>(GroupPostsDocument, options);
        }
export type GroupPostsQueryHookResult = ReturnType<typeof useGroupPostsQuery>;
export type GroupPostsLazyQueryHookResult = ReturnType<typeof useGroupPostsLazyQuery>;
export type GroupPostsSuspenseQueryHookResult = ReturnType<typeof useGroupPostsSuspenseQuery>;
export type GroupPostsQueryResult = Apollo.QueryResult<GroupPostsQuery, GroupPostsQueryVariables>;
export const GroupApprovedPostsDocument = gql`
    query GroupApprovedPosts($groupId: String!) {
  groupApprovedPosts(groupId: $groupId) {
    id
    isRepost
    repostComment
    originalPostId
    postType
    contentTokens {
      type
      value
      handle
      userId
      url
    }
    translatedContentTokens {
      type
      value
      handle
      userId
      url
    }
    author {
      id
      firstName
      lastName
      title
      middleName
      profileImageUrl
      role
      createdAt
      updatedAt
      companyName
    }
    companyAuthor {
      id
      name
      logoUrl
      industry
      tagline
      followersCount
      isFollowing
    }
    article {
      id
      title
      subtitle
      coverImageUrl
      slug
      readingTimeMinutes
      tags
      content
      status
      translatedTitle
      translatedSubtitle
      translatedExcerpt
    }
    occasion {
      id
      postId
      title
      description
      imageUrl
      privacy
      translatedTitle
      translatedDescription
    }
    poll {
      question
      expiresAt
      options {
        id
        text
        votes
        isChosen
      }
      translatedQuestion
      translatedOptions
    }
    event {
      id
      name
      description
      imageUrl
      startTime
      endTime
      location
      category
      maxAttendees
      participantsCount
      organizedby {
        userId
        name
        imageUrl
        companyName
      }
      course {
        id
        title
        thumbnailUrl
      }
      isjoinedbyMe
    }
    case {
      id
      postId
      createdAt
      updatedAt
      media {
        id
        step
        type
        imageUrl
        text
        order
        createdAt
        translatedText
      }
    }
    originalPost {
      id
      contentTokens {
        type
        value
        handle
        userId
        url
      }
      translatedContentTokens {
        type
        value
        handle
        userId
        url
      }
      author {
        id
        firstName
        lastName
        title
        middleName
        profileImageUrl
        role
        createdAt
        updatedAt
        companyName
      }
      mediaUrls
      occasion {
        id
        postId
        title
        description
        imageUrl
        privacy
        translatedTitle
        translatedDescription
      }
      poll {
        question
        expiresAt
        options {
          id
          text
          votes
          isChosen
        }
        translatedQuestion
        translatedOptions
      }
      event {
        id
        name
        description
        imageUrl
        startTime
        endTime
        location
        category
        maxAttendees
        participantsCount
        organizedby {
          userId
          name
          imageUrl
          companyName
        }
        course {
          id
          title
          thumbnailUrl
        }
        isjoinedbyMe
      }
      case {
        id
        postId
        createdAt
        updatedAt
        media {
          id
          step
          type
          imageUrl
          text
          order
          createdAt
          translatedText
        }
      }
      reactions {
        reactionCounts {
          type
          count
        }
        totalReactions
        currentUserReaction
      }
      commentsCount
      isSavedByMe
      isRepostedByMe
      isPublished
      createdAt
      updatedAt
    }
    mediaUrls
    reactions {
      reactionCounts {
        type
        count
      }
      totalReactions
      currentUserReaction
    }
    commentsCount
    isSavedByMe
    isRepostedByMe
    isPublished
    isBoosted
    activeBoostId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGroupApprovedPostsQuery__
 *
 * To run a query within a React component, call `useGroupApprovedPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupApprovedPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupApprovedPostsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupApprovedPostsQuery(baseOptions: Apollo.QueryHookOptions<GroupApprovedPostsQuery, GroupApprovedPostsQueryVariables> & ({ variables: GroupApprovedPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupApprovedPostsQuery, GroupApprovedPostsQueryVariables>(GroupApprovedPostsDocument, options);
      }
export function useGroupApprovedPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupApprovedPostsQuery, GroupApprovedPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupApprovedPostsQuery, GroupApprovedPostsQueryVariables>(GroupApprovedPostsDocument, options);
        }
// @ts-ignore
export function useGroupApprovedPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupApprovedPostsQuery, GroupApprovedPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupApprovedPostsQuery, GroupApprovedPostsQueryVariables>;
export function useGroupApprovedPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupApprovedPostsQuery, GroupApprovedPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupApprovedPostsQuery | undefined, GroupApprovedPostsQueryVariables>;
export function useGroupApprovedPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupApprovedPostsQuery, GroupApprovedPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupApprovedPostsQuery, GroupApprovedPostsQueryVariables>(GroupApprovedPostsDocument, options);
        }
export type GroupApprovedPostsQueryHookResult = ReturnType<typeof useGroupApprovedPostsQuery>;
export type GroupApprovedPostsLazyQueryHookResult = ReturnType<typeof useGroupApprovedPostsLazyQuery>;
export type GroupApprovedPostsSuspenseQueryHookResult = ReturnType<typeof useGroupApprovedPostsSuspenseQuery>;
export type GroupApprovedPostsQueryResult = Apollo.QueryResult<GroupApprovedPostsQuery, GroupApprovedPostsQueryVariables>;
export const GroupFeedDocument = gql`
    query GroupFeed($input: GroupFeedInput!) {
  groupFeed(input: $input) {
    pageInfo {
      nextCursor
      hasNextPage
    }
    items {
      id
      type
      cursor
      postBoost {
        id
        postId
        userId
        status
        durationHours
        durationSeconds
        hourlyRateCents
        amountCents
        currency
        startsAt
        expiresAt
        remainingDurationSeconds
        paymentIntentId
        invoiceId
        createdAt
        updatedAt
      }
      post {
        id
        isRepost
        repostComment
        originalPostId
        postType
        contentTokens {
          type
          value
          handle
          userId
          url
        }
        translatedContentTokens {
          type
          value
          handle
          userId
          url
        }
        author {
          id
          firstName
          lastName
          title
          middleName
          profileImageUrl
          role
          headline
          isHiring
          openToWork
          influenceBadge {
            ...InfluenceBadgeFields
          }
          createdAt
          updatedAt
          companyName
        }
        companyAuthor {
          id
          name
          logoUrl
          industry
          tagline
          followersCount
          isFollowing
        }
        article {
          id
          title
          subtitle
          coverImageUrl
          slug
          readingTimeMinutes
          tags
          content
          status
          translatedTitle
          translatedSubtitle
          translatedExcerpt
        }
        occasion {
          id
          postId
          title
          description
          imageUrl
          privacy
          translatedTitle
          translatedDescription
        }
        poll {
          question
          expiresAt
          options {
            id
            text
            votes
            isChosen
          }
          translatedQuestion
          translatedOptions
        }
        event {
          id
          name
          description
          imageUrl
          startTime
          endTime
          location
          category
          maxAttendees
          participantsCount
          organizedby {
            userId
            name
            imageUrl
            companyName
          }
          course {
            id
            title
            thumbnailUrl
          }
          isjoinedbyMe
        }
        case {
          id
          postId
          createdAt
          updatedAt
          media {
            id
            step
            type
            imageUrl
            text
            order
            createdAt
            translatedText
          }
        }
        originalPost {
          id
          contentTokens {
            type
            value
            handle
            userId
            url
          }
          translatedContentTokens {
            type
            value
            handle
            userId
            url
          }
          author {
            id
            firstName
            lastName
            title
            middleName
            profileImageUrl
            role
            createdAt
            updatedAt
            companyName
          }
          mediaUrls
          isBoosted
          activeBoostId
          occasion {
            id
            postId
            title
            description
            imageUrl
            privacy
            translatedTitle
            translatedDescription
          }
          poll {
            question
            expiresAt
            options {
              id
              text
              votes
              isChosen
            }
            translatedQuestion
            translatedOptions
          }
          event {
            id
            name
            description
            imageUrl
            startTime
            endTime
            location
            category
            maxAttendees
            participantsCount
            organizedby {
              userId
              name
              imageUrl
              companyName
            }
            course {
              id
              title
              thumbnailUrl
            }
            isjoinedbyMe
          }
          case {
            id
            postId
            createdAt
            updatedAt
            media {
              id
              step
              type
              imageUrl
              text
              order
              createdAt
              translatedText
            }
          }
          reactions {
            reactionCounts {
              type
              count
            }
            totalReactions
            currentUserReaction
          }
          commentsCount
          isSavedByMe
          isRepostedByMe
          isPublished
          createdAt
          updatedAt
        }
        mediaUrls
        reactions {
          reactionCounts {
            type
            count
          }
          totalReactions
          currentUserReaction
        }
        commentsCount
        isSavedByMe
        isRepostedByMe
        isPublished
        isBoosted
        activeBoostId
        createdAt
        updatedAt
      }
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGroupFeedQuery__
 *
 * To run a query within a React component, call `useGroupFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupFeedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGroupFeedQuery(baseOptions: Apollo.QueryHookOptions<GroupFeedQuery, GroupFeedQueryVariables> & ({ variables: GroupFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupFeedQuery, GroupFeedQueryVariables>(GroupFeedDocument, options);
      }
export function useGroupFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupFeedQuery, GroupFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupFeedQuery, GroupFeedQueryVariables>(GroupFeedDocument, options);
        }
// @ts-ignore
export function useGroupFeedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupFeedQuery, GroupFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GroupFeedQuery, GroupFeedQueryVariables>;
export function useGroupFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupFeedQuery, GroupFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GroupFeedQuery | undefined, GroupFeedQueryVariables>;
export function useGroupFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupFeedQuery, GroupFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupFeedQuery, GroupFeedQueryVariables>(GroupFeedDocument, options);
        }
export type GroupFeedQueryHookResult = ReturnType<typeof useGroupFeedQuery>;
export type GroupFeedLazyQueryHookResult = ReturnType<typeof useGroupFeedLazyQuery>;
export type GroupFeedSuspenseQueryHookResult = ReturnType<typeof useGroupFeedSuspenseQuery>;
export type GroupFeedQueryResult = Apollo.QueryResult<GroupFeedQuery, GroupFeedQueryVariables>;
export const GroupPendingPostsDocument = gql`
    query GroupPendingPosts($groupId: String!) {
  groupPendingPosts(groupId: $groupId) {
    id
    postType
    contentTokens {
      type
      value
      handle
      userId
      url
    }
    translatedContentTokens {
      type
      value
      handle
      userId
      url
    }
    createdAt
    author {
      id
      firstName
      lastName
      title
      middleName
      profileImageUrl
      role
      influenceBadge {
        ...InfluenceBadgeFields
      }
      companyName
    }
    mediaUrls
    isPublished
    commentsCount
    article {
      id
      title
      subtitle
      coverImageUrl
      slug
      readingTimeMinutes
      tags
      content
      status
      translatedTitle
      translatedSubtitle
      translatedExcerpt
    }
    occasion {
      id
      postId
      title
      description
      imageUrl
      privacy
      translatedTitle
      translatedDescription
    }
    poll {
      question
      expiresAt
      options {
        id
        text
        votes
        isChosen
      }
      translatedQuestion
      translatedOptions
    }
    event {
      id
      name
      description
      imageUrl
      startTime
      endTime
      location
      category
      maxAttendees
      participantsCount
      organizedby {
        userId
        name
        imageUrl
        companyName
      }
      course {
        id
        title
        thumbnailUrl
      }
      isjoinedbyMe
    }
    case {
      id
      postId
      createdAt
      updatedAt
      media {
        id
        step
        type
        imageUrl
        text
        order
        createdAt
        translatedText
      }
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGroupPendingPostsQuery__
 *
 * To run a query within a React component, call `useGroupPendingPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupPendingPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupPendingPostsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupPendingPostsQuery(baseOptions: Apollo.QueryHookOptions<GroupPendingPostsQuery, GroupPendingPostsQueryVariables> & ({ variables: GroupPendingPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupPendingPostsQuery, GroupPendingPostsQueryVariables>(GroupPendingPostsDocument, options);
      }
export function useGroupPendingPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupPendingPostsQuery, GroupPendingPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupPendingPostsQuery, GroupPendingPostsQueryVariables>(GroupPendingPostsDocument, options);
        }
// @ts-ignore
export function useGroupPendingPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupPendingPostsQuery, GroupPendingPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupPendingPostsQuery, GroupPendingPostsQueryVariables>;
export function useGroupPendingPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupPendingPostsQuery, GroupPendingPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupPendingPostsQuery | undefined, GroupPendingPostsQueryVariables>;
export function useGroupPendingPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupPendingPostsQuery, GroupPendingPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupPendingPostsQuery, GroupPendingPostsQueryVariables>(GroupPendingPostsDocument, options);
        }
export type GroupPendingPostsQueryHookResult = ReturnType<typeof useGroupPendingPostsQuery>;
export type GroupPendingPostsLazyQueryHookResult = ReturnType<typeof useGroupPendingPostsLazyQuery>;
export type GroupPendingPostsSuspenseQueryHookResult = ReturnType<typeof useGroupPendingPostsSuspenseQuery>;
export type GroupPendingPostsQueryResult = Apollo.QueryResult<GroupPendingPostsQuery, GroupPendingPostsQueryVariables>;
export const ApprovePostDocument = gql`
    mutation ApprovePost($postId: String!) {
  approvePost(postId: $postId)
}
    `;
export type ApprovePostMutationFn = Apollo.MutationFunction<ApprovePostMutation, ApprovePostMutationVariables>;

/**
 * __useApprovePostMutation__
 *
 * To run a mutation, you first call `useApprovePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvePostMutation, { data, loading, error }] = useApprovePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useApprovePostMutation(baseOptions?: Apollo.MutationHookOptions<ApprovePostMutation, ApprovePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApprovePostMutation, ApprovePostMutationVariables>(ApprovePostDocument, options);
      }
export type ApprovePostMutationHookResult = ReturnType<typeof useApprovePostMutation>;
export type ApprovePostMutationResult = Apollo.MutationResult<ApprovePostMutation>;
export type ApprovePostMutationOptions = Apollo.BaseMutationOptions<ApprovePostMutation, ApprovePostMutationVariables>;
export const RejectPostDocument = gql`
    mutation RejectPost($postId: String!) {
  rejectPost(postId: $postId)
}
    `;
export type RejectPostMutationFn = Apollo.MutationFunction<RejectPostMutation, RejectPostMutationVariables>;

/**
 * __useRejectPostMutation__
 *
 * To run a mutation, you first call `useRejectPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectPostMutation, { data, loading, error }] = useRejectPostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useRejectPostMutation(baseOptions?: Apollo.MutationHookOptions<RejectPostMutation, RejectPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectPostMutation, RejectPostMutationVariables>(RejectPostDocument, options);
      }
export type RejectPostMutationHookResult = ReturnType<typeof useRejectPostMutation>;
export type RejectPostMutationResult = Apollo.MutationResult<RejectPostMutation>;
export type RejectPostMutationOptions = Apollo.BaseMutationOptions<RejectPostMutation, RejectPostMutationVariables>;
export const GetGroupRoleIdsDocument = gql`
    query GetGroupRoleIds($groupId: String!) {
  getGroupRoleIds(groupId: $groupId) {
    ownerId
    admins
    moderators
  }
}
    `;

/**
 * __useGetGroupRoleIdsQuery__
 *
 * To run a query within a React component, call `useGetGroupRoleIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupRoleIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupRoleIdsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetGroupRoleIdsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupRoleIdsQuery, GetGroupRoleIdsQueryVariables> & ({ variables: GetGroupRoleIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupRoleIdsQuery, GetGroupRoleIdsQueryVariables>(GetGroupRoleIdsDocument, options);
      }
export function useGetGroupRoleIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupRoleIdsQuery, GetGroupRoleIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupRoleIdsQuery, GetGroupRoleIdsQueryVariables>(GetGroupRoleIdsDocument, options);
        }
// @ts-ignore
export function useGetGroupRoleIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGroupRoleIdsQuery, GetGroupRoleIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupRoleIdsQuery, GetGroupRoleIdsQueryVariables>;
export function useGetGroupRoleIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupRoleIdsQuery, GetGroupRoleIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupRoleIdsQuery | undefined, GetGroupRoleIdsQueryVariables>;
export function useGetGroupRoleIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupRoleIdsQuery, GetGroupRoleIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupRoleIdsQuery, GetGroupRoleIdsQueryVariables>(GetGroupRoleIdsDocument, options);
        }
export type GetGroupRoleIdsQueryHookResult = ReturnType<typeof useGetGroupRoleIdsQuery>;
export type GetGroupRoleIdsLazyQueryHookResult = ReturnType<typeof useGetGroupRoleIdsLazyQuery>;
export type GetGroupRoleIdsSuspenseQueryHookResult = ReturnType<typeof useGetGroupRoleIdsSuspenseQuery>;
export type GetGroupRoleIdsQueryResult = Apollo.QueryResult<GetGroupRoleIdsQuery, GetGroupRoleIdsQueryVariables>;
export const MyGroupsWithPendingRequestsDocument = gql`
    query MyGroupsWithPendingRequests {
  myGroupsWithPendingRequests {
    id
    name
    memberships {
      id
      status
      joinedAt
      user {
        id
        firstName
        lastName
        title
        email
        role
        headline
        isHiring
        openToWork
        profileImageUrl
        companyName
      }
    }
  }
}
    `;

/**
 * __useMyGroupsWithPendingRequestsQuery__
 *
 * To run a query within a React component, call `useMyGroupsWithPendingRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGroupsWithPendingRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGroupsWithPendingRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyGroupsWithPendingRequestsQuery(baseOptions?: Apollo.QueryHookOptions<MyGroupsWithPendingRequestsQuery, MyGroupsWithPendingRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyGroupsWithPendingRequestsQuery, MyGroupsWithPendingRequestsQueryVariables>(MyGroupsWithPendingRequestsDocument, options);
      }
export function useMyGroupsWithPendingRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyGroupsWithPendingRequestsQuery, MyGroupsWithPendingRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyGroupsWithPendingRequestsQuery, MyGroupsWithPendingRequestsQueryVariables>(MyGroupsWithPendingRequestsDocument, options);
        }
// @ts-ignore
export function useMyGroupsWithPendingRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyGroupsWithPendingRequestsQuery, MyGroupsWithPendingRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<MyGroupsWithPendingRequestsQuery, MyGroupsWithPendingRequestsQueryVariables>;
export function useMyGroupsWithPendingRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyGroupsWithPendingRequestsQuery, MyGroupsWithPendingRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<MyGroupsWithPendingRequestsQuery | undefined, MyGroupsWithPendingRequestsQueryVariables>;
export function useMyGroupsWithPendingRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyGroupsWithPendingRequestsQuery, MyGroupsWithPendingRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyGroupsWithPendingRequestsQuery, MyGroupsWithPendingRequestsQueryVariables>(MyGroupsWithPendingRequestsDocument, options);
        }
export type MyGroupsWithPendingRequestsQueryHookResult = ReturnType<typeof useMyGroupsWithPendingRequestsQuery>;
export type MyGroupsWithPendingRequestsLazyQueryHookResult = ReturnType<typeof useMyGroupsWithPendingRequestsLazyQuery>;
export type MyGroupsWithPendingRequestsSuspenseQueryHookResult = ReturnType<typeof useMyGroupsWithPendingRequestsSuspenseQuery>;
export type MyGroupsWithPendingRequestsQueryResult = Apollo.QueryResult<MyGroupsWithPendingRequestsQuery, MyGroupsWithPendingRequestsQueryVariables>;
export const ApproveMembershipDocument = gql`
    mutation ApproveMembership($membershipId: String!) {
  approveMembership(membershipId: $membershipId)
}
    `;
export type ApproveMembershipMutationFn = Apollo.MutationFunction<ApproveMembershipMutation, ApproveMembershipMutationVariables>;

/**
 * __useApproveMembershipMutation__
 *
 * To run a mutation, you first call `useApproveMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveMembershipMutation, { data, loading, error }] = useApproveMembershipMutation({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useApproveMembershipMutation(baseOptions?: Apollo.MutationHookOptions<ApproveMembershipMutation, ApproveMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveMembershipMutation, ApproveMembershipMutationVariables>(ApproveMembershipDocument, options);
      }
export type ApproveMembershipMutationHookResult = ReturnType<typeof useApproveMembershipMutation>;
export type ApproveMembershipMutationResult = Apollo.MutationResult<ApproveMembershipMutation>;
export type ApproveMembershipMutationOptions = Apollo.BaseMutationOptions<ApproveMembershipMutation, ApproveMembershipMutationVariables>;
export const RejectMembershipDocument = gql`
    mutation RejectMembership($membershipId: String!) {
  rejectMembership(membershipId: $membershipId)
}
    `;
export type RejectMembershipMutationFn = Apollo.MutationFunction<RejectMembershipMutation, RejectMembershipMutationVariables>;

/**
 * __useRejectMembershipMutation__
 *
 * To run a mutation, you first call `useRejectMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectMembershipMutation, { data, loading, error }] = useRejectMembershipMutation({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useRejectMembershipMutation(baseOptions?: Apollo.MutationHookOptions<RejectMembershipMutation, RejectMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectMembershipMutation, RejectMembershipMutationVariables>(RejectMembershipDocument, options);
      }
export type RejectMembershipMutationHookResult = ReturnType<typeof useRejectMembershipMutation>;
export type RejectMembershipMutationResult = Apollo.MutationResult<RejectMembershipMutation>;
export type RejectMembershipMutationOptions = Apollo.BaseMutationOptions<RejectMembershipMutation, RejectMembershipMutationVariables>;
export const GetMemberPermissionsDocument = gql`
    query GetMemberPermissions($groupId: String!) {
  getMemberPermissions(groupId: $groupId) {
    canPost
    canModerate
    canManageMembers
    canEditSettings
    canDelete
    canAssignRoles
    canRemoveMembers
    canInvite
    role
    membershipStatus
    isMember
  }
}
    `;

/**
 * __useGetMemberPermissionsQuery__
 *
 * To run a query within a React component, call `useGetMemberPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberPermissionsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetMemberPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetMemberPermissionsQuery, GetMemberPermissionsQueryVariables> & ({ variables: GetMemberPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberPermissionsQuery, GetMemberPermissionsQueryVariables>(GetMemberPermissionsDocument, options);
      }
export function useGetMemberPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberPermissionsQuery, GetMemberPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberPermissionsQuery, GetMemberPermissionsQueryVariables>(GetMemberPermissionsDocument, options);
        }
// @ts-ignore
export function useGetMemberPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMemberPermissionsQuery, GetMemberPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMemberPermissionsQuery, GetMemberPermissionsQueryVariables>;
export function useGetMemberPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMemberPermissionsQuery, GetMemberPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMemberPermissionsQuery | undefined, GetMemberPermissionsQueryVariables>;
export function useGetMemberPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMemberPermissionsQuery, GetMemberPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMemberPermissionsQuery, GetMemberPermissionsQueryVariables>(GetMemberPermissionsDocument, options);
        }
export type GetMemberPermissionsQueryHookResult = ReturnType<typeof useGetMemberPermissionsQuery>;
export type GetMemberPermissionsLazyQueryHookResult = ReturnType<typeof useGetMemberPermissionsLazyQuery>;
export type GetMemberPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetMemberPermissionsSuspenseQuery>;
export type GetMemberPermissionsQueryResult = Apollo.QueryResult<GetMemberPermissionsQuery, GetMemberPermissionsQueryVariables>;
export const UpdateMemberRoleDocument = gql`
    mutation UpdateMemberRole($input: UpdateMemberRoleInput!) {
  updateMemberRole(input: $input)
}
    `;
export type UpdateMemberRoleMutationFn = Apollo.MutationFunction<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>;

/**
 * __useUpdateMemberRoleMutation__
 *
 * To run a mutation, you first call `useUpdateMemberRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberRoleMutation, { data, loading, error }] = useUpdateMemberRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMemberRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>(UpdateMemberRoleDocument, options);
      }
export type UpdateMemberRoleMutationHookResult = ReturnType<typeof useUpdateMemberRoleMutation>;
export type UpdateMemberRoleMutationResult = Apollo.MutationResult<UpdateMemberRoleMutation>;
export type UpdateMemberRoleMutationOptions = Apollo.BaseMutationOptions<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>;
export const RemoveMemberFromGroupDocument = gql`
    mutation RemoveMemberFromGroup($input: RemoveMemberInput!) {
  removeMemberFromGroup(input: $input)
}
    `;
export type RemoveMemberFromGroupMutationFn = Apollo.MutationFunction<RemoveMemberFromGroupMutation, RemoveMemberFromGroupMutationVariables>;

/**
 * __useRemoveMemberFromGroupMutation__
 *
 * To run a mutation, you first call `useRemoveMemberFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberFromGroupMutation, { data, loading, error }] = useRemoveMemberFromGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveMemberFromGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberFromGroupMutation, RemoveMemberFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMemberFromGroupMutation, RemoveMemberFromGroupMutationVariables>(RemoveMemberFromGroupDocument, options);
      }
export type RemoveMemberFromGroupMutationHookResult = ReturnType<typeof useRemoveMemberFromGroupMutation>;
export type RemoveMemberFromGroupMutationResult = Apollo.MutationResult<RemoveMemberFromGroupMutation>;
export type RemoveMemberFromGroupMutationOptions = Apollo.BaseMutationOptions<RemoveMemberFromGroupMutation, RemoveMemberFromGroupMutationVariables>;
export const UpdateGroupDocument = gql`
    mutation UpdateGroup($groupId: String!, $input: UpdateGroupInput!) {
  updateGroup(groupId: $groupId, input: $input) {
    id
    name
    description
    location
    rules
    privacy
    coverImage
    profileImage
    tags
    reviewPosts
  }
}
    `;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const DeleteGroupDocument = gql`
    mutation DeleteGroup($groupId: String!) {
  deleteGroup(groupId: $groupId)
}
    `;
export type DeleteGroupMutationFn = Apollo.MutationFunction<DeleteGroupMutation, DeleteGroupMutationVariables>;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMutation, { data, loading, error }] = useDeleteGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDeleteGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupMutation, DeleteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument, options);
      }
export type DeleteGroupMutationHookResult = ReturnType<typeof useDeleteGroupMutation>;
export type DeleteGroupMutationResult = Apollo.MutationResult<DeleteGroupMutation>;
export type DeleteGroupMutationOptions = Apollo.BaseMutationOptions<DeleteGroupMutation, DeleteGroupMutationVariables>;
export const BanDocument = gql`
    mutation Ban($input: BanMemberInput!) {
  banMember(input: $input)
}
    `;
export type BanMutationFn = Apollo.MutationFunction<BanMutation, BanMutationVariables>;

/**
 * __useBanMutation__
 *
 * To run a mutation, you first call `useBanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [banMutation, { data, loading, error }] = useBanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBanMutation(baseOptions?: Apollo.MutationHookOptions<BanMutation, BanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BanMutation, BanMutationVariables>(BanDocument, options);
      }
export type BanMutationHookResult = ReturnType<typeof useBanMutation>;
export type BanMutationResult = Apollo.MutationResult<BanMutation>;
export type BanMutationOptions = Apollo.BaseMutationOptions<BanMutation, BanMutationVariables>;
export const UnbanDocument = gql`
    mutation Unban($input: UnbanMemberInput!) {
  unbanMember(input: $input)
}
    `;
export type UnbanMutationFn = Apollo.MutationFunction<UnbanMutation, UnbanMutationVariables>;

/**
 * __useUnbanMutation__
 *
 * To run a mutation, you first call `useUnbanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnbanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unbanMutation, { data, loading, error }] = useUnbanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnbanMutation(baseOptions?: Apollo.MutationHookOptions<UnbanMutation, UnbanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnbanMutation, UnbanMutationVariables>(UnbanDocument, options);
      }
export type UnbanMutationHookResult = ReturnType<typeof useUnbanMutation>;
export type UnbanMutationResult = Apollo.MutationResult<UnbanMutation>;
export type UnbanMutationOptions = Apollo.BaseMutationOptions<UnbanMutation, UnbanMutationVariables>;
export const InviteToGroupDocument = gql`
    mutation InviteToGroup($input: InviteToGroupInput!) {
  inviteToGroup(input: $input) {
    success
    message
    invitedCount
    skippedCount
  }
}
    `;
export type InviteToGroupMutationFn = Apollo.MutationFunction<InviteToGroupMutation, InviteToGroupMutationVariables>;

/**
 * __useInviteToGroupMutation__
 *
 * To run a mutation, you first call `useInviteToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteToGroupMutation, { data, loading, error }] = useInviteToGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteToGroupMutation(baseOptions?: Apollo.MutationHookOptions<InviteToGroupMutation, InviteToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteToGroupMutation, InviteToGroupMutationVariables>(InviteToGroupDocument, options);
      }
export type InviteToGroupMutationHookResult = ReturnType<typeof useInviteToGroupMutation>;
export type InviteToGroupMutationResult = Apollo.MutationResult<InviteToGroupMutation>;
export type InviteToGroupMutationOptions = Apollo.BaseMutationOptions<InviteToGroupMutation, InviteToGroupMutationVariables>;
export const AcceptGroupInviteDocument = gql`
    mutation AcceptGroupInvite($groupId: String!) {
  acceptGroupInvite(groupId: $groupId) {
    joinedInstantly
  }
}
    `;
export type AcceptGroupInviteMutationFn = Apollo.MutationFunction<AcceptGroupInviteMutation, AcceptGroupInviteMutationVariables>;

/**
 * __useAcceptGroupInviteMutation__
 *
 * To run a mutation, you first call `useAcceptGroupInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptGroupInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptGroupInviteMutation, { data, loading, error }] = useAcceptGroupInviteMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useAcceptGroupInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptGroupInviteMutation, AcceptGroupInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptGroupInviteMutation, AcceptGroupInviteMutationVariables>(AcceptGroupInviteDocument, options);
      }
export type AcceptGroupInviteMutationHookResult = ReturnType<typeof useAcceptGroupInviteMutation>;
export type AcceptGroupInviteMutationResult = Apollo.MutationResult<AcceptGroupInviteMutation>;
export type AcceptGroupInviteMutationOptions = Apollo.BaseMutationOptions<AcceptGroupInviteMutation, AcceptGroupInviteMutationVariables>;
export const DeclineGroupInviteDocument = gql`
    mutation DeclineGroupInvite($groupId: String!) {
  declineGroupInvite(groupId: $groupId)
}
    `;
export type DeclineGroupInviteMutationFn = Apollo.MutationFunction<DeclineGroupInviteMutation, DeclineGroupInviteMutationVariables>;

/**
 * __useDeclineGroupInviteMutation__
 *
 * To run a mutation, you first call `useDeclineGroupInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineGroupInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineGroupInviteMutation, { data, loading, error }] = useDeclineGroupInviteMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDeclineGroupInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeclineGroupInviteMutation, DeclineGroupInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineGroupInviteMutation, DeclineGroupInviteMutationVariables>(DeclineGroupInviteDocument, options);
      }
export type DeclineGroupInviteMutationHookResult = ReturnType<typeof useDeclineGroupInviteMutation>;
export type DeclineGroupInviteMutationResult = Apollo.MutationResult<DeclineGroupInviteMutation>;
export type DeclineGroupInviteMutationOptions = Apollo.BaseMutationOptions<DeclineGroupInviteMutation, DeclineGroupInviteMutationVariables>;
export const MyPendingGroupInviteDocument = gql`
    query MyPendingGroupInvite($groupId: String!) {
  myPendingGroupInvite(groupId: $groupId) {
    id
    groupId
    inviterId
    inviteeEmail
    status
    expiresAt
    createdAt
    groupName
    inviter {
      id
      firstName
      lastName
      title
      profileImageUrl
      companyName
    }
  }
}
    `;

/**
 * __useMyPendingGroupInviteQuery__
 *
 * To run a query within a React component, call `useMyPendingGroupInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPendingGroupInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPendingGroupInviteQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useMyPendingGroupInviteQuery(baseOptions: Apollo.QueryHookOptions<MyPendingGroupInviteQuery, MyPendingGroupInviteQueryVariables> & ({ variables: MyPendingGroupInviteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPendingGroupInviteQuery, MyPendingGroupInviteQueryVariables>(MyPendingGroupInviteDocument, options);
      }
export function useMyPendingGroupInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPendingGroupInviteQuery, MyPendingGroupInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPendingGroupInviteQuery, MyPendingGroupInviteQueryVariables>(MyPendingGroupInviteDocument, options);
        }
// @ts-ignore
export function useMyPendingGroupInviteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyPendingGroupInviteQuery, MyPendingGroupInviteQueryVariables>): Apollo.UseSuspenseQueryResult<MyPendingGroupInviteQuery, MyPendingGroupInviteQueryVariables>;
export function useMyPendingGroupInviteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyPendingGroupInviteQuery, MyPendingGroupInviteQueryVariables>): Apollo.UseSuspenseQueryResult<MyPendingGroupInviteQuery | undefined, MyPendingGroupInviteQueryVariables>;
export function useMyPendingGroupInviteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyPendingGroupInviteQuery, MyPendingGroupInviteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyPendingGroupInviteQuery, MyPendingGroupInviteQueryVariables>(MyPendingGroupInviteDocument, options);
        }
export type MyPendingGroupInviteQueryHookResult = ReturnType<typeof useMyPendingGroupInviteQuery>;
export type MyPendingGroupInviteLazyQueryHookResult = ReturnType<typeof useMyPendingGroupInviteLazyQuery>;
export type MyPendingGroupInviteSuspenseQueryHookResult = ReturnType<typeof useMyPendingGroupInviteSuspenseQuery>;
export type MyPendingGroupInviteQueryResult = Apollo.QueryResult<MyPendingGroupInviteQuery, MyPendingGroupInviteQueryVariables>;
export const UpsertUserHeadlineDocument = gql`
    mutation UpsertUserHeadline($input: UserHeadlineInput!) {
  upsertUserHeadline(input: $input)
}
    `;
export type UpsertUserHeadlineMutationFn = Apollo.MutationFunction<UpsertUserHeadlineMutation, UpsertUserHeadlineMutationVariables>;

/**
 * __useUpsertUserHeadlineMutation__
 *
 * To run a mutation, you first call `useUpsertUserHeadlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserHeadlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserHeadlineMutation, { data, loading, error }] = useUpsertUserHeadlineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertUserHeadlineMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserHeadlineMutation, UpsertUserHeadlineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserHeadlineMutation, UpsertUserHeadlineMutationVariables>(UpsertUserHeadlineDocument, options);
      }
export type UpsertUserHeadlineMutationHookResult = ReturnType<typeof useUpsertUserHeadlineMutation>;
export type UpsertUserHeadlineMutationResult = Apollo.MutationResult<UpsertUserHeadlineMutation>;
export type UpsertUserHeadlineMutationOptions = Apollo.BaseMutationOptions<UpsertUserHeadlineMutation, UpsertUserHeadlineMutationVariables>;
export const UpdateSelectedBadgesDocument = gql`
    mutation UpdateSelectedBadges($input: UpdateSelectedBadgesInput!) {
  updateSelectedBadges(input: $input) {
    ...InfluenceBadgeFields
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;
export type UpdateSelectedBadgesMutationFn = Apollo.MutationFunction<UpdateSelectedBadgesMutation, UpdateSelectedBadgesMutationVariables>;

/**
 * __useUpdateSelectedBadgesMutation__
 *
 * To run a mutation, you first call `useUpdateSelectedBadgesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSelectedBadgesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSelectedBadgesMutation, { data, loading, error }] = useUpdateSelectedBadgesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSelectedBadgesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSelectedBadgesMutation, UpdateSelectedBadgesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSelectedBadgesMutation, UpdateSelectedBadgesMutationVariables>(UpdateSelectedBadgesDocument, options);
      }
export type UpdateSelectedBadgesMutationHookResult = ReturnType<typeof useUpdateSelectedBadgesMutation>;
export type UpdateSelectedBadgesMutationResult = Apollo.MutationResult<UpdateSelectedBadgesMutation>;
export type UpdateSelectedBadgesMutationOptions = Apollo.BaseMutationOptions<UpdateSelectedBadgesMutation, UpdateSelectedBadgesMutationVariables>;
export const SetLeaderboardVisibilityDocument = gql`
    mutation SetLeaderboardVisibility($hidden: Boolean!) {
  setLeaderboardVisibility(hidden: $hidden)
}
    `;
export type SetLeaderboardVisibilityMutationFn = Apollo.MutationFunction<SetLeaderboardVisibilityMutation, SetLeaderboardVisibilityMutationVariables>;

/**
 * __useSetLeaderboardVisibilityMutation__
 *
 * To run a mutation, you first call `useSetLeaderboardVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLeaderboardVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLeaderboardVisibilityMutation, { data, loading, error }] = useSetLeaderboardVisibilityMutation({
 *   variables: {
 *      hidden: // value for 'hidden'
 *   },
 * });
 */
export function useSetLeaderboardVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<SetLeaderboardVisibilityMutation, SetLeaderboardVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetLeaderboardVisibilityMutation, SetLeaderboardVisibilityMutationVariables>(SetLeaderboardVisibilityDocument, options);
      }
export type SetLeaderboardVisibilityMutationHookResult = ReturnType<typeof useSetLeaderboardVisibilityMutation>;
export type SetLeaderboardVisibilityMutationResult = Apollo.MutationResult<SetLeaderboardVisibilityMutation>;
export type SetLeaderboardVisibilityMutationOptions = Apollo.BaseMutationOptions<SetLeaderboardVisibilityMutation, SetLeaderboardVisibilityMutationVariables>;
export const MyInfluenceProfileDocument = gql`
    query MyInfluenceProfile {
  myInfluenceProfile {
    ...InfluenceProfileFields
    hideFromLeaderboards
  }
}
    ${InfluenceProfileFieldsFragmentDoc}`;

/**
 * __useMyInfluenceProfileQuery__
 *
 * To run a query within a React component, call `useMyInfluenceProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyInfluenceProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyInfluenceProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyInfluenceProfileQuery(baseOptions?: Apollo.QueryHookOptions<MyInfluenceProfileQuery, MyInfluenceProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyInfluenceProfileQuery, MyInfluenceProfileQueryVariables>(MyInfluenceProfileDocument, options);
      }
export function useMyInfluenceProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyInfluenceProfileQuery, MyInfluenceProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyInfluenceProfileQuery, MyInfluenceProfileQueryVariables>(MyInfluenceProfileDocument, options);
        }
// @ts-ignore
export function useMyInfluenceProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyInfluenceProfileQuery, MyInfluenceProfileQueryVariables>): Apollo.UseSuspenseQueryResult<MyInfluenceProfileQuery, MyInfluenceProfileQueryVariables>;
export function useMyInfluenceProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyInfluenceProfileQuery, MyInfluenceProfileQueryVariables>): Apollo.UseSuspenseQueryResult<MyInfluenceProfileQuery | undefined, MyInfluenceProfileQueryVariables>;
export function useMyInfluenceProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyInfluenceProfileQuery, MyInfluenceProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyInfluenceProfileQuery, MyInfluenceProfileQueryVariables>(MyInfluenceProfileDocument, options);
        }
export type MyInfluenceProfileQueryHookResult = ReturnType<typeof useMyInfluenceProfileQuery>;
export type MyInfluenceProfileLazyQueryHookResult = ReturnType<typeof useMyInfluenceProfileLazyQuery>;
export type MyInfluenceProfileSuspenseQueryHookResult = ReturnType<typeof useMyInfluenceProfileSuspenseQuery>;
export type MyInfluenceProfileQueryResult = Apollo.QueryResult<MyInfluenceProfileQuery, MyInfluenceProfileQueryVariables>;
export const InfluenceProfileDocument = gql`
    query InfluenceProfile($userId: ID!) {
  influenceProfile(userId: $userId) {
    ...InfluenceProfileFields
  }
}
    ${InfluenceProfileFieldsFragmentDoc}`;

/**
 * __useInfluenceProfileQuery__
 *
 * To run a query within a React component, call `useInfluenceProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfluenceProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfluenceProfileQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useInfluenceProfileQuery(baseOptions: Apollo.QueryHookOptions<InfluenceProfileQuery, InfluenceProfileQueryVariables> & ({ variables: InfluenceProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfluenceProfileQuery, InfluenceProfileQueryVariables>(InfluenceProfileDocument, options);
      }
export function useInfluenceProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfluenceProfileQuery, InfluenceProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfluenceProfileQuery, InfluenceProfileQueryVariables>(InfluenceProfileDocument, options);
        }
// @ts-ignore
export function useInfluenceProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfluenceProfileQuery, InfluenceProfileQueryVariables>): Apollo.UseSuspenseQueryResult<InfluenceProfileQuery, InfluenceProfileQueryVariables>;
export function useInfluenceProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfluenceProfileQuery, InfluenceProfileQueryVariables>): Apollo.UseSuspenseQueryResult<InfluenceProfileQuery | undefined, InfluenceProfileQueryVariables>;
export function useInfluenceProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfluenceProfileQuery, InfluenceProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfluenceProfileQuery, InfluenceProfileQueryVariables>(InfluenceProfileDocument, options);
        }
export type InfluenceProfileQueryHookResult = ReturnType<typeof useInfluenceProfileQuery>;
export type InfluenceProfileLazyQueryHookResult = ReturnType<typeof useInfluenceProfileLazyQuery>;
export type InfluenceProfileSuspenseQueryHookResult = ReturnType<typeof useInfluenceProfileSuspenseQuery>;
export type InfluenceProfileQueryResult = Apollo.QueryResult<InfluenceProfileQuery, InfluenceProfileQueryVariables>;
export const UserAchievementsDocument = gql`
    query UserAchievements($userId: ID!) {
  userAchievements(userId: $userId) {
    badge {
      ...InfluenceBadgeFields
    }
    target
    unlockedAt
    expiresAt
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useUserAchievementsQuery__
 *
 * To run a query within a React component, call `useUserAchievementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAchievementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAchievementsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserAchievementsQuery(baseOptions: Apollo.QueryHookOptions<UserAchievementsQuery, UserAchievementsQueryVariables> & ({ variables: UserAchievementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAchievementsQuery, UserAchievementsQueryVariables>(UserAchievementsDocument, options);
      }
export function useUserAchievementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAchievementsQuery, UserAchievementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAchievementsQuery, UserAchievementsQueryVariables>(UserAchievementsDocument, options);
        }
// @ts-ignore
export function useUserAchievementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserAchievementsQuery, UserAchievementsQueryVariables>): Apollo.UseSuspenseQueryResult<UserAchievementsQuery, UserAchievementsQueryVariables>;
export function useUserAchievementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserAchievementsQuery, UserAchievementsQueryVariables>): Apollo.UseSuspenseQueryResult<UserAchievementsQuery | undefined, UserAchievementsQueryVariables>;
export function useUserAchievementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserAchievementsQuery, UserAchievementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserAchievementsQuery, UserAchievementsQueryVariables>(UserAchievementsDocument, options);
        }
export type UserAchievementsQueryHookResult = ReturnType<typeof useUserAchievementsQuery>;
export type UserAchievementsLazyQueryHookResult = ReturnType<typeof useUserAchievementsLazyQuery>;
export type UserAchievementsSuspenseQueryHookResult = ReturnType<typeof useUserAchievementsSuspenseQuery>;
export type UserAchievementsQueryResult = Apollo.QueryResult<UserAchievementsQuery, UserAchievementsQueryVariables>;
export const MyAchievementProgressDocument = gql`
    query MyAchievementProgress {
  myAchievementProgress {
    ...InfluenceProgressFields
  }
}
    ${InfluenceProgressFieldsFragmentDoc}`;

/**
 * __useMyAchievementProgressQuery__
 *
 * To run a query within a React component, call `useMyAchievementProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAchievementProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAchievementProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAchievementProgressQuery(baseOptions?: Apollo.QueryHookOptions<MyAchievementProgressQuery, MyAchievementProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAchievementProgressQuery, MyAchievementProgressQueryVariables>(MyAchievementProgressDocument, options);
      }
export function useMyAchievementProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAchievementProgressQuery, MyAchievementProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAchievementProgressQuery, MyAchievementProgressQueryVariables>(MyAchievementProgressDocument, options);
        }
// @ts-ignore
export function useMyAchievementProgressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyAchievementProgressQuery, MyAchievementProgressQueryVariables>): Apollo.UseSuspenseQueryResult<MyAchievementProgressQuery, MyAchievementProgressQueryVariables>;
export function useMyAchievementProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAchievementProgressQuery, MyAchievementProgressQueryVariables>): Apollo.UseSuspenseQueryResult<MyAchievementProgressQuery | undefined, MyAchievementProgressQueryVariables>;
export function useMyAchievementProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAchievementProgressQuery, MyAchievementProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyAchievementProgressQuery, MyAchievementProgressQueryVariables>(MyAchievementProgressDocument, options);
        }
export type MyAchievementProgressQueryHookResult = ReturnType<typeof useMyAchievementProgressQuery>;
export type MyAchievementProgressLazyQueryHookResult = ReturnType<typeof useMyAchievementProgressLazyQuery>;
export type MyAchievementProgressSuspenseQueryHookResult = ReturnType<typeof useMyAchievementProgressSuspenseQuery>;
export type MyAchievementProgressQueryResult = Apollo.QueryResult<MyAchievementProgressQuery, MyAchievementProgressQueryVariables>;
export const LeaderboardDocument = gql`
    query Leaderboard($input: LeaderboardInput!) {
  leaderboard(input: $input) {
    category
    periodKey
    total
    page
    limit
    hasMore
    me {
      rank
      score
    }
    entries {
      rank
      userId
      score
      isCurrentUser
      user {
        id
        firstName
        middleName
        lastName
        title
        role
        profileImageUrl
        companyName
      }
    }
  }
}
    `;

/**
 * __useLeaderboardQuery__
 *
 * To run a query within a React component, call `useLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaderboardQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLeaderboardQuery(baseOptions: Apollo.QueryHookOptions<LeaderboardQuery, LeaderboardQueryVariables> & ({ variables: LeaderboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaderboardQuery, LeaderboardQueryVariables>(LeaderboardDocument, options);
      }
export function useLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaderboardQuery, LeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaderboardQuery, LeaderboardQueryVariables>(LeaderboardDocument, options);
        }
// @ts-ignore
export function useLeaderboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LeaderboardQuery, LeaderboardQueryVariables>): Apollo.UseSuspenseQueryResult<LeaderboardQuery, LeaderboardQueryVariables>;
export function useLeaderboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeaderboardQuery, LeaderboardQueryVariables>): Apollo.UseSuspenseQueryResult<LeaderboardQuery | undefined, LeaderboardQueryVariables>;
export function useLeaderboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeaderboardQuery, LeaderboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeaderboardQuery, LeaderboardQueryVariables>(LeaderboardDocument, options);
        }
export type LeaderboardQueryHookResult = ReturnType<typeof useLeaderboardQuery>;
export type LeaderboardLazyQueryHookResult = ReturnType<typeof useLeaderboardLazyQuery>;
export type LeaderboardSuspenseQueryHookResult = ReturnType<typeof useLeaderboardSuspenseQuery>;
export type LeaderboardQueryResult = Apollo.QueryResult<LeaderboardQuery, LeaderboardQueryVariables>;
export const InitializeSessionPaymentDocument = gql`
    mutation InitializeSessionPayment($input: InitializeSessionPaymentInput!) {
  initializeSessionPayment(input: $input) {
    clientSecret
    paymentIntentId
    amount
    currency
    publishableKey
  }
}
    `;
export type InitializeSessionPaymentMutationFn = Apollo.MutationFunction<InitializeSessionPaymentMutation, InitializeSessionPaymentMutationVariables>;

/**
 * __useInitializeSessionPaymentMutation__
 *
 * To run a mutation, you first call `useInitializeSessionPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeSessionPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeSessionPaymentMutation, { data, loading, error }] = useInitializeSessionPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitializeSessionPaymentMutation(baseOptions?: Apollo.MutationHookOptions<InitializeSessionPaymentMutation, InitializeSessionPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitializeSessionPaymentMutation, InitializeSessionPaymentMutationVariables>(InitializeSessionPaymentDocument, options);
      }
export type InitializeSessionPaymentMutationHookResult = ReturnType<typeof useInitializeSessionPaymentMutation>;
export type InitializeSessionPaymentMutationResult = Apollo.MutationResult<InitializeSessionPaymentMutation>;
export type InitializeSessionPaymentMutationOptions = Apollo.BaseMutationOptions<InitializeSessionPaymentMutation, InitializeSessionPaymentMutationVariables>;
export const UpdateIsHiringDocument = gql`
    mutation UpdateIsHiring($isHiring: Boolean!) {
  updateIsHiring(isHiring: $isHiring)
}
    `;
export type UpdateIsHiringMutationFn = Apollo.MutationFunction<UpdateIsHiringMutation, UpdateIsHiringMutationVariables>;

/**
 * __useUpdateIsHiringMutation__
 *
 * To run a mutation, you first call `useUpdateIsHiringMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIsHiringMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIsHiringMutation, { data, loading, error }] = useUpdateIsHiringMutation({
 *   variables: {
 *      isHiring: // value for 'isHiring'
 *   },
 * });
 */
export function useUpdateIsHiringMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIsHiringMutation, UpdateIsHiringMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIsHiringMutation, UpdateIsHiringMutationVariables>(UpdateIsHiringDocument, options);
      }
export type UpdateIsHiringMutationHookResult = ReturnType<typeof useUpdateIsHiringMutation>;
export type UpdateIsHiringMutationResult = Apollo.MutationResult<UpdateIsHiringMutation>;
export type UpdateIsHiringMutationOptions = Apollo.BaseMutationOptions<UpdateIsHiringMutation, UpdateIsHiringMutationVariables>;
export const GetIsHiringDocument = gql`
    query GetIsHiring {
  getIsHiring
}
    `;

/**
 * __useGetIsHiringQuery__
 *
 * To run a query within a React component, call `useGetIsHiringQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsHiringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsHiringQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIsHiringQuery(baseOptions?: Apollo.QueryHookOptions<GetIsHiringQuery, GetIsHiringQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIsHiringQuery, GetIsHiringQueryVariables>(GetIsHiringDocument, options);
      }
export function useGetIsHiringLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIsHiringQuery, GetIsHiringQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIsHiringQuery, GetIsHiringQueryVariables>(GetIsHiringDocument, options);
        }
// @ts-ignore
export function useGetIsHiringSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIsHiringQuery, GetIsHiringQueryVariables>): Apollo.UseSuspenseQueryResult<GetIsHiringQuery, GetIsHiringQueryVariables>;
export function useGetIsHiringSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIsHiringQuery, GetIsHiringQueryVariables>): Apollo.UseSuspenseQueryResult<GetIsHiringQuery | undefined, GetIsHiringQueryVariables>;
export function useGetIsHiringSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIsHiringQuery, GetIsHiringQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIsHiringQuery, GetIsHiringQueryVariables>(GetIsHiringDocument, options);
        }
export type GetIsHiringQueryHookResult = ReturnType<typeof useGetIsHiringQuery>;
export type GetIsHiringLazyQueryHookResult = ReturnType<typeof useGetIsHiringLazyQuery>;
export type GetIsHiringSuspenseQueryHookResult = ReturnType<typeof useGetIsHiringSuspenseQuery>;
export type GetIsHiringQueryResult = Apollo.QueryResult<GetIsHiringQuery, GetIsHiringQueryVariables>;
export const JobsDocument = gql`
    query Jobs($input: JobsFilterInput) {
  jobs(input: $input) {
    items {
      id
      roleNeeded
      companyName
      location
      createdAt
      applyUrl
    }
    page
    limit
    total
    totalPages
    hasMore
  }
}
    `;

/**
 * __useJobsQuery__
 *
 * To run a query within a React component, call `useJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobsQuery(baseOptions?: Apollo.QueryHookOptions<JobsQuery, JobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobsQuery, JobsQueryVariables>(JobsDocument, options);
      }
export function useJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobsQuery, JobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobsQuery, JobsQueryVariables>(JobsDocument, options);
        }
// @ts-ignore
export function useJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobsQuery, JobsQueryVariables>): Apollo.UseSuspenseQueryResult<JobsQuery, JobsQueryVariables>;
export function useJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobsQuery, JobsQueryVariables>): Apollo.UseSuspenseQueryResult<JobsQuery | undefined, JobsQueryVariables>;
export function useJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobsQuery, JobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobsQuery, JobsQueryVariables>(JobsDocument, options);
        }
export type JobsQueryHookResult = ReturnType<typeof useJobsQuery>;
export type JobsLazyQueryHookResult = ReturnType<typeof useJobsLazyQuery>;
export type JobsSuspenseQueryHookResult = ReturnType<typeof useJobsSuspenseQuery>;
export type JobsQueryResult = Apollo.QueryResult<JobsQuery, JobsQueryVariables>;
export const JobDocument = gql`
    query Job($id: ID!) {
  job(id: $id) {
    id
    roleNeeded
    companyName
    location
    createdAt
    applyUrl
    status
    roleType
    specialty
    headcount
    additionalLocations
    employmentType
    workerClassification
    requiredDaysHours
    startDate
    annualCompMin
    annualCompMax
    guaranteedDailyRate
    guaranteeType
    productionPercentage
    upsideBasis
    labFeeResponsibility
    tieredCommission
    dailyProductionGoal
    benefits
    yearsOfExperience
    experienceLevel
    requiredProcedures
    microscopeUse
    requiredLicenses
    nonNegotiableAvailability
    openToMentoring
    challenge
    officeDescription
    whyAttractive
    neighborhoodDescription
    techLevel
    majorEquipment
    specialistCaseVolume
  }
}
    `;

/**
 * __useJobQuery__
 *
 * To run a query within a React component, call `useJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobQuery(baseOptions: Apollo.QueryHookOptions<JobQuery, JobQueryVariables> & ({ variables: JobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobQuery, JobQueryVariables>(JobDocument, options);
      }
export function useJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobQuery, JobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobQuery, JobQueryVariables>(JobDocument, options);
        }
// @ts-ignore
export function useJobSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobQuery, JobQueryVariables>): Apollo.UseSuspenseQueryResult<JobQuery, JobQueryVariables>;
export function useJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobQuery, JobQueryVariables>): Apollo.UseSuspenseQueryResult<JobQuery | undefined, JobQueryVariables>;
export function useJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobQuery, JobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobQuery, JobQueryVariables>(JobDocument, options);
        }
export type JobQueryHookResult = ReturnType<typeof useJobQuery>;
export type JobLazyQueryHookResult = ReturnType<typeof useJobLazyQuery>;
export type JobSuspenseQueryHookResult = ReturnType<typeof useJobSuspenseQuery>;
export type JobQueryResult = Apollo.QueryResult<JobQuery, JobQueryVariables>;
export const JobFilterOptionsDocument = gql`
    query JobFilterOptions {
  jobFilterOptions {
    roleTypes {
      value
      label
    }
    specialties {
      value
      label
    }
    employmentTypes {
      value
      label
    }
    yearsOfExperience {
      value
      label
    }
    sort {
      value
      label
    }
  }
}
    `;

/**
 * __useJobFilterOptionsQuery__
 *
 * To run a query within a React component, call `useJobFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useJobFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<JobFilterOptionsQuery, JobFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobFilterOptionsQuery, JobFilterOptionsQueryVariables>(JobFilterOptionsDocument, options);
      }
export function useJobFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobFilterOptionsQuery, JobFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobFilterOptionsQuery, JobFilterOptionsQueryVariables>(JobFilterOptionsDocument, options);
        }
// @ts-ignore
export function useJobFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobFilterOptionsQuery, JobFilterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<JobFilterOptionsQuery, JobFilterOptionsQueryVariables>;
export function useJobFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobFilterOptionsQuery, JobFilterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<JobFilterOptionsQuery | undefined, JobFilterOptionsQueryVariables>;
export function useJobFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobFilterOptionsQuery, JobFilterOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobFilterOptionsQuery, JobFilterOptionsQueryVariables>(JobFilterOptionsDocument, options);
        }
export type JobFilterOptionsQueryHookResult = ReturnType<typeof useJobFilterOptionsQuery>;
export type JobFilterOptionsLazyQueryHookResult = ReturnType<typeof useJobFilterOptionsLazyQuery>;
export type JobFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useJobFilterOptionsSuspenseQuery>;
export type JobFilterOptionsQueryResult = Apollo.QueryResult<JobFilterOptionsQuery, JobFilterOptionsQueryVariables>;
export const SaveLibraryItemDocument = gql`
    mutation SaveLibraryItem($input: SaveLibraryItemInput!) {
  saveLibraryItem(input: $input) {
    ...LibraryItemFields
  }
}
    ${LibraryItemFieldsFragmentDoc}`;
export type SaveLibraryItemMutationFn = Apollo.MutationFunction<SaveLibraryItemMutation, SaveLibraryItemMutationVariables>;

/**
 * __useSaveLibraryItemMutation__
 *
 * To run a mutation, you first call `useSaveLibraryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLibraryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLibraryItemMutation, { data, loading, error }] = useSaveLibraryItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLibraryItemMutation(baseOptions?: Apollo.MutationHookOptions<SaveLibraryItemMutation, SaveLibraryItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveLibraryItemMutation, SaveLibraryItemMutationVariables>(SaveLibraryItemDocument, options);
      }
export type SaveLibraryItemMutationHookResult = ReturnType<typeof useSaveLibraryItemMutation>;
export type SaveLibraryItemMutationResult = Apollo.MutationResult<SaveLibraryItemMutation>;
export type SaveLibraryItemMutationOptions = Apollo.BaseMutationOptions<SaveLibraryItemMutation, SaveLibraryItemMutationVariables>;
export const UnsaveLibraryItemDocument = gql`
    mutation UnsaveLibraryItem($itemId: ID!) {
  unsaveLibraryItem(itemId: $itemId)
}
    `;
export type UnsaveLibraryItemMutationFn = Apollo.MutationFunction<UnsaveLibraryItemMutation, UnsaveLibraryItemMutationVariables>;

/**
 * __useUnsaveLibraryItemMutation__
 *
 * To run a mutation, you first call `useUnsaveLibraryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsaveLibraryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsaveLibraryItemMutation, { data, loading, error }] = useUnsaveLibraryItemMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useUnsaveLibraryItemMutation(baseOptions?: Apollo.MutationHookOptions<UnsaveLibraryItemMutation, UnsaveLibraryItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsaveLibraryItemMutation, UnsaveLibraryItemMutationVariables>(UnsaveLibraryItemDocument, options);
      }
export type UnsaveLibraryItemMutationHookResult = ReturnType<typeof useUnsaveLibraryItemMutation>;
export type UnsaveLibraryItemMutationResult = Apollo.MutationResult<UnsaveLibraryItemMutation>;
export type UnsaveLibraryItemMutationOptions = Apollo.BaseMutationOptions<UnsaveLibraryItemMutation, UnsaveLibraryItemMutationVariables>;
export const ToggleLibraryFavoriteDocument = gql`
    mutation ToggleLibraryFavorite($itemId: ID!, $isFavorite: Boolean) {
  toggleLibraryFavorite(itemId: $itemId, isFavorite: $isFavorite) {
    id
    isFavorite
  }
}
    `;
export type ToggleLibraryFavoriteMutationFn = Apollo.MutationFunction<ToggleLibraryFavoriteMutation, ToggleLibraryFavoriteMutationVariables>;

/**
 * __useToggleLibraryFavoriteMutation__
 *
 * To run a mutation, you first call `useToggleLibraryFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleLibraryFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleLibraryFavoriteMutation, { data, loading, error }] = useToggleLibraryFavoriteMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *      isFavorite: // value for 'isFavorite'
 *   },
 * });
 */
export function useToggleLibraryFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<ToggleLibraryFavoriteMutation, ToggleLibraryFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleLibraryFavoriteMutation, ToggleLibraryFavoriteMutationVariables>(ToggleLibraryFavoriteDocument, options);
      }
export type ToggleLibraryFavoriteMutationHookResult = ReturnType<typeof useToggleLibraryFavoriteMutation>;
export type ToggleLibraryFavoriteMutationResult = Apollo.MutationResult<ToggleLibraryFavoriteMutation>;
export type ToggleLibraryFavoriteMutationOptions = Apollo.BaseMutationOptions<ToggleLibraryFavoriteMutation, ToggleLibraryFavoriteMutationVariables>;
export const CreateLibraryFolderDocument = gql`
    mutation CreateLibraryFolder($input: CreateLibraryFolderInput!) {
  createLibraryFolder(input: $input) {
    ...LibraryFolderFields
  }
}
    ${LibraryFolderFieldsFragmentDoc}`;
export type CreateLibraryFolderMutationFn = Apollo.MutationFunction<CreateLibraryFolderMutation, CreateLibraryFolderMutationVariables>;

/**
 * __useCreateLibraryFolderMutation__
 *
 * To run a mutation, you first call `useCreateLibraryFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryFolderMutation, { data, loading, error }] = useCreateLibraryFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLibraryFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateLibraryFolderMutation, CreateLibraryFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLibraryFolderMutation, CreateLibraryFolderMutationVariables>(CreateLibraryFolderDocument, options);
      }
export type CreateLibraryFolderMutationHookResult = ReturnType<typeof useCreateLibraryFolderMutation>;
export type CreateLibraryFolderMutationResult = Apollo.MutationResult<CreateLibraryFolderMutation>;
export type CreateLibraryFolderMutationOptions = Apollo.BaseMutationOptions<CreateLibraryFolderMutation, CreateLibraryFolderMutationVariables>;
export const UpdateLibraryFolderDocument = gql`
    mutation UpdateLibraryFolder($input: UpdateLibraryFolderInput!) {
  updateLibraryFolder(input: $input) {
    ...LibraryFolderFields
  }
}
    ${LibraryFolderFieldsFragmentDoc}`;
export type UpdateLibraryFolderMutationFn = Apollo.MutationFunction<UpdateLibraryFolderMutation, UpdateLibraryFolderMutationVariables>;

/**
 * __useUpdateLibraryFolderMutation__
 *
 * To run a mutation, you first call `useUpdateLibraryFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLibraryFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLibraryFolderMutation, { data, loading, error }] = useUpdateLibraryFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLibraryFolderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLibraryFolderMutation, UpdateLibraryFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLibraryFolderMutation, UpdateLibraryFolderMutationVariables>(UpdateLibraryFolderDocument, options);
      }
export type UpdateLibraryFolderMutationHookResult = ReturnType<typeof useUpdateLibraryFolderMutation>;
export type UpdateLibraryFolderMutationResult = Apollo.MutationResult<UpdateLibraryFolderMutation>;
export type UpdateLibraryFolderMutationOptions = Apollo.BaseMutationOptions<UpdateLibraryFolderMutation, UpdateLibraryFolderMutationVariables>;
export const MoveLibraryFolderDocument = gql`
    mutation MoveLibraryFolder($input: MoveLibraryFolderInput!) {
  moveLibraryFolder(input: $input) {
    ...LibraryFolderFields
  }
}
    ${LibraryFolderFieldsFragmentDoc}`;
export type MoveLibraryFolderMutationFn = Apollo.MutationFunction<MoveLibraryFolderMutation, MoveLibraryFolderMutationVariables>;

/**
 * __useMoveLibraryFolderMutation__
 *
 * To run a mutation, you first call `useMoveLibraryFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveLibraryFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveLibraryFolderMutation, { data, loading, error }] = useMoveLibraryFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveLibraryFolderMutation(baseOptions?: Apollo.MutationHookOptions<MoveLibraryFolderMutation, MoveLibraryFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveLibraryFolderMutation, MoveLibraryFolderMutationVariables>(MoveLibraryFolderDocument, options);
      }
export type MoveLibraryFolderMutationHookResult = ReturnType<typeof useMoveLibraryFolderMutation>;
export type MoveLibraryFolderMutationResult = Apollo.MutationResult<MoveLibraryFolderMutation>;
export type MoveLibraryFolderMutationOptions = Apollo.BaseMutationOptions<MoveLibraryFolderMutation, MoveLibraryFolderMutationVariables>;
export const DeleteLibraryFolderDocument = gql`
    mutation DeleteLibraryFolder($id: ID!) {
  deleteLibraryFolder(id: $id)
}
    `;
export type DeleteLibraryFolderMutationFn = Apollo.MutationFunction<DeleteLibraryFolderMutation, DeleteLibraryFolderMutationVariables>;

/**
 * __useDeleteLibraryFolderMutation__
 *
 * To run a mutation, you first call `useDeleteLibraryFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibraryFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibraryFolderMutation, { data, loading, error }] = useDeleteLibraryFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLibraryFolderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLibraryFolderMutation, DeleteLibraryFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLibraryFolderMutation, DeleteLibraryFolderMutationVariables>(DeleteLibraryFolderDocument, options);
      }
export type DeleteLibraryFolderMutationHookResult = ReturnType<typeof useDeleteLibraryFolderMutation>;
export type DeleteLibraryFolderMutationResult = Apollo.MutationResult<DeleteLibraryFolderMutation>;
export type DeleteLibraryFolderMutationOptions = Apollo.BaseMutationOptions<DeleteLibraryFolderMutation, DeleteLibraryFolderMutationVariables>;
export const RestoreLibraryFolderDocument = gql`
    mutation RestoreLibraryFolder($id: ID!) {
  restoreLibraryFolder(id: $id) {
    ...LibraryFolderFields
  }
}
    ${LibraryFolderFieldsFragmentDoc}`;
export type RestoreLibraryFolderMutationFn = Apollo.MutationFunction<RestoreLibraryFolderMutation, RestoreLibraryFolderMutationVariables>;

/**
 * __useRestoreLibraryFolderMutation__
 *
 * To run a mutation, you first call `useRestoreLibraryFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreLibraryFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreLibraryFolderMutation, { data, loading, error }] = useRestoreLibraryFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreLibraryFolderMutation(baseOptions?: Apollo.MutationHookOptions<RestoreLibraryFolderMutation, RestoreLibraryFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreLibraryFolderMutation, RestoreLibraryFolderMutationVariables>(RestoreLibraryFolderDocument, options);
      }
export type RestoreLibraryFolderMutationHookResult = ReturnType<typeof useRestoreLibraryFolderMutation>;
export type RestoreLibraryFolderMutationResult = Apollo.MutationResult<RestoreLibraryFolderMutation>;
export type RestoreLibraryFolderMutationOptions = Apollo.BaseMutationOptions<RestoreLibraryFolderMutation, RestoreLibraryFolderMutationVariables>;
export const RestoreLibraryCollectionDocument = gql`
    mutation RestoreLibraryCollection($id: ID!) {
  restoreLibraryCollection(id: $id) {
    ...LibraryCollectionFields
  }
}
    ${LibraryCollectionFieldsFragmentDoc}`;
export type RestoreLibraryCollectionMutationFn = Apollo.MutationFunction<RestoreLibraryCollectionMutation, RestoreLibraryCollectionMutationVariables>;

/**
 * __useRestoreLibraryCollectionMutation__
 *
 * To run a mutation, you first call `useRestoreLibraryCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreLibraryCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreLibraryCollectionMutation, { data, loading, error }] = useRestoreLibraryCollectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreLibraryCollectionMutation(baseOptions?: Apollo.MutationHookOptions<RestoreLibraryCollectionMutation, RestoreLibraryCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreLibraryCollectionMutation, RestoreLibraryCollectionMutationVariables>(RestoreLibraryCollectionDocument, options);
      }
export type RestoreLibraryCollectionMutationHookResult = ReturnType<typeof useRestoreLibraryCollectionMutation>;
export type RestoreLibraryCollectionMutationResult = Apollo.MutationResult<RestoreLibraryCollectionMutation>;
export type RestoreLibraryCollectionMutationOptions = Apollo.BaseMutationOptions<RestoreLibraryCollectionMutation, RestoreLibraryCollectionMutationVariables>;
export const CreateLibraryCollectionDocument = gql`
    mutation CreateLibraryCollection($input: CreateLibraryCollectionInput!) {
  createLibraryCollection(input: $input) {
    ...LibraryCollectionFields
  }
}
    ${LibraryCollectionFieldsFragmentDoc}`;
export type CreateLibraryCollectionMutationFn = Apollo.MutationFunction<CreateLibraryCollectionMutation, CreateLibraryCollectionMutationVariables>;

/**
 * __useCreateLibraryCollectionMutation__
 *
 * To run a mutation, you first call `useCreateLibraryCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryCollectionMutation, { data, loading, error }] = useCreateLibraryCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLibraryCollectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateLibraryCollectionMutation, CreateLibraryCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLibraryCollectionMutation, CreateLibraryCollectionMutationVariables>(CreateLibraryCollectionDocument, options);
      }
export type CreateLibraryCollectionMutationHookResult = ReturnType<typeof useCreateLibraryCollectionMutation>;
export type CreateLibraryCollectionMutationResult = Apollo.MutationResult<CreateLibraryCollectionMutation>;
export type CreateLibraryCollectionMutationOptions = Apollo.BaseMutationOptions<CreateLibraryCollectionMutation, CreateLibraryCollectionMutationVariables>;
export const UpdateLibraryCollectionDocument = gql`
    mutation UpdateLibraryCollection($input: UpdateLibraryCollectionInput!) {
  updateLibraryCollection(input: $input) {
    ...LibraryCollectionFields
  }
}
    ${LibraryCollectionFieldsFragmentDoc}`;
export type UpdateLibraryCollectionMutationFn = Apollo.MutationFunction<UpdateLibraryCollectionMutation, UpdateLibraryCollectionMutationVariables>;

/**
 * __useUpdateLibraryCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateLibraryCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLibraryCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLibraryCollectionMutation, { data, loading, error }] = useUpdateLibraryCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLibraryCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLibraryCollectionMutation, UpdateLibraryCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLibraryCollectionMutation, UpdateLibraryCollectionMutationVariables>(UpdateLibraryCollectionDocument, options);
      }
export type UpdateLibraryCollectionMutationHookResult = ReturnType<typeof useUpdateLibraryCollectionMutation>;
export type UpdateLibraryCollectionMutationResult = Apollo.MutationResult<UpdateLibraryCollectionMutation>;
export type UpdateLibraryCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateLibraryCollectionMutation, UpdateLibraryCollectionMutationVariables>;
export const DeleteLibraryCollectionDocument = gql`
    mutation DeleteLibraryCollection($id: ID!) {
  deleteLibraryCollection(id: $id)
}
    `;
export type DeleteLibraryCollectionMutationFn = Apollo.MutationFunction<DeleteLibraryCollectionMutation, DeleteLibraryCollectionMutationVariables>;

/**
 * __useDeleteLibraryCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteLibraryCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibraryCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibraryCollectionMutation, { data, loading, error }] = useDeleteLibraryCollectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLibraryCollectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLibraryCollectionMutation, DeleteLibraryCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLibraryCollectionMutation, DeleteLibraryCollectionMutationVariables>(DeleteLibraryCollectionDocument, options);
      }
export type DeleteLibraryCollectionMutationHookResult = ReturnType<typeof useDeleteLibraryCollectionMutation>;
export type DeleteLibraryCollectionMutationResult = Apollo.MutationResult<DeleteLibraryCollectionMutation>;
export type DeleteLibraryCollectionMutationOptions = Apollo.BaseMutationOptions<DeleteLibraryCollectionMutation, DeleteLibraryCollectionMutationVariables>;
export const AddLibraryEntryDocument = gql`
    mutation AddLibraryEntry($input: LibraryEntryInput!) {
  addLibraryEntry(input: $input) {
    ...LibraryEntryFields
  }
}
    ${LibraryEntryFieldsFragmentDoc}`;
export type AddLibraryEntryMutationFn = Apollo.MutationFunction<AddLibraryEntryMutation, AddLibraryEntryMutationVariables>;

/**
 * __useAddLibraryEntryMutation__
 *
 * To run a mutation, you first call `useAddLibraryEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLibraryEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLibraryEntryMutation, { data, loading, error }] = useAddLibraryEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLibraryEntryMutation(baseOptions?: Apollo.MutationHookOptions<AddLibraryEntryMutation, AddLibraryEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLibraryEntryMutation, AddLibraryEntryMutationVariables>(AddLibraryEntryDocument, options);
      }
export type AddLibraryEntryMutationHookResult = ReturnType<typeof useAddLibraryEntryMutation>;
export type AddLibraryEntryMutationResult = Apollo.MutationResult<AddLibraryEntryMutation>;
export type AddLibraryEntryMutationOptions = Apollo.BaseMutationOptions<AddLibraryEntryMutation, AddLibraryEntryMutationVariables>;
export const RemoveLibraryEntryDocument = gql`
    mutation RemoveLibraryEntry($input: LibraryEntryInput!) {
  removeLibraryEntry(input: $input)
}
    `;
export type RemoveLibraryEntryMutationFn = Apollo.MutationFunction<RemoveLibraryEntryMutation, RemoveLibraryEntryMutationVariables>;

/**
 * __useRemoveLibraryEntryMutation__
 *
 * To run a mutation, you first call `useRemoveLibraryEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLibraryEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLibraryEntryMutation, { data, loading, error }] = useRemoveLibraryEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveLibraryEntryMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLibraryEntryMutation, RemoveLibraryEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLibraryEntryMutation, RemoveLibraryEntryMutationVariables>(RemoveLibraryEntryDocument, options);
      }
export type RemoveLibraryEntryMutationHookResult = ReturnType<typeof useRemoveLibraryEntryMutation>;
export type RemoveLibraryEntryMutationResult = Apollo.MutationResult<RemoveLibraryEntryMutation>;
export type RemoveLibraryEntryMutationOptions = Apollo.BaseMutationOptions<RemoveLibraryEntryMutation, RemoveLibraryEntryMutationVariables>;
export const MoveLibraryItemDocument = gql`
    mutation MoveLibraryItem($input: MoveLibraryItemInput!) {
  moveLibraryItem(input: $input)
}
    `;
export type MoveLibraryItemMutationFn = Apollo.MutationFunction<MoveLibraryItemMutation, MoveLibraryItemMutationVariables>;

/**
 * __useMoveLibraryItemMutation__
 *
 * To run a mutation, you first call `useMoveLibraryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveLibraryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveLibraryItemMutation, { data, loading, error }] = useMoveLibraryItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveLibraryItemMutation(baseOptions?: Apollo.MutationHookOptions<MoveLibraryItemMutation, MoveLibraryItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveLibraryItemMutation, MoveLibraryItemMutationVariables>(MoveLibraryItemDocument, options);
      }
export type MoveLibraryItemMutationHookResult = ReturnType<typeof useMoveLibraryItemMutation>;
export type MoveLibraryItemMutationResult = Apollo.MutationResult<MoveLibraryItemMutation>;
export type MoveLibraryItemMutationOptions = Apollo.BaseMutationOptions<MoveLibraryItemMutation, MoveLibraryItemMutationVariables>;
export const ReorderLibraryCollectionItemsDocument = gql`
    mutation ReorderLibraryCollectionItems($input: ReorderLibraryCollectionInput!) {
  reorderLibraryCollectionItems(input: $input)
}
    `;
export type ReorderLibraryCollectionItemsMutationFn = Apollo.MutationFunction<ReorderLibraryCollectionItemsMutation, ReorderLibraryCollectionItemsMutationVariables>;

/**
 * __useReorderLibraryCollectionItemsMutation__
 *
 * To run a mutation, you first call `useReorderLibraryCollectionItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderLibraryCollectionItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderLibraryCollectionItemsMutation, { data, loading, error }] = useReorderLibraryCollectionItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderLibraryCollectionItemsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderLibraryCollectionItemsMutation, ReorderLibraryCollectionItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderLibraryCollectionItemsMutation, ReorderLibraryCollectionItemsMutationVariables>(ReorderLibraryCollectionItemsDocument, options);
      }
export type ReorderLibraryCollectionItemsMutationHookResult = ReturnType<typeof useReorderLibraryCollectionItemsMutation>;
export type ReorderLibraryCollectionItemsMutationResult = Apollo.MutationResult<ReorderLibraryCollectionItemsMutation>;
export type ReorderLibraryCollectionItemsMutationOptions = Apollo.BaseMutationOptions<ReorderLibraryCollectionItemsMutation, ReorderLibraryCollectionItemsMutationVariables>;
export const CreateLibraryTagDocument = gql`
    mutation CreateLibraryTag($input: CreateLibraryTagInput!) {
  createLibraryTag(input: $input) {
    id
    name
    itemCount
  }
}
    `;
export type CreateLibraryTagMutationFn = Apollo.MutationFunction<CreateLibraryTagMutation, CreateLibraryTagMutationVariables>;

/**
 * __useCreateLibraryTagMutation__
 *
 * To run a mutation, you first call `useCreateLibraryTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryTagMutation, { data, loading, error }] = useCreateLibraryTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLibraryTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateLibraryTagMutation, CreateLibraryTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLibraryTagMutation, CreateLibraryTagMutationVariables>(CreateLibraryTagDocument, options);
      }
export type CreateLibraryTagMutationHookResult = ReturnType<typeof useCreateLibraryTagMutation>;
export type CreateLibraryTagMutationResult = Apollo.MutationResult<CreateLibraryTagMutation>;
export type CreateLibraryTagMutationOptions = Apollo.BaseMutationOptions<CreateLibraryTagMutation, CreateLibraryTagMutationVariables>;
export const UpdateLibraryTagDocument = gql`
    mutation UpdateLibraryTag($input: UpdateLibraryTagInput!) {
  updateLibraryTag(input: $input) {
    id
    name
  }
}
    `;
export type UpdateLibraryTagMutationFn = Apollo.MutationFunction<UpdateLibraryTagMutation, UpdateLibraryTagMutationVariables>;

/**
 * __useUpdateLibraryTagMutation__
 *
 * To run a mutation, you first call `useUpdateLibraryTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLibraryTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLibraryTagMutation, { data, loading, error }] = useUpdateLibraryTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLibraryTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLibraryTagMutation, UpdateLibraryTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLibraryTagMutation, UpdateLibraryTagMutationVariables>(UpdateLibraryTagDocument, options);
      }
export type UpdateLibraryTagMutationHookResult = ReturnType<typeof useUpdateLibraryTagMutation>;
export type UpdateLibraryTagMutationResult = Apollo.MutationResult<UpdateLibraryTagMutation>;
export type UpdateLibraryTagMutationOptions = Apollo.BaseMutationOptions<UpdateLibraryTagMutation, UpdateLibraryTagMutationVariables>;
export const DeleteLibraryTagDocument = gql`
    mutation DeleteLibraryTag($id: ID!) {
  deleteLibraryTag(id: $id)
}
    `;
export type DeleteLibraryTagMutationFn = Apollo.MutationFunction<DeleteLibraryTagMutation, DeleteLibraryTagMutationVariables>;

/**
 * __useDeleteLibraryTagMutation__
 *
 * To run a mutation, you first call `useDeleteLibraryTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibraryTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibraryTagMutation, { data, loading, error }] = useDeleteLibraryTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLibraryTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLibraryTagMutation, DeleteLibraryTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLibraryTagMutation, DeleteLibraryTagMutationVariables>(DeleteLibraryTagDocument, options);
      }
export type DeleteLibraryTagMutationHookResult = ReturnType<typeof useDeleteLibraryTagMutation>;
export type DeleteLibraryTagMutationResult = Apollo.MutationResult<DeleteLibraryTagMutation>;
export type DeleteLibraryTagMutationOptions = Apollo.BaseMutationOptions<DeleteLibraryTagMutation, DeleteLibraryTagMutationVariables>;
export const AddLibraryItemTagDocument = gql`
    mutation AddLibraryItemTag($input: LibraryItemTagInput!) {
  addLibraryItemTag(input: $input) {
    ...LibraryItemFields
  }
}
    ${LibraryItemFieldsFragmentDoc}`;
export type AddLibraryItemTagMutationFn = Apollo.MutationFunction<AddLibraryItemTagMutation, AddLibraryItemTagMutationVariables>;

/**
 * __useAddLibraryItemTagMutation__
 *
 * To run a mutation, you first call `useAddLibraryItemTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLibraryItemTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLibraryItemTagMutation, { data, loading, error }] = useAddLibraryItemTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLibraryItemTagMutation(baseOptions?: Apollo.MutationHookOptions<AddLibraryItemTagMutation, AddLibraryItemTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLibraryItemTagMutation, AddLibraryItemTagMutationVariables>(AddLibraryItemTagDocument, options);
      }
export type AddLibraryItemTagMutationHookResult = ReturnType<typeof useAddLibraryItemTagMutation>;
export type AddLibraryItemTagMutationResult = Apollo.MutationResult<AddLibraryItemTagMutation>;
export type AddLibraryItemTagMutationOptions = Apollo.BaseMutationOptions<AddLibraryItemTagMutation, AddLibraryItemTagMutationVariables>;
export const RemoveLibraryItemTagDocument = gql`
    mutation RemoveLibraryItemTag($input: LibraryItemTagInput!) {
  removeLibraryItemTag(input: $input) {
    ...LibraryItemFields
  }
}
    ${LibraryItemFieldsFragmentDoc}`;
export type RemoveLibraryItemTagMutationFn = Apollo.MutationFunction<RemoveLibraryItemTagMutation, RemoveLibraryItemTagMutationVariables>;

/**
 * __useRemoveLibraryItemTagMutation__
 *
 * To run a mutation, you first call `useRemoveLibraryItemTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLibraryItemTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLibraryItemTagMutation, { data, loading, error }] = useRemoveLibraryItemTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveLibraryItemTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLibraryItemTagMutation, RemoveLibraryItemTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLibraryItemTagMutation, RemoveLibraryItemTagMutationVariables>(RemoveLibraryItemTagDocument, options);
      }
export type RemoveLibraryItemTagMutationHookResult = ReturnType<typeof useRemoveLibraryItemTagMutation>;
export type RemoveLibraryItemTagMutationResult = Apollo.MutationResult<RemoveLibraryItemTagMutation>;
export type RemoveLibraryItemTagMutationOptions = Apollo.BaseMutationOptions<RemoveLibraryItemTagMutation, RemoveLibraryItemTagMutationVariables>;
export const UpsertLibraryNoteDocument = gql`
    mutation UpsertLibraryNote($input: UpsertLibraryNoteInput!) {
  upsertLibraryNote(input: $input) {
    ...LibraryItemFields
  }
}
    ${LibraryItemFieldsFragmentDoc}`;
export type UpsertLibraryNoteMutationFn = Apollo.MutationFunction<UpsertLibraryNoteMutation, UpsertLibraryNoteMutationVariables>;

/**
 * __useUpsertLibraryNoteMutation__
 *
 * To run a mutation, you first call `useUpsertLibraryNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLibraryNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLibraryNoteMutation, { data, loading, error }] = useUpsertLibraryNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertLibraryNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpsertLibraryNoteMutation, UpsertLibraryNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertLibraryNoteMutation, UpsertLibraryNoteMutationVariables>(UpsertLibraryNoteDocument, options);
      }
export type UpsertLibraryNoteMutationHookResult = ReturnType<typeof useUpsertLibraryNoteMutation>;
export type UpsertLibraryNoteMutationResult = Apollo.MutationResult<UpsertLibraryNoteMutation>;
export type UpsertLibraryNoteMutationOptions = Apollo.BaseMutationOptions<UpsertLibraryNoteMutation, UpsertLibraryNoteMutationVariables>;
export const DeleteLibraryNoteDocument = gql`
    mutation DeleteLibraryNote($itemId: ID!) {
  deleteLibraryNote(itemId: $itemId) {
    ...LibraryItemFields
  }
}
    ${LibraryItemFieldsFragmentDoc}`;
export type DeleteLibraryNoteMutationFn = Apollo.MutationFunction<DeleteLibraryNoteMutation, DeleteLibraryNoteMutationVariables>;

/**
 * __useDeleteLibraryNoteMutation__
 *
 * To run a mutation, you first call `useDeleteLibraryNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibraryNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibraryNoteMutation, { data, loading, error }] = useDeleteLibraryNoteMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useDeleteLibraryNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLibraryNoteMutation, DeleteLibraryNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLibraryNoteMutation, DeleteLibraryNoteMutationVariables>(DeleteLibraryNoteDocument, options);
      }
export type DeleteLibraryNoteMutationHookResult = ReturnType<typeof useDeleteLibraryNoteMutation>;
export type DeleteLibraryNoteMutationResult = Apollo.MutationResult<DeleteLibraryNoteMutation>;
export type DeleteLibraryNoteMutationOptions = Apollo.BaseMutationOptions<DeleteLibraryNoteMutation, DeleteLibraryNoteMutationVariables>;
export const ShareLibraryResourceDocument = gql`
    mutation ShareLibraryResource($input: ShareLibraryResourceInput!) {
  shareLibraryResource(input: $input) {
    shareId
    userId
    name
    profileImageUrl
    headline
    role
    resourceType
    resourceId
    createdAt
  }
}
    `;
export type ShareLibraryResourceMutationFn = Apollo.MutationFunction<ShareLibraryResourceMutation, ShareLibraryResourceMutationVariables>;

/**
 * __useShareLibraryResourceMutation__
 *
 * To run a mutation, you first call `useShareLibraryResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareLibraryResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareLibraryResourceMutation, { data, loading, error }] = useShareLibraryResourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareLibraryResourceMutation(baseOptions?: Apollo.MutationHookOptions<ShareLibraryResourceMutation, ShareLibraryResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareLibraryResourceMutation, ShareLibraryResourceMutationVariables>(ShareLibraryResourceDocument, options);
      }
export type ShareLibraryResourceMutationHookResult = ReturnType<typeof useShareLibraryResourceMutation>;
export type ShareLibraryResourceMutationResult = Apollo.MutationResult<ShareLibraryResourceMutation>;
export type ShareLibraryResourceMutationOptions = Apollo.BaseMutationOptions<ShareLibraryResourceMutation, ShareLibraryResourceMutationVariables>;
export const UpdateLibraryShareRoleDocument = gql`
    mutation UpdateLibraryShareRole($input: UpdateLibraryShareRoleInput!) {
  updateLibraryShareRole(input: $input)
}
    `;
export type UpdateLibraryShareRoleMutationFn = Apollo.MutationFunction<UpdateLibraryShareRoleMutation, UpdateLibraryShareRoleMutationVariables>;

/**
 * __useUpdateLibraryShareRoleMutation__
 *
 * To run a mutation, you first call `useUpdateLibraryShareRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLibraryShareRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLibraryShareRoleMutation, { data, loading, error }] = useUpdateLibraryShareRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLibraryShareRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLibraryShareRoleMutation, UpdateLibraryShareRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLibraryShareRoleMutation, UpdateLibraryShareRoleMutationVariables>(UpdateLibraryShareRoleDocument, options);
      }
export type UpdateLibraryShareRoleMutationHookResult = ReturnType<typeof useUpdateLibraryShareRoleMutation>;
export type UpdateLibraryShareRoleMutationResult = Apollo.MutationResult<UpdateLibraryShareRoleMutation>;
export type UpdateLibraryShareRoleMutationOptions = Apollo.BaseMutationOptions<UpdateLibraryShareRoleMutation, UpdateLibraryShareRoleMutationVariables>;
export const RevokeLibraryShareDocument = gql`
    mutation RevokeLibraryShare($shareId: ID!) {
  revokeLibraryShare(shareId: $shareId)
}
    `;
export type RevokeLibraryShareMutationFn = Apollo.MutationFunction<RevokeLibraryShareMutation, RevokeLibraryShareMutationVariables>;

/**
 * __useRevokeLibraryShareMutation__
 *
 * To run a mutation, you first call `useRevokeLibraryShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeLibraryShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeLibraryShareMutation, { data, loading, error }] = useRevokeLibraryShareMutation({
 *   variables: {
 *      shareId: // value for 'shareId'
 *   },
 * });
 */
export function useRevokeLibraryShareMutation(baseOptions?: Apollo.MutationHookOptions<RevokeLibraryShareMutation, RevokeLibraryShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeLibraryShareMutation, RevokeLibraryShareMutationVariables>(RevokeLibraryShareDocument, options);
      }
export type RevokeLibraryShareMutationHookResult = ReturnType<typeof useRevokeLibraryShareMutation>;
export type RevokeLibraryShareMutationResult = Apollo.MutationResult<RevokeLibraryShareMutation>;
export type RevokeLibraryShareMutationOptions = Apollo.BaseMutationOptions<RevokeLibraryShareMutation, RevokeLibraryShareMutationVariables>;
export const LeaveLibraryShareDocument = gql`
    mutation LeaveLibraryShare($shareId: ID!) {
  leaveLibraryShare(shareId: $shareId)
}
    `;
export type LeaveLibraryShareMutationFn = Apollo.MutationFunction<LeaveLibraryShareMutation, LeaveLibraryShareMutationVariables>;

/**
 * __useLeaveLibraryShareMutation__
 *
 * To run a mutation, you first call `useLeaveLibraryShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveLibraryShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveLibraryShareMutation, { data, loading, error }] = useLeaveLibraryShareMutation({
 *   variables: {
 *      shareId: // value for 'shareId'
 *   },
 * });
 */
export function useLeaveLibraryShareMutation(baseOptions?: Apollo.MutationHookOptions<LeaveLibraryShareMutation, LeaveLibraryShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveLibraryShareMutation, LeaveLibraryShareMutationVariables>(LeaveLibraryShareDocument, options);
      }
export type LeaveLibraryShareMutationHookResult = ReturnType<typeof useLeaveLibraryShareMutation>;
export type LeaveLibraryShareMutationResult = Apollo.MutationResult<LeaveLibraryShareMutation>;
export type LeaveLibraryShareMutationOptions = Apollo.BaseMutationOptions<LeaveLibraryShareMutation, LeaveLibraryShareMutationVariables>;
export const MyLibraryItemsDocument = gql`
    query MyLibraryItems($input: LibraryItemsInput) {
  myLibraryItems(input: $input) {
    typeCounts {
      filter
      count
    }
    total
    hasMore
    page
    limit
    items {
      ...LibraryItemFields
    }
  }
}
    ${LibraryItemFieldsFragmentDoc}`;

/**
 * __useMyLibraryItemsQuery__
 *
 * To run a query within a React component, call `useMyLibraryItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLibraryItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLibraryItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMyLibraryItemsQuery(baseOptions?: Apollo.QueryHookOptions<MyLibraryItemsQuery, MyLibraryItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLibraryItemsQuery, MyLibraryItemsQueryVariables>(MyLibraryItemsDocument, options);
      }
export function useMyLibraryItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLibraryItemsQuery, MyLibraryItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLibraryItemsQuery, MyLibraryItemsQueryVariables>(MyLibraryItemsDocument, options);
        }
// @ts-ignore
export function useMyLibraryItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyLibraryItemsQuery, MyLibraryItemsQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryItemsQuery, MyLibraryItemsQueryVariables>;
export function useMyLibraryItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryItemsQuery, MyLibraryItemsQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryItemsQuery | undefined, MyLibraryItemsQueryVariables>;
export function useMyLibraryItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryItemsQuery, MyLibraryItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyLibraryItemsQuery, MyLibraryItemsQueryVariables>(MyLibraryItemsDocument, options);
        }
export type MyLibraryItemsQueryHookResult = ReturnType<typeof useMyLibraryItemsQuery>;
export type MyLibraryItemsLazyQueryHookResult = ReturnType<typeof useMyLibraryItemsLazyQuery>;
export type MyLibraryItemsSuspenseQueryHookResult = ReturnType<typeof useMyLibraryItemsSuspenseQuery>;
export type MyLibraryItemsQueryResult = Apollo.QueryResult<MyLibraryItemsQuery, MyLibraryItemsQueryVariables>;
export const SearchMyLibraryDocument = gql`
    query SearchMyLibrary($input: LibrarySearchInput!) {
  searchMyLibrary(input: $input) {
    typeCounts {
      filter
      count
    }
    total
    hasMore
    page
    limit
    results {
      ...LibrarySearchResultFields
    }
  }
}
    ${LibrarySearchResultFieldsFragmentDoc}`;

/**
 * __useSearchMyLibraryQuery__
 *
 * To run a query within a React component, call `useSearchMyLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMyLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMyLibraryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchMyLibraryQuery(baseOptions: Apollo.QueryHookOptions<SearchMyLibraryQuery, SearchMyLibraryQueryVariables> & ({ variables: SearchMyLibraryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchMyLibraryQuery, SearchMyLibraryQueryVariables>(SearchMyLibraryDocument, options);
      }
export function useSearchMyLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchMyLibraryQuery, SearchMyLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchMyLibraryQuery, SearchMyLibraryQueryVariables>(SearchMyLibraryDocument, options);
        }
// @ts-ignore
export function useSearchMyLibrarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchMyLibraryQuery, SearchMyLibraryQueryVariables>): Apollo.UseSuspenseQueryResult<SearchMyLibraryQuery, SearchMyLibraryQueryVariables>;
export function useSearchMyLibrarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchMyLibraryQuery, SearchMyLibraryQueryVariables>): Apollo.UseSuspenseQueryResult<SearchMyLibraryQuery | undefined, SearchMyLibraryQueryVariables>;
export function useSearchMyLibrarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchMyLibraryQuery, SearchMyLibraryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchMyLibraryQuery, SearchMyLibraryQueryVariables>(SearchMyLibraryDocument, options);
        }
export type SearchMyLibraryQueryHookResult = ReturnType<typeof useSearchMyLibraryQuery>;
export type SearchMyLibraryLazyQueryHookResult = ReturnType<typeof useSearchMyLibraryLazyQuery>;
export type SearchMyLibrarySuspenseQueryHookResult = ReturnType<typeof useSearchMyLibrarySuspenseQuery>;
export type SearchMyLibraryQueryResult = Apollo.QueryResult<SearchMyLibraryQuery, SearchMyLibraryQueryVariables>;
export const MyLibraryItemDocument = gql`
    query MyLibraryItem($id: ID!) {
  myLibraryItem(id: $id) {
    ...LibraryItemFields
  }
}
    ${LibraryItemFieldsFragmentDoc}`;

/**
 * __useMyLibraryItemQuery__
 *
 * To run a query within a React component, call `useMyLibraryItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLibraryItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLibraryItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMyLibraryItemQuery(baseOptions: Apollo.QueryHookOptions<MyLibraryItemQuery, MyLibraryItemQueryVariables> & ({ variables: MyLibraryItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLibraryItemQuery, MyLibraryItemQueryVariables>(MyLibraryItemDocument, options);
      }
export function useMyLibraryItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLibraryItemQuery, MyLibraryItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLibraryItemQuery, MyLibraryItemQueryVariables>(MyLibraryItemDocument, options);
        }
// @ts-ignore
export function useMyLibraryItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyLibraryItemQuery, MyLibraryItemQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryItemQuery, MyLibraryItemQueryVariables>;
export function useMyLibraryItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryItemQuery, MyLibraryItemQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryItemQuery | undefined, MyLibraryItemQueryVariables>;
export function useMyLibraryItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryItemQuery, MyLibraryItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyLibraryItemQuery, MyLibraryItemQueryVariables>(MyLibraryItemDocument, options);
        }
export type MyLibraryItemQueryHookResult = ReturnType<typeof useMyLibraryItemQuery>;
export type MyLibraryItemLazyQueryHookResult = ReturnType<typeof useMyLibraryItemLazyQuery>;
export type MyLibraryItemSuspenseQueryHookResult = ReturnType<typeof useMyLibraryItemSuspenseQuery>;
export type MyLibraryItemQueryResult = Apollo.QueryResult<MyLibraryItemQuery, MyLibraryItemQueryVariables>;
export const MyLibraryStatsDocument = gql`
    query MyLibraryStats {
  myLibraryStats {
    total
    favorites
    unfiled
    posts
    cases
    articles
    ceCourses
    media
    folders
    collections
    sharedWithMe
  }
}
    `;

/**
 * __useMyLibraryStatsQuery__
 *
 * To run a query within a React component, call `useMyLibraryStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLibraryStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLibraryStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyLibraryStatsQuery(baseOptions?: Apollo.QueryHookOptions<MyLibraryStatsQuery, MyLibraryStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLibraryStatsQuery, MyLibraryStatsQueryVariables>(MyLibraryStatsDocument, options);
      }
export function useMyLibraryStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLibraryStatsQuery, MyLibraryStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLibraryStatsQuery, MyLibraryStatsQueryVariables>(MyLibraryStatsDocument, options);
        }
// @ts-ignore
export function useMyLibraryStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyLibraryStatsQuery, MyLibraryStatsQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryStatsQuery, MyLibraryStatsQueryVariables>;
export function useMyLibraryStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryStatsQuery, MyLibraryStatsQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryStatsQuery | undefined, MyLibraryStatsQueryVariables>;
export function useMyLibraryStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryStatsQuery, MyLibraryStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyLibraryStatsQuery, MyLibraryStatsQueryVariables>(MyLibraryStatsDocument, options);
        }
export type MyLibraryStatsQueryHookResult = ReturnType<typeof useMyLibraryStatsQuery>;
export type MyLibraryStatsLazyQueryHookResult = ReturnType<typeof useMyLibraryStatsLazyQuery>;
export type MyLibraryStatsSuspenseQueryHookResult = ReturnType<typeof useMyLibraryStatsSuspenseQuery>;
export type MyLibraryStatsQueryResult = Apollo.QueryResult<MyLibraryStatsQuery, MyLibraryStatsQueryVariables>;
export const MyLibraryOverviewDocument = gql`
    query MyLibraryOverview {
  myLibraryStats {
    total
    favorites
    unfiled
    posts
    cases
    articles
    ceCourses
    media
    folders
    collections
    sharedWithMe
  }
  myLibraryFolders {
    ...LibraryFolderFields
  }
  myLibraryCollections {
    ...LibraryCollectionFields
  }
}
    ${LibraryFolderFieldsFragmentDoc}
${LibraryCollectionFieldsFragmentDoc}`;

/**
 * __useMyLibraryOverviewQuery__
 *
 * To run a query within a React component, call `useMyLibraryOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLibraryOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLibraryOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyLibraryOverviewQuery(baseOptions?: Apollo.QueryHookOptions<MyLibraryOverviewQuery, MyLibraryOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLibraryOverviewQuery, MyLibraryOverviewQueryVariables>(MyLibraryOverviewDocument, options);
      }
export function useMyLibraryOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLibraryOverviewQuery, MyLibraryOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLibraryOverviewQuery, MyLibraryOverviewQueryVariables>(MyLibraryOverviewDocument, options);
        }
// @ts-ignore
export function useMyLibraryOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyLibraryOverviewQuery, MyLibraryOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryOverviewQuery, MyLibraryOverviewQueryVariables>;
export function useMyLibraryOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryOverviewQuery, MyLibraryOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryOverviewQuery | undefined, MyLibraryOverviewQueryVariables>;
export function useMyLibraryOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryOverviewQuery, MyLibraryOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyLibraryOverviewQuery, MyLibraryOverviewQueryVariables>(MyLibraryOverviewDocument, options);
        }
export type MyLibraryOverviewQueryHookResult = ReturnType<typeof useMyLibraryOverviewQuery>;
export type MyLibraryOverviewLazyQueryHookResult = ReturnType<typeof useMyLibraryOverviewLazyQuery>;
export type MyLibraryOverviewSuspenseQueryHookResult = ReturnType<typeof useMyLibraryOverviewSuspenseQuery>;
export type MyLibraryOverviewQueryResult = Apollo.QueryResult<MyLibraryOverviewQuery, MyLibraryOverviewQueryVariables>;
export const LibrarySaveDestinationsDocument = gql`
    query LibrarySaveDestinations {
  myLibraryFolders {
    ...LibraryFolderFields
  }
  myLibraryCollections {
    ...LibraryCollectionFields
  }
  sharedWithMeLibrary {
    folders {
      ...LibraryFolderFields
    }
    collections {
      ...LibraryCollectionFields
    }
  }
}
    ${LibraryFolderFieldsFragmentDoc}
${LibraryCollectionFieldsFragmentDoc}`;

/**
 * __useLibrarySaveDestinationsQuery__
 *
 * To run a query within a React component, call `useLibrarySaveDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibrarySaveDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibrarySaveDestinationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLibrarySaveDestinationsQuery(baseOptions?: Apollo.QueryHookOptions<LibrarySaveDestinationsQuery, LibrarySaveDestinationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LibrarySaveDestinationsQuery, LibrarySaveDestinationsQueryVariables>(LibrarySaveDestinationsDocument, options);
      }
export function useLibrarySaveDestinationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LibrarySaveDestinationsQuery, LibrarySaveDestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LibrarySaveDestinationsQuery, LibrarySaveDestinationsQueryVariables>(LibrarySaveDestinationsDocument, options);
        }
// @ts-ignore
export function useLibrarySaveDestinationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LibrarySaveDestinationsQuery, LibrarySaveDestinationsQueryVariables>): Apollo.UseSuspenseQueryResult<LibrarySaveDestinationsQuery, LibrarySaveDestinationsQueryVariables>;
export function useLibrarySaveDestinationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibrarySaveDestinationsQuery, LibrarySaveDestinationsQueryVariables>): Apollo.UseSuspenseQueryResult<LibrarySaveDestinationsQuery | undefined, LibrarySaveDestinationsQueryVariables>;
export function useLibrarySaveDestinationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibrarySaveDestinationsQuery, LibrarySaveDestinationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LibrarySaveDestinationsQuery, LibrarySaveDestinationsQueryVariables>(LibrarySaveDestinationsDocument, options);
        }
export type LibrarySaveDestinationsQueryHookResult = ReturnType<typeof useLibrarySaveDestinationsQuery>;
export type LibrarySaveDestinationsLazyQueryHookResult = ReturnType<typeof useLibrarySaveDestinationsLazyQuery>;
export type LibrarySaveDestinationsSuspenseQueryHookResult = ReturnType<typeof useLibrarySaveDestinationsSuspenseQuery>;
export type LibrarySaveDestinationsQueryResult = Apollo.QueryResult<LibrarySaveDestinationsQuery, LibrarySaveDestinationsQueryVariables>;
export const MyLibraryFoldersDocument = gql`
    query MyLibraryFolders($parentId: ID) {
  myLibraryFolders(parentId: $parentId) {
    ...LibraryFolderFields
  }
}
    ${LibraryFolderFieldsFragmentDoc}`;

/**
 * __useMyLibraryFoldersQuery__
 *
 * To run a query within a React component, call `useMyLibraryFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLibraryFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLibraryFoldersQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useMyLibraryFoldersQuery(baseOptions?: Apollo.QueryHookOptions<MyLibraryFoldersQuery, MyLibraryFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLibraryFoldersQuery, MyLibraryFoldersQueryVariables>(MyLibraryFoldersDocument, options);
      }
export function useMyLibraryFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLibraryFoldersQuery, MyLibraryFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLibraryFoldersQuery, MyLibraryFoldersQueryVariables>(MyLibraryFoldersDocument, options);
        }
// @ts-ignore
export function useMyLibraryFoldersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyLibraryFoldersQuery, MyLibraryFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryFoldersQuery, MyLibraryFoldersQueryVariables>;
export function useMyLibraryFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryFoldersQuery, MyLibraryFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryFoldersQuery | undefined, MyLibraryFoldersQueryVariables>;
export function useMyLibraryFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryFoldersQuery, MyLibraryFoldersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyLibraryFoldersQuery, MyLibraryFoldersQueryVariables>(MyLibraryFoldersDocument, options);
        }
export type MyLibraryFoldersQueryHookResult = ReturnType<typeof useMyLibraryFoldersQuery>;
export type MyLibraryFoldersLazyQueryHookResult = ReturnType<typeof useMyLibraryFoldersLazyQuery>;
export type MyLibraryFoldersSuspenseQueryHookResult = ReturnType<typeof useMyLibraryFoldersSuspenseQuery>;
export type MyLibraryFoldersQueryResult = Apollo.QueryResult<MyLibraryFoldersQuery, MyLibraryFoldersQueryVariables>;
export const MyLibraryFolderDocument = gql`
    query MyLibraryFolder($id: ID!) {
  myLibraryFolder(id: $id) {
    ...LibraryFolderFields
    breadcrumb {
      id
      name
    }
  }
}
    ${LibraryFolderFieldsFragmentDoc}`;

/**
 * __useMyLibraryFolderQuery__
 *
 * To run a query within a React component, call `useMyLibraryFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLibraryFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLibraryFolderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMyLibraryFolderQuery(baseOptions: Apollo.QueryHookOptions<MyLibraryFolderQuery, MyLibraryFolderQueryVariables> & ({ variables: MyLibraryFolderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLibraryFolderQuery, MyLibraryFolderQueryVariables>(MyLibraryFolderDocument, options);
      }
export function useMyLibraryFolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLibraryFolderQuery, MyLibraryFolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLibraryFolderQuery, MyLibraryFolderQueryVariables>(MyLibraryFolderDocument, options);
        }
// @ts-ignore
export function useMyLibraryFolderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyLibraryFolderQuery, MyLibraryFolderQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryFolderQuery, MyLibraryFolderQueryVariables>;
export function useMyLibraryFolderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryFolderQuery, MyLibraryFolderQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryFolderQuery | undefined, MyLibraryFolderQueryVariables>;
export function useMyLibraryFolderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryFolderQuery, MyLibraryFolderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyLibraryFolderQuery, MyLibraryFolderQueryVariables>(MyLibraryFolderDocument, options);
        }
export type MyLibraryFolderQueryHookResult = ReturnType<typeof useMyLibraryFolderQuery>;
export type MyLibraryFolderLazyQueryHookResult = ReturnType<typeof useMyLibraryFolderLazyQuery>;
export type MyLibraryFolderSuspenseQueryHookResult = ReturnType<typeof useMyLibraryFolderSuspenseQuery>;
export type MyLibraryFolderQueryResult = Apollo.QueryResult<MyLibraryFolderQuery, MyLibraryFolderQueryVariables>;
export const MyLibraryTrashDocument = gql`
    query MyLibraryTrash {
  myLibraryTrash {
    folders {
      ...LibraryFolderFields
    }
    collections {
      ...LibraryCollectionFields
    }
  }
}
    ${LibraryFolderFieldsFragmentDoc}
${LibraryCollectionFieldsFragmentDoc}`;

/**
 * __useMyLibraryTrashQuery__
 *
 * To run a query within a React component, call `useMyLibraryTrashQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLibraryTrashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLibraryTrashQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyLibraryTrashQuery(baseOptions?: Apollo.QueryHookOptions<MyLibraryTrashQuery, MyLibraryTrashQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLibraryTrashQuery, MyLibraryTrashQueryVariables>(MyLibraryTrashDocument, options);
      }
export function useMyLibraryTrashLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLibraryTrashQuery, MyLibraryTrashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLibraryTrashQuery, MyLibraryTrashQueryVariables>(MyLibraryTrashDocument, options);
        }
// @ts-ignore
export function useMyLibraryTrashSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyLibraryTrashQuery, MyLibraryTrashQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryTrashQuery, MyLibraryTrashQueryVariables>;
export function useMyLibraryTrashSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryTrashQuery, MyLibraryTrashQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryTrashQuery | undefined, MyLibraryTrashQueryVariables>;
export function useMyLibraryTrashSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryTrashQuery, MyLibraryTrashQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyLibraryTrashQuery, MyLibraryTrashQueryVariables>(MyLibraryTrashDocument, options);
        }
export type MyLibraryTrashQueryHookResult = ReturnType<typeof useMyLibraryTrashQuery>;
export type MyLibraryTrashLazyQueryHookResult = ReturnType<typeof useMyLibraryTrashLazyQuery>;
export type MyLibraryTrashSuspenseQueryHookResult = ReturnType<typeof useMyLibraryTrashSuspenseQuery>;
export type MyLibraryTrashQueryResult = Apollo.QueryResult<MyLibraryTrashQuery, MyLibraryTrashQueryVariables>;
export const MyTrashedLibraryFoldersDocument = gql`
    query MyTrashedLibraryFolders {
  myTrashedLibraryFolders {
    ...LibraryFolderFields
  }
}
    ${LibraryFolderFieldsFragmentDoc}`;

/**
 * __useMyTrashedLibraryFoldersQuery__
 *
 * To run a query within a React component, call `useMyTrashedLibraryFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTrashedLibraryFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTrashedLibraryFoldersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyTrashedLibraryFoldersQuery(baseOptions?: Apollo.QueryHookOptions<MyTrashedLibraryFoldersQuery, MyTrashedLibraryFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTrashedLibraryFoldersQuery, MyTrashedLibraryFoldersQueryVariables>(MyTrashedLibraryFoldersDocument, options);
      }
export function useMyTrashedLibraryFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTrashedLibraryFoldersQuery, MyTrashedLibraryFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTrashedLibraryFoldersQuery, MyTrashedLibraryFoldersQueryVariables>(MyTrashedLibraryFoldersDocument, options);
        }
// @ts-ignore
export function useMyTrashedLibraryFoldersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyTrashedLibraryFoldersQuery, MyTrashedLibraryFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<MyTrashedLibraryFoldersQuery, MyTrashedLibraryFoldersQueryVariables>;
export function useMyTrashedLibraryFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyTrashedLibraryFoldersQuery, MyTrashedLibraryFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<MyTrashedLibraryFoldersQuery | undefined, MyTrashedLibraryFoldersQueryVariables>;
export function useMyTrashedLibraryFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyTrashedLibraryFoldersQuery, MyTrashedLibraryFoldersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyTrashedLibraryFoldersQuery, MyTrashedLibraryFoldersQueryVariables>(MyTrashedLibraryFoldersDocument, options);
        }
export type MyTrashedLibraryFoldersQueryHookResult = ReturnType<typeof useMyTrashedLibraryFoldersQuery>;
export type MyTrashedLibraryFoldersLazyQueryHookResult = ReturnType<typeof useMyTrashedLibraryFoldersLazyQuery>;
export type MyTrashedLibraryFoldersSuspenseQueryHookResult = ReturnType<typeof useMyTrashedLibraryFoldersSuspenseQuery>;
export type MyTrashedLibraryFoldersQueryResult = Apollo.QueryResult<MyTrashedLibraryFoldersQuery, MyTrashedLibraryFoldersQueryVariables>;
export const MyLibraryCollectionsDocument = gql`
    query MyLibraryCollections {
  myLibraryCollections {
    ...LibraryCollectionFields
  }
}
    ${LibraryCollectionFieldsFragmentDoc}`;

/**
 * __useMyLibraryCollectionsQuery__
 *
 * To run a query within a React component, call `useMyLibraryCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLibraryCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLibraryCollectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyLibraryCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<MyLibraryCollectionsQuery, MyLibraryCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLibraryCollectionsQuery, MyLibraryCollectionsQueryVariables>(MyLibraryCollectionsDocument, options);
      }
export function useMyLibraryCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLibraryCollectionsQuery, MyLibraryCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLibraryCollectionsQuery, MyLibraryCollectionsQueryVariables>(MyLibraryCollectionsDocument, options);
        }
// @ts-ignore
export function useMyLibraryCollectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyLibraryCollectionsQuery, MyLibraryCollectionsQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryCollectionsQuery, MyLibraryCollectionsQueryVariables>;
export function useMyLibraryCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryCollectionsQuery, MyLibraryCollectionsQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryCollectionsQuery | undefined, MyLibraryCollectionsQueryVariables>;
export function useMyLibraryCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryCollectionsQuery, MyLibraryCollectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyLibraryCollectionsQuery, MyLibraryCollectionsQueryVariables>(MyLibraryCollectionsDocument, options);
        }
export type MyLibraryCollectionsQueryHookResult = ReturnType<typeof useMyLibraryCollectionsQuery>;
export type MyLibraryCollectionsLazyQueryHookResult = ReturnType<typeof useMyLibraryCollectionsLazyQuery>;
export type MyLibraryCollectionsSuspenseQueryHookResult = ReturnType<typeof useMyLibraryCollectionsSuspenseQuery>;
export type MyLibraryCollectionsQueryResult = Apollo.QueryResult<MyLibraryCollectionsQuery, MyLibraryCollectionsQueryVariables>;
export const MyLibraryCollectionDocument = gql`
    query MyLibraryCollection($id: ID!) {
  myLibraryCollection(id: $id) {
    ...LibraryCollectionFields
  }
}
    ${LibraryCollectionFieldsFragmentDoc}`;

/**
 * __useMyLibraryCollectionQuery__
 *
 * To run a query within a React component, call `useMyLibraryCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLibraryCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLibraryCollectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMyLibraryCollectionQuery(baseOptions: Apollo.QueryHookOptions<MyLibraryCollectionQuery, MyLibraryCollectionQueryVariables> & ({ variables: MyLibraryCollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLibraryCollectionQuery, MyLibraryCollectionQueryVariables>(MyLibraryCollectionDocument, options);
      }
export function useMyLibraryCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLibraryCollectionQuery, MyLibraryCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLibraryCollectionQuery, MyLibraryCollectionQueryVariables>(MyLibraryCollectionDocument, options);
        }
// @ts-ignore
export function useMyLibraryCollectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyLibraryCollectionQuery, MyLibraryCollectionQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryCollectionQuery, MyLibraryCollectionQueryVariables>;
export function useMyLibraryCollectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryCollectionQuery, MyLibraryCollectionQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryCollectionQuery | undefined, MyLibraryCollectionQueryVariables>;
export function useMyLibraryCollectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryCollectionQuery, MyLibraryCollectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyLibraryCollectionQuery, MyLibraryCollectionQueryVariables>(MyLibraryCollectionDocument, options);
        }
export type MyLibraryCollectionQueryHookResult = ReturnType<typeof useMyLibraryCollectionQuery>;
export type MyLibraryCollectionLazyQueryHookResult = ReturnType<typeof useMyLibraryCollectionLazyQuery>;
export type MyLibraryCollectionSuspenseQueryHookResult = ReturnType<typeof useMyLibraryCollectionSuspenseQuery>;
export type MyLibraryCollectionQueryResult = Apollo.QueryResult<MyLibraryCollectionQuery, MyLibraryCollectionQueryVariables>;
export const MyLibraryTagsDocument = gql`
    query MyLibraryTags {
  myLibraryTags {
    id
    name
    itemCount
  }
}
    `;

/**
 * __useMyLibraryTagsQuery__
 *
 * To run a query within a React component, call `useMyLibraryTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLibraryTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLibraryTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyLibraryTagsQuery(baseOptions?: Apollo.QueryHookOptions<MyLibraryTagsQuery, MyLibraryTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLibraryTagsQuery, MyLibraryTagsQueryVariables>(MyLibraryTagsDocument, options);
      }
export function useMyLibraryTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLibraryTagsQuery, MyLibraryTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLibraryTagsQuery, MyLibraryTagsQueryVariables>(MyLibraryTagsDocument, options);
        }
// @ts-ignore
export function useMyLibraryTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyLibraryTagsQuery, MyLibraryTagsQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryTagsQuery, MyLibraryTagsQueryVariables>;
export function useMyLibraryTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryTagsQuery, MyLibraryTagsQueryVariables>): Apollo.UseSuspenseQueryResult<MyLibraryTagsQuery | undefined, MyLibraryTagsQueryVariables>;
export function useMyLibraryTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLibraryTagsQuery, MyLibraryTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyLibraryTagsQuery, MyLibraryTagsQueryVariables>(MyLibraryTagsDocument, options);
        }
export type MyLibraryTagsQueryHookResult = ReturnType<typeof useMyLibraryTagsQuery>;
export type MyLibraryTagsLazyQueryHookResult = ReturnType<typeof useMyLibraryTagsLazyQuery>;
export type MyLibraryTagsSuspenseQueryHookResult = ReturnType<typeof useMyLibraryTagsSuspenseQuery>;
export type MyLibraryTagsQueryResult = Apollo.QueryResult<MyLibraryTagsQuery, MyLibraryTagsQueryVariables>;
export const LibraryEntriesDocument = gql`
    query LibraryEntries($input: LibraryEntriesInput!) {
  libraryEntries(input: $input) {
    typeCounts {
      filter
      count
    }
    total
    hasMore
    page
    limit
    entries {
      ...LibraryEntryFields
    }
  }
}
    ${LibraryEntryFieldsFragmentDoc}`;

/**
 * __useLibraryEntriesQuery__
 *
 * To run a query within a React component, call `useLibraryEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryEntriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLibraryEntriesQuery(baseOptions: Apollo.QueryHookOptions<LibraryEntriesQuery, LibraryEntriesQueryVariables> & ({ variables: LibraryEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LibraryEntriesQuery, LibraryEntriesQueryVariables>(LibraryEntriesDocument, options);
      }
export function useLibraryEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LibraryEntriesQuery, LibraryEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LibraryEntriesQuery, LibraryEntriesQueryVariables>(LibraryEntriesDocument, options);
        }
// @ts-ignore
export function useLibraryEntriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LibraryEntriesQuery, LibraryEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<LibraryEntriesQuery, LibraryEntriesQueryVariables>;
export function useLibraryEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryEntriesQuery, LibraryEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<LibraryEntriesQuery | undefined, LibraryEntriesQueryVariables>;
export function useLibraryEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryEntriesQuery, LibraryEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LibraryEntriesQuery, LibraryEntriesQueryVariables>(LibraryEntriesDocument, options);
        }
export type LibraryEntriesQueryHookResult = ReturnType<typeof useLibraryEntriesQuery>;
export type LibraryEntriesLazyQueryHookResult = ReturnType<typeof useLibraryEntriesLazyQuery>;
export type LibraryEntriesSuspenseQueryHookResult = ReturnType<typeof useLibraryEntriesSuspenseQuery>;
export type LibraryEntriesQueryResult = Apollo.QueryResult<LibraryEntriesQuery, LibraryEntriesQueryVariables>;
export const SharedWithMeLibraryDocument = gql`
    query SharedWithMeLibrary {
  sharedWithMeLibrary {
    folders {
      ...LibraryFolderFields
    }
    collections {
      ...LibraryCollectionFields
    }
  }
}
    ${LibraryFolderFieldsFragmentDoc}
${LibraryCollectionFieldsFragmentDoc}`;

/**
 * __useSharedWithMeLibraryQuery__
 *
 * To run a query within a React component, call `useSharedWithMeLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedWithMeLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedWithMeLibraryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSharedWithMeLibraryQuery(baseOptions?: Apollo.QueryHookOptions<SharedWithMeLibraryQuery, SharedWithMeLibraryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedWithMeLibraryQuery, SharedWithMeLibraryQueryVariables>(SharedWithMeLibraryDocument, options);
      }
export function useSharedWithMeLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedWithMeLibraryQuery, SharedWithMeLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedWithMeLibraryQuery, SharedWithMeLibraryQueryVariables>(SharedWithMeLibraryDocument, options);
        }
// @ts-ignore
export function useSharedWithMeLibrarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SharedWithMeLibraryQuery, SharedWithMeLibraryQueryVariables>): Apollo.UseSuspenseQueryResult<SharedWithMeLibraryQuery, SharedWithMeLibraryQueryVariables>;
export function useSharedWithMeLibrarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SharedWithMeLibraryQuery, SharedWithMeLibraryQueryVariables>): Apollo.UseSuspenseQueryResult<SharedWithMeLibraryQuery | undefined, SharedWithMeLibraryQueryVariables>;
export function useSharedWithMeLibrarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SharedWithMeLibraryQuery, SharedWithMeLibraryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SharedWithMeLibraryQuery, SharedWithMeLibraryQueryVariables>(SharedWithMeLibraryDocument, options);
        }
export type SharedWithMeLibraryQueryHookResult = ReturnType<typeof useSharedWithMeLibraryQuery>;
export type SharedWithMeLibraryLazyQueryHookResult = ReturnType<typeof useSharedWithMeLibraryLazyQuery>;
export type SharedWithMeLibrarySuspenseQueryHookResult = ReturnType<typeof useSharedWithMeLibrarySuspenseQuery>;
export type SharedWithMeLibraryQueryResult = Apollo.QueryResult<SharedWithMeLibraryQuery, SharedWithMeLibraryQueryVariables>;
export const LibraryShareMembersDocument = gql`
    query LibraryShareMembers($resourceType: LibraryResourceType!, $resourceId: ID!) {
  libraryShareMembers(resourceType: $resourceType, resourceId: $resourceId) {
    shareId
    userId
    name
    profileImageUrl
    headline
    role
    resourceType
    resourceId
    createdAt
  }
}
    `;

/**
 * __useLibraryShareMembersQuery__
 *
 * To run a query within a React component, call `useLibraryShareMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryShareMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryShareMembersQuery({
 *   variables: {
 *      resourceType: // value for 'resourceType'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useLibraryShareMembersQuery(baseOptions: Apollo.QueryHookOptions<LibraryShareMembersQuery, LibraryShareMembersQueryVariables> & ({ variables: LibraryShareMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LibraryShareMembersQuery, LibraryShareMembersQueryVariables>(LibraryShareMembersDocument, options);
      }
export function useLibraryShareMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LibraryShareMembersQuery, LibraryShareMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LibraryShareMembersQuery, LibraryShareMembersQueryVariables>(LibraryShareMembersDocument, options);
        }
// @ts-ignore
export function useLibraryShareMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LibraryShareMembersQuery, LibraryShareMembersQueryVariables>): Apollo.UseSuspenseQueryResult<LibraryShareMembersQuery, LibraryShareMembersQueryVariables>;
export function useLibraryShareMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryShareMembersQuery, LibraryShareMembersQueryVariables>): Apollo.UseSuspenseQueryResult<LibraryShareMembersQuery | undefined, LibraryShareMembersQueryVariables>;
export function useLibraryShareMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryShareMembersQuery, LibraryShareMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LibraryShareMembersQuery, LibraryShareMembersQueryVariables>(LibraryShareMembersDocument, options);
        }
export type LibraryShareMembersQueryHookResult = ReturnType<typeof useLibraryShareMembersQuery>;
export type LibraryShareMembersLazyQueryHookResult = ReturnType<typeof useLibraryShareMembersLazyQuery>;
export type LibraryShareMembersSuspenseQueryHookResult = ReturnType<typeof useLibraryShareMembersSuspenseQuery>;
export type LibraryShareMembersQueryResult = Apollo.QueryResult<LibraryShareMembersQuery, LibraryShareMembersQueryVariables>;
export const LibraryShareDialogDocument = gql`
    query LibraryShareDialog($resourceType: LibraryResourceType!, $resourceId: ID!, $q: String) {
  libraryShareMembers(resourceType: $resourceType, resourceId: $resourceId) {
    shareId
    userId
    name
    profileImageUrl
    headline
    role
    resourceType
    resourceId
    createdAt
  }
  searchLibraryShareUsers(q: $q) {
    userId
    name
    profileImageUrl
    headline
  }
}
    `;

/**
 * __useLibraryShareDialogQuery__
 *
 * To run a query within a React component, call `useLibraryShareDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryShareDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryShareDialogQuery({
 *   variables: {
 *      resourceType: // value for 'resourceType'
 *      resourceId: // value for 'resourceId'
 *      q: // value for 'q'
 *   },
 * });
 */
export function useLibraryShareDialogQuery(baseOptions: Apollo.QueryHookOptions<LibraryShareDialogQuery, LibraryShareDialogQueryVariables> & ({ variables: LibraryShareDialogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LibraryShareDialogQuery, LibraryShareDialogQueryVariables>(LibraryShareDialogDocument, options);
      }
export function useLibraryShareDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LibraryShareDialogQuery, LibraryShareDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LibraryShareDialogQuery, LibraryShareDialogQueryVariables>(LibraryShareDialogDocument, options);
        }
// @ts-ignore
export function useLibraryShareDialogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LibraryShareDialogQuery, LibraryShareDialogQueryVariables>): Apollo.UseSuspenseQueryResult<LibraryShareDialogQuery, LibraryShareDialogQueryVariables>;
export function useLibraryShareDialogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryShareDialogQuery, LibraryShareDialogQueryVariables>): Apollo.UseSuspenseQueryResult<LibraryShareDialogQuery | undefined, LibraryShareDialogQueryVariables>;
export function useLibraryShareDialogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryShareDialogQuery, LibraryShareDialogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LibraryShareDialogQuery, LibraryShareDialogQueryVariables>(LibraryShareDialogDocument, options);
        }
export type LibraryShareDialogQueryHookResult = ReturnType<typeof useLibraryShareDialogQuery>;
export type LibraryShareDialogLazyQueryHookResult = ReturnType<typeof useLibraryShareDialogLazyQuery>;
export type LibraryShareDialogSuspenseQueryHookResult = ReturnType<typeof useLibraryShareDialogSuspenseQuery>;
export type LibraryShareDialogQueryResult = Apollo.QueryResult<LibraryShareDialogQuery, LibraryShareDialogQueryVariables>;
export const SearchLibraryShareUsersDocument = gql`
    query SearchLibraryShareUsers($q: String) {
  searchLibraryShareUsers(q: $q) {
    userId
    name
    profileImageUrl
    headline
  }
}
    `;

/**
 * __useSearchLibraryShareUsersQuery__
 *
 * To run a query within a React component, call `useSearchLibraryShareUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLibraryShareUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLibraryShareUsersQuery({
 *   variables: {
 *      q: // value for 'q'
 *   },
 * });
 */
export function useSearchLibraryShareUsersQuery(baseOptions?: Apollo.QueryHookOptions<SearchLibraryShareUsersQuery, SearchLibraryShareUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchLibraryShareUsersQuery, SearchLibraryShareUsersQueryVariables>(SearchLibraryShareUsersDocument, options);
      }
export function useSearchLibraryShareUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchLibraryShareUsersQuery, SearchLibraryShareUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchLibraryShareUsersQuery, SearchLibraryShareUsersQueryVariables>(SearchLibraryShareUsersDocument, options);
        }
// @ts-ignore
export function useSearchLibraryShareUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchLibraryShareUsersQuery, SearchLibraryShareUsersQueryVariables>): Apollo.UseSuspenseQueryResult<SearchLibraryShareUsersQuery, SearchLibraryShareUsersQueryVariables>;
export function useSearchLibraryShareUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchLibraryShareUsersQuery, SearchLibraryShareUsersQueryVariables>): Apollo.UseSuspenseQueryResult<SearchLibraryShareUsersQuery | undefined, SearchLibraryShareUsersQueryVariables>;
export function useSearchLibraryShareUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchLibraryShareUsersQuery, SearchLibraryShareUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchLibraryShareUsersQuery, SearchLibraryShareUsersQueryVariables>(SearchLibraryShareUsersDocument, options);
        }
export type SearchLibraryShareUsersQueryHookResult = ReturnType<typeof useSearchLibraryShareUsersQuery>;
export type SearchLibraryShareUsersLazyQueryHookResult = ReturnType<typeof useSearchLibraryShareUsersLazyQuery>;
export type SearchLibraryShareUsersSuspenseQueryHookResult = ReturnType<typeof useSearchLibraryShareUsersSuspenseQuery>;
export type SearchLibraryShareUsersQueryResult = Apollo.QueryResult<SearchLibraryShareUsersQuery, SearchLibraryShareUsersQueryVariables>;
export const PostLibraryItemDocument = gql`
    query PostLibraryItem($input: GetPostInput!) {
  getPost(input: $input) {
    id
    libraryItemId
  }
}
    `;

/**
 * __usePostLibraryItemQuery__
 *
 * To run a query within a React component, call `usePostLibraryItemQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostLibraryItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostLibraryItemQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostLibraryItemQuery(baseOptions: Apollo.QueryHookOptions<PostLibraryItemQuery, PostLibraryItemQueryVariables> & ({ variables: PostLibraryItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostLibraryItemQuery, PostLibraryItemQueryVariables>(PostLibraryItemDocument, options);
      }
export function usePostLibraryItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostLibraryItemQuery, PostLibraryItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostLibraryItemQuery, PostLibraryItemQueryVariables>(PostLibraryItemDocument, options);
        }
// @ts-ignore
export function usePostLibraryItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PostLibraryItemQuery, PostLibraryItemQueryVariables>): Apollo.UseSuspenseQueryResult<PostLibraryItemQuery, PostLibraryItemQueryVariables>;
export function usePostLibraryItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostLibraryItemQuery, PostLibraryItemQueryVariables>): Apollo.UseSuspenseQueryResult<PostLibraryItemQuery | undefined, PostLibraryItemQueryVariables>;
export function usePostLibraryItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostLibraryItemQuery, PostLibraryItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostLibraryItemQuery, PostLibraryItemQueryVariables>(PostLibraryItemDocument, options);
        }
export type PostLibraryItemQueryHookResult = ReturnType<typeof usePostLibraryItemQuery>;
export type PostLibraryItemLazyQueryHookResult = ReturnType<typeof usePostLibraryItemLazyQuery>;
export type PostLibraryItemSuspenseQueryHookResult = ReturnType<typeof usePostLibraryItemSuspenseQuery>;
export type PostLibraryItemQueryResult = Apollo.QueryResult<PostLibraryItemQuery, PostLibraryItemQueryVariables>;
export const ArticleLibraryItemDocument = gql`
    query ArticleLibraryItem($id: ID!) {
  article(id: $id) {
    id
    libraryItemId
  }
}
    `;

/**
 * __useArticleLibraryItemQuery__
 *
 * To run a query within a React component, call `useArticleLibraryItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleLibraryItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleLibraryItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArticleLibraryItemQuery(baseOptions: Apollo.QueryHookOptions<ArticleLibraryItemQuery, ArticleLibraryItemQueryVariables> & ({ variables: ArticleLibraryItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleLibraryItemQuery, ArticleLibraryItemQueryVariables>(ArticleLibraryItemDocument, options);
      }
export function useArticleLibraryItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleLibraryItemQuery, ArticleLibraryItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleLibraryItemQuery, ArticleLibraryItemQueryVariables>(ArticleLibraryItemDocument, options);
        }
// @ts-ignore
export function useArticleLibraryItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ArticleLibraryItemQuery, ArticleLibraryItemQueryVariables>): Apollo.UseSuspenseQueryResult<ArticleLibraryItemQuery, ArticleLibraryItemQueryVariables>;
export function useArticleLibraryItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticleLibraryItemQuery, ArticleLibraryItemQueryVariables>): Apollo.UseSuspenseQueryResult<ArticleLibraryItemQuery | undefined, ArticleLibraryItemQueryVariables>;
export function useArticleLibraryItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticleLibraryItemQuery, ArticleLibraryItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticleLibraryItemQuery, ArticleLibraryItemQueryVariables>(ArticleLibraryItemDocument, options);
        }
export type ArticleLibraryItemQueryHookResult = ReturnType<typeof useArticleLibraryItemQuery>;
export type ArticleLibraryItemLazyQueryHookResult = ReturnType<typeof useArticleLibraryItemLazyQuery>;
export type ArticleLibraryItemSuspenseQueryHookResult = ReturnType<typeof useArticleLibraryItemSuspenseQuery>;
export type ArticleLibraryItemQueryResult = Apollo.QueryResult<ArticleLibraryItemQuery, ArticleLibraryItemQueryVariables>;
export const AddLicenseDocument = gql`
    mutation AddLicense($input: AddLicenseInput!) {
  addLicense(input: $input)
}
    `;
export type AddLicenseMutationFn = Apollo.MutationFunction<AddLicenseMutation, AddLicenseMutationVariables>;

/**
 * __useAddLicenseMutation__
 *
 * To run a mutation, you first call `useAddLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLicenseMutation, { data, loading, error }] = useAddLicenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLicenseMutation(baseOptions?: Apollo.MutationHookOptions<AddLicenseMutation, AddLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLicenseMutation, AddLicenseMutationVariables>(AddLicenseDocument, options);
      }
export type AddLicenseMutationHookResult = ReturnType<typeof useAddLicenseMutation>;
export type AddLicenseMutationResult = Apollo.MutationResult<AddLicenseMutation>;
export type AddLicenseMutationOptions = Apollo.BaseMutationOptions<AddLicenseMutation, AddLicenseMutationVariables>;
export const DeleteLicenseDocument = gql`
    mutation DeleteLicense($input: DeleteLicenseInput!) {
  deleteLicense(input: $input)
}
    `;
export type DeleteLicenseMutationFn = Apollo.MutationFunction<DeleteLicenseMutation, DeleteLicenseMutationVariables>;

/**
 * __useDeleteLicenseMutation__
 *
 * To run a mutation, you first call `useDeleteLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLicenseMutation, { data, loading, error }] = useDeleteLicenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLicenseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLicenseMutation, DeleteLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLicenseMutation, DeleteLicenseMutationVariables>(DeleteLicenseDocument, options);
      }
export type DeleteLicenseMutationHookResult = ReturnType<typeof useDeleteLicenseMutation>;
export type DeleteLicenseMutationResult = Apollo.MutationResult<DeleteLicenseMutation>;
export type DeleteLicenseMutationOptions = Apollo.BaseMutationOptions<DeleteLicenseMutation, DeleteLicenseMutationVariables>;
export const EditLicenseDocument = gql`
    mutation EditLicense($input: EditLicenseInput!) {
  editLicense(input: $input)
}
    `;
export type EditLicenseMutationFn = Apollo.MutationFunction<EditLicenseMutation, EditLicenseMutationVariables>;

/**
 * __useEditLicenseMutation__
 *
 * To run a mutation, you first call `useEditLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLicenseMutation, { data, loading, error }] = useEditLicenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditLicenseMutation(baseOptions?: Apollo.MutationHookOptions<EditLicenseMutation, EditLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditLicenseMutation, EditLicenseMutationVariables>(EditLicenseDocument, options);
      }
export type EditLicenseMutationHookResult = ReturnType<typeof useEditLicenseMutation>;
export type EditLicenseMutationResult = Apollo.MutationResult<EditLicenseMutation>;
export type EditLicenseMutationOptions = Apollo.BaseMutationOptions<EditLicenseMutation, EditLicenseMutationVariables>;
export const GetLinkPreviewDocument = gql`
    query GetLinkPreview($input: GetLinkPreviewInput!) {
  getLinkPreview(input: $input) {
    title
    description
    image
    url
    siteName
    type
  }
}
    `;

/**
 * __useGetLinkPreviewQuery__
 *
 * To run a query within a React component, call `useGetLinkPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkPreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLinkPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetLinkPreviewQuery, GetLinkPreviewQueryVariables> & ({ variables: GetLinkPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinkPreviewQuery, GetLinkPreviewQueryVariables>(GetLinkPreviewDocument, options);
      }
export function useGetLinkPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinkPreviewQuery, GetLinkPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinkPreviewQuery, GetLinkPreviewQueryVariables>(GetLinkPreviewDocument, options);
        }
// @ts-ignore
export function useGetLinkPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLinkPreviewQuery, GetLinkPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetLinkPreviewQuery, GetLinkPreviewQueryVariables>;
export function useGetLinkPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLinkPreviewQuery, GetLinkPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetLinkPreviewQuery | undefined, GetLinkPreviewQueryVariables>;
export function useGetLinkPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLinkPreviewQuery, GetLinkPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLinkPreviewQuery, GetLinkPreviewQueryVariables>(GetLinkPreviewDocument, options);
        }
export type GetLinkPreviewQueryHookResult = ReturnType<typeof useGetLinkPreviewQuery>;
export type GetLinkPreviewLazyQueryHookResult = ReturnType<typeof useGetLinkPreviewLazyQuery>;
export type GetLinkPreviewSuspenseQueryHookResult = ReturnType<typeof useGetLinkPreviewSuspenseQuery>;
export type GetLinkPreviewQueryResult = Apollo.QueryResult<GetLinkPreviewQuery, GetLinkPreviewQueryVariables>;
export const CreateLiveStreamDocument = gql`
    mutation CreateLiveStream($input: CreateLiveStreamInput!) {
  createLiveStream(createLiveStreamInput: $input) {
    id
    roomId
    description
    status
    livekitToken
    createdAt
    updatedAt
  }
}
    `;
export type CreateLiveStreamMutationFn = Apollo.MutationFunction<CreateLiveStreamMutation, CreateLiveStreamMutationVariables>;

/**
 * __useCreateLiveStreamMutation__
 *
 * To run a mutation, you first call `useCreateLiveStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLiveStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLiveStreamMutation, { data, loading, error }] = useCreateLiveStreamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLiveStreamMutation(baseOptions?: Apollo.MutationHookOptions<CreateLiveStreamMutation, CreateLiveStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLiveStreamMutation, CreateLiveStreamMutationVariables>(CreateLiveStreamDocument, options);
      }
export type CreateLiveStreamMutationHookResult = ReturnType<typeof useCreateLiveStreamMutation>;
export type CreateLiveStreamMutationResult = Apollo.MutationResult<CreateLiveStreamMutation>;
export type CreateLiveStreamMutationOptions = Apollo.BaseMutationOptions<CreateLiveStreamMutation, CreateLiveStreamMutationVariables>;
export const FindAllLiveStreamsDocument = gql`
    query FindAllLiveStreams {
  findAllLiveStreams {
    ...LiveStreamListFields
  }
}
    ${LiveStreamListFieldsFragmentDoc}`;

/**
 * __useFindAllLiveStreamsQuery__
 *
 * To run a query within a React component, call `useFindAllLiveStreamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllLiveStreamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllLiveStreamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllLiveStreamsQuery(baseOptions?: Apollo.QueryHookOptions<FindAllLiveStreamsQuery, FindAllLiveStreamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllLiveStreamsQuery, FindAllLiveStreamsQueryVariables>(FindAllLiveStreamsDocument, options);
      }
export function useFindAllLiveStreamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllLiveStreamsQuery, FindAllLiveStreamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllLiveStreamsQuery, FindAllLiveStreamsQueryVariables>(FindAllLiveStreamsDocument, options);
        }
// @ts-ignore
export function useFindAllLiveStreamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllLiveStreamsQuery, FindAllLiveStreamsQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllLiveStreamsQuery, FindAllLiveStreamsQueryVariables>;
export function useFindAllLiveStreamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllLiveStreamsQuery, FindAllLiveStreamsQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllLiveStreamsQuery | undefined, FindAllLiveStreamsQueryVariables>;
export function useFindAllLiveStreamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllLiveStreamsQuery, FindAllLiveStreamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllLiveStreamsQuery, FindAllLiveStreamsQueryVariables>(FindAllLiveStreamsDocument, options);
        }
export type FindAllLiveStreamsQueryHookResult = ReturnType<typeof useFindAllLiveStreamsQuery>;
export type FindAllLiveStreamsLazyQueryHookResult = ReturnType<typeof useFindAllLiveStreamsLazyQuery>;
export type FindAllLiveStreamsSuspenseQueryHookResult = ReturnType<typeof useFindAllLiveStreamsSuspenseQuery>;
export type FindAllLiveStreamsQueryResult = Apollo.QueryResult<FindAllLiveStreamsQuery, FindAllLiveStreamsQueryVariables>;
export const GetLiveStreamDocument = gql`
    query GetLiveStream($roomId: String!) {
  getLiveStream(roomId: $roomId) {
    id
    roomId
    description
    status
    isHostOnline
    user {
      id
      profileImageUrl
      firstName
      lastName
      title
      companyName
    }
  }
}
    `;

/**
 * __useGetLiveStreamQuery__
 *
 * To run a query within a React component, call `useGetLiveStreamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLiveStreamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiveStreamQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useGetLiveStreamQuery(baseOptions: Apollo.QueryHookOptions<GetLiveStreamQuery, GetLiveStreamQueryVariables> & ({ variables: GetLiveStreamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLiveStreamQuery, GetLiveStreamQueryVariables>(GetLiveStreamDocument, options);
      }
export function useGetLiveStreamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLiveStreamQuery, GetLiveStreamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLiveStreamQuery, GetLiveStreamQueryVariables>(GetLiveStreamDocument, options);
        }
// @ts-ignore
export function useGetLiveStreamSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLiveStreamQuery, GetLiveStreamQueryVariables>): Apollo.UseSuspenseQueryResult<GetLiveStreamQuery, GetLiveStreamQueryVariables>;
export function useGetLiveStreamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLiveStreamQuery, GetLiveStreamQueryVariables>): Apollo.UseSuspenseQueryResult<GetLiveStreamQuery | undefined, GetLiveStreamQueryVariables>;
export function useGetLiveStreamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLiveStreamQuery, GetLiveStreamQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLiveStreamQuery, GetLiveStreamQueryVariables>(GetLiveStreamDocument, options);
        }
export type GetLiveStreamQueryHookResult = ReturnType<typeof useGetLiveStreamQuery>;
export type GetLiveStreamLazyQueryHookResult = ReturnType<typeof useGetLiveStreamLazyQuery>;
export type GetLiveStreamSuspenseQueryHookResult = ReturnType<typeof useGetLiveStreamSuspenseQuery>;
export type GetLiveStreamQueryResult = Apollo.QueryResult<GetLiveStreamQuery, GetLiveStreamQueryVariables>;
export const ResumeLiveStreamDocument = gql`
    mutation ResumeLiveStream($roomId: String!) {
  resumeLiveStream(roomId: $roomId) {
    id
    roomId
    description
    status
    livekitToken
    createdAt
    updatedAt
  }
}
    `;
export type ResumeLiveStreamMutationFn = Apollo.MutationFunction<ResumeLiveStreamMutation, ResumeLiveStreamMutationVariables>;

/**
 * __useResumeLiveStreamMutation__
 *
 * To run a mutation, you first call `useResumeLiveStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeLiveStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeLiveStreamMutation, { data, loading, error }] = useResumeLiveStreamMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useResumeLiveStreamMutation(baseOptions?: Apollo.MutationHookOptions<ResumeLiveStreamMutation, ResumeLiveStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeLiveStreamMutation, ResumeLiveStreamMutationVariables>(ResumeLiveStreamDocument, options);
      }
export type ResumeLiveStreamMutationHookResult = ReturnType<typeof useResumeLiveStreamMutation>;
export type ResumeLiveStreamMutationResult = Apollo.MutationResult<ResumeLiveStreamMutation>;
export type ResumeLiveStreamMutationOptions = Apollo.BaseMutationOptions<ResumeLiveStreamMutation, ResumeLiveStreamMutationVariables>;
export const HostHeartbeatDocument = gql`
    mutation HostHeartbeat($roomId: String!) {
  hostHeartbeat(roomId: $roomId) {
    success
    message
  }
}
    `;
export type HostHeartbeatMutationFn = Apollo.MutationFunction<HostHeartbeatMutation, HostHeartbeatMutationVariables>;

/**
 * __useHostHeartbeatMutation__
 *
 * To run a mutation, you first call `useHostHeartbeatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHostHeartbeatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hostHeartbeatMutation, { data, loading, error }] = useHostHeartbeatMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useHostHeartbeatMutation(baseOptions?: Apollo.MutationHookOptions<HostHeartbeatMutation, HostHeartbeatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HostHeartbeatMutation, HostHeartbeatMutationVariables>(HostHeartbeatDocument, options);
      }
export type HostHeartbeatMutationHookResult = ReturnType<typeof useHostHeartbeatMutation>;
export type HostHeartbeatMutationResult = Apollo.MutationResult<HostHeartbeatMutation>;
export type HostHeartbeatMutationOptions = Apollo.BaseMutationOptions<HostHeartbeatMutation, HostHeartbeatMutationVariables>;
export const MarkHostAwayDocument = gql`
    mutation MarkHostAway($roomId: String!) {
  markHostAway(roomId: $roomId) {
    success
    message
  }
}
    `;
export type MarkHostAwayMutationFn = Apollo.MutationFunction<MarkHostAwayMutation, MarkHostAwayMutationVariables>;

/**
 * __useMarkHostAwayMutation__
 *
 * To run a mutation, you first call `useMarkHostAwayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkHostAwayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markHostAwayMutation, { data, loading, error }] = useMarkHostAwayMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useMarkHostAwayMutation(baseOptions?: Apollo.MutationHookOptions<MarkHostAwayMutation, MarkHostAwayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkHostAwayMutation, MarkHostAwayMutationVariables>(MarkHostAwayDocument, options);
      }
export type MarkHostAwayMutationHookResult = ReturnType<typeof useMarkHostAwayMutation>;
export type MarkHostAwayMutationResult = Apollo.MutationResult<MarkHostAwayMutation>;
export type MarkHostAwayMutationOptions = Apollo.BaseMutationOptions<MarkHostAwayMutation, MarkHostAwayMutationVariables>;
export const KickParticipantInLiveStreamDocument = gql`
    mutation KickParticipantInLiveStream($roomId: String!, $participantIdentity: String!) {
  kickParticipantInStream(
    roomId: $roomId
    participantIdentity: $participantIdentity
  ) {
    message
    success
  }
}
    `;
export type KickParticipantInLiveStreamMutationFn = Apollo.MutationFunction<KickParticipantInLiveStreamMutation, KickParticipantInLiveStreamMutationVariables>;

/**
 * __useKickParticipantInLiveStreamMutation__
 *
 * To run a mutation, you first call `useKickParticipantInLiveStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKickParticipantInLiveStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kickParticipantInLiveStreamMutation, { data, loading, error }] = useKickParticipantInLiveStreamMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      participantIdentity: // value for 'participantIdentity'
 *   },
 * });
 */
export function useKickParticipantInLiveStreamMutation(baseOptions?: Apollo.MutationHookOptions<KickParticipantInLiveStreamMutation, KickParticipantInLiveStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KickParticipantInLiveStreamMutation, KickParticipantInLiveStreamMutationVariables>(KickParticipantInLiveStreamDocument, options);
      }
export type KickParticipantInLiveStreamMutationHookResult = ReturnType<typeof useKickParticipantInLiveStreamMutation>;
export type KickParticipantInLiveStreamMutationResult = Apollo.MutationResult<KickParticipantInLiveStreamMutation>;
export type KickParticipantInLiveStreamMutationOptions = Apollo.BaseMutationOptions<KickParticipantInLiveStreamMutation, KickParticipantInLiveStreamMutationVariables>;
export const JoinLiveStreamDocument = gql`
    mutation JoinLiveStream($roomId: String!) {
  joinLiveStream(roomId: $roomId) {
    id
    roomId
    description
    status
    livekitToken
    createdAt
    updatedAt
  }
}
    `;
export type JoinLiveStreamMutationFn = Apollo.MutationFunction<JoinLiveStreamMutation, JoinLiveStreamMutationVariables>;

/**
 * __useJoinLiveStreamMutation__
 *
 * To run a mutation, you first call `useJoinLiveStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinLiveStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinLiveStreamMutation, { data, loading, error }] = useJoinLiveStreamMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useJoinLiveStreamMutation(baseOptions?: Apollo.MutationHookOptions<JoinLiveStreamMutation, JoinLiveStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinLiveStreamMutation, JoinLiveStreamMutationVariables>(JoinLiveStreamDocument, options);
      }
export type JoinLiveStreamMutationHookResult = ReturnType<typeof useJoinLiveStreamMutation>;
export type JoinLiveStreamMutationResult = Apollo.MutationResult<JoinLiveStreamMutation>;
export type JoinLiveStreamMutationOptions = Apollo.BaseMutationOptions<JoinLiveStreamMutation, JoinLiveStreamMutationVariables>;
export const InviteToLiveStreamDocument = gql`
    mutation InviteToLiveStream($input: InviteToLiveStreamInput!) {
  inviteToLiveStream(input: $input) {
    success
    message
    invitedCount
    skippedCount
  }
}
    `;
export type InviteToLiveStreamMutationFn = Apollo.MutationFunction<InviteToLiveStreamMutation, InviteToLiveStreamMutationVariables>;

/**
 * __useInviteToLiveStreamMutation__
 *
 * To run a mutation, you first call `useInviteToLiveStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteToLiveStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteToLiveStreamMutation, { data, loading, error }] = useInviteToLiveStreamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteToLiveStreamMutation(baseOptions?: Apollo.MutationHookOptions<InviteToLiveStreamMutation, InviteToLiveStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteToLiveStreamMutation, InviteToLiveStreamMutationVariables>(InviteToLiveStreamDocument, options);
      }
export type InviteToLiveStreamMutationHookResult = ReturnType<typeof useInviteToLiveStreamMutation>;
export type InviteToLiveStreamMutationResult = Apollo.MutationResult<InviteToLiveStreamMutation>;
export type InviteToLiveStreamMutationOptions = Apollo.BaseMutationOptions<InviteToLiveStreamMutation, InviteToLiveStreamMutationVariables>;
export const EndLiveStreamDocument = gql`
    mutation EndLiveStream($roomId: String!) {
  endLiveStream(roomId: $roomId) {
    message
    success
  }
}
    `;
export type EndLiveStreamMutationFn = Apollo.MutationFunction<EndLiveStreamMutation, EndLiveStreamMutationVariables>;

/**
 * __useEndLiveStreamMutation__
 *
 * To run a mutation, you first call `useEndLiveStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndLiveStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endLiveStreamMutation, { data, loading, error }] = useEndLiveStreamMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useEndLiveStreamMutation(baseOptions?: Apollo.MutationHookOptions<EndLiveStreamMutation, EndLiveStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndLiveStreamMutation, EndLiveStreamMutationVariables>(EndLiveStreamDocument, options);
      }
export type EndLiveStreamMutationHookResult = ReturnType<typeof useEndLiveStreamMutation>;
export type EndLiveStreamMutationResult = Apollo.MutationResult<EndLiveStreamMutation>;
export type EndLiveStreamMutationOptions = Apollo.BaseMutationOptions<EndLiveStreamMutation, EndLiveStreamMutationVariables>;
export const DeleteRoomDocument = gql`
    mutation DeleteRoom($roomId: String!) {
  deleteRoom(roomId: $roomId) {
    success
    message
  }
}
    `;
export type DeleteRoomMutationFn = Apollo.MutationFunction<DeleteRoomMutation, DeleteRoomMutationVariables>;

/**
 * __useDeleteRoomMutation__
 *
 * To run a mutation, you first call `useDeleteRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoomMutation, { data, loading, error }] = useDeleteRoomMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useDeleteRoomMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoomMutation, DeleteRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoomMutation, DeleteRoomMutationVariables>(DeleteRoomDocument, options);
      }
export type DeleteRoomMutationHookResult = ReturnType<typeof useDeleteRoomMutation>;
export type DeleteRoomMutationResult = Apollo.MutationResult<DeleteRoomMutation>;
export type DeleteRoomMutationOptions = Apollo.BaseMutationOptions<DeleteRoomMutation, DeleteRoomMutationVariables>;
export const OnLiveStreamChangedDocument = gql`
    subscription OnLiveStreamChanged {
  liveStreamChanged {
    type
    changeType
    roomId
    stream {
      ...LiveStreamListFields
    }
  }
}
    ${LiveStreamListFieldsFragmentDoc}`;

/**
 * __useOnLiveStreamChangedSubscription__
 *
 * To run a query within a React component, call `useOnLiveStreamChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnLiveStreamChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnLiveStreamChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnLiveStreamChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnLiveStreamChangedSubscription, OnLiveStreamChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnLiveStreamChangedSubscription, OnLiveStreamChangedSubscriptionVariables>(OnLiveStreamChangedDocument, options);
      }
export type OnLiveStreamChangedSubscriptionHookResult = ReturnType<typeof useOnLiveStreamChangedSubscription>;
export type OnLiveStreamChangedSubscriptionResult = Apollo.SubscriptionResult<OnLiveStreamChangedSubscription>;
export const LoginDocument = gql`
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    accessToken
    refreshToken
    redirectToPlans
    subscription {
      id
      planId
      status
      currentPeriodStart
      currentPeriodEnd
      planLimitsPeriodStart
      cancelAtPeriodEnd
      planSnapshot
      trialEndsAt
      graceEndsAt
      accessState
      plan {
        id
        name
        priceMonthly
        description
        companyPages
        connectionSendingLimits
        serviceListings
        groupCreation
        actionButtonOnProfile
        liveStreaming
        accessAIChatbot
      }
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const MarkNotificationAsReadDocument = gql`
    mutation MarkNotificationAsRead($input: MarkNotificationReadInput!) {
  markNotificationAsRead(input: $input)
}
    `;
export type MarkNotificationAsReadMutationFn = Apollo.MutationFunction<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument, options);
      }
export type MarkNotificationAsReadMutationHookResult = ReturnType<typeof useMarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationResult = Apollo.MutationResult<MarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    createdAt
    updatedAt
    firstName
    lastName
    middleName
    title
    phone
    role
    status
    expertise
    email
    profileImageUrl
    profileImageOptimizedUrl
    bannerImageOptimizedUrl
    imageUrl
    bannerImageUrl
    state
    profileVisitsCount
    dentalLicenseNumber
    isHiring
    openToWork
    isVerified
    headline
    about
    universityEmail
    influenceBadge {
      ...InfluenceBadgeFields
    }
    mentorSettings {
      pricing {
        price
        duration
        currency
      }
      availability {
        timezone
        weekly {
          day
          times {
            start
            end
          }
        }
      }
    }
    companyName
  }
  influenceStatus {
    enabled
    leaderboardsEnabled
  }
  myConnectionCount
  myProfileViewsLast7Days
  myActiveProfileBoost {
    ...ProfileBoostFields
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}
${ProfileBoostFieldsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
// @ts-ignore
export function useMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>): Apollo.UseSuspenseQueryResult<MeQuery, MeQueryVariables>;
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>): Apollo.UseSuspenseQueryResult<MeQuery | undefined, MeQueryVariables>;
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const UpsertMentorDayAvailabilityDocument = gql`
    mutation UpsertMentorDayAvailability($input: EditMentorDayAvailabilityInput!) {
  upsertMentorDayAvailability(input: $input)
}
    `;
export type UpsertMentorDayAvailabilityMutationFn = Apollo.MutationFunction<UpsertMentorDayAvailabilityMutation, UpsertMentorDayAvailabilityMutationVariables>;

/**
 * __useUpsertMentorDayAvailabilityMutation__
 *
 * To run a mutation, you first call `useUpsertMentorDayAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMentorDayAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMentorDayAvailabilityMutation, { data, loading, error }] = useUpsertMentorDayAvailabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertMentorDayAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMentorDayAvailabilityMutation, UpsertMentorDayAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMentorDayAvailabilityMutation, UpsertMentorDayAvailabilityMutationVariables>(UpsertMentorDayAvailabilityDocument, options);
      }
export type UpsertMentorDayAvailabilityMutationHookResult = ReturnType<typeof useUpsertMentorDayAvailabilityMutation>;
export type UpsertMentorDayAvailabilityMutationResult = Apollo.MutationResult<UpsertMentorDayAvailabilityMutation>;
export type UpsertMentorDayAvailabilityMutationOptions = Apollo.BaseMutationOptions<UpsertMentorDayAvailabilityMutation, UpsertMentorDayAvailabilityMutationVariables>;
export const ToggleMentorDayOffDocument = gql`
    mutation ToggleMentorDayOff($input: MentorDayOffInput!) {
  toggleMentorDayOff(input: $input)
}
    `;
export type ToggleMentorDayOffMutationFn = Apollo.MutationFunction<ToggleMentorDayOffMutation, ToggleMentorDayOffMutationVariables>;

/**
 * __useToggleMentorDayOffMutation__
 *
 * To run a mutation, you first call `useToggleMentorDayOffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleMentorDayOffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleMentorDayOffMutation, { data, loading, error }] = useToggleMentorDayOffMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleMentorDayOffMutation(baseOptions?: Apollo.MutationHookOptions<ToggleMentorDayOffMutation, ToggleMentorDayOffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleMentorDayOffMutation, ToggleMentorDayOffMutationVariables>(ToggleMentorDayOffDocument, options);
      }
export type ToggleMentorDayOffMutationHookResult = ReturnType<typeof useToggleMentorDayOffMutation>;
export type ToggleMentorDayOffMutationResult = Apollo.MutationResult<ToggleMentorDayOffMutation>;
export type ToggleMentorDayOffMutationOptions = Apollo.BaseMutationOptions<ToggleMentorDayOffMutation, ToggleMentorDayOffMutationVariables>;
export const MyMentorEarningsStatsDocument = gql`
    query MyMentorEarningsStats {
  myMentorEarningsStats {
    totalEarned
    thisMonthEarned
    totalSessions
    thisMonthSessions
    totalGrossVolume
    thisMonthGrossVolume
    totalRefunded
    thisMonthRefunded
    totalPlatformFees
    thisMonthPlatformFees
    totalNetEarned
    avgEarningPerSession
    monthlyBreakdown {
      month
      label
      earned
      refunded
      net
      sessions
    }
    currency
  }
}
    `;

/**
 * __useMyMentorEarningsStatsQuery__
 *
 * To run a query within a React component, call `useMyMentorEarningsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyMentorEarningsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyMentorEarningsStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyMentorEarningsStatsQuery(baseOptions?: Apollo.QueryHookOptions<MyMentorEarningsStatsQuery, MyMentorEarningsStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyMentorEarningsStatsQuery, MyMentorEarningsStatsQueryVariables>(MyMentorEarningsStatsDocument, options);
      }
export function useMyMentorEarningsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyMentorEarningsStatsQuery, MyMentorEarningsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyMentorEarningsStatsQuery, MyMentorEarningsStatsQueryVariables>(MyMentorEarningsStatsDocument, options);
        }
// @ts-ignore
export function useMyMentorEarningsStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyMentorEarningsStatsQuery, MyMentorEarningsStatsQueryVariables>): Apollo.UseSuspenseQueryResult<MyMentorEarningsStatsQuery, MyMentorEarningsStatsQueryVariables>;
export function useMyMentorEarningsStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyMentorEarningsStatsQuery, MyMentorEarningsStatsQueryVariables>): Apollo.UseSuspenseQueryResult<MyMentorEarningsStatsQuery | undefined, MyMentorEarningsStatsQueryVariables>;
export function useMyMentorEarningsStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyMentorEarningsStatsQuery, MyMentorEarningsStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyMentorEarningsStatsQuery, MyMentorEarningsStatsQueryVariables>(MyMentorEarningsStatsDocument, options);
        }
export type MyMentorEarningsStatsQueryHookResult = ReturnType<typeof useMyMentorEarningsStatsQuery>;
export type MyMentorEarningsStatsLazyQueryHookResult = ReturnType<typeof useMyMentorEarningsStatsLazyQuery>;
export type MyMentorEarningsStatsSuspenseQueryHookResult = ReturnType<typeof useMyMentorEarningsStatsSuspenseQuery>;
export type MyMentorEarningsStatsQueryResult = Apollo.QueryResult<MyMentorEarningsStatsQuery, MyMentorEarningsStatsQueryVariables>;
export const MyMentorPaymentsDocument = gql`
    query MyMentorPayments($page: Int, $limit: Int, $paymentStatus: String, $fromDate: String, $toDate: String) {
  myMentorPayments(
    page: $page
    limit: $limit
    paymentStatus: $paymentStatus
    fromDate: $fromDate
    toDate: $toDate
  ) {
    data {
      id
      studentName
      subject
      sessionStatus
      paymentStatus
      paidAmount
      sessionFeeAmount
      platformFeeAmount
      currency
      sessionDate
      sessionTime
      paidAt
      receiptUrl
      invoiceNumber
      invoiceId
      createdAt
    }
    total
    page
    limit
    totalPages
    hasMore
  }
}
    `;

/**
 * __useMyMentorPaymentsQuery__
 *
 * To run a query within a React component, call `useMyMentorPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyMentorPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyMentorPaymentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      paymentStatus: // value for 'paymentStatus'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useMyMentorPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<MyMentorPaymentsQuery, MyMentorPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyMentorPaymentsQuery, MyMentorPaymentsQueryVariables>(MyMentorPaymentsDocument, options);
      }
export function useMyMentorPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyMentorPaymentsQuery, MyMentorPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyMentorPaymentsQuery, MyMentorPaymentsQueryVariables>(MyMentorPaymentsDocument, options);
        }
// @ts-ignore
export function useMyMentorPaymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyMentorPaymentsQuery, MyMentorPaymentsQueryVariables>): Apollo.UseSuspenseQueryResult<MyMentorPaymentsQuery, MyMentorPaymentsQueryVariables>;
export function useMyMentorPaymentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyMentorPaymentsQuery, MyMentorPaymentsQueryVariables>): Apollo.UseSuspenseQueryResult<MyMentorPaymentsQuery | undefined, MyMentorPaymentsQueryVariables>;
export function useMyMentorPaymentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyMentorPaymentsQuery, MyMentorPaymentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyMentorPaymentsQuery, MyMentorPaymentsQueryVariables>(MyMentorPaymentsDocument, options);
        }
export type MyMentorPaymentsQueryHookResult = ReturnType<typeof useMyMentorPaymentsQuery>;
export type MyMentorPaymentsLazyQueryHookResult = ReturnType<typeof useMyMentorPaymentsLazyQuery>;
export type MyMentorPaymentsSuspenseQueryHookResult = ReturnType<typeof useMyMentorPaymentsSuspenseQuery>;
export type MyMentorPaymentsQueryResult = Apollo.QueryResult<MyMentorPaymentsQuery, MyMentorPaymentsQueryVariables>;
export const GenerateMentorReceiptPdfDocument = gql`
    mutation GenerateMentorReceiptPdf($invoiceId: ID!) {
  generateMentorReceiptPdf(invoiceId: $invoiceId) {
    base64Pdf
    filename
  }
}
    `;
export type GenerateMentorReceiptPdfMutationFn = Apollo.MutationFunction<GenerateMentorReceiptPdfMutation, GenerateMentorReceiptPdfMutationVariables>;

/**
 * __useGenerateMentorReceiptPdfMutation__
 *
 * To run a mutation, you first call `useGenerateMentorReceiptPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMentorReceiptPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMentorReceiptPdfMutation, { data, loading, error }] = useGenerateMentorReceiptPdfMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGenerateMentorReceiptPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateMentorReceiptPdfMutation, GenerateMentorReceiptPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateMentorReceiptPdfMutation, GenerateMentorReceiptPdfMutationVariables>(GenerateMentorReceiptPdfDocument, options);
      }
export type GenerateMentorReceiptPdfMutationHookResult = ReturnType<typeof useGenerateMentorReceiptPdfMutation>;
export type GenerateMentorReceiptPdfMutationResult = Apollo.MutationResult<GenerateMentorReceiptPdfMutation>;
export type GenerateMentorReceiptPdfMutationOptions = Apollo.BaseMutationOptions<GenerateMentorReceiptPdfMutation, GenerateMentorReceiptPdfMutationVariables>;
export const InitiateMultipartUploadDocument = gql`
    mutation InitiateMultipartUpload($input: InitiateMultipartUploadInput!) {
  initiateMultipartUpload(input: $input) {
    uploadId
    key
    fileUrl
    partSize
    totalParts
  }
}
    `;
export type InitiateMultipartUploadMutationFn = Apollo.MutationFunction<InitiateMultipartUploadMutation, InitiateMultipartUploadMutationVariables>;

/**
 * __useInitiateMultipartUploadMutation__
 *
 * To run a mutation, you first call `useInitiateMultipartUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateMultipartUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateMultipartUploadMutation, { data, loading, error }] = useInitiateMultipartUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateMultipartUploadMutation(baseOptions?: Apollo.MutationHookOptions<InitiateMultipartUploadMutation, InitiateMultipartUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateMultipartUploadMutation, InitiateMultipartUploadMutationVariables>(InitiateMultipartUploadDocument, options);
      }
export type InitiateMultipartUploadMutationHookResult = ReturnType<typeof useInitiateMultipartUploadMutation>;
export type InitiateMultipartUploadMutationResult = Apollo.MutationResult<InitiateMultipartUploadMutation>;
export type InitiateMultipartUploadMutationOptions = Apollo.BaseMutationOptions<InitiateMultipartUploadMutation, InitiateMultipartUploadMutationVariables>;
export const UploadMultipartPartDocument = gql`
    mutation UploadMultipartPart($input: MultipartUploadPartInput!) {
  uploadMultipartPart(input: $input) {
    partNumber
    eTag
  }
}
    `;
export type UploadMultipartPartMutationFn = Apollo.MutationFunction<UploadMultipartPartMutation, UploadMultipartPartMutationVariables>;

/**
 * __useUploadMultipartPartMutation__
 *
 * To run a mutation, you first call `useUploadMultipartPartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMultipartPartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMultipartPartMutation, { data, loading, error }] = useUploadMultipartPartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadMultipartPartMutation(baseOptions?: Apollo.MutationHookOptions<UploadMultipartPartMutation, UploadMultipartPartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMultipartPartMutation, UploadMultipartPartMutationVariables>(UploadMultipartPartDocument, options);
      }
export type UploadMultipartPartMutationHookResult = ReturnType<typeof useUploadMultipartPartMutation>;
export type UploadMultipartPartMutationResult = Apollo.MutationResult<UploadMultipartPartMutation>;
export type UploadMultipartPartMutationOptions = Apollo.BaseMutationOptions<UploadMultipartPartMutation, UploadMultipartPartMutationVariables>;
export const CompleteMultipartUploadDocument = gql`
    mutation CompleteMultipartUpload($input: CompleteMultipartUploadInput!) {
  completeMultipartUpload(input: $input) {
    id
    fileName
    fileUrl
    mimeType
    size
    type
  }
}
    `;
export type CompleteMultipartUploadMutationFn = Apollo.MutationFunction<CompleteMultipartUploadMutation, CompleteMultipartUploadMutationVariables>;

/**
 * __useCompleteMultipartUploadMutation__
 *
 * To run a mutation, you first call `useCompleteMultipartUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteMultipartUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeMultipartUploadMutation, { data, loading, error }] = useCompleteMultipartUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteMultipartUploadMutation(baseOptions?: Apollo.MutationHookOptions<CompleteMultipartUploadMutation, CompleteMultipartUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteMultipartUploadMutation, CompleteMultipartUploadMutationVariables>(CompleteMultipartUploadDocument, options);
      }
export type CompleteMultipartUploadMutationHookResult = ReturnType<typeof useCompleteMultipartUploadMutation>;
export type CompleteMultipartUploadMutationResult = Apollo.MutationResult<CompleteMultipartUploadMutation>;
export type CompleteMultipartUploadMutationOptions = Apollo.BaseMutationOptions<CompleteMultipartUploadMutation, CompleteMultipartUploadMutationVariables>;
export const AbortMultipartUploadDocument = gql`
    mutation AbortMultipartUpload($input: AbortMultipartUploadInput!) {
  abortMultipartUpload(input: $input)
}
    `;
export type AbortMultipartUploadMutationFn = Apollo.MutationFunction<AbortMultipartUploadMutation, AbortMultipartUploadMutationVariables>;

/**
 * __useAbortMultipartUploadMutation__
 *
 * To run a mutation, you first call `useAbortMultipartUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbortMultipartUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abortMultipartUploadMutation, { data, loading, error }] = useAbortMultipartUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAbortMultipartUploadMutation(baseOptions?: Apollo.MutationHookOptions<AbortMultipartUploadMutation, AbortMultipartUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AbortMultipartUploadMutation, AbortMultipartUploadMutationVariables>(AbortMultipartUploadDocument, options);
      }
export type AbortMultipartUploadMutationHookResult = ReturnType<typeof useAbortMultipartUploadMutation>;
export type AbortMultipartUploadMutationResult = Apollo.MutationResult<AbortMultipartUploadMutation>;
export type AbortMultipartUploadMutationOptions = Apollo.BaseMutationOptions<AbortMultipartUploadMutation, AbortMultipartUploadMutationVariables>;
export const GetUserPostsDocument = gql`
    query getUserPosts($input: GetUserPostsInput!) {
  getUserPosts(input: $input) {
    id
    isRepost
    repostComment
    originalPostId
    postType
    companyId
    contentTokens {
      type
      value
      handle
      userId
      url
    }
    translatedContentTokens {
      type
      value
      handle
      userId
      url
    }
    author {
      id
      firstName
      lastName
      title
      middleName
      profileImageUrl
      role
      headline
      isHiring
      openToWork
      isMentorVerified
      influenceBadge {
        ...InfluenceBadgeFields
      }
      connection {
        status
        direction
      }
      actionButtons {
        id
        name
        url
        isShow
        createdAt
      }
      createdAt
      updatedAt
      companyName
    }
    originalPost {
      id
      contentTokens {
        type
        value
        handle
        userId
        url
      }
      translatedContentTokens {
        type
        value
        handle
        userId
        url
      }
      author {
        id
        firstName
        lastName
        title
        middleName
        profileImageUrl
        role
        headline
        isHiring
        openToWork
        isMentorVerified
        influenceBadge {
          ...InfluenceBadgeFields
        }
        connection {
          status
          direction
        }
        actionButtons {
          id
          name
          url
          isShow
          createdAt
        }
        createdAt
        updatedAt
        companyName
      }
      mediaUrls
      reactions {
        reactionCounts {
          type
          count
        }
        totalReactions
        currentUserReaction
      }
      article {
        id
        title
        subtitle
        coverImageUrl
        slug
        readingTimeMinutes
        tags
        content
        status
        translatedTitle
        translatedSubtitle
        translatedExcerpt
      }
      companyAuthor {
        id
        name
        logoUrl
        industry
        tagline
        followersCount
        isFollowing
      }
      poll {
        question
        expiresAt
        options {
          id
          text
          votes
          isChosen
        }
        translatedQuestion
        translatedOptions
      }
      occasion {
        id
        postId
        title
        description
        imageUrl
        privacy
        translatedTitle
        translatedDescription
      }
      event {
        id
        name
        description
        imageUrl
        startTime
        endTime
        location
        category
        maxAttendees
        participantsCount
        isjoinedbyMe
        organizedby {
          userId
          name
          imageUrl
          companyName
        }
        course {
          id
          title
          thumbnailUrl
        }
      }
      case {
        id
        postId
        createdAt
        updatedAt
        media {
          id
          step
          type
          imageUrl
          text
          order
          createdAt
          translatedText
        }
      }
      commentsCount
      isSavedByMe
      isRepostedByMe
      isPublished
      isBoosted
      activeBoostId
      createdAt
      updatedAt
    }
    mediaUrls
    reactions {
      reactionCounts {
        type
        count
      }
      totalReactions
      currentUserReaction
    }
    article {
      id
      title
      subtitle
      coverImageUrl
      slug
      readingTimeMinutes
      tags
      content
      status
      translatedTitle
      translatedSubtitle
      translatedExcerpt
    }
    companyAuthor {
      id
      name
      logoUrl
      industry
      tagline
      followersCount
      isFollowing
    }
    poll {
      question
      expiresAt
      options {
        id
        text
        votes
        isChosen
      }
      translatedQuestion
      translatedOptions
    }
    occasion {
      id
      postId
      title
      description
      imageUrl
      privacy
      translatedTitle
      translatedDescription
    }
    event {
      id
      name
      description
      imageUrl
      startTime
      endTime
      location
      category
      maxAttendees
      participantsCount
      isjoinedbyMe
      organizedby {
        userId
        name
        imageUrl
        companyName
      }
      course {
        id
        title
        thumbnailUrl
      }
    }
    case {
      id
      postId
      createdAt
      updatedAt
      media {
        id
        step
        type
        imageUrl
        text
        order
        createdAt
        translatedText
      }
    }
    isSavedByMe
    isRepostedByMe
    isPublished
    isBoosted
    activeBoostId
    createdAt
    updatedAt
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetUserPostsQuery__
 *
 * To run a query within a React component, call `useGetUserPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPostsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserPostsQuery(baseOptions: Apollo.QueryHookOptions<GetUserPostsQuery, GetUserPostsQueryVariables> & ({ variables: GetUserPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPostsQuery, GetUserPostsQueryVariables>(GetUserPostsDocument, options);
      }
export function useGetUserPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPostsQuery, GetUserPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPostsQuery, GetUserPostsQueryVariables>(GetUserPostsDocument, options);
        }
// @ts-ignore
export function useGetUserPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserPostsQuery, GetUserPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserPostsQuery, GetUserPostsQueryVariables>;
export function useGetUserPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPostsQuery, GetUserPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserPostsQuery | undefined, GetUserPostsQueryVariables>;
export function useGetUserPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPostsQuery, GetUserPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPostsQuery, GetUserPostsQueryVariables>(GetUserPostsDocument, options);
        }
export type GetUserPostsQueryHookResult = ReturnType<typeof useGetUserPostsQuery>;
export type GetUserPostsLazyQueryHookResult = ReturnType<typeof useGetUserPostsLazyQuery>;
export type GetUserPostsSuspenseQueryHookResult = ReturnType<typeof useGetUserPostsSuspenseQuery>;
export type GetUserPostsQueryResult = Apollo.QueryResult<GetUserPostsQuery, GetUserPostsQueryVariables>;
export const CreateNewsletterDocument = gql`
    mutation CreateNewsletter($input: CreateNewsletterInput!) {
  createNewsletter(input: $input)
}
    `;
export type CreateNewsletterMutationFn = Apollo.MutationFunction<CreateNewsletterMutation, CreateNewsletterMutationVariables>;

/**
 * __useCreateNewsletterMutation__
 *
 * To run a mutation, you first call `useCreateNewsletterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewsletterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewsletterMutation, { data, loading, error }] = useCreateNewsletterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewsletterMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewsletterMutation, CreateNewsletterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewsletterMutation, CreateNewsletterMutationVariables>(CreateNewsletterDocument, options);
      }
export type CreateNewsletterMutationHookResult = ReturnType<typeof useCreateNewsletterMutation>;
export type CreateNewsletterMutationResult = Apollo.MutationResult<CreateNewsletterMutation>;
export type CreateNewsletterMutationOptions = Apollo.BaseMutationOptions<CreateNewsletterMutation, CreateNewsletterMutationVariables>;
export const MarkPostNotInterestedDocument = gql`
    mutation MarkPostNotInterested($postId: String!) {
  markPostNotInterested(postId: $postId)
}
    `;
export type MarkPostNotInterestedMutationFn = Apollo.MutationFunction<MarkPostNotInterestedMutation, MarkPostNotInterestedMutationVariables>;

/**
 * __useMarkPostNotInterestedMutation__
 *
 * To run a mutation, you first call `useMarkPostNotInterestedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPostNotInterestedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPostNotInterestedMutation, { data, loading, error }] = useMarkPostNotInterestedMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useMarkPostNotInterestedMutation(baseOptions?: Apollo.MutationHookOptions<MarkPostNotInterestedMutation, MarkPostNotInterestedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkPostNotInterestedMutation, MarkPostNotInterestedMutationVariables>(MarkPostNotInterestedDocument, options);
      }
export type MarkPostNotInterestedMutationHookResult = ReturnType<typeof useMarkPostNotInterestedMutation>;
export type MarkPostNotInterestedMutationResult = Apollo.MutationResult<MarkPostNotInterestedMutation>;
export type MarkPostNotInterestedMutationOptions = Apollo.BaseMutationOptions<MarkPostNotInterestedMutation, MarkPostNotInterestedMutationVariables>;
export const CreateOccasionPostDocument = gql`
    mutation CreateOccasionPost($input: CreateOccasionPostInput!) {
  createOccasionPost(input: $input)
}
    `;
export type CreateOccasionPostMutationFn = Apollo.MutationFunction<CreateOccasionPostMutation, CreateOccasionPostMutationVariables>;

/**
 * __useCreateOccasionPostMutation__
 *
 * To run a mutation, you first call `useCreateOccasionPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOccasionPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOccasionPostMutation, { data, loading, error }] = useCreateOccasionPostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOccasionPostMutation(baseOptions?: Apollo.MutationHookOptions<CreateOccasionPostMutation, CreateOccasionPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOccasionPostMutation, CreateOccasionPostMutationVariables>(CreateOccasionPostDocument, options);
      }
export type CreateOccasionPostMutationHookResult = ReturnType<typeof useCreateOccasionPostMutation>;
export type CreateOccasionPostMutationResult = Apollo.MutationResult<CreateOccasionPostMutation>;
export type CreateOccasionPostMutationOptions = Apollo.BaseMutationOptions<CreateOccasionPostMutation, CreateOccasionPostMutationVariables>;
export const GetOccasionByPostIdDocument = gql`
    query GetOccasionByPostId($postId: String!) {
  getOccasionByPostId(postId: $postId) {
    id
    postId
    title
    description
    imageUrl
    privacy
  }
}
    `;

/**
 * __useGetOccasionByPostIdQuery__
 *
 * To run a query within a React component, call `useGetOccasionByPostIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOccasionByPostIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOccasionByPostIdQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetOccasionByPostIdQuery(baseOptions: Apollo.QueryHookOptions<GetOccasionByPostIdQuery, GetOccasionByPostIdQueryVariables> & ({ variables: GetOccasionByPostIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOccasionByPostIdQuery, GetOccasionByPostIdQueryVariables>(GetOccasionByPostIdDocument, options);
      }
export function useGetOccasionByPostIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOccasionByPostIdQuery, GetOccasionByPostIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOccasionByPostIdQuery, GetOccasionByPostIdQueryVariables>(GetOccasionByPostIdDocument, options);
        }
// @ts-ignore
export function useGetOccasionByPostIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOccasionByPostIdQuery, GetOccasionByPostIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetOccasionByPostIdQuery, GetOccasionByPostIdQueryVariables>;
export function useGetOccasionByPostIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOccasionByPostIdQuery, GetOccasionByPostIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetOccasionByPostIdQuery | undefined, GetOccasionByPostIdQueryVariables>;
export function useGetOccasionByPostIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOccasionByPostIdQuery, GetOccasionByPostIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOccasionByPostIdQuery, GetOccasionByPostIdQueryVariables>(GetOccasionByPostIdDocument, options);
        }
export type GetOccasionByPostIdQueryHookResult = ReturnType<typeof useGetOccasionByPostIdQuery>;
export type GetOccasionByPostIdLazyQueryHookResult = ReturnType<typeof useGetOccasionByPostIdLazyQuery>;
export type GetOccasionByPostIdSuspenseQueryHookResult = ReturnType<typeof useGetOccasionByPostIdSuspenseQuery>;
export type GetOccasionByPostIdQueryResult = Apollo.QueryResult<GetOccasionByPostIdQuery, GetOccasionByPostIdQueryVariables>;
export const CallSendDocument = gql`
    mutation CallSend($input: CallSendInput!) {
  callSend(input: $input) {
    success
    message
    room
    token
  }
}
    `;
export type CallSendMutationFn = Apollo.MutationFunction<CallSendMutation, CallSendMutationVariables>;

/**
 * __useCallSendMutation__
 *
 * To run a mutation, you first call `useCallSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callSendMutation, { data, loading, error }] = useCallSendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCallSendMutation(baseOptions?: Apollo.MutationHookOptions<CallSendMutation, CallSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CallSendMutation, CallSendMutationVariables>(CallSendDocument, options);
      }
export type CallSendMutationHookResult = ReturnType<typeof useCallSendMutation>;
export type CallSendMutationResult = Apollo.MutationResult<CallSendMutation>;
export type CallSendMutationOptions = Apollo.BaseMutationOptions<CallSendMutation, CallSendMutationVariables>;
export const ReceiveCallDocument = gql`
    mutation ReceiveCall($input: CallSendInput!) {
  receiveCall(input: $input) {
    success
    message
    room
    token
  }
}
    `;
export type ReceiveCallMutationFn = Apollo.MutationFunction<ReceiveCallMutation, ReceiveCallMutationVariables>;

/**
 * __useReceiveCallMutation__
 *
 * To run a mutation, you first call `useReceiveCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReceiveCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [receiveCallMutation, { data, loading, error }] = useReceiveCallMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReceiveCallMutation(baseOptions?: Apollo.MutationHookOptions<ReceiveCallMutation, ReceiveCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReceiveCallMutation, ReceiveCallMutationVariables>(ReceiveCallDocument, options);
      }
export type ReceiveCallMutationHookResult = ReturnType<typeof useReceiveCallMutation>;
export type ReceiveCallMutationResult = Apollo.MutationResult<ReceiveCallMutation>;
export type ReceiveCallMutationOptions = Apollo.BaseMutationOptions<ReceiveCallMutation, ReceiveCallMutationVariables>;
export const RejectCallDocument = gql`
    mutation RejectCall($input: CallSendInput!) {
  rejectCall(input: $input) {
    success
    message
    room
    token
  }
}
    `;
export type RejectCallMutationFn = Apollo.MutationFunction<RejectCallMutation, RejectCallMutationVariables>;

/**
 * __useRejectCallMutation__
 *
 * To run a mutation, you first call `useRejectCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectCallMutation, { data, loading, error }] = useRejectCallMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectCallMutation(baseOptions?: Apollo.MutationHookOptions<RejectCallMutation, RejectCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectCallMutation, RejectCallMutationVariables>(RejectCallDocument, options);
      }
export type RejectCallMutationHookResult = ReturnType<typeof useRejectCallMutation>;
export type RejectCallMutationResult = Apollo.MutationResult<RejectCallMutation>;
export type RejectCallMutationOptions = Apollo.BaseMutationOptions<RejectCallMutation, RejectCallMutationVariables>;
export const CallMissedDocument = gql`
    mutation CallMissed($input: CallSendInput!) {
  callMissed(input: $input) {
    success
    message
    room
    token
  }
}
    `;
export type CallMissedMutationFn = Apollo.MutationFunction<CallMissedMutation, CallMissedMutationVariables>;

/**
 * __useCallMissedMutation__
 *
 * To run a mutation, you first call `useCallMissedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallMissedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callMissedMutation, { data, loading, error }] = useCallMissedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCallMissedMutation(baseOptions?: Apollo.MutationHookOptions<CallMissedMutation, CallMissedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CallMissedMutation, CallMissedMutationVariables>(CallMissedDocument, options);
      }
export type CallMissedMutationHookResult = ReturnType<typeof useCallMissedMutation>;
export type CallMissedMutationResult = Apollo.MutationResult<CallMissedMutation>;
export type CallMissedMutationOptions = Apollo.BaseMutationOptions<CallMissedMutation, CallMissedMutationVariables>;
export const CallCancleDocument = gql`
    mutation CallCancle($input: CallSendInput!) {
  callCancle(input: $input) {
    success
    message
    room
    token
  }
}
    `;
export type CallCancleMutationFn = Apollo.MutationFunction<CallCancleMutation, CallCancleMutationVariables>;

/**
 * __useCallCancleMutation__
 *
 * To run a mutation, you first call `useCallCancleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallCancleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callCancleMutation, { data, loading, error }] = useCallCancleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCallCancleMutation(baseOptions?: Apollo.MutationHookOptions<CallCancleMutation, CallCancleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CallCancleMutation, CallCancleMutationVariables>(CallCancleDocument, options);
      }
export type CallCancleMutationHookResult = ReturnType<typeof useCallCancleMutation>;
export type CallCancleMutationResult = Apollo.MutationResult<CallCancleMutation>;
export type CallCancleMutationOptions = Apollo.BaseMutationOptions<CallCancleMutation, CallCancleMutationVariables>;
export const UpdateOpenToWorkDocument = gql`
    mutation UpdateOpenToWork($openToWork: Boolean!) {
  updateOpenToWork(openToWork: $openToWork)
}
    `;
export type UpdateOpenToWorkMutationFn = Apollo.MutationFunction<UpdateOpenToWorkMutation, UpdateOpenToWorkMutationVariables>;

/**
 * __useUpdateOpenToWorkMutation__
 *
 * To run a mutation, you first call `useUpdateOpenToWorkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpenToWorkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpenToWorkMutation, { data, loading, error }] = useUpdateOpenToWorkMutation({
 *   variables: {
 *      openToWork: // value for 'openToWork'
 *   },
 * });
 */
export function useUpdateOpenToWorkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOpenToWorkMutation, UpdateOpenToWorkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOpenToWorkMutation, UpdateOpenToWorkMutationVariables>(UpdateOpenToWorkDocument, options);
      }
export type UpdateOpenToWorkMutationHookResult = ReturnType<typeof useUpdateOpenToWorkMutation>;
export type UpdateOpenToWorkMutationResult = Apollo.MutationResult<UpdateOpenToWorkMutation>;
export type UpdateOpenToWorkMutationOptions = Apollo.BaseMutationOptions<UpdateOpenToWorkMutation, UpdateOpenToWorkMutationVariables>;
export const GetOpenToWorkDocument = gql`
    query GetOpenToWork {
  getOpenToWork
}
    `;

/**
 * __useGetOpenToWorkQuery__
 *
 * To run a query within a React component, call `useGetOpenToWorkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenToWorkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpenToWorkQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOpenToWorkQuery(baseOptions?: Apollo.QueryHookOptions<GetOpenToWorkQuery, GetOpenToWorkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpenToWorkQuery, GetOpenToWorkQueryVariables>(GetOpenToWorkDocument, options);
      }
export function useGetOpenToWorkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpenToWorkQuery, GetOpenToWorkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpenToWorkQuery, GetOpenToWorkQueryVariables>(GetOpenToWorkDocument, options);
        }
// @ts-ignore
export function useGetOpenToWorkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOpenToWorkQuery, GetOpenToWorkQueryVariables>): Apollo.UseSuspenseQueryResult<GetOpenToWorkQuery, GetOpenToWorkQueryVariables>;
export function useGetOpenToWorkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOpenToWorkQuery, GetOpenToWorkQueryVariables>): Apollo.UseSuspenseQueryResult<GetOpenToWorkQuery | undefined, GetOpenToWorkQueryVariables>;
export function useGetOpenToWorkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOpenToWorkQuery, GetOpenToWorkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOpenToWorkQuery, GetOpenToWorkQueryVariables>(GetOpenToWorkDocument, options);
        }
export type GetOpenToWorkQueryHookResult = ReturnType<typeof useGetOpenToWorkQuery>;
export type GetOpenToWorkLazyQueryHookResult = ReturnType<typeof useGetOpenToWorkLazyQuery>;
export type GetOpenToWorkSuspenseQueryHookResult = ReturnType<typeof useGetOpenToWorkSuspenseQuery>;
export type GetOpenToWorkQueryResult = Apollo.QueryResult<GetOpenToWorkQuery, GetOpenToWorkQueryVariables>;
export const PayoutOnboardingLinkDocument = gql`
    mutation PayoutOnboardingLink {
  payoutOnboardingLink
}
    `;
export type PayoutOnboardingLinkMutationFn = Apollo.MutationFunction<PayoutOnboardingLinkMutation, PayoutOnboardingLinkMutationVariables>;

/**
 * __usePayoutOnboardingLinkMutation__
 *
 * To run a mutation, you first call `usePayoutOnboardingLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayoutOnboardingLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payoutOnboardingLinkMutation, { data, loading, error }] = usePayoutOnboardingLinkMutation({
 *   variables: {
 *   },
 * });
 */
export function usePayoutOnboardingLinkMutation(baseOptions?: Apollo.MutationHookOptions<PayoutOnboardingLinkMutation, PayoutOnboardingLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayoutOnboardingLinkMutation, PayoutOnboardingLinkMutationVariables>(PayoutOnboardingLinkDocument, options);
      }
export type PayoutOnboardingLinkMutationHookResult = ReturnType<typeof usePayoutOnboardingLinkMutation>;
export type PayoutOnboardingLinkMutationResult = Apollo.MutationResult<PayoutOnboardingLinkMutation>;
export type PayoutOnboardingLinkMutationOptions = Apollo.BaseMutationOptions<PayoutOnboardingLinkMutation, PayoutOnboardingLinkMutationVariables>;
export const ReVerifyPayoutAccountDocument = gql`
    mutation ReVerifyPayoutAccount {
  reVerifyPayoutAccount {
    id
    verified
    verifiedAt
    status
    isPaymentsActive
    isProviderAccountClosed
    disconnectedAt
    providerAccountId
    chargesEnabled
    payoutsEnabled
    detailsSubmitted
    businessType
    businessUrl
    supportEmail
    supportPhone
    mcc
    defaultCurrency
    providerAccountCreatedAt
    cardPaymentsStatus
    transfersStatus
    requirementsCurrentlyDue
    requirementsPastDue
    requirementsEventuallyDue
    requirementsDisabledReason
    externalAccountBankName
    externalAccountLast4
  }
}
    `;
export type ReVerifyPayoutAccountMutationFn = Apollo.MutationFunction<ReVerifyPayoutAccountMutation, ReVerifyPayoutAccountMutationVariables>;

/**
 * __useReVerifyPayoutAccountMutation__
 *
 * To run a mutation, you first call `useReVerifyPayoutAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReVerifyPayoutAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reVerifyPayoutAccountMutation, { data, loading, error }] = useReVerifyPayoutAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useReVerifyPayoutAccountMutation(baseOptions?: Apollo.MutationHookOptions<ReVerifyPayoutAccountMutation, ReVerifyPayoutAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReVerifyPayoutAccountMutation, ReVerifyPayoutAccountMutationVariables>(ReVerifyPayoutAccountDocument, options);
      }
export type ReVerifyPayoutAccountMutationHookResult = ReturnType<typeof useReVerifyPayoutAccountMutation>;
export type ReVerifyPayoutAccountMutationResult = Apollo.MutationResult<ReVerifyPayoutAccountMutation>;
export type ReVerifyPayoutAccountMutationOptions = Apollo.BaseMutationOptions<ReVerifyPayoutAccountMutation, ReVerifyPayoutAccountMutationVariables>;
export const DisconnectPayoutAccountDocument = gql`
    mutation DisconnectPayoutAccount {
  disconnectPayoutAccount
}
    `;
export type DisconnectPayoutAccountMutationFn = Apollo.MutationFunction<DisconnectPayoutAccountMutation, DisconnectPayoutAccountMutationVariables>;

/**
 * __useDisconnectPayoutAccountMutation__
 *
 * To run a mutation, you first call `useDisconnectPayoutAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectPayoutAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectPayoutAccountMutation, { data, loading, error }] = useDisconnectPayoutAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisconnectPayoutAccountMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectPayoutAccountMutation, DisconnectPayoutAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectPayoutAccountMutation, DisconnectPayoutAccountMutationVariables>(DisconnectPayoutAccountDocument, options);
      }
export type DisconnectPayoutAccountMutationHookResult = ReturnType<typeof useDisconnectPayoutAccountMutation>;
export type DisconnectPayoutAccountMutationResult = Apollo.MutationResult<DisconnectPayoutAccountMutation>;
export type DisconnectPayoutAccountMutationOptions = Apollo.BaseMutationOptions<DisconnectPayoutAccountMutation, DisconnectPayoutAccountMutationVariables>;
export const ReconnectPayoutAccountDocument = gql`
    mutation ReconnectPayoutAccount {
  reconnectPayoutAccount {
    id
    status
    verified
    verifiedAt
    disconnectedAt
    isPaymentsActive
    isProviderAccountClosed
    providerAccountId
    chargesEnabled
    payoutsEnabled
    detailsSubmitted
    accountName
    accountEmail
  }
}
    `;
export type ReconnectPayoutAccountMutationFn = Apollo.MutationFunction<ReconnectPayoutAccountMutation, ReconnectPayoutAccountMutationVariables>;

/**
 * __useReconnectPayoutAccountMutation__
 *
 * To run a mutation, you first call `useReconnectPayoutAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReconnectPayoutAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reconnectPayoutAccountMutation, { data, loading, error }] = useReconnectPayoutAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useReconnectPayoutAccountMutation(baseOptions?: Apollo.MutationHookOptions<ReconnectPayoutAccountMutation, ReconnectPayoutAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReconnectPayoutAccountMutation, ReconnectPayoutAccountMutationVariables>(ReconnectPayoutAccountDocument, options);
      }
export type ReconnectPayoutAccountMutationHookResult = ReturnType<typeof useReconnectPayoutAccountMutation>;
export type ReconnectPayoutAccountMutationResult = Apollo.MutationResult<ReconnectPayoutAccountMutation>;
export type ReconnectPayoutAccountMutationOptions = Apollo.BaseMutationOptions<ReconnectPayoutAccountMutation, ReconnectPayoutAccountMutationVariables>;
export const PayoutDashboardLinkDocument = gql`
    mutation PayoutDashboardLink {
  payoutDashboardLink
}
    `;
export type PayoutDashboardLinkMutationFn = Apollo.MutationFunction<PayoutDashboardLinkMutation, PayoutDashboardLinkMutationVariables>;

/**
 * __usePayoutDashboardLinkMutation__
 *
 * To run a mutation, you first call `usePayoutDashboardLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayoutDashboardLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payoutDashboardLinkMutation, { data, loading, error }] = usePayoutDashboardLinkMutation({
 *   variables: {
 *   },
 * });
 */
export function usePayoutDashboardLinkMutation(baseOptions?: Apollo.MutationHookOptions<PayoutDashboardLinkMutation, PayoutDashboardLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayoutDashboardLinkMutation, PayoutDashboardLinkMutationVariables>(PayoutDashboardLinkDocument, options);
      }
export type PayoutDashboardLinkMutationHookResult = ReturnType<typeof usePayoutDashboardLinkMutation>;
export type PayoutDashboardLinkMutationResult = Apollo.MutationResult<PayoutDashboardLinkMutation>;
export type PayoutDashboardLinkMutationOptions = Apollo.BaseMutationOptions<PayoutDashboardLinkMutation, PayoutDashboardLinkMutationVariables>;
export const MyPayoutAccountDocument = gql`
    query MyPayoutAccount {
  myPayoutAccount {
    id
    userId
    provider
    providerAccountId
    status
    verified
    verifiedAt
    disconnectedAt
    isPaymentsActive
    isProviderAccountClosed
    mode
    accountName
    accountEmail
    accountCountry
    chargesEnabled
    payoutsEnabled
    detailsSubmitted
    businessType
    businessUrl
    supportEmail
    supportPhone
    mcc
    defaultCurrency
    providerAccountCreatedAt
    cardPaymentsStatus
    transfersStatus
    requirementsCurrentlyDue
    requirementsPastDue
    requirementsEventuallyDue
    requirementsDisabledReason
    externalAccountBankName
    externalAccountLast4
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useMyPayoutAccountQuery__
 *
 * To run a query within a React component, call `useMyPayoutAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPayoutAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPayoutAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPayoutAccountQuery(baseOptions?: Apollo.QueryHookOptions<MyPayoutAccountQuery, MyPayoutAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPayoutAccountQuery, MyPayoutAccountQueryVariables>(MyPayoutAccountDocument, options);
      }
export function useMyPayoutAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPayoutAccountQuery, MyPayoutAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPayoutAccountQuery, MyPayoutAccountQueryVariables>(MyPayoutAccountDocument, options);
        }
// @ts-ignore
export function useMyPayoutAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyPayoutAccountQuery, MyPayoutAccountQueryVariables>): Apollo.UseSuspenseQueryResult<MyPayoutAccountQuery, MyPayoutAccountQueryVariables>;
export function useMyPayoutAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyPayoutAccountQuery, MyPayoutAccountQueryVariables>): Apollo.UseSuspenseQueryResult<MyPayoutAccountQuery | undefined, MyPayoutAccountQueryVariables>;
export function useMyPayoutAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyPayoutAccountQuery, MyPayoutAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyPayoutAccountQuery, MyPayoutAccountQueryVariables>(MyPayoutAccountDocument, options);
        }
export type MyPayoutAccountQueryHookResult = ReturnType<typeof useMyPayoutAccountQuery>;
export type MyPayoutAccountLazyQueryHookResult = ReturnType<typeof useMyPayoutAccountLazyQuery>;
export type MyPayoutAccountSuspenseQueryHookResult = ReturnType<typeof useMyPayoutAccountSuspenseQuery>;
export type MyPayoutAccountQueryResult = Apollo.QueryResult<MyPayoutAccountQuery, MyPayoutAccountQueryVariables>;
export const PlatformCommissionRateDocument = gql`
    query PlatformCommissionRate {
  platformCommissionRate
}
    `;

/**
 * __usePlatformCommissionRateQuery__
 *
 * To run a query within a React component, call `usePlatformCommissionRateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformCommissionRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformCommissionRateQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlatformCommissionRateQuery(baseOptions?: Apollo.QueryHookOptions<PlatformCommissionRateQuery, PlatformCommissionRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformCommissionRateQuery, PlatformCommissionRateQueryVariables>(PlatformCommissionRateDocument, options);
      }
export function usePlatformCommissionRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlatformCommissionRateQuery, PlatformCommissionRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformCommissionRateQuery, PlatformCommissionRateQueryVariables>(PlatformCommissionRateDocument, options);
        }
// @ts-ignore
export function usePlatformCommissionRateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlatformCommissionRateQuery, PlatformCommissionRateQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformCommissionRateQuery, PlatformCommissionRateQueryVariables>;
export function usePlatformCommissionRateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformCommissionRateQuery, PlatformCommissionRateQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformCommissionRateQuery | undefined, PlatformCommissionRateQueryVariables>;
export function usePlatformCommissionRateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformCommissionRateQuery, PlatformCommissionRateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlatformCommissionRateQuery, PlatformCommissionRateQueryVariables>(PlatformCommissionRateDocument, options);
        }
export type PlatformCommissionRateQueryHookResult = ReturnType<typeof usePlatformCommissionRateQuery>;
export type PlatformCommissionRateLazyQueryHookResult = ReturnType<typeof usePlatformCommissionRateLazyQuery>;
export type PlatformCommissionRateSuspenseQueryHookResult = ReturnType<typeof usePlatformCommissionRateSuspenseQuery>;
export type PlatformCommissionRateQueryResult = Apollo.QueryResult<PlatformCommissionRateQuery, PlatformCommissionRateQueryVariables>;
export const PlatformStripePublishableKeyDocument = gql`
    query PlatformStripePublishableKey {
  platformStripePublishableKey
}
    `;

/**
 * __usePlatformStripePublishableKeyQuery__
 *
 * To run a query within a React component, call `usePlatformStripePublishableKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformStripePublishableKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformStripePublishableKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlatformStripePublishableKeyQuery(baseOptions?: Apollo.QueryHookOptions<PlatformStripePublishableKeyQuery, PlatformStripePublishableKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformStripePublishableKeyQuery, PlatformStripePublishableKeyQueryVariables>(PlatformStripePublishableKeyDocument, options);
      }
export function usePlatformStripePublishableKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlatformStripePublishableKeyQuery, PlatformStripePublishableKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformStripePublishableKeyQuery, PlatformStripePublishableKeyQueryVariables>(PlatformStripePublishableKeyDocument, options);
        }
// @ts-ignore
export function usePlatformStripePublishableKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlatformStripePublishableKeyQuery, PlatformStripePublishableKeyQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformStripePublishableKeyQuery, PlatformStripePublishableKeyQueryVariables>;
export function usePlatformStripePublishableKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformStripePublishableKeyQuery, PlatformStripePublishableKeyQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformStripePublishableKeyQuery | undefined, PlatformStripePublishableKeyQueryVariables>;
export function usePlatformStripePublishableKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformStripePublishableKeyQuery, PlatformStripePublishableKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlatformStripePublishableKeyQuery, PlatformStripePublishableKeyQueryVariables>(PlatformStripePublishableKeyDocument, options);
        }
export type PlatformStripePublishableKeyQueryHookResult = ReturnType<typeof usePlatformStripePublishableKeyQuery>;
export type PlatformStripePublishableKeyLazyQueryHookResult = ReturnType<typeof usePlatformStripePublishableKeyLazyQuery>;
export type PlatformStripePublishableKeySuspenseQueryHookResult = ReturnType<typeof usePlatformStripePublishableKeySuspenseQuery>;
export type PlatformStripePublishableKeyQueryResult = Apollo.QueryResult<PlatformStripePublishableKeyQuery, PlatformStripePublishableKeyQueryVariables>;
export const OnPodcastActivityDocument = gql`
    subscription OnPodcastActivity($episodeId: ID!) {
  podcastActivity(episodeId: $episodeId) {
    type
    changeType
    episodeId
    actorId
    likesCount
    actorLiked
    commentsCount
    commentId
    parentCommentId
    repliesCount
    commentLikesCount
    actorCommentLiked
    comment {
      ...PodcastCommentFields
    }
  }
}
    ${PodcastCommentFieldsFragmentDoc}`;

/**
 * __useOnPodcastActivitySubscription__
 *
 * To run a query within a React component, call `useOnPodcastActivitySubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnPodcastActivitySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnPodcastActivitySubscription({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useOnPodcastActivitySubscription(baseOptions: Apollo.SubscriptionHookOptions<OnPodcastActivitySubscription, OnPodcastActivitySubscriptionVariables> & ({ variables: OnPodcastActivitySubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnPodcastActivitySubscription, OnPodcastActivitySubscriptionVariables>(OnPodcastActivityDocument, options);
      }
export type OnPodcastActivitySubscriptionHookResult = ReturnType<typeof useOnPodcastActivitySubscription>;
export type OnPodcastActivitySubscriptionResult = Apollo.SubscriptionResult<OnPodcastActivitySubscription>;
export const PodcastEpisodesDocument = gql`
    query PodcastEpisodes($input: GetPodcastEpisodesInput) {
  podcastEpisodes(input: $input) {
    items {
      ...PodcastEpisodeFields
    }
    total
    hasMore
    nextCursor
  }
}
    ${PodcastEpisodeFieldsFragmentDoc}`;

/**
 * __usePodcastEpisodesQuery__
 *
 * To run a query within a React component, call `usePodcastEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodcastEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodcastEpisodesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePodcastEpisodesQuery(baseOptions?: Apollo.QueryHookOptions<PodcastEpisodesQuery, PodcastEpisodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PodcastEpisodesQuery, PodcastEpisodesQueryVariables>(PodcastEpisodesDocument, options);
      }
export function usePodcastEpisodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PodcastEpisodesQuery, PodcastEpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PodcastEpisodesQuery, PodcastEpisodesQueryVariables>(PodcastEpisodesDocument, options);
        }
// @ts-ignore
export function usePodcastEpisodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PodcastEpisodesQuery, PodcastEpisodesQueryVariables>): Apollo.UseSuspenseQueryResult<PodcastEpisodesQuery, PodcastEpisodesQueryVariables>;
export function usePodcastEpisodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PodcastEpisodesQuery, PodcastEpisodesQueryVariables>): Apollo.UseSuspenseQueryResult<PodcastEpisodesQuery | undefined, PodcastEpisodesQueryVariables>;
export function usePodcastEpisodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PodcastEpisodesQuery, PodcastEpisodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PodcastEpisodesQuery, PodcastEpisodesQueryVariables>(PodcastEpisodesDocument, options);
        }
export type PodcastEpisodesQueryHookResult = ReturnType<typeof usePodcastEpisodesQuery>;
export type PodcastEpisodesLazyQueryHookResult = ReturnType<typeof usePodcastEpisodesLazyQuery>;
export type PodcastEpisodesSuspenseQueryHookResult = ReturnType<typeof usePodcastEpisodesSuspenseQuery>;
export type PodcastEpisodesQueryResult = Apollo.QueryResult<PodcastEpisodesQuery, PodcastEpisodesQueryVariables>;
export const PodcastCreatorsDocument = gql`
    query PodcastCreators($input: GetPodcastCreatorsInput) {
  podcastCreators(input: $input) {
    items {
      id
      name
      profileImageUrl
      organizationName
      role
      influenceBadge {
        ...InfluenceBadgeFields
      }
      episodesCount
      latestEpisodeAt
      companyName
    }
    total
    hasMore
    nextCursor
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __usePodcastCreatorsQuery__
 *
 * To run a query within a React component, call `usePodcastCreatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodcastCreatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodcastCreatorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePodcastCreatorsQuery(baseOptions?: Apollo.QueryHookOptions<PodcastCreatorsQuery, PodcastCreatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PodcastCreatorsQuery, PodcastCreatorsQueryVariables>(PodcastCreatorsDocument, options);
      }
export function usePodcastCreatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PodcastCreatorsQuery, PodcastCreatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PodcastCreatorsQuery, PodcastCreatorsQueryVariables>(PodcastCreatorsDocument, options);
        }
// @ts-ignore
export function usePodcastCreatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PodcastCreatorsQuery, PodcastCreatorsQueryVariables>): Apollo.UseSuspenseQueryResult<PodcastCreatorsQuery, PodcastCreatorsQueryVariables>;
export function usePodcastCreatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PodcastCreatorsQuery, PodcastCreatorsQueryVariables>): Apollo.UseSuspenseQueryResult<PodcastCreatorsQuery | undefined, PodcastCreatorsQueryVariables>;
export function usePodcastCreatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PodcastCreatorsQuery, PodcastCreatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PodcastCreatorsQuery, PodcastCreatorsQueryVariables>(PodcastCreatorsDocument, options);
        }
export type PodcastCreatorsQueryHookResult = ReturnType<typeof usePodcastCreatorsQuery>;
export type PodcastCreatorsLazyQueryHookResult = ReturnType<typeof usePodcastCreatorsLazyQuery>;
export type PodcastCreatorsSuspenseQueryHookResult = ReturnType<typeof usePodcastCreatorsSuspenseQuery>;
export type PodcastCreatorsQueryResult = Apollo.QueryResult<PodcastCreatorsQuery, PodcastCreatorsQueryVariables>;
export const PodcastEpisodesByUserDocument = gql`
    query PodcastEpisodesByUser($input: GetPodcastEpisodesByUserInput!) {
  podcastEpisodesByUser(input: $input) {
    items {
      ...PodcastEpisodeFields
    }
    total
    hasMore
    nextCursor
  }
}
    ${PodcastEpisodeFieldsFragmentDoc}`;

/**
 * __usePodcastEpisodesByUserQuery__
 *
 * To run a query within a React component, call `usePodcastEpisodesByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodcastEpisodesByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodcastEpisodesByUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePodcastEpisodesByUserQuery(baseOptions: Apollo.QueryHookOptions<PodcastEpisodesByUserQuery, PodcastEpisodesByUserQueryVariables> & ({ variables: PodcastEpisodesByUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PodcastEpisodesByUserQuery, PodcastEpisodesByUserQueryVariables>(PodcastEpisodesByUserDocument, options);
      }
export function usePodcastEpisodesByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PodcastEpisodesByUserQuery, PodcastEpisodesByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PodcastEpisodesByUserQuery, PodcastEpisodesByUserQueryVariables>(PodcastEpisodesByUserDocument, options);
        }
// @ts-ignore
export function usePodcastEpisodesByUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PodcastEpisodesByUserQuery, PodcastEpisodesByUserQueryVariables>): Apollo.UseSuspenseQueryResult<PodcastEpisodesByUserQuery, PodcastEpisodesByUserQueryVariables>;
export function usePodcastEpisodesByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PodcastEpisodesByUserQuery, PodcastEpisodesByUserQueryVariables>): Apollo.UseSuspenseQueryResult<PodcastEpisodesByUserQuery | undefined, PodcastEpisodesByUserQueryVariables>;
export function usePodcastEpisodesByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PodcastEpisodesByUserQuery, PodcastEpisodesByUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PodcastEpisodesByUserQuery, PodcastEpisodesByUserQueryVariables>(PodcastEpisodesByUserDocument, options);
        }
export type PodcastEpisodesByUserQueryHookResult = ReturnType<typeof usePodcastEpisodesByUserQuery>;
export type PodcastEpisodesByUserLazyQueryHookResult = ReturnType<typeof usePodcastEpisodesByUserLazyQuery>;
export type PodcastEpisodesByUserSuspenseQueryHookResult = ReturnType<typeof usePodcastEpisodesByUserSuspenseQuery>;
export type PodcastEpisodesByUserQueryResult = Apollo.QueryResult<PodcastEpisodesByUserQuery, PodcastEpisodesByUserQueryVariables>;
export const PodcastEpisodeDocument = gql`
    query PodcastEpisode($episodeId: String!) {
  podcastEpisode(episodeId: $episodeId) {
    ...PodcastEpisodeFields
  }
}
    ${PodcastEpisodeFieldsFragmentDoc}`;

/**
 * __usePodcastEpisodeQuery__
 *
 * To run a query within a React component, call `usePodcastEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodcastEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodcastEpisodeQuery({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function usePodcastEpisodeQuery(baseOptions: Apollo.QueryHookOptions<PodcastEpisodeQuery, PodcastEpisodeQueryVariables> & ({ variables: PodcastEpisodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PodcastEpisodeQuery, PodcastEpisodeQueryVariables>(PodcastEpisodeDocument, options);
      }
export function usePodcastEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PodcastEpisodeQuery, PodcastEpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PodcastEpisodeQuery, PodcastEpisodeQueryVariables>(PodcastEpisodeDocument, options);
        }
// @ts-ignore
export function usePodcastEpisodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PodcastEpisodeQuery, PodcastEpisodeQueryVariables>): Apollo.UseSuspenseQueryResult<PodcastEpisodeQuery, PodcastEpisodeQueryVariables>;
export function usePodcastEpisodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PodcastEpisodeQuery, PodcastEpisodeQueryVariables>): Apollo.UseSuspenseQueryResult<PodcastEpisodeQuery | undefined, PodcastEpisodeQueryVariables>;
export function usePodcastEpisodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PodcastEpisodeQuery, PodcastEpisodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PodcastEpisodeQuery, PodcastEpisodeQueryVariables>(PodcastEpisodeDocument, options);
        }
export type PodcastEpisodeQueryHookResult = ReturnType<typeof usePodcastEpisodeQuery>;
export type PodcastEpisodeLazyQueryHookResult = ReturnType<typeof usePodcastEpisodeLazyQuery>;
export type PodcastEpisodeSuspenseQueryHookResult = ReturnType<typeof usePodcastEpisodeSuspenseQuery>;
export type PodcastEpisodeQueryResult = Apollo.QueryResult<PodcastEpisodeQuery, PodcastEpisodeQueryVariables>;
export const PodcastCommentsDocument = gql`
    query PodcastComments($input: GetPodcastCommentsInput!) {
  podcastComments(input: $input) {
    items {
      ...PodcastCommentFields
    }
    total
    hasMore
    nextCursor
  }
}
    ${PodcastCommentFieldsFragmentDoc}`;

/**
 * __usePodcastCommentsQuery__
 *
 * To run a query within a React component, call `usePodcastCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodcastCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodcastCommentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePodcastCommentsQuery(baseOptions: Apollo.QueryHookOptions<PodcastCommentsQuery, PodcastCommentsQueryVariables> & ({ variables: PodcastCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PodcastCommentsQuery, PodcastCommentsQueryVariables>(PodcastCommentsDocument, options);
      }
export function usePodcastCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PodcastCommentsQuery, PodcastCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PodcastCommentsQuery, PodcastCommentsQueryVariables>(PodcastCommentsDocument, options);
        }
// @ts-ignore
export function usePodcastCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PodcastCommentsQuery, PodcastCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<PodcastCommentsQuery, PodcastCommentsQueryVariables>;
export function usePodcastCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PodcastCommentsQuery, PodcastCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<PodcastCommentsQuery | undefined, PodcastCommentsQueryVariables>;
export function usePodcastCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PodcastCommentsQuery, PodcastCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PodcastCommentsQuery, PodcastCommentsQueryVariables>(PodcastCommentsDocument, options);
        }
export type PodcastCommentsQueryHookResult = ReturnType<typeof usePodcastCommentsQuery>;
export type PodcastCommentsLazyQueryHookResult = ReturnType<typeof usePodcastCommentsLazyQuery>;
export type PodcastCommentsSuspenseQueryHookResult = ReturnType<typeof usePodcastCommentsSuspenseQuery>;
export type PodcastCommentsQueryResult = Apollo.QueryResult<PodcastCommentsQuery, PodcastCommentsQueryVariables>;
export const UploadPodcastEpisodeDocument = gql`
    mutation UploadPodcastEpisode($input: UploadPodcastEpisodeInput!) {
  uploadPodcastEpisode(input: $input) {
    ...PodcastEpisodeFields
  }
}
    ${PodcastEpisodeFieldsFragmentDoc}`;
export type UploadPodcastEpisodeMutationFn = Apollo.MutationFunction<UploadPodcastEpisodeMutation, UploadPodcastEpisodeMutationVariables>;

/**
 * __useUploadPodcastEpisodeMutation__
 *
 * To run a mutation, you first call `useUploadPodcastEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPodcastEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPodcastEpisodeMutation, { data, loading, error }] = useUploadPodcastEpisodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadPodcastEpisodeMutation(baseOptions?: Apollo.MutationHookOptions<UploadPodcastEpisodeMutation, UploadPodcastEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadPodcastEpisodeMutation, UploadPodcastEpisodeMutationVariables>(UploadPodcastEpisodeDocument, options);
      }
export type UploadPodcastEpisodeMutationHookResult = ReturnType<typeof useUploadPodcastEpisodeMutation>;
export type UploadPodcastEpisodeMutationResult = Apollo.MutationResult<UploadPodcastEpisodeMutation>;
export type UploadPodcastEpisodeMutationOptions = Apollo.BaseMutationOptions<UploadPodcastEpisodeMutation, UploadPodcastEpisodeMutationVariables>;
export const DeletePodcastEpisodeDocument = gql`
    mutation DeletePodcastEpisode($input: DeletePodcastEpisodeInput!) {
  deletePodcastEpisode(input: $input)
}
    `;
export type DeletePodcastEpisodeMutationFn = Apollo.MutationFunction<DeletePodcastEpisodeMutation, DeletePodcastEpisodeMutationVariables>;

/**
 * __useDeletePodcastEpisodeMutation__
 *
 * To run a mutation, you first call `useDeletePodcastEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePodcastEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePodcastEpisodeMutation, { data, loading, error }] = useDeletePodcastEpisodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePodcastEpisodeMutation(baseOptions?: Apollo.MutationHookOptions<DeletePodcastEpisodeMutation, DeletePodcastEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePodcastEpisodeMutation, DeletePodcastEpisodeMutationVariables>(DeletePodcastEpisodeDocument, options);
      }
export type DeletePodcastEpisodeMutationHookResult = ReturnType<typeof useDeletePodcastEpisodeMutation>;
export type DeletePodcastEpisodeMutationResult = Apollo.MutationResult<DeletePodcastEpisodeMutation>;
export type DeletePodcastEpisodeMutationOptions = Apollo.BaseMutationOptions<DeletePodcastEpisodeMutation, DeletePodcastEpisodeMutationVariables>;
export const RecordPodcastPlayDocument = gql`
    mutation RecordPodcastPlay($input: RecordPodcastPlayInput!) {
  recordPodcastPlay(input: $input)
}
    `;
export type RecordPodcastPlayMutationFn = Apollo.MutationFunction<RecordPodcastPlayMutation, RecordPodcastPlayMutationVariables>;

/**
 * __useRecordPodcastPlayMutation__
 *
 * To run a mutation, you first call `useRecordPodcastPlayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordPodcastPlayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordPodcastPlayMutation, { data, loading, error }] = useRecordPodcastPlayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordPodcastPlayMutation(baseOptions?: Apollo.MutationHookOptions<RecordPodcastPlayMutation, RecordPodcastPlayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordPodcastPlayMutation, RecordPodcastPlayMutationVariables>(RecordPodcastPlayDocument, options);
      }
export type RecordPodcastPlayMutationHookResult = ReturnType<typeof useRecordPodcastPlayMutation>;
export type RecordPodcastPlayMutationResult = Apollo.MutationResult<RecordPodcastPlayMutation>;
export type RecordPodcastPlayMutationOptions = Apollo.BaseMutationOptions<RecordPodcastPlayMutation, RecordPodcastPlayMutationVariables>;
export const ReportPodcastPlaybackErrorDocument = gql`
    mutation ReportPodcastPlaybackError($input: ReportPodcastPlaybackErrorInput!) {
  reportPodcastPlaybackError(input: $input)
}
    `;
export type ReportPodcastPlaybackErrorMutationFn = Apollo.MutationFunction<ReportPodcastPlaybackErrorMutation, ReportPodcastPlaybackErrorMutationVariables>;

/**
 * __useReportPodcastPlaybackErrorMutation__
 *
 * To run a mutation, you first call `useReportPodcastPlaybackErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportPodcastPlaybackErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportPodcastPlaybackErrorMutation, { data, loading, error }] = useReportPodcastPlaybackErrorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportPodcastPlaybackErrorMutation(baseOptions?: Apollo.MutationHookOptions<ReportPodcastPlaybackErrorMutation, ReportPodcastPlaybackErrorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportPodcastPlaybackErrorMutation, ReportPodcastPlaybackErrorMutationVariables>(ReportPodcastPlaybackErrorDocument, options);
      }
export type ReportPodcastPlaybackErrorMutationHookResult = ReturnType<typeof useReportPodcastPlaybackErrorMutation>;
export type ReportPodcastPlaybackErrorMutationResult = Apollo.MutationResult<ReportPodcastPlaybackErrorMutation>;
export type ReportPodcastPlaybackErrorMutationOptions = Apollo.BaseMutationOptions<ReportPodcastPlaybackErrorMutation, ReportPodcastPlaybackErrorMutationVariables>;
export const LikePodcastEpisodeDocument = gql`
    mutation LikePodcastEpisode($episodeId: String!) {
  likePodcastEpisode(episodeId: $episodeId) {
    id
    likesCount
    isLikedByMe
  }
}
    `;
export type LikePodcastEpisodeMutationFn = Apollo.MutationFunction<LikePodcastEpisodeMutation, LikePodcastEpisodeMutationVariables>;

/**
 * __useLikePodcastEpisodeMutation__
 *
 * To run a mutation, you first call `useLikePodcastEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikePodcastEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likePodcastEpisodeMutation, { data, loading, error }] = useLikePodcastEpisodeMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useLikePodcastEpisodeMutation(baseOptions?: Apollo.MutationHookOptions<LikePodcastEpisodeMutation, LikePodcastEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LikePodcastEpisodeMutation, LikePodcastEpisodeMutationVariables>(LikePodcastEpisodeDocument, options);
      }
export type LikePodcastEpisodeMutationHookResult = ReturnType<typeof useLikePodcastEpisodeMutation>;
export type LikePodcastEpisodeMutationResult = Apollo.MutationResult<LikePodcastEpisodeMutation>;
export type LikePodcastEpisodeMutationOptions = Apollo.BaseMutationOptions<LikePodcastEpisodeMutation, LikePodcastEpisodeMutationVariables>;
export const UnlikePodcastEpisodeDocument = gql`
    mutation UnlikePodcastEpisode($episodeId: String!) {
  unlikePodcastEpisode(episodeId: $episodeId) {
    id
    likesCount
    isLikedByMe
  }
}
    `;
export type UnlikePodcastEpisodeMutationFn = Apollo.MutationFunction<UnlikePodcastEpisodeMutation, UnlikePodcastEpisodeMutationVariables>;

/**
 * __useUnlikePodcastEpisodeMutation__
 *
 * To run a mutation, you first call `useUnlikePodcastEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlikePodcastEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlikePodcastEpisodeMutation, { data, loading, error }] = useUnlikePodcastEpisodeMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useUnlikePodcastEpisodeMutation(baseOptions?: Apollo.MutationHookOptions<UnlikePodcastEpisodeMutation, UnlikePodcastEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlikePodcastEpisodeMutation, UnlikePodcastEpisodeMutationVariables>(UnlikePodcastEpisodeDocument, options);
      }
export type UnlikePodcastEpisodeMutationHookResult = ReturnType<typeof useUnlikePodcastEpisodeMutation>;
export type UnlikePodcastEpisodeMutationResult = Apollo.MutationResult<UnlikePodcastEpisodeMutation>;
export type UnlikePodcastEpisodeMutationOptions = Apollo.BaseMutationOptions<UnlikePodcastEpisodeMutation, UnlikePodcastEpisodeMutationVariables>;
export const CreatePodcastCommentDocument = gql`
    mutation CreatePodcastComment($input: CreatePodcastCommentInput!) {
  createPodcastComment(input: $input) {
    ...PodcastCommentFields
  }
}
    ${PodcastCommentFieldsFragmentDoc}`;
export type CreatePodcastCommentMutationFn = Apollo.MutationFunction<CreatePodcastCommentMutation, CreatePodcastCommentMutationVariables>;

/**
 * __useCreatePodcastCommentMutation__
 *
 * To run a mutation, you first call `useCreatePodcastCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePodcastCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPodcastCommentMutation, { data, loading, error }] = useCreatePodcastCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePodcastCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePodcastCommentMutation, CreatePodcastCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePodcastCommentMutation, CreatePodcastCommentMutationVariables>(CreatePodcastCommentDocument, options);
      }
export type CreatePodcastCommentMutationHookResult = ReturnType<typeof useCreatePodcastCommentMutation>;
export type CreatePodcastCommentMutationResult = Apollo.MutationResult<CreatePodcastCommentMutation>;
export type CreatePodcastCommentMutationOptions = Apollo.BaseMutationOptions<CreatePodcastCommentMutation, CreatePodcastCommentMutationVariables>;
export const DeletePodcastCommentDocument = gql`
    mutation DeletePodcastComment($commentId: String!) {
  deletePodcastComment(commentId: $commentId)
}
    `;
export type DeletePodcastCommentMutationFn = Apollo.MutationFunction<DeletePodcastCommentMutation, DeletePodcastCommentMutationVariables>;

/**
 * __useDeletePodcastCommentMutation__
 *
 * To run a mutation, you first call `useDeletePodcastCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePodcastCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePodcastCommentMutation, { data, loading, error }] = useDeletePodcastCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeletePodcastCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeletePodcastCommentMutation, DeletePodcastCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePodcastCommentMutation, DeletePodcastCommentMutationVariables>(DeletePodcastCommentDocument, options);
      }
export type DeletePodcastCommentMutationHookResult = ReturnType<typeof useDeletePodcastCommentMutation>;
export type DeletePodcastCommentMutationResult = Apollo.MutationResult<DeletePodcastCommentMutation>;
export type DeletePodcastCommentMutationOptions = Apollo.BaseMutationOptions<DeletePodcastCommentMutation, DeletePodcastCommentMutationVariables>;
export const LikePodcastCommentDocument = gql`
    mutation LikePodcastComment($commentId: String!) {
  likePodcastComment(commentId: $commentId) {
    id
    likesCount
    isLikedByMe
  }
}
    `;
export type LikePodcastCommentMutationFn = Apollo.MutationFunction<LikePodcastCommentMutation, LikePodcastCommentMutationVariables>;

/**
 * __useLikePodcastCommentMutation__
 *
 * To run a mutation, you first call `useLikePodcastCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikePodcastCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likePodcastCommentMutation, { data, loading, error }] = useLikePodcastCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useLikePodcastCommentMutation(baseOptions?: Apollo.MutationHookOptions<LikePodcastCommentMutation, LikePodcastCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LikePodcastCommentMutation, LikePodcastCommentMutationVariables>(LikePodcastCommentDocument, options);
      }
export type LikePodcastCommentMutationHookResult = ReturnType<typeof useLikePodcastCommentMutation>;
export type LikePodcastCommentMutationResult = Apollo.MutationResult<LikePodcastCommentMutation>;
export type LikePodcastCommentMutationOptions = Apollo.BaseMutationOptions<LikePodcastCommentMutation, LikePodcastCommentMutationVariables>;
export const UnlikePodcastCommentDocument = gql`
    mutation UnlikePodcastComment($commentId: String!) {
  unlikePodcastComment(commentId: $commentId) {
    id
    likesCount
    isLikedByMe
  }
}
    `;
export type UnlikePodcastCommentMutationFn = Apollo.MutationFunction<UnlikePodcastCommentMutation, UnlikePodcastCommentMutationVariables>;

/**
 * __useUnlikePodcastCommentMutation__
 *
 * To run a mutation, you first call `useUnlikePodcastCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlikePodcastCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlikePodcastCommentMutation, { data, loading, error }] = useUnlikePodcastCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useUnlikePodcastCommentMutation(baseOptions?: Apollo.MutationHookOptions<UnlikePodcastCommentMutation, UnlikePodcastCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlikePodcastCommentMutation, UnlikePodcastCommentMutationVariables>(UnlikePodcastCommentDocument, options);
      }
export type UnlikePodcastCommentMutationHookResult = ReturnType<typeof useUnlikePodcastCommentMutation>;
export type UnlikePodcastCommentMutationResult = Apollo.MutationResult<UnlikePodcastCommentMutation>;
export type UnlikePodcastCommentMutationOptions = Apollo.BaseMutationOptions<UnlikePodcastCommentMutation, UnlikePodcastCommentMutationVariables>;
export const SetPodcastEpisodeHiddenDocument = gql`
    mutation SetPodcastEpisodeHidden($input: SetPodcastEpisodeHiddenInput!) {
  setPodcastEpisodeHidden(input: $input) {
    ...PodcastEpisodeFields
  }
}
    ${PodcastEpisodeFieldsFragmentDoc}`;
export type SetPodcastEpisodeHiddenMutationFn = Apollo.MutationFunction<SetPodcastEpisodeHiddenMutation, SetPodcastEpisodeHiddenMutationVariables>;

/**
 * __useSetPodcastEpisodeHiddenMutation__
 *
 * To run a mutation, you first call `useSetPodcastEpisodeHiddenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPodcastEpisodeHiddenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPodcastEpisodeHiddenMutation, { data, loading, error }] = useSetPodcastEpisodeHiddenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPodcastEpisodeHiddenMutation(baseOptions?: Apollo.MutationHookOptions<SetPodcastEpisodeHiddenMutation, SetPodcastEpisodeHiddenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPodcastEpisodeHiddenMutation, SetPodcastEpisodeHiddenMutationVariables>(SetPodcastEpisodeHiddenDocument, options);
      }
export type SetPodcastEpisodeHiddenMutationHookResult = ReturnType<typeof useSetPodcastEpisodeHiddenMutation>;
export type SetPodcastEpisodeHiddenMutationResult = Apollo.MutationResult<SetPodcastEpisodeHiddenMutation>;
export type SetPodcastEpisodeHiddenMutationOptions = Apollo.BaseMutationOptions<SetPodcastEpisodeHiddenMutation, SetPodcastEpisodeHiddenMutationVariables>;
export const PodcastSourcesDocument = gql`
    query PodcastSources {
  podcastSources {
    ...PodcastSourceFields
  }
}
    ${PodcastSourceFieldsFragmentDoc}`;

/**
 * __usePodcastSourcesQuery__
 *
 * To run a query within a React component, call `usePodcastSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodcastSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodcastSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePodcastSourcesQuery(baseOptions?: Apollo.QueryHookOptions<PodcastSourcesQuery, PodcastSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PodcastSourcesQuery, PodcastSourcesQueryVariables>(PodcastSourcesDocument, options);
      }
export function usePodcastSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PodcastSourcesQuery, PodcastSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PodcastSourcesQuery, PodcastSourcesQueryVariables>(PodcastSourcesDocument, options);
        }
// @ts-ignore
export function usePodcastSourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PodcastSourcesQuery, PodcastSourcesQueryVariables>): Apollo.UseSuspenseQueryResult<PodcastSourcesQuery, PodcastSourcesQueryVariables>;
export function usePodcastSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PodcastSourcesQuery, PodcastSourcesQueryVariables>): Apollo.UseSuspenseQueryResult<PodcastSourcesQuery | undefined, PodcastSourcesQueryVariables>;
export function usePodcastSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PodcastSourcesQuery, PodcastSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PodcastSourcesQuery, PodcastSourcesQueryVariables>(PodcastSourcesDocument, options);
        }
export type PodcastSourcesQueryHookResult = ReturnType<typeof usePodcastSourcesQuery>;
export type PodcastSourcesLazyQueryHookResult = ReturnType<typeof usePodcastSourcesLazyQuery>;
export type PodcastSourcesSuspenseQueryHookResult = ReturnType<typeof usePodcastSourcesSuspenseQuery>;
export type PodcastSourcesQueryResult = Apollo.QueryResult<PodcastSourcesQuery, PodcastSourcesQueryVariables>;
export const CreatePodcastSourceDocument = gql`
    mutation CreatePodcastSource($input: CreatePodcastSourceInput!) {
  createPodcastSource(input: $input) {
    ...PodcastSourceFields
  }
}
    ${PodcastSourceFieldsFragmentDoc}`;
export type CreatePodcastSourceMutationFn = Apollo.MutationFunction<CreatePodcastSourceMutation, CreatePodcastSourceMutationVariables>;

/**
 * __useCreatePodcastSourceMutation__
 *
 * To run a mutation, you first call `useCreatePodcastSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePodcastSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPodcastSourceMutation, { data, loading, error }] = useCreatePodcastSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePodcastSourceMutation(baseOptions?: Apollo.MutationHookOptions<CreatePodcastSourceMutation, CreatePodcastSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePodcastSourceMutation, CreatePodcastSourceMutationVariables>(CreatePodcastSourceDocument, options);
      }
export type CreatePodcastSourceMutationHookResult = ReturnType<typeof useCreatePodcastSourceMutation>;
export type CreatePodcastSourceMutationResult = Apollo.MutationResult<CreatePodcastSourceMutation>;
export type CreatePodcastSourceMutationOptions = Apollo.BaseMutationOptions<CreatePodcastSourceMutation, CreatePodcastSourceMutationVariables>;
export const UpdatePodcastSourceDocument = gql`
    mutation UpdatePodcastSource($input: UpdatePodcastSourceInput!) {
  updatePodcastSource(input: $input) {
    ...PodcastSourceFields
  }
}
    ${PodcastSourceFieldsFragmentDoc}`;
export type UpdatePodcastSourceMutationFn = Apollo.MutationFunction<UpdatePodcastSourceMutation, UpdatePodcastSourceMutationVariables>;

/**
 * __useUpdatePodcastSourceMutation__
 *
 * To run a mutation, you first call `useUpdatePodcastSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePodcastSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePodcastSourceMutation, { data, loading, error }] = useUpdatePodcastSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePodcastSourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePodcastSourceMutation, UpdatePodcastSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePodcastSourceMutation, UpdatePodcastSourceMutationVariables>(UpdatePodcastSourceDocument, options);
      }
export type UpdatePodcastSourceMutationHookResult = ReturnType<typeof useUpdatePodcastSourceMutation>;
export type UpdatePodcastSourceMutationResult = Apollo.MutationResult<UpdatePodcastSourceMutation>;
export type UpdatePodcastSourceMutationOptions = Apollo.BaseMutationOptions<UpdatePodcastSourceMutation, UpdatePodcastSourceMutationVariables>;
export const DeletePodcastSourceDocument = gql`
    mutation DeletePodcastSource($id: ID!) {
  deletePodcastSource(id: $id)
}
    `;
export type DeletePodcastSourceMutationFn = Apollo.MutationFunction<DeletePodcastSourceMutation, DeletePodcastSourceMutationVariables>;

/**
 * __useDeletePodcastSourceMutation__
 *
 * To run a mutation, you first call `useDeletePodcastSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePodcastSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePodcastSourceMutation, { data, loading, error }] = useDeletePodcastSourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePodcastSourceMutation(baseOptions?: Apollo.MutationHookOptions<DeletePodcastSourceMutation, DeletePodcastSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePodcastSourceMutation, DeletePodcastSourceMutationVariables>(DeletePodcastSourceDocument, options);
      }
export type DeletePodcastSourceMutationHookResult = ReturnType<typeof useDeletePodcastSourceMutation>;
export type DeletePodcastSourceMutationResult = Apollo.MutationResult<DeletePodcastSourceMutation>;
export type DeletePodcastSourceMutationOptions = Apollo.BaseMutationOptions<DeletePodcastSourceMutation, DeletePodcastSourceMutationVariables>;
export const SyncPodcastSourceNowDocument = gql`
    mutation SyncPodcastSourceNow($id: ID!) {
  syncPodcastSourceNow(id: $id) {
    sourcesProcessed
    created
    updated
    errors
  }
}
    `;
export type SyncPodcastSourceNowMutationFn = Apollo.MutationFunction<SyncPodcastSourceNowMutation, SyncPodcastSourceNowMutationVariables>;

/**
 * __useSyncPodcastSourceNowMutation__
 *
 * To run a mutation, you first call `useSyncPodcastSourceNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPodcastSourceNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPodcastSourceNowMutation, { data, loading, error }] = useSyncPodcastSourceNowMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSyncPodcastSourceNowMutation(baseOptions?: Apollo.MutationHookOptions<SyncPodcastSourceNowMutation, SyncPodcastSourceNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncPodcastSourceNowMutation, SyncPodcastSourceNowMutationVariables>(SyncPodcastSourceNowDocument, options);
      }
export type SyncPodcastSourceNowMutationHookResult = ReturnType<typeof useSyncPodcastSourceNowMutation>;
export type SyncPodcastSourceNowMutationResult = Apollo.MutationResult<SyncPodcastSourceNowMutation>;
export type SyncPodcastSourceNowMutationOptions = Apollo.BaseMutationOptions<SyncPodcastSourceNowMutation, SyncPodcastSourceNowMutationVariables>;
export const CreatePollPostDocument = gql`
    mutation CreatePollPost($input: CreatePollPostInput!) {
  createPollPost(input: $input)
}
    `;
export type CreatePollPostMutationFn = Apollo.MutationFunction<CreatePollPostMutation, CreatePollPostMutationVariables>;

/**
 * __useCreatePollPostMutation__
 *
 * To run a mutation, you first call `useCreatePollPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePollPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPollPostMutation, { data, loading, error }] = useCreatePollPostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePollPostMutation(baseOptions?: Apollo.MutationHookOptions<CreatePollPostMutation, CreatePollPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePollPostMutation, CreatePollPostMutationVariables>(CreatePollPostDocument, options);
      }
export type CreatePollPostMutationHookResult = ReturnType<typeof useCreatePollPostMutation>;
export type CreatePollPostMutationResult = Apollo.MutationResult<CreatePollPostMutation>;
export type CreatePollPostMutationOptions = Apollo.BaseMutationOptions<CreatePollPostMutation, CreatePollPostMutationVariables>;
export const GetPollByPostIdDocument = gql`
    query GetPollByPostId($postId: String!) {
  getPollByPostId(postId: $postId) {
    question
    expiresAt
    options {
      id
      text
      votes
      isChosen
    }
  }
}
    `;

/**
 * __useGetPollByPostIdQuery__
 *
 * To run a query within a React component, call `useGetPollByPostIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPollByPostIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPollByPostIdQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPollByPostIdQuery(baseOptions: Apollo.QueryHookOptions<GetPollByPostIdQuery, GetPollByPostIdQueryVariables> & ({ variables: GetPollByPostIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPollByPostIdQuery, GetPollByPostIdQueryVariables>(GetPollByPostIdDocument, options);
      }
export function useGetPollByPostIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPollByPostIdQuery, GetPollByPostIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPollByPostIdQuery, GetPollByPostIdQueryVariables>(GetPollByPostIdDocument, options);
        }
// @ts-ignore
export function useGetPollByPostIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPollByPostIdQuery, GetPollByPostIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetPollByPostIdQuery, GetPollByPostIdQueryVariables>;
export function useGetPollByPostIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPollByPostIdQuery, GetPollByPostIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetPollByPostIdQuery | undefined, GetPollByPostIdQueryVariables>;
export function useGetPollByPostIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPollByPostIdQuery, GetPollByPostIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPollByPostIdQuery, GetPollByPostIdQueryVariables>(GetPollByPostIdDocument, options);
        }
export type GetPollByPostIdQueryHookResult = ReturnType<typeof useGetPollByPostIdQuery>;
export type GetPollByPostIdLazyQueryHookResult = ReturnType<typeof useGetPollByPostIdLazyQuery>;
export type GetPollByPostIdSuspenseQueryHookResult = ReturnType<typeof useGetPollByPostIdSuspenseQuery>;
export type GetPollByPostIdQueryResult = Apollo.QueryResult<GetPollByPostIdQuery, GetPollByPostIdQueryVariables>;
export const VoteInPollDocument = gql`
    mutation VoteInPoll($postId: String!, $optionId: String!) {
  voteInPoll(postId: $postId, optionId: $optionId) {
    question
    expiresAt
    options {
      id
      text
      votes
      isChosen
    }
  }
}
    `;
export type VoteInPollMutationFn = Apollo.MutationFunction<VoteInPollMutation, VoteInPollMutationVariables>;

/**
 * __useVoteInPollMutation__
 *
 * To run a mutation, you first call `useVoteInPollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoteInPollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voteInPollMutation, { data, loading, error }] = useVoteInPollMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      optionId: // value for 'optionId'
 *   },
 * });
 */
export function useVoteInPollMutation(baseOptions?: Apollo.MutationHookOptions<VoteInPollMutation, VoteInPollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoteInPollMutation, VoteInPollMutationVariables>(VoteInPollDocument, options);
      }
export type VoteInPollMutationHookResult = ReturnType<typeof useVoteInPollMutation>;
export type VoteInPollMutationResult = Apollo.MutationResult<VoteInPollMutation>;
export type VoteInPollMutationOptions = Apollo.BaseMutationOptions<VoteInPollMutation, VoteInPollMutationVariables>;
export const OnPostActivityDocument = gql`
    subscription OnPostActivity($postId: ID!) {
  postActivity(postId: $postId) {
    type
    changeType
    postId
    actorId
    actorReaction
    reactionCounts {
      type
      count
    }
    totalReactions
    commentsCount
    commentId
    parentCommentId
    repliesCount
    deletedCommentIds
    comment {
      id
      content
      translatedContent
      userId
      mediaUrls
      createdAt
      updatedAt
      repliesCount
      user {
        id
        firstName
        middleName
        lastName
        title
        role
        profileImageUrl
        companyName
        influenceBadge {
          ...InfluenceBadgeFields
        }
      }
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useOnPostActivitySubscription__
 *
 * To run a query within a React component, call `useOnPostActivitySubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnPostActivitySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnPostActivitySubscription({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useOnPostActivitySubscription(baseOptions: Apollo.SubscriptionHookOptions<OnPostActivitySubscription, OnPostActivitySubscriptionVariables> & ({ variables: OnPostActivitySubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnPostActivitySubscription, OnPostActivitySubscriptionVariables>(OnPostActivityDocument, options);
      }
export type OnPostActivitySubscriptionHookResult = ReturnType<typeof useOnPostActivitySubscription>;
export type OnPostActivitySubscriptionResult = Apollo.SubscriptionResult<OnPostActivitySubscription>;
export const InitializePostBoostPaymentDocument = gql`
    mutation InitializePostBoostPayment($input: InitializePostBoostPaymentInput!) {
  initializePostBoostPayment(input: $input) {
    clientSecret
    paymentIntentId
    amountCents
    hours
    durationSeconds
    packLabel
    postBoostId
    postId
    publishableKey
  }
}
    `;
export type InitializePostBoostPaymentMutationFn = Apollo.MutationFunction<InitializePostBoostPaymentMutation, InitializePostBoostPaymentMutationVariables>;

/**
 * __useInitializePostBoostPaymentMutation__
 *
 * To run a mutation, you first call `useInitializePostBoostPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializePostBoostPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializePostBoostPaymentMutation, { data, loading, error }] = useInitializePostBoostPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitializePostBoostPaymentMutation(baseOptions?: Apollo.MutationHookOptions<InitializePostBoostPaymentMutation, InitializePostBoostPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitializePostBoostPaymentMutation, InitializePostBoostPaymentMutationVariables>(InitializePostBoostPaymentDocument, options);
      }
export type InitializePostBoostPaymentMutationHookResult = ReturnType<typeof useInitializePostBoostPaymentMutation>;
export type InitializePostBoostPaymentMutationResult = Apollo.MutationResult<InitializePostBoostPaymentMutation>;
export type InitializePostBoostPaymentMutationOptions = Apollo.BaseMutationOptions<InitializePostBoostPaymentMutation, InitializePostBoostPaymentMutationVariables>;
export const ConfirmPostBoostPaymentDocument = gql`
    mutation ConfirmPostBoostPayment($paymentIntentId: String!) {
  confirmPostBoostPayment(paymentIntentId: $paymentIntentId) {
    ...PostBoostFields
  }
}
    ${PostBoostFieldsFragmentDoc}`;
export type ConfirmPostBoostPaymentMutationFn = Apollo.MutationFunction<ConfirmPostBoostPaymentMutation, ConfirmPostBoostPaymentMutationVariables>;

/**
 * __useConfirmPostBoostPaymentMutation__
 *
 * To run a mutation, you first call `useConfirmPostBoostPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmPostBoostPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmPostBoostPaymentMutation, { data, loading, error }] = useConfirmPostBoostPaymentMutation({
 *   variables: {
 *      paymentIntentId: // value for 'paymentIntentId'
 *   },
 * });
 */
export function useConfirmPostBoostPaymentMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmPostBoostPaymentMutation, ConfirmPostBoostPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmPostBoostPaymentMutation, ConfirmPostBoostPaymentMutationVariables>(ConfirmPostBoostPaymentDocument, options);
      }
export type ConfirmPostBoostPaymentMutationHookResult = ReturnType<typeof useConfirmPostBoostPaymentMutation>;
export type ConfirmPostBoostPaymentMutationResult = Apollo.MutationResult<ConfirmPostBoostPaymentMutation>;
export type ConfirmPostBoostPaymentMutationOptions = Apollo.BaseMutationOptions<ConfirmPostBoostPaymentMutation, ConfirmPostBoostPaymentMutationVariables>;
export const CancelPendingPostBoostDocument = gql`
    mutation CancelPendingPostBoost($id: ID!) {
  cancelPendingPostBoost(id: $id) {
    ...PostBoostFields
  }
}
    ${PostBoostFieldsFragmentDoc}`;
export type CancelPendingPostBoostMutationFn = Apollo.MutationFunction<CancelPendingPostBoostMutation, CancelPendingPostBoostMutationVariables>;

/**
 * __useCancelPendingPostBoostMutation__
 *
 * To run a mutation, you first call `useCancelPendingPostBoostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPendingPostBoostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPendingPostBoostMutation, { data, loading, error }] = useCancelPendingPostBoostMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelPendingPostBoostMutation(baseOptions?: Apollo.MutationHookOptions<CancelPendingPostBoostMutation, CancelPendingPostBoostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPendingPostBoostMutation, CancelPendingPostBoostMutationVariables>(CancelPendingPostBoostDocument, options);
      }
export type CancelPendingPostBoostMutationHookResult = ReturnType<typeof useCancelPendingPostBoostMutation>;
export type CancelPendingPostBoostMutationResult = Apollo.MutationResult<CancelPendingPostBoostMutation>;
export type CancelPendingPostBoostMutationOptions = Apollo.BaseMutationOptions<CancelPendingPostBoostMutation, CancelPendingPostBoostMutationVariables>;
export const PausePostBoostDocument = gql`
    mutation PausePostBoost($id: ID!) {
  pausePostBoost(id: $id) {
    ...PostBoostFields
  }
}
    ${PostBoostFieldsFragmentDoc}`;
export type PausePostBoostMutationFn = Apollo.MutationFunction<PausePostBoostMutation, PausePostBoostMutationVariables>;

/**
 * __usePausePostBoostMutation__
 *
 * To run a mutation, you first call `usePausePostBoostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePausePostBoostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pausePostBoostMutation, { data, loading, error }] = usePausePostBoostMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePausePostBoostMutation(baseOptions?: Apollo.MutationHookOptions<PausePostBoostMutation, PausePostBoostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PausePostBoostMutation, PausePostBoostMutationVariables>(PausePostBoostDocument, options);
      }
export type PausePostBoostMutationHookResult = ReturnType<typeof usePausePostBoostMutation>;
export type PausePostBoostMutationResult = Apollo.MutationResult<PausePostBoostMutation>;
export type PausePostBoostMutationOptions = Apollo.BaseMutationOptions<PausePostBoostMutation, PausePostBoostMutationVariables>;
export const ResumePostBoostDocument = gql`
    mutation ResumePostBoost($id: ID!) {
  resumePostBoost(id: $id) {
    ...PostBoostFields
  }
}
    ${PostBoostFieldsFragmentDoc}`;
export type ResumePostBoostMutationFn = Apollo.MutationFunction<ResumePostBoostMutation, ResumePostBoostMutationVariables>;

/**
 * __useResumePostBoostMutation__
 *
 * To run a mutation, you first call `useResumePostBoostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumePostBoostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumePostBoostMutation, { data, loading, error }] = useResumePostBoostMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResumePostBoostMutation(baseOptions?: Apollo.MutationHookOptions<ResumePostBoostMutation, ResumePostBoostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumePostBoostMutation, ResumePostBoostMutationVariables>(ResumePostBoostDocument, options);
      }
export type ResumePostBoostMutationHookResult = ReturnType<typeof useResumePostBoostMutation>;
export type ResumePostBoostMutationResult = Apollo.MutationResult<ResumePostBoostMutation>;
export type ResumePostBoostMutationOptions = Apollo.BaseMutationOptions<ResumePostBoostMutation, ResumePostBoostMutationVariables>;
export const RecordPostBoostImpressionDocument = gql`
    mutation RecordPostBoostImpression($boostId: ID!) {
  recordPostBoostImpression(boostId: $boostId)
}
    `;
export type RecordPostBoostImpressionMutationFn = Apollo.MutationFunction<RecordPostBoostImpressionMutation, RecordPostBoostImpressionMutationVariables>;

/**
 * __useRecordPostBoostImpressionMutation__
 *
 * To run a mutation, you first call `useRecordPostBoostImpressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordPostBoostImpressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordPostBoostImpressionMutation, { data, loading, error }] = useRecordPostBoostImpressionMutation({
 *   variables: {
 *      boostId: // value for 'boostId'
 *   },
 * });
 */
export function useRecordPostBoostImpressionMutation(baseOptions?: Apollo.MutationHookOptions<RecordPostBoostImpressionMutation, RecordPostBoostImpressionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordPostBoostImpressionMutation, RecordPostBoostImpressionMutationVariables>(RecordPostBoostImpressionDocument, options);
      }
export type RecordPostBoostImpressionMutationHookResult = ReturnType<typeof useRecordPostBoostImpressionMutation>;
export type RecordPostBoostImpressionMutationResult = Apollo.MutationResult<RecordPostBoostImpressionMutation>;
export type RecordPostBoostImpressionMutationOptions = Apollo.BaseMutationOptions<RecordPostBoostImpressionMutation, RecordPostBoostImpressionMutationVariables>;
export const RecordPostBoostClickDocument = gql`
    mutation RecordPostBoostClick($boostId: ID!) {
  recordPostBoostClick(boostId: $boostId)
}
    `;
export type RecordPostBoostClickMutationFn = Apollo.MutationFunction<RecordPostBoostClickMutation, RecordPostBoostClickMutationVariables>;

/**
 * __useRecordPostBoostClickMutation__
 *
 * To run a mutation, you first call `useRecordPostBoostClickMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordPostBoostClickMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordPostBoostClickMutation, { data, loading, error }] = useRecordPostBoostClickMutation({
 *   variables: {
 *      boostId: // value for 'boostId'
 *   },
 * });
 */
export function useRecordPostBoostClickMutation(baseOptions?: Apollo.MutationHookOptions<RecordPostBoostClickMutation, RecordPostBoostClickMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordPostBoostClickMutation, RecordPostBoostClickMutationVariables>(RecordPostBoostClickDocument, options);
      }
export type RecordPostBoostClickMutationHookResult = ReturnType<typeof useRecordPostBoostClickMutation>;
export type RecordPostBoostClickMutationResult = Apollo.MutationResult<RecordPostBoostClickMutation>;
export type RecordPostBoostClickMutationOptions = Apollo.BaseMutationOptions<RecordPostBoostClickMutation, RecordPostBoostClickMutationVariables>;
export const PostBoostHourlyRateDocument = gql`
    query PostBoostHourlyRate {
  postBoostHourlyRate {
    hourlyRateCents
  }
}
    `;

/**
 * __usePostBoostHourlyRateQuery__
 *
 * To run a query within a React component, call `usePostBoostHourlyRateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostBoostHourlyRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostBoostHourlyRateQuery({
 *   variables: {
 *   },
 * });
 */
export function usePostBoostHourlyRateQuery(baseOptions?: Apollo.QueryHookOptions<PostBoostHourlyRateQuery, PostBoostHourlyRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostBoostHourlyRateQuery, PostBoostHourlyRateQueryVariables>(PostBoostHourlyRateDocument, options);
      }
export function usePostBoostHourlyRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostBoostHourlyRateQuery, PostBoostHourlyRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostBoostHourlyRateQuery, PostBoostHourlyRateQueryVariables>(PostBoostHourlyRateDocument, options);
        }
// @ts-ignore
export function usePostBoostHourlyRateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PostBoostHourlyRateQuery, PostBoostHourlyRateQueryVariables>): Apollo.UseSuspenseQueryResult<PostBoostHourlyRateQuery, PostBoostHourlyRateQueryVariables>;
export function usePostBoostHourlyRateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostBoostHourlyRateQuery, PostBoostHourlyRateQueryVariables>): Apollo.UseSuspenseQueryResult<PostBoostHourlyRateQuery | undefined, PostBoostHourlyRateQueryVariables>;
export function usePostBoostHourlyRateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostBoostHourlyRateQuery, PostBoostHourlyRateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostBoostHourlyRateQuery, PostBoostHourlyRateQueryVariables>(PostBoostHourlyRateDocument, options);
        }
export type PostBoostHourlyRateQueryHookResult = ReturnType<typeof usePostBoostHourlyRateQuery>;
export type PostBoostHourlyRateLazyQueryHookResult = ReturnType<typeof usePostBoostHourlyRateLazyQuery>;
export type PostBoostHourlyRateSuspenseQueryHookResult = ReturnType<typeof usePostBoostHourlyRateSuspenseQuery>;
export type PostBoostHourlyRateQueryResult = Apollo.QueryResult<PostBoostHourlyRateQuery, PostBoostHourlyRateQueryVariables>;
export const PreviewPostBoostCostDocument = gql`
    query PreviewPostBoostCost($durationHours: Int!) {
  previewPostBoostCost(durationHours: $durationHours) {
    durationHours
    durationSeconds
    hourlyRateCents
    amountCents
  }
}
    `;

/**
 * __usePreviewPostBoostCostQuery__
 *
 * To run a query within a React component, call `usePreviewPostBoostCostQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewPostBoostCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewPostBoostCostQuery({
 *   variables: {
 *      durationHours: // value for 'durationHours'
 *   },
 * });
 */
export function usePreviewPostBoostCostQuery(baseOptions: Apollo.QueryHookOptions<PreviewPostBoostCostQuery, PreviewPostBoostCostQueryVariables> & ({ variables: PreviewPostBoostCostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewPostBoostCostQuery, PreviewPostBoostCostQueryVariables>(PreviewPostBoostCostDocument, options);
      }
export function usePreviewPostBoostCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewPostBoostCostQuery, PreviewPostBoostCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewPostBoostCostQuery, PreviewPostBoostCostQueryVariables>(PreviewPostBoostCostDocument, options);
        }
// @ts-ignore
export function usePreviewPostBoostCostSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreviewPostBoostCostQuery, PreviewPostBoostCostQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewPostBoostCostQuery, PreviewPostBoostCostQueryVariables>;
export function usePreviewPostBoostCostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewPostBoostCostQuery, PreviewPostBoostCostQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewPostBoostCostQuery | undefined, PreviewPostBoostCostQueryVariables>;
export function usePreviewPostBoostCostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewPostBoostCostQuery, PreviewPostBoostCostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewPostBoostCostQuery, PreviewPostBoostCostQueryVariables>(PreviewPostBoostCostDocument, options);
        }
export type PreviewPostBoostCostQueryHookResult = ReturnType<typeof usePreviewPostBoostCostQuery>;
export type PreviewPostBoostCostLazyQueryHookResult = ReturnType<typeof usePreviewPostBoostCostLazyQuery>;
export type PreviewPostBoostCostSuspenseQueryHookResult = ReturnType<typeof usePreviewPostBoostCostSuspenseQuery>;
export type PreviewPostBoostCostQueryResult = Apollo.QueryResult<PreviewPostBoostCostQuery, PreviewPostBoostCostQueryVariables>;
export const MyPostBoostsDocument = gql`
    query MyPostBoosts($status: PostBoostStatus) {
  myPostBoosts(status: $status) {
    ...PostBoostFields
  }
}
    ${PostBoostFieldsFragmentDoc}`;

/**
 * __useMyPostBoostsQuery__
 *
 * To run a query within a React component, call `useMyPostBoostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPostBoostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPostBoostsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useMyPostBoostsQuery(baseOptions?: Apollo.QueryHookOptions<MyPostBoostsQuery, MyPostBoostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPostBoostsQuery, MyPostBoostsQueryVariables>(MyPostBoostsDocument, options);
      }
export function useMyPostBoostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPostBoostsQuery, MyPostBoostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPostBoostsQuery, MyPostBoostsQueryVariables>(MyPostBoostsDocument, options);
        }
// @ts-ignore
export function useMyPostBoostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyPostBoostsQuery, MyPostBoostsQueryVariables>): Apollo.UseSuspenseQueryResult<MyPostBoostsQuery, MyPostBoostsQueryVariables>;
export function useMyPostBoostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyPostBoostsQuery, MyPostBoostsQueryVariables>): Apollo.UseSuspenseQueryResult<MyPostBoostsQuery | undefined, MyPostBoostsQueryVariables>;
export function useMyPostBoostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyPostBoostsQuery, MyPostBoostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyPostBoostsQuery, MyPostBoostsQueryVariables>(MyPostBoostsDocument, options);
        }
export type MyPostBoostsQueryHookResult = ReturnType<typeof useMyPostBoostsQuery>;
export type MyPostBoostsLazyQueryHookResult = ReturnType<typeof useMyPostBoostsLazyQuery>;
export type MyPostBoostsSuspenseQueryHookResult = ReturnType<typeof useMyPostBoostsSuspenseQuery>;
export type MyPostBoostsQueryResult = Apollo.QueryResult<MyPostBoostsQuery, MyPostBoostsQueryVariables>;
export const PostBoostByIdDocument = gql`
    query PostBoostById($id: ID!) {
  postBoost(id: $id) {
    ...PostBoostFields
  }
}
    ${PostBoostFieldsFragmentDoc}`;

/**
 * __usePostBoostByIdQuery__
 *
 * To run a query within a React component, call `usePostBoostByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostBoostByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostBoostByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostBoostByIdQuery(baseOptions: Apollo.QueryHookOptions<PostBoostByIdQuery, PostBoostByIdQueryVariables> & ({ variables: PostBoostByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostBoostByIdQuery, PostBoostByIdQueryVariables>(PostBoostByIdDocument, options);
      }
export function usePostBoostByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostBoostByIdQuery, PostBoostByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostBoostByIdQuery, PostBoostByIdQueryVariables>(PostBoostByIdDocument, options);
        }
// @ts-ignore
export function usePostBoostByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PostBoostByIdQuery, PostBoostByIdQueryVariables>): Apollo.UseSuspenseQueryResult<PostBoostByIdQuery, PostBoostByIdQueryVariables>;
export function usePostBoostByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostBoostByIdQuery, PostBoostByIdQueryVariables>): Apollo.UseSuspenseQueryResult<PostBoostByIdQuery | undefined, PostBoostByIdQueryVariables>;
export function usePostBoostByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostBoostByIdQuery, PostBoostByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostBoostByIdQuery, PostBoostByIdQueryVariables>(PostBoostByIdDocument, options);
        }
export type PostBoostByIdQueryHookResult = ReturnType<typeof usePostBoostByIdQuery>;
export type PostBoostByIdLazyQueryHookResult = ReturnType<typeof usePostBoostByIdLazyQuery>;
export type PostBoostByIdSuspenseQueryHookResult = ReturnType<typeof usePostBoostByIdSuspenseQuery>;
export type PostBoostByIdQueryResult = Apollo.QueryResult<PostBoostByIdQuery, PostBoostByIdQueryVariables>;
export const PostBoostDailyStatsDocument = gql`
    query PostBoostDailyStats($boostId: ID!) {
  postBoostDailyStats(boostId: $boostId) {
    categories
    impressions
    clicks
  }
}
    `;

/**
 * __usePostBoostDailyStatsQuery__
 *
 * To run a query within a React component, call `usePostBoostDailyStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostBoostDailyStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostBoostDailyStatsQuery({
 *   variables: {
 *      boostId: // value for 'boostId'
 *   },
 * });
 */
export function usePostBoostDailyStatsQuery(baseOptions: Apollo.QueryHookOptions<PostBoostDailyStatsQuery, PostBoostDailyStatsQueryVariables> & ({ variables: PostBoostDailyStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostBoostDailyStatsQuery, PostBoostDailyStatsQueryVariables>(PostBoostDailyStatsDocument, options);
      }
export function usePostBoostDailyStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostBoostDailyStatsQuery, PostBoostDailyStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostBoostDailyStatsQuery, PostBoostDailyStatsQueryVariables>(PostBoostDailyStatsDocument, options);
        }
// @ts-ignore
export function usePostBoostDailyStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PostBoostDailyStatsQuery, PostBoostDailyStatsQueryVariables>): Apollo.UseSuspenseQueryResult<PostBoostDailyStatsQuery, PostBoostDailyStatsQueryVariables>;
export function usePostBoostDailyStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostBoostDailyStatsQuery, PostBoostDailyStatsQueryVariables>): Apollo.UseSuspenseQueryResult<PostBoostDailyStatsQuery | undefined, PostBoostDailyStatsQueryVariables>;
export function usePostBoostDailyStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostBoostDailyStatsQuery, PostBoostDailyStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostBoostDailyStatsQuery, PostBoostDailyStatsQueryVariables>(PostBoostDailyStatsDocument, options);
        }
export type PostBoostDailyStatsQueryHookResult = ReturnType<typeof usePostBoostDailyStatsQuery>;
export type PostBoostDailyStatsLazyQueryHookResult = ReturnType<typeof usePostBoostDailyStatsLazyQuery>;
export type PostBoostDailyStatsSuspenseQueryHookResult = ReturnType<typeof usePostBoostDailyStatsSuspenseQuery>;
export type PostBoostDailyStatsQueryResult = Apollo.QueryResult<PostBoostDailyStatsQuery, PostBoostDailyStatsQueryVariables>;
export const OnPostBoostActivityDocument = gql`
    subscription OnPostBoostActivity {
  postBoostActivity {
    changeType
    boostId
    boost {
      ...PostBoostFields
    }
  }
}
    ${PostBoostFieldsFragmentDoc}`;

/**
 * __useOnPostBoostActivitySubscription__
 *
 * To run a query within a React component, call `useOnPostBoostActivitySubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnPostBoostActivitySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnPostBoostActivitySubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnPostBoostActivitySubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnPostBoostActivitySubscription, OnPostBoostActivitySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnPostBoostActivitySubscription, OnPostBoostActivitySubscriptionVariables>(OnPostBoostActivityDocument, options);
      }
export type OnPostBoostActivitySubscriptionHookResult = ReturnType<typeof useOnPostBoostActivitySubscription>;
export type OnPostBoostActivitySubscriptionResult = Apollo.SubscriptionResult<OnPostBoostActivitySubscription>;
export const PostNowDocument = gql`
    mutation PostNow($postId: String!) {
  postNow(postId: $postId)
}
    `;
export type PostNowMutationFn = Apollo.MutationFunction<PostNowMutation, PostNowMutationVariables>;

/**
 * __usePostNowMutation__
 *
 * To run a mutation, you first call `usePostNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postNowMutation, { data, loading, error }] = usePostNowMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostNowMutation(baseOptions?: Apollo.MutationHookOptions<PostNowMutation, PostNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostNowMutation, PostNowMutationVariables>(PostNowDocument, options);
      }
export type PostNowMutationHookResult = ReturnType<typeof usePostNowMutation>;
export type PostNowMutationResult = Apollo.MutationResult<PostNowMutation>;
export type PostNowMutationOptions = Apollo.BaseMutationOptions<PostNowMutation, PostNowMutationVariables>;
export const PostReactionsDocument = gql`
    query PostReactions($input: GetPostReactionsInput!) {
  postReactions(input: $input) {
    total
    hasMore
    nextCursor
    reactors {
      id
      reactionType
      isCurrentUser
      user {
        userId
        name
        profileImageUrl
        role
        headline
        title
        influenceBadge {
          ...InfluenceBadgeFields
        }
        companyName
      }
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __usePostReactionsQuery__
 *
 * To run a query within a React component, call `usePostReactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostReactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostReactionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostReactionsQuery(baseOptions: Apollo.QueryHookOptions<PostReactionsQuery, PostReactionsQueryVariables> & ({ variables: PostReactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostReactionsQuery, PostReactionsQueryVariables>(PostReactionsDocument, options);
      }
export function usePostReactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostReactionsQuery, PostReactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostReactionsQuery, PostReactionsQueryVariables>(PostReactionsDocument, options);
        }
// @ts-ignore
export function usePostReactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PostReactionsQuery, PostReactionsQueryVariables>): Apollo.UseSuspenseQueryResult<PostReactionsQuery, PostReactionsQueryVariables>;
export function usePostReactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostReactionsQuery, PostReactionsQueryVariables>): Apollo.UseSuspenseQueryResult<PostReactionsQuery | undefined, PostReactionsQueryVariables>;
export function usePostReactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostReactionsQuery, PostReactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostReactionsQuery, PostReactionsQueryVariables>(PostReactionsDocument, options);
        }
export type PostReactionsQueryHookResult = ReturnType<typeof usePostReactionsQuery>;
export type PostReactionsLazyQueryHookResult = ReturnType<typeof usePostReactionsLazyQuery>;
export type PostReactionsSuspenseQueryHookResult = ReturnType<typeof usePostReactionsSuspenseQuery>;
export type PostReactionsQueryResult = Apollo.QueryResult<PostReactionsQuery, PostReactionsQueryVariables>;
export const InitializeProfileBoostPaymentDocument = gql`
    mutation InitializeProfileBoostPayment($input: InitializeProfileBoostPaymentInput!) {
  initializeProfileBoostPayment(input: $input) {
    clientSecret
    paymentIntentId
    amountCents
    hours
    durationSeconds
    packLabel
    packId
    boostId
    publishableKey
  }
}
    `;
export type InitializeProfileBoostPaymentMutationFn = Apollo.MutationFunction<InitializeProfileBoostPaymentMutation, InitializeProfileBoostPaymentMutationVariables>;

/**
 * __useInitializeProfileBoostPaymentMutation__
 *
 * To run a mutation, you first call `useInitializeProfileBoostPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeProfileBoostPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeProfileBoostPaymentMutation, { data, loading, error }] = useInitializeProfileBoostPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitializeProfileBoostPaymentMutation(baseOptions?: Apollo.MutationHookOptions<InitializeProfileBoostPaymentMutation, InitializeProfileBoostPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitializeProfileBoostPaymentMutation, InitializeProfileBoostPaymentMutationVariables>(InitializeProfileBoostPaymentDocument, options);
      }
export type InitializeProfileBoostPaymentMutationHookResult = ReturnType<typeof useInitializeProfileBoostPaymentMutation>;
export type InitializeProfileBoostPaymentMutationResult = Apollo.MutationResult<InitializeProfileBoostPaymentMutation>;
export type InitializeProfileBoostPaymentMutationOptions = Apollo.BaseMutationOptions<InitializeProfileBoostPaymentMutation, InitializeProfileBoostPaymentMutationVariables>;
export const ConfirmProfileBoostPaymentDocument = gql`
    mutation ConfirmProfileBoostPayment($paymentIntentId: String!) {
  confirmProfileBoostPayment(paymentIntentId: $paymentIntentId) {
    ...ProfileBoostFields
  }
}
    ${ProfileBoostFieldsFragmentDoc}`;
export type ConfirmProfileBoostPaymentMutationFn = Apollo.MutationFunction<ConfirmProfileBoostPaymentMutation, ConfirmProfileBoostPaymentMutationVariables>;

/**
 * __useConfirmProfileBoostPaymentMutation__
 *
 * To run a mutation, you first call `useConfirmProfileBoostPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmProfileBoostPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmProfileBoostPaymentMutation, { data, loading, error }] = useConfirmProfileBoostPaymentMutation({
 *   variables: {
 *      paymentIntentId: // value for 'paymentIntentId'
 *   },
 * });
 */
export function useConfirmProfileBoostPaymentMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmProfileBoostPaymentMutation, ConfirmProfileBoostPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmProfileBoostPaymentMutation, ConfirmProfileBoostPaymentMutationVariables>(ConfirmProfileBoostPaymentDocument, options);
      }
export type ConfirmProfileBoostPaymentMutationHookResult = ReturnType<typeof useConfirmProfileBoostPaymentMutation>;
export type ConfirmProfileBoostPaymentMutationResult = Apollo.MutationResult<ConfirmProfileBoostPaymentMutation>;
export type ConfirmProfileBoostPaymentMutationOptions = Apollo.BaseMutationOptions<ConfirmProfileBoostPaymentMutation, ConfirmProfileBoostPaymentMutationVariables>;
export const InitializeProfileBoostExtensionDocument = gql`
    mutation InitializeProfileBoostExtension($input: InitializeProfileBoostExtensionInput!) {
  initializeProfileBoostExtension(input: $input) {
    clientSecret
    paymentIntentId
    amountCents
    hours
    durationSeconds
    packLabel
    packId
    boostId
    publishableKey
  }
}
    `;
export type InitializeProfileBoostExtensionMutationFn = Apollo.MutationFunction<InitializeProfileBoostExtensionMutation, InitializeProfileBoostExtensionMutationVariables>;

/**
 * __useInitializeProfileBoostExtensionMutation__
 *
 * To run a mutation, you first call `useInitializeProfileBoostExtensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeProfileBoostExtensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeProfileBoostExtensionMutation, { data, loading, error }] = useInitializeProfileBoostExtensionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitializeProfileBoostExtensionMutation(baseOptions?: Apollo.MutationHookOptions<InitializeProfileBoostExtensionMutation, InitializeProfileBoostExtensionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitializeProfileBoostExtensionMutation, InitializeProfileBoostExtensionMutationVariables>(InitializeProfileBoostExtensionDocument, options);
      }
export type InitializeProfileBoostExtensionMutationHookResult = ReturnType<typeof useInitializeProfileBoostExtensionMutation>;
export type InitializeProfileBoostExtensionMutationResult = Apollo.MutationResult<InitializeProfileBoostExtensionMutation>;
export type InitializeProfileBoostExtensionMutationOptions = Apollo.BaseMutationOptions<InitializeProfileBoostExtensionMutation, InitializeProfileBoostExtensionMutationVariables>;
export const ConfirmProfileBoostExtensionDocument = gql`
    mutation ConfirmProfileBoostExtension($paymentIntentId: String!) {
  confirmProfileBoostExtension(paymentIntentId: $paymentIntentId) {
    ...ProfileBoostFields
  }
}
    ${ProfileBoostFieldsFragmentDoc}`;
export type ConfirmProfileBoostExtensionMutationFn = Apollo.MutationFunction<ConfirmProfileBoostExtensionMutation, ConfirmProfileBoostExtensionMutationVariables>;

/**
 * __useConfirmProfileBoostExtensionMutation__
 *
 * To run a mutation, you first call `useConfirmProfileBoostExtensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmProfileBoostExtensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmProfileBoostExtensionMutation, { data, loading, error }] = useConfirmProfileBoostExtensionMutation({
 *   variables: {
 *      paymentIntentId: // value for 'paymentIntentId'
 *   },
 * });
 */
export function useConfirmProfileBoostExtensionMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmProfileBoostExtensionMutation, ConfirmProfileBoostExtensionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmProfileBoostExtensionMutation, ConfirmProfileBoostExtensionMutationVariables>(ConfirmProfileBoostExtensionDocument, options);
      }
export type ConfirmProfileBoostExtensionMutationHookResult = ReturnType<typeof useConfirmProfileBoostExtensionMutation>;
export type ConfirmProfileBoostExtensionMutationResult = Apollo.MutationResult<ConfirmProfileBoostExtensionMutation>;
export type ConfirmProfileBoostExtensionMutationOptions = Apollo.BaseMutationOptions<ConfirmProfileBoostExtensionMutation, ConfirmProfileBoostExtensionMutationVariables>;
export const PauseProfileBoostDocument = gql`
    mutation PauseProfileBoost($id: ID!) {
  pauseProfileBoost(id: $id) {
    ...ProfileBoostFields
  }
}
    ${ProfileBoostFieldsFragmentDoc}`;
export type PauseProfileBoostMutationFn = Apollo.MutationFunction<PauseProfileBoostMutation, PauseProfileBoostMutationVariables>;

/**
 * __usePauseProfileBoostMutation__
 *
 * To run a mutation, you first call `usePauseProfileBoostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseProfileBoostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseProfileBoostMutation, { data, loading, error }] = usePauseProfileBoostMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePauseProfileBoostMutation(baseOptions?: Apollo.MutationHookOptions<PauseProfileBoostMutation, PauseProfileBoostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseProfileBoostMutation, PauseProfileBoostMutationVariables>(PauseProfileBoostDocument, options);
      }
export type PauseProfileBoostMutationHookResult = ReturnType<typeof usePauseProfileBoostMutation>;
export type PauseProfileBoostMutationResult = Apollo.MutationResult<PauseProfileBoostMutation>;
export type PauseProfileBoostMutationOptions = Apollo.BaseMutationOptions<PauseProfileBoostMutation, PauseProfileBoostMutationVariables>;
export const ResumeProfileBoostDocument = gql`
    mutation ResumeProfileBoost($id: ID!) {
  resumeProfileBoost(id: $id) {
    ...ProfileBoostFields
  }
}
    ${ProfileBoostFieldsFragmentDoc}`;
export type ResumeProfileBoostMutationFn = Apollo.MutationFunction<ResumeProfileBoostMutation, ResumeProfileBoostMutationVariables>;

/**
 * __useResumeProfileBoostMutation__
 *
 * To run a mutation, you first call `useResumeProfileBoostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeProfileBoostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeProfileBoostMutation, { data, loading, error }] = useResumeProfileBoostMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResumeProfileBoostMutation(baseOptions?: Apollo.MutationHookOptions<ResumeProfileBoostMutation, ResumeProfileBoostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeProfileBoostMutation, ResumeProfileBoostMutationVariables>(ResumeProfileBoostDocument, options);
      }
export type ResumeProfileBoostMutationHookResult = ReturnType<typeof useResumeProfileBoostMutation>;
export type ResumeProfileBoostMutationResult = Apollo.MutationResult<ResumeProfileBoostMutation>;
export type ResumeProfileBoostMutationOptions = Apollo.BaseMutationOptions<ResumeProfileBoostMutation, ResumeProfileBoostMutationVariables>;
export const RecordProfileBoostImpressionDocument = gql`
    mutation RecordProfileBoostImpression($boostId: ID!) {
  recordProfileBoostImpression(boostId: $boostId)
}
    `;
export type RecordProfileBoostImpressionMutationFn = Apollo.MutationFunction<RecordProfileBoostImpressionMutation, RecordProfileBoostImpressionMutationVariables>;

/**
 * __useRecordProfileBoostImpressionMutation__
 *
 * To run a mutation, you first call `useRecordProfileBoostImpressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordProfileBoostImpressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordProfileBoostImpressionMutation, { data, loading, error }] = useRecordProfileBoostImpressionMutation({
 *   variables: {
 *      boostId: // value for 'boostId'
 *   },
 * });
 */
export function useRecordProfileBoostImpressionMutation(baseOptions?: Apollo.MutationHookOptions<RecordProfileBoostImpressionMutation, RecordProfileBoostImpressionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordProfileBoostImpressionMutation, RecordProfileBoostImpressionMutationVariables>(RecordProfileBoostImpressionDocument, options);
      }
export type RecordProfileBoostImpressionMutationHookResult = ReturnType<typeof useRecordProfileBoostImpressionMutation>;
export type RecordProfileBoostImpressionMutationResult = Apollo.MutationResult<RecordProfileBoostImpressionMutation>;
export type RecordProfileBoostImpressionMutationOptions = Apollo.BaseMutationOptions<RecordProfileBoostImpressionMutation, RecordProfileBoostImpressionMutationVariables>;
export const RecordProfileBoostClickDocument = gql`
    mutation RecordProfileBoostClick($boostId: ID!) {
  recordProfileBoostClick(boostId: $boostId)
}
    `;
export type RecordProfileBoostClickMutationFn = Apollo.MutationFunction<RecordProfileBoostClickMutation, RecordProfileBoostClickMutationVariables>;

/**
 * __useRecordProfileBoostClickMutation__
 *
 * To run a mutation, you first call `useRecordProfileBoostClickMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordProfileBoostClickMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordProfileBoostClickMutation, { data, loading, error }] = useRecordProfileBoostClickMutation({
 *   variables: {
 *      boostId: // value for 'boostId'
 *   },
 * });
 */
export function useRecordProfileBoostClickMutation(baseOptions?: Apollo.MutationHookOptions<RecordProfileBoostClickMutation, RecordProfileBoostClickMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordProfileBoostClickMutation, RecordProfileBoostClickMutationVariables>(RecordProfileBoostClickDocument, options);
      }
export type RecordProfileBoostClickMutationHookResult = ReturnType<typeof useRecordProfileBoostClickMutation>;
export type RecordProfileBoostClickMutationResult = Apollo.MutationResult<RecordProfileBoostClickMutation>;
export type RecordProfileBoostClickMutationOptions = Apollo.BaseMutationOptions<RecordProfileBoostClickMutation, RecordProfileBoostClickMutationVariables>;
export const RecordProfileBoostProfileVisitDocument = gql`
    mutation RecordProfileBoostProfileVisit($boostId: ID!) {
  recordProfileBoostProfileVisit(boostId: $boostId)
}
    `;
export type RecordProfileBoostProfileVisitMutationFn = Apollo.MutationFunction<RecordProfileBoostProfileVisitMutation, RecordProfileBoostProfileVisitMutationVariables>;

/**
 * __useRecordProfileBoostProfileVisitMutation__
 *
 * To run a mutation, you first call `useRecordProfileBoostProfileVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordProfileBoostProfileVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordProfileBoostProfileVisitMutation, { data, loading, error }] = useRecordProfileBoostProfileVisitMutation({
 *   variables: {
 *      boostId: // value for 'boostId'
 *   },
 * });
 */
export function useRecordProfileBoostProfileVisitMutation(baseOptions?: Apollo.MutationHookOptions<RecordProfileBoostProfileVisitMutation, RecordProfileBoostProfileVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordProfileBoostProfileVisitMutation, RecordProfileBoostProfileVisitMutationVariables>(RecordProfileBoostProfileVisitDocument, options);
      }
export type RecordProfileBoostProfileVisitMutationHookResult = ReturnType<typeof useRecordProfileBoostProfileVisitMutation>;
export type RecordProfileBoostProfileVisitMutationResult = Apollo.MutationResult<RecordProfileBoostProfileVisitMutation>;
export type RecordProfileBoostProfileVisitMutationOptions = Apollo.BaseMutationOptions<RecordProfileBoostProfileVisitMutation, RecordProfileBoostProfileVisitMutationVariables>;
export const FeaturedMentorsDocument = gql`
    query FeaturedMentors($limit: Int) {
  featuredMentors(limit: $limit) {
    id
    firstName
    lastName
    title
    profileImageUrl
    role
    about
    totalConsultations
    totalConnections
    isBoosted
    boostEndsAt
    companyName
  }
}
    `;

/**
 * __useFeaturedMentorsQuery__
 *
 * To run a query within a React component, call `useFeaturedMentorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturedMentorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturedMentorsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFeaturedMentorsQuery(baseOptions?: Apollo.QueryHookOptions<FeaturedMentorsQuery, FeaturedMentorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeaturedMentorsQuery, FeaturedMentorsQueryVariables>(FeaturedMentorsDocument, options);
      }
export function useFeaturedMentorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeaturedMentorsQuery, FeaturedMentorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeaturedMentorsQuery, FeaturedMentorsQueryVariables>(FeaturedMentorsDocument, options);
        }
// @ts-ignore
export function useFeaturedMentorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeaturedMentorsQuery, FeaturedMentorsQueryVariables>): Apollo.UseSuspenseQueryResult<FeaturedMentorsQuery, FeaturedMentorsQueryVariables>;
export function useFeaturedMentorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeaturedMentorsQuery, FeaturedMentorsQueryVariables>): Apollo.UseSuspenseQueryResult<FeaturedMentorsQuery | undefined, FeaturedMentorsQueryVariables>;
export function useFeaturedMentorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeaturedMentorsQuery, FeaturedMentorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeaturedMentorsQuery, FeaturedMentorsQueryVariables>(FeaturedMentorsDocument, options);
        }
export type FeaturedMentorsQueryHookResult = ReturnType<typeof useFeaturedMentorsQuery>;
export type FeaturedMentorsLazyQueryHookResult = ReturnType<typeof useFeaturedMentorsLazyQuery>;
export type FeaturedMentorsSuspenseQueryHookResult = ReturnType<typeof useFeaturedMentorsSuspenseQuery>;
export type FeaturedMentorsQueryResult = Apollo.QueryResult<FeaturedMentorsQuery, FeaturedMentorsQueryVariables>;
export const ActiveProfileBoostPacksDocument = gql`
    query ActiveProfileBoostPacks {
  activeProfileBoostPacks {
    id
    label
    hours
    priceCents
    status
  }
}
    `;

/**
 * __useActiveProfileBoostPacksQuery__
 *
 * To run a query within a React component, call `useActiveProfileBoostPacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveProfileBoostPacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveProfileBoostPacksQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveProfileBoostPacksQuery(baseOptions?: Apollo.QueryHookOptions<ActiveProfileBoostPacksQuery, ActiveProfileBoostPacksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveProfileBoostPacksQuery, ActiveProfileBoostPacksQueryVariables>(ActiveProfileBoostPacksDocument, options);
      }
export function useActiveProfileBoostPacksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveProfileBoostPacksQuery, ActiveProfileBoostPacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveProfileBoostPacksQuery, ActiveProfileBoostPacksQueryVariables>(ActiveProfileBoostPacksDocument, options);
        }
// @ts-ignore
export function useActiveProfileBoostPacksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActiveProfileBoostPacksQuery, ActiveProfileBoostPacksQueryVariables>): Apollo.UseSuspenseQueryResult<ActiveProfileBoostPacksQuery, ActiveProfileBoostPacksQueryVariables>;
export function useActiveProfileBoostPacksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActiveProfileBoostPacksQuery, ActiveProfileBoostPacksQueryVariables>): Apollo.UseSuspenseQueryResult<ActiveProfileBoostPacksQuery | undefined, ActiveProfileBoostPacksQueryVariables>;
export function useActiveProfileBoostPacksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActiveProfileBoostPacksQuery, ActiveProfileBoostPacksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActiveProfileBoostPacksQuery, ActiveProfileBoostPacksQueryVariables>(ActiveProfileBoostPacksDocument, options);
        }
export type ActiveProfileBoostPacksQueryHookResult = ReturnType<typeof useActiveProfileBoostPacksQuery>;
export type ActiveProfileBoostPacksLazyQueryHookResult = ReturnType<typeof useActiveProfileBoostPacksLazyQuery>;
export type ActiveProfileBoostPacksSuspenseQueryHookResult = ReturnType<typeof useActiveProfileBoostPacksSuspenseQuery>;
export type ActiveProfileBoostPacksQueryResult = Apollo.QueryResult<ActiveProfileBoostPacksQuery, ActiveProfileBoostPacksQueryVariables>;
export const ProfileBoostHourlyRateDocument = gql`
    query ProfileBoostHourlyRate {
  profileBoostHourlyRate {
    hourlyRateCents
  }
}
    `;

/**
 * __useProfileBoostHourlyRateQuery__
 *
 * To run a query within a React component, call `useProfileBoostHourlyRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileBoostHourlyRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileBoostHourlyRateQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileBoostHourlyRateQuery(baseOptions?: Apollo.QueryHookOptions<ProfileBoostHourlyRateQuery, ProfileBoostHourlyRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileBoostHourlyRateQuery, ProfileBoostHourlyRateQueryVariables>(ProfileBoostHourlyRateDocument, options);
      }
export function useProfileBoostHourlyRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileBoostHourlyRateQuery, ProfileBoostHourlyRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileBoostHourlyRateQuery, ProfileBoostHourlyRateQueryVariables>(ProfileBoostHourlyRateDocument, options);
        }
// @ts-ignore
export function useProfileBoostHourlyRateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfileBoostHourlyRateQuery, ProfileBoostHourlyRateQueryVariables>): Apollo.UseSuspenseQueryResult<ProfileBoostHourlyRateQuery, ProfileBoostHourlyRateQueryVariables>;
export function useProfileBoostHourlyRateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileBoostHourlyRateQuery, ProfileBoostHourlyRateQueryVariables>): Apollo.UseSuspenseQueryResult<ProfileBoostHourlyRateQuery | undefined, ProfileBoostHourlyRateQueryVariables>;
export function useProfileBoostHourlyRateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileBoostHourlyRateQuery, ProfileBoostHourlyRateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileBoostHourlyRateQuery, ProfileBoostHourlyRateQueryVariables>(ProfileBoostHourlyRateDocument, options);
        }
export type ProfileBoostHourlyRateQueryHookResult = ReturnType<typeof useProfileBoostHourlyRateQuery>;
export type ProfileBoostHourlyRateLazyQueryHookResult = ReturnType<typeof useProfileBoostHourlyRateLazyQuery>;
export type ProfileBoostHourlyRateSuspenseQueryHookResult = ReturnType<typeof useProfileBoostHourlyRateSuspenseQuery>;
export type ProfileBoostHourlyRateQueryResult = Apollo.QueryResult<ProfileBoostHourlyRateQuery, ProfileBoostHourlyRateQueryVariables>;
export const PreviewProfileBoostCostDocument = gql`
    query PreviewProfileBoostCost($durationHours: Int!) {
  previewProfileBoostCost(durationHours: $durationHours) {
    durationHours
    durationSeconds
    hourlyRateCents
    amountCents
  }
}
    `;

/**
 * __usePreviewProfileBoostCostQuery__
 *
 * To run a query within a React component, call `usePreviewProfileBoostCostQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewProfileBoostCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewProfileBoostCostQuery({
 *   variables: {
 *      durationHours: // value for 'durationHours'
 *   },
 * });
 */
export function usePreviewProfileBoostCostQuery(baseOptions: Apollo.QueryHookOptions<PreviewProfileBoostCostQuery, PreviewProfileBoostCostQueryVariables> & ({ variables: PreviewProfileBoostCostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewProfileBoostCostQuery, PreviewProfileBoostCostQueryVariables>(PreviewProfileBoostCostDocument, options);
      }
export function usePreviewProfileBoostCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewProfileBoostCostQuery, PreviewProfileBoostCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewProfileBoostCostQuery, PreviewProfileBoostCostQueryVariables>(PreviewProfileBoostCostDocument, options);
        }
// @ts-ignore
export function usePreviewProfileBoostCostSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreviewProfileBoostCostQuery, PreviewProfileBoostCostQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewProfileBoostCostQuery, PreviewProfileBoostCostQueryVariables>;
export function usePreviewProfileBoostCostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewProfileBoostCostQuery, PreviewProfileBoostCostQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewProfileBoostCostQuery | undefined, PreviewProfileBoostCostQueryVariables>;
export function usePreviewProfileBoostCostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewProfileBoostCostQuery, PreviewProfileBoostCostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewProfileBoostCostQuery, PreviewProfileBoostCostQueryVariables>(PreviewProfileBoostCostDocument, options);
        }
export type PreviewProfileBoostCostQueryHookResult = ReturnType<typeof usePreviewProfileBoostCostQuery>;
export type PreviewProfileBoostCostLazyQueryHookResult = ReturnType<typeof usePreviewProfileBoostCostLazyQuery>;
export type PreviewProfileBoostCostSuspenseQueryHookResult = ReturnType<typeof usePreviewProfileBoostCostSuspenseQuery>;
export type PreviewProfileBoostCostQueryResult = Apollo.QueryResult<PreviewProfileBoostCostQuery, PreviewProfileBoostCostQueryVariables>;
export const MyActiveProfileBoostDocument = gql`
    query MyActiveProfileBoost {
  myActiveProfileBoost {
    ...ProfileBoostFields
  }
}
    ${ProfileBoostFieldsFragmentDoc}`;

/**
 * __useMyActiveProfileBoostQuery__
 *
 * To run a query within a React component, call `useMyActiveProfileBoostQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyActiveProfileBoostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyActiveProfileBoostQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyActiveProfileBoostQuery(baseOptions?: Apollo.QueryHookOptions<MyActiveProfileBoostQuery, MyActiveProfileBoostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyActiveProfileBoostQuery, MyActiveProfileBoostQueryVariables>(MyActiveProfileBoostDocument, options);
      }
export function useMyActiveProfileBoostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyActiveProfileBoostQuery, MyActiveProfileBoostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyActiveProfileBoostQuery, MyActiveProfileBoostQueryVariables>(MyActiveProfileBoostDocument, options);
        }
// @ts-ignore
export function useMyActiveProfileBoostSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyActiveProfileBoostQuery, MyActiveProfileBoostQueryVariables>): Apollo.UseSuspenseQueryResult<MyActiveProfileBoostQuery, MyActiveProfileBoostQueryVariables>;
export function useMyActiveProfileBoostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyActiveProfileBoostQuery, MyActiveProfileBoostQueryVariables>): Apollo.UseSuspenseQueryResult<MyActiveProfileBoostQuery | undefined, MyActiveProfileBoostQueryVariables>;
export function useMyActiveProfileBoostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyActiveProfileBoostQuery, MyActiveProfileBoostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyActiveProfileBoostQuery, MyActiveProfileBoostQueryVariables>(MyActiveProfileBoostDocument, options);
        }
export type MyActiveProfileBoostQueryHookResult = ReturnType<typeof useMyActiveProfileBoostQuery>;
export type MyActiveProfileBoostLazyQueryHookResult = ReturnType<typeof useMyActiveProfileBoostLazyQuery>;
export type MyActiveProfileBoostSuspenseQueryHookResult = ReturnType<typeof useMyActiveProfileBoostSuspenseQuery>;
export type MyActiveProfileBoostQueryResult = Apollo.QueryResult<MyActiveProfileBoostQuery, MyActiveProfileBoostQueryVariables>;
export const MyProfileBoostsDocument = gql`
    query MyProfileBoosts {
  myProfileBoosts {
    ...ProfileBoostFields
  }
}
    ${ProfileBoostFieldsFragmentDoc}`;

/**
 * __useMyProfileBoostsQuery__
 *
 * To run a query within a React component, call `useMyProfileBoostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileBoostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileBoostsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyProfileBoostsQuery(baseOptions?: Apollo.QueryHookOptions<MyProfileBoostsQuery, MyProfileBoostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProfileBoostsQuery, MyProfileBoostsQueryVariables>(MyProfileBoostsDocument, options);
      }
export function useMyProfileBoostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProfileBoostsQuery, MyProfileBoostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProfileBoostsQuery, MyProfileBoostsQueryVariables>(MyProfileBoostsDocument, options);
        }
// @ts-ignore
export function useMyProfileBoostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyProfileBoostsQuery, MyProfileBoostsQueryVariables>): Apollo.UseSuspenseQueryResult<MyProfileBoostsQuery, MyProfileBoostsQueryVariables>;
export function useMyProfileBoostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyProfileBoostsQuery, MyProfileBoostsQueryVariables>): Apollo.UseSuspenseQueryResult<MyProfileBoostsQuery | undefined, MyProfileBoostsQueryVariables>;
export function useMyProfileBoostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyProfileBoostsQuery, MyProfileBoostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyProfileBoostsQuery, MyProfileBoostsQueryVariables>(MyProfileBoostsDocument, options);
        }
export type MyProfileBoostsQueryHookResult = ReturnType<typeof useMyProfileBoostsQuery>;
export type MyProfileBoostsLazyQueryHookResult = ReturnType<typeof useMyProfileBoostsLazyQuery>;
export type MyProfileBoostsSuspenseQueryHookResult = ReturnType<typeof useMyProfileBoostsSuspenseQuery>;
export type MyProfileBoostsQueryResult = Apollo.QueryResult<MyProfileBoostsQuery, MyProfileBoostsQueryVariables>;
export const ProfileBoostByIdDocument = gql`
    query ProfileBoostById($id: ID!) {
  profileBoostById(id: $id) {
    ...ProfileBoostFields
  }
}
    ${ProfileBoostFieldsFragmentDoc}`;

/**
 * __useProfileBoostByIdQuery__
 *
 * To run a query within a React component, call `useProfileBoostByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileBoostByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileBoostByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProfileBoostByIdQuery(baseOptions: Apollo.QueryHookOptions<ProfileBoostByIdQuery, ProfileBoostByIdQueryVariables> & ({ variables: ProfileBoostByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileBoostByIdQuery, ProfileBoostByIdQueryVariables>(ProfileBoostByIdDocument, options);
      }
export function useProfileBoostByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileBoostByIdQuery, ProfileBoostByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileBoostByIdQuery, ProfileBoostByIdQueryVariables>(ProfileBoostByIdDocument, options);
        }
// @ts-ignore
export function useProfileBoostByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfileBoostByIdQuery, ProfileBoostByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ProfileBoostByIdQuery, ProfileBoostByIdQueryVariables>;
export function useProfileBoostByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileBoostByIdQuery, ProfileBoostByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ProfileBoostByIdQuery | undefined, ProfileBoostByIdQueryVariables>;
export function useProfileBoostByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileBoostByIdQuery, ProfileBoostByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileBoostByIdQuery, ProfileBoostByIdQueryVariables>(ProfileBoostByIdDocument, options);
        }
export type ProfileBoostByIdQueryHookResult = ReturnType<typeof useProfileBoostByIdQuery>;
export type ProfileBoostByIdLazyQueryHookResult = ReturnType<typeof useProfileBoostByIdLazyQuery>;
export type ProfileBoostByIdSuspenseQueryHookResult = ReturnType<typeof useProfileBoostByIdSuspenseQuery>;
export type ProfileBoostByIdQueryResult = Apollo.QueryResult<ProfileBoostByIdQuery, ProfileBoostByIdQueryVariables>;
export const ProfileBoostDailyStatsDocument = gql`
    query ProfileBoostDailyStats($boostId: ID!) {
  profileBoostDailyStats(boostId: $boostId) {
    categories
    impressions
    profileVisits
    clicks
  }
}
    `;

/**
 * __useProfileBoostDailyStatsQuery__
 *
 * To run a query within a React component, call `useProfileBoostDailyStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileBoostDailyStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileBoostDailyStatsQuery({
 *   variables: {
 *      boostId: // value for 'boostId'
 *   },
 * });
 */
export function useProfileBoostDailyStatsQuery(baseOptions: Apollo.QueryHookOptions<ProfileBoostDailyStatsQuery, ProfileBoostDailyStatsQueryVariables> & ({ variables: ProfileBoostDailyStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileBoostDailyStatsQuery, ProfileBoostDailyStatsQueryVariables>(ProfileBoostDailyStatsDocument, options);
      }
export function useProfileBoostDailyStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileBoostDailyStatsQuery, ProfileBoostDailyStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileBoostDailyStatsQuery, ProfileBoostDailyStatsQueryVariables>(ProfileBoostDailyStatsDocument, options);
        }
// @ts-ignore
export function useProfileBoostDailyStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfileBoostDailyStatsQuery, ProfileBoostDailyStatsQueryVariables>): Apollo.UseSuspenseQueryResult<ProfileBoostDailyStatsQuery, ProfileBoostDailyStatsQueryVariables>;
export function useProfileBoostDailyStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileBoostDailyStatsQuery, ProfileBoostDailyStatsQueryVariables>): Apollo.UseSuspenseQueryResult<ProfileBoostDailyStatsQuery | undefined, ProfileBoostDailyStatsQueryVariables>;
export function useProfileBoostDailyStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileBoostDailyStatsQuery, ProfileBoostDailyStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileBoostDailyStatsQuery, ProfileBoostDailyStatsQueryVariables>(ProfileBoostDailyStatsDocument, options);
        }
export type ProfileBoostDailyStatsQueryHookResult = ReturnType<typeof useProfileBoostDailyStatsQuery>;
export type ProfileBoostDailyStatsLazyQueryHookResult = ReturnType<typeof useProfileBoostDailyStatsLazyQuery>;
export type ProfileBoostDailyStatsSuspenseQueryHookResult = ReturnType<typeof useProfileBoostDailyStatsSuspenseQuery>;
export type ProfileBoostDailyStatsQueryResult = Apollo.QueryResult<ProfileBoostDailyStatsQuery, ProfileBoostDailyStatsQueryVariables>;
export const OnProfileBoostActivityDocument = gql`
    subscription OnProfileBoostActivity {
  profileBoostActivity {
    changeType
    boostId
    boost {
      ...ProfileBoostFields
    }
  }
}
    ${ProfileBoostFieldsFragmentDoc}`;

/**
 * __useOnProfileBoostActivitySubscription__
 *
 * To run a query within a React component, call `useOnProfileBoostActivitySubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnProfileBoostActivitySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnProfileBoostActivitySubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnProfileBoostActivitySubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnProfileBoostActivitySubscription, OnProfileBoostActivitySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnProfileBoostActivitySubscription, OnProfileBoostActivitySubscriptionVariables>(OnProfileBoostActivityDocument, options);
      }
export type OnProfileBoostActivitySubscriptionHookResult = ReturnType<typeof useOnProfileBoostActivitySubscription>;
export type OnProfileBoostActivitySubscriptionResult = Apollo.SubscriptionResult<OnProfileBoostActivitySubscription>;
export const RecordProfileViewDocument = gql`
    mutation RecordProfileView($input: RecordProfileViewInput!) {
  recordProfileView(input: $input)
}
    `;
export type RecordProfileViewMutationFn = Apollo.MutationFunction<RecordProfileViewMutation, RecordProfileViewMutationVariables>;

/**
 * __useRecordProfileViewMutation__
 *
 * To run a mutation, you first call `useRecordProfileViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordProfileViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordProfileViewMutation, { data, loading, error }] = useRecordProfileViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordProfileViewMutation(baseOptions?: Apollo.MutationHookOptions<RecordProfileViewMutation, RecordProfileViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordProfileViewMutation, RecordProfileViewMutationVariables>(RecordProfileViewDocument, options);
      }
export type RecordProfileViewMutationHookResult = ReturnType<typeof useRecordProfileViewMutation>;
export type RecordProfileViewMutationResult = Apollo.MutationResult<RecordProfileViewMutation>;
export type RecordProfileViewMutationOptions = Apollo.BaseMutationOptions<RecordProfileViewMutation, RecordProfileViewMutationVariables>;
export const TogglePostReactionDocument = gql`
    mutation TogglePostReaction($input: LikePostInput!) {
  togglePostReaction(input: $input)
}
    `;
export type TogglePostReactionMutationFn = Apollo.MutationFunction<TogglePostReactionMutation, TogglePostReactionMutationVariables>;

/**
 * __useTogglePostReactionMutation__
 *
 * To run a mutation, you first call `useTogglePostReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePostReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePostReactionMutation, { data, loading, error }] = useTogglePostReactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTogglePostReactionMutation(baseOptions?: Apollo.MutationHookOptions<TogglePostReactionMutation, TogglePostReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TogglePostReactionMutation, TogglePostReactionMutationVariables>(TogglePostReactionDocument, options);
      }
export type TogglePostReactionMutationHookResult = ReturnType<typeof useTogglePostReactionMutation>;
export type TogglePostReactionMutationResult = Apollo.MutationResult<TogglePostReactionMutation>;
export type TogglePostReactionMutationOptions = Apollo.BaseMutationOptions<TogglePostReactionMutation, TogglePostReactionMutationVariables>;
export const GetReelsFeedDocument = gql`
    query GetReelsFeed($input: ReelsFeedInput) {
  getReelsFeed(input: $input) {
    id
    libraryItemId
    userId
    title
    description
    hlsUrl
    rawVideoUrl
    blurHash
    status
    likesCount
    commentsCount
    isLikedByMe
    createdAt
    isCurated
    embedUrl
    sourceUrl
    thumbnailUrl
    provider
    channelTitle
  }
}
    `;

/**
 * __useGetReelsFeedQuery__
 *
 * To run a query within a React component, call `useGetReelsFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReelsFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReelsFeedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReelsFeedQuery(baseOptions?: Apollo.QueryHookOptions<GetReelsFeedQuery, GetReelsFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReelsFeedQuery, GetReelsFeedQueryVariables>(GetReelsFeedDocument, options);
      }
export function useGetReelsFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReelsFeedQuery, GetReelsFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReelsFeedQuery, GetReelsFeedQueryVariables>(GetReelsFeedDocument, options);
        }
// @ts-ignore
export function useGetReelsFeedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReelsFeedQuery, GetReelsFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GetReelsFeedQuery, GetReelsFeedQueryVariables>;
export function useGetReelsFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReelsFeedQuery, GetReelsFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GetReelsFeedQuery | undefined, GetReelsFeedQueryVariables>;
export function useGetReelsFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReelsFeedQuery, GetReelsFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReelsFeedQuery, GetReelsFeedQueryVariables>(GetReelsFeedDocument, options);
        }
export type GetReelsFeedQueryHookResult = ReturnType<typeof useGetReelsFeedQuery>;
export type GetReelsFeedLazyQueryHookResult = ReturnType<typeof useGetReelsFeedLazyQuery>;
export type GetReelsFeedSuspenseQueryHookResult = ReturnType<typeof useGetReelsFeedSuspenseQuery>;
export type GetReelsFeedQueryResult = Apollo.QueryResult<GetReelsFeedQuery, GetReelsFeedQueryVariables>;
export const GetReelsByUserIdDocument = gql`
    query GetReelsByUserId($input: GetReelsByUserIdInput!) {
  getReelsByUserId(input: $input) {
    reels {
      id
      userId
      title
      description
      hlsUrl
      rawVideoUrl
      blurHash
      status
      likesCount
      commentsCount
      createdAt
      isCurated
      embedUrl
      sourceUrl
      thumbnailUrl
      provider
      channelTitle
    }
    total
    hasMore
    nextCursor
  }
}
    `;

/**
 * __useGetReelsByUserIdQuery__
 *
 * To run a query within a React component, call `useGetReelsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReelsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReelsByUserIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReelsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetReelsByUserIdQuery, GetReelsByUserIdQueryVariables> & ({ variables: GetReelsByUserIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReelsByUserIdQuery, GetReelsByUserIdQueryVariables>(GetReelsByUserIdDocument, options);
      }
export function useGetReelsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReelsByUserIdQuery, GetReelsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReelsByUserIdQuery, GetReelsByUserIdQueryVariables>(GetReelsByUserIdDocument, options);
        }
// @ts-ignore
export function useGetReelsByUserIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReelsByUserIdQuery, GetReelsByUserIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetReelsByUserIdQuery, GetReelsByUserIdQueryVariables>;
export function useGetReelsByUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReelsByUserIdQuery, GetReelsByUserIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetReelsByUserIdQuery | undefined, GetReelsByUserIdQueryVariables>;
export function useGetReelsByUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReelsByUserIdQuery, GetReelsByUserIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReelsByUserIdQuery, GetReelsByUserIdQueryVariables>(GetReelsByUserIdDocument, options);
        }
export type GetReelsByUserIdQueryHookResult = ReturnType<typeof useGetReelsByUserIdQuery>;
export type GetReelsByUserIdLazyQueryHookResult = ReturnType<typeof useGetReelsByUserIdLazyQuery>;
export type GetReelsByUserIdSuspenseQueryHookResult = ReturnType<typeof useGetReelsByUserIdSuspenseQuery>;
export type GetReelsByUserIdQueryResult = Apollo.QueryResult<GetReelsByUserIdQuery, GetReelsByUserIdQueryVariables>;
export const GetMyReelsDocument = gql`
    query GetMyReels {
  getMyReels {
    id
    userId
    title
    description
    hlsUrl
    rawVideoUrl
    blurHash
    status
    likesCount
    commentsCount
    createdAt
  }
}
    `;

/**
 * __useGetMyReelsQuery__
 *
 * To run a query within a React component, call `useGetMyReelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyReelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyReelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyReelsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyReelsQuery, GetMyReelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyReelsQuery, GetMyReelsQueryVariables>(GetMyReelsDocument, options);
      }
export function useGetMyReelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyReelsQuery, GetMyReelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyReelsQuery, GetMyReelsQueryVariables>(GetMyReelsDocument, options);
        }
// @ts-ignore
export function useGetMyReelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyReelsQuery, GetMyReelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyReelsQuery, GetMyReelsQueryVariables>;
export function useGetMyReelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyReelsQuery, GetMyReelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyReelsQuery | undefined, GetMyReelsQueryVariables>;
export function useGetMyReelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyReelsQuery, GetMyReelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyReelsQuery, GetMyReelsQueryVariables>(GetMyReelsDocument, options);
        }
export type GetMyReelsQueryHookResult = ReturnType<typeof useGetMyReelsQuery>;
export type GetMyReelsLazyQueryHookResult = ReturnType<typeof useGetMyReelsLazyQuery>;
export type GetMyReelsSuspenseQueryHookResult = ReturnType<typeof useGetMyReelsSuspenseQuery>;
export type GetMyReelsQueryResult = Apollo.QueryResult<GetMyReelsQuery, GetMyReelsQueryVariables>;
export const GetReelUploadUrlDocument = gql`
    mutation GetReelUploadUrl($input: GetUploadUrlInput!) {
  getReelUploadUrl(input: $input) {
    uploadUrl
    key
  }
}
    `;
export type GetReelUploadUrlMutationFn = Apollo.MutationFunction<GetReelUploadUrlMutation, GetReelUploadUrlMutationVariables>;

/**
 * __useGetReelUploadUrlMutation__
 *
 * To run a mutation, you first call `useGetReelUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReelUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReelUploadUrlMutation, { data, loading, error }] = useGetReelUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReelUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetReelUploadUrlMutation, GetReelUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReelUploadUrlMutation, GetReelUploadUrlMutationVariables>(GetReelUploadUrlDocument, options);
      }
export type GetReelUploadUrlMutationHookResult = ReturnType<typeof useGetReelUploadUrlMutation>;
export type GetReelUploadUrlMutationResult = Apollo.MutationResult<GetReelUploadUrlMutation>;
export type GetReelUploadUrlMutationOptions = Apollo.BaseMutationOptions<GetReelUploadUrlMutation, GetReelUploadUrlMutationVariables>;
export const ConfirmReelUploadDocument = gql`
    mutation ConfirmReelUpload($input: ConfirmUploadInput!) {
  confirmReelUpload(input: $input) {
    id
    title
    status
  }
}
    `;
export type ConfirmReelUploadMutationFn = Apollo.MutationFunction<ConfirmReelUploadMutation, ConfirmReelUploadMutationVariables>;

/**
 * __useConfirmReelUploadMutation__
 *
 * To run a mutation, you first call `useConfirmReelUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmReelUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmReelUploadMutation, { data, loading, error }] = useConfirmReelUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmReelUploadMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmReelUploadMutation, ConfirmReelUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmReelUploadMutation, ConfirmReelUploadMutationVariables>(ConfirmReelUploadDocument, options);
      }
export type ConfirmReelUploadMutationHookResult = ReturnType<typeof useConfirmReelUploadMutation>;
export type ConfirmReelUploadMutationResult = Apollo.MutationResult<ConfirmReelUploadMutation>;
export type ConfirmReelUploadMutationOptions = Apollo.BaseMutationOptions<ConfirmReelUploadMutation, ConfirmReelUploadMutationVariables>;
export const DeleteReelDocument = gql`
    mutation DeleteReel($input: DeleteReelInput!) {
  deleteReel(input: $input)
}
    `;
export type DeleteReelMutationFn = Apollo.MutationFunction<DeleteReelMutation, DeleteReelMutationVariables>;

/**
 * __useDeleteReelMutation__
 *
 * To run a mutation, you first call `useDeleteReelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReelMutation, { data, loading, error }] = useDeleteReelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteReelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReelMutation, DeleteReelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReelMutation, DeleteReelMutationVariables>(DeleteReelDocument, options);
      }
export type DeleteReelMutationHookResult = ReturnType<typeof useDeleteReelMutation>;
export type DeleteReelMutationResult = Apollo.MutationResult<DeleteReelMutation>;
export type DeleteReelMutationOptions = Apollo.BaseMutationOptions<DeleteReelMutation, DeleteReelMutationVariables>;
export const ReportReelPlaybackErrorDocument = gql`
    mutation ReportReelPlaybackError($input: ReportReelPlaybackErrorInput!) {
  reportReelPlaybackError(input: $input)
}
    `;
export type ReportReelPlaybackErrorMutationFn = Apollo.MutationFunction<ReportReelPlaybackErrorMutation, ReportReelPlaybackErrorMutationVariables>;

/**
 * __useReportReelPlaybackErrorMutation__
 *
 * To run a mutation, you first call `useReportReelPlaybackErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportReelPlaybackErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportReelPlaybackErrorMutation, { data, loading, error }] = useReportReelPlaybackErrorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportReelPlaybackErrorMutation(baseOptions?: Apollo.MutationHookOptions<ReportReelPlaybackErrorMutation, ReportReelPlaybackErrorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportReelPlaybackErrorMutation, ReportReelPlaybackErrorMutationVariables>(ReportReelPlaybackErrorDocument, options);
      }
export type ReportReelPlaybackErrorMutationHookResult = ReturnType<typeof useReportReelPlaybackErrorMutation>;
export type ReportReelPlaybackErrorMutationResult = Apollo.MutationResult<ReportReelPlaybackErrorMutation>;
export type ReportReelPlaybackErrorMutationOptions = Apollo.BaseMutationOptions<ReportReelPlaybackErrorMutation, ReportReelPlaybackErrorMutationVariables>;
export const UpdateReelDocument = gql`
    mutation UpdateReel($input: UpdateReelInput!) {
  updateReel(input: $input) {
    id
    userId
    title
    description
    hlsUrl
    rawVideoUrl
    blurHash
    status
    likesCount
    commentsCount
    createdAt
  }
}
    `;
export type UpdateReelMutationFn = Apollo.MutationFunction<UpdateReelMutation, UpdateReelMutationVariables>;

/**
 * __useUpdateReelMutation__
 *
 * To run a mutation, you first call `useUpdateReelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReelMutation, { data, loading, error }] = useUpdateReelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReelMutation, UpdateReelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReelMutation, UpdateReelMutationVariables>(UpdateReelDocument, options);
      }
export type UpdateReelMutationHookResult = ReturnType<typeof useUpdateReelMutation>;
export type UpdateReelMutationResult = Apollo.MutationResult<UpdateReelMutation>;
export type UpdateReelMutationOptions = Apollo.BaseMutationOptions<UpdateReelMutation, UpdateReelMutationVariables>;
export const LikeReelDocument = gql`
    mutation LikeReel($reelId: String!) {
  likeReel(reelId: $reelId) {
    id
    likesCount
    isLikedByMe
  }
}
    `;
export type LikeReelMutationFn = Apollo.MutationFunction<LikeReelMutation, LikeReelMutationVariables>;

/**
 * __useLikeReelMutation__
 *
 * To run a mutation, you first call `useLikeReelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikeReelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likeReelMutation, { data, loading, error }] = useLikeReelMutation({
 *   variables: {
 *      reelId: // value for 'reelId'
 *   },
 * });
 */
export function useLikeReelMutation(baseOptions?: Apollo.MutationHookOptions<LikeReelMutation, LikeReelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LikeReelMutation, LikeReelMutationVariables>(LikeReelDocument, options);
      }
export type LikeReelMutationHookResult = ReturnType<typeof useLikeReelMutation>;
export type LikeReelMutationResult = Apollo.MutationResult<LikeReelMutation>;
export type LikeReelMutationOptions = Apollo.BaseMutationOptions<LikeReelMutation, LikeReelMutationVariables>;
export const UnlikeReelDocument = gql`
    mutation UnlikeReel($reelId: String!) {
  unlikeReel(reelId: $reelId) {
    id
    likesCount
    isLikedByMe
  }
}
    `;
export type UnlikeReelMutationFn = Apollo.MutationFunction<UnlikeReelMutation, UnlikeReelMutationVariables>;

/**
 * __useUnlikeReelMutation__
 *
 * To run a mutation, you first call `useUnlikeReelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlikeReelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlikeReelMutation, { data, loading, error }] = useUnlikeReelMutation({
 *   variables: {
 *      reelId: // value for 'reelId'
 *   },
 * });
 */
export function useUnlikeReelMutation(baseOptions?: Apollo.MutationHookOptions<UnlikeReelMutation, UnlikeReelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlikeReelMutation, UnlikeReelMutationVariables>(UnlikeReelDocument, options);
      }
export type UnlikeReelMutationHookResult = ReturnType<typeof useUnlikeReelMutation>;
export type UnlikeReelMutationResult = Apollo.MutationResult<UnlikeReelMutation>;
export type UnlikeReelMutationOptions = Apollo.BaseMutationOptions<UnlikeReelMutation, UnlikeReelMutationVariables>;
export const CreateReelCommentDocument = gql`
    mutation CreateReelComment($input: CreateReelCommentInput!) {
  createReelComment(input: $input) {
    id
    reelId
    userId
    content
    translatedContent
    parentId
    repliesCount
    likesCount
    isLikedByMe
    createdAt
    updatedAt
    user {
      id
      firstName
      middleName
      lastName
      title
      role
      profileImageUrl
      companyName
    }
  }
}
    `;
export type CreateReelCommentMutationFn = Apollo.MutationFunction<CreateReelCommentMutation, CreateReelCommentMutationVariables>;

/**
 * __useCreateReelCommentMutation__
 *
 * To run a mutation, you first call `useCreateReelCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReelCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReelCommentMutation, { data, loading, error }] = useCreateReelCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReelCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateReelCommentMutation, CreateReelCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReelCommentMutation, CreateReelCommentMutationVariables>(CreateReelCommentDocument, options);
      }
export type CreateReelCommentMutationHookResult = ReturnType<typeof useCreateReelCommentMutation>;
export type CreateReelCommentMutationResult = Apollo.MutationResult<CreateReelCommentMutation>;
export type CreateReelCommentMutationOptions = Apollo.BaseMutationOptions<CreateReelCommentMutation, CreateReelCommentMutationVariables>;
export const LikeReelCommentDocument = gql`
    mutation LikeReelComment($commentId: String!) {
  likeReelComment(commentId: $commentId) {
    id
    likesCount
    isLikedByMe
  }
}
    `;
export type LikeReelCommentMutationFn = Apollo.MutationFunction<LikeReelCommentMutation, LikeReelCommentMutationVariables>;

/**
 * __useLikeReelCommentMutation__
 *
 * To run a mutation, you first call `useLikeReelCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikeReelCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likeReelCommentMutation, { data, loading, error }] = useLikeReelCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useLikeReelCommentMutation(baseOptions?: Apollo.MutationHookOptions<LikeReelCommentMutation, LikeReelCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LikeReelCommentMutation, LikeReelCommentMutationVariables>(LikeReelCommentDocument, options);
      }
export type LikeReelCommentMutationHookResult = ReturnType<typeof useLikeReelCommentMutation>;
export type LikeReelCommentMutationResult = Apollo.MutationResult<LikeReelCommentMutation>;
export type LikeReelCommentMutationOptions = Apollo.BaseMutationOptions<LikeReelCommentMutation, LikeReelCommentMutationVariables>;
export const UnlikeReelCommentDocument = gql`
    mutation UnlikeReelComment($commentId: String!) {
  unlikeReelComment(commentId: $commentId) {
    id
    likesCount
    isLikedByMe
  }
}
    `;
export type UnlikeReelCommentMutationFn = Apollo.MutationFunction<UnlikeReelCommentMutation, UnlikeReelCommentMutationVariables>;

/**
 * __useUnlikeReelCommentMutation__
 *
 * To run a mutation, you first call `useUnlikeReelCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlikeReelCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlikeReelCommentMutation, { data, loading, error }] = useUnlikeReelCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useUnlikeReelCommentMutation(baseOptions?: Apollo.MutationHookOptions<UnlikeReelCommentMutation, UnlikeReelCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlikeReelCommentMutation, UnlikeReelCommentMutationVariables>(UnlikeReelCommentDocument, options);
      }
export type UnlikeReelCommentMutationHookResult = ReturnType<typeof useUnlikeReelCommentMutation>;
export type UnlikeReelCommentMutationResult = Apollo.MutationResult<UnlikeReelCommentMutation>;
export type UnlikeReelCommentMutationOptions = Apollo.BaseMutationOptions<UnlikeReelCommentMutation, UnlikeReelCommentMutationVariables>;
export const GetReelCommentsDocument = gql`
    query GetReelComments($input: GetReelCommentsInput!) {
  getReelComments(input: $input) {
    comments {
      id
      reelId
      userId
      content
      translatedContent
      parentId
      repliesCount
      likesCount
      isLikedByMe
      createdAt
      updatedAt
      user {
        id
        firstName
        middleName
        lastName
        title
        role
        profileImageUrl
        companyName
      }
    }
    total
    hasMore
    nextCursor
  }
}
    `;

/**
 * __useGetReelCommentsQuery__
 *
 * To run a query within a React component, call `useGetReelCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReelCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReelCommentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReelCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetReelCommentsQuery, GetReelCommentsQueryVariables> & ({ variables: GetReelCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReelCommentsQuery, GetReelCommentsQueryVariables>(GetReelCommentsDocument, options);
      }
export function useGetReelCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReelCommentsQuery, GetReelCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReelCommentsQuery, GetReelCommentsQueryVariables>(GetReelCommentsDocument, options);
        }
// @ts-ignore
export function useGetReelCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReelCommentsQuery, GetReelCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReelCommentsQuery, GetReelCommentsQueryVariables>;
export function useGetReelCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReelCommentsQuery, GetReelCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReelCommentsQuery | undefined, GetReelCommentsQueryVariables>;
export function useGetReelCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReelCommentsQuery, GetReelCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReelCommentsQuery, GetReelCommentsQueryVariables>(GetReelCommentsDocument, options);
        }
export type GetReelCommentsQueryHookResult = ReturnType<typeof useGetReelCommentsQuery>;
export type GetReelCommentsLazyQueryHookResult = ReturnType<typeof useGetReelCommentsLazyQuery>;
export type GetReelCommentsSuspenseQueryHookResult = ReturnType<typeof useGetReelCommentsSuspenseQuery>;
export type GetReelCommentsQueryResult = Apollo.QueryResult<GetReelCommentsQuery, GetReelCommentsQueryVariables>;
export const GetReelCommentRepliesDocument = gql`
    query GetReelCommentReplies($input: GetReelCommentRepliesInput!) {
  getReelCommentReplies(input: $input) {
    comments {
      id
      reelId
      userId
      content
      translatedContent
      parentId
      repliesCount
      likesCount
      isLikedByMe
      createdAt
      updatedAt
      user {
        id
        firstName
        middleName
        lastName
        title
        role
        profileImageUrl
        companyName
      }
    }
    total
    hasMore
    nextCursor
  }
}
    `;

/**
 * __useGetReelCommentRepliesQuery__
 *
 * To run a query within a React component, call `useGetReelCommentRepliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReelCommentRepliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReelCommentRepliesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReelCommentRepliesQuery(baseOptions: Apollo.QueryHookOptions<GetReelCommentRepliesQuery, GetReelCommentRepliesQueryVariables> & ({ variables: GetReelCommentRepliesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReelCommentRepliesQuery, GetReelCommentRepliesQueryVariables>(GetReelCommentRepliesDocument, options);
      }
export function useGetReelCommentRepliesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReelCommentRepliesQuery, GetReelCommentRepliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReelCommentRepliesQuery, GetReelCommentRepliesQueryVariables>(GetReelCommentRepliesDocument, options);
        }
// @ts-ignore
export function useGetReelCommentRepliesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReelCommentRepliesQuery, GetReelCommentRepliesQueryVariables>): Apollo.UseSuspenseQueryResult<GetReelCommentRepliesQuery, GetReelCommentRepliesQueryVariables>;
export function useGetReelCommentRepliesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReelCommentRepliesQuery, GetReelCommentRepliesQueryVariables>): Apollo.UseSuspenseQueryResult<GetReelCommentRepliesQuery | undefined, GetReelCommentRepliesQueryVariables>;
export function useGetReelCommentRepliesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReelCommentRepliesQuery, GetReelCommentRepliesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReelCommentRepliesQuery, GetReelCommentRepliesQueryVariables>(GetReelCommentRepliesDocument, options);
        }
export type GetReelCommentRepliesQueryHookResult = ReturnType<typeof useGetReelCommentRepliesQuery>;
export type GetReelCommentRepliesLazyQueryHookResult = ReturnType<typeof useGetReelCommentRepliesLazyQuery>;
export type GetReelCommentRepliesSuspenseQueryHookResult = ReturnType<typeof useGetReelCommentRepliesSuspenseQuery>;
export type GetReelCommentRepliesQueryResult = Apollo.QueryResult<GetReelCommentRepliesQuery, GetReelCommentRepliesQueryVariables>;
export const GenerateMyReferralCodeDocument = gql`
    mutation GenerateMyReferralCode {
  generateMyReferralCode {
    id
    code
    name
    description
    isActive
    signupCount
    createdAt
  }
}
    `;
export type GenerateMyReferralCodeMutationFn = Apollo.MutationFunction<GenerateMyReferralCodeMutation, GenerateMyReferralCodeMutationVariables>;

/**
 * __useGenerateMyReferralCodeMutation__
 *
 * To run a mutation, you first call `useGenerateMyReferralCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMyReferralCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMyReferralCodeMutation, { data, loading, error }] = useGenerateMyReferralCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateMyReferralCodeMutation(baseOptions?: Apollo.MutationHookOptions<GenerateMyReferralCodeMutation, GenerateMyReferralCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateMyReferralCodeMutation, GenerateMyReferralCodeMutationVariables>(GenerateMyReferralCodeDocument, options);
      }
export type GenerateMyReferralCodeMutationHookResult = ReturnType<typeof useGenerateMyReferralCodeMutation>;
export type GenerateMyReferralCodeMutationResult = Apollo.MutationResult<GenerateMyReferralCodeMutation>;
export type GenerateMyReferralCodeMutationOptions = Apollo.BaseMutationOptions<GenerateMyReferralCodeMutation, GenerateMyReferralCodeMutationVariables>;
export const MyReferralCampaignDocument = gql`
    query MyReferralCampaign {
  myReferralCampaign {
    id
    code
    name
    description
    isActive
    signupCount
    createdAt
  }
}
    `;

/**
 * __useMyReferralCampaignQuery__
 *
 * To run a query within a React component, call `useMyReferralCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyReferralCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyReferralCampaignQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyReferralCampaignQuery(baseOptions?: Apollo.QueryHookOptions<MyReferralCampaignQuery, MyReferralCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyReferralCampaignQuery, MyReferralCampaignQueryVariables>(MyReferralCampaignDocument, options);
      }
export function useMyReferralCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyReferralCampaignQuery, MyReferralCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyReferralCampaignQuery, MyReferralCampaignQueryVariables>(MyReferralCampaignDocument, options);
        }
// @ts-ignore
export function useMyReferralCampaignSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyReferralCampaignQuery, MyReferralCampaignQueryVariables>): Apollo.UseSuspenseQueryResult<MyReferralCampaignQuery, MyReferralCampaignQueryVariables>;
export function useMyReferralCampaignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyReferralCampaignQuery, MyReferralCampaignQueryVariables>): Apollo.UseSuspenseQueryResult<MyReferralCampaignQuery | undefined, MyReferralCampaignQueryVariables>;
export function useMyReferralCampaignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyReferralCampaignQuery, MyReferralCampaignQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyReferralCampaignQuery, MyReferralCampaignQueryVariables>(MyReferralCampaignDocument, options);
        }
export type MyReferralCampaignQueryHookResult = ReturnType<typeof useMyReferralCampaignQuery>;
export type MyReferralCampaignLazyQueryHookResult = ReturnType<typeof useMyReferralCampaignLazyQuery>;
export type MyReferralCampaignSuspenseQueryHookResult = ReturnType<typeof useMyReferralCampaignSuspenseQuery>;
export type MyReferralCampaignQueryResult = Apollo.QueryResult<MyReferralCampaignQuery, MyReferralCampaignQueryVariables>;
export const RejectSessionDocument = gql`
    mutation RejectSession($sessionId: String!) {
  rejectBooking(sessionId: $sessionId)
}
    `;
export type RejectSessionMutationFn = Apollo.MutationFunction<RejectSessionMutation, RejectSessionMutationVariables>;

/**
 * __useRejectSessionMutation__
 *
 * To run a mutation, you first call `useRejectSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectSessionMutation, { data, loading, error }] = useRejectSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useRejectSessionMutation(baseOptions?: Apollo.MutationHookOptions<RejectSessionMutation, RejectSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectSessionMutation, RejectSessionMutationVariables>(RejectSessionDocument, options);
      }
export type RejectSessionMutationHookResult = ReturnType<typeof useRejectSessionMutation>;
export type RejectSessionMutationResult = Apollo.MutationResult<RejectSessionMutation>;
export type RejectSessionMutationOptions = Apollo.BaseMutationOptions<RejectSessionMutation, RejectSessionMutationVariables>;
export const WithdrawBookingDocument = gql`
    mutation WithdrawBooking($sessionId: String!) {
  withdrawBooking(sessionId: $sessionId)
}
    `;
export type WithdrawBookingMutationFn = Apollo.MutationFunction<WithdrawBookingMutation, WithdrawBookingMutationVariables>;

/**
 * __useWithdrawBookingMutation__
 *
 * To run a mutation, you first call `useWithdrawBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawBookingMutation, { data, loading, error }] = useWithdrawBookingMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useWithdrawBookingMutation(baseOptions?: Apollo.MutationHookOptions<WithdrawBookingMutation, WithdrawBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WithdrawBookingMutation, WithdrawBookingMutationVariables>(WithdrawBookingDocument, options);
      }
export type WithdrawBookingMutationHookResult = ReturnType<typeof useWithdrawBookingMutation>;
export type WithdrawBookingMutationResult = Apollo.MutationResult<WithdrawBookingMutation>;
export type WithdrawBookingMutationOptions = Apollo.BaseMutationOptions<WithdrawBookingMutation, WithdrawBookingMutationVariables>;
export const ReportPostDocument = gql`
    mutation ReportPost($input: ReportPostInput!) {
  reportPost(input: $input)
}
    `;
export type ReportPostMutationFn = Apollo.MutationFunction<ReportPostMutation, ReportPostMutationVariables>;

/**
 * __useReportPostMutation__
 *
 * To run a mutation, you first call `useReportPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportPostMutation, { data, loading, error }] = useReportPostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportPostMutation(baseOptions?: Apollo.MutationHookOptions<ReportPostMutation, ReportPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportPostMutation, ReportPostMutationVariables>(ReportPostDocument, options);
      }
export type ReportPostMutationHookResult = ReturnType<typeof useReportPostMutation>;
export type ReportPostMutationResult = Apollo.MutationResult<ReportPostMutation>;
export type ReportPostMutationOptions = Apollo.BaseMutationOptions<ReportPostMutation, ReportPostMutationVariables>;
export const RequestSessionRefundDocument = gql`
    mutation RequestSessionRefund($sessionId: String!, $reason: String) {
  requestSessionRefund(sessionId: $sessionId, reason: $reason)
}
    `;
export type RequestSessionRefundMutationFn = Apollo.MutationFunction<RequestSessionRefundMutation, RequestSessionRefundMutationVariables>;

/**
 * __useRequestSessionRefundMutation__
 *
 * To run a mutation, you first call `useRequestSessionRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestSessionRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestSessionRefundMutation, { data, loading, error }] = useRequestSessionRefundMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRequestSessionRefundMutation(baseOptions?: Apollo.MutationHookOptions<RequestSessionRefundMutation, RequestSessionRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestSessionRefundMutation, RequestSessionRefundMutationVariables>(RequestSessionRefundDocument, options);
      }
export type RequestSessionRefundMutationHookResult = ReturnType<typeof useRequestSessionRefundMutation>;
export type RequestSessionRefundMutationResult = Apollo.MutationResult<RequestSessionRefundMutation>;
export type RequestSessionRefundMutationOptions = Apollo.BaseMutationOptions<RequestSessionRefundMutation, RequestSessionRefundMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ResetUserPasswordDocument = gql`
    mutation ResetUserPassword($input: ResetPasswordInput!) {
  resetUserPassword(input: $input)
}
    `;
export type ResetUserPasswordMutationFn = Apollo.MutationFunction<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPasswordMutation, { data, loading, error }] = useResetUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(ResetUserPasswordDocument, options);
      }
export type ResetUserPasswordMutationHookResult = ReturnType<typeof useResetUserPasswordMutation>;
export type ResetUserPasswordMutationResult = Apollo.MutationResult<ResetUserPasswordMutation>;
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;
export const CreateReviewDocument = gql`
    mutation CreateReview($input: CreateReviewInput!) {
  createReview(input: $input) {
    id
    rating
    comment
    createdAt
    mentorId
    reviewer {
      id
      firstName
      lastName
      title
      companyName
    }
  }
}
    `;
export type CreateReviewMutationFn = Apollo.MutationFunction<CreateReviewMutation, CreateReviewMutationVariables>;

/**
 * __useCreateReviewMutation__
 *
 * To run a mutation, you first call `useCreateReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReviewMutation, { data, loading, error }] = useCreateReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateReviewMutation, CreateReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReviewMutation, CreateReviewMutationVariables>(CreateReviewDocument, options);
      }
export type CreateReviewMutationHookResult = ReturnType<typeof useCreateReviewMutation>;
export type CreateReviewMutationResult = Apollo.MutationResult<CreateReviewMutation>;
export type CreateReviewMutationOptions = Apollo.BaseMutationOptions<CreateReviewMutation, CreateReviewMutationVariables>;
export const GetAllReviewsOfMentorDocument = gql`
    query GetAllReviewsOfMentor($mentorId: String!) {
  getAllReviewsOfMentor(mentorId: $mentorId) {
    id
    rating
    comment
    createdAt
    reviewer {
      id
      firstName
      lastName
      title
      profileImageUrl
      companyName
    }
  }
}
    `;

/**
 * __useGetAllReviewsOfMentorQuery__
 *
 * To run a query within a React component, call `useGetAllReviewsOfMentorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllReviewsOfMentorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllReviewsOfMentorQuery({
 *   variables: {
 *      mentorId: // value for 'mentorId'
 *   },
 * });
 */
export function useGetAllReviewsOfMentorQuery(baseOptions: Apollo.QueryHookOptions<GetAllReviewsOfMentorQuery, GetAllReviewsOfMentorQueryVariables> & ({ variables: GetAllReviewsOfMentorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllReviewsOfMentorQuery, GetAllReviewsOfMentorQueryVariables>(GetAllReviewsOfMentorDocument, options);
      }
export function useGetAllReviewsOfMentorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllReviewsOfMentorQuery, GetAllReviewsOfMentorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllReviewsOfMentorQuery, GetAllReviewsOfMentorQueryVariables>(GetAllReviewsOfMentorDocument, options);
        }
// @ts-ignore
export function useGetAllReviewsOfMentorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllReviewsOfMentorQuery, GetAllReviewsOfMentorQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllReviewsOfMentorQuery, GetAllReviewsOfMentorQueryVariables>;
export function useGetAllReviewsOfMentorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllReviewsOfMentorQuery, GetAllReviewsOfMentorQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllReviewsOfMentorQuery | undefined, GetAllReviewsOfMentorQueryVariables>;
export function useGetAllReviewsOfMentorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllReviewsOfMentorQuery, GetAllReviewsOfMentorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllReviewsOfMentorQuery, GetAllReviewsOfMentorQueryVariables>(GetAllReviewsOfMentorDocument, options);
        }
export type GetAllReviewsOfMentorQueryHookResult = ReturnType<typeof useGetAllReviewsOfMentorQuery>;
export type GetAllReviewsOfMentorLazyQueryHookResult = ReturnType<typeof useGetAllReviewsOfMentorLazyQuery>;
export type GetAllReviewsOfMentorSuspenseQueryHookResult = ReturnType<typeof useGetAllReviewsOfMentorSuspenseQuery>;
export type GetAllReviewsOfMentorQueryResult = Apollo.QueryResult<GetAllReviewsOfMentorQuery, GetAllReviewsOfMentorQueryVariables>;
export const IsAvailableForReviewDocument = gql`
    query IsAvailableForReview($mentorId: String!) {
  isAvailableForReview(mentorId: $mentorId)
}
    `;

/**
 * __useIsAvailableForReviewQuery__
 *
 * To run a query within a React component, call `useIsAvailableForReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsAvailableForReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsAvailableForReviewQuery({
 *   variables: {
 *      mentorId: // value for 'mentorId'
 *   },
 * });
 */
export function useIsAvailableForReviewQuery(baseOptions: Apollo.QueryHookOptions<IsAvailableForReviewQuery, IsAvailableForReviewQueryVariables> & ({ variables: IsAvailableForReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsAvailableForReviewQuery, IsAvailableForReviewQueryVariables>(IsAvailableForReviewDocument, options);
      }
export function useIsAvailableForReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsAvailableForReviewQuery, IsAvailableForReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsAvailableForReviewQuery, IsAvailableForReviewQueryVariables>(IsAvailableForReviewDocument, options);
        }
// @ts-ignore
export function useIsAvailableForReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsAvailableForReviewQuery, IsAvailableForReviewQueryVariables>): Apollo.UseSuspenseQueryResult<IsAvailableForReviewQuery, IsAvailableForReviewQueryVariables>;
export function useIsAvailableForReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsAvailableForReviewQuery, IsAvailableForReviewQueryVariables>): Apollo.UseSuspenseQueryResult<IsAvailableForReviewQuery | undefined, IsAvailableForReviewQueryVariables>;
export function useIsAvailableForReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsAvailableForReviewQuery, IsAvailableForReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsAvailableForReviewQuery, IsAvailableForReviewQueryVariables>(IsAvailableForReviewDocument, options);
        }
export type IsAvailableForReviewQueryHookResult = ReturnType<typeof useIsAvailableForReviewQuery>;
export type IsAvailableForReviewLazyQueryHookResult = ReturnType<typeof useIsAvailableForReviewLazyQuery>;
export type IsAvailableForReviewSuspenseQueryHookResult = ReturnType<typeof useIsAvailableForReviewSuspenseQuery>;
export type IsAvailableForReviewQueryResult = Apollo.QueryResult<IsAvailableForReviewQuery, IsAvailableForReviewQueryVariables>;
export const CreateRoleChangeRequestDocument = gql`
    mutation CreateRoleChangeRequest($input: CreateRoleChangeRequestInput!) {
  createRoleChangeRequest(input: $input) {
    id
    currentRole
    requestedRole
    reason
    status
    createdAt
  }
}
    `;
export type CreateRoleChangeRequestMutationFn = Apollo.MutationFunction<CreateRoleChangeRequestMutation, CreateRoleChangeRequestMutationVariables>;

/**
 * __useCreateRoleChangeRequestMutation__
 *
 * To run a mutation, you first call `useCreateRoleChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleChangeRequestMutation, { data, loading, error }] = useCreateRoleChangeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoleChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleChangeRequestMutation, CreateRoleChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleChangeRequestMutation, CreateRoleChangeRequestMutationVariables>(CreateRoleChangeRequestDocument, options);
      }
export type CreateRoleChangeRequestMutationHookResult = ReturnType<typeof useCreateRoleChangeRequestMutation>;
export type CreateRoleChangeRequestMutationResult = Apollo.MutationResult<CreateRoleChangeRequestMutation>;
export type CreateRoleChangeRequestMutationOptions = Apollo.BaseMutationOptions<CreateRoleChangeRequestMutation, CreateRoleChangeRequestMutationVariables>;
export const CancelRoleChangeRequestDocument = gql`
    mutation CancelRoleChangeRequest($id: String!) {
  cancelRoleChangeRequest(id: $id) {
    id
    status
  }
}
    `;
export type CancelRoleChangeRequestMutationFn = Apollo.MutationFunction<CancelRoleChangeRequestMutation, CancelRoleChangeRequestMutationVariables>;

/**
 * __useCancelRoleChangeRequestMutation__
 *
 * To run a mutation, you first call `useCancelRoleChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRoleChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRoleChangeRequestMutation, { data, loading, error }] = useCancelRoleChangeRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelRoleChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelRoleChangeRequestMutation, CancelRoleChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelRoleChangeRequestMutation, CancelRoleChangeRequestMutationVariables>(CancelRoleChangeRequestDocument, options);
      }
export type CancelRoleChangeRequestMutationHookResult = ReturnType<typeof useCancelRoleChangeRequestMutation>;
export type CancelRoleChangeRequestMutationResult = Apollo.MutationResult<CancelRoleChangeRequestMutation>;
export type CancelRoleChangeRequestMutationOptions = Apollo.BaseMutationOptions<CancelRoleChangeRequestMutation, CancelRoleChangeRequestMutationVariables>;
export const MyRoleChangeRequestsDocument = gql`
    query MyRoleChangeRequests {
  myRoleChangeRequests {
    id
    userId
    currentRole
    requestedRole
    reason
    status
    reviewedBy
    reviewedAt
    rejectionReason
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useMyRoleChangeRequestsQuery__
 *
 * To run a query within a React component, call `useMyRoleChangeRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyRoleChangeRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyRoleChangeRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyRoleChangeRequestsQuery(baseOptions?: Apollo.QueryHookOptions<MyRoleChangeRequestsQuery, MyRoleChangeRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyRoleChangeRequestsQuery, MyRoleChangeRequestsQueryVariables>(MyRoleChangeRequestsDocument, options);
      }
export function useMyRoleChangeRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyRoleChangeRequestsQuery, MyRoleChangeRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyRoleChangeRequestsQuery, MyRoleChangeRequestsQueryVariables>(MyRoleChangeRequestsDocument, options);
        }
// @ts-ignore
export function useMyRoleChangeRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyRoleChangeRequestsQuery, MyRoleChangeRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<MyRoleChangeRequestsQuery, MyRoleChangeRequestsQueryVariables>;
export function useMyRoleChangeRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyRoleChangeRequestsQuery, MyRoleChangeRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<MyRoleChangeRequestsQuery | undefined, MyRoleChangeRequestsQueryVariables>;
export function useMyRoleChangeRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyRoleChangeRequestsQuery, MyRoleChangeRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyRoleChangeRequestsQuery, MyRoleChangeRequestsQueryVariables>(MyRoleChangeRequestsDocument, options);
        }
export type MyRoleChangeRequestsQueryHookResult = ReturnType<typeof useMyRoleChangeRequestsQuery>;
export type MyRoleChangeRequestsLazyQueryHookResult = ReturnType<typeof useMyRoleChangeRequestsLazyQuery>;
export type MyRoleChangeRequestsSuspenseQueryHookResult = ReturnType<typeof useMyRoleChangeRequestsSuspenseQuery>;
export type MyRoleChangeRequestsQueryResult = Apollo.QueryResult<MyRoleChangeRequestsQuery, MyRoleChangeRequestsQueryVariables>;
export const AllowedRoleChangeTargetsDocument = gql`
    query AllowedRoleChangeTargets {
  allowedRoleChangeTargets
}
    `;

/**
 * __useAllowedRoleChangeTargetsQuery__
 *
 * To run a query within a React component, call `useAllowedRoleChangeTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllowedRoleChangeTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllowedRoleChangeTargetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllowedRoleChangeTargetsQuery(baseOptions?: Apollo.QueryHookOptions<AllowedRoleChangeTargetsQuery, AllowedRoleChangeTargetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllowedRoleChangeTargetsQuery, AllowedRoleChangeTargetsQueryVariables>(AllowedRoleChangeTargetsDocument, options);
      }
export function useAllowedRoleChangeTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllowedRoleChangeTargetsQuery, AllowedRoleChangeTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllowedRoleChangeTargetsQuery, AllowedRoleChangeTargetsQueryVariables>(AllowedRoleChangeTargetsDocument, options);
        }
// @ts-ignore
export function useAllowedRoleChangeTargetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllowedRoleChangeTargetsQuery, AllowedRoleChangeTargetsQueryVariables>): Apollo.UseSuspenseQueryResult<AllowedRoleChangeTargetsQuery, AllowedRoleChangeTargetsQueryVariables>;
export function useAllowedRoleChangeTargetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllowedRoleChangeTargetsQuery, AllowedRoleChangeTargetsQueryVariables>): Apollo.UseSuspenseQueryResult<AllowedRoleChangeTargetsQuery | undefined, AllowedRoleChangeTargetsQueryVariables>;
export function useAllowedRoleChangeTargetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllowedRoleChangeTargetsQuery, AllowedRoleChangeTargetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllowedRoleChangeTargetsQuery, AllowedRoleChangeTargetsQueryVariables>(AllowedRoleChangeTargetsDocument, options);
        }
export type AllowedRoleChangeTargetsQueryHookResult = ReturnType<typeof useAllowedRoleChangeTargetsQuery>;
export type AllowedRoleChangeTargetsLazyQueryHookResult = ReturnType<typeof useAllowedRoleChangeTargetsLazyQuery>;
export type AllowedRoleChangeTargetsSuspenseQueryHookResult = ReturnType<typeof useAllowedRoleChangeTargetsSuspenseQuery>;
export type AllowedRoleChangeTargetsQueryResult = Apollo.QueryResult<AllowedRoleChangeTargetsQuery, AllowedRoleChangeTargetsQueryVariables>;
export const GetAllRssFeedsDocument = gql`
    query GetAllRssFeeds($page: Int, $limit: Int, $keywords: [String!], $excludeAdIds: [String!]) {
  getAllRssFeeds(
    query: {page: $page, limit: $limit, keywords: $keywords, excludeAdIds: $excludeAdIds}
  ) {
    items {
      id
      guid
      summary
      imageUrl
      profile_image
      link
      title
      source
      publishedAt
      isSaved
      libraryItemId
    }
    sponsoredItems {
      afterItemIndex
      ad {
        id
        name
        headline
        description
        adFormat
        mediaUrls
        ctaText
        ctaUrl
        user {
          id
          organizationName
          firstName
          lastName
          title
          profileImageUrl
          companyName
        }
      }
    }
    total
    totalPages
  }
}
    `;

/**
 * __useGetAllRssFeedsQuery__
 *
 * To run a query within a React component, call `useGetAllRssFeedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRssFeedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRssFeedsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      keywords: // value for 'keywords'
 *      excludeAdIds: // value for 'excludeAdIds'
 *   },
 * });
 */
export function useGetAllRssFeedsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRssFeedsQuery, GetAllRssFeedsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRssFeedsQuery, GetAllRssFeedsQueryVariables>(GetAllRssFeedsDocument, options);
      }
export function useGetAllRssFeedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRssFeedsQuery, GetAllRssFeedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRssFeedsQuery, GetAllRssFeedsQueryVariables>(GetAllRssFeedsDocument, options);
        }
// @ts-ignore
export function useGetAllRssFeedsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllRssFeedsQuery, GetAllRssFeedsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllRssFeedsQuery, GetAllRssFeedsQueryVariables>;
export function useGetAllRssFeedsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRssFeedsQuery, GetAllRssFeedsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllRssFeedsQuery | undefined, GetAllRssFeedsQueryVariables>;
export function useGetAllRssFeedsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRssFeedsQuery, GetAllRssFeedsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRssFeedsQuery, GetAllRssFeedsQueryVariables>(GetAllRssFeedsDocument, options);
        }
export type GetAllRssFeedsQueryHookResult = ReturnType<typeof useGetAllRssFeedsQuery>;
export type GetAllRssFeedsLazyQueryHookResult = ReturnType<typeof useGetAllRssFeedsLazyQuery>;
export type GetAllRssFeedsSuspenseQueryHookResult = ReturnType<typeof useGetAllRssFeedsSuspenseQuery>;
export type GetAllRssFeedsQueryResult = Apollo.QueryResult<GetAllRssFeedsQuery, GetAllRssFeedsQueryVariables>;
export const GetRssFeedsBySourceDocument = gql`
    query GetRssFeedsBySource($source: String!, $query: RssFeedQueryDto!) {
  getRssFeedsBySource(source: $source, query: $query) {
    items {
      id
      guid
      title
      source
      link
      publishedAt
      summary
      imageUrl
      profile_image
      isSaved
      libraryItemId
    }
    page
    limit
    total
    totalPages
  }
}
    `;

/**
 * __useGetRssFeedsBySourceQuery__
 *
 * To run a query within a React component, call `useGetRssFeedsBySourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRssFeedsBySourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRssFeedsBySourceQuery({
 *   variables: {
 *      source: // value for 'source'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetRssFeedsBySourceQuery(baseOptions: Apollo.QueryHookOptions<GetRssFeedsBySourceQuery, GetRssFeedsBySourceQueryVariables> & ({ variables: GetRssFeedsBySourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRssFeedsBySourceQuery, GetRssFeedsBySourceQueryVariables>(GetRssFeedsBySourceDocument, options);
      }
export function useGetRssFeedsBySourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRssFeedsBySourceQuery, GetRssFeedsBySourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRssFeedsBySourceQuery, GetRssFeedsBySourceQueryVariables>(GetRssFeedsBySourceDocument, options);
        }
// @ts-ignore
export function useGetRssFeedsBySourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRssFeedsBySourceQuery, GetRssFeedsBySourceQueryVariables>): Apollo.UseSuspenseQueryResult<GetRssFeedsBySourceQuery, GetRssFeedsBySourceQueryVariables>;
export function useGetRssFeedsBySourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRssFeedsBySourceQuery, GetRssFeedsBySourceQueryVariables>): Apollo.UseSuspenseQueryResult<GetRssFeedsBySourceQuery | undefined, GetRssFeedsBySourceQueryVariables>;
export function useGetRssFeedsBySourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRssFeedsBySourceQuery, GetRssFeedsBySourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRssFeedsBySourceQuery, GetRssFeedsBySourceQueryVariables>(GetRssFeedsBySourceDocument, options);
        }
export type GetRssFeedsBySourceQueryHookResult = ReturnType<typeof useGetRssFeedsBySourceQuery>;
export type GetRssFeedsBySourceLazyQueryHookResult = ReturnType<typeof useGetRssFeedsBySourceLazyQuery>;
export type GetRssFeedsBySourceSuspenseQueryHookResult = ReturnType<typeof useGetRssFeedsBySourceSuspenseQuery>;
export type GetRssFeedsBySourceQueryResult = Apollo.QueryResult<GetRssFeedsBySourceQuery, GetRssFeedsBySourceQueryVariables>;
export const GetRssFeedByIdDocument = gql`
    query GetRssFeedById($id: String!) {
  getRssFeedById(id: $id) {
    id
    guid
    source
    title
    link
    publishedAt
    summary
    content
    imageUrl
    profile_image
    createdAt
    updatedAt
    isSaved
    libraryItemId
  }
}
    `;

/**
 * __useGetRssFeedByIdQuery__
 *
 * To run a query within a React component, call `useGetRssFeedByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRssFeedByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRssFeedByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRssFeedByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRssFeedByIdQuery, GetRssFeedByIdQueryVariables> & ({ variables: GetRssFeedByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRssFeedByIdQuery, GetRssFeedByIdQueryVariables>(GetRssFeedByIdDocument, options);
      }
export function useGetRssFeedByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRssFeedByIdQuery, GetRssFeedByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRssFeedByIdQuery, GetRssFeedByIdQueryVariables>(GetRssFeedByIdDocument, options);
        }
// @ts-ignore
export function useGetRssFeedByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRssFeedByIdQuery, GetRssFeedByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetRssFeedByIdQuery, GetRssFeedByIdQueryVariables>;
export function useGetRssFeedByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRssFeedByIdQuery, GetRssFeedByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetRssFeedByIdQuery | undefined, GetRssFeedByIdQueryVariables>;
export function useGetRssFeedByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRssFeedByIdQuery, GetRssFeedByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRssFeedByIdQuery, GetRssFeedByIdQueryVariables>(GetRssFeedByIdDocument, options);
        }
export type GetRssFeedByIdQueryHookResult = ReturnType<typeof useGetRssFeedByIdQuery>;
export type GetRssFeedByIdLazyQueryHookResult = ReturnType<typeof useGetRssFeedByIdLazyQuery>;
export type GetRssFeedByIdSuspenseQueryHookResult = ReturnType<typeof useGetRssFeedByIdSuspenseQuery>;
export type GetRssFeedByIdQueryResult = Apollo.QueryResult<GetRssFeedByIdQuery, GetRssFeedByIdQueryVariables>;
export const GetRssSourceByNameDocument = gql`
    query GetRssSourceByName($name: String!) {
  getRssSourceByName(name: $name) {
    id
    name
    url
    description
    imageUrl
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetRssSourceByNameQuery__
 *
 * To run a query within a React component, call `useGetRssSourceByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRssSourceByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRssSourceByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetRssSourceByNameQuery(baseOptions: Apollo.QueryHookOptions<GetRssSourceByNameQuery, GetRssSourceByNameQueryVariables> & ({ variables: GetRssSourceByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRssSourceByNameQuery, GetRssSourceByNameQueryVariables>(GetRssSourceByNameDocument, options);
      }
export function useGetRssSourceByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRssSourceByNameQuery, GetRssSourceByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRssSourceByNameQuery, GetRssSourceByNameQueryVariables>(GetRssSourceByNameDocument, options);
        }
// @ts-ignore
export function useGetRssSourceByNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRssSourceByNameQuery, GetRssSourceByNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetRssSourceByNameQuery, GetRssSourceByNameQueryVariables>;
export function useGetRssSourceByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRssSourceByNameQuery, GetRssSourceByNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetRssSourceByNameQuery | undefined, GetRssSourceByNameQueryVariables>;
export function useGetRssSourceByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRssSourceByNameQuery, GetRssSourceByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRssSourceByNameQuery, GetRssSourceByNameQueryVariables>(GetRssSourceByNameDocument, options);
        }
export type GetRssSourceByNameQueryHookResult = ReturnType<typeof useGetRssSourceByNameQuery>;
export type GetRssSourceByNameLazyQueryHookResult = ReturnType<typeof useGetRssSourceByNameLazyQuery>;
export type GetRssSourceByNameSuspenseQueryHookResult = ReturnType<typeof useGetRssSourceByNameSuspenseQuery>;
export type GetRssSourceByNameQueryResult = Apollo.QueryResult<GetRssSourceByNameQuery, GetRssSourceByNameQueryVariables>;
export const GetSourcesDocument = gql`
    query GetSources {
  getSources {
    id
    name
    url
    description
    imageUrl
    createdAt
  }
}
    `;

/**
 * __useGetSourcesQuery__
 *
 * To run a query within a React component, call `useGetSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSourcesQuery(baseOptions?: Apollo.QueryHookOptions<GetSourcesQuery, GetSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSourcesQuery, GetSourcesQueryVariables>(GetSourcesDocument, options);
      }
export function useGetSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSourcesQuery, GetSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSourcesQuery, GetSourcesQueryVariables>(GetSourcesDocument, options);
        }
// @ts-ignore
export function useGetSourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSourcesQuery, GetSourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSourcesQuery, GetSourcesQueryVariables>;
export function useGetSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSourcesQuery, GetSourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSourcesQuery | undefined, GetSourcesQueryVariables>;
export function useGetSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSourcesQuery, GetSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSourcesQuery, GetSourcesQueryVariables>(GetSourcesDocument, options);
        }
export type GetSourcesQueryHookResult = ReturnType<typeof useGetSourcesQuery>;
export type GetSourcesLazyQueryHookResult = ReturnType<typeof useGetSourcesLazyQuery>;
export type GetSourcesSuspenseQueryHookResult = ReturnType<typeof useGetSourcesSuspenseQuery>;
export type GetSourcesQueryResult = Apollo.QueryResult<GetSourcesQuery, GetSourcesQueryVariables>;
export const SavePostDocument = gql`
    mutation SavePost($postId: String!) {
  savePost(postId: $postId)
}
    `;
export type SavePostMutationFn = Apollo.MutationFunction<SavePostMutation, SavePostMutationVariables>;

/**
 * __useSavePostMutation__
 *
 * To run a mutation, you first call `useSavePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePostMutation, { data, loading, error }] = useSavePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useSavePostMutation(baseOptions?: Apollo.MutationHookOptions<SavePostMutation, SavePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePostMutation, SavePostMutationVariables>(SavePostDocument, options);
      }
export type SavePostMutationHookResult = ReturnType<typeof useSavePostMutation>;
export type SavePostMutationResult = Apollo.MutationResult<SavePostMutation>;
export type SavePostMutationOptions = Apollo.BaseMutationOptions<SavePostMutation, SavePostMutationVariables>;
export const UnsavePostDocument = gql`
    mutation UnsavePost($postId: String!) {
  unsavePost(postId: $postId)
}
    `;
export type UnsavePostMutationFn = Apollo.MutationFunction<UnsavePostMutation, UnsavePostMutationVariables>;

/**
 * __useUnsavePostMutation__
 *
 * To run a mutation, you first call `useUnsavePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsavePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsavePostMutation, { data, loading, error }] = useUnsavePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useUnsavePostMutation(baseOptions?: Apollo.MutationHookOptions<UnsavePostMutation, UnsavePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsavePostMutation, UnsavePostMutationVariables>(UnsavePostDocument, options);
      }
export type UnsavePostMutationHookResult = ReturnType<typeof useUnsavePostMutation>;
export type UnsavePostMutationResult = Apollo.MutationResult<UnsavePostMutation>;
export type UnsavePostMutationOptions = Apollo.BaseMutationOptions<UnsavePostMutation, UnsavePostMutationVariables>;
export const GetSavedPostsDocument = gql`
    query GetSavedPosts($page: Int = 1, $limit: Int = 10) {
  getSavedPosts(page: $page, limit: $limit) {
    posts {
      id
      isRepost
      repostComment
      originalPostId
      postType
      companyId
      contentTokens {
        type
        value
        handle
        userId
        url
      }
      translatedContentTokens {
        type
        value
        handle
        userId
        url
      }
      mediaUrls
      createdAt
      updatedAt
      isPublished
      reactions {
        reactionCounts {
          type
          count
        }
        totalReactions
        currentUserReaction
      }
      article {
        id
        title
        subtitle
        coverImageUrl
        slug
        readingTimeMinutes
        tags
        content
        status
        translatedTitle
        translatedSubtitle
        translatedExcerpt
      }
      companyAuthor {
        id
        name
        logoUrl
        industry
        tagline
        followersCount
        isFollowing
      }
      poll {
        question
        expiresAt
        options {
          id
          text
          votes
          isChosen
        }
        translatedQuestion
        translatedOptions
      }
      occasion {
        id
        postId
        title
        description
        imageUrl
        privacy
        translatedTitle
        translatedDescription
      }
      event {
        id
        name
        description
        imageUrl
        startTime
        endTime
        location
        category
        maxAttendees
        participantsCount
        isjoinedbyMe
        organizedby {
          userId
          name
          imageUrl
          companyName
        }
        course {
          id
          title
          thumbnailUrl
        }
      }
      case {
        id
        postId
        createdAt
        updatedAt
        media {
          id
          step
          type
          imageUrl
          text
          order
          createdAt
          translatedText
        }
      }
      author {
        id
        firstName
        lastName
        title
        middleName
        profileImageUrl
        role
        headline
        isHiring
        openToWork
        isMentorVerified
        connection {
          status
          direction
        }
        actionButtons {
          id
          name
          url
          isShow
          createdAt
        }
        influenceBadge {
          ...InfluenceBadgeFields
        }
        companyName
      }
      originalPost {
        id
        contentTokens {
          type
          value
          handle
          userId
          url
        }
        translatedContentTokens {
          type
          value
          handle
          userId
          url
        }
        mediaUrls
        createdAt
        updatedAt
        isPublished
        reactions {
          reactionCounts {
            type
            count
          }
          totalReactions
          currentUserReaction
        }
        article {
          id
          title
          subtitle
          coverImageUrl
          slug
          readingTimeMinutes
          tags
          content
          status
          translatedTitle
          translatedSubtitle
          translatedExcerpt
        }
        companyAuthor {
          id
          name
          logoUrl
          industry
          tagline
          followersCount
          isFollowing
        }
        poll {
          question
          expiresAt
          options {
            id
            text
            votes
            isChosen
          }
          translatedQuestion
          translatedOptions
        }
        occasion {
          id
          postId
          title
          description
          imageUrl
          privacy
          translatedTitle
          translatedDescription
        }
        event {
          id
          name
          description
          imageUrl
          startTime
          endTime
          location
          category
          maxAttendees
          participantsCount
          isjoinedbyMe
          organizedby {
            userId
            name
            imageUrl
            companyName
          }
          course {
            id
            title
            thumbnailUrl
          }
        }
        case {
          id
          postId
          createdAt
          updatedAt
          media {
            id
            step
            type
            imageUrl
            text
            order
            createdAt
            translatedText
          }
        }
        commentsCount
        isSavedByMe
        isRepost
        originalPostId
        repostComment
        isRepostedByMe
        author {
          id
          firstName
          lastName
          title
          middleName
          profileImageUrl
          role
          headline
          isHiring
          openToWork
          isMentorVerified
          connection {
            status
            direction
          }
          actionButtons {
            id
            name
            url
            isShow
            createdAt
          }
          influenceBadge {
            ...InfluenceBadgeFields
          }
          companyName
        }
      }
    }
    total
    hasMore
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetSavedPostsQuery__
 *
 * To run a query within a React component, call `useGetSavedPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedPostsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSavedPostsQuery(baseOptions?: Apollo.QueryHookOptions<GetSavedPostsQuery, GetSavedPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavedPostsQuery, GetSavedPostsQueryVariables>(GetSavedPostsDocument, options);
      }
export function useGetSavedPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavedPostsQuery, GetSavedPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavedPostsQuery, GetSavedPostsQueryVariables>(GetSavedPostsDocument, options);
        }
// @ts-ignore
export function useGetSavedPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSavedPostsQuery, GetSavedPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSavedPostsQuery, GetSavedPostsQueryVariables>;
export function useGetSavedPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavedPostsQuery, GetSavedPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSavedPostsQuery | undefined, GetSavedPostsQueryVariables>;
export function useGetSavedPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavedPostsQuery, GetSavedPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSavedPostsQuery, GetSavedPostsQueryVariables>(GetSavedPostsDocument, options);
        }
export type GetSavedPostsQueryHookResult = ReturnType<typeof useGetSavedPostsQuery>;
export type GetSavedPostsLazyQueryHookResult = ReturnType<typeof useGetSavedPostsLazyQuery>;
export type GetSavedPostsSuspenseQueryHookResult = ReturnType<typeof useGetSavedPostsSuspenseQuery>;
export type GetSavedPostsQueryResult = Apollo.QueryResult<GetSavedPostsQuery, GetSavedPostsQueryVariables>;
export const SaveRssFeedDocument = gql`
    mutation SaveRssFeed($input: SaveRssPostsInput!) {
  saveRssFeed(input: $input)
}
    `;
export type SaveRssFeedMutationFn = Apollo.MutationFunction<SaveRssFeedMutation, SaveRssFeedMutationVariables>;

/**
 * __useSaveRssFeedMutation__
 *
 * To run a mutation, you first call `useSaveRssFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveRssFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveRssFeedMutation, { data, loading, error }] = useSaveRssFeedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveRssFeedMutation(baseOptions?: Apollo.MutationHookOptions<SaveRssFeedMutation, SaveRssFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveRssFeedMutation, SaveRssFeedMutationVariables>(SaveRssFeedDocument, options);
      }
export type SaveRssFeedMutationHookResult = ReturnType<typeof useSaveRssFeedMutation>;
export type SaveRssFeedMutationResult = Apollo.MutationResult<SaveRssFeedMutation>;
export type SaveRssFeedMutationOptions = Apollo.BaseMutationOptions<SaveRssFeedMutation, SaveRssFeedMutationVariables>;
export const SearchCompaniesDocument = gql`
    query SearchCompanies($input: SearchCompaniesInput!) {
  searchCompanies(input: $input) {
    id
    name
    slug
    logoUrl
    tagline
    industry
    type
    hashtags
    followersCount
    city
    country
    isFollowing
  }
}
    `;

/**
 * __useSearchCompaniesQuery__
 *
 * To run a query within a React component, call `useSearchCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCompaniesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchCompaniesQuery(baseOptions: Apollo.QueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables> & ({ variables: SearchCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCompaniesQuery, SearchCompaniesQueryVariables>(SearchCompaniesDocument, options);
      }
export function useSearchCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCompaniesQuery, SearchCompaniesQueryVariables>(SearchCompaniesDocument, options);
        }
// @ts-ignore
export function useSearchCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<SearchCompaniesQuery, SearchCompaniesQueryVariables>;
export function useSearchCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<SearchCompaniesQuery | undefined, SearchCompaniesQueryVariables>;
export function useSearchCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCompaniesQuery, SearchCompaniesQueryVariables>(SearchCompaniesDocument, options);
        }
export type SearchCompaniesQueryHookResult = ReturnType<typeof useSearchCompaniesQuery>;
export type SearchCompaniesLazyQueryHookResult = ReturnType<typeof useSearchCompaniesLazyQuery>;
export type SearchCompaniesSuspenseQueryHookResult = ReturnType<typeof useSearchCompaniesSuspenseQuery>;
export type SearchCompaniesQueryResult = Apollo.QueryResult<SearchCompaniesQuery, SearchCompaniesQueryVariables>;
export const SearchMentorsDocument = gql`
    query SearchMentors($input: SearchMentorsInput!) {
  searchMentors(input: $input) {
    id
    firstName
    lastName
    title
    profileImageUrl
    role
    about
    totalConsultations
    totalConnections
    isBoosted
    boostEndsAt
    influenceBadge {
      ...InfluenceBadgeFields
    }
    companyName
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useSearchMentorsQuery__
 *
 * To run a query within a React component, call `useSearchMentorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMentorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMentorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchMentorsQuery(baseOptions: Apollo.QueryHookOptions<SearchMentorsQuery, SearchMentorsQueryVariables> & ({ variables: SearchMentorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchMentorsQuery, SearchMentorsQueryVariables>(SearchMentorsDocument, options);
      }
export function useSearchMentorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchMentorsQuery, SearchMentorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchMentorsQuery, SearchMentorsQueryVariables>(SearchMentorsDocument, options);
        }
// @ts-ignore
export function useSearchMentorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchMentorsQuery, SearchMentorsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchMentorsQuery, SearchMentorsQueryVariables>;
export function useSearchMentorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchMentorsQuery, SearchMentorsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchMentorsQuery | undefined, SearchMentorsQueryVariables>;
export function useSearchMentorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchMentorsQuery, SearchMentorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchMentorsQuery, SearchMentorsQueryVariables>(SearchMentorsDocument, options);
        }
export type SearchMentorsQueryHookResult = ReturnType<typeof useSearchMentorsQuery>;
export type SearchMentorsLazyQueryHookResult = ReturnType<typeof useSearchMentorsLazyQuery>;
export type SearchMentorsSuspenseQueryHookResult = ReturnType<typeof useSearchMentorsSuspenseQuery>;
export type SearchMentorsQueryResult = Apollo.QueryResult<SearchMentorsQuery, SearchMentorsQueryVariables>;
export const SearchPreviewDocument = gql`
    query SearchPreview($query: String!) {
  searchPreview(query: $query) {
    users {
      id
      name
      title
      profileImageUrl
      role
      about
      headline
      totalConnections
      companyName
      state
      country
      city
      isHiring
      openToWork
      influenceBadge {
        ...InfluenceBadgeFields
      }
    }
    posts {
      id
      isRepost
      repostComment
      originalPostId
      contentTokens {
        type
        value
        handle
        userId
        url
      }
      translatedContentTokens {
        type
        value
        handle
        userId
        url
      }
      author {
        id
        firstName
        lastName
        title
        middleName
        profileImageUrl
        openToWork
        isHiring
        role
        createdAt
        updatedAt
        influenceBadge {
          ...InfluenceBadgeFields
        }
        companyName
      }
      companyAuthor {
        id
        name
        logoUrl
        industry
        tagline
        followersCount
        isFollowing
      }
      originalPost {
        id
        contentTokens {
          type
          value
          handle
          userId
          url
        }
        translatedContentTokens {
          type
          value
          handle
          userId
          url
        }
        author {
          id
          firstName
          lastName
          title
          middleName
          profileImageUrl
          openToWork
          isHiring
          role
          createdAt
          updatedAt
          influenceBadge {
            ...InfluenceBadgeFields
          }
          companyName
        }
        mediaUrls
        reactions {
          reactionCounts {
            type
            count
          }
          totalReactions
          currentUserReaction
        }
        commentsCount
        isSavedByMe
        isRepostedByMe
        isPublished
        isBoosted
        activeBoostId
        createdAt
        updatedAt
      }
      mediaUrls
      reactions {
        reactionCounts {
          type
          count
        }
        totalReactions
        currentUserReaction
      }
      commentsCount
      isSavedByMe
      isRepostedByMe
      isPublished
      isBoosted
      activeBoostId
      createdAt
      updatedAt
    }
    groups {
      id
      name
      description
      profileImage
      coverImage
      privacy
      membersCount
      postsCount
      tags
      categories
      location
      owner {
        id
        name
        profileImageUrl
        role
        about
        totalConnections
        headline
        companyName
        state
        country
        city
        influenceBadge {
          ...InfluenceBadgeFields
        }
      }
      isJoined
      membershipStatus
      createdAt
      lastActivityAt
    }
    companies {
      id
      name
      slug
      logoUrl
      tagline
      industry
      type
      hashtags
      followersCount
      city
      country
      isFollowing
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useSearchPreviewQuery__
 *
 * To run a query within a React component, call `useSearchPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPreviewQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchPreviewQuery(baseOptions: Apollo.QueryHookOptions<SearchPreviewQuery, SearchPreviewQueryVariables> & ({ variables: SearchPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPreviewQuery, SearchPreviewQueryVariables>(SearchPreviewDocument, options);
      }
export function useSearchPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPreviewQuery, SearchPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPreviewQuery, SearchPreviewQueryVariables>(SearchPreviewDocument, options);
        }
// @ts-ignore
export function useSearchPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchPreviewQuery, SearchPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<SearchPreviewQuery, SearchPreviewQueryVariables>;
export function useSearchPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchPreviewQuery, SearchPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<SearchPreviewQuery | undefined, SearchPreviewQueryVariables>;
export function useSearchPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchPreviewQuery, SearchPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchPreviewQuery, SearchPreviewQueryVariables>(SearchPreviewDocument, options);
        }
export type SearchPreviewQueryHookResult = ReturnType<typeof useSearchPreviewQuery>;
export type SearchPreviewLazyQueryHookResult = ReturnType<typeof useSearchPreviewLazyQuery>;
export type SearchPreviewSuspenseQueryHookResult = ReturnType<typeof useSearchPreviewSuspenseQuery>;
export type SearchPreviewQueryResult = Apollo.QueryResult<SearchPreviewQuery, SearchPreviewQueryVariables>;
export const SearchUserOrPostDocument = gql`
    query SearchUserOrPost($input: SearchUserOrPostInput!) {
  searchUserOrPost(input: $input) {
    users {
      id
      name
      title
      profileImageUrl
      role
      about
      headline
      totalConnections
      companyName
      state
      country
      city
      isHiring
      openToWork
      isBoosted
      boostEndsAt
      influenceBadge {
        ...InfluenceBadgeFields
      }
    }
    posts {
      id
      isRepost
      repostComment
      originalPostId
      contentTokens {
        type
        value
        handle
        userId
        url
      }
      translatedContentTokens {
        type
        value
        handle
        userId
        url
      }
      author {
        id
        firstName
        lastName
        title
        middleName
        profileImageUrl
        role
        createdAt
        updatedAt
        influenceBadge {
          ...InfluenceBadgeFields
        }
        companyName
      }
      companyAuthor {
        id
        name
        logoUrl
        industry
        tagline
        followersCount
        isFollowing
      }
      originalPost {
        id
        contentTokens {
          type
          value
          handle
          userId
          url
        }
        translatedContentTokens {
          type
          value
          handle
          userId
          url
        }
        author {
          id
          firstName
          lastName
          title
          middleName
          profileImageUrl
          role
          createdAt
          updatedAt
          influenceBadge {
            ...InfluenceBadgeFields
          }
          companyName
        }
        mediaUrls
        reactions {
          reactionCounts {
            type
            count
          }
          totalReactions
          currentUserReaction
        }
        commentsCount
        isSavedByMe
        isRepostedByMe
        isPublished
        isBoosted
        activeBoostId
        createdAt
        updatedAt
      }
      mediaUrls
      reactions {
        reactionCounts {
          type
          count
        }
        totalReactions
        currentUserReaction
      }
      commentsCount
      isSavedByMe
      isRepostedByMe
      isPublished
      isBoosted
      activeBoostId
      createdAt
      updatedAt
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useSearchUserOrPostQuery__
 *
 * To run a query within a React component, call `useSearchUserOrPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserOrPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserOrPostQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchUserOrPostQuery(baseOptions: Apollo.QueryHookOptions<SearchUserOrPostQuery, SearchUserOrPostQueryVariables> & ({ variables: SearchUserOrPostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUserOrPostQuery, SearchUserOrPostQueryVariables>(SearchUserOrPostDocument, options);
      }
export function useSearchUserOrPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUserOrPostQuery, SearchUserOrPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUserOrPostQuery, SearchUserOrPostQueryVariables>(SearchUserOrPostDocument, options);
        }
// @ts-ignore
export function useSearchUserOrPostSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchUserOrPostQuery, SearchUserOrPostQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUserOrPostQuery, SearchUserOrPostQueryVariables>;
export function useSearchUserOrPostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUserOrPostQuery, SearchUserOrPostQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUserOrPostQuery | undefined, SearchUserOrPostQueryVariables>;
export function useSearchUserOrPostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUserOrPostQuery, SearchUserOrPostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUserOrPostQuery, SearchUserOrPostQueryVariables>(SearchUserOrPostDocument, options);
        }
export type SearchUserOrPostQueryHookResult = ReturnType<typeof useSearchUserOrPostQuery>;
export type SearchUserOrPostLazyQueryHookResult = ReturnType<typeof useSearchUserOrPostLazyQuery>;
export type SearchUserOrPostSuspenseQueryHookResult = ReturnType<typeof useSearchUserOrPostSuspenseQuery>;
export type SearchUserOrPostQueryResult = Apollo.QueryResult<SearchUserOrPostQuery, SearchUserOrPostQueryVariables>;
export const SearchUsersDocument = gql`
    query SearchUsers($input: SearchUsersInput!) {
  searchUsers(input: $input) {
    id
    firstName
    lastName
    title
    middleName
    suffix
    profileImageUrl
    influenceBadge {
      ...InfluenceBadgeFields
    }
    companyName
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchUsersQuery(baseOptions: Apollo.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables> & ({ variables: SearchUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
// @ts-ignore
export function useSearchUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export function useSearchUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUsersQuery | undefined, SearchUsersQueryVariables>;
export function useSearchUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersSuspenseQueryHookResult = ReturnType<typeof useSearchUsersSuspenseQuery>;
export type SearchUsersQueryResult = Apollo.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export const UpdateRssFiltersDocument = gql`
    mutation UpdateRssFilters($filters: [String!]!) {
  updateRssFilters(filters: $filters)
}
    `;
export type UpdateRssFiltersMutationFn = Apollo.MutationFunction<UpdateRssFiltersMutation, UpdateRssFiltersMutationVariables>;

/**
 * __useUpdateRssFiltersMutation__
 *
 * To run a mutation, you first call `useUpdateRssFiltersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRssFiltersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRssFiltersMutation, { data, loading, error }] = useUpdateRssFiltersMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useUpdateRssFiltersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRssFiltersMutation, UpdateRssFiltersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRssFiltersMutation, UpdateRssFiltersMutationVariables>(UpdateRssFiltersDocument, options);
      }
export type UpdateRssFiltersMutationHookResult = ReturnType<typeof useUpdateRssFiltersMutation>;
export type UpdateRssFiltersMutationResult = Apollo.MutationResult<UpdateRssFiltersMutation>;
export type UpdateRssFiltersMutationOptions = Apollo.BaseMutationOptions<UpdateRssFiltersMutation, UpdateRssFiltersMutationVariables>;
export const GetRssFiltersDocument = gql`
    query GetRssFilters {
  getRssFilters
}
    `;

/**
 * __useGetRssFiltersQuery__
 *
 * To run a query within a React component, call `useGetRssFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRssFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRssFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRssFiltersQuery(baseOptions?: Apollo.QueryHookOptions<GetRssFiltersQuery, GetRssFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRssFiltersQuery, GetRssFiltersQueryVariables>(GetRssFiltersDocument, options);
      }
export function useGetRssFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRssFiltersQuery, GetRssFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRssFiltersQuery, GetRssFiltersQueryVariables>(GetRssFiltersDocument, options);
        }
// @ts-ignore
export function useGetRssFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRssFiltersQuery, GetRssFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GetRssFiltersQuery, GetRssFiltersQueryVariables>;
export function useGetRssFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRssFiltersQuery, GetRssFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GetRssFiltersQuery | undefined, GetRssFiltersQueryVariables>;
export function useGetRssFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRssFiltersQuery, GetRssFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRssFiltersQuery, GetRssFiltersQueryVariables>(GetRssFiltersDocument, options);
        }
export type GetRssFiltersQueryHookResult = ReturnType<typeof useGetRssFiltersQuery>;
export type GetRssFiltersLazyQueryHookResult = ReturnType<typeof useGetRssFiltersLazyQuery>;
export type GetRssFiltersSuspenseQueryHookResult = ReturnType<typeof useGetRssFiltersSuspenseQuery>;
export type GetRssFiltersQueryResult = Apollo.QueryResult<GetRssFiltersQuery, GetRssFiltersQueryVariables>;
export const CreateServiceDocument = gql`
    mutation CreateService($input: CreateServiceInput!) {
  createService(createServiceInput: $input) {
    id
    title
    category
    type
    fee
    serviceStatus
    priceType
    description
    images
    optimizedImages
    userId
    createdAt
    updatedAt
    user {
      id
      firstName
      lastName
      title
      role
      profileImageUrl
      companyName
    }
  }
}
    `;
export type CreateServiceMutationFn = Apollo.MutationFunction<CreateServiceMutation, CreateServiceMutationVariables>;

/**
 * __useCreateServiceMutation__
 *
 * To run a mutation, you first call `useCreateServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceMutation, { data, loading, error }] = useCreateServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceMutation, CreateServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceMutation, CreateServiceMutationVariables>(CreateServiceDocument, options);
      }
export type CreateServiceMutationHookResult = ReturnType<typeof useCreateServiceMutation>;
export type CreateServiceMutationResult = Apollo.MutationResult<CreateServiceMutation>;
export type CreateServiceMutationOptions = Apollo.BaseMutationOptions<CreateServiceMutation, CreateServiceMutationVariables>;
export const UpdateServiceDocument = gql`
    mutation UpdateService($input: UpdateServiceInput!) {
  updateService(updateServiceInput: $input) {
    id
    title
    category
    type
    fee
    serviceStatus
    priceType
    description
    images
    optimizedImages
    userId
    createdAt
    updatedAt
    user {
      id
      email
      firstName
      lastName
      title
      profileImageUrl
      companyName
    }
  }
}
    `;
export type UpdateServiceMutationFn = Apollo.MutationFunction<UpdateServiceMutation, UpdateServiceMutationVariables>;

/**
 * __useUpdateServiceMutation__
 *
 * To run a mutation, you first call `useUpdateServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceMutation, { data, loading, error }] = useUpdateServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceMutation, UpdateServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceMutation, UpdateServiceMutationVariables>(UpdateServiceDocument, options);
      }
export type UpdateServiceMutationHookResult = ReturnType<typeof useUpdateServiceMutation>;
export type UpdateServiceMutationResult = Apollo.MutationResult<UpdateServiceMutation>;
export type UpdateServiceMutationOptions = Apollo.BaseMutationOptions<UpdateServiceMutation, UpdateServiceMutationVariables>;
export const RemoveServiceDocument = gql`
    mutation RemoveService($id: ID!) {
  removeService(id: $id) {
    id
    title
    description
  }
}
    `;
export type RemoveServiceMutationFn = Apollo.MutationFunction<RemoveServiceMutation, RemoveServiceMutationVariables>;

/**
 * __useRemoveServiceMutation__
 *
 * To run a mutation, you first call `useRemoveServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeServiceMutation, { data, loading, error }] = useRemoveServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveServiceMutation(baseOptions?: Apollo.MutationHookOptions<RemoveServiceMutation, RemoveServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveServiceMutation, RemoveServiceMutationVariables>(RemoveServiceDocument, options);
      }
export type RemoveServiceMutationHookResult = ReturnType<typeof useRemoveServiceMutation>;
export type RemoveServiceMutationResult = Apollo.MutationResult<RemoveServiceMutation>;
export type RemoveServiceMutationOptions = Apollo.BaseMutationOptions<RemoveServiceMutation, RemoveServiceMutationVariables>;
export const ServiceDetailDocument = gql`
    query ServiceDetail($id: ID!) {
  service(id: $id) {
    id
    title
    category
    type
    fee
    currency
    address
    langitude
    latitude
    serviceStatus
    priceType
    description
    images
    optimizedImages
    createdAt
    updatedAt
    user {
      id
      firstName
      lastName
      title
      profileImageUrl
      bannerImageUrl
      createdAt
      role
      influenceBadge {
        ...InfluenceBadgeFields
      }
      companyName
    }
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useServiceDetailQuery__
 *
 * To run a query within a React component, call `useServiceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useServiceDetailQuery(baseOptions: Apollo.QueryHookOptions<ServiceDetailQuery, ServiceDetailQueryVariables> & ({ variables: ServiceDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceDetailQuery, ServiceDetailQueryVariables>(ServiceDetailDocument, options);
      }
export function useServiceDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceDetailQuery, ServiceDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceDetailQuery, ServiceDetailQueryVariables>(ServiceDetailDocument, options);
        }
// @ts-ignore
export function useServiceDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceDetailQuery, ServiceDetailQueryVariables>): Apollo.UseSuspenseQueryResult<ServiceDetailQuery, ServiceDetailQueryVariables>;
export function useServiceDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ServiceDetailQuery, ServiceDetailQueryVariables>): Apollo.UseSuspenseQueryResult<ServiceDetailQuery | undefined, ServiceDetailQueryVariables>;
export function useServiceDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ServiceDetailQuery, ServiceDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceDetailQuery, ServiceDetailQueryVariables>(ServiceDetailDocument, options);
        }
export type ServiceDetailQueryHookResult = ReturnType<typeof useServiceDetailQuery>;
export type ServiceDetailLazyQueryHookResult = ReturnType<typeof useServiceDetailLazyQuery>;
export type ServiceDetailSuspenseQueryHookResult = ReturnType<typeof useServiceDetailSuspenseQuery>;
export type ServiceDetailQueryResult = Apollo.QueryResult<ServiceDetailQuery, ServiceDetailQueryVariables>;
export const MyServicesDocument = gql`
    query MyServices($page: Int, $limit: Int) {
  myServices(page: $page, limit: $limit) {
    data {
      id
      title
      category
      type
      fee
      currency
      address
      langitude
      latitude
      serviceStatus
      priceType
      description
      images
      optimizedImages
      hasCoupon
      user {
        id
        firstName
        lastName
        title
        profileImageUrl
        role
        companyName
      }
    }
    total
    page
    limit
    totalActiveServices
    totalPendingServices
    totalPages
    hasMore
  }
}
    `;

/**
 * __useMyServicesQuery__
 *
 * To run a query within a React component, call `useMyServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyServicesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMyServicesQuery(baseOptions?: Apollo.QueryHookOptions<MyServicesQuery, MyServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyServicesQuery, MyServicesQueryVariables>(MyServicesDocument, options);
      }
export function useMyServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyServicesQuery, MyServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyServicesQuery, MyServicesQueryVariables>(MyServicesDocument, options);
        }
// @ts-ignore
export function useMyServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyServicesQuery, MyServicesQueryVariables>): Apollo.UseSuspenseQueryResult<MyServicesQuery, MyServicesQueryVariables>;
export function useMyServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyServicesQuery, MyServicesQueryVariables>): Apollo.UseSuspenseQueryResult<MyServicesQuery | undefined, MyServicesQueryVariables>;
export function useMyServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyServicesQuery, MyServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyServicesQuery, MyServicesQueryVariables>(MyServicesDocument, options);
        }
export type MyServicesQueryHookResult = ReturnType<typeof useMyServicesQuery>;
export type MyServicesLazyQueryHookResult = ReturnType<typeof useMyServicesLazyQuery>;
export type MyServicesSuspenseQueryHookResult = ReturnType<typeof useMyServicesSuspenseQuery>;
export type MyServicesQueryResult = Apollo.QueryResult<MyServicesQuery, MyServicesQueryVariables>;
export const AllServicesDocument = gql`
    query AllServices($page: Int, $limit: Int, $search: String, $category: String, $sortBy: String, $minPrice: Int, $maxPrice: Int, $city: String, $state: String, $type: ServiceType) {
  allServices(
    page: $page
    limit: $limit
    search: $search
    category: $category
    sortBy: $sortBy
    minPrice: $minPrice
    maxPrice: $maxPrice
    city: $city
    state: $state
    type: $type
  ) {
    data {
      id
      libraryItemId
      title
      category
      type
      fee
      currency
      address
      langitude
      latitude
      serviceStatus
      priceType
      description
      images
      optimizedImages
      createdAt
      user {
        id
        firstName
        lastName
        title
        profileImageUrl
        role
        companyName
      }
    }
    total
    page
    limit
    totalPages
    hasMore
  }
}
    `;

/**
 * __useAllServicesQuery__
 *
 * To run a query within a React component, call `useAllServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllServicesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      category: // value for 'category'
 *      sortBy: // value for 'sortBy'
 *      minPrice: // value for 'minPrice'
 *      maxPrice: // value for 'maxPrice'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAllServicesQuery(baseOptions?: Apollo.QueryHookOptions<AllServicesQuery, AllServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllServicesQuery, AllServicesQueryVariables>(AllServicesDocument, options);
      }
export function useAllServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllServicesQuery, AllServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllServicesQuery, AllServicesQueryVariables>(AllServicesDocument, options);
        }
// @ts-ignore
export function useAllServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllServicesQuery, AllServicesQueryVariables>): Apollo.UseSuspenseQueryResult<AllServicesQuery, AllServicesQueryVariables>;
export function useAllServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllServicesQuery, AllServicesQueryVariables>): Apollo.UseSuspenseQueryResult<AllServicesQuery | undefined, AllServicesQueryVariables>;
export function useAllServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllServicesQuery, AllServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllServicesQuery, AllServicesQueryVariables>(AllServicesDocument, options);
        }
export type AllServicesQueryHookResult = ReturnType<typeof useAllServicesQuery>;
export type AllServicesLazyQueryHookResult = ReturnType<typeof useAllServicesLazyQuery>;
export type AllServicesSuspenseQueryHookResult = ReturnType<typeof useAllServicesSuspenseQuery>;
export type AllServicesQueryResult = Apollo.QueryResult<AllServicesQuery, AllServicesQueryVariables>;
export const SimilarServicesDocument = gql`
    query SimilarServices($id: String!) {
  similarServices(id: $id) {
    id
    title
    category
    type
    fee
    currency
    address
    langitude
    latitude
    serviceStatus
    priceType
    description
    images
    optimizedImages
    createdAt
    user {
      id
      firstName
      lastName
      title
      profileImageUrl
      role
      companyName
    }
  }
}
    `;

/**
 * __useSimilarServicesQuery__
 *
 * To run a query within a React component, call `useSimilarServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimilarServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimilarServicesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSimilarServicesQuery(baseOptions: Apollo.QueryHookOptions<SimilarServicesQuery, SimilarServicesQueryVariables> & ({ variables: SimilarServicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimilarServicesQuery, SimilarServicesQueryVariables>(SimilarServicesDocument, options);
      }
export function useSimilarServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimilarServicesQuery, SimilarServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimilarServicesQuery, SimilarServicesQueryVariables>(SimilarServicesDocument, options);
        }
// @ts-ignore
export function useSimilarServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SimilarServicesQuery, SimilarServicesQueryVariables>): Apollo.UseSuspenseQueryResult<SimilarServicesQuery, SimilarServicesQueryVariables>;
export function useSimilarServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimilarServicesQuery, SimilarServicesQueryVariables>): Apollo.UseSuspenseQueryResult<SimilarServicesQuery | undefined, SimilarServicesQueryVariables>;
export function useSimilarServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimilarServicesQuery, SimilarServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SimilarServicesQuery, SimilarServicesQueryVariables>(SimilarServicesDocument, options);
        }
export type SimilarServicesQueryHookResult = ReturnType<typeof useSimilarServicesQuery>;
export type SimilarServicesLazyQueryHookResult = ReturnType<typeof useSimilarServicesLazyQuery>;
export type SimilarServicesSuspenseQueryHookResult = ReturnType<typeof useSimilarServicesSuspenseQuery>;
export type SimilarServicesQueryResult = Apollo.QueryResult<SimilarServicesQuery, SimilarServicesQueryVariables>;
export const ReportServiceDocument = gql`
    mutation ReportService($createServiceReportInput: CreateServiceReportInput!) {
  reportService(createServiceReportInput: $createServiceReportInput)
}
    `;
export type ReportServiceMutationFn = Apollo.MutationFunction<ReportServiceMutation, ReportServiceMutationVariables>;

/**
 * __useReportServiceMutation__
 *
 * To run a mutation, you first call `useReportServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportServiceMutation, { data, loading, error }] = useReportServiceMutation({
 *   variables: {
 *      createServiceReportInput: // value for 'createServiceReportInput'
 *   },
 * });
 */
export function useReportServiceMutation(baseOptions?: Apollo.MutationHookOptions<ReportServiceMutation, ReportServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportServiceMutation, ReportServiceMutationVariables>(ReportServiceDocument, options);
      }
export type ReportServiceMutationHookResult = ReturnType<typeof useReportServiceMutation>;
export type ReportServiceMutationResult = Apollo.MutationResult<ReportServiceMutation>;
export type ReportServiceMutationOptions = Apollo.BaseMutationOptions<ReportServiceMutation, ReportServiceMutationVariables>;
export const CheckCouponAvailabilityDocument = gql`
    query checkCouponAvailability($serviceId: ID!) {
  checkCouponAvailability(checkCouponAvailabilityInput: {serviceId: $serviceId}) {
    isAvailable
    status
    couponCode
    title
    discountPrice
    redeemedCoupons
    totalCoupons
    message
    isReportedByMe
    isRedeemedByMe
  }
}
    `;

/**
 * __useCheckCouponAvailabilityQuery__
 *
 * To run a query within a React component, call `useCheckCouponAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCouponAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCouponAvailabilityQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useCheckCouponAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<CheckCouponAvailabilityQuery, CheckCouponAvailabilityQueryVariables> & ({ variables: CheckCouponAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckCouponAvailabilityQuery, CheckCouponAvailabilityQueryVariables>(CheckCouponAvailabilityDocument, options);
      }
export function useCheckCouponAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckCouponAvailabilityQuery, CheckCouponAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckCouponAvailabilityQuery, CheckCouponAvailabilityQueryVariables>(CheckCouponAvailabilityDocument, options);
        }
// @ts-ignore
export function useCheckCouponAvailabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckCouponAvailabilityQuery, CheckCouponAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<CheckCouponAvailabilityQuery, CheckCouponAvailabilityQueryVariables>;
export function useCheckCouponAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckCouponAvailabilityQuery, CheckCouponAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<CheckCouponAvailabilityQuery | undefined, CheckCouponAvailabilityQueryVariables>;
export function useCheckCouponAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckCouponAvailabilityQuery, CheckCouponAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckCouponAvailabilityQuery, CheckCouponAvailabilityQueryVariables>(CheckCouponAvailabilityDocument, options);
        }
export type CheckCouponAvailabilityQueryHookResult = ReturnType<typeof useCheckCouponAvailabilityQuery>;
export type CheckCouponAvailabilityLazyQueryHookResult = ReturnType<typeof useCheckCouponAvailabilityLazyQuery>;
export type CheckCouponAvailabilitySuspenseQueryHookResult = ReturnType<typeof useCheckCouponAvailabilitySuspenseQuery>;
export type CheckCouponAvailabilityQueryResult = Apollo.QueryResult<CheckCouponAvailabilityQuery, CheckCouponAvailabilityQueryVariables>;
export const RedeemCouponDocument = gql`
    mutation redeemCoupon($serviceId: ID!, $couponCode: String!) {
  redeemCoupon(
    redeemCouponInput: {serviceId: $serviceId, couponCode: $couponCode}
  ) {
    success
    message
    discountPrice
  }
}
    `;
export type RedeemCouponMutationFn = Apollo.MutationFunction<RedeemCouponMutation, RedeemCouponMutationVariables>;

/**
 * __useRedeemCouponMutation__
 *
 * To run a mutation, you first call `useRedeemCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemCouponMutation, { data, loading, error }] = useRedeemCouponMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useRedeemCouponMutation(baseOptions?: Apollo.MutationHookOptions<RedeemCouponMutation, RedeemCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemCouponMutation, RedeemCouponMutationVariables>(RedeemCouponDocument, options);
      }
export type RedeemCouponMutationHookResult = ReturnType<typeof useRedeemCouponMutation>;
export type RedeemCouponMutationResult = Apollo.MutationResult<RedeemCouponMutation>;
export type RedeemCouponMutationOptions = Apollo.BaseMutationOptions<RedeemCouponMutation, RedeemCouponMutationVariables>;
export const PublicServicesDocument = gql`
    query PublicServices($page: Int, $limit: Int, $search: String) {
  publicServices(page: $page, limit: $limit, search: $search) {
    data {
      id
      image
      title
      description
      createAT
      location
      category
      postedBy {
        name
        avatar
        companyName
      }
    }
    total
    page
    limit
    totalPages
    hasMore
  }
}
    `;

/**
 * __usePublicServicesQuery__
 *
 * To run a query within a React component, call `usePublicServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicServicesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function usePublicServicesQuery(baseOptions?: Apollo.QueryHookOptions<PublicServicesQuery, PublicServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicServicesQuery, PublicServicesQueryVariables>(PublicServicesDocument, options);
      }
export function usePublicServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicServicesQuery, PublicServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicServicesQuery, PublicServicesQueryVariables>(PublicServicesDocument, options);
        }
// @ts-ignore
export function usePublicServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublicServicesQuery, PublicServicesQueryVariables>): Apollo.UseSuspenseQueryResult<PublicServicesQuery, PublicServicesQueryVariables>;
export function usePublicServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicServicesQuery, PublicServicesQueryVariables>): Apollo.UseSuspenseQueryResult<PublicServicesQuery | undefined, PublicServicesQueryVariables>;
export function usePublicServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicServicesQuery, PublicServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicServicesQuery, PublicServicesQueryVariables>(PublicServicesDocument, options);
        }
export type PublicServicesQueryHookResult = ReturnType<typeof usePublicServicesQuery>;
export type PublicServicesLazyQueryHookResult = ReturnType<typeof usePublicServicesLazyQuery>;
export type PublicServicesSuspenseQueryHookResult = ReturnType<typeof usePublicServicesSuspenseQuery>;
export type PublicServicesQueryResult = Apollo.QueryResult<PublicServicesQuery, PublicServicesQueryVariables>;
export const ChangeMyServiceStatusDocument = gql`
    mutation ChangeMyServiceStatus($id: ID!, $status: ServiceStatus!) {
  changeMyServiceStatus(id: $id, status: $status) {
    id
    title
    category
    type
    fee
    currency
    address
    langitude
    latitude
    serviceStatus
    priceType
    description
    images
    optimizedImages
    createdAt
    updatedAt
    user {
      id
      firstName
      lastName
      title
      profileImageUrl
      bannerImageUrl
      createdAt
      role
      companyName
    }
  }
}
    `;
export type ChangeMyServiceStatusMutationFn = Apollo.MutationFunction<ChangeMyServiceStatusMutation, ChangeMyServiceStatusMutationVariables>;

/**
 * __useChangeMyServiceStatusMutation__
 *
 * To run a mutation, you first call `useChangeMyServiceStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeMyServiceStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeMyServiceStatusMutation, { data, loading, error }] = useChangeMyServiceStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangeMyServiceStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeMyServiceStatusMutation, ChangeMyServiceStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeMyServiceStatusMutation, ChangeMyServiceStatusMutationVariables>(ChangeMyServiceStatusDocument, options);
      }
export type ChangeMyServiceStatusMutationHookResult = ReturnType<typeof useChangeMyServiceStatusMutation>;
export type ChangeMyServiceStatusMutationResult = Apollo.MutationResult<ChangeMyServiceStatusMutation>;
export type ChangeMyServiceStatusMutationOptions = Apollo.BaseMutationOptions<ChangeMyServiceStatusMutation, ChangeMyServiceStatusMutationVariables>;
export const CouponDetailWithUsersDocument = gql`
    query CouponDetailWithUsers($serviceId: String!) {
  couponDetailWithUsers(serviceId: $serviceId) {
    id
    couponCode
    title
    discountPrice
    status
    startDate
    endDate
    redeemedCoupons
    totalCoupons
    users {
      id
      firstName
      lastName
      title
      profileImageUrl
      email
      role
      companyName
    }
  }
}
    `;

/**
 * __useCouponDetailWithUsersQuery__
 *
 * To run a query within a React component, call `useCouponDetailWithUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouponDetailWithUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouponDetailWithUsersQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useCouponDetailWithUsersQuery(baseOptions: Apollo.QueryHookOptions<CouponDetailWithUsersQuery, CouponDetailWithUsersQueryVariables> & ({ variables: CouponDetailWithUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CouponDetailWithUsersQuery, CouponDetailWithUsersQueryVariables>(CouponDetailWithUsersDocument, options);
      }
export function useCouponDetailWithUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CouponDetailWithUsersQuery, CouponDetailWithUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CouponDetailWithUsersQuery, CouponDetailWithUsersQueryVariables>(CouponDetailWithUsersDocument, options);
        }
// @ts-ignore
export function useCouponDetailWithUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CouponDetailWithUsersQuery, CouponDetailWithUsersQueryVariables>): Apollo.UseSuspenseQueryResult<CouponDetailWithUsersQuery, CouponDetailWithUsersQueryVariables>;
export function useCouponDetailWithUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CouponDetailWithUsersQuery, CouponDetailWithUsersQueryVariables>): Apollo.UseSuspenseQueryResult<CouponDetailWithUsersQuery | undefined, CouponDetailWithUsersQueryVariables>;
export function useCouponDetailWithUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CouponDetailWithUsersQuery, CouponDetailWithUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CouponDetailWithUsersQuery, CouponDetailWithUsersQueryVariables>(CouponDetailWithUsersDocument, options);
        }
export type CouponDetailWithUsersQueryHookResult = ReturnType<typeof useCouponDetailWithUsersQuery>;
export type CouponDetailWithUsersLazyQueryHookResult = ReturnType<typeof useCouponDetailWithUsersLazyQuery>;
export type CouponDetailWithUsersSuspenseQueryHookResult = ReturnType<typeof useCouponDetailWithUsersSuspenseQuery>;
export type CouponDetailWithUsersQueryResult = Apollo.QueryResult<CouponDetailWithUsersQuery, CouponDetailWithUsersQueryVariables>;
export const SignUpDocument = gql`
    mutation SignUp($input: SignUpInput!) {
  signUp(input: $input) {
    success
    checkoutUrl
    accessToken
    refreshToken
  }
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const CheckSignupAvailabilityDocument = gql`
    query CheckSignupAvailability($input: CheckSignupAvailabilityInput!) {
  checkSignupAvailability(input: $input) {
    emailTaken
    dentalLicenseNumberTaken
    universityEmailTaken
  }
}
    `;

/**
 * __useCheckSignupAvailabilityQuery__
 *
 * To run a query within a React component, call `useCheckSignupAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSignupAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSignupAvailabilityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckSignupAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<CheckSignupAvailabilityQuery, CheckSignupAvailabilityQueryVariables> & ({ variables: CheckSignupAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckSignupAvailabilityQuery, CheckSignupAvailabilityQueryVariables>(CheckSignupAvailabilityDocument, options);
      }
export function useCheckSignupAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckSignupAvailabilityQuery, CheckSignupAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckSignupAvailabilityQuery, CheckSignupAvailabilityQueryVariables>(CheckSignupAvailabilityDocument, options);
        }
// @ts-ignore
export function useCheckSignupAvailabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckSignupAvailabilityQuery, CheckSignupAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<CheckSignupAvailabilityQuery, CheckSignupAvailabilityQueryVariables>;
export function useCheckSignupAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckSignupAvailabilityQuery, CheckSignupAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<CheckSignupAvailabilityQuery | undefined, CheckSignupAvailabilityQueryVariables>;
export function useCheckSignupAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckSignupAvailabilityQuery, CheckSignupAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckSignupAvailabilityQuery, CheckSignupAvailabilityQueryVariables>(CheckSignupAvailabilityDocument, options);
        }
export type CheckSignupAvailabilityQueryHookResult = ReturnType<typeof useCheckSignupAvailabilityQuery>;
export type CheckSignupAvailabilityLazyQueryHookResult = ReturnType<typeof useCheckSignupAvailabilityLazyQuery>;
export type CheckSignupAvailabilitySuspenseQueryHookResult = ReturnType<typeof useCheckSignupAvailabilitySuspenseQuery>;
export type CheckSignupAvailabilityQueryResult = Apollo.QueryResult<CheckSignupAvailabilityQuery, CheckSignupAvailabilityQueryVariables>;
export const AddSkillsToUserDocument = gql`
    mutation AddSkillsToUser($input: AddSkillsInput!) {
  addSkillsToUser(input: $input)
}
    `;
export type AddSkillsToUserMutationFn = Apollo.MutationFunction<AddSkillsToUserMutation, AddSkillsToUserMutationVariables>;

/**
 * __useAddSkillsToUserMutation__
 *
 * To run a mutation, you first call `useAddSkillsToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSkillsToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSkillsToUserMutation, { data, loading, error }] = useAddSkillsToUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSkillsToUserMutation(baseOptions?: Apollo.MutationHookOptions<AddSkillsToUserMutation, AddSkillsToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSkillsToUserMutation, AddSkillsToUserMutationVariables>(AddSkillsToUserDocument, options);
      }
export type AddSkillsToUserMutationHookResult = ReturnType<typeof useAddSkillsToUserMutation>;
export type AddSkillsToUserMutationResult = Apollo.MutationResult<AddSkillsToUserMutation>;
export type AddSkillsToUserMutationOptions = Apollo.BaseMutationOptions<AddSkillsToUserMutation, AddSkillsToUserMutationVariables>;
export const DeleteSkillFromUserDocument = gql`
    mutation DeleteSkillFromUser($input: DeleteSkillInput!) {
  deleteSkillFromUser(input: $input)
}
    `;
export type DeleteSkillFromUserMutationFn = Apollo.MutationFunction<DeleteSkillFromUserMutation, DeleteSkillFromUserMutationVariables>;

/**
 * __useDeleteSkillFromUserMutation__
 *
 * To run a mutation, you first call `useDeleteSkillFromUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSkillFromUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSkillFromUserMutation, { data, loading, error }] = useDeleteSkillFromUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSkillFromUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSkillFromUserMutation, DeleteSkillFromUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSkillFromUserMutation, DeleteSkillFromUserMutationVariables>(DeleteSkillFromUserDocument, options);
      }
export type DeleteSkillFromUserMutationHookResult = ReturnType<typeof useDeleteSkillFromUserMutation>;
export type DeleteSkillFromUserMutationResult = Apollo.MutationResult<DeleteSkillFromUserMutation>;
export type DeleteSkillFromUserMutationOptions = Apollo.BaseMutationOptions<DeleteSkillFromUserMutation, DeleteSkillFromUserMutationVariables>;
export const CreateStoryDocument = gql`
    mutation CreateStory($input: CreateStoryInput!) {
  createStory(input: $input) {
    ...StoryFields
  }
}
    ${StoryFieldsFragmentDoc}`;
export type CreateStoryMutationFn = Apollo.MutationFunction<CreateStoryMutation, CreateStoryMutationVariables>;

/**
 * __useCreateStoryMutation__
 *
 * To run a mutation, you first call `useCreateStoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStoryMutation, { data, loading, error }] = useCreateStoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateStoryMutation, CreateStoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStoryMutation, CreateStoryMutationVariables>(CreateStoryDocument, options);
      }
export type CreateStoryMutationHookResult = ReturnType<typeof useCreateStoryMutation>;
export type CreateStoryMutationResult = Apollo.MutationResult<CreateStoryMutation>;
export type CreateStoryMutationOptions = Apollo.BaseMutationOptions<CreateStoryMutation, CreateStoryMutationVariables>;
export const GetConnectedUsersStoriesDocument = gql`
    query GetConnectedUsersStories {
  getConnectedUsersStories {
    ...StoryFields
  }
}
    ${StoryFieldsFragmentDoc}`;

/**
 * __useGetConnectedUsersStoriesQuery__
 *
 * To run a query within a React component, call `useGetConnectedUsersStoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectedUsersStoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectedUsersStoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConnectedUsersStoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetConnectedUsersStoriesQuery, GetConnectedUsersStoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectedUsersStoriesQuery, GetConnectedUsersStoriesQueryVariables>(GetConnectedUsersStoriesDocument, options);
      }
export function useGetConnectedUsersStoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectedUsersStoriesQuery, GetConnectedUsersStoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectedUsersStoriesQuery, GetConnectedUsersStoriesQueryVariables>(GetConnectedUsersStoriesDocument, options);
        }
// @ts-ignore
export function useGetConnectedUsersStoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConnectedUsersStoriesQuery, GetConnectedUsersStoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetConnectedUsersStoriesQuery, GetConnectedUsersStoriesQueryVariables>;
export function useGetConnectedUsersStoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConnectedUsersStoriesQuery, GetConnectedUsersStoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetConnectedUsersStoriesQuery | undefined, GetConnectedUsersStoriesQueryVariables>;
export function useGetConnectedUsersStoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConnectedUsersStoriesQuery, GetConnectedUsersStoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConnectedUsersStoriesQuery, GetConnectedUsersStoriesQueryVariables>(GetConnectedUsersStoriesDocument, options);
        }
export type GetConnectedUsersStoriesQueryHookResult = ReturnType<typeof useGetConnectedUsersStoriesQuery>;
export type GetConnectedUsersStoriesLazyQueryHookResult = ReturnType<typeof useGetConnectedUsersStoriesLazyQuery>;
export type GetConnectedUsersStoriesSuspenseQueryHookResult = ReturnType<typeof useGetConnectedUsersStoriesSuspenseQuery>;
export type GetConnectedUsersStoriesQueryResult = Apollo.QueryResult<GetConnectedUsersStoriesQuery, GetConnectedUsersStoriesQueryVariables>;
export const OnStoryChangedDocument = gql`
    subscription OnStoryChanged {
  storyChanged {
    type
    storyId
    userId
    story {
      ...StoryFields
    }
  }
}
    ${StoryFieldsFragmentDoc}`;

/**
 * __useOnStoryChangedSubscription__
 *
 * To run a query within a React component, call `useOnStoryChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnStoryChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnStoryChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnStoryChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnStoryChangedSubscription, OnStoryChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnStoryChangedSubscription, OnStoryChangedSubscriptionVariables>(OnStoryChangedDocument, options);
      }
export type OnStoryChangedSubscriptionHookResult = ReturnType<typeof useOnStoryChangedSubscription>;
export type OnStoryChangedSubscriptionResult = Apollo.SubscriptionResult<OnStoryChangedSubscription>;
export const DeleteStoryDocument = gql`
    mutation DeleteStory($input: DeleteContentInput!) {
  deleteStory(input: $input)
}
    `;
export type DeleteStoryMutationFn = Apollo.MutationFunction<DeleteStoryMutation, DeleteStoryMutationVariables>;

/**
 * __useDeleteStoryMutation__
 *
 * To run a mutation, you first call `useDeleteStoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStoryMutation, { data, loading, error }] = useDeleteStoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteStoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStoryMutation, DeleteStoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStoryMutation, DeleteStoryMutationVariables>(DeleteStoryDocument, options);
      }
export type DeleteStoryMutationHookResult = ReturnType<typeof useDeleteStoryMutation>;
export type DeleteStoryMutationResult = Apollo.MutationResult<DeleteStoryMutation>;
export type DeleteStoryMutationOptions = Apollo.BaseMutationOptions<DeleteStoryMutation, DeleteStoryMutationVariables>;
export const MarkStoryViewedDocument = gql`
    mutation MarkStoryViewed($input: MarkStoryViewedInput!) {
  markStoryViewed(input: $input)
}
    `;
export type MarkStoryViewedMutationFn = Apollo.MutationFunction<MarkStoryViewedMutation, MarkStoryViewedMutationVariables>;

/**
 * __useMarkStoryViewedMutation__
 *
 * To run a mutation, you first call `useMarkStoryViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkStoryViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markStoryViewedMutation, { data, loading, error }] = useMarkStoryViewedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkStoryViewedMutation(baseOptions?: Apollo.MutationHookOptions<MarkStoryViewedMutation, MarkStoryViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkStoryViewedMutation, MarkStoryViewedMutationVariables>(MarkStoryViewedDocument, options);
      }
export type MarkStoryViewedMutationHookResult = ReturnType<typeof useMarkStoryViewedMutation>;
export type MarkStoryViewedMutationResult = Apollo.MutationResult<MarkStoryViewedMutation>;
export type MarkStoryViewedMutationOptions = Apollo.BaseMutationOptions<MarkStoryViewedMutation, MarkStoryViewedMutationVariables>;
export const GetUserStoriesDocument = gql`
    query GetUserStories($userId: ID!) {
  getUserStories(userId: $userId) {
    id
    userId
    user {
      id
      firstName
      lastName
      title
      profileImageUrl
      companyName
    }
    content {
      id
      content
      type
      caption
      duration
      order
      createdAt
    }
    isSeen
    createdAt
    expiresAt
    viewCount
  }
}
    `;

/**
 * __useGetUserStoriesQuery__
 *
 * To run a query within a React component, call `useGetUserStoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserStoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserStoriesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserStoriesQuery(baseOptions: Apollo.QueryHookOptions<GetUserStoriesQuery, GetUserStoriesQueryVariables> & ({ variables: GetUserStoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserStoriesQuery, GetUserStoriesQueryVariables>(GetUserStoriesDocument, options);
      }
export function useGetUserStoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserStoriesQuery, GetUserStoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserStoriesQuery, GetUserStoriesQueryVariables>(GetUserStoriesDocument, options);
        }
// @ts-ignore
export function useGetUserStoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserStoriesQuery, GetUserStoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserStoriesQuery, GetUserStoriesQueryVariables>;
export function useGetUserStoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserStoriesQuery, GetUserStoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserStoriesQuery | undefined, GetUserStoriesQueryVariables>;
export function useGetUserStoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserStoriesQuery, GetUserStoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserStoriesQuery, GetUserStoriesQueryVariables>(GetUserStoriesDocument, options);
        }
export type GetUserStoriesQueryHookResult = ReturnType<typeof useGetUserStoriesQuery>;
export type GetUserStoriesLazyQueryHookResult = ReturnType<typeof useGetUserStoriesLazyQuery>;
export type GetUserStoriesSuspenseQueryHookResult = ReturnType<typeof useGetUserStoriesSuspenseQuery>;
export type GetUserStoriesQueryResult = Apollo.QueryResult<GetUserStoriesQuery, GetUserStoriesQueryVariables>;
export const GetStoryViewersDocument = gql`
    query GetStoryViewers($storyId: String!, $page: Int, $limit: Int) {
  getStoryViewers(storyId: $storyId, page: $page, limit: $limit) {
    id
    viewedAt
    totalViews
    viewer {
      id
      firstName
      lastName
      title
      profileImageUrl
      companyName
    }
  }
}
    `;

/**
 * __useGetStoryViewersQuery__
 *
 * To run a query within a React component, call `useGetStoryViewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoryViewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoryViewersQuery({
 *   variables: {
 *      storyId: // value for 'storyId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetStoryViewersQuery(baseOptions: Apollo.QueryHookOptions<GetStoryViewersQuery, GetStoryViewersQueryVariables> & ({ variables: GetStoryViewersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoryViewersQuery, GetStoryViewersQueryVariables>(GetStoryViewersDocument, options);
      }
export function useGetStoryViewersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoryViewersQuery, GetStoryViewersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoryViewersQuery, GetStoryViewersQueryVariables>(GetStoryViewersDocument, options);
        }
// @ts-ignore
export function useGetStoryViewersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStoryViewersQuery, GetStoryViewersQueryVariables>): Apollo.UseSuspenseQueryResult<GetStoryViewersQuery, GetStoryViewersQueryVariables>;
export function useGetStoryViewersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStoryViewersQuery, GetStoryViewersQueryVariables>): Apollo.UseSuspenseQueryResult<GetStoryViewersQuery | undefined, GetStoryViewersQueryVariables>;
export function useGetStoryViewersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStoryViewersQuery, GetStoryViewersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoryViewersQuery, GetStoryViewersQueryVariables>(GetStoryViewersDocument, options);
        }
export type GetStoryViewersQueryHookResult = ReturnType<typeof useGetStoryViewersQuery>;
export type GetStoryViewersLazyQueryHookResult = ReturnType<typeof useGetStoryViewersLazyQuery>;
export type GetStoryViewersSuspenseQueryHookResult = ReturnType<typeof useGetStoryViewersSuspenseQuery>;
export type GetStoryViewersQueryResult = Apollo.QueryResult<GetStoryViewersQuery, GetStoryViewersQueryVariables>;
export const ToggleStoryReactionDocument = gql`
    mutation ToggleStoryReaction($input: ToggleStoryLikeInput!) {
  toggleStoryReaction(input: $input) {
    id
    action
    reactionType
    message
  }
}
    `;
export type ToggleStoryReactionMutationFn = Apollo.MutationFunction<ToggleStoryReactionMutation, ToggleStoryReactionMutationVariables>;

/**
 * __useToggleStoryReactionMutation__
 *
 * To run a mutation, you first call `useToggleStoryReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleStoryReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleStoryReactionMutation, { data, loading, error }] = useToggleStoryReactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleStoryReactionMutation(baseOptions?: Apollo.MutationHookOptions<ToggleStoryReactionMutation, ToggleStoryReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleStoryReactionMutation, ToggleStoryReactionMutationVariables>(ToggleStoryReactionDocument, options);
      }
export type ToggleStoryReactionMutationHookResult = ReturnType<typeof useToggleStoryReactionMutation>;
export type ToggleStoryReactionMutationResult = Apollo.MutationResult<ToggleStoryReactionMutation>;
export type ToggleStoryReactionMutationOptions = Apollo.BaseMutationOptions<ToggleStoryReactionMutation, ToggleStoryReactionMutationVariables>;
export const GetStoryReactorsDocument = gql`
    query GetStoryReactors($input: GetStoryReactorsInput!) {
  getStoryReactors(input: $input) {
    id
    reactionType
    userId
    firstName
    lastName
    title
    profileImageUrl
    role
    totalReactions
    companyName
  }
}
    `;

/**
 * __useGetStoryReactorsQuery__
 *
 * To run a query within a React component, call `useGetStoryReactorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoryReactorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoryReactorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStoryReactorsQuery(baseOptions: Apollo.QueryHookOptions<GetStoryReactorsQuery, GetStoryReactorsQueryVariables> & ({ variables: GetStoryReactorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoryReactorsQuery, GetStoryReactorsQueryVariables>(GetStoryReactorsDocument, options);
      }
export function useGetStoryReactorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoryReactorsQuery, GetStoryReactorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoryReactorsQuery, GetStoryReactorsQueryVariables>(GetStoryReactorsDocument, options);
        }
// @ts-ignore
export function useGetStoryReactorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStoryReactorsQuery, GetStoryReactorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStoryReactorsQuery, GetStoryReactorsQueryVariables>;
export function useGetStoryReactorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStoryReactorsQuery, GetStoryReactorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStoryReactorsQuery | undefined, GetStoryReactorsQueryVariables>;
export function useGetStoryReactorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStoryReactorsQuery, GetStoryReactorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoryReactorsQuery, GetStoryReactorsQueryVariables>(GetStoryReactorsDocument, options);
        }
export type GetStoryReactorsQueryHookResult = ReturnType<typeof useGetStoryReactorsQuery>;
export type GetStoryReactorsLazyQueryHookResult = ReturnType<typeof useGetStoryReactorsLazyQuery>;
export type GetStoryReactorsSuspenseQueryHookResult = ReturnType<typeof useGetStoryReactorsSuspenseQuery>;
export type GetStoryReactorsQueryResult = Apollo.QueryResult<GetStoryReactorsQuery, GetStoryReactorsQueryVariables>;
export const MyInvoicesDocument = gql`
    query MyInvoices {
  myInvoices {
    id
    invoiceNumber
    stripeInvoiceId
    providerInvoiceId
    status
    amountPaid
    amountDue
    currency
    invoiceUrl
    invoicePdf
    periodStart
    periodEnd
    periodLabel
    periodDays
    previousPlanAmount
    previousPlanUnusedCredit
    newPlanPrice
    finalAmountPaid
    paidAt
    planName
    invoiceType
    createdAt
  }
}
    `;

/**
 * __useMyInvoicesQuery__
 *
 * To run a query within a React component, call `useMyInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyInvoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<MyInvoicesQuery, MyInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyInvoicesQuery, MyInvoicesQueryVariables>(MyInvoicesDocument, options);
      }
export function useMyInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyInvoicesQuery, MyInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyInvoicesQuery, MyInvoicesQueryVariables>(MyInvoicesDocument, options);
        }
// @ts-ignore
export function useMyInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyInvoicesQuery, MyInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<MyInvoicesQuery, MyInvoicesQueryVariables>;
export function useMyInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyInvoicesQuery, MyInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<MyInvoicesQuery | undefined, MyInvoicesQueryVariables>;
export function useMyInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyInvoicesQuery, MyInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyInvoicesQuery, MyInvoicesQueryVariables>(MyInvoicesDocument, options);
        }
export type MyInvoicesQueryHookResult = ReturnType<typeof useMyInvoicesQuery>;
export type MyInvoicesLazyQueryHookResult = ReturnType<typeof useMyInvoicesLazyQuery>;
export type MyInvoicesSuspenseQueryHookResult = ReturnType<typeof useMyInvoicesSuspenseQuery>;
export type MyInvoicesQueryResult = Apollo.QueryResult<MyInvoicesQuery, MyInvoicesQueryVariables>;
export const ActivePlansDocument = gql`
    query ActivePlans {
  activePlans {
    id
    name
    stripePriceId
    stripeProductId
    priceMonthly
    description
    status
    companyPages
    connectionSendingLimits
    serviceListings
    groupCreation
    actionButtonOnProfile
    liveStreaming
    accessAIChatbot
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useActivePlansQuery__
 *
 * To run a query within a React component, call `useActivePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivePlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivePlansQuery(baseOptions?: Apollo.QueryHookOptions<ActivePlansQuery, ActivePlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivePlansQuery, ActivePlansQueryVariables>(ActivePlansDocument, options);
      }
export function useActivePlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivePlansQuery, ActivePlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivePlansQuery, ActivePlansQueryVariables>(ActivePlansDocument, options);
        }
// @ts-ignore
export function useActivePlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActivePlansQuery, ActivePlansQueryVariables>): Apollo.UseSuspenseQueryResult<ActivePlansQuery, ActivePlansQueryVariables>;
export function useActivePlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivePlansQuery, ActivePlansQueryVariables>): Apollo.UseSuspenseQueryResult<ActivePlansQuery | undefined, ActivePlansQueryVariables>;
export function useActivePlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivePlansQuery, ActivePlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivePlansQuery, ActivePlansQueryVariables>(ActivePlansDocument, options);
        }
export type ActivePlansQueryHookResult = ReturnType<typeof useActivePlansQuery>;
export type ActivePlansLazyQueryHookResult = ReturnType<typeof useActivePlansLazyQuery>;
export type ActivePlansSuspenseQueryHookResult = ReturnType<typeof useActivePlansSuspenseQuery>;
export type ActivePlansQueryResult = Apollo.QueryResult<ActivePlansQuery, ActivePlansQueryVariables>;
export const MySubscriptionDocument = gql`
    query MySubscription {
  mySubscription {
    id
    userId
    planId
    stripeCustomerId
    stripeSubscriptionId
    status
    currentPeriodStart
    currentPeriodEnd
    planLimitsPeriodStart
    cancelAtPeriodEnd
    pendingPlanId
    planSnapshot
    trialStartsAt
    trialEndsAt
    paymentFailedAt
    graceEndsAt
    accessState
    couponId
    stripeDiscountId
    stripePromotionCodeId
    createdAt
    updatedAt
    coupon {
      id
      code
      discountPercent
      type
      status
    }
    pendingCoupon {
      id
      code
      discountPercent
      type
      status
    }
    plan {
      id
      name
      stripePriceId
      stripeProductId
      priceMonthly
      description
      status
      companyPages
      connectionSendingLimits
      serviceListings
      groupCreation
      actionButtonOnProfile
      liveStreaming
      accessAIChatbot
      createdAt
      updatedAt
    }
    pendingPlan {
      id
      name
      priceMonthly
      description
    }
    invoices {
      id
      stripeInvoiceId
      status
      amountPaid
      amountDue
      currency
      invoiceUrl
      invoicePdf
      periodStart
      periodEnd
      paidAt
      paymentMethodBrand
      paymentMethodLast4
      billingReason
      createdAt
    }
  }
}
    `;

/**
 * __useMySubscriptionQuery__
 *
 * To run a query within a React component, call `useMySubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<MySubscriptionQuery, MySubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MySubscriptionQuery, MySubscriptionQueryVariables>(MySubscriptionDocument, options);
      }
export function useMySubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySubscriptionQuery, MySubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MySubscriptionQuery, MySubscriptionQueryVariables>(MySubscriptionDocument, options);
        }
// @ts-ignore
export function useMySubscriptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MySubscriptionQuery, MySubscriptionQueryVariables>): Apollo.UseSuspenseQueryResult<MySubscriptionQuery, MySubscriptionQueryVariables>;
export function useMySubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MySubscriptionQuery, MySubscriptionQueryVariables>): Apollo.UseSuspenseQueryResult<MySubscriptionQuery | undefined, MySubscriptionQueryVariables>;
export function useMySubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MySubscriptionQuery, MySubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MySubscriptionQuery, MySubscriptionQueryVariables>(MySubscriptionDocument, options);
        }
export type MySubscriptionQueryHookResult = ReturnType<typeof useMySubscriptionQuery>;
export type MySubscriptionLazyQueryHookResult = ReturnType<typeof useMySubscriptionLazyQuery>;
export type MySubscriptionSuspenseQueryHookResult = ReturnType<typeof useMySubscriptionSuspenseQuery>;
export type MySubscriptionQueryResult = Apollo.QueryResult<MySubscriptionQuery, MySubscriptionQueryVariables>;
export const ValidateSubscriptionCouponDocument = gql`
    query ValidateSubscriptionCoupon($couponCode: String!, $context: String) {
  validateSubscriptionCoupon(couponCode: $couponCode, context: $context) {
    valid
    message
    discountPercent
    type
  }
}
    `;

/**
 * __useValidateSubscriptionCouponQuery__
 *
 * To run a query within a React component, call `useValidateSubscriptionCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateSubscriptionCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateSubscriptionCouponQuery({
 *   variables: {
 *      couponCode: // value for 'couponCode'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useValidateSubscriptionCouponQuery(baseOptions: Apollo.QueryHookOptions<ValidateSubscriptionCouponQuery, ValidateSubscriptionCouponQueryVariables> & ({ variables: ValidateSubscriptionCouponQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateSubscriptionCouponQuery, ValidateSubscriptionCouponQueryVariables>(ValidateSubscriptionCouponDocument, options);
      }
export function useValidateSubscriptionCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateSubscriptionCouponQuery, ValidateSubscriptionCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateSubscriptionCouponQuery, ValidateSubscriptionCouponQueryVariables>(ValidateSubscriptionCouponDocument, options);
        }
// @ts-ignore
export function useValidateSubscriptionCouponSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateSubscriptionCouponQuery, ValidateSubscriptionCouponQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateSubscriptionCouponQuery, ValidateSubscriptionCouponQueryVariables>;
export function useValidateSubscriptionCouponSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateSubscriptionCouponQuery, ValidateSubscriptionCouponQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateSubscriptionCouponQuery | undefined, ValidateSubscriptionCouponQueryVariables>;
export function useValidateSubscriptionCouponSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateSubscriptionCouponQuery, ValidateSubscriptionCouponQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateSubscriptionCouponQuery, ValidateSubscriptionCouponQueryVariables>(ValidateSubscriptionCouponDocument, options);
        }
export type ValidateSubscriptionCouponQueryHookResult = ReturnType<typeof useValidateSubscriptionCouponQuery>;
export type ValidateSubscriptionCouponLazyQueryHookResult = ReturnType<typeof useValidateSubscriptionCouponLazyQuery>;
export type ValidateSubscriptionCouponSuspenseQueryHookResult = ReturnType<typeof useValidateSubscriptionCouponSuspenseQuery>;
export type ValidateSubscriptionCouponQueryResult = Apollo.QueryResult<ValidateSubscriptionCouponQuery, ValidateSubscriptionCouponQueryVariables>;
export const PreviewUpgradeCheckoutDocument = gql`
    query PreviewUpgradeCheckout($planId: ID!, $couponCode: String) {
  previewUpgradeCheckout(planId: $planId, couponCode: $couponCode) {
    amountDueCents
    discountCents
    amountDueAfterDiscountCents
    currency
    newPlanPriceMonthly
    currentPlanPriceMonthly
    discountPercent
    couponType
    couponCode
  }
}
    `;

/**
 * __usePreviewUpgradeCheckoutQuery__
 *
 * To run a query within a React component, call `usePreviewUpgradeCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewUpgradeCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewUpgradeCheckoutQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function usePreviewUpgradeCheckoutQuery(baseOptions: Apollo.QueryHookOptions<PreviewUpgradeCheckoutQuery, PreviewUpgradeCheckoutQueryVariables> & ({ variables: PreviewUpgradeCheckoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewUpgradeCheckoutQuery, PreviewUpgradeCheckoutQueryVariables>(PreviewUpgradeCheckoutDocument, options);
      }
export function usePreviewUpgradeCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewUpgradeCheckoutQuery, PreviewUpgradeCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewUpgradeCheckoutQuery, PreviewUpgradeCheckoutQueryVariables>(PreviewUpgradeCheckoutDocument, options);
        }
// @ts-ignore
export function usePreviewUpgradeCheckoutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreviewUpgradeCheckoutQuery, PreviewUpgradeCheckoutQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewUpgradeCheckoutQuery, PreviewUpgradeCheckoutQueryVariables>;
export function usePreviewUpgradeCheckoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewUpgradeCheckoutQuery, PreviewUpgradeCheckoutQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewUpgradeCheckoutQuery | undefined, PreviewUpgradeCheckoutQueryVariables>;
export function usePreviewUpgradeCheckoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewUpgradeCheckoutQuery, PreviewUpgradeCheckoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewUpgradeCheckoutQuery, PreviewUpgradeCheckoutQueryVariables>(PreviewUpgradeCheckoutDocument, options);
        }
export type PreviewUpgradeCheckoutQueryHookResult = ReturnType<typeof usePreviewUpgradeCheckoutQuery>;
export type PreviewUpgradeCheckoutLazyQueryHookResult = ReturnType<typeof usePreviewUpgradeCheckoutLazyQuery>;
export type PreviewUpgradeCheckoutSuspenseQueryHookResult = ReturnType<typeof usePreviewUpgradeCheckoutSuspenseQuery>;
export type PreviewUpgradeCheckoutQueryResult = Apollo.QueryResult<PreviewUpgradeCheckoutQuery, PreviewUpgradeCheckoutQueryVariables>;
export const CreateSubscriptionCheckoutDocument = gql`
    mutation CreateSubscriptionCheckout($planId: ID!, $couponCode: String) {
  createSubscriptionCheckout(planId: $planId, couponCode: $couponCode) {
    checkoutUrl
  }
}
    `;
export type CreateSubscriptionCheckoutMutationFn = Apollo.MutationFunction<CreateSubscriptionCheckoutMutation, CreateSubscriptionCheckoutMutationVariables>;

/**
 * __useCreateSubscriptionCheckoutMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionCheckoutMutation, { data, loading, error }] = useCreateSubscriptionCheckoutMutation({
 *   variables: {
 *      planId: // value for 'planId'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useCreateSubscriptionCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionCheckoutMutation, CreateSubscriptionCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionCheckoutMutation, CreateSubscriptionCheckoutMutationVariables>(CreateSubscriptionCheckoutDocument, options);
      }
export type CreateSubscriptionCheckoutMutationHookResult = ReturnType<typeof useCreateSubscriptionCheckoutMutation>;
export type CreateSubscriptionCheckoutMutationResult = Apollo.MutationResult<CreateSubscriptionCheckoutMutation>;
export type CreateSubscriptionCheckoutMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionCheckoutMutation, CreateSubscriptionCheckoutMutationVariables>;
export const CreateUpgradeCheckoutDocument = gql`
    mutation CreateUpgradeCheckout($planId: ID!, $couponCode: String) {
  createUpgradeCheckout(planId: $planId, couponCode: $couponCode) {
    checkoutUrl
  }
}
    `;
export type CreateUpgradeCheckoutMutationFn = Apollo.MutationFunction<CreateUpgradeCheckoutMutation, CreateUpgradeCheckoutMutationVariables>;

/**
 * __useCreateUpgradeCheckoutMutation__
 *
 * To run a mutation, you first call `useCreateUpgradeCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpgradeCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpgradeCheckoutMutation, { data, loading, error }] = useCreateUpgradeCheckoutMutation({
 *   variables: {
 *      planId: // value for 'planId'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useCreateUpgradeCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpgradeCheckoutMutation, CreateUpgradeCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpgradeCheckoutMutation, CreateUpgradeCheckoutMutationVariables>(CreateUpgradeCheckoutDocument, options);
      }
export type CreateUpgradeCheckoutMutationHookResult = ReturnType<typeof useCreateUpgradeCheckoutMutation>;
export type CreateUpgradeCheckoutMutationResult = Apollo.MutationResult<CreateUpgradeCheckoutMutation>;
export type CreateUpgradeCheckoutMutationOptions = Apollo.BaseMutationOptions<CreateUpgradeCheckoutMutation, CreateUpgradeCheckoutMutationVariables>;
export const RetryTrialSignupWithNewCardDocument = gql`
    mutation RetryTrialSignupWithNewCard($sessionId: String!) {
  retryTrialSignupWithNewCard(sessionId: $sessionId) {
    checkoutUrl
  }
}
    `;
export type RetryTrialSignupWithNewCardMutationFn = Apollo.MutationFunction<RetryTrialSignupWithNewCardMutation, RetryTrialSignupWithNewCardMutationVariables>;

/**
 * __useRetryTrialSignupWithNewCardMutation__
 *
 * To run a mutation, you first call `useRetryTrialSignupWithNewCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryTrialSignupWithNewCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryTrialSignupWithNewCardMutation, { data, loading, error }] = useRetryTrialSignupWithNewCardMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useRetryTrialSignupWithNewCardMutation(baseOptions?: Apollo.MutationHookOptions<RetryTrialSignupWithNewCardMutation, RetryTrialSignupWithNewCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryTrialSignupWithNewCardMutation, RetryTrialSignupWithNewCardMutationVariables>(RetryTrialSignupWithNewCardDocument, options);
      }
export type RetryTrialSignupWithNewCardMutationHookResult = ReturnType<typeof useRetryTrialSignupWithNewCardMutation>;
export type RetryTrialSignupWithNewCardMutationResult = Apollo.MutationResult<RetryTrialSignupWithNewCardMutation>;
export type RetryTrialSignupWithNewCardMutationOptions = Apollo.BaseMutationOptions<RetryTrialSignupWithNewCardMutation, RetryTrialSignupWithNewCardMutationVariables>;
export const ContinueSignupWithoutTrialDocument = gql`
    mutation ContinueSignupWithoutTrial($sessionId: String!) {
  continueSignupWithoutTrial(sessionId: $sessionId) {
    checkoutUrl
  }
}
    `;
export type ContinueSignupWithoutTrialMutationFn = Apollo.MutationFunction<ContinueSignupWithoutTrialMutation, ContinueSignupWithoutTrialMutationVariables>;

/**
 * __useContinueSignupWithoutTrialMutation__
 *
 * To run a mutation, you first call `useContinueSignupWithoutTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContinueSignupWithoutTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [continueSignupWithoutTrialMutation, { data, loading, error }] = useContinueSignupWithoutTrialMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useContinueSignupWithoutTrialMutation(baseOptions?: Apollo.MutationHookOptions<ContinueSignupWithoutTrialMutation, ContinueSignupWithoutTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContinueSignupWithoutTrialMutation, ContinueSignupWithoutTrialMutationVariables>(ContinueSignupWithoutTrialDocument, options);
      }
export type ContinueSignupWithoutTrialMutationHookResult = ReturnType<typeof useContinueSignupWithoutTrialMutation>;
export type ContinueSignupWithoutTrialMutationResult = Apollo.MutationResult<ContinueSignupWithoutTrialMutation>;
export type ContinueSignupWithoutTrialMutationOptions = Apollo.BaseMutationOptions<ContinueSignupWithoutTrialMutation, ContinueSignupWithoutTrialMutationVariables>;
export const VerifyCheckoutSessionDocument = gql`
    mutation VerifyCheckoutSession($sessionId: String!) {
  verifyCheckoutSession(sessionId: $sessionId) {
    id
    planId
    status
    currentPeriodStart
    currentPeriodEnd
    planLimitsPeriodStart
    cancelAtPeriodEnd
    planSnapshot
    coupon {
      id
      code
      discountPercent
      type
      status
    }
    plan {
      id
      name
      priceMonthly
      description
      companyPages
      connectionSendingLimits
      serviceListings
      groupCreation
      actionButtonOnProfile
      liveStreaming
      accessAIChatbot
    }
  }
}
    `;
export type VerifyCheckoutSessionMutationFn = Apollo.MutationFunction<VerifyCheckoutSessionMutation, VerifyCheckoutSessionMutationVariables>;

/**
 * __useVerifyCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useVerifyCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyCheckoutSessionMutation, { data, loading, error }] = useVerifyCheckoutSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useVerifyCheckoutSessionMutation(baseOptions?: Apollo.MutationHookOptions<VerifyCheckoutSessionMutation, VerifyCheckoutSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyCheckoutSessionMutation, VerifyCheckoutSessionMutationVariables>(VerifyCheckoutSessionDocument, options);
      }
export type VerifyCheckoutSessionMutationHookResult = ReturnType<typeof useVerifyCheckoutSessionMutation>;
export type VerifyCheckoutSessionMutationResult = Apollo.MutationResult<VerifyCheckoutSessionMutation>;
export type VerifyCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<VerifyCheckoutSessionMutation, VerifyCheckoutSessionMutationVariables>;
export const VerifyUpgradeCheckoutSessionDocument = gql`
    mutation VerifyUpgradeCheckoutSession($sessionId: String!) {
  verifyUpgradeCheckoutSession(sessionId: $sessionId) {
    id
    planId
    status
    currentPeriodStart
    currentPeriodEnd
    planLimitsPeriodStart
    cancelAtPeriodEnd
    planSnapshot
    coupon {
      id
      code
      discountPercent
      type
      status
    }
    plan {
      id
      name
      priceMonthly
      description
      companyPages
      connectionSendingLimits
      serviceListings
      groupCreation
      actionButtonOnProfile
      liveStreaming
      accessAIChatbot
    }
  }
}
    `;
export type VerifyUpgradeCheckoutSessionMutationFn = Apollo.MutationFunction<VerifyUpgradeCheckoutSessionMutation, VerifyUpgradeCheckoutSessionMutationVariables>;

/**
 * __useVerifyUpgradeCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useVerifyUpgradeCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyUpgradeCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyUpgradeCheckoutSessionMutation, { data, loading, error }] = useVerifyUpgradeCheckoutSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useVerifyUpgradeCheckoutSessionMutation(baseOptions?: Apollo.MutationHookOptions<VerifyUpgradeCheckoutSessionMutation, VerifyUpgradeCheckoutSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyUpgradeCheckoutSessionMutation, VerifyUpgradeCheckoutSessionMutationVariables>(VerifyUpgradeCheckoutSessionDocument, options);
      }
export type VerifyUpgradeCheckoutSessionMutationHookResult = ReturnType<typeof useVerifyUpgradeCheckoutSessionMutation>;
export type VerifyUpgradeCheckoutSessionMutationResult = Apollo.MutationResult<VerifyUpgradeCheckoutSessionMutation>;
export type VerifyUpgradeCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<VerifyUpgradeCheckoutSessionMutation, VerifyUpgradeCheckoutSessionMutationVariables>;
export const CancelMySubscriptionDocument = gql`
    mutation CancelMySubscription {
  cancelMySubscription
}
    `;
export type CancelMySubscriptionMutationFn = Apollo.MutationFunction<CancelMySubscriptionMutation, CancelMySubscriptionMutationVariables>;

/**
 * __useCancelMySubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelMySubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMySubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMySubscriptionMutation, { data, loading, error }] = useCancelMySubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelMySubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelMySubscriptionMutation, CancelMySubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelMySubscriptionMutation, CancelMySubscriptionMutationVariables>(CancelMySubscriptionDocument, options);
      }
export type CancelMySubscriptionMutationHookResult = ReturnType<typeof useCancelMySubscriptionMutation>;
export type CancelMySubscriptionMutationResult = Apollo.MutationResult<CancelMySubscriptionMutation>;
export type CancelMySubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelMySubscriptionMutation, CancelMySubscriptionMutationVariables>;
export const ChangeSubscriptionPlanDocument = gql`
    mutation ChangeSubscriptionPlan($planId: ID!, $couponCode: String) {
  changeSubscriptionPlan(planId: $planId, couponCode: $couponCode) {
    id
    planId
    status
    currentPeriodStart
    currentPeriodEnd
    planLimitsPeriodStart
    cancelAtPeriodEnd
    pendingPlanId
    planSnapshot
    coupon {
      id
      code
      discountPercent
      type
      status
    }
    pendingCoupon {
      id
      code
      discountPercent
      type
      status
    }
    plan {
      id
      name
      priceMonthly
      description
      companyPages
      connectionSendingLimits
      serviceListings
      groupCreation
      actionButtonOnProfile
      liveStreaming
      accessAIChatbot
    }
    pendingPlan {
      id
      name
      priceMonthly
    }
  }
}
    `;
export type ChangeSubscriptionPlanMutationFn = Apollo.MutationFunction<ChangeSubscriptionPlanMutation, ChangeSubscriptionPlanMutationVariables>;

/**
 * __useChangeSubscriptionPlanMutation__
 *
 * To run a mutation, you first call `useChangeSubscriptionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSubscriptionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSubscriptionPlanMutation, { data, loading, error }] = useChangeSubscriptionPlanMutation({
 *   variables: {
 *      planId: // value for 'planId'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useChangeSubscriptionPlanMutation(baseOptions?: Apollo.MutationHookOptions<ChangeSubscriptionPlanMutation, ChangeSubscriptionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeSubscriptionPlanMutation, ChangeSubscriptionPlanMutationVariables>(ChangeSubscriptionPlanDocument, options);
      }
export type ChangeSubscriptionPlanMutationHookResult = ReturnType<typeof useChangeSubscriptionPlanMutation>;
export type ChangeSubscriptionPlanMutationResult = Apollo.MutationResult<ChangeSubscriptionPlanMutation>;
export type ChangeSubscriptionPlanMutationOptions = Apollo.BaseMutationOptions<ChangeSubscriptionPlanMutation, ChangeSubscriptionPlanMutationVariables>;
export const ApplySubscriptionCouponDocument = gql`
    mutation ApplySubscriptionCoupon($couponCode: String!) {
  applySubscriptionCoupon(couponCode: $couponCode) {
    id
    couponId
    coupon {
      id
      code
      discountPercent
      type
      status
    }
    plan {
      id
      name
      priceMonthly
    }
  }
}
    `;
export type ApplySubscriptionCouponMutationFn = Apollo.MutationFunction<ApplySubscriptionCouponMutation, ApplySubscriptionCouponMutationVariables>;

/**
 * __useApplySubscriptionCouponMutation__
 *
 * To run a mutation, you first call `useApplySubscriptionCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplySubscriptionCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applySubscriptionCouponMutation, { data, loading, error }] = useApplySubscriptionCouponMutation({
 *   variables: {
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useApplySubscriptionCouponMutation(baseOptions?: Apollo.MutationHookOptions<ApplySubscriptionCouponMutation, ApplySubscriptionCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplySubscriptionCouponMutation, ApplySubscriptionCouponMutationVariables>(ApplySubscriptionCouponDocument, options);
      }
export type ApplySubscriptionCouponMutationHookResult = ReturnType<typeof useApplySubscriptionCouponMutation>;
export type ApplySubscriptionCouponMutationResult = Apollo.MutationResult<ApplySubscriptionCouponMutation>;
export type ApplySubscriptionCouponMutationOptions = Apollo.BaseMutationOptions<ApplySubscriptionCouponMutation, ApplySubscriptionCouponMutationVariables>;
export const ResumeMySubscriptionDocument = gql`
    mutation ResumeMySubscription {
  resumeMySubscription {
    id
    status
    cancelAtPeriodEnd
    currentPeriodEnd
    plan {
      id
      name
      priceMonthly
    }
  }
}
    `;
export type ResumeMySubscriptionMutationFn = Apollo.MutationFunction<ResumeMySubscriptionMutation, ResumeMySubscriptionMutationVariables>;

/**
 * __useResumeMySubscriptionMutation__
 *
 * To run a mutation, you first call `useResumeMySubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeMySubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeMySubscriptionMutation, { data, loading, error }] = useResumeMySubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useResumeMySubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ResumeMySubscriptionMutation, ResumeMySubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeMySubscriptionMutation, ResumeMySubscriptionMutationVariables>(ResumeMySubscriptionDocument, options);
      }
export type ResumeMySubscriptionMutationHookResult = ReturnType<typeof useResumeMySubscriptionMutation>;
export type ResumeMySubscriptionMutationResult = Apollo.MutationResult<ResumeMySubscriptionMutation>;
export type ResumeMySubscriptionMutationOptions = Apollo.BaseMutationOptions<ResumeMySubscriptionMutation, ResumeMySubscriptionMutationVariables>;
export const CancelPendingPlanChangeDocument = gql`
    mutation CancelPendingPlanChange {
  cancelPendingPlanChange {
    id
    pendingPlanId
    pendingPlan {
      id
      name
    }
  }
}
    `;
export type CancelPendingPlanChangeMutationFn = Apollo.MutationFunction<CancelPendingPlanChangeMutation, CancelPendingPlanChangeMutationVariables>;

/**
 * __useCancelPendingPlanChangeMutation__
 *
 * To run a mutation, you first call `useCancelPendingPlanChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPendingPlanChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPendingPlanChangeMutation, { data, loading, error }] = useCancelPendingPlanChangeMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelPendingPlanChangeMutation(baseOptions?: Apollo.MutationHookOptions<CancelPendingPlanChangeMutation, CancelPendingPlanChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPendingPlanChangeMutation, CancelPendingPlanChangeMutationVariables>(CancelPendingPlanChangeDocument, options);
      }
export type CancelPendingPlanChangeMutationHookResult = ReturnType<typeof useCancelPendingPlanChangeMutation>;
export type CancelPendingPlanChangeMutationResult = Apollo.MutationResult<CancelPendingPlanChangeMutation>;
export type CancelPendingPlanChangeMutationOptions = Apollo.BaseMutationOptions<CancelPendingPlanChangeMutation, CancelPendingPlanChangeMutationVariables>;
export const GenerateReceiptPdfDocument = gql`
    mutation GenerateReceiptPdf($invoiceId: ID!) {
  generateReceiptPdf(invoiceId: $invoiceId) {
    base64Pdf
    filename
  }
}
    `;
export type GenerateReceiptPdfMutationFn = Apollo.MutationFunction<GenerateReceiptPdfMutation, GenerateReceiptPdfMutationVariables>;

/**
 * __useGenerateReceiptPdfMutation__
 *
 * To run a mutation, you first call `useGenerateReceiptPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReceiptPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReceiptPdfMutation, { data, loading, error }] = useGenerateReceiptPdfMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGenerateReceiptPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateReceiptPdfMutation, GenerateReceiptPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateReceiptPdfMutation, GenerateReceiptPdfMutationVariables>(GenerateReceiptPdfDocument, options);
      }
export type GenerateReceiptPdfMutationHookResult = ReturnType<typeof useGenerateReceiptPdfMutation>;
export type GenerateReceiptPdfMutationResult = Apollo.MutationResult<GenerateReceiptPdfMutation>;
export type GenerateReceiptPdfMutationOptions = Apollo.BaseMutationOptions<GenerateReceiptPdfMutation, GenerateReceiptPdfMutationVariables>;
export const TrialConfigDocument = gql`
    query TrialConfig {
  trialConfig {
    enabled
    trialDays
  }
}
    `;

/**
 * __useTrialConfigQuery__
 *
 * To run a query within a React component, call `useTrialConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrialConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrialConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useTrialConfigQuery(baseOptions?: Apollo.QueryHookOptions<TrialConfigQuery, TrialConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrialConfigQuery, TrialConfigQueryVariables>(TrialConfigDocument, options);
      }
export function useTrialConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrialConfigQuery, TrialConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrialConfigQuery, TrialConfigQueryVariables>(TrialConfigDocument, options);
        }
// @ts-ignore
export function useTrialConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrialConfigQuery, TrialConfigQueryVariables>): Apollo.UseSuspenseQueryResult<TrialConfigQuery, TrialConfigQueryVariables>;
export function useTrialConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrialConfigQuery, TrialConfigQueryVariables>): Apollo.UseSuspenseQueryResult<TrialConfigQuery | undefined, TrialConfigQueryVariables>;
export function useTrialConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrialConfigQuery, TrialConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrialConfigQuery, TrialConfigQueryVariables>(TrialConfigDocument, options);
        }
export type TrialConfigQueryHookResult = ReturnType<typeof useTrialConfigQuery>;
export type TrialConfigLazyQueryHookResult = ReturnType<typeof useTrialConfigLazyQuery>;
export type TrialConfigSuspenseQueryHookResult = ReturnType<typeof useTrialConfigSuspenseQuery>;
export type TrialConfigQueryResult = Apollo.QueryResult<TrialConfigQuery, TrialConfigQueryVariables>;
export const CreateBillingPortalSessionDocument = gql`
    mutation CreateBillingPortalSession {
  createBillingPortalSession {
    url
  }
}
    `;
export type CreateBillingPortalSessionMutationFn = Apollo.MutationFunction<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>;

/**
 * __useCreateBillingPortalSessionMutation__
 *
 * To run a mutation, you first call `useCreateBillingPortalSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingPortalSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingPortalSessionMutation, { data, loading, error }] = useCreateBillingPortalSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateBillingPortalSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>(CreateBillingPortalSessionDocument, options);
      }
export type CreateBillingPortalSessionMutationHookResult = ReturnType<typeof useCreateBillingPortalSessionMutation>;
export type CreateBillingPortalSessionMutationResult = Apollo.MutationResult<CreateBillingPortalSessionMutation>;
export type CreateBillingPortalSessionMutationOptions = Apollo.BaseMutationOptions<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>;
export const PayMyOpenInvoiceDocument = gql`
    mutation PayMyOpenInvoice {
  payMyOpenInvoice
}
    `;
export type PayMyOpenInvoiceMutationFn = Apollo.MutationFunction<PayMyOpenInvoiceMutation, PayMyOpenInvoiceMutationVariables>;

/**
 * __usePayMyOpenInvoiceMutation__
 *
 * To run a mutation, you first call `usePayMyOpenInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayMyOpenInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payMyOpenInvoiceMutation, { data, loading, error }] = usePayMyOpenInvoiceMutation({
 *   variables: {
 *   },
 * });
 */
export function usePayMyOpenInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<PayMyOpenInvoiceMutation, PayMyOpenInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayMyOpenInvoiceMutation, PayMyOpenInvoiceMutationVariables>(PayMyOpenInvoiceDocument, options);
      }
export type PayMyOpenInvoiceMutationHookResult = ReturnType<typeof usePayMyOpenInvoiceMutation>;
export type PayMyOpenInvoiceMutationResult = Apollo.MutationResult<PayMyOpenInvoiceMutation>;
export type PayMyOpenInvoiceMutationOptions = Apollo.BaseMutationOptions<PayMyOpenInvoiceMutation, PayMyOpenInvoiceMutationVariables>;
export const MyOpenInvoicePaymentUrlDocument = gql`
    mutation MyOpenInvoicePaymentUrl {
  myOpenInvoicePaymentUrl {
    url
  }
}
    `;
export type MyOpenInvoicePaymentUrlMutationFn = Apollo.MutationFunction<MyOpenInvoicePaymentUrlMutation, MyOpenInvoicePaymentUrlMutationVariables>;

/**
 * __useMyOpenInvoicePaymentUrlMutation__
 *
 * To run a mutation, you first call `useMyOpenInvoicePaymentUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyOpenInvoicePaymentUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myOpenInvoicePaymentUrlMutation, { data, loading, error }] = useMyOpenInvoicePaymentUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useMyOpenInvoicePaymentUrlMutation(baseOptions?: Apollo.MutationHookOptions<MyOpenInvoicePaymentUrlMutation, MyOpenInvoicePaymentUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyOpenInvoicePaymentUrlMutation, MyOpenInvoicePaymentUrlMutationVariables>(MyOpenInvoicePaymentUrlDocument, options);
      }
export type MyOpenInvoicePaymentUrlMutationHookResult = ReturnType<typeof useMyOpenInvoicePaymentUrlMutation>;
export type MyOpenInvoicePaymentUrlMutationResult = Apollo.MutationResult<MyOpenInvoicePaymentUrlMutation>;
export type MyOpenInvoicePaymentUrlMutationOptions = Apollo.BaseMutationOptions<MyOpenInvoicePaymentUrlMutation, MyOpenInvoicePaymentUrlMutationVariables>;
export const GetSuggestedProfilesDocument = gql`
    query GetSuggestedProfiles($limit: Int!) {
  getSuggestedProfiles(limit: $limit) {
    id
    firstName
    lastName
    title
    openToWork
    isHiring
    profileImageUrl
    role
    isBoosted
    boostEndsAt
    influenceBadge {
      ...InfluenceBadgeFields
    }
    companyName
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetSuggestedProfilesQuery__
 *
 * To run a query within a React component, call `useGetSuggestedProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedProfilesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSuggestedProfilesQuery(baseOptions: Apollo.QueryHookOptions<GetSuggestedProfilesQuery, GetSuggestedProfilesQueryVariables> & ({ variables: GetSuggestedProfilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestedProfilesQuery, GetSuggestedProfilesQueryVariables>(GetSuggestedProfilesDocument, options);
      }
export function useGetSuggestedProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestedProfilesQuery, GetSuggestedProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestedProfilesQuery, GetSuggestedProfilesQueryVariables>(GetSuggestedProfilesDocument, options);
        }
// @ts-ignore
export function useGetSuggestedProfilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSuggestedProfilesQuery, GetSuggestedProfilesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSuggestedProfilesQuery, GetSuggestedProfilesQueryVariables>;
export function useGetSuggestedProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuggestedProfilesQuery, GetSuggestedProfilesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSuggestedProfilesQuery | undefined, GetSuggestedProfilesQueryVariables>;
export function useGetSuggestedProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuggestedProfilesQuery, GetSuggestedProfilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuggestedProfilesQuery, GetSuggestedProfilesQueryVariables>(GetSuggestedProfilesDocument, options);
        }
export type GetSuggestedProfilesQueryHookResult = ReturnType<typeof useGetSuggestedProfilesQuery>;
export type GetSuggestedProfilesLazyQueryHookResult = ReturnType<typeof useGetSuggestedProfilesLazyQuery>;
export type GetSuggestedProfilesSuspenseQueryHookResult = ReturnType<typeof useGetSuggestedProfilesSuspenseQuery>;
export type GetSuggestedProfilesQueryResult = Apollo.QueryResult<GetSuggestedProfilesQuery, GetSuggestedProfilesQueryVariables>;
export const GrowNetworkDocument = gql`
    query GrowNetwork($page: Int!, $limit: Int!) {
  growNetwork(page: $page, limit: $limit) {
    id
    firstName
    lastName
    title
    openToWork
    isHiring
    profileImageUrl
    role
    influenceBadge {
      ...InfluenceBadgeFields
    }
    companyName
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGrowNetworkQuery__
 *
 * To run a query within a React component, call `useGrowNetworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrowNetworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrowNetworkQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGrowNetworkQuery(baseOptions: Apollo.QueryHookOptions<GrowNetworkQuery, GrowNetworkQueryVariables> & ({ variables: GrowNetworkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GrowNetworkQuery, GrowNetworkQueryVariables>(GrowNetworkDocument, options);
      }
export function useGrowNetworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GrowNetworkQuery, GrowNetworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GrowNetworkQuery, GrowNetworkQueryVariables>(GrowNetworkDocument, options);
        }
// @ts-ignore
export function useGrowNetworkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GrowNetworkQuery, GrowNetworkQueryVariables>): Apollo.UseSuspenseQueryResult<GrowNetworkQuery, GrowNetworkQueryVariables>;
export function useGrowNetworkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GrowNetworkQuery, GrowNetworkQueryVariables>): Apollo.UseSuspenseQueryResult<GrowNetworkQuery | undefined, GrowNetworkQueryVariables>;
export function useGrowNetworkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GrowNetworkQuery, GrowNetworkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GrowNetworkQuery, GrowNetworkQueryVariables>(GrowNetworkDocument, options);
        }
export type GrowNetworkQueryHookResult = ReturnType<typeof useGrowNetworkQuery>;
export type GrowNetworkLazyQueryHookResult = ReturnType<typeof useGrowNetworkLazyQuery>;
export type GrowNetworkSuspenseQueryHookResult = ReturnType<typeof useGrowNetworkSuspenseQuery>;
export type GrowNetworkQueryResult = Apollo.QueryResult<GrowNetworkQuery, GrowNetworkQueryVariables>;
export const CreateSupportTicketFromAiDocument = gql`
    mutation CreateSupportTicketFromAI($conversationId: ID!) {
  createSupportTicketFromAI(conversationId: $conversationId) {
    id
    ticketNumber
    subject
    status
  }
}
    `;
export type CreateSupportTicketFromAiMutationFn = Apollo.MutationFunction<CreateSupportTicketFromAiMutation, CreateSupportTicketFromAiMutationVariables>;

/**
 * __useCreateSupportTicketFromAiMutation__
 *
 * To run a mutation, you first call `useCreateSupportTicketFromAiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupportTicketFromAiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupportTicketFromAiMutation, { data, loading, error }] = useCreateSupportTicketFromAiMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useCreateSupportTicketFromAiMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupportTicketFromAiMutation, CreateSupportTicketFromAiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupportTicketFromAiMutation, CreateSupportTicketFromAiMutationVariables>(CreateSupportTicketFromAiDocument, options);
      }
export type CreateSupportTicketFromAiMutationHookResult = ReturnType<typeof useCreateSupportTicketFromAiMutation>;
export type CreateSupportTicketFromAiMutationResult = Apollo.MutationResult<CreateSupportTicketFromAiMutation>;
export type CreateSupportTicketFromAiMutationOptions = Apollo.BaseMutationOptions<CreateSupportTicketFromAiMutation, CreateSupportTicketFromAiMutationVariables>;
export const SubmitAiConversationFeedbackDocument = gql`
    mutation SubmitAiConversationFeedback($conversationId: ID!, $helpful: Boolean!) {
  submitAiConversationFeedback(conversationId: $conversationId, helpful: $helpful)
}
    `;
export type SubmitAiConversationFeedbackMutationFn = Apollo.MutationFunction<SubmitAiConversationFeedbackMutation, SubmitAiConversationFeedbackMutationVariables>;

/**
 * __useSubmitAiConversationFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitAiConversationFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAiConversationFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAiConversationFeedbackMutation, { data, loading, error }] = useSubmitAiConversationFeedbackMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      helpful: // value for 'helpful'
 *   },
 * });
 */
export function useSubmitAiConversationFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SubmitAiConversationFeedbackMutation, SubmitAiConversationFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitAiConversationFeedbackMutation, SubmitAiConversationFeedbackMutationVariables>(SubmitAiConversationFeedbackDocument, options);
      }
export type SubmitAiConversationFeedbackMutationHookResult = ReturnType<typeof useSubmitAiConversationFeedbackMutation>;
export type SubmitAiConversationFeedbackMutationResult = Apollo.MutationResult<SubmitAiConversationFeedbackMutation>;
export type SubmitAiConversationFeedbackMutationOptions = Apollo.BaseMutationOptions<SubmitAiConversationFeedbackMutation, SubmitAiConversationFeedbackMutationVariables>;
export const CreateSupportTicketDocument = gql`
    mutation CreateSupportTicket($input: CreateSupportTicketInput!) {
  createSupportTicket(input: $input) {
    ...SupportTicketRow
    description
    messages {
      ...SupportMessageFields
    }
  }
}
    ${SupportTicketRowFragmentDoc}
${SupportMessageFieldsFragmentDoc}`;
export type CreateSupportTicketMutationFn = Apollo.MutationFunction<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>;

/**
 * __useCreateSupportTicketMutation__
 *
 * To run a mutation, you first call `useCreateSupportTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupportTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupportTicketMutation, { data, loading, error }] = useCreateSupportTicketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSupportTicketMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>(CreateSupportTicketDocument, options);
      }
export type CreateSupportTicketMutationHookResult = ReturnType<typeof useCreateSupportTicketMutation>;
export type CreateSupportTicketMutationResult = Apollo.MutationResult<CreateSupportTicketMutation>;
export type CreateSupportTicketMutationOptions = Apollo.BaseMutationOptions<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>;
export const SendSupportMessageDocument = gql`
    mutation SendSupportMessage($input: SendSupportMessageInput!) {
  sendSupportMessage(input: $input) {
    ...SupportMessageFields
  }
}
    ${SupportMessageFieldsFragmentDoc}`;
export type SendSupportMessageMutationFn = Apollo.MutationFunction<SendSupportMessageMutation, SendSupportMessageMutationVariables>;

/**
 * __useSendSupportMessageMutation__
 *
 * To run a mutation, you first call `useSendSupportMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSupportMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSupportMessageMutation, { data, loading, error }] = useSendSupportMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSupportMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendSupportMessageMutation, SendSupportMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSupportMessageMutation, SendSupportMessageMutationVariables>(SendSupportMessageDocument, options);
      }
export type SendSupportMessageMutationHookResult = ReturnType<typeof useSendSupportMessageMutation>;
export type SendSupportMessageMutationResult = Apollo.MutationResult<SendSupportMessageMutation>;
export type SendSupportMessageMutationOptions = Apollo.BaseMutationOptions<SendSupportMessageMutation, SendSupportMessageMutationVariables>;
export const CloseSupportTicketDocument = gql`
    mutation CloseSupportTicket($ticketId: ID!) {
  closeSupportTicket(ticketId: $ticketId) {
    ...SupportTicketRow
  }
}
    ${SupportTicketRowFragmentDoc}`;
export type CloseSupportTicketMutationFn = Apollo.MutationFunction<CloseSupportTicketMutation, CloseSupportTicketMutationVariables>;

/**
 * __useCloseSupportTicketMutation__
 *
 * To run a mutation, you first call `useCloseSupportTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseSupportTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeSupportTicketMutation, { data, loading, error }] = useCloseSupportTicketMutation({
 *   variables: {
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useCloseSupportTicketMutation(baseOptions?: Apollo.MutationHookOptions<CloseSupportTicketMutation, CloseSupportTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseSupportTicketMutation, CloseSupportTicketMutationVariables>(CloseSupportTicketDocument, options);
      }
export type CloseSupportTicketMutationHookResult = ReturnType<typeof useCloseSupportTicketMutation>;
export type CloseSupportTicketMutationResult = Apollo.MutationResult<CloseSupportTicketMutation>;
export type CloseSupportTicketMutationOptions = Apollo.BaseMutationOptions<CloseSupportTicketMutation, CloseSupportTicketMutationVariables>;
export const SubmitSupportTicketFeedbackDocument = gql`
    mutation SubmitSupportTicketFeedback($input: SubmitTicketFeedbackInput!) {
  submitSupportTicketFeedback(input: $input) {
    ...SupportTicketRow
  }
}
    ${SupportTicketRowFragmentDoc}`;
export type SubmitSupportTicketFeedbackMutationFn = Apollo.MutationFunction<SubmitSupportTicketFeedbackMutation, SubmitSupportTicketFeedbackMutationVariables>;

/**
 * __useSubmitSupportTicketFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitSupportTicketFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSupportTicketFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSupportTicketFeedbackMutation, { data, loading, error }] = useSubmitSupportTicketFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitSupportTicketFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSupportTicketFeedbackMutation, SubmitSupportTicketFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSupportTicketFeedbackMutation, SubmitSupportTicketFeedbackMutationVariables>(SubmitSupportTicketFeedbackDocument, options);
      }
export type SubmitSupportTicketFeedbackMutationHookResult = ReturnType<typeof useSubmitSupportTicketFeedbackMutation>;
export type SubmitSupportTicketFeedbackMutationResult = Apollo.MutationResult<SubmitSupportTicketFeedbackMutation>;
export type SubmitSupportTicketFeedbackMutationOptions = Apollo.BaseMutationOptions<SubmitSupportTicketFeedbackMutation, SubmitSupportTicketFeedbackMutationVariables>;
export const RateKnowledgeArticleDocument = gql`
    mutation RateKnowledgeArticle($input: RateKnowledgeArticleInput!) {
  rateKnowledgeArticle(input: $input) {
    id
    helpfulCount
    notHelpfulCount
  }
}
    `;
export type RateKnowledgeArticleMutationFn = Apollo.MutationFunction<RateKnowledgeArticleMutation, RateKnowledgeArticleMutationVariables>;

/**
 * __useRateKnowledgeArticleMutation__
 *
 * To run a mutation, you first call `useRateKnowledgeArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateKnowledgeArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateKnowledgeArticleMutation, { data, loading, error }] = useRateKnowledgeArticleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRateKnowledgeArticleMutation(baseOptions?: Apollo.MutationHookOptions<RateKnowledgeArticleMutation, RateKnowledgeArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RateKnowledgeArticleMutation, RateKnowledgeArticleMutationVariables>(RateKnowledgeArticleDocument, options);
      }
export type RateKnowledgeArticleMutationHookResult = ReturnType<typeof useRateKnowledgeArticleMutation>;
export type RateKnowledgeArticleMutationResult = Apollo.MutationResult<RateKnowledgeArticleMutation>;
export type RateKnowledgeArticleMutationOptions = Apollo.BaseMutationOptions<RateKnowledgeArticleMutation, RateKnowledgeArticleMutationVariables>;
export const SupportCategoriesDocument = gql`
    query SupportCategories {
  supportCategories {
    id
    key
    name
    description
    isActive
    sortOrder
  }
}
    `;

/**
 * __useSupportCategoriesQuery__
 *
 * To run a query within a React component, call `useSupportCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupportCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<SupportCategoriesQuery, SupportCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportCategoriesQuery, SupportCategoriesQueryVariables>(SupportCategoriesDocument, options);
      }
export function useSupportCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportCategoriesQuery, SupportCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportCategoriesQuery, SupportCategoriesQueryVariables>(SupportCategoriesDocument, options);
        }
// @ts-ignore
export function useSupportCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupportCategoriesQuery, SupportCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<SupportCategoriesQuery, SupportCategoriesQueryVariables>;
export function useSupportCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupportCategoriesQuery, SupportCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<SupportCategoriesQuery | undefined, SupportCategoriesQueryVariables>;
export function useSupportCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupportCategoriesQuery, SupportCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupportCategoriesQuery, SupportCategoriesQueryVariables>(SupportCategoriesDocument, options);
        }
export type SupportCategoriesQueryHookResult = ReturnType<typeof useSupportCategoriesQuery>;
export type SupportCategoriesLazyQueryHookResult = ReturnType<typeof useSupportCategoriesLazyQuery>;
export type SupportCategoriesSuspenseQueryHookResult = ReturnType<typeof useSupportCategoriesSuspenseQuery>;
export type SupportCategoriesQueryResult = Apollo.QueryResult<SupportCategoriesQuery, SupportCategoriesQueryVariables>;
export const MySupportTicketsDocument = gql`
    query MySupportTickets($pagination: PaginationInput) {
  mySupportTickets(pagination: $pagination) {
    data {
      ...SupportTicketRow
    }
    total
    page
    limit
    totalPages
    hasMore
  }
}
    ${SupportTicketRowFragmentDoc}`;

/**
 * __useMySupportTicketsQuery__
 *
 * To run a query within a React component, call `useMySupportTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySupportTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySupportTicketsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMySupportTicketsQuery(baseOptions?: Apollo.QueryHookOptions<MySupportTicketsQuery, MySupportTicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MySupportTicketsQuery, MySupportTicketsQueryVariables>(MySupportTicketsDocument, options);
      }
export function useMySupportTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySupportTicketsQuery, MySupportTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MySupportTicketsQuery, MySupportTicketsQueryVariables>(MySupportTicketsDocument, options);
        }
// @ts-ignore
export function useMySupportTicketsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MySupportTicketsQuery, MySupportTicketsQueryVariables>): Apollo.UseSuspenseQueryResult<MySupportTicketsQuery, MySupportTicketsQueryVariables>;
export function useMySupportTicketsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MySupportTicketsQuery, MySupportTicketsQueryVariables>): Apollo.UseSuspenseQueryResult<MySupportTicketsQuery | undefined, MySupportTicketsQueryVariables>;
export function useMySupportTicketsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MySupportTicketsQuery, MySupportTicketsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MySupportTicketsQuery, MySupportTicketsQueryVariables>(MySupportTicketsDocument, options);
        }
export type MySupportTicketsQueryHookResult = ReturnType<typeof useMySupportTicketsQuery>;
export type MySupportTicketsLazyQueryHookResult = ReturnType<typeof useMySupportTicketsLazyQuery>;
export type MySupportTicketsSuspenseQueryHookResult = ReturnType<typeof useMySupportTicketsSuspenseQuery>;
export type MySupportTicketsQueryResult = Apollo.QueryResult<MySupportTicketsQuery, MySupportTicketsQueryVariables>;
export const SupportTicketDocument = gql`
    query SupportTicket($id: ID!) {
  supportTicket(id: $id) {
    ...SupportTicketRow
    description
    relatedType
    relatedId
    aiConversationId
    messages {
      ...SupportMessageFields
    }
  }
}
    ${SupportTicketRowFragmentDoc}
${SupportMessageFieldsFragmentDoc}`;

/**
 * __useSupportTicketQuery__
 *
 * To run a query within a React component, call `useSupportTicketQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportTicketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportTicketQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSupportTicketQuery(baseOptions: Apollo.QueryHookOptions<SupportTicketQuery, SupportTicketQueryVariables> & ({ variables: SupportTicketQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportTicketQuery, SupportTicketQueryVariables>(SupportTicketDocument, options);
      }
export function useSupportTicketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportTicketQuery, SupportTicketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportTicketQuery, SupportTicketQueryVariables>(SupportTicketDocument, options);
        }
// @ts-ignore
export function useSupportTicketSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupportTicketQuery, SupportTicketQueryVariables>): Apollo.UseSuspenseQueryResult<SupportTicketQuery, SupportTicketQueryVariables>;
export function useSupportTicketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupportTicketQuery, SupportTicketQueryVariables>): Apollo.UseSuspenseQueryResult<SupportTicketQuery | undefined, SupportTicketQueryVariables>;
export function useSupportTicketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupportTicketQuery, SupportTicketQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupportTicketQuery, SupportTicketQueryVariables>(SupportTicketDocument, options);
        }
export type SupportTicketQueryHookResult = ReturnType<typeof useSupportTicketQuery>;
export type SupportTicketLazyQueryHookResult = ReturnType<typeof useSupportTicketLazyQuery>;
export type SupportTicketSuspenseQueryHookResult = ReturnType<typeof useSupportTicketSuspenseQuery>;
export type SupportTicketQueryResult = Apollo.QueryResult<SupportTicketQuery, SupportTicketQueryVariables>;
export const KnowledgeArticlesDocument = gql`
    query KnowledgeArticles($input: KnowledgeArticleSearchInput) {
  knowledgeArticles(input: $input) {
    data {
      id
      title
      slug
      excerpt
      tags
      category {
        id
        name
      }
      helpfulCount
      notHelpfulCount
      publishedAt
    }
    total
    page
    limit
    totalPages
    hasMore
  }
}
    `;

/**
 * __useKnowledgeArticlesQuery__
 *
 * To run a query within a React component, call `useKnowledgeArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKnowledgeArticlesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKnowledgeArticlesQuery(baseOptions?: Apollo.QueryHookOptions<KnowledgeArticlesQuery, KnowledgeArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KnowledgeArticlesQuery, KnowledgeArticlesQueryVariables>(KnowledgeArticlesDocument, options);
      }
export function useKnowledgeArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KnowledgeArticlesQuery, KnowledgeArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KnowledgeArticlesQuery, KnowledgeArticlesQueryVariables>(KnowledgeArticlesDocument, options);
        }
// @ts-ignore
export function useKnowledgeArticlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KnowledgeArticlesQuery, KnowledgeArticlesQueryVariables>): Apollo.UseSuspenseQueryResult<KnowledgeArticlesQuery, KnowledgeArticlesQueryVariables>;
export function useKnowledgeArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KnowledgeArticlesQuery, KnowledgeArticlesQueryVariables>): Apollo.UseSuspenseQueryResult<KnowledgeArticlesQuery | undefined, KnowledgeArticlesQueryVariables>;
export function useKnowledgeArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KnowledgeArticlesQuery, KnowledgeArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KnowledgeArticlesQuery, KnowledgeArticlesQueryVariables>(KnowledgeArticlesDocument, options);
        }
export type KnowledgeArticlesQueryHookResult = ReturnType<typeof useKnowledgeArticlesQuery>;
export type KnowledgeArticlesLazyQueryHookResult = ReturnType<typeof useKnowledgeArticlesLazyQuery>;
export type KnowledgeArticlesSuspenseQueryHookResult = ReturnType<typeof useKnowledgeArticlesSuspenseQuery>;
export type KnowledgeArticlesQueryResult = Apollo.QueryResult<KnowledgeArticlesQuery, KnowledgeArticlesQueryVariables>;
export const KnowledgeArticleDocument = gql`
    query KnowledgeArticle($slug: String!) {
  knowledgeArticle(slug: $slug) {
    id
    title
    slug
    content
    excerpt
    tags
    category {
      id
      name
    }
    helpfulCount
    notHelpfulCount
    publishedAt
    updatedAt
  }
}
    `;

/**
 * __useKnowledgeArticleQuery__
 *
 * To run a query within a React component, call `useKnowledgeArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKnowledgeArticleQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useKnowledgeArticleQuery(baseOptions: Apollo.QueryHookOptions<KnowledgeArticleQuery, KnowledgeArticleQueryVariables> & ({ variables: KnowledgeArticleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KnowledgeArticleQuery, KnowledgeArticleQueryVariables>(KnowledgeArticleDocument, options);
      }
export function useKnowledgeArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KnowledgeArticleQuery, KnowledgeArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KnowledgeArticleQuery, KnowledgeArticleQueryVariables>(KnowledgeArticleDocument, options);
        }
// @ts-ignore
export function useKnowledgeArticleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KnowledgeArticleQuery, KnowledgeArticleQueryVariables>): Apollo.UseSuspenseQueryResult<KnowledgeArticleQuery, KnowledgeArticleQueryVariables>;
export function useKnowledgeArticleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KnowledgeArticleQuery, KnowledgeArticleQueryVariables>): Apollo.UseSuspenseQueryResult<KnowledgeArticleQuery | undefined, KnowledgeArticleQueryVariables>;
export function useKnowledgeArticleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KnowledgeArticleQuery, KnowledgeArticleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KnowledgeArticleQuery, KnowledgeArticleQueryVariables>(KnowledgeArticleDocument, options);
        }
export type KnowledgeArticleQueryHookResult = ReturnType<typeof useKnowledgeArticleQuery>;
export type KnowledgeArticleLazyQueryHookResult = ReturnType<typeof useKnowledgeArticleLazyQuery>;
export type KnowledgeArticleSuspenseQueryHookResult = ReturnType<typeof useKnowledgeArticleSuspenseQuery>;
export type KnowledgeArticleQueryResult = Apollo.QueryResult<KnowledgeArticleQuery, KnowledgeArticleQueryVariables>;
export const UnsaveRssFeedDocument = gql`
    mutation UnsaveRssFeed($input: UnSaveRssPostsInput!) {
  unsaveRssFeed(input: $input)
}
    `;
export type UnsaveRssFeedMutationFn = Apollo.MutationFunction<UnsaveRssFeedMutation, UnsaveRssFeedMutationVariables>;

/**
 * __useUnsaveRssFeedMutation__
 *
 * To run a mutation, you first call `useUnsaveRssFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsaveRssFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsaveRssFeedMutation, { data, loading, error }] = useUnsaveRssFeedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnsaveRssFeedMutation(baseOptions?: Apollo.MutationHookOptions<UnsaveRssFeedMutation, UnsaveRssFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsaveRssFeedMutation, UnsaveRssFeedMutationVariables>(UnsaveRssFeedDocument, options);
      }
export type UnsaveRssFeedMutationHookResult = ReturnType<typeof useUnsaveRssFeedMutation>;
export type UnsaveRssFeedMutationResult = Apollo.MutationResult<UnsaveRssFeedMutation>;
export type UnsaveRssFeedMutationOptions = Apollo.BaseMutationOptions<UnsaveRssFeedMutation, UnsaveRssFeedMutationVariables>;
export const UniversityGroupDocument = gql`
    query UniversityGroup($communityId: String!, $type: String!) {
  universityGroup(communityId: $communityId, type: $type) {
    id
    name
    type
    description
  }
}
    `;

/**
 * __useUniversityGroupQuery__
 *
 * To run a query within a React component, call `useUniversityGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniversityGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniversityGroupQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUniversityGroupQuery(baseOptions: Apollo.QueryHookOptions<UniversityGroupQuery, UniversityGroupQueryVariables> & ({ variables: UniversityGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniversityGroupQuery, UniversityGroupQueryVariables>(UniversityGroupDocument, options);
      }
export function useUniversityGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniversityGroupQuery, UniversityGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniversityGroupQuery, UniversityGroupQueryVariables>(UniversityGroupDocument, options);
        }
// @ts-ignore
export function useUniversityGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UniversityGroupQuery, UniversityGroupQueryVariables>): Apollo.UseSuspenseQueryResult<UniversityGroupQuery, UniversityGroupQueryVariables>;
export function useUniversityGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UniversityGroupQuery, UniversityGroupQueryVariables>): Apollo.UseSuspenseQueryResult<UniversityGroupQuery | undefined, UniversityGroupQueryVariables>;
export function useUniversityGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UniversityGroupQuery, UniversityGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UniversityGroupQuery, UniversityGroupQueryVariables>(UniversityGroupDocument, options);
        }
export type UniversityGroupQueryHookResult = ReturnType<typeof useUniversityGroupQuery>;
export type UniversityGroupLazyQueryHookResult = ReturnType<typeof useUniversityGroupLazyQuery>;
export type UniversityGroupSuspenseQueryHookResult = ReturnType<typeof useUniversityGroupSuspenseQuery>;
export type UniversityGroupQueryResult = Apollo.QueryResult<UniversityGroupQuery, UniversityGroupQueryVariables>;
export const UpdateScheduleDocument = gql`
    mutation UpdateSchedule($input: UpdateScheduleInput!) {
  updateSchedule(input: $input)
}
    `;
export type UpdateScheduleMutationFn = Apollo.MutationFunction<UpdateScheduleMutation, UpdateScheduleMutationVariables>;

/**
 * __useUpdateScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleMutation, { data, loading, error }] = useUpdateScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleMutation, UpdateScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleMutation, UpdateScheduleMutationVariables>(UpdateScheduleDocument, options);
      }
export type UpdateScheduleMutationHookResult = ReturnType<typeof useUpdateScheduleMutation>;
export type UpdateScheduleMutationResult = Apollo.MutationResult<UpdateScheduleMutation>;
export type UpdateScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleMutation, UpdateScheduleMutationVariables>;
export const UpdatePostDocument = gql`
    mutation UpdatePost($input: UpdatePostInputForBoth!) {
  updatePost(input: $input)
}
    `;
export type UpdatePostMutationFn = Apollo.MutationFunction<UpdatePostMutation, UpdatePostMutationVariables>;

/**
 * __useUpdatePostMutation__
 *
 * To run a mutation, you first call `useUpdatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostMutation, { data, loading, error }] = useUpdatePostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePostMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePostMutation, UpdatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePostMutation, UpdatePostMutationVariables>(UpdatePostDocument, options);
      }
export type UpdatePostMutationHookResult = ReturnType<typeof useUpdatePostMutation>;
export type UpdatePostMutationResult = Apollo.MutationResult<UpdatePostMutation>;
export type UpdatePostMutationOptions = Apollo.BaseMutationOptions<UpdatePostMutation, UpdatePostMutationVariables>;
export const UploadCommentMediaDocument = gql`
    mutation UploadCommentMedia($input: UploadCommentMediaInput!) {
  uploadCommentMedia(input: $input)
}
    `;
export type UploadCommentMediaMutationFn = Apollo.MutationFunction<UploadCommentMediaMutation, UploadCommentMediaMutationVariables>;

/**
 * __useUploadCommentMediaMutation__
 *
 * To run a mutation, you first call `useUploadCommentMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCommentMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCommentMediaMutation, { data, loading, error }] = useUploadCommentMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadCommentMediaMutation(baseOptions?: Apollo.MutationHookOptions<UploadCommentMediaMutation, UploadCommentMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCommentMediaMutation, UploadCommentMediaMutationVariables>(UploadCommentMediaDocument, options);
      }
export type UploadCommentMediaMutationHookResult = ReturnType<typeof useUploadCommentMediaMutation>;
export type UploadCommentMediaMutationResult = Apollo.MutationResult<UploadCommentMediaMutation>;
export type UploadCommentMediaMutationOptions = Apollo.BaseMutationOptions<UploadCommentMediaMutation, UploadCommentMediaMutationVariables>;
export const UploadGroupImagesDocument = gql`
    mutation UploadGroupImages($coverImage: Upload!, $profileImage: Upload!) {
  uploadGroupImages(
    input: {coverImage: {file: $coverImage}, profileImage: {file: $profileImage}}
  ) {
    coverImageUrl
    profileImageUrl
  }
}
    `;
export type UploadGroupImagesMutationFn = Apollo.MutationFunction<UploadGroupImagesMutation, UploadGroupImagesMutationVariables>;

/**
 * __useUploadGroupImagesMutation__
 *
 * To run a mutation, you first call `useUploadGroupImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadGroupImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadGroupImagesMutation, { data, loading, error }] = useUploadGroupImagesMutation({
 *   variables: {
 *      coverImage: // value for 'coverImage'
 *      profileImage: // value for 'profileImage'
 *   },
 * });
 */
export function useUploadGroupImagesMutation(baseOptions?: Apollo.MutationHookOptions<UploadGroupImagesMutation, UploadGroupImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadGroupImagesMutation, UploadGroupImagesMutationVariables>(UploadGroupImagesDocument, options);
      }
export type UploadGroupImagesMutationHookResult = ReturnType<typeof useUploadGroupImagesMutation>;
export type UploadGroupImagesMutationResult = Apollo.MutationResult<UploadGroupImagesMutation>;
export type UploadGroupImagesMutationOptions = Apollo.BaseMutationOptions<UploadGroupImagesMutation, UploadGroupImagesMutationVariables>;
export const UploadProfileImageDocument = gql`
    mutation UploadProfileImage($input: UploadProfileImageInput!) {
  uploadProfileImage(input: $input) {
    id
    createdAt
    updatedAt
    userId
    fileName
    fileUrl
    optimizedUrl
    mimeType
    size
    type
  }
}
    `;
export type UploadProfileImageMutationFn = Apollo.MutationFunction<UploadProfileImageMutation, UploadProfileImageMutationVariables>;

/**
 * __useUploadProfileImageMutation__
 *
 * To run a mutation, you first call `useUploadProfileImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadProfileImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadProfileImageMutation, { data, loading, error }] = useUploadProfileImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadProfileImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadProfileImageMutation, UploadProfileImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadProfileImageMutation, UploadProfileImageMutationVariables>(UploadProfileImageDocument, options);
      }
export type UploadProfileImageMutationHookResult = ReturnType<typeof useUploadProfileImageMutation>;
export type UploadProfileImageMutationResult = Apollo.MutationResult<UploadProfileImageMutation>;
export type UploadProfileImageMutationOptions = Apollo.BaseMutationOptions<UploadProfileImageMutation, UploadProfileImageMutationVariables>;
export const GetUserBasicInfoDocument = gql`
    query GetUserBasicInfo($userId: String!) {
  getUserBasicInfo(userId: $userId) {
    userId
    name
    profileImageUrl
    role
    title
    headline
    influenceBadge {
      ...InfluenceBadgeFields
    }
    companyName
  }
}
    ${InfluenceBadgeFieldsFragmentDoc}`;

/**
 * __useGetUserBasicInfoQuery__
 *
 * To run a query within a React component, call `useGetUserBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserBasicInfoQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserBasicInfoQuery(baseOptions: Apollo.QueryHookOptions<GetUserBasicInfoQuery, GetUserBasicInfoQueryVariables> & ({ variables: GetUserBasicInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserBasicInfoQuery, GetUserBasicInfoQueryVariables>(GetUserBasicInfoDocument, options);
      }
export function useGetUserBasicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserBasicInfoQuery, GetUserBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserBasicInfoQuery, GetUserBasicInfoQueryVariables>(GetUserBasicInfoDocument, options);
        }
// @ts-ignore
export function useGetUserBasicInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserBasicInfoQuery, GetUserBasicInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserBasicInfoQuery, GetUserBasicInfoQueryVariables>;
export function useGetUserBasicInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserBasicInfoQuery, GetUserBasicInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserBasicInfoQuery | undefined, GetUserBasicInfoQueryVariables>;
export function useGetUserBasicInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserBasicInfoQuery, GetUserBasicInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserBasicInfoQuery, GetUserBasicInfoQueryVariables>(GetUserBasicInfoDocument, options);
        }
export type GetUserBasicInfoQueryHookResult = ReturnType<typeof useGetUserBasicInfoQuery>;
export type GetUserBasicInfoLazyQueryHookResult = ReturnType<typeof useGetUserBasicInfoLazyQuery>;
export type GetUserBasicInfoSuspenseQueryHookResult = ReturnType<typeof useGetUserBasicInfoSuspenseQuery>;
export type GetUserBasicInfoQueryResult = Apollo.QueryResult<GetUserBasicInfoQuery, GetUserBasicInfoQueryVariables>;
export const VerifyEmailDocument = gql`
    mutation VerifyEmail($input: VerifyEmailInput!) {
  verifyEmail(input: $input)
}
    `;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const ResendVerificationEmailDocument = gql`
    mutation ResendVerificationEmail($email: String!) {
  resendVerificationEmail(email: $email)
}
    `;
export type ResendVerificationEmailMutationFn = Apollo.MutationFunction<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;

/**
 * __useResendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationEmailMutation, { data, loading, error }] = useResendVerificationEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>(ResendVerificationEmailDocument, options);
      }
export type ResendVerificationEmailMutationHookResult = ReturnType<typeof useResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationResult = Apollo.MutationResult<ResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationOptions = Apollo.BaseMutationOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;